import { SvgIcon } from '@mui/material';

export function ResetIllustration(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 267,
    height: 164.469,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 267 164.469"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 102583" transform="translate(-59 -47)">
        <circle
          data-name="Ellipse 39441"
          cx={18}
          cy={18}
          r={18}
          transform="translate(290 119)"
          fill="rgba(90,197,179,0.1)"
        />
        <g data-name="Group 90888">
          <g
            data-name="Group 5475"
            transform="translate(21.991 -7) translate(36.893 54)"
          >
            <path
              data-name="Rectangle 44658"
              transform="rotate(3.9 -2045.229 2286.62)"
              fill="#f4f2ff"
              d="M0 0H13.576V11.03H0z"
            />
            <g data-name="Verify OTP">
              <path
                data-name="Path 5032"
                d="M177.282 157.273a2.545 2.545 0 014.409 0l14.329 24.818a2.546 2.546 0 01-2.205 3.818h-28.657a2.546 2.546 0 01-2.205-3.818z"
                transform="translate(-10.954 -30.424)"
                fill="rgba(90,197,179,0.1)"
              />
              <path
                data-name="Path 4696"
                d="M240.626 4.273a2.545 2.545 0 014.409 0l18 31.182a2.546 2.546 0 01-2.2 3.818h-36.008a2.546 2.546 0 01-2.2-3.818z"
                transform="translate(-33.571 -3)"
                fill="rgba(90,197,179,0.1)"
              />
              <circle
                data-name="Ellipse 39444"
                cx={25.5}
                cy={25.5}
                r={25.5}
                transform="translate(.116 99.36)"
                fill="rgba(90,197,179,0.1)"
              />
              <circle
                data-name="Ellipse 39445"
                cx={16}
                cy={16}
                r={16}
                transform="translate(37.116 9.36)"
                fill="rgba(90,197,179,0.1)"
              />
              <g
                data-name="Group 5436"
                opacity={0.3}
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
              >
                <path
                  data-name="Path 4735"
                  d="M52.975 121.765H0V25.817A25.817 25.817 0 0125.817 0a27.145 27.145 0 0127.147 27.147v94.618z"
                  opacity={0.3}
                  transform="translate(198.072 4.242)"
                />
                <path
                  data-name="Path 4736"
                  d="M46.984 121.477V27.359A20.507 20.507 0 0026.477 6.852h0a20.507 20.507 0 00-20.5 20.507v94.136"
                  opacity={0.3}
                  transform="translate(198.072 4.242)"
                />
                <path
                  data-name="Path 4737"
                  d="M26.488 0v121.622"
                  opacity={0.3}
                  transform="translate(198.072 4.242)"
                />
                <path
                  data-name="Path 4738"
                  d="M52.691 23.429H.354"
                  opacity={0.3}
                  transform="translate(198.072 4.242)"
                />
                <path
                  data-name="Path 4739"
                  d="M52.691 39.948H.354"
                  opacity={0.3}
                  transform="translate(198.072 4.242)"
                />
                <path
                  data-name="Path 4740"
                  d="M52.691 56.466H.354"
                  opacity={0.3}
                  transform="translate(198.072 4.242)"
                />
                <path
                  data-name="Path 4741"
                  d="M52.691 72.99H.354"
                  opacity={0.3}
                  transform="translate(198.072 4.242)"
                />
                <path
                  data-name="Path 4742"
                  d="M52.691 89.51H.354"
                  opacity={0.3}
                  transform="translate(198.072 4.242)"
                />
                <path
                  data-name="Path 4743"
                  d="M52.691 106.029H.354"
                  opacity={0.3}
                  transform="translate(198.072 4.242)"
                />
                <path
                  data-name="Path 4744"
                  d="M45.693 8.265l-4.744 4.323"
                  opacity={0.3}
                  transform="translate(198.072 4.242)"
                />
                <path
                  data-name="Path 4745"
                  d="M7.479 8.265l4.747 4.323"
                  opacity={0.3}
                  transform="translate(198.072 4.242)"
                />
              </g>
              <g
                data-name="Group 5437"
                opacity={0.3}
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
              >
                <path
                  data-name="Path 4746"
                  d="M52.975 121.765H0V25.817A25.817 25.817 0 0125.817 0a27.147 27.147 0 0127.146 27.147v94.618z"
                  opacity={0.3}
                  transform="translate(3.5 4.242)"
                />
                <path
                  data-name="Path 4747"
                  d="M46.993 121.479V27.358A20.508 20.508 0 0026.485 6.836h0A20.507 20.507 0 005.962 27.358v94.136"
                  opacity={0.3}
                  transform="translate(3.5 4.242)"
                />
                <path
                  data-name="Path 4748"
                  d="M26.485 0v121.622"
                  opacity={0.3}
                  transform="translate(3.5 4.242)"
                />
                <path
                  data-name="Path 4749"
                  d="M52.691 23.429H.351"
                  opacity={0.3}
                  transform="translate(3.5 4.242)"
                />
                <path
                  data-name="Path 4750"
                  d="M52.691 39.948H.351"
                  opacity={0.3}
                  transform="translate(3.5 4.242)"
                />
                <path
                  data-name="Path 4751"
                  d="M52.691 56.466H.351"
                  opacity={0.3}
                  transform="translate(3.5 4.242)"
                />
                <path
                  data-name="Path 4752"
                  d="M52.691 72.99H.351"
                  opacity={0.3}
                  transform="translate(3.5 4.242)"
                />
                <path
                  data-name="Path 4753"
                  d="M52.691 89.509H.351"
                  opacity={0.3}
                  transform="translate(3.5 4.242)"
                />
                <path
                  data-name="Path 4754"
                  d="M52.691 106.028H.351"
                  opacity={0.3}
                  transform="translate(3.5 4.242)"
                />
                <path
                  data-name="Path 4755"
                  d="M45.689 8.265l-4.747 4.323"
                  opacity={0.3}
                  transform="translate(3.5 4.242)"
                />
                <path
                  data-name="Path 4756"
                  d="M7.479 8.265l4.743 4.323"
                  opacity={0.3}
                  transform="translate(3.5 4.242)"
                />
              </g>
              <path
                data-name="Path 4757"
                d="M200.799 163.969h55.142"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
              />
              <path
                data-name="Path 4758"
                d="M8.592 163.969h186.694"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
              />
              <g data-name="Group 5561">
                <path
                  data-name="Path 4344"
                  d="M29.523 138.1a4.228 4.228 0 00-1.517-2.6c-1.517-1.517-2.49-2.383-2.49-2.383s-.76 2.492.648 4.007a26.65 26.65 0 003.353 2.926z"
                  transform="translate(240.13 110.32) translate(-16.531 -133.118)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4345"
                  d="M26.932 146.075a4.234 4.234 0 00-1.514-2.6c-1.514-1.517-2.492-2.383-2.492-2.383s-.757 2.492.651 4.009a26.683 26.683 0 003.356 2.917z"
                  transform="translate(240.13 110.32) translate(-16.138 -134.326)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4346"
                  d="M30.126 140.357a4.226 4.226 0 011.783-2.426c1.668-1.347 2.73-2.107 2.73-2.107s.492 2.556-1.07 3.912a26.58 26.58 0 01-3.649 2.554z"
                  transform="translate(240.13 110.32) translate(-17.229 -133.528)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4347"
                  d="M26.95 149.849s.229-1.059 2.028-2.235 2.937-1.808 2.937-1.808.218 2.6-1.475 3.783a26.765 26.765 0 01-3.912 2.157z"
                  transform="translate(240.13 110.32) translate(-16.715 -135.04)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4348"
                  d="M27.618 159.958a4.231 4.231 0 011.517-2.6c1.517-1.517 2.492-2.383 2.492-2.383s.757 2.493-.651 4.01a26.582 26.582 0 01-3.353 2.925z"
                  transform="translate(240.13 110.32) translate(-16.88 -136.429)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4349"
                  d="M26.924 162.371a4.265 4.265 0 00-1.118-2.794c-1.271-1.722-2.126-2.713-2.126-2.713s-1.118 2.359.073 4.06a26.69 26.69 0 002.909 3.373z"
                  transform="translate(240.13 110.32) translate(-16.212 -136.716)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4350"
                  d="M25.826 169.89a4.223 4.223 0 011.517-2.6c1.517-1.515 2.492-2.383 2.492-2.383s.757 2.489-.651 4.007a26.589 26.589 0 01-3.353 2.926z"
                  transform="translate(240.13 110.32) translate(-16.609 -137.935)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4351"
                  d="M27.019 176.472a4.2 4.2 0 01.808-2.9c1.087-1.852 1.808-2.937 1.808-2.937s1.364 2.219.386 4.043a26.478 26.478 0 01-2.515 3.68z"
                  transform="translate(240.13 110.32) translate(-16.785 -138.802)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4352"
                  d="M13.13 4.705a31.016 31.016 0 01-.414 3.352c-.6 3.1-2.1 5.1-2.7 7.893s1.118 6.4.662 9.994-1.861 5.588-1.461 7.991 2.5 8.891 2.5 8.891"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4353"
                  d="M12.883 7.547l1.635-1.252"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4354"
                  d="M12.959 6.102l-.685-1.216"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4355"
                  d="M10.108 15.834s1.366-1.026 2.775-2.054"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4356"
                  d="M10.793 13.691a21.873 21.873 0 00-2.431-3.719"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4357"
                  d="M10.793 25.068a16.894 16.894 0 012.925-3.912"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4358"
                  d="M10.513 26.591a19.256 19.256 0 00-1.481-2.814c-.8-1.179-.914-1.33-.914-1.33"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4359"
                  d="M9.217 33.948a18.015 18.015 0 011.232-2.492 15.827 15.827 0 011.6-2.09"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4360"
                  d="M10.726 39.556a4.656 4.656 0 01.411-2.4c.559-1.1 1.215-2.545 1.481-3.115"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4361"
                  d="M18.571 155.411a2.7 2.7 0 01.668-1.8 39.683 39.683 0 011.3-1.762 2.907 2.907 0 01.028 2.585 16.855 16.855 0 01-1.788 2.2z"
                  transform="translate(240.13 110.32) translate(-15.509 -135.956)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4362"
                  d="M21.064 160.141a2.7 2.7 0 01.668-1.8c.785-1.115 1.316-1.774 1.316-1.774a2.9 2.9 0 01.025 2.582 16.927 16.927 0 01-1.788 2.2z"
                  transform="translate(240.13 110.32) translate(-15.886 -136.671)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4363"
                  d="M18.285 156.977s-.19-.663-1.38-1.327-1.942-1.026-1.942-1.026a2.9 2.9 0 001.1 2.342 17.027 17.027 0 002.565 1.2z"
                  transform="translate(240.13 110.32) translate(-14.963 -136.376)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4364"
                  d="M21.231 162.607s-.257-.64-1.512-1.173-2.037-.815-2.037-.815a2.894 2.894 0 001.336 2.209 16.819 16.819 0 002.68.931z"
                  transform="translate(240.13 110.32) translate(-15.375 -137.285)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4365"
                  d="M22.062 168.983s-.117-.679-1.232-1.464-1.822-1.224-1.822-1.224a2.917 2.917 0 00.838 2.443 16.959 16.959 0 002.423 1.47z"
                  transform="translate(240.13 110.32) translate(-15.573 -138.145)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4366"
                  d="M22.9 170.353a2.679 2.679 0 01.405-1.872c.62-1.215 1.039-1.934 1.039-1.934a2.91 2.91 0 01.4 2.554 17.019 17.019 0 01-1.458 2.431z"
                  transform="translate(240.13 110.32) translate(-16.159 -138.183)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4367"
                  d="M25.118 176.98s.078-.685 1.148-1.534 1.746-1.327 1.746-1.327a2.9 2.9 0 01-.7 2.486 16.84 16.84 0 01-2.336 1.607z"
                  transform="translate(240.13 110.32) translate(-16.48 -139.33)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4368"
                  d="M24.263 175.019s-.117-.679-1.232-1.467-1.822-1.224-1.822-1.224a2.913 2.913 0 00.838 2.442 16.834 16.834 0 002.417 1.47z"
                  transform="translate(240.13 110.32) translate(-15.907 -139.059)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4369"
                  d="M24.351 179.246a2.685 2.685 0 00-.821-1.729c-.88-1.043-1.453-1.646-1.453-1.646a2.908 2.908 0 00.2 2.576 16.964 16.964 0 001.973 2.037z"
                  transform="translate(240.13 110.32) translate(-16.007 -139.596)"
                  fill="#4cc5b1"
                />
                <path
                  data-name="Path 4370"
                  d="M2.945 19.295a19.833 19.833 0 00.626 2.064c.713 1.875 1.869 2.968 2.548 4.656s0 4.138.671 6.339 1.774 3.306 1.783 4.853-.6 5.845-.6 5.845"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4371"
                  d="M3.409 21.051l-1.16-.609"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4372"
                  d="M3.205 20.153l.3-.838"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4373"
                  d="M6.044 25.946s-.97-.495-1.956-.986"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4374"
                  d="M5.388 24.68a13.823 13.823 0 011.118-2.6"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4375"
                  d="M6.622 31.811a10.846 10.846 0 00-2.255-2.138"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4376"
                  d="M6.954 32.735a12.3 12.3 0 01.623-1.925c.374-.824.428-.932.428-.932"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4377"
                  d="M8.522 38.386a10.066 10.066 0 011.246-1.3 6.829 6.829 0 00.813-.707"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4378"
                  d="M8.572 37.208a11.588 11.588 0 00-1.042-1.431 10.051 10.051 0 00-1.227-1.132"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4379"
                  d="M8.237 40.889a2.943 2.943 0 00-.517-1.461c-.478-.629-1.039-1.465-1.268-1.794"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
                <path
                  data-name="Path 4380"
                  d="M12.699 53.366h-6.33a.5.5 0 01-.5-.5l-1.57-10.483h10.47l-1.57 10.483a.5.5 0 01-.5.5z"
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  transform="translate(240.13 110.32)"
                />
              </g>
            </g>
          </g>
          <g transform="translate(21.991 -7) translate(73.485 89.039)">
            <path
              data-name="Path 5456"
              d="M85.174 366.34l-5.467 28.46-8.74 26.023-2.159 4.063s-2.42 3.527-2.674 6.222a3.068 3.068 0 004.2 3.3c1.9-.889 2.92-4.571 3.3-6.222s1.143-4.571 1.411-5.587a6.348 6.348 0 01.762-1.778s15.1-25.134 15.1-25.9 7.111-19.307 7.111-19.307l1.411.127 4.169 20.69L91.9 420.7s-3.682 4.317-3.428 4.825a17.26 17.26 0 003.047 3.054c.762.508 3.527 4.938 5.587 5.46s2.822 1.016 2.42-.635a50.007 50.007 0 00-1.785-4.938c-.254-.762-.755-6.081-.755-6.081l17.529-23.13-2.293-28.583z"
              transform="translate(-65.761 -306.674)"
              fill="#fff"
            />
            <path
              data-name="Path 5457"
              d="M69.034 434.865a3.3 3.3 0 01-1.933-.621 3.527 3.527 0 01-1.453-3.315c.254-2.73 2.624-6.243 2.723-6.391l2.116-4.035 8.719-25.966 5.453-28.407a.346.346 0 01.4-.282l27.088 4.338a.36.36 0 01.3.324l2.286 28.6a.332.332 0 01-.071.24l-17.447 23.03c.2 2.116.55 5.34.705 5.862.078.226.226.607.416 1.079a28.929 28.929 0 011.368 3.908c.127.529.2 1.058-.12 1.361s-.917.183-1.848-.07c-.254-.078-.55-.155-.875-.233-1.5-.381-3.245-2.561-4.522-4.155a10.372 10.372 0 00-1.178-1.361A17.509 17.509 0 0188 425.589c-.106-.219-.36-.705 3.449-5.178l11.639-24.125-4.12-20.337-.868-.078c-2.822 7.315-6.913 18.214-7 18.954S80.518 413.3 75.954 420.877a6.216 6.216 0 00-.705 1.686l-.3 1.185c-.346 1.354-.818 3.2-1.093 4.395-.571 2.476-1.644 5.6-3.527 6.469a3.1 3.1 0 01-1.3.254zM85.315 366.6l-5.4 28.118-8.754 26.1-2.18 4.112c-.042.071-2.384 3.527-2.631 6.095a2.822 2.822 0 001.157 2.681 2.561 2.561 0 002.539.268c1.227-.571 2.356-2.751 3.1-5.982a257.13 257.13 0 011.1-4.409l.3-1.185a6.645 6.645 0 01.8-1.891c5.911-9.833 14.814-24.816 15.046-25.747 0-.705 5.453-15.018 7.132-19.385a.353.353 0 01.36-.226l1.411.127a.367.367 0 01.317.282l4.19 20.7a.353.353 0 010 .226l-11.68 24.273-.049.078a28.035 28.035 0 00-3.351 4.493 18.277 18.277 0 002.9 2.857 8.88 8.88 0 011.333 1.5c1.15 1.411 2.878 3.591 4.148 3.908l.889.24a4 4 0 001.185.24 1.961 1.961 0 00-.092-.705 29.113 29.113 0 00-1.34-3.8c-.19-.487-.353-.882-.43-1.122-.261-.776-.705-5.6-.776-6.151a.388.388 0 01.071-.247l17.445-23.032-2.314-28.2z"
              transform="translate(-65.62 -306.528)"
              fill="#263238"
            />
            <path
              data-name="Path 5458"
              d="M102.428 452.748a51.565 51.565 0 01-4.105-4.028c-.353.536-.578.952-.508 1.086a17.258 17.258 0 003.047 3.054c.762.508 3.527 4.938 5.587 5.46 1.361.339 2.116.705 2.412.374-4.126-1.086-5.34-5.121-6.433-5.946z"
              transform="translate(-75.1 -330.943)"
              fill="#fff"
            />
            <path
              data-name="Path 5459"
              d="M108.369 459.013a5.4 5.4 0 01-1.305-.268l-.868-.226c-1.5-.381-3.245-2.561-4.522-4.155A10.362 10.362 0 00100.5 453a17.506 17.506 0 01-3.167-3.181c-.134-.275 0-.642.536-1.446a.353.353 0 01.55-.042 47.88 47.88 0 004.056 3.986 5.982 5.982 0 011.136 1.46c1 1.559 2.377 3.689 5.171 4.423a.353.353 0 01.247.24.331.331 0 01-.063.332.705.705 0 01-.597.241zM98 449.567a18.493 18.493 0 002.892 2.822 8.881 8.881 0 011.333 1.5c1.093 1.369 2.716 3.393 3.964 3.859a12.047 12.047 0 01-3.181-3.619 5.7 5.7 0 00-.959-1.277 46.263 46.263 0 01-3.837-3.739 1.91 1.91 0 00-.2.451zm0-.067z"
              transform="translate(-74.947 -330.796)"
              fill="#263238"
            />
            <path
              data-name="Path 5460"
              d="M72.7 456.87c-1.326 1.333-2.878 2.335-4.529 1.841-1.94-.579-1.474-3.527-.959-5.361a11.034 11.034 0 00-1.072 3.386 3.069 3.069 0 004.2 3.3 5.812 5.812 0 002.36-3.166z"
              transform="translate(-65.761 -332.307)"
              fill="#fff"
            />
            <path
              data-name="Path 5461"
              d="M69.034 460.474a3.3 3.3 0 01-1.933-.621 3.527 3.527 0 01-1.453-3.322 11.011 11.011 0 011.1-3.527.354.354 0 11.663.247c-.451 1.63-.959 4.43.705 4.938 1.3.388 2.638-.176 4.19-1.728a.36.36 0 01.444-.042.353.353 0 01.134.423 5.934 5.934 0 01-2.547 3.365 3.1 3.1 0 01-1.303.267zm-2.7-3.633a2.822 2.822 0 001.171 2.441 2.561 2.561 0 002.539.268 3.682 3.682 0 001.411-1.467 4.007 4.007 0 01-3.527.8 2.3 2.3 0 01-1.594-2.039z"
              transform="translate(-65.619 -332.137)"
              fill="#263238"
            />
            <path
              data-name="Path 5462"
              d="M87.207 366.34L81.74 394.8 73 420.819s.776 2.786 4.232 1.256a6.346 6.346 0 01.6-1.256s15.1-25.134 15.1-25.9 7.111-19.307 7.111-19.307l1.411.127 4.176 20.69L93.937 420.7s1.524 2.561 5.135 1.615l17.48-23.06-2.293-28.583z"
              transform="translate(-67.794 -306.674)"
              fill="#263238"
            />
            <path
              data-name="Path 5463"
              d="M97.393 422.751a4.663 4.663 0 01-3.908-1.989.381.381 0 010-.339L105.11 396.3l-4.12-20.337-.868-.078c-2.822 7.315-6.913 18.214-7 18.954s-10.578 18.474-15.142 26.05a5.891 5.891 0 00-.571 1.2.381.381 0 01-.19.2 3.83 3.83 0 01-3.238.226 2.857 2.857 0 01-1.467-1.714.339.339 0 010-.2l8.747-26.023 5.453-28.407a.346.346 0 01.4-.282l27.059 4.31a.36.36 0 01.3.324l2.286 28.6a.332.332 0 01-.071.24L99.2 422.4a.332.332 0 01-.19.127 6.269 6.269 0 01-1.615.226zm-3.2-2.2a4.136 4.136 0 004.515 1.333l17.325-22.876-2.271-28.174L87.32 366.6l-5.4 28.118-8.691 25.959a2.166 2.166 0 001.058 1.178 3.083 3.083 0 002.511-.183 7.055 7.055 0 01.585-1.185c5.911-9.833 14.814-24.816 15.046-25.747 0-.705 5.453-15.018 7.132-19.385a.353.353 0 01.36-.226l1.411.127a.367.367 0 01.317.282l4.19 20.7a.353.353 0 010 .226z"
              transform="translate(-67.646 -306.54)"
              fill="#263238"
            />
            <path
              data-name="Path 5464"
              d="M116.165 310.1l-3.167.585L98.48 352.9s2.751 4.832 11.682 4.754 11.512-1.5 11.512-1.5l-.254-25.529 3.661-16.887s-5.664-3.469-8.916-3.638z"
              transform="translate(-75.3 -290.107)"
              fill="#fff"
            />
            <path
              data-name="Path 5465"
              d="M109.789 357.85c-8.846 0-11.639-4.733-11.752-4.938a.346.346 0 010-.289l14.517-42.2a.339.339 0 01.268-.233l3.167-.585h.085c3.3.162 8.846 3.527 9.079 3.675a.339.339 0 01.162.374l-3.654 16.846.254 25.486a.36.36 0 01-.183.317c-.113.056-2.772 1.46-11.682 1.545zm-11.082-5.15c.522.748 3.527 4.508 11.287 4.451 7.421-.071 10.426-1.079 11.16-1.376l-.247-25.3a.262.262 0 010-.078l3.612-16.648c-1.051-.614-5.714-3.28-8.465-3.442l-2.92.536z"
              transform="translate(-75.16 -289.959)"
              fill="#263238"
            />
            <path
              data-name="Path 5466"
              d="M138.711 292.592a35.9 35.9 0 01-.2 4.409c-.2.536-1.2 1.27-1.2 1.742s1.136 2.335.938 2.822-2.208 1-2.208 1-1.672 3.273-2.476 3.6-3.943-1.27-3.943-1.27l-1.806 5.559s-.8 1.538-3.809 1.065-4.077-1.6-4.232-2.335-.466-.938-.063-1.742 1-2.539 1-2.539l3.809-8.02.6-3.675s1.34-2.6 6.285-3.139a8.184 8.184 0 017.305 2.523z"
              transform="translate(-81.495 -284.188)"
              fill="#fff"
            />
            <path
              data-name="Path 5467"
              d="M124.946 311.791a7.408 7.408 0 01-1.129-.092c-3.054-.48-4.331-1.672-4.508-2.624a3.532 3.532 0 00-.127-.48 1.622 1.622 0 01.092-1.481c.388-.769.981-2.483.988-2.5l3.8-8.013.593-3.626a.623.623 0 010-.106c.056-.113 1.481-2.779 6.56-3.33a8.4 8.4 0 017.6 2.681.36.36 0 01.071.212 31.871 31.871 0 01-.226 4.536 3.16 3.16 0 01-.656.91c-.19.212-.515.571-.522.705a6.037 6.037 0 00.381.966c.437.973.705 1.587.529 1.975-.226.515-1.467.938-2.293 1.164-.409.79-1.756 3.294-2.575 3.64s-2.822-.6-3.873-1.1l-1.679 5.157c-.007.115-.712 1.406-3.026 1.406zm.4-18.637l-.585 3.612a.409.409 0 010 .1l-3.809 8.021a26.147 26.147 0 01-1 2.547.945.945 0 00-.056.938 4.734 4.734 0 01.155.578c.1.55 1.037 1.608 3.915 2.053 2.688.416 3.414-.832 3.442-.889l1.785-5.488a.36.36 0 01.2-.219.339.339 0 01.3 0c1.446.705 3.259 1.411 3.647 1.256a12.509 12.509 0 002.293-3.442.367.367 0 01.226-.183 5.694 5.694 0 001.975-.811 6.255 6.255 0 00-.522-1.411 3.95 3.95 0 01-.444-1.256 2.116 2.116 0 01.705-1.178 3.154 3.154 0 00.529-.705 32.5 32.5 0 00.176-4.162 7.8 7.8 0 00-6.9-2.314c-4.268.466-5.82 2.631-6 2.956z"
              transform="translate(-81.358 -284.031)"
              fill="#263238"
            />
            <path
              data-name="Path 5468"
              d="M140.957 307.612a.177.177 0 01-.085 0 2.37 2.37 0 01-1.933-1.9.351.351 0 01.7-.078 1.728 1.728 0 001.411 1.305.353.353 0 01.254.43.36.36 0 01-.347.243z"
              transform="translate(-87.218 -288.698)"
              fill="#263238"
            />
            <path
              data-name="Path 5469"
              d="M143.565 299.383a.36.36 0 01-.275-.127 1.728 1.728 0 00-1.629-.621.36.36 0 01-.437-.24.346.346 0 01.24-.437 2.419 2.419 0 012.377.846.367.367 0 01-.049.5.4.4 0 01-.226.078z"
              transform="translate(-87.887 -286.515)"
              fill="#263238"
            />
            <path
              data-name="Path 5470"
              d="M142.756 301.41c-.078.339-.325.578-.557.529s-.367-.367-.3-.705.317-.585.557-.536.37.366.3.712z"
              transform="translate(-88.086 -287.335)"
              fill="#263238"
            />
            <path
              data-name="Path 5471"
              d="M133.03 310.375l-1.94-1.735 1.411 3.612z"
              transform="translate(-84.906 -289.677)"
              fill="#263238"
            />
            <path
              data-name="Path 5472"
              d="M132.345 312.452a.353.353 0 01-.324-.226l-1.411-3.612a.367.367 0 01.564-.416l1.94 1.735a.346.346 0 01.1.36l-.529 1.869a.36.36 0 01-.324.261zm-.536-2.716l.487 1.256.19-.649z"
              transform="translate(-84.758 -289.524)"
              fill="#263238"
            />
            <path
              data-name="Path 5473"
              d="M129.809 293.989a29 29 0 003.471-1.411c.705-.473-.261-2.01.339-2.539s3.21-.8 4.613-.339 1.467 1.538 2.822 1.34 3.005-1.27 2.271-3.146a6.454 6.454 0 00-4.747-3.675c-1.806-.2-3.675.268-6.017 0s-4.74-1.136-6.017 1.411-2.335 5.283-1.869 6.617.67 3.012 1.206 3.28 3.928-1.538 3.928-1.538z"
              transform="translate(-82.983 -282.376)"
              fill="#263238"
            />
            <path
              data-name="Path 5474"
              d="M125.782 295.744a.648.648 0 01-.282-.056c-.494-.247-.705-1.065-.981-2.116-.12-.459-.24-.931-.4-1.368-.43-1.234.183-3.485 1.891-6.892 1.185-2.377 3.28-2.06 5.3-1.749.36.056.705.113 1.072.155a18.991 18.991 0 003.351 0 15.3 15.3 0 012.666 0 6.751 6.751 0 015.03 3.894 2.356 2.356 0 01-.092 2.116 3.456 3.456 0 01-2.455 1.5 2 2 0 01-1.82-.635 3.119 3.119 0 00-1.15-.705c-1.333-.444-3.8-.155-4.232.261-.141.127-.071.543 0 .91.1.578.212 1.3-.367 1.665a27.445 27.445 0 01-3.527 1.411 13.036 13.036 0 01-4.004 1.609zm3.485-11.674a2.631 2.631 0 00-2.624 1.573c-1.982 3.957-2.116 5.643-1.855 6.349.162.466.289.952.416 1.411.162.614.4 1.545.614 1.651a15.92 15.92 0 003.619-1.531h.056a27.76 27.76 0 003.4-1.361c.169-.113.127-.466.042-.952s-.19-1.171.247-1.559c.705-.656 3.527-.882 4.938-.4a3.794 3.794 0 011.411.846 1.326 1.326 0 001.256.473 2.822 2.822 0 001.954-1.157 1.665 1.665 0 00.042-1.5 6.081 6.081 0 00-4.451-3.457 14.668 14.668 0 00-2.547 0 19.716 19.716 0 01-3.471 0c-.367-.042-.705-.1-1.1-.155a13.171 13.171 0 00-1.947-.226z"
              transform="translate(-82.815 -282.226)"
              fill="#263238"
            />
            <path
              data-name="Path 5475"
              d="M131.281 298.422s-.268-3.2-1.672-2.6-1.27 3.675-.4 4.275a1.213 1.213 0 001.608-.332"
              transform="translate(-84.159 -285.877)"
              fill="#fff"
            />
            <path
              data-name="Path 5476"
              d="M129.667 300.5a1.411 1.411 0 01-.8-.268 3.2 3.2 0 01-.783-2.737 2.448 2.448 0 011.249-2.151 1.065 1.065 0 011.009.049c.931.557 1.129 2.617 1.15 2.822a.354.354 0 11-.705.064c-.063-.748-.339-2.025-.811-2.314a.36.36 0 00-.367 0 1.834 1.834 0 00-.825 1.573 2.631 2.631 0 00.487 2.116c.585.409 1.1-.233 1.122-.261a.354.354 0 01.557.437 1.749 1.749 0 01-1.283.67z"
              transform="translate(-84.013 -285.73)"
              fill="#263238"
            />
            <path
              data-name="Path 5477"
              d="M105.119 316.646l-13.368 43.375s-3.478-2.737-5.41-4.613S83.935 353 83.935 353l4.811-10.623.868-3.407-14.108 9.361-2.406-4.746 11.992-10.694s7.35-20.386 7.816-20.654 13.84-2.067 13.84-2.067z"
              transform="translate(-67.823 -290.127)"
              fill="#38c5ae"
            />
            <path
              data-name="Path 5478"
              d="M91.605 360.222a.36.36 0 01-.219-.078s-3.527-2.772-5.439-4.635-2.405-2.405-2.427-2.427a.346.346 0 01-.056-.374l4.811-10.631.628-2.462-13.346 8.855a.36.36 0 01-.508-.134l-2.405-4.747a.353.353 0 01.078-.423l11.9-10.638c7.364-20.422 7.8-20.668 7.943-20.753.48-.275 9.925-1.573 13.967-2.116a.359.359 0 01.31.113.367.367 0 01.078.324l-1.587 6.483-13.4 43.4a.353.353 0 01-.233.233zm-7.4-7.435c.261.275.9.924 2.229 2.215 1.517 1.467 4.014 3.492 4.987 4.268l13.206-42.87 1.474-5.968c-5.051.705-12.232 1.707-13.149 1.954-.635 1.1-4.938 12.747-7.7 20.457a.423.423 0 01-.1.148L73.391 343.5l2.116 4.148 13.77-9.135a.353.353 0 01.4 0 .339.339 0 01.134.374l-.875 3.464zm20.767-36.293z"
              transform="translate(-67.677 -289.976)"
              fill="#263238"
            />
            <path
              data-name="Path 5479"
              d="M119.687 308.49s-2.01-.536-3.012.466-4.677 6.285-3.739 6.814 3.471-.868 3.471-.868l.4 1.206z"
              transform="translate(-79.514 -289.59)"
              fill="#fff"
            />
            <path
              data-name="Path 5480"
              d="M116.666 316.313a.353.353 0 01-.324-.247l-.268-.8c-.825.409-2.575 1.171-3.449.67a.635.635 0 01-.317-.508c-.19-1.411 3.139-6.017 3.986-6.864 1.136-1.136 3.259-.586 3.351-.564a.353.353 0 01.219.183.332.332 0 010 .282l-2.836 7.618a.353.353 0 01-.362.23zm1.679-7.76a2.187 2.187 0 00-1.559.508c-1.185 1.185-4.056 5.643-3.788 6.3.494.268 2.116-.367 3.1-.91a.353.353 0 01.3 0 .36.36 0 01.2.212l.085.261 2.377-6.3a5.044 5.044 0 00-.72-.078z"
              transform="translate(-79.371 -289.442)"
              fill="#263238"
            />
            <path
              data-name="Path 5481"
              d="M96.362 342.862h-.078a.346.346 0 01-.268-.416l4.345-19.984a.36.36 0 01.423-.275.353.353 0 01.268.423l-4.345 19.97a.36.36 0 01-.346.282z"
              transform="translate(-74.571 -293.665)"
              fill="#263238"
            />
            <path
              data-name="Path 5482"
              d="M109.337 332.814h-.056l-6.821-1.206a.332.332 0 01-.226-.148.317.317 0 01-.056-.261l.4-2.208a.339.339 0 01.388-.282l6.751.8a.353.353 0 01.3.4.339.339 0 01-.388.3l-6.419-.762-.282 1.531 6.151 1.086.254-.9a.346.346 0 01.43-.24.353.353 0 01.247.43l-.332 1.206a.36.36 0 01-.341.254z"
              transform="translate(-76.386 -295.587)"
              fill="#263238"
            />
            <path
              data-name="Path 5483"
              d="M101.34 323.821a.353.353 0 01-.346-.289c0-.162-.705-4.014-.875-6.151a.354.354 0 11.705-.056c.155 2.116.868 6.038.875 6.081a.36.36 0 01-.289.409z"
              transform="translate(-75.782 -292.139)"
              fill="#263238"
            />
            <path
              data-name="Path 5484"
              d="M100.011 326.085s-1.185-1.989-1.982-3.252a.36.36 0 01.113-.487.346.346 0 01.487.113c.8 1.27 1.989 3.259 1.989 3.259z"
              transform="translate(-75.152 -293.698)"
              fill="#263238"
            />
            <path
              data-name="Path 5485"
              d="M129.942 317.012s-3.287 13.812-3.2 18.023 1.192 26.53 1.192 26.53 4.282-.8 5-1.037l3.492-1.107s-4.846-15.731-4.846-16.281.875-4.289.875-4.289 2.864 6.433 3.259 6.906 11.336 5.41 11.336 5.41l.973-5.806-6.913-6.349s-1.5-11.992-1.5-12.944.4-6.991.4-6.991l-8.655-6.828z"
              transform="translate(-83.624 -290.74)"
              fill="#38c5ae"
            />
            <path
              data-name="Path 5486"
              d="M127.777 361.742a.359.359 0 01-.219-.078.331.331 0 01-.127-.261c0-.226-1.115-22.369-1.192-26.537s3.083-17.551 3.217-18.115l1.411-4.769a.346.346 0 01.557-.176l8.655 6.828a.346.346 0 01.134.3c0 .063-.4 6.038-.4 6.969 0 .705.959 8.6 1.488 12.775l6.814 6.264a.353.353 0 01.106.317l-.995 5.791a.353.353 0 01-.176.254.36.36 0 01-.317 0c-3.308-1.488-11.054-5.015-11.463-5.5s-2.01-4.105-2.871-6.024c-.3 1.34-.635 2.885-.635 3.181.071.571 2.927 9.989 4.832 16.175a.353.353 0 01-.233.437s-2.772.875-3.485 1.115-4.874 1.009-5.051 1.044zm2.363-44.815c-.1.409-3.273 13.854-3.2 17.924.071 3.844 1.016 23.074 1.171 26.1 1.411-.261 4.042-.776 4.557-.945s2.405-.769 3.167-1.009c-1.249-4.042-4.762-15.519-4.762-16.048s.8-3.986.889-4.373a.339.339 0 01.31-.268.367.367 0 01.353.2c1.093 2.462 2.927 6.49 3.2 6.828.43.374 6.68 3.266 10.793 5.128l.868-5.171-6.765-6.222a.332.332 0 01-.113-.219c-.063-.487-1.51-11.992-1.51-12.987s.317-5.791.381-6.828l-8.1-6.391z"
              transform="translate(-83.477 -290.586)"
              fill="#263238"
            />
            <path
              data-name="Path 5487"
              d="M164.619 363.709s-3.464.755-4.352.839a10.158 10.158 0 01-3.337-.353c-.755-.268-2.222-.847-2.222-.847a2.37 2.37 0 01-.085-1.376c.219-.487 1.411-.444 1.411-.444l7.513.755z"
              transform="translate(-91.82 -305.257)"
              fill="#fff"
            />
            <path
              data-name="Path 5488"
              d="M159.569 364.782a10.454 10.454 0 01-2.9-.4c-.762-.268-2.236-.846-2.236-.846a.36.36 0 01-.2-.212 2.7 2.7 0 01-.078-1.644c.3-.67 1.524-.656 1.756-.649l7.534.755a.388.388 0 01.247.141l1.065 1.411a.346.346 0 01.049.332.367.367 0 01-.261.226c-.141 0-3.492.755-4.388.846a3.749 3.749 0 01-.588.04zm-4.719-1.841c.4.155 1.453.564 2.053.776a10.166 10.166 0 003.181.339c.649-.071 2.772-.508 3.774-.705l-.642-.854-7.357-.783c-.459 0-1 .1-1.065.24a1.862 1.862 0 00.056.987z"
              transform="translate(-91.673 -305.11)"
              fill="#263238"
            />
            <path
              data-name="Path 5489"
              d="M134.694 344.243h-.094a.36.36 0 01-.247-.437l3.894-14.108a.365.365 0 11.705.19L135.06 344a.353.353 0 01-.366.243z"
              transform="translate(-85.865 -295.8)"
              fill="#263238"
            />
            <path
              data-name="Path 5490"
              d="M134.318 336.719h-.092L130.1 335.6a.346.346 0 01-.261-.381l.24-1.912a.374.374 0 01.155-.247.36.36 0 01.282-.049l4.684 1.192a.353.353 0 01.254.43.346.346 0 01-.423.254l-4.3-1.093-.148 1.206 3.83 1.03a.356.356 0 01-.092.705z"
              transform="translate(-84.537 -296.855)"
              fill="#263238"
            />
            <path
              data-name="Path 5491"
              d="M138.073 337.219a.367.367 0 01-.2-.063.353.353 0 01-.085-.487l2.384-3.421a.354.354 0 11.578.409l-2.384 3.414a.346.346 0 01-.289.148z"
              transform="translate(-86.86 -296.882)"
              fill="#263238"
            />
            <path
              data-name="Path 5492"
              d="M130.79 318.874l.875-.875s1.982 2.3 2.384 1.587a7.823 7.823 0 00.55-5.559c-.635-3.019-1.658-2.927-1.658-2.927l-1.806 5.573z"
              transform="translate(-84.818 -290.401)"
              fill="#fff"
            />
            <path
              data-name="Path 5493"
              d="M133.67 319.928c-.635 0-1.6-.938-2.166-1.559l-.614.607a.353.353 0 01-.409.063.346.346 0 01-.183-.367l.346-2.222 1.82-5.6a.339.339 0 01.3-.24c.219 0 1.368.035 2.032 3.2a8.226 8.226 0 01-.593 5.8.593.593 0 01-.473.317zm-2.17-2.428a.345.345 0 01.254.12 6.166 6.166 0 001.834 1.6 7.661 7.661 0 00.487-5.269 4.591 4.591 0 00-1.086-2.532l-1.693 5.192-.169 1.1.106-.113a.381.381 0 01.267-.098z"
              transform="translate(-84.671 -290.257)"
              fill="#263238"
            />
            <path
              data-name="Path 5494"
              d="M186.35 367.54l-4.176 28.216-9.574 27.462a19.379 19.379 0 00-4.232 7.52c-.931 3.993 1.707 4.232 3.076 3.188s4.67-9.8 4.783-10.25 14.4-24.774 14.609-25.084 7.054-20.292 7.054-20.292l5.008 19.6 10.384 28.506s.705 4.9 2.4 6.842 4.232 3.3 4.67 1.594.113-4.677-1.143-6.038a50.833 50.833 0 01-3.188-4.232l-3.647-29.4-2.257-27.511z"
              transform="translate(-95.831 -307.028)"
              fill="#fff"
            />
            <path
              data-name="Path 5495"
              d="M219.248 435.81c-1.206 0-2.822-1.234-3.964-2.49-1.7-1.926-2.4-6.49-2.476-6.991l-10.32-28.449-4.726-18.489c-2.222 6.462-6.511 18.926-6.723 19.244-.12.183-14.2 24.153-14.553 24.993-.078.339-3.407 9.3-4.938 10.426a2.582 2.582 0 01-2.822.268c-.663-.43-1.333-1.411-.79-3.823a19.489 19.489 0 014.232-7.626l9.544-27.4 4.155-28.139a.36.36 0 01.353-.3l23.765.134a.353.353 0 01.353.324l2.257 27.511 3.633 29.3a48.447 48.447 0 003.111 4.105c1.333 1.453 1.714 4.522 1.22 6.349a1.277 1.277 0 01-.952.995 1.48 1.48 0 01-.359.058zm-21.472-58.01a.353.353 0 01.325.268l5.015 19.6 10.355 28.456v.071c0 .049.705 4.818 2.307 6.652 1.263 1.411 2.857 2.42 3.633 2.236.134-.035.332-.12.437-.494.444-1.665.085-4.465-1.065-5.714a49.041 49.041 0 01-3.217-4.232.332.332 0 01-.064-.155l-3.647-29.4-2.228-27.188-23.137-.134-4.127 27.9-9.587 27.511a.382.382 0 01-.078.127s-3.252 3.527-4.134 7.357c-.353 1.552-.176 2.638.487 3.076a1.9 1.9 0 002.039-.247c1.234-.924 4.493-9.431 4.656-10.059s14.5-24.979 14.63-25.176c.24-.48 4.338-12.352 7.054-20.2a.36.36 0 01.346-.255zm-25.3 45.252z"
              transform="translate(-95.702 -306.881)"
              fill="#263238"
            />
            <path
              data-name="Path 5496"
              d="M215.061 395.165l-2.261-27.511-23.765-.134-4.176 28.216-7.562 21.7 4.395 1.361c4.183-7.223 11.667-19.963 11.83-20.21s7.054-20.288 7.054-20.288l5.008 19.6 8.225 22.573 4.2-1.411z"
              transform="translate(-98.519 -307.022)"
              fill="#263238"
            />
            <path
              data-name="Path 5497"
              d="M213.693 420.7a.353.353 0 01-.332-.233l-8.225-22.573-4.726-18.489c-2.222 6.462-6.511 18.926-6.723 19.243s-7.562 12.8-11.794 20.182a.353.353 0 01-.409.162l-4.395-1.361a.36.36 0 01-.212-.183.338.338 0 010-.275l7.562-21.7 4.155-28.139a.36.36 0 01.353-.3l23.765.134a.353.353 0 01.353.324l2.257 27.511 2.963 23.9a.346.346 0 01-.24.374l-4.2 1.411zm-13.233-42.9a.353.353 0 01.325.268l5.015 19.6 8.105 22.249 3.6-1.213-2.934-23.624-2.229-27.172-23.137-.134-4.127 27.9-7.46 21.426 3.781 1.164c4.19-7.23 11.526-19.751 11.7-19.984.24-.48 4.338-12.352 7.054-20.2a.36.36 0 01.307-.28z"
              transform="translate(-98.386 -306.881)"
              fill="#263238"
            />
            <path
              data-name="Path 5498"
              d="M171.484 458.905c.705-.529 1.94-3.146 2.977-5.608l-2.405 2.765-2.822-.8.494-2.885a13.706 13.706 0 00-1.291 3.337c-.946 3.995 1.678 4.221 3.047 3.191z"
              transform="translate(-95.849 -332.021)"
              fill="#263238"
            />
            <path
              data-name="Path 5499"
              d="M169.819 459.638a2.025 2.025 0 01-1.122-.317c-.663-.43-1.333-1.411-.79-3.823a13.905 13.905 0 011.326-3.421.353.353 0 01.656.219l-.437 2.568 2.328.656 2.257-2.6a.353.353 0 01.593.367c-1.411 3.337-2.448 5.276-3.09 5.763a3.019 3.019 0 01-1.721.585zm-1.115-4.43c-.042.148-.078.3-.113.444-.353 1.552-.176 2.638.487 3.076a1.9 1.9 0 002.039-.247c.2-.148.748-.776 1.94-3.358l-.91 1.023a.346.346 0 01-.36.113l-2.822-.8a.374.374 0 01-.265-.251zm2.624 3.527z"
              transform="translate(-95.694 -331.879)"
              fill="#263238"
            />
            <path
              data-name="Path 5500"
              d="M239.344 460.214c.451-1.714.113-4.677-1.143-6.038l-.268-.31.614 3.837-2.278.8-3.619-4.79a12.7 12.7 0 002.025 4.938c1.707 1.901 4.211 3.27 4.669 1.563z"
              transform="translate(-114.825 -332.413)"
              fill="#263238"
            />
            <path
              data-name="Path 5501"
              d="M238.214 461.188c-1.206 0-2.822-1.234-3.964-2.49s-1.728-3.414-2.116-5.065a.346.346 0 01.621-.289l3.471 4.585 1.757-.614-.564-3.527a.353.353 0 01.2-.374.36.36 0 01.416.092l.261.3c1.333 1.453 1.714 4.522 1.22 6.349a1.277 1.277 0 01-.952.995 1.484 1.484 0 01-.35.038zm-4.938-5.975a8.643 8.643 0 001.474 3.012c1.263 1.411 2.857 2.42 3.633 2.236.134-.035.332-.12.437-.494a7.929 7.929 0 00-.487-4.839l.374 2.363a.353.353 0 01-.233.388l-2.25.818a.353.353 0 01-.4-.12z"
              transform="translate(-114.668 -332.258)"
              fill="#263238"
            />
            <path
              data-name="Path 5502"
              d="M193.94 367.207s4.9 8.655 11.689 9.043 12.077-8.909 12.077-8.909l-23.321-.931z"
              transform="translate(-103.421 -306.695)"
              fill="#fff"
            />
            <path
              data-name="Path 5503"
              d="M205.9 376.476h-.444c-6.906-.4-11.773-8.867-11.992-9.227a.374.374 0 010-.346l.444-.8a.36.36 0 01.325-.176l23.321.931a.36.36 0 01.3.183.353.353 0 010 .346c-.21.363-5.24 9.089-11.954 9.089zm-11.71-9.417c.705 1.2 5.3 8.352 11.287 8.7 5.643.324 10.236-6.349 11.442-8.232l-22.51-.9z"
              transform="translate(-103.268 -306.554)"
              fill="#263238"
            />
            <path
              data-name="Path 5504"
              d="M199.18 321s-7.654 3.725-7.7 4.232-5.192 20.908-5.192 20.908-1.827 4.084.473 5.368 6.405-2.977 6.405-2.977l-1.686 5.333a35.5 35.5 0 0012.817 3.1c5.643.289 10.948-2.97 10.948-2.97l-.811-5.643s4.74 3.2 6.426 2.455 2.956-2.25 2.956-3.259-.8-1.284-2.159-2.772-3.576-8.846-3.576-8.846-1.89-10.123-2.363-10.934-6.349-3.442-6.349-3.442z"
              transform="translate(-100.966 -293.318)"
              fill="#38c5ae"
            />
            <path
              data-name="Path 5505"
              d="M204.886 357.174h-.748a36.217 36.217 0 01-12.965-3.153.346.346 0 01-.173-.421l1.284-4.056c-1.411 1.227-4.049 3.111-5.841 2.116-2.547-1.411-.705-5.643-.621-5.813 1.742-6.955 5.086-20.344 5.164-20.817 0-.212.092-.656 7.894-4.451a.3.3 0 01.169-.035l10.2.543a.275.275 0 01.127 0c1.411.628 6.01 2.744 6.5 3.591s2.116 9.347 2.405 11.047c.755 2.483 2.469 7.548 3.527 8.677.423.466.8.818 1.107 1.1.705.642 1.143 1.065 1.143 1.9 0 1.206-1.411 2.822-3.167 3.576-1.467.649-4.684-1.164-6.109-2.053l.705 4.839a.346.346 0 01-.162.346 22.326 22.326 0 01-10.439 3.064zm-13.121-3.668a35.822 35.822 0 0012.408 2.942c4.938.247 9.544-2.229 10.581-2.822l-.776-5.368a.36.36 0 01.155-.353.353.353 0 01.388 0c1.771 1.192 4.987 2.906 6.088 2.42 1.622-.705 2.744-2.116 2.744-2.935 0-.508-.233-.755-.917-1.411-.31-.289-.705-.656-1.15-1.143-1.411-1.531-3.527-8.677-3.654-8.98-.705-3.929-2.01-10.313-2.328-10.863s-3.308-2-6.13-3.273l-10.038-.48a82.282 82.282 0 00-7.435 3.964c-.317 1.446-4.67 18.82-5.178 20.852-.042.1-1.693 3.866.3 4.973 1.686.945 4.888-1.785 5.982-2.913a.353.353 0 01.437-.056.36.36 0 01.155.409z"
              transform="translate(-100.816 -293.185)"
              fill="#263238"
            />
            <path
              data-name="Path 5506"
              d="M196.183 352.131h-.056a.353.353 0 01-.289-.409l2.568-15.138-1.306-3.984a.36.36 0 01.226-.444.367.367 0 01.451.226l1.326 4.063a.459.459 0 010 .169l-2.589 15.23a.353.353 0 01-.331.287z"
              transform="translate(-103.979 -296.599)"
              fill="#263238"
            />
            <path
              data-name="Path 5507"
              d="M225.934 352.282a.353.353 0 01-.353-.324l-.952-15.251a.62.62 0 010-.12l.938-3.2a.353.353 0 01.437-.24.346.346 0 01.24.437l-.917 3.139.973 15.187a.346.346 0 01-.332.374z"
              transform="translate(-112.461 -296.891)"
              fill="#263238"
            />
            <path
              data-name="Path 5508"
              d="M207.174 366.483a48.2 48.2 0 01-12.655-1.665.353.353 0 11.2-.67c.12 0 11.526 3.442 22.693.31a.365.365 0 11.19.705 38.855 38.855 0 01-10.428 1.32z"
              transform="translate(-103.507 -306.02)"
              fill="#263238"
            />
            <path
              data-name="Path 5509"
              d="M72.314 349.48a22.978 22.978 0 00-2.532.67c-.444.226-.522 1.122-1.122 1.5s-1.488.9-.966 1.27 1.608.649 2.116-.085a3.682 3.682 0 012.116-1.277"
              transform="translate(-66.184 -301.708)"
              fill="#fff"
            />
            <path
              data-name="Path 5510"
              d="M68.707 353.5a2.476 2.476 0 01-1.411-.444.635.635 0 01-.3-.529c0-.5.621-.875 1.206-1.242l.085-.056a1.693 1.693 0 00.508-.705 1.6 1.6 0 01.67-.818 20.673 20.673 0 012.621-.706.353.353 0 01.416.275.346.346 0 01-.268.416 20.154 20.154 0 00-2.455.642 1.411 1.411 0 00-.324.487 2.236 2.236 0 01-.762 1l-.085.056a3.9 3.9 0 00-.854.635c.409.268 1.256.515 1.644 0 .543-.741 2.053-1.58 2.518-1.411a.346.346 0 01.2.458.36.36 0 01-.4.219 3.781 3.781 0 00-1.746 1.123 1.5 1.5 0 01-1.263.593z"
              transform="translate(-66.026 -301.563)"
              fill="#263238"
            />
            <path
              data-name="Path 5511"
              d="M180.46 363.223a2.6 2.6 0 01-1.263-.416 4.1 4.1 0 00-1.629-.607c-.423-.1-.282-.473.324-.705a3.844 3.844 0 012.293.092 2.962 2.962 0 01.839.515z"
              transform="translate(-98.527 -305.208)"
              fill="#fff"
            />
            <path
              data-name="Path 5512"
              d="M180.309 363.45a2.914 2.914 0 01-1.46-.494 3.484 3.484 0 00-1.411-.515h-.106a.593.593 0 01-.522-.515c0-.332.275-.656.8-.861a4.191 4.191 0 012.554.1 3.055 3.055 0 01.952.593.367.367 0 01.071.409l-.564 1.122a.346.346 0 01-.314.161zm-2.6-1.679a3.929 3.929 0 011.566.635 2.017 2.017 0 00.832.317l.324-.649a2.613 2.613 0 00-.536-.282 3.477 3.477 0 00-2.024-.092z"
              transform="translate(-98.375 -305.076)"
              fill="#263238"
            />
            <path
              data-name="Rectangle 44679"
              transform="translate(54.402 50.77)"
              fill="#227a65"
              d="M0 0H128.596V5.94H0z"
            />
            <path
              data-name="Path 5513"
              d="M271.161 359.875H142.593a.353.353 0 01-.353-.353v-5.94a.353.353 0 01.353-.353h128.568a.353.353 0 01.353.353v5.94a.353.353 0 01-.353.353zm-128.236-.705h127.9v-5.234h-127.88z"
              transform="translate(-88.191 -302.812)"
              fill="#263238"
            />
            <path
              data-name="Path 5514"
              d="M98.75 320.11a26.693 26.693 0 1026.685 26.69 26.693 26.693 0 00-26.685-26.69zm0 46.395a19.709 19.709 0 1119.7-19.707 19.709 19.709 0 01-19.7 19.702z"
              transform="translate(-67.514 -293.056)"
              fill="#227a65"
            />
            <path
              data-name="Path 5515"
              d="M98.6 373.691a27.045 27.045 0 1127.038-27.043A27.045 27.045 0 0198.6 373.691zm0-53.378a26.34 26.34 0 1026.333 26.335A26.34 26.34 0 0098.6 320.312zm0 46.395a20.062 20.062 0 1120.055-20.059A20.062 20.062 0 0198.6 366.707zm0-39.411a19.356 19.356 0 1019.349 19.352A19.356 19.356 0 0098.6 327.3z"
              transform="translate(-67.366 -292.905)"
              fill="#263238"
            />
            <path
              data-name="Path 5516"
              d="M292.26 353.73v27.857h5.46v-.155a6.469 6.469 0 0112.937 0v.155h4.7V353.73z"
              transform="translate(-132.386 -302.96)"
              fill="#227a65"
            />
            <path
              data-name="Path 5517"
              d="M315.2 381.792h-4.719a.339.339 0 01-.254-.106.353.353 0 01-.1-.254v-.085a6.116 6.116 0 10-12.225-.063v.148a.325.325 0 01-.1.254.339.339 0 01-.254.106h-5.474a.353.353 0 01-.353-.353v-27.856a.353.353 0 01.353-.353H315.2a.353.353 0 01.353.353v27.857a.353.353 0 01-.353.352zm-4.359-.705h4.007v-27.152h-22.39v27.151h4.769a6.821 6.821 0 0113.636 0z"
              transform="translate(-132.227 -302.812)"
              fill="#263238"
            />
            <path
              data-name="Path 5518"
              d="M249.65 353.73v15.992h3.139v-.092a3.71 3.71 0 117.421 0v.092h2.709V353.73z"
              transform="translate(-119.833 -302.96)"
              fill="#227a65"
            />
            <path
              data-name="Path 5519"
              d="M262.771 369.927h-2.709a.36.36 0 01-.254-.106.353.353 0 01-.1-.261l.353-.078h-.353a3.358 3.358 0 10-6.716 0c0 .2-.155.444-.353.444H249.5a.353.353 0 01-.353-.353v-15.99a.353.353 0 01.353-.353h13.269a.353.353 0 01.353.353v15.992a.353.353 0 01-.351.352zm-2.363-.705h2.039v-15.287h-12.592v15.286h2.445a4.063 4.063 0 018.112 0z"
              transform="translate(-119.686 -302.812)"
              fill="#263238"
            />
            <path
              data-name="Path 5520"
              d="M213.981 288.569s1.855-1.517 1.009-3.033-4.55-3.76-6.067-3.2-4.493 3.71-4.719 4.888 2.116 2.822 2.582 2.871 4.274-2.195 7.195-1.526z"
              transform="translate(-106.44 -281.901)"
              fill="#263238"
            />
            <path
              data-name="Path 5521"
              d="M206.663 290.3h-.063a5.692 5.692 0 01-2.448-1.876 1.806 1.806 0 01-.437-1.411c.254-1.34 3.351-4.564 4.938-5.149 1.728-.649 5.643 1.778 6.5 3.358.973 1.756-1.009 3.407-1.1 3.478a.324.324 0 01-.3.071c-2.046-.473-4.613.593-6 1.157a3.781 3.781 0 01-1.093.374zm2.681-7.844a1.412 1.412 0 00-.444.064c-1.411.536-4.3 3.612-4.493 4.628-.169.9 1.9 2.37 2.286 2.448.063 0 .451-.176.8-.317 1.411-.586 4.014-1.658 6.236-1.234.367-.346 1.411-1.446.811-2.476a8.35 8.35 0 00-5.196-3.112z"
              transform="translate(-106.297 -281.757)"
              fill="#263238"
            />
            <path
              data-name="Path 5522"
              d="M209.045 290.394s-6.066 1.686-7.759 4.938-1.8 3.986-.846 5.559a17.079 17.079 0 005.509 5.509c2.194 1.122 9.17-.508 9.17-.508a6.112 6.112 0 002.822-2.638c.705-1.686 2.187-4.049 1.178-6.574s-5.509-6.01-6.913-6.405a6.715 6.715 0 00-3.16.12z"
              transform="translate(-105.159 -284.227)"
              fill="#263238"
            />
            <path
              data-name="Path 5523"
              d="M208.28 307a6.052 6.052 0 01-2.61-.43 17.358 17.358 0 01-5.643-5.643c-1.093-1.792-.818-2.723.832-5.9 1.728-3.351 7.689-5.044 7.964-5.121a7.054 7.054 0 013.344-.113c1.587.444 6.109 4.028 7.139 6.61.9 2.236-.035 4.289-.783 5.932-.141.317-.282.621-.4.9a5.955 5.955 0 01-2.991 2.822 35.835 35.835 0 01-6.852.943zm2.582-16.662a7.4 7.4 0 00-1.876.261c-.063 0-5.947 1.686-7.541 4.769-1.7 3.287-1.686 3.845-.854 5.213a16.6 16.6 0 005.368 5.375c1.7.875 7.012-.092 8.916-.529a5.61 5.61 0 002.561-2.434c.12-.289.261-.6.409-.931.705-1.524 1.552-3.421.769-5.382-.973-2.448-5.425-5.841-6.673-6.194a4.232 4.232 0 00-1.093-.148zm-1.94-.092z"
              transform="translate(-105.022 -284.079)"
              fill="#263238"
            />
            <path
              data-name="Path 5524"
              d="M215.294 296.54s-3.026 1.862-4.578 2.949a15.2 15.2 0 01-3.416 1.711 2.017 2.017 0 00-1.086 2.25c.31 1.63.9 7.259.9 7.259l-1.051 2.286 4.5 4.938 3.569-4.656.388-2.405s3.259-2.017 3.337-2.483 1.009-7.287.931-7.992-3.494-3.857-3.494-3.857z"
              transform="translate(-106.992 -286.112)"
              fill="#fff"
            />
            <path
              data-name="Path 5525"
              d="M210.414 318.174a.367.367 0 01-.261-.113l-4.5-4.938a.353.353 0 01-.056-.388l1.009-2.194c-.078-.755-.6-5.643-.882-7.132a2.363 2.363 0 011.291-2.645 14.889 14.889 0 003.358-1.672c1.538-1.079 4.564-2.942 4.592-2.956a.339.339 0 01.423.042c1.058.981 3.527 3.351 3.6 4.1s-.889 7.795-.931 8.084c0 .155-.106.614-3.365 2.645l-.36 2.243a.472.472 0 01-.071.162l-3.569 4.656a.332.332 0 01-.268.134zm-4.084-5.382l4.063 4.479 3.259-4.232.374-2.321a.339.339 0 01.162-.24 18.871 18.871 0 003.188-2.293c.078-.5.981-7.23.917-7.844a20.322 20.322 0 00-3.188-3.478c-.705.452-3.054 1.9-4.331 2.822a15.518 15.518 0 01-3.527 1.756 1.658 1.658 0 00-.854 1.848c.31 1.622.882 7.054.9 7.287a.324.324 0 010 .183z"
              transform="translate(-106.845 -285.977)"
              fill="#263238"
            />
            <path
              data-name="Path 5526"
              d="M218.561 307.9a.356.356 0 01-.1-.7 4.14 4.14 0 001.411-.656 4.129 4.129 0 00-.578-.924c-.254-.31-.381-.466-.381-.663s.141-1.524.169-1.778a.367.367 0 01.4-.317.36.36 0 01.31.4 59.415 59.415 0 00-.169 1.637l.219.282c.444.543 1.107 1.368.508 1.9a5.093 5.093 0 01-1.658.811z"
              transform="translate(-110.57 -287.973)"
              fill="#263238"
            />
            <path
              data-name="Path 5527"
              d="M217.623 311.52a2.476 2.476 0 01-1.637-.931.353.353 0 010-.5.36.36 0 01.5 0c.762.8 1.192.755 1.291.67a.346.346 0 01.494 0 .353.353 0 010 .5.9.9 0 01-.656.268z"
              transform="translate(-109.885 -290.073)"
              fill="#263238"
            />
            <path
              data-name="Path 5528"
              d="M216.483 316.083a5.643 5.643 0 01-1.785-.466c-.508-.339-1.968-1.467-1.968-1.467l2.864 4.938.5-.607z"
              transform="translate(-108.957 -291.3)"
              fill="#263238"
            />
            <path
              data-name="Path 5529"
              d="M215.458 319.3a.332.332 0 01-.275-.176l-2.864-4.938a.353.353 0 01.522-.458s1.453 1.122 1.947 1.446a4.845 4.845 0 001.622.416.339.339 0 01.247.134.367.367 0 01.071.268l-.388 2.405a.465.465 0 01-.078.169l-.5.607a.353.353 0 01-.304.127zm-1.686-3.993l1.742 3 .113-.141.317-1.954a4.615 4.615 0 01-1.58-.48 2.361 2.361 0 01-.592-.424z"
              transform="translate(-108.82 -291.152)"
              fill="#263238"
            />
            <path
              data-name="Path 5530"
              d="M207.539 304.413s-1.065-3.2-2.307-1.411.705 4.331 1.686 4.275"
              transform="translate(-106.63 -287.855)"
              fill="#fff"
            />
            <path
              data-name="Path 5531"
              d="M206.75 307.5c-.705 0-1.474-.8-1.9-1.552a3.019 3.019 0 01-.035-3.245 1.263 1.263 0 011.206-.705c.995.141 1.608 1.841 1.721 2.187a.349.349 0 11-.663.219c-.226-.656-.705-1.651-1.157-1.707-.19 0-.388.2-.522.4a2.413 2.413 0 00.078 2.525c.444.79 1.037 1.192 1.291 1.192a.353.353 0 01.042.705z"
              transform="translate(-106.489 -287.72)"
              fill="#263238"
            />
            <ellipse
              data-name="Ellipse 39461"
              cx={0.48}
              cy={0.677}
              rx={0.48}
              ry={0.677}
              transform="translate(105.572 15.711)"
              fill="#263238"
            />
            <ellipse
              data-name="Ellipse 39462"
              cx={0.48}
              cy={0.677}
              rx={0.48}
              ry={0.677}
              transform="translate(109.783 15.711)"
              fill="#263238"
            />
            <path
              data-name="Path 5532"
              d="M214.022 302.909a.36.36 0 01-.254-.106.353.353 0 010-.494 2.307 2.307 0 012.786-.282.354.354 0 01-.353.614 1.594 1.594 0 00-1.933.169.345.345 0 01-.246.099z"
              transform="translate(-109.233 -287.628)"
              fill="#263238"
            />
            <path
              data-name="Path 5533"
              d="M222.326 303.148a.36.36 0 01-.346-.254.564.564 0 00-.3-.395 1.622 1.622 0 00-1.086.063.353.353 0 11-.261-.656 2.314 2.314 0 011.658-.042 1.319 1.319 0 01.67.832.353.353 0 01-.247.437.211.211 0 01-.088.015z"
              transform="translate(-111.132 -287.641)"
              fill="#263238"
            />
            <path
              data-name="Path 5534"
              d="M205.289 317.42l3.936 5-2.7 2.92-3.033-5.453z"
              transform="translate(-106.235 -292.263)"
              fill="#fff"
            />
            <path
              data-name="Path 5535"
              d="M206.372 325.55h-.042a.353.353 0 01-.261-.183l-3.033-5.446a.339.339 0 010-.381l1.8-2.469a.346.346 0 01.557 0l3.95 4.987a.353.353 0 010 .458l-2.709 2.927a.36.36 0 01-.262.107zm-2.617-5.749l2.688 4.825 2.166-2.342-3.456-4.395z"
              transform="translate(-106.084 -292.119)"
              fill="#263238"
            />
            <path
              data-name="Path 5536"
              d="M211.29 324.51l.578 1.686-1.368-.677z"
              transform="translate(-108.3 -294.352)"
              fill="#fff"
            />
            <path
              data-name="Path 5537"
              d="M211.721 326.405a.311.311 0 01-.155 0l-1.366-.705a.388.388 0 01-.19-.24.331.331 0 01.071-.289l.783-1.016a.367.367 0 01.339-.127.346.346 0 01.275.233l.578 1.686a.337.337 0 01-.332.458zm-.825-1.15l.212.106-.092-.268z"
              transform="translate(-108.152 -294.208)"
              fill="#263238"
            />
            <path
              data-name="Path 5538"
              d="M213.61 322.161l1.912 3.767 2.92-4.945-1.968-1.573z"
              transform="translate(-109.216 -292.849)"
              fill="#fff"
            />
            <path
              data-name="Path 5539"
              d="M215.379 326.138a.36.36 0 01-.3-.19l-1.912-3.767a.353.353 0 01.071-.416l2.864-2.751a.353.353 0 01.466 0l1.968 1.573a.367.367 0 01.085.458l-2.92 4.938a.353.353 0 01-.322.155zM213.9 322.1l1.5 2.956 2.441-4.127-1.488-1.185z"
              transform="translate(-109.073 -292.707)"
              fill="#263238"
            />
            <path
              data-name="Path 5540"
              d="M213.265 323.31l-.825 2.532 1.383-1.347z"
              transform="translate(-108.871 -293.998)"
              fill="#fff"
            />
            <path
              data-name="Path 5541"
              d="M212.294 326.048a.338.338 0 01-.183-.049.346.346 0 01-.148-.409l.818-2.532a.367.367 0 01.317-.247.346.346 0 01.339.2l.564 1.178a.346.346 0 01-.078.4l-1.411 1.354a.367.367 0 01-.218.105zm.889-1.933l-.113.332.183-.176z"
              transform="translate(-108.725 -293.851)"
              fill="#263238"
            />
            <path
              data-name="Path 5542"
              d="M181.8 359.812s-.8 2.264-.578 2.575 1 .705 1.213 0a5.874 5.874 0 00.148-2.871c-.273-.473-.783.296-.783.296z"
              transform="translate(-99.664 -304.619)"
              fill="#fff"
            />
            <path
              data-name="Path 5543"
              d="M181.806 363.015a1.361 1.361 0 01-1.009-.55c-.092-.127-.332-.458.522-2.9v-.071c.1-.148.437-.635.868-.635a.607.607 0 01.508.324c.381.635.085 2.483-.106 3.146a.846.846 0 01-.705.705zm.169-3.174a8.918 8.918 0 00-.578 2.278.783.783 0 00.437.19c.049 0 .092-.071.12-.169a6.581 6.581 0 00.212-2.518.989.989 0 00-.191.219z"
              transform="translate(-99.52 -304.471)"
              fill="#263238"
            />
            <path
              data-name="Path 5544"
              d="M183.585 360.816s-.79 2.264-.571 2.582 1 .705 1.213 0a5.785 5.785 0 00.141-2.871c-.282-.466-.783.289-.783.289z"
              transform="translate(-100.191 -304.917)"
              fill="#fff"
            />
            <path
              data-name="Path 5545"
              d="M183.6 364.008a1.411 1.411 0 01-1.009-.543c-.092-.127-.332-.466.522-2.906a.332.332 0 010-.071c.1-.148.437-.628.861-.628a.586.586 0 01.515.317c.381.635.085 2.483-.106 3.153a.847.847 0 01-.705.663.539.539 0 01-.078.015zm.169-3.167a8.888 8.888 0 00-.578 2.271.663.663 0 00.437.19c.049 0 .092-.063.12-.169a6.715 6.715 0 00.212-2.518 1.235 1.235 0 00-.195.226z"
              transform="translate(-100.047 -304.766)"
              fill="#263238"
            />
            <path
              data-name="Path 5546"
              d="M185.905 360.706s-.79 2.264-.571 2.575 1 .705 1.213 0a5.757 5.757 0 00.141-2.864c-.282-.466-.783.289-.783.289z"
              transform="translate(-100.875 -304.885)"
              fill="#fff"
            />
            <path
              data-name="Path 5547"
              d="M185.916 363.878a1.411 1.411 0 01-1.016-.55c-.085-.12-.324-.459.529-2.9a.219.219 0 01.035-.071c.1-.148.437-.628.861-.628a.586.586 0 01.515.317c.381.635.085 2.483-.106 3.146a.853.853 0 01-.705.67zm.162-3.174a9.121 9.121 0 00-.571 2.278.783.783 0 00.437.19c.049 0 .092-.071.12-.169a6.723 6.723 0 00.212-2.518 1.22 1.22 0 00-.198.215z"
              transform="translate(-100.73 -304.727)"
              fill="#263238"
            />
            <path
              data-name="Path 5548"
              d="M187.8 361.3a7.63 7.63 0 00-.437 2.187c.169.261.762.614.924 0a5.587 5.587 0 00.106-2.434c-.2-.417-.593.247-.593.247z"
              transform="translate(-101.476 -305.076)"
              fill="#fff"
            />
            <path
              data-name="Path 5549"
              d="M187.789 364.026a1.086 1.086 0 01-.854-.5c-.078-.12-.254-.4.4-2.483v-.071c.1-.169.374-.571.741-.571a.522.522 0 01.466.31 6.1 6.1 0 01-.078 2.688.705.705 0 01-.6.621zm.2-2.73a8.542 8.542 0 00-.437 1.912.572.572 0 00.226.113v-.092a7.259 7.259 0 00.19-1.947z"
              transform="translate(-101.334 -304.925)"
              fill="#263238"
            />
            <path
              data-name="Path 5550"
              d="M71.847 355.034s-2.391-.451-2.6-.092-.332 1.46.437 1.552 2.391-.056 2.73-.529-.567-.931-.567-.931z"
              transform="translate(-66.64 -303.276)"
              fill="#fff"
            />
            <path
              data-name="Path 5551"
              d="M69.967 356.732a3.8 3.8 0 01-.529 0 .952.952 0 01-.776-.536 1.813 1.813 0 01.071-1.538c.1-.162.339-.578 2.977-.078h.09c.113.064.705.367.818.846a.755.755 0 01-.12.607c-.386.536-1.677.699-2.531.699zm-.649-1.686a1.093 1.093 0 000 .8.254.254 0 00.226.155 4.213 4.213 0 002.4-.381c0-.092-.176-.268-.4-.388a7.76 7.76 0 00-2.226-.186z"
              transform="translate(-66.475 -303.14)"
              fill="#263238"
            />
            <path
              data-name="Path 5552"
              d="M71.476 357.582s-2.384-.459-2.6-.092-.324 1.46.444 1.545 2.384-.049 2.73-.529-.574-.924-.574-.924z"
              transform="translate(-66.531 -304.026)"
              fill="#fff"
            />
            <path
              data-name="Path 5553"
              d="M69.656 359.282a5.2 5.2 0 01-.529 0 .973.973 0 01-.776-.543 1.792 1.792 0 01.071-1.538c.092-.155.339-.571 2.977-.07h.092a1.587 1.587 0 01.811.846.705.705 0 01-.12.6c-.382.542-1.672.705-2.526.705zM69 357.589a1.185 1.185 0 000 .811.268.268 0 00.226.155 4.215 4.215 0 002.405-.388c0-.085-.183-.268-.4-.381a8.169 8.169 0 00-2.231-.197z"
              transform="translate(-66.383 -303.891)"
              fill="#263238"
            />
            <path
              data-name="Path 5554"
              d="M72.4 360.524s-2.384-.451-2.6-.092-.324 1.46.444 1.552 2.384-.056 2.73-.529-.574-.931-.574-.931z"
              transform="translate(-66.802 -304.893)"
              fill="#fff"
            />
            <path
              data-name="Path 5555"
              d="M70.578 362.219h-.529a.973.973 0 01-.776-.543 1.82 1.82 0 01.071-1.538c.092-.155.346-.578 2.977-.078h.092c.113.063.705.374.811.846a.705.705 0 01-.12.607c-.382.551-1.673.706-2.526.706zm-.656-1.686a1.164 1.164 0 000 .8.268.268 0 00.233.155 4.153 4.153 0 002.4-.381c0-.092-.2-.282-.4-.388a7.76 7.76 0 00-2.236-.19z"
              transform="translate(-66.655 -304.755)"
              fill="#263238"
            />
            <path
              data-name="Path 5556"
              d="M72.675 363.085s-2-.3-2.187 0-.31 1.122.332 1.171a3.909 3.909 0 002.314-.466c.295-.373-.459-.705-.459-.705z"
              transform="translate(-67.01 -305.677)"
              fill="#fff"
            />
            <path
              data-name="Path 5557"
              d="M70.934 364.464h-.289a.818.818 0 01-.705-.466 1.411 1.411 0 01.113-1.256c.092-.141.31-.466 2.532-.141h.092c.141.056.621.289.705.705a.635.635 0 01-.127.55c-.381.481-1.644.608-2.321.608zm-.334-1.284a.705.705 0 000 .494s0 .071.134.078a4.557 4.557 0 001.975-.3 1 1 0 00-.247-.169 7.846 7.846 0 00-1.862-.1zm-.047 0z"
              transform="translate(-66.863 -305.532)"
              fill="#263238"
            />
            <path
              data-name="Path 5558"
              d="M240.446 359.812s.79 2.264.571 2.575-1 .705-1.213 0a5.782 5.782 0 01-.141-2.871c.282-.473.783.296.783.296z"
              transform="translate(-116.851 -304.619)"
              fill="#fff"
            />
            <path
              data-name="Path 5559"
              d="M240.132 363.006h-.148a.854.854 0 01-.705-.705c-.19-.663-.487-2.511-.106-3.146a.607.607 0 01.508-.324c.423 0 .762.487.861.635l.035.071c.854 2.441.614 2.772.522 2.9a1.362 1.362 0 01-.966.571zm-.36-3.393a6.687 6.687 0 00.212 2.518.175.175 0 00.12.169.705.705 0 00.466-.254 11.915 11.915 0 00-.607-2.215 1.177 1.177 0 00-.191-.218z"
              transform="translate(-116.692 -304.462)"
              fill="#263238"
            />
            <path
              data-name="Path 5560"
              d="M238.616 360.816s.79 2.264.571 2.582-1 .705-1.213 0a5.785 5.785 0 01-.141-2.871c.282-.466.783.289.783.289z"
              transform="translate(-116.312 -304.917)"
              fill="#fff"
            />
            <path
              data-name="Path 5561"
              d="M238.342 364.014a.528.528 0 01-.148 0 .847.847 0 01-.705-.663c-.19-.67-.487-2.518-.106-3.153a.586.586 0 01.515-.318c.409 0 .769.48.868.628a.334.334 0 010 .07c.854 2.441.614 2.779.529 2.906a1.411 1.411 0 01-.953.53zm-.36-3.393a6.667 6.667 0 00.212 2.518.162.162 0 00.12.169.621.621 0 00.466-.247 12.145 12.145 0 00-.6-2.215 1.257 1.257 0 00-.198-.225z"
              transform="translate(-116.165 -304.771)"
              fill="#263238"
            />
            <path
              data-name="Path 5562"
              d="M236.336 360.706s.8 2.264.571 2.575-1 .705-1.213 0a5.757 5.757 0 01-.141-2.864c.282-.466.783.289.783.289z"
              transform="translate(-115.64 -304.885)"
              fill="#fff"
            />
            <path
              data-name="Path 5563"
              d="M236.022 363.884h-.148a.853.853 0 01-.705-.67c-.19-.663-.487-2.511-.106-3.146a.585.585 0 01.515-.317c.423 0 .762.48.861.628a.219.219 0 01.035.071c.854 2.441.614 2.779.529 2.9a1.411 1.411 0 01-.981.534zm-.353-3.393a6.659 6.659 0 00.2 2.518c.035.1.071.155.12.169a.706.706 0 00.466-.254 12.283 12.283 0 00-.6-2.215 2.018 2.018 0 00-.186-.218z"
              transform="translate(-115.481 -304.733)"
              fill="#263238"
            />
            <path
              data-name="Path 5564"
              d="M234.587 361.3a7.632 7.632 0 01.437 2.187c-.169.261-.762.614-.917 0a5.5 5.5 0 01-.113-2.434c.212-.417.593.247.593.247z"
              transform="translate(-115.196 -305.076)"
              fill="#fff"
            />
            <path
              data-name="Path 5565"
              d="M234.314 364.029h-.106a.705.705 0 01-.6-.621 5.8 5.8 0 01-.078-2.688.522.522 0 01.473-.31c.36 0 .635.4.705.571v.071c.656 2.081.473 2.363.4 2.483a1.086 1.086 0 01-.79.494zm-.212-2.744a7.237 7.237 0 00.19 1.947.268.268 0 00.042.106.564.564 0 00.24-.19 13.116 13.116 0 00-.466-1.848z"
              transform="translate(-115.043 -304.928)"
              fill="#263238"
            />
            <path
              data-name="Path 5566"
              d="M155.05 366.071a.353.353 0 01-.346-.275l-.8-3.647a.36.36 0 11.705-.148l.8 3.64a.353.353 0 01-.268.423z"
              transform="translate(-91.626 -305.312)"
              fill="#263238"
            />
            <path
              data-name="Path 5567"
              d="M163.142 362.829l4.543-.649 2.116-1.827s.769-2.42.889-2.716a.557.557 0 00-.705-.705c-.586.176-.762 1.058-.762 1.058s-.473-1.651-.945-1.291a1.326 1.326 0 00-.529.825s-.769-.945-1.122-.649a2.356 2.356 0 00-.473 1.178s-.889-.705-1.178-.3 0 1.122 0 1.122l.353 1.411-.593.113-2.476.12"
              transform="translate(-94.089 -303.819)"
              fill="#fff"
            />
            <path
              data-name="Path 5568"
              d="M162.977 363.031a.354.354 0 01-.049-.705l4.444-.635 1.968-1.7c.155-.487.755-2.363.861-2.638a.247.247 0 00-.056-.212s-.071-.078-.219 0c-.31.092-.487.614-.522.79a.353.353 0 01-.705 0 3.456 3.456 0 00-.473-1.051.988.988 0 00-.317.529.353.353 0 01-.621.176 1.94 1.94 0 00-.705-.578 2.821 2.821 0 00-.289.938.339.339 0 01-.219.275.346.346 0 01-.346-.049 1.482 1.482 0 00-.705-.346c-.106.169 0 .586.071.762l.367 1.467a.324.324 0 01-.042.268.346.346 0 01-.233.162l-.585.113-2.532.127a.346.346 0 01-.367-.339.36.36 0 01.332-.367l2.659-.155-.268-1.058a1.608 1.608 0 01.056-1.411.635.635 0 01.451-.268 1.411 1.411 0 01.776.19 1.82 1.82 0 01.487-.875.607.607 0 01.451-.134 1.56 1.56 0 01.776.416 1.911 1.911 0 01.437-.473.572.572 0 01.529-.085 1.411 1.411 0 01.656.741 1.214 1.214 0 01.635-.473.889.889 0 01.945.233.938.938 0 01.19.945c-.092.233-.663 2.017-.875 2.688a.36.36 0 01-.106.162l-2.116 1.827a.4.4 0 01-.183.085l-4.543.649z"
              transform="translate(-93.924 -303.669)"
              fill="#263238"
            />
            <path
              data-name="Path 5569"
              d="M169.853 362.759a.367.367 0 01-.247-.1.353.353 0 010-.5 10.478 10.478 0 00.522-2.321c-.056-.162-.508-1.813-.557-2a.36.36 0 01.254-.437.353.353 0 01.43.254c.2.705.5 1.862.55 2a7.555 7.555 0 01-.705 3 .381.381 0 01-.247.104z"
              transform="translate(-96.222 -304.039)"
              fill="#263238"
            />
            <path
              data-name="Path 5570"
              d="M172.258 361.254a.33.33 0 01-.12 0 .353.353 0 01-.2-.459 5.171 5.171 0 00-.289-2.243.353.353 0 01.67-.219 5.669 5.669 0 01.275 2.716.346.346 0 01-.336.205z"
              transform="translate(-96.849 -304.248)"
              fill="#263238"
            />
            <path
              data-name="Path 5571"
              d="M168.105 362.9a.353.353 0 01-.31-.515 8.712 8.712 0 00.268-2.25l-.748-1.488a.36.36 0 01.155-.473.353.353 0 01.473.155l.79 1.566a.423.423 0 010 .169 9.256 9.256 0 01-.346 2.652.353.353 0 01-.282.184z"
              transform="translate(-95.568 -304.258)"
              fill="#263238"
            />
            <path
              data-name="Path 5572"
              d="M166.512 362.78a.36.36 0 01-.353-.332v-.762a.353.353 0 11.705-.035v.762a.346.346 0 01-.332.367z"
              transform="translate(-95.237 -305.195)"
              fill="#263238"
            />
            <path
              data-name="Path 5573"
              d="M162.206 363.942a.346.346 0 01-.289-.148 1.411 1.411 0 01.155-1.9.353.353 0 01.5 0 .36.36 0 010 .5.705.705 0 00-.049.973.353.353 0 01-.085.487.367.367 0 01-.232.088z"
              transform="translate(-93.901 -305.335)"
              fill="#263238"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
export function ChatStartIllustration(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 119.891,
    height: 125.574,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 119.891 125.574"
      {...rest}
      sx={rootSx}
    >
      <g id="Schedule-bro" transform="translate(-48.131 -54.767)">
        <g
          id="freepik--background-simple--inject-38"
          transform="translate(168.023 60.722) rotate(93)"
        >
          <path
            id="Path_20580"
            data-name="Path 20580"
            d="M37.539,7S17.165,17.387,7.007,33.385A44.148,44.148,0,0,0,9.994,85.23c12.351,15.282,35.952,13.26,55.715,22.943s41.579,7.685,50.914-12.816S111.877,67.2,109.44,43.471,85.646-15,37.539,7Z"
            fill="#c5e7e1"
          />
          <path
            id="Path_20581"
            data-name="Path 20581"
            d="M37.539,7S17.165,17.387,7.007,33.385A44.148,44.148,0,0,0,9.994,85.23c12.351,15.282,35.952,13.26,55.715,22.943s41.579,7.685,50.914-12.816S111.877,67.2,109.44,43.471,85.646-15,37.539,7Z"
            fill="#fff"
            opacity="0.7"
          />
        </g>
        <path
          id="Path_943"
          data-name="Path 943"
          d="M44.436,25A19.436,19.436,0,1,0,63.871,44.436,19.436,19.436,0,0,0,44.436,25Z"
          transform="translate(90.554 84.646)"
          fill="#9bbcb6"
        />
        <g
          id="Group_121373"
          data-name="Group 121373"
          transform="matrix(0.966, -0.259, 0.259, 0.966, 31.506, 102.961)"
        >
          <path
            id="icons8-chat-message"
            d="M30.231,4A26.262,26.262,0,0,0,4,30.229,25.989,25.989,0,0,0,6.966,42.121L4.123,52.3a3.347,3.347,0,0,0,4.042,4.042L18.353,53.5a25.984,25.984,0,0,0,11.878,2.961A26.231,26.231,0,0,0,30.231,4Zm0,3.935A22.3,22.3,0,1,1,19.4,49.713a1.968,1.968,0,0,0-1.486-.177l-9.688,2.7,2.705-9.683a1.968,1.968,0,0,0-.177-1.488A22.284,22.284,0,0,1,30.231,7.933ZM19.083,23.672a1.967,1.967,0,1,0,0,3.935h22.3a1.967,1.967,0,1,0,0-3.935Zm0,9.181a1.967,1.967,0,1,0,0,3.935h17.05a1.967,1.967,0,1,0,0-3.935Z"
            transform="translate(42 -3.954)"
            fill="#9bbcb6"
          />
        </g>
        <path
          id="Path_944"
          data-name="Path 944"
          d="M36.841,16A20.841,20.841,0,1,0,57.682,36.841,20.841,20.841,0,0,0,36.841,16Z"
          transform="translate(98.149 92.241)"
          fill="none"
          stroke="#edf8f6"
          stroke-width="4"
        />
        <path
          id="Path_945"
          data-name="Path 945"
          d="M42,55.986l5.883,5.21L61.1,46"
          transform="translate(83.438 75.266)"
          fill="none"
          stroke="#fff"
          stroke-linecap="round"
          stroke-width="4"
        />
      </g>
    </SvgIcon>
  );
}
export function ChatIllustration(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 119.891,
    height: 125.574,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 119.891 125.574"
      {...rest}
      sx={rootSx}
    >
      <g id="Schedule-bro" transform="translate(-48.131 -54.767)">
        <g
          id="freepik--background-simple--inject-38"
          transform="translate(168.023 60.722) rotate(93)"
        >
          <path
            id="Path_20580"
            data-name="Path 20580"
            d="M37.539,7S17.165,17.387,7.007,33.385A44.148,44.148,0,0,0,9.994,85.23c12.351,15.282,35.952,13.26,55.715,22.943s41.579,7.685,50.914-12.816S111.877,67.2,109.44,43.471,85.646-15,37.539,7Z"
            fill="#c5e7e1"
          />
          <path
            id="Path_20581"
            data-name="Path 20581"
            d="M37.539,7S17.165,17.387,7.007,33.385A44.148,44.148,0,0,0,9.994,85.23c12.351,15.282,35.952,13.26,55.715,22.943s41.579,7.685,50.914-12.816S111.877,67.2,109.44,43.471,85.646-15,37.539,7Z"
            fill="#fff"
            opacity="0.7"
          />
        </g>
        <path
          id="icons8-card-payment"
          d="M28.284,8a10.011,10.011,0,0,0-9.97,9.97v9.7l-3.229.995v0a13.6,13.6,0,0,0-7.58,5.87l-4.5,7.307a2.719,2.719,0,1,0,4.631,2.85l4.5-7.308a8.156,8.156,0,0,1,4.549-3.519l1.629-.5V44.979a8.307,8.307,0,0,0,.446,2.687,2.719,2.719,0,0,0,4,1.434l15.847-9.775.032-.021a2.885,2.885,0,0,1,3.533,4.528L37.2,48.382a2.72,2.72,0,0,0-.527.478l-.014.018L23.3,61.1a11.78,11.78,0,0,1-7.941,3.087l-10.642.011a2.719,2.719,0,1,0,.007,5.438l8.72-.007a2.717,2.717,0,0,0,.34.018l17.893-.011a17.232,17.232,0,0,0,11.609-4.514l12.9-11.8h15.6a10.011,10.011,0,0,0,9.97-9.97V17.97A10.011,10.011,0,0,0,71.788,8Zm0,5.438h43.5A4.492,4.492,0,0,1,76.32,17.97v2.719H23.752V17.97A4.492,4.492,0,0,1,28.284,13.438ZM23.752,26.127H76.32v17.22a4.492,4.492,0,0,1-4.532,4.532H55.513a2.416,2.416,0,0,0-.694,0H45.805l.074-.067.036-.032A8.323,8.323,0,0,0,35.722,34.716L23.752,42.1V30.124a2.719,2.719,0,0,0,0-.892Zm16.109,27.19h8.267l-8.515,7.789a11.775,11.775,0,0,1-7.941,3.087l-3.707,0Z"
          transform="matrix(0.966, -0.259, 0.259, 0.966, 56.11, 90.895)"
          fill="#9bbcb6"
        />
        <path
          id="Path_943"
          data-name="Path 943"
          d="M44.436,25A19.436,19.436,0,1,0,63.871,44.436,19.436,19.436,0,0,0,44.436,25Z"
          transform="translate(90.554 84.646)"
          fill="#9bbcb6"
        />
        <path
          id="Path_944"
          data-name="Path 944"
          d="M36.841,16A20.841,20.841,0,1,0,57.682,36.841,20.841,20.841,0,0,0,36.841,16Z"
          transform="translate(98.149 92.241)"
          fill="none"
          stroke="#edf8f6"
          stroke-width="4"
        />
        <path
          id="Path_945"
          data-name="Path 945"
          d="M42,55.986l5.883,5.21L61.1,46"
          transform="translate(83.438 75.266)"
          fill="none"
          stroke="#fff"
          stroke-linecap="round"
          stroke-width="4"
        />
      </g>
    </SvgIcon>
  );
}

export function DoctorEmptyStateIllustration(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 128.252,
    height: 118.438,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128.252 118.438"
      {...rest}
      sx={rootSx}
    >
      <g id="Notebook-bro" transform="translate(-77.798 -112.187)">
        <g
          id="freepik--background-simple--inject-1--inject-7"
          transform="translate(77.798 112.187)"
        >
          <path
            id="Path_20625"
            data-name="Path 20625"
            d="M199.688,152.67c.327-1.875.852-3.73,1.228-5.64a33.34,33.34,0,0,0,.157-11.169,43.873,43.873,0,0,0-8.233-19.6c-4.586-6.152-11.482-11.134-18.894-9.252-7.711,1.949-14.238,7.9-21.737,10.609-12.7,4.593-25.557-3.779-38.355-3.48-11.051.24-22.645,4.207-29.924,14.016-2.972,4-5.042,9.395-4.339,14.7.859,6.462,5.6,11.378,9.137,16.159,5.421,7.328,7.474,15.31,2.912,23.863-3.083,5.8-7.23,10.919-6.872,18.118.574,11.517,11.208,18.473,19.976,21.573,8.908,3.152,19.023,3.48,27.878-.07,7.867-3.166,13.358-10.091,20.529-14.51a32.45,32.45,0,0,1,21.055-4.621c7.578.9,15.564,2.5,22.888-.769,7.008-3.132,10.327-11.5,10.588-19.52a32.063,32.063,0,0,0-1.778-11.775c-1.625-4.544-5.219-8.09-6.232-12.909a14.962,14.962,0,0,1,.014-5.717Z"
            transform="translate(-79.454 -106.601)"
            fill="#c5e8e2"
          />
          <path
            id="Path_20626"
            data-name="Path 20626"
            d="M199.688,152.67c.327-1.875.852-3.73,1.228-5.64a33.34,33.34,0,0,0,.157-11.169,43.873,43.873,0,0,0-8.233-19.6c-4.586-6.152-11.482-11.134-18.894-9.252-7.711,1.949-14.238,7.9-21.737,10.609-12.7,4.593-25.557-3.779-38.355-3.48-11.051.24-22.645,4.207-29.924,14.016-2.972,4-5.042,9.395-4.339,14.7.859,6.462,5.6,11.378,9.137,16.159,5.421,7.328,7.474,15.31,2.912,23.863-3.083,5.8-7.23,10.919-6.872,18.118.574,11.517,11.208,18.473,19.976,21.573,8.908,3.152,19.023,3.48,27.878-.07,7.867-3.166,13.358-10.091,20.529-14.51a32.45,32.45,0,0,1,21.055-4.621c7.578.9,15.564,2.5,22.888-.769,7.008-3.132,10.327-11.5,10.588-19.52a32.063,32.063,0,0,0-1.778-11.775c-1.625-4.544-5.219-8.09-6.232-12.909a14.962,14.962,0,0,1,.014-5.717Z"
            transform="translate(-79.454 -106.601)"
            fill="#fff"
            opacity="0.7"
          />
        </g>
        <path
          id="icons8-medical-doctor_1_"
          data-name="icons8-medical-doctor (1)"
          d="M32.224,0C27.1,0,24.175.719,22.409,1.56a6.111,6.111,0,0,0-1.848,1.273,4.1,4.1,0,0,0-.616.9,1.462,1.462,0,0,0-.082.329l-2.094,18.11a1.34,1.34,0,0,0,.041.534c-.005.231-.041.452-.041.7a14.455,14.455,0,1,0,28.91,0c0-.231-.036-.436-.041-.657a1.285,1.285,0,0,0,.041-.575L44.584,4.065a1.476,1.476,0,0,0-.082-.329,4.107,4.107,0,0,0-.616-.9A6.111,6.111,0,0,0,42.038,1.56C40.272.719,37.346,0,32.224,0Zm0,2.628c4.866,0,7.448.714,8.706,1.314A3.775,3.775,0,0,1,42,4.64l1.437,12.443a5.132,5.132,0,0,0-.78-.205c-2.52-.421-5.667.205-10.43.205-2.382,0-4.378-.144-6.078-.246a19.853,19.853,0,0,0-4.353.041,5.126,5.126,0,0,0-.78.205L22.45,4.64a3.775,3.775,0,0,1,1.068-.7C24.775,3.342,27.357,2.628,32.224,2.628ZM30.91,5.256V9.2H26.967v2.628H30.91v3.942h2.628V11.827H37.48V9.2H33.538V5.256ZM22.9,19.383c1.812-.082,4.979.329,9.322.329,4.964,0,8.4-.518,10.02-.246.811.134,1.047.318,1.314.78a7.022,7.022,0,0,1,.493,3.162,11.827,11.827,0,1,1-23.653,0,7.022,7.022,0,0,1,.493-3.162c.267-.462.5-.647,1.314-.78A5.127,5.127,0,0,1,22.9,19.383Zm9.322,19.793A44.852,44.852,0,0,0,11.2,44.145C5.737,47.106,2,51.013,2,55.314V65.7H31.936a1.337,1.337,0,0,0,.534,0H62.447V55.314c0-4.3-3.737-8.208-9.2-11.17a40.793,40.793,0,0,0-10.841-3.9,1.286,1.286,0,0,0-.739-.164A48.581,48.581,0,0,0,32.224,39.176Zm0,2.628a46.443,46.443,0,0,1,7.679.616L32.224,60.94,24.545,42.42A46.44,46.44,0,0,1,32.224,41.8ZM21.957,42.995l8.3,20.081H4.628V55.314c0-2.664,2.782-6.149,7.8-8.87A37.938,37.938,0,0,1,21.957,42.995Zm20.532,0a37.937,37.937,0,0,1,9.527,3.449c5.02,2.721,7.8,6.206,7.8,8.87v7.761H34.195Z"
          transform="translate(109.074 134.332)"
          fill="#8fb7b0"
          stroke="#8fb7b0"
          stroke-width="1"
        />
      </g>
    </SvgIcon>
  );
}

export function ComingSoonIllustration(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 203.038,
    height: 225.264,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 203.038 225.264"
      {...rest}
      sx={rootSx}
    >
      <g
        data-name="2577208_373909-PBLFMK-641"
        transform="translate(-82.852 -68.17)"
      >
        <g transform="translate(89.548 284.921)">
          <ellipse
            cx="94.823"
            cy="4.256"
            data-name="Ellipse 130087"
            opacity="0.05"
            rx="94.823"
            ry="4.256"
          ></ellipse>
        </g>
        <g transform="translate(85.867 69.67)">
          <g data-name="Group 123415">
            <path
              fill="none"
              stroke="#454258"
              strokeWidth="5"
              d="M8.455 79.398L80.62 8.115l94.206 52.155"
              data-name="Path 109763"
            ></path>
            <path
              fill="#eb6d13"
              stroke="#dbe2e8"
              strokeWidth="6"
              d="M180.391 176.371L31.046 193.597a18.764 18.764 0 01-20.79-16.491L.125 89.256a18.764 18.764 0 0116.491-20.79l149.345-17.222a18.764 18.764 0 0120.79 16.49l10.131 87.85a18.764 18.764 0 01-16.491 20.787z"
              data-name="Path 109764"
            ></path>
            <g
              fill="#fff"
              fontFamily="Poppins-Bold, Poppins"
              fontSize="30"
              fontWeight="700"
              transform="translate(33.625 77.886)"
            >
              <text transform="rotate(-6.581 376.308 15.815)">
                <tspan x="0" y="0">
                  Coming
                </tspan>
              </text>
              <text transform="rotate(-6.581 710.383 -226.182)">
                <tspan x="0" y="0">
                  Soon
                </tspan>
              </text>
            </g>
            <circle
              cx="9.362"
              cy="9.362"
              r="9.362"
              fill="#eb6d13"
              stroke="#dbe2e8"
              strokeWidth="3"
              data-name="Ellipse 130088"
              transform="translate(70.634)"
            ></circle>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function LoadingMessage(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 54,
    height: 25,
    ...rootStyle,
  };
  return (
    <SvgIcon
      version="1.1"
      id="L4"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 25"
      sx={rootSx}
      {...rest}
    >
      <circle fill="#0cae95" stroke="none" cx="6" cy="12" r="6">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.1"
        />
      </circle>
      <circle fill="#0cae95" stroke="none" cx="26" cy="12" r="6">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.2"
        />
      </circle>
      <circle fill="#0cae95" stroke="none" cx="46" cy="12" r="6">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.3"
        />
      </circle>
    </SvgIcon>
  );
}

export function BotIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 11.829,
    width: 17.67,

    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="17.67"
      height="8.846"
      viewBox="0 0 17.67 11.829"
      {...rest}
      sx={rootSx}
    >
      <g
        id="Group_113946"
        data-name="Group 113946"
        transform="translate(7.507 -5.821) rotate(42)"
      >
        <g
          id="Group_107399"
          data-name="Group 107399"
          transform="matrix(0.719, -0.695, 0.695, 0.719, 2.959, 14.505)"
        >
          <path
            id="Path_8555"
            data-name="Path 8555"
            d="M4.285,4.465c-.139.61-.852.511-1.809.074C1.331,4.016-.292,2.18.045.715h0A1.692,1.692,0,0,1,.188.325C.968-1.184,4.093,3.016,4.245,3.7A1.8,1.8,0,0,1,4.285,4.465Z"
            transform="translate(0 0)"
            fill="#e6eefa"
          />
          <path
            id="Path_8556"
            data-name="Path 8556"
            d="M4.285,3.75c-.139.61-.852.511-1.809.074C1.331,3.3-.292,1.465.045,0A5.763,5.763,0,0,0,4.285,3.75Z"
            transform="translate(0 0.715)"
            fill="#cbdbef"
          />
          <path
            id="Path_8557"
            data-name="Path 8557"
            d="M1.014.728c.269.294.672.824.579.926S.881,1.416.46.914C.175.573-.073.093.02.013.128-.08.661.344,1.014.728Z"
            transform="translate(0.691 0.191)"
            fill="#fff"
          />
        </g>
        <g
          id="Group_107406"
          data-name="Group 107406"
          transform="translate(0 7.833) rotate(-42)"
        >
          <path
            id="Path_8564"
            data-name="Path 8564"
            d="M.54,3.069A1.841,1.841,0,0,1,.153,2.5,1.793,1.793,0,0,1,.177,1,1.8,1.8,0,0,1,1.376.05,1.849,1.849,0,0,1,1.831,0,3.109,3.109,0,0,1,.54,3.069Z"
            transform="translate(1.151 3.552)"
            fill="#e6eefa"
          />
          <path
            id="Path_8565"
            data-name="Path 8565"
            d="M.387,3.066A1.841,1.841,0,0,1,0,2.5c.207-.359.415-.743.619-1.149q.339-.674.6-1.3A1.849,1.849,0,0,1,1.679,0C1.245,1.019.814,2.044.387,3.066Z"
            transform="translate(1.304 3.555)"
            fill="#cbdbef"
          />
          <path
            id="Path_8566"
            data-name="Path 8566"
            d="M10.087,7.076C9.9,9.6,4.113,10.437,1.4,8.91A2.429,2.429,0,0,1,.047,7.076C-.371,3.382,2.075,0,4.884,0A4.981,4.981,0,0,1,8.089,1.254C9.359,2.36,10.291,4.243,10.087,7.076Z"
            transform="translate(1.591 1.583)"
            fill="#e6eefa"
          />
          <path
            id="Path_8567"
            data-name="Path 8567"
            d="M1.339,3.945a2.62,2.62,0,0,1-.892-.9A3.632,3.632,0,0,1,.215,0l.26.077a3.386,3.386,0,0,0,.2,2.812,2.434,2.434,0,0,0,.8.818Z"
            transform="translate(0.188 0.91)"
            fill="#e6eefa"
          />
          <circle
            id="Ellipse_129534"
            data-name="Ellipse 129534"
            cx="0.635"
            cy="0.635"
            r="0.635"
            transform="translate(0 0)"
            fill="#294f81"
          />
          <path
            id="Path_8568"
            data-name="Path 8568"
            d="M7.225,1.988c0,.508-.557.818-1.273,1a9.755,9.755,0,0,1-2.338.245C2.682,3.227.889,3.066.242,2.478A.657.657,0,0,1,0,1.988,1.961,1.961,0,0,1,.6.582,2.07,2.07,0,0,1,2.044,0H5.181A2.055,2.055,0,0,1,6.795.768,1.933,1.933,0,0,1,7.225,1.988Z"
            transform="translate(2.948 4.438)"
            fill="#7699c4"
          />
          <path
            id="Path_8569"
            data-name="Path 8569"
            d="M6.984,1.22c0,.508-.557.818-1.273,1a9.755,9.755,0,0,1-2.338.245C2.44,2.459.647,2.3,0,1.709,1.843,1.654,4.977,1.35,6.556,0A1.949,1.949,0,0,1,6.984,1.22Z"
            transform="translate(3.19 5.206)"
            fill="#547aa9"
          />
          <path
            id="Path_8570"
            data-name="Path 8570"
            d="M2.066,1.673A2.168,2.168,0,0,1,.673,1.19C.069.7-.12.016.072,0A15.605,15.605,0,0,0,1.9.335,18.494,18.494,0,0,0,3.94.081c.022,0,.043,0,.062,0C4.485.081,3.894,1.673,2.066,1.673Z"
            transform="translate(4.583 8.283)"
            fill="#294f81"
          />
          <path
            id="Path_8571"
            data-name="Path 8571"
            d="M8.684,5.822C8.5,8.349,2.71,9.182,0,7.656c1.657.276,6.584.88,7.47-1.5C8.232,4.119,7.29,1.394,6.686,0,7.956,1.106,8.888,2.989,8.684,5.822Z"
            transform="translate(2.995 2.837)"
            fill="#cbdbef"
          />
          <path
            id="Path_8572"
            data-name="Path 8572"
            d="M.022,2.05c.149.2,1.072-.217,1.688-.672C2.3.941,2.909.253,2.772.058c-.118-.173-.8.074-1.226.3C.592.87-.139,1.833.022,2.05Z"
            transform="translate(3.214 2.02)"
            fill="#fff"
          />
          <path
            id="Path_8573"
            data-name="Path 8573"
            d="M0,.923C.022,1.6.434,2.239.6,2.2S.707,1.344.623.9C.6.774.459,0,.276,0,.137,0-.012.486,0,.923Z"
            transform="translate(1.895 7.076)"
            fill="#fff"
          />
          <g
            id="Group_107403"
            data-name="Group 107403"
            transform="translate(7.55 4.93)"
          >
            <g
              id="Group_107402"
              data-name="Group 107402"
              transform="translate(0 0)"
            >
              <path
                id="Path_8574"
                data-name="Path 8574"
                d="M1.827.914a.914.914,0,0,1-1.768.325A.946.946,0,0,1,0,.914a.914.914,0,0,1,1.827,0Z"
                transform="translate(0.155 0.155)"
                fill="#393760"
              />
              <path
                id="Path_8575"
                data-name="Path 8575"
                d="M1.068.155A.915.915,0,0,1,1.9.694a.894.894,0,0,1,.081.375.914.914,0,0,1-1.768.325.946.946,0,0,1-.059-.325A.915.915,0,0,1,1.068.155Zm0-.155A1.068,1.068,0,1,0,2.14,1.068,1.053,1.053,0,0,0,2.047.632,1.075,1.075,0,0,0,1.068,0Z"
                transform="translate(0 0)"
                fill="#6998d2"
              />
            </g>
            <path
              id="Path_8576"
              data-name="Path 8576"
              d="M1.747.539a1.385,1.385,0,0,1-1.685.7A.88.88,0,0,1,0,.917.914.914,0,0,1,1.747.539Z"
              transform="translate(0.155 0.155)"
              fill="#2f4572"
            />
            <circle
              id="Ellipse_129535"
              data-name="Ellipse 129535"
              cx="0.303"
              cy="0.303"
              r="0.303"
              transform="translate(0.424 0.461)"
              fill="#b8e2ff"
            />
            <path
              id="Path_8577"
              data-name="Path 8577"
              d="M.719,0C.768.037.7.353.474.477.273.585.006.5,0,.446,0,.4.133.39.365.251S.681-.022.719,0Z"
              transform="translate(1.068 1.245)"
              fill="#b8e2ff"
            />
          </g>
          <g
            id="Group_107405"
            data-name="Group 107405"
            transform="translate(3.499 4.93)"
          >
            <g
              id="Group_107404"
              data-name="Group 107404"
              transform="translate(0 0)"
            >
              <path
                id="Path_8578"
                data-name="Path 8578"
                d="M1.827.914a.914.914,0,0,1-1.768.325A.946.946,0,0,1,0,.914a.914.914,0,0,1,1.827,0Z"
                transform="translate(0.155 0.155)"
                fill="#393760"
              />
              <path
                id="Path_8579"
                data-name="Path 8579"
                d="M1.068.155A.915.915,0,0,1,1.9.694a.894.894,0,0,1,.081.375.914.914,0,0,1-1.768.325.946.946,0,0,1-.059-.325A.915.915,0,0,1,1.068.155Zm0-.155A1.068,1.068,0,1,0,2.14,1.068,1.053,1.053,0,0,0,2.047.632,1.075,1.075,0,0,0,1.068,0Z"
                transform="translate(0 0)"
                fill="#6998d2"
              />
            </g>
            <path
              id="Path_8580"
              data-name="Path 8580"
              d="M1.747.539a1.385,1.385,0,0,1-1.685.7A.88.88,0,0,1,0,.917.913.913,0,0,1,.911,0,.923.923,0,0,1,1.747.539Z"
              transform="translate(0.155 0.155)"
              fill="#2f4572"
            />
            <circle
              id="Ellipse_129536"
              data-name="Ellipse 129536"
              cx="0.303"
              cy="0.303"
              r="0.303"
              transform="translate(0.421 0.461)"
              fill="#b8e2ff"
            />
            <path
              id="Path_8581"
              data-name="Path 8581"
              d="M.719,0C.768.037.7.353.474.477.273.585.006.5,0,.446,0,.4.133.39.365.251S.684-.022.719,0Z"
              transform="translate(1.065 1.245)"
              fill="#b8e2ff"
            />
          </g>
          <path
            id="Path_8582"
            data-name="Path 8582"
            d="M2.14.038c.009.062-.4.2-.827.242A2.01,2.01,0,0,1,0,.047,7.421,7.421,0,0,1,1.313,0C2.013,0,2.134.007,2.14.038Z"
            transform="translate(4.695 4.608)"
            fill="#8fb0d8"
          />
          <circle
            id="Ellipse_129537"
            data-name="Ellipse 129537"
            cx="0.341"
            cy="0.341"
            r="0.341"
            transform="translate(0.116 0.247) rotate(-18.089)"
            fill="#296abd"
          />
          <path
            id="Path_8583"
            data-name="Path 8583"
            d="M1.394,1.592A2.168,2.168,0,0,1,0,1.109,7.264,7.264,0,0,0,3.267,0c.022,0,.043,0,.062,0C3.812,0,3.221,1.592,1.394,1.592Z"
            transform="translate(5.255 8.365)"
            fill="#33487a"
          />
        </g>
        <path
          id="Path_8594"
          data-name="Path 8594"
          d="M.626.13,0,0H0Z"
          transform="translate(16.159 3.453)"
          fill="#bbe1f4"
        />
      </g>
    </SvgIcon>
  );
}

export function RxGroupEmptyStateImg(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 134.828,
    height: 146,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 146 134.828"
      {...rest}
      sx={rootSx}
    >
      <g
        id="Group_105630"
        data-name="Group 105630"
        transform="translate(-449 -268.735)"
      >
        <g
          id="freepik--background-simple--inject-1--inject-7"
          transform="translate(449 268.735)"
        >
          <path
            id="Path_20625"
            data-name="Path 20625"
            d="M216.327,159.045c.372-2.135.97-4.246,1.4-6.421a37.953,37.953,0,0,0,.178-12.715,49.944,49.944,0,0,0-9.372-22.317c-5.221-7-13.071-12.675-21.508-10.532-8.778,2.218-16.209,8.988-24.745,12.077-14.458,5.229-29.094-4.3-43.663-3.961-12.58.273-25.779,4.789-34.065,15.955-3.383,4.559-5.74,10.695-4.939,16.731.978,7.356,6.377,12.953,10.4,18.4,6.171,8.342,8.508,17.429,3.315,27.165-3.509,6.6-8.231,12.43-7.823,20.625.654,13.111,12.759,21.029,22.74,24.558,10.14,3.589,21.655,3.961,31.736-.079,8.956-3.6,15.206-11.487,23.37-16.518a36.941,36.941,0,0,1,23.968-5.26c8.627,1.03,17.718,2.844,26.056-.875,7.978-3.565,11.756-13.091,12.053-22.221a36.5,36.5,0,0,0-2.024-13.4c-1.85-5.173-5.942-9.209-7.094-14.7a17.033,17.033,0,0,1,.016-6.508Z"
            transform="translate(-79.454 -106.601)"
            fill="#c5e8e2"
          />
          <path
            id="Path_20626"
            data-name="Path 20626"
            d="M216.327,159.045c.372-2.135.97-4.246,1.4-6.421a37.953,37.953,0,0,0,.178-12.715,49.944,49.944,0,0,0-9.372-22.317c-5.221-7-13.071-12.675-21.508-10.532-8.778,2.218-16.209,8.988-24.745,12.077-14.458,5.229-29.094-4.3-43.663-3.961-12.58.273-25.779,4.789-34.065,15.955-3.383,4.559-5.74,10.695-4.939,16.731.978,7.356,6.377,12.953,10.4,18.4,6.171,8.342,8.508,17.429,3.315,27.165-3.509,6.6-8.231,12.43-7.823,20.625.654,13.111,12.759,21.029,22.74,24.558,10.14,3.589,21.655,3.961,31.736-.079,8.956-3.6,15.206-11.487,23.37-16.518a36.941,36.941,0,0,1,23.968-5.26c8.627,1.03,17.718,2.844,26.056-.875,7.978-3.565,11.756-13.091,12.053-22.221a36.5,36.5,0,0,0-2.024-13.4c-1.85-5.173-5.942-9.209-7.094-14.7a17.033,17.033,0,0,1,.016-6.508Z"
            transform="translate(-79.454 -106.601)"
            fill="#fff"
            opacity="0.7"
          />
        </g>
        <g
          id="_28480885_Tiny_pharmacists_with_prescription_drugs_for_patients_Converted_"
          data-name="28480885_Tiny pharmacists with prescription drugs for patients [Converted]"
          transform="translate(-121.604 -317.486)"
          opacity="0.6"
        >
          <g
            id="Group_105626"
            data-name="Group 105626"
            transform="translate(570.604 599.478)"
          >
            <g id="_7" data-name="7" transform="translate(0 0)">
              <path
                id="Path_101110"
                data-name="Path 101110"
                d="M617.661,599.79l-40.587,11.079a8.78,8.78,0,0,0-6.157,10.782l20.96,76.788a8.781,8.781,0,0,0,10.782,6.159l40.587-11.079a8.78,8.78,0,0,0,6.157-10.782l-20.96-76.788A8.781,8.781,0,0,0,617.661,599.79Z"
                transform="translate(-570.604 -599.478)"
                fill="#c6d1cf"
              />
              <path
                id="Path_101111"
                data-name="Path 101111"
                d="M874.377,1412.52s-3.1,6.162-3.1,6.163l6.51,3.276a3.481,3.481,0,0,0,4.885-4.135,3.441,3.441,0,0,0-1.724-2s-6.571-3.312-6.572-3.3Z"
                transform="translate(-840.164 -1328.381)"
                fill="#548c83"
              />
              <path
                id="Path_101112"
                data-name="Path 101112"
                d="M789.747,1379.687a3.451,3.451,0,0,0,1.543,4.609l6.568,3.305c.008,0,3.106-6.16,3.1-6.164C797.969,1380.365,792.131,1375.135,789.747,1379.687Z"
                transform="translate(-766.748 -1297.303)"
                fill="#fff"
              />
              <path
                id="Path_101113"
                data-name="Path 101113"
                d="M1166.837,1333.19s-3.1,6.162-3.1,6.163l6.51,3.276a3.481,3.481,0,0,0,4.885-4.135,3.44,3.44,0,0,0-1.724-2s-6.571-3.312-6.572-3.3Z"
                transform="translate(-1102.358 -1257.261)"
                fill="#1d3f70"
              />
              <path
                id="Path_101114"
                data-name="Path 101114"
                d="M1082.217,1300.357a3.451,3.451,0,0,0,1.543,4.609l6.568,3.305c.008,0,3.106-6.161,3.1-6.164C1090.439,1301.034,1084.6,1295.805,1082.217,1300.357Z"
                transform="translate(-1028.952 -1226.183)"
                fill="#fff"
              />
              <path
                id="Path_101115"
                data-name="Path 101115"
                d="M715.057,825.14s-3.1,6.162-3.1,6.163l6.51,3.276a3.482,3.482,0,0,0,4.885-4.135,3.441,3.441,0,0,0-1.724-2s-6.571-3.312-6.572-3.3Z"
                transform="translate(-697.331 -801.787)"
                fill="#548c83"
              />
              <path
                id="Path_101116"
                data-name="Path 101116"
                d="M630.437,792.307a3.451,3.451,0,0,0,1.543,4.609l6.568,3.305c.008,0,3.106-6.161,3.1-6.164C638.659,792.985,632.821,787.755,630.437,792.307Z"
                transform="translate(-623.925 -770.709)"
                fill="#fff"
              />
              <path
                id="Path_101117"
                data-name="Path 101117"
                d="M1007.517,745.81s-3.1,6.162-3.1,6.163l6.51,3.276a3.481,3.481,0,0,0,4.885-4.135,3.441,3.441,0,0,0-1.724-2s-6.571-3.312-6.573-3.3Z"
                transform="translate(-959.526 -730.667)"
                fill="#548c83"
              />
              <path
                id="Path_101118"
                data-name="Path 101118"
                d="M922.9,712.977a3.451,3.451,0,0,0,1.543,4.609l6.568,3.305c.008,0,3.106-6.161,3.1-6.164C931.12,713.655,925.281,708.425,922.9,712.977Z"
                transform="translate(-886.119 -699.589)"
                fill="#fff"
              />
              <path
                id="Path_101119"
                data-name="Path 101119"
                d="M768.157,1020.93s-3.1,6.162-3.1,6.163l6.51,3.276a3.481,3.481,0,0,0,4.885-4.135,3.441,3.441,0,0,0-1.724-2s-6.571-3.312-6.572-3.3Z"
                transform="translate(-744.936 -977.315)"
                fill="#548c83"
              />
              <path
                id="Path_101120"
                data-name="Path 101120"
                d="M683.537,988.1a3.45,3.45,0,0,0,1.543,4.609l6.568,3.305c.008,0,3.106-6.161,3.1-6.164C691.759,988.775,685.921,983.545,683.537,988.1Z"
                transform="translate(-671.53 -946.237)"
                fill="#fff"
              />
              <path
                id="Path_101121"
                data-name="Path 101121"
                d="M1060.627,941.6s-3.1,6.161-3.1,6.163l6.51,3.276a3.482,3.482,0,0,0,4.885-4.135,3.441,3.441,0,0,0-1.724-2s-6.571-3.312-6.573-3.3Z"
                transform="translate(-1007.14 -906.195)"
                fill="#1d3f70"
              />
              <path
                id="Path_101122"
                data-name="Path 101122"
                d="M976,908.777a3.45,3.45,0,0,0,1.543,4.609l6.568,3.305c.008,0,3.106-6.161,3.1-6.164C984.219,909.455,978.381,904.225,976,908.777Z"
                transform="translate(-933.724 -875.126)"
                fill="#fff"
              />
              <path
                id="Path_101123"
                data-name="Path 101123"
                d="M821.267,1216.72s-3.1,6.162-3.1,6.163l6.51,3.276a3.481,3.481,0,0,0,4.885-4.135,3.441,3.441,0,0,0-1.724-2s-6.571-3.312-6.572-3.3Z"
                transform="translate(-792.55 -1152.844)"
                fill="#548c83"
              />
              <path
                id="Path_101124"
                data-name="Path 101124"
                d="M736.647,1183.9a3.45,3.45,0,0,0,1.543,4.609l6.568,3.305c.008,0,3.106-6.161,3.1-6.164C744.869,1184.575,739.031,1179.345,736.647,1183.9Z"
                transform="translate(-719.143 -1121.775)"
                fill="#fff"
              />
              <path
                id="Path_101125"
                data-name="Path 101125"
                d="M1113.727,1137.4s-3.1,6.162-3.1,6.163l6.51,3.276a3.481,3.481,0,0,0,4.885-4.135,3.441,3.441,0,0,0-1.724-2s-6.571-3.312-6.572-3.3Z"
                transform="translate(-1054.745 -1081.732)"
                fill="#1d3f70"
              />
              <path
                id="Path_101126"
                data-name="Path 101126"
                d="M1029.107,1104.567a3.451,3.451,0,0,0,1.543,4.609l6.568,3.305c.008,0,3.106-6.161,3.1-6.164C1037.329,1105.245,1031.491,1100.015,1029.107,1104.567Z"
                transform="translate(-981.338 -1050.654)"
                fill="#fff"
              />
              <path
                id="Path_101127"
                data-name="Path 101127"
                d="M834.292,702.518a1.316,1.316,0,0,0-.926,1.616l22.1,81.481a1.317,1.317,0,1,0,2.543-.689l-22.1-81.481a1.317,1.317,0,0,0-1.616-.926Z"
                transform="translate(-806.132 -691.814)"
                fill="#b7c4c1"
              />
            </g>
            <g id="_6" data-name="6" transform="translate(48.678 7.855)">
              <path
                id="Path_101128"
                data-name="Path 101128"
                d="M1105.4,827.6v50.231a10.622,10.622,0,0,1-10.623,10.622H1051.6a10.622,10.622,0,0,1-10.622-10.622V827.6a15.678,15.678,0,0,1,4.288-10.854,14.262,14.262,0,0,1,10.352-4.5,2.046,2.046,0,0,0,2-2.093V804.21h31.148v5.948a2.045,2.045,0,0,0,2,2.093c8.085,0,14.641,6.871,14.641,15.349Z"
                transform="translate(-1040.98 -790.878)"
                fill="#629e94"
              />
              <path
                id="Path_101129"
                data-name="Path 101129"
                d="M1105.4,1030.24v50.231a10.622,10.622,0,0,1-10.623,10.622H1051.6a10.622,10.622,0,0,1-10.622-10.622c63.443,0,64.421-50.231,64.421-50.231Z"
                transform="translate(-1040.98 -993.517)"
                fill="#548c83"
              />
              <path
                id="Path_101130"
                data-name="Path 101130"
                d="M1175.476,675.38h28.487a4.518,4.518,0,0,1,4.516,4.516v8.547a4.518,4.518,0,0,1-4.516,4.516h-28.487a4.518,4.518,0,0,1-4.516-4.516V679.9A4.518,4.518,0,0,1,1175.476,675.38Z"
                transform="translate(-1157.509 -675.38)"
                fill="#5c8f86"
              />
              <rect
                id="Rectangle_55825"
                data-name="Rectangle 55825"
                width="47.785"
                height="48.847"
                rx="4"
                transform="translate(8.318 35.514)"
                fill="#fff"
              />
              <path
                id="Path_101131"
                data-name="Path 101131"
                d="M1177.921,1074.8a6.078,6.078,0,0,0-.567-.952,4.5,4.5,0,0,0-.659-.814,2.89,2.89,0,0,0-.621-.383,3.869,3.869,0,0,0,.965-.471,4.07,4.07,0,0,0,1.3-1.517,4.883,4.883,0,0,0,.47-2.209,4.8,4.8,0,0,0-.615-2.494,3.241,3.241,0,0,0-1.641-1.426,8.427,8.427,0,0,0-2.846-.376h-6.547a.177.177,0,0,0-.177.177v14.832a.177.177,0,0,0,.177.177h3.945a.177.177,0,0,0,.177-.177v-5.842h.17a1.306,1.306,0,0,1,.848.3,3.209,3.209,0,0,1,.664,1.083l2.1,4.533a.177.177,0,0,0,.162.1h4.438a.177.177,0,0,0,.149-.081.175.175,0,0,0,.013-.169l-1.9-4.3Zm-6.642-7.292h1.548a1.965,1.965,0,0,1,1.341.333,1.3,1.3,0,0,1,.337.976,1.348,1.348,0,0,1-.217.763.857.857,0,0,1-.534.391,4.76,4.76,0,0,1-1,.2h-1.479v-2.661Z"
                transform="translate(-1153.941 -1023.927)"
                fill="#eb8278"
              />
              <path
                id="Path_101132"
                data-name="Path 101132"
                d="M1310.259,1079.083l-4.28-7.563,3.909-7.1a.178.178,0,0,0-.156-.263h-4.283a.179.179,0,0,0-.16.1l-2.031,4.234-2.088-4.236a.178.178,0,0,0-.159-.1h-4.327a.177.177,0,0,0-.153.088.18.18,0,0,0,0,.177l3.937,7.015-4.335,7.642a.18.18,0,0,0,0,.177.177.177,0,0,0,.153.088h4.388a.177.177,0,0,0,.157-.1l2.353-4.468,2.353,4.468a.179.179,0,0,0,.157.1h4.414a.177.177,0,0,0,.154-.265Z"
                transform="translate(-1269.703 -1023.927)"
                fill="#eb8278"
              />
              <path
                id="Path_101133"
                data-name="Path 101133"
                d="M1195.9,1255.75H1156.73a.59.59,0,0,1,0-1.18H1195.9a.59.59,0,0,1,0,1.18Z"
                transform="translate(-1144.223 -1194.632)"
                fill="#cbe3df"
              />
              <path
                id="Path_101134"
                data-name="Path 101134"
                d="M1346.05,1303.35h-21.84a.59.59,0,1,1,0-1.18h21.84a.59.59,0,1,1,0,1.18Z"
                transform="translate(-1294.371 -1237.306)"
                fill="#cbe3df"
              />
              <path
                id="Path_101135"
                data-name="Path 101135"
                d="M1169.722,1303.35h-13a.59.59,0,1,1,0-1.18h13a.59.59,0,0,1,0,1.18Z"
                transform="translate(-1144.214 -1237.306)"
                fill="#cbe3df"
              />
              <path
                id="Path_101136"
                data-name="Path 101136"
                d="M1195.9,1350.95H1156.73a.59.59,0,0,1,0-1.18H1195.9a.59.59,0,0,1,0,1.18Z"
                transform="translate(-1144.223 -1279.98)"
                fill="#cbe3df"
              />
              <path
                id="Path_101137"
                data-name="Path 101137"
                d="M1439.09,1398.55h-11.1a.59.59,0,0,1,0-1.18h11.1a.59.59,0,1,1,0,1.18Z"
                transform="translate(-1387.411 -1322.654)"
                fill="#cbe3df"
              />
              <path
                id="Path_101138"
                data-name="Path 101138"
                d="M1180.573,1398.55H1156.73a.59.59,0,0,1,0-1.18h23.843a.59.59,0,0,1,0,1.18Z"
                transform="translate(-1144.223 -1322.654)"
                fill="#cbe3df"
              />
              <path
                id="Path_101139"
                data-name="Path 101139"
                d="M1296.58,1446.15h-27.55a.59.59,0,0,1,0-1.18h27.55a.59.59,0,0,1,0,1.18Z"
                transform="translate(-1244.901 -1365.328)"
                fill="#cbe3df"
              />
              <path
                id="Path_101140"
                data-name="Path 101140"
                d="M1164.259,1446.15h-7.529a.59.59,0,0,1,0-1.18h7.529a.59.59,0,0,1,0,1.18Z"
                transform="translate(-1144.223 -1365.328)"
                fill="#cbe3df"
              />
              <path
                id="Path_101141"
                data-name="Path 101141"
                d="M1202.316,708.424h0a1.4,1.4,0,0,1-1.4-1.4V696.276a1.4,1.4,0,0,1,1.4-1.4h0a1.4,1.4,0,0,1,1.4,1.4v10.752A1.4,1.4,0,0,1,1202.316,708.424Z"
                transform="translate(-1184.368 -692.862)"
                fill="#629e94"
              />
              <path
                id="Path_101142"
                data-name="Path 101142"
                d="M1312.576,708.424h0a1.4,1.4,0,0,1-1.4-1.4V696.276a1.4,1.4,0,0,1,1.4-1.4h0a1.4,1.4,0,0,1,1.4,1.4v10.752A1.4,1.4,0,0,1,1312.576,708.424Z"
                transform="translate(-1283.218 -692.862)"
                fill="#629e94"
              />
              <path
                id="Path_101143"
                data-name="Path 101143"
                d="M1257.446,708.424h0a1.4,1.4,0,0,1-1.4-1.4V696.276a1.4,1.4,0,0,1,1.4-1.4h0a1.4,1.4,0,0,1,1.4,1.4v10.752A1.4,1.4,0,0,1,1257.446,708.424Z"
                transform="translate(-1233.793 -692.862)"
                fill="#629e94"
              />
              <path
                id="Path_101144"
                data-name="Path 101144"
                d="M1367.706,708.424h0a1.4,1.4,0,0,1-1.4-1.4V696.276a1.4,1.4,0,0,1,1.4-1.4h0a1.4,1.4,0,0,1,1.4,1.4v10.752A1.4,1.4,0,0,1,1367.706,708.424Z"
                transform="translate(-1332.643 -692.862)"
                fill="#629e94"
              />
              <path
                id="Path_101145"
                data-name="Path 101145"
                d="M1422.836,708.424h0a1.4,1.4,0,0,1-1.4-1.4V696.276a1.4,1.4,0,0,1,1.4-1.4h0a1.4,1.4,0,0,1,1.4,1.4v10.752A1.4,1.4,0,0,1,1422.836,708.424Z"
                transform="translate(-1382.068 -692.862)"
                fill="#629e94"
              />
              <path
                id="Path_101146"
                data-name="Path 101146"
                d="M1477.966,708.424h0a1.4,1.4,0,0,1-1.4-1.4V696.276a1.4,1.4,0,0,1,1.4-1.4h0a1.4,1.4,0,0,1,1.4,1.4v10.752A1.4,1.4,0,0,1,1477.966,708.424Z"
                transform="translate(-1431.492 -692.862)"
                fill="#629e94"
              />
            </g>
            <g id="_5" data-name="5" transform="translate(97.411 94.801)">
              <path
                id="Path_101147"
                data-name="Path 101147"
                d="M1541.548,1582.11v4.749c0,3.832-6.617,6.939-14.779,6.939a25.2,25.2,0,0,1-10.52-2.066c-2.634-1.253-4.259-2.974-4.259-4.873v-4.749h29.559Z"
                transform="translate(-1511.98 -1575.222)"
                fill="#d6a65e"
              />
              <path
                id="Path_101148"
                data-name="Path 101148"
                d="M1541.46,1522.435c-.139,8.3-27.783,10.065-29.5.62a3.982,3.982,0,0,1-.057-1.007c.41-5.5,12.882-7.776,21.508-5.8C1537.677,1517.229,1541,1519.249,1541.46,1522.435Z"
                transform="translate(-1511.892 -1515.547)"
                fill="#eec275"
              />
              <path
                id="Path_101149"
                data-name="Path 101149"
                d="M1599.98,1520.232l-12.967,12.979c-.336-.067-.591-.262-.914-.34l12.7-12.9C1599.132,1520.037,1599.658,1520.153,1599.98,1520.232Z"
                transform="translate(-1578.42 -1519.512)"
                fill="#d6a65e"
              />
            </g>
            <g id="_4" data-name="4" transform="translate(39.542 97.546)">
              <path
                id="Path_101150"
                data-name="Path 101150"
                d="M1104.61,1565.339s1.209-10.4,1.219-10.4l10.99,1.283c4.557.378,6.4,6.628,2.738,9.322a5.224,5.224,0,0,1-3.856,1.095s-11.1-1.289-11.092-1.3Z"
                transform="translate(-1088.89 -1553.609)"
                fill="#4d726c"
              />
              <path
                id="Path_101151"
                data-name="Path 101151"
                d="M952.742,1546.666a5.239,5.239,0,0,1,5.806-4.555l11.088,1.295c.012,0-1.208,10.4-1.215,10.4C963.733,1552.673,951.965,1554.427,952.742,1546.666Z"
                transform="translate(-952.705 -1542.075)"
                fill="#f2f2f2"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function OtherHealthIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 114,
    height: 114,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 114 114"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 4601" transform="translate(-70.233 -537.233)">
        <circle
          data-name="Ellipse 39410"
          cx={57}
          cy={57}
          r={57}
          transform="translate(70.233 537.233)"
          fill="rgba(255,255,255,0.5)"
          opacity={0.5}
        />
        <circle
          data-name="Ellipse 39384"
          cx={50.5}
          cy={50.5}
          r={50.5}
          transform="translate(76.233 543.233)"
          fill="rgba(255,255,255,0.5)"
        />
        <path
          data-name="Path 853"
          d="M155.719 173.179a.734.734 0 01-.079-.008v3.763a3.466 3.466 0 012.793-1.408h.072v-1.063a11.248 11.248 0 01.075-1.288h-2.861z"
          transform="translate(86.161 558.5) translate(-103.656 -141.016)"
          fill="#4671c6"
        />
        <path
          data-name="Path 854"
          d="M222.328 173.18h-2.86a11.242 11.242 0 01.075 1.288v1.063h.072a3.466 3.466 0 012.793 1.408v-3.763c-.027-.002-.053.004-.08.004z"
          transform="translate(86.161 558.5) translate(-141.99 -141.016)"
          fill="#184457"
        />
        <path
          data-name="Path 855"
          d="M179.013 220.344h-13.956a5.79 5.79 0 00-5.79 5.79v5.256H184.8v-5.256a5.789 5.789 0 00-5.789-5.79z"
          transform="translate(86.161 558.5) translate(-105.835 -169.346)"
          fill="#cce2cb"
        />
        <path
          data-name="Path 4205"
          d="M40.434 83.783a9.914 9.914 0 01-.477-1.063c-.772-2.1-2.842-8.13-2.69-12.029v-.418H15.244c.144 3.707-1.72 9.343-2.568 11.693a11.735 11.735 0 01-.775 1.665 5.154 5.154 0 004.519 7.631c.127 0 .252-.006.376-.015v.015h19.04a5.153 5.153 0 004.6-7.48z"
          transform="translate(86.161 558.5) translate(40.158 -42.193)"
          fill="#464c55"
        />
        <path
          data-name="Path 857"
          d="M180.272 160.559h-.072V159.5a11.353 11.353 0 00-22.7 0v1.063h-.072a3.432 3.432 0 100 6.865 3.569 3.569 0 00.371-.02 11.375 11.375 0 0022.106 0 3.575 3.575 0 00.371.02 3.432 3.432 0 100-6.865z"
          transform="translate(86.161 558.5) translate(-102.647 -126.049)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 860"
          d="M167.647 175.686a12.078 12.078 0 01-11.664-8.672 4.228 4.228 0 01-.487-8.394v-.32a12.152 12.152 0 0124.3 0v.322a4.228 4.228 0 01-.487 8.394 12.077 12.077 0 01-11.664 8.672zM156.595 165.4a.8.8 0 01.777.616 10.577 10.577 0 0020.55 0 .805.805 0 01.861-.611 2.738 2.738 0 00.288.016 2.634 2.634 0 10.014-5.267h-.086a.8.8 0 01-.8-.8V158.3a10.554 10.554 0 00-21.107 0v1.063a.8.8 0 01-.825.8h-.065a2.634 2.634 0 10.018 5.268 2.746 2.746 0 00.288-.016.761.761 0 01.087-.015z"
          transform="translate(86.161 558.5) translate(-101.446 -124.847)"
          fill="#464c55"
        />
        <path
          data-name="Path 862"
          d="M166.473 152.151h-11.764a.75.75 0 01-.75-.75v-3a10.241 10.241 0 0110.241-10.243h5.46a2.812 2.812 0 012.812 2.812v5.181a6 6 0 01-6 6z"
          transform="translate(86.161 558.5) translate(-102.647 -119.988)"
          fill="#464c55"
        />
        <path
          data-name="Path 863"
          d="M210.824 152.151h-4.512a6 6 0 01-6-6v-5.181a2.812 2.812 0 012.812-2.812 8.449 8.449 0 018.449 8.449v4.793a.75.75 0 01-.749.751z"
          transform="translate(86.161 558.5) translate(-131.942 -119.502)"
          fill="#464c55"
        />
        <path
          data-name="Path 864"
          d="M183.487 216.109a11.38 11.38 0 01-5.151-1.223v1.966a5.15 5.15 0 1010.3 0v-1.964a11.379 11.379 0 01-5.149 1.221z"
          transform="translate(86.161 558.5) translate(-117.287 -166.069)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 865"
          d="M183.6 227.71h-25.533a.8.8 0 01-.8-.8v-5.256a6.6 6.6 0 016.589-6.588h1.028v-1.382a.8.8 0 011.16-.713 10.66 10.66 0 009.579 0 .8.8 0 011.159.713v1.38h1.031a6.6 6.6 0 016.589 6.588v5.256a.8.8 0 01-.8.8zm-24.737-1.6H182.8v-4.458a5 5 0 00-4.991-4.991h-1.835a.8.8 0 01-.8-.832v-.921a12.3 12.3 0 01-8.7 0V215.83a.8.8 0 01-.8.832h-1.832a5 5 0 00-4.991 4.991v4.458z"
          transform="translate(86.161 558.5) translate(-104.634 -164.867)"
          fill="#464c55"
        />
        <path
          data-name="Path 866"
          d="M165.273 151.748h-11.764a1.551 1.551 0 01-1.549-1.549v-3A11.053 11.053 0 01163 136.156h5.46a3.616 3.616 0 013.612 3.612v5.181a6.807 6.807 0 01-6.799 6.799zm-11.716-1.6h11.716a5.207 5.207 0 005.2-5.2v-5.181a2.016 2.016 0 00-2.014-2.014H163a9.453 9.453 0 00-9.443 9.443v2.953z"
          transform="translate(86.161 558.5) translate(-101.446 -118.785)"
          fill="#464c55"
        />
        <path
          data-name="Path 867"
          d="M209.622 151.748h-4.512a6.807 6.807 0 01-6.8-6.8v-5.181a3.616 3.616 0 013.611-3.612 9.258 9.258 0 019.248 9.248v4.797a1.55 1.55 0 01-1.549 1.549zm-7.7-13.993a2.016 2.016 0 00-2.014 2.014v5.181a5.207 5.207 0 005.2 5.2h4.463v-4.75a7.659 7.659 0 00-7.648-7.645z"
          transform="translate(86.161 558.5) translate(-130.74 -118.301)"
          fill="#464c55"
        />
        <path
          data-name="Path 868"
          d="M29.252 173.052a.741.741 0 01-.079-.008v3.763a3.466 3.466 0 012.793-1.408h.072v-1.059a11.246 11.246 0 01.075-1.288h-2.861z"
          transform="translate(86.161 558.5) translate(-27.704 -140.939)"
          fill="#464c55"
        />
        <path
          data-name="Path 869"
          d="M95.861 173.053H93a11.243 11.243 0 01.075 1.288v1.059h.072a3.466 3.466 0 012.793 1.408v-3.763c-.026.002-.052.008-.079.008z"
          transform="translate(86.161 558.5) translate(-66.037 -140.94)"
          fill="#4671c6"
        />
        <path
          data-name="Path 870"
          d="M52.547 220.217H38.591a5.79 5.79 0 00-5.79 5.79v5.256h25.536v-5.256a5.79 5.79 0 00-5.79-5.79z"
          transform="translate(86.161 558.5) translate(-29.882 -169.27)"
          fill="#cce2cb"
        />
        <path
          data-name="Path 4204"
          d="M40.434 83.783a9.914 9.914 0 01-.477-1.063c-.772-2.1-2.842-8.13-2.69-12.029v-.418H15.244c.144 3.707-1.72 9.343-2.568 11.693a11.735 11.735 0 01-.775 1.665 5.154 5.154 0 004.519 7.631c.127 0 .252-.006.376-.015v.015h19.04a5.153 5.153 0 004.6-7.48z"
          transform="translate(86.161 558.5) translate(-10.572 -42.193)"
          fill="#464c55"
        />
        <path
          data-name="Path 872"
          d="M53.806 160.432h-.072v-1.063a11.353 11.353 0 00-22.7 0v1.063h-.072a3.432 3.432 0 100 6.865 3.561 3.561 0 00.371-.02 11.375 11.375 0 0022.106 0 3.567 3.567 0 00.371.02 3.432 3.432 0 100-6.865z"
          transform="translate(86.161 558.5) translate(-26.695 -125.973)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 875"
          d="M41.181 175.559a12.078 12.078 0 01-11.664-8.672 4.228 4.228 0 01-.487-8.394v-.322a12.152 12.152 0 0124.3 0v.322a4.228 4.228 0 01-.487 8.394 12.078 12.078 0 01-11.662 8.672zm-11.052-10.283a.8.8 0 01.777.616 10.577 10.577 0 0020.55 0 .807.807 0 01.861-.612 2.738 2.738 0 00.288.016 2.634 2.634 0 10.012-5.267h-.084a.8.8 0 01-.8-.8v-1.063a10.554 10.554 0 00-21.107 0v1.063a.8.8 0 01-.238.57.82.82 0 01-.573.229h-.076a2.634 2.634 0 10.018 5.267 2.738 2.738 0 00.288-.016h.084z"
          transform="translate(86.161 558.5) translate(-25.494 -124.771)"
          fill="#464c55"
        />
        <path
          data-name="Path 877"
          d="M40.007 152.024H28.243a.75.75 0 01-.75-.75v-3a10.241 10.241 0 0110.241-10.241h5.46a2.812 2.812 0 012.812 2.812v5.181a6 6 0 01-6 6z"
          transform="translate(86.161 558.5) translate(-25.238 -119.426)"
          fill="#464c55"
        />
        <path
          data-name="Path 878"
          d="M84.357 152.024h-4.511a6 6 0 01-6-6v-5.181a2.812 2.812 0 012.812-2.812 8.449 8.449 0 018.449 8.449v4.794a.75.75 0 01-.75.75z"
          transform="translate(86.161 558.5) translate(-54.533 -119.912)"
          fill="#184457"
        />
        <path
          data-name="Path 879"
          d="M57.021 215.982a11.38 11.38 0 01-5.151-1.223v1.966a5.15 5.15 0 1010.3 0v-1.964a11.382 11.382 0 01-5.149 1.221z"
          transform="translate(86.161 558.5) translate(-41.335 -165.992)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 880"
          d="M57.136 227.583H31.6a.8.8 0 01-.8-.8v-5.256a6.6 6.6 0 016.589-6.589h1.028v-1.382a.8.8 0 011.16-.713 10.66 10.66 0 009.579 0 .8.8 0 011.159.713v1.38h1.031a6.6 6.6 0 016.589 6.589v5.256a.8.8 0 01-.8.8zm-24.737-1.6h23.938v-4.458a5 5 0 00-4.991-4.991h-1.835a.8.8 0 01-.8-.832v-.921a12.3 12.3 0 01-8.7 0V215.703a.8.8 0 01-.8.832h-1.822a5 5 0 00-4.991 4.991v4.458z"
          transform="translate(86.161 558.5) translate(-28.681 -164.791)"
          fill="#464c55"
        />
        <path
          data-name="Path 881"
          d="M38.807 151.62H27.043a1.551 1.551 0 01-1.549-1.549v-3a11.053 11.053 0 0111.041-11.041h5.46a3.616 3.616 0 013.612 3.611v5.181a6.807 6.807 0 01-6.8 6.8zm-11.715-1.6h11.715a5.207 5.207 0 005.2-5.2v-5.181a2.016 2.016 0 00-2.014-2.014h-5.46a9.453 9.453 0 00-9.443 9.443v2.953z"
          transform="translate(86.161 558.5) translate(-24.038 -118.224)"
          fill="#464c55"
        />
        <path
          data-name="Path 882"
          d="M83.156 151.621h-4.511a6.806 6.806 0 01-6.8-6.8v-5.181a3.615 3.615 0 013.611-3.611 9.258 9.258 0 019.248 9.248v4.794a1.551 1.551 0 01-1.548 1.55zm-7.7-13.993a2.016 2.016 0 00-2.013 2.014v5.181a5.207 5.207 0 005.2 5.2h4.463v-4.745a7.659 7.659 0 00-7.65-7.65z"
          transform="translate(86.161 558.5) translate(-53.332 -118.71)"
          fill="#464c55"
        />
        <path
          data-name="Path 883"
          d="M109.814 209.05H90.131a8.16 8.16 0 00-8.165 8.154v7.4h36.013v-7.4a8.159 8.159 0 00-8.165-8.154z"
          transform="translate(86.161 558.5) translate(-59.41 -162.563)"
          fill="#b7cfb7"
        />
        <path
          data-name="Path 885"
          d="M116.124 202.3a15.7 15.7 0 01-7.267-1.772v3.1a1.6 1.6 0 00.04.338 1.636 1.636 0 00.1.322l.018.041a1.645 1.645 0 00.141.238c.014.02.027.042.042.061l1.032 1.31a7.328 7.328 0 004.066 2.627c.216.051.441.094.673.129a7.358 7.358 0 006.868-2.82l1.5-1.938a1.613 1.613 0 00.034-.316v-3.086a15.7 15.7 0 01-7.247 1.766z"
          transform="translate(86.161 558.5) translate(-75.56 -157.448)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 886"
          d="M111.944 125.979h-.1v-1.459a15.648 15.648 0 00-31.293 0v1.463h-.1a4.724 4.724 0 100 9.448 4.91 4.91 0 00.512-.028 15.683 15.683 0 0030.467 0 4.819 4.819 0 00.512.028 4.724 4.724 0 100-9.448z"
          transform="translate(86.161 558.5) translate(-55.777 -102.498)"
          fill="#ffd8be"
        />
        <g data-name="Group 4587">
          <path
            data-name="Path 887"
            d="M95 146.952a16.342 16.342 0 01-15.846-11.927 5.52 5.52 0 01-.6-11v-.7a16.446 16.446 0 0132.891 0v.7a5.52 5.52 0 01-.6 11A16.343 16.343 0 0195 146.952zM79.765 133.4a.8.8 0 01.777.616 14.884 14.884 0 0028.911 0 .8.8 0 01.86-.611 4.115 4.115 0 00.429.024 3.925 3.925 0 10.01-7.85h-.109a.8.8 0 01-.8-.8v-1.463a14.849 14.849 0 00-29.7 0v1.463a.8.8 0 01-.237.568.818.818 0 01-.571.23h-.092a3.925 3.925 0 100 7.85 4.011 4.011 0 00.429-.024c.038-.003.066-.003.093-.003z"
            transform="translate(86.161 558.5) translate(19.247 5.74) translate(-73.68 -107.037)"
            fill="#3762cc"
          />
          <path
            data-name="Path 891"
            d="M95 146.952a16.342 16.342 0 01-15.846-11.927 5.52 5.52 0 01-.6-11v-.7a16.446 16.446 0 0132.891 0v.7a5.52 5.52 0 01-.6 11A16.343 16.343 0 0195 146.952zM79.765 133.4a.8.8 0 01.777.616 14.884 14.884 0 0028.911 0 .8.8 0 01.86-.611 4.115 4.115 0 00.429.024 3.925 3.925 0 10.01-7.85h-.109a.8.8 0 01-.8-.8v-1.463a14.849 14.849 0 00-29.7 0v1.463a.8.8 0 01-.237.568.818.818 0 01-.571.23h-.092a3.925 3.925 0 100 7.85 4.011 4.011 0 00.429-.024c.038-.003.066-.003.093-.003z"
            transform="translate(86.161 558.5) translate(19.247 5.74) translate(-73.68 -107.037)"
            fill="#464c55"
          />
        </g>
        <path
          data-name="Path 892"
          d="M101.146 97.908a17.857 17.857 0 00-6.6-2.321c-3.2-1.077-7.316-1.372-12.557 0a21.629 21.629 0 01-9.589 1.171.526.526 0 00-.556.661 19.264 19.264 0 002.033 4.679.528.528 0 01-.258.761 26.46 26.46 0 01-3.956 1.23.526.526 0 00-.325.8c1.744 2.679 9.436 12.593 25.852 8.987.292-.064.584-.145.869-.234a10.332 10.332 0 006.227-5.431l1.2-2.518a6.027 6.027 0 00-2.34-7.785z"
          transform="translate(86.161 558.5) translate(-51.775 -93.868)"
          fill="#464c55"
        />
        <path
          data-name="Path 893"
          d="M87.085 114.264a22.934 22.934 0 01-19.615-10.139 1.325 1.325 0 01.818-2.015 25.84 25.84 0 003.543-1.077 20.056 20.056 0 01-1.956-4.6 1.326 1.326 0 011.4-1.669 21.117 21.117 0 009.2-1.106.815.815 0 01.11-.038 22.578 22.578 0 0112.944-.013 18.594 18.594 0 016.826 2.414 6.866 6.866 0 012.655 8.817l-1.2 2.518a11.157 11.157 0 01-6.71 5.85c-.334.1-.64.187-.936.252a32.908 32.908 0 01-7.077.808zm-18.06-10.686c2.2 3.2 9.6 11.655 24.794 8.318.25-.055.513-.126.8-.216a9.558 9.558 0 005.744-5.012l1.2-2.518a5.258 5.258 0 00-2.023-6.75 17.008 17.008 0 00-6.309-2.218.814.814 0 01-.145-.034 20.943 20.943 0 00-12.047.007 22.412 22.412 0 01-9.515 1.235 18.852 18.852 0 001.839 4.1 1.327 1.327 0 01-.647 1.913 27.257 27.257 0 01-3.691 1.177z"
          transform="translate(86.161 558.5) translate(-50.575 -92.667)"
          fill="#464c55"
        />
        <path
          data-name="Path 894"
          d="M156.456 116.985a2.545 2.545 0 00-2.755-.885l-.88.266a6.064 6.064 0 01-.377 1.672c-.059.155-.122.31-.195.462l-1.2 2.518a9.696 9.696 0 01-.282.546l-.016.028q-.144.261-.3.511a9.038 9.038 0 003.684 6.174l2.617 1.881c.033 0 .066-.005.1-.005a4.792 4.792 0 012.282.574l.332-2.431a15.2 15.2 0 00-3.01-11.311z"
          transform="translate(86.161 558.5) translate(-100.539 -106.675)"
          fill="#464c55"
        />
        <path
          data-name="Path 895"
          d="M157.929 130.331a.8.8 0 01-.379-.1 4.022 4.022 0 00-1.9-.478c-.03 0-.065.005-.1.005a.8.8 0 01-.466-.15l-2.617-1.881a9.877 9.877 0 01-4.011-6.72.8.8 0 01.117-.53 10.596 10.596 0 00.556-1.002l1.2-2.518c.063-.132.117-.265.168-.4a5.307 5.307 0 00.327-1.454.8.8 0 01.565-.7l.881-.266a3.36 3.36 0 013.62 1.163 16.1 16.1 0 013.165 11.908l-.332 2.431a.8.8 0 01-.791.691zm-2.128-2.17a5.644 5.644 0 011.476.24l.192-1.407a14.5 14.5 0 00-2.849-10.719 1.755 1.755 0 00-1.89-.607l-.382.116a6.912 6.912 0 01-.359 1.34c-.065.175-.138.35-.22.524l-1.2 2.518c-.095.2-.2.395-.3.588l-.021.036a5.9 5.9 0 01-.167.29 8.269 8.269 0 003.318 5.355z"
          transform="translate(86.161 558.5) translate(-99.337 -105.477)"
          fill="#464c55"
        />
        <path
          data-name="Path 896"
          d="M79.927 140.862a4.782 4.782 0 012.77-.881.67.67 0 01.1.005v-1.463a15.361 15.361 0 01.5-3.912 22.035 22.035 0 01-3.421-2.26 15.187 15.187 0 00-.326 5.774z"
          transform="translate(86.161 558.5) translate(-57.877 -116.5)"
          fill="#464c55"
        />
        <path
          data-name="Path 897"
          d="M78.724 140.46a.8.8 0 01-.792-.691l-.374-2.738a15.927 15.927 0 01.343-6.078.8.8 0 011.275-.427 21.313 21.313 0 003.3 2.178.8.8 0 01.4.908 14.583 14.583 0 00-.479 3.709v1.464a.8.8 0 01-.241.572.77.77 0 01-.577.227h-.083a3.97 3.97 0 00-2.3.734.8.8 0 01-.461.147zm.476-7.911a14.293 14.293 0 00-.058 4.267l.217 1.589a5.534 5.534 0 011.435-.379v-.7a16.2 16.2 0 01.384-3.508 23.161 23.161 0 01-1.978-1.27z"
          transform="translate(86.161 558.5) translate(-56.674 -115.299)"
          fill="#464c55"
        />
        <path
          data-name="Path 898"
          d="M116.777 219.089H80.765a.8.8 0 01-.8-.8v-7.4a8.968 8.968 0 018.964-8.953h1.777v-2.6a.8.8 0 011.168-.709 14.992 14.992 0 006.9 1.682 14.793 14.793 0 006.89-1.678.8.8 0 011.167.709v2.6h1.781a8.968 8.968 0 018.964 8.953v7.4a.8.8 0 01-.799.796zm-35.214-1.6h34.415v-6.6a7.369 7.369 0 00-7.366-7.355H106a.8.8 0 01-.785-.954.852.852 0 00.019-.158v-1.828a16.593 16.593 0 01-12.928 0v1.84a.763.763 0 00.019.147.8.8 0 01-.783.956H88.93a7.369 7.369 0 00-7.366 7.355v6.6z"
          transform="translate(86.161 558.5) translate(-58.209 -156.247)"
          fill="#464c55"
        />
        <path
          data-name="Path 899"
          d="M10.535 50.788S9.598 55.961 15.4 55.8c0-.046 5.55.78 5.55-4.679"
          fill="none"
          stroke="#464c55"
          strokeWidth={3}
          transform="translate(86.161 558.5)"
        />
        <path
          data-name="Path 900"
          d="M61.106 50.788s-.937 5.173 4.865 5.012c0-.046 5.55.78 5.55-4.679"
          fill="none"
          stroke="#464c55"
          strokeWidth={3}
          transform="translate(86.161 558.5)"
        />
        <path
          data-name="Path 901"
          d="M33.297 46.486s1.919 4.636 6.735 4.957 7.265-3.875 7.89-4.957"
          fill="none"
          stroke="#464c55"
          strokeWidth={3}
          transform="translate(86.161 558.5)"
        />
        <g data-name="Group 4616">
          <g
            data-name="Group 4615"
            transform="translate(86.161 558.5) translate(31.702 22.572)"
          >
            <ellipse
              data-name="Ellipse 39387"
              cx={2}
              cy={2.5}
              rx={2}
              ry={2.5}
              transform="translate(.37 2.16)"
              fill="#464c55"
            />
            <ellipse
              data-name="Ellipse 39388"
              cx={1.5}
              cy={2.5}
              rx={1.5}
              ry={2.5}
              transform="translate(13.37 2.16)"
              fill="#464c55"
            />
            <path
              data-name="Line 268"
              transform="translate(13.685)"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L2.913 0"
            />
            <path
              data-name="Line 269"
              transform="translate(.821)"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L2.913 0"
            />
            <path
              data-name="Path 926"
              d="M5.432 13.801a6.451 6.451 0 006.278 0"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
            />
          </g>
        </g>
        <g data-name="Group 4619">
          <g
            data-name="Group 4615"
            transform="translate(86.161 558.5) translate(9.633 34.472)"
          >
            <g
              data-name="Group 4620"
              transform="translate(.076 1.78)"
              fill="#464c55"
            >
              <ellipse
                data-name="Ellipse 39387"
                cx={0.971}
                cy={1.214}
                rx={0.971}
                ry={1.214}
              />
              <ellipse
                data-name="Ellipse 39389"
                cx={0.971}
                cy={1.214}
                rx={0.971}
                ry={1.214}
                transform="translate(9.708)"
              />
            </g>
            <path
              data-name="Line 269"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L1.91 0"
            />
            <path
              data-name="Line 270"
              transform="translate(9.708)"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L1.91 0"
            />
            <path
              data-name="Path 926"
              d="M3.716 9.052a4.231 4.231 0 004.118 0"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
            />
          </g>
        </g>
        <g data-name="Group 4621">
          <g
            data-name="Group 4615"
            transform="translate(86.161 558.5) translate(60.147 34.472)"
          >
            <g
              data-name="Group 4620"
              transform="translate(.076 1.78)"
              fill="#464c55"
            >
              <ellipse
                data-name="Ellipse 39387"
                cx={0.971}
                cy={1.214}
                rx={0.971}
                ry={1.214}
              />
              <ellipse
                data-name="Ellipse 39389"
                cx={0.971}
                cy={1.214}
                rx={0.971}
                ry={1.214}
                transform="translate(9.708)"
              />
            </g>
            <path
              data-name="Line 269"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L1.91 0"
            />
            <path
              data-name="Line 270"
              transform="translate(9.708)"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L1.91 0"
            />
            <path
              data-name="Path 926"
              d="M3.716 9.052a4.231 4.231 0 004.118 0"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function CorporateSignUp(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 347,
    height: 241,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 347 241"
      {...rest}
      sx={rootSx}
    >
      <g
        data-name="Corporate Signup Illustration"
        transform="translate(-37 -54)"
      >
        <g data-name="Corporate Signup Illustration">
          <g
            data-name="Signup illustration"
            transform="translate(-806 -5246) translate(843 5297)"
          >
            <path
              data-name="Path 4343"
              d="M243.9 4.5a3 3 0 015.2 0l21.218 36.75a3 3 0 01-2.6 4.5h-42.436a3 3 0 01-2.6-4.5z"
              fill="rgba(90,197,179,0.1)"
            />
            <circle
              data-name="Ellipse 39439"
              cx={30}
              cy={30}
              r={30}
              transform="translate(0 120)"
              fill="rgba(90,197,179,0.1)"
            />
            <circle
              data-name="Ellipse 39440"
              cx={19}
              cy={19}
              r={19}
              transform="translate(43 14)"
              fill="rgba(90,197,179,0.1)"
            />
            <g
              data-name="Group 5427"
              opacity={0.3}
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            >
              <path
                data-name="Path 4381"
                d="M301.75 151.508h-62.435V38.427A30.427 30.427 0 01269.742 8a31.993 31.993 0 0131.994 31.994v111.514z"
                opacity={0.3}
              />
              <path
                data-name="Path 4382"
                d="M294.689 151.172V40.244a24.169 24.169 0 00-24.169-24.169h0a24.169 24.169 0 00-24.156 24.169V151.19"
                opacity={0.3}
              />
              <path data-name="Path 4383" d="M270.533 8v143.34" opacity={0.3} />
              <path
                data-name="Path 4384"
                d="M301.414 35.612h-61.682"
                opacity={0.3}
              />
              <path
                data-name="Path 4385"
                d="M301.414 55.081h-61.682"
                opacity={0.3}
              />
              <path
                data-name="Path 4386"
                d="M301.414 74.549h-61.682"
                opacity={0.3}
              />
              <path
                data-name="Path 4387"
                d="M301.414 94.023h-61.682"
                opacity={0.3}
              />
              <path
                data-name="Path 4388"
                d="M301.414 113.493h-61.682"
                opacity={0.3}
              />
              <path
                data-name="Path 4389"
                d="M301.414 132.962h-61.682"
                opacity={0.3}
              />
              <path
                data-name="Path 4390"
                d="M293.167 17.741l-5.591 5.1"
                opacity={0.3}
              />
              <path
                data-name="Path 4391"
                d="M248.13 17.741l5.6 5.1"
                opacity={0.3}
              />
            </g>
            <g
              data-name="Group 5428"
              opacity={0.3}
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            >
              <path
                data-name="Path 4392"
                d="M72.435 151.508H10V38.427A30.427 30.427 0 0140.427 8a31.994 31.994 0 0131.994 31.994v111.514z"
                opacity={0.3}
              />
              <path
                data-name="Path 4393"
                d="M65.383 151.172V40.244a24.17 24.17 0 00-24.169-24.187h0a24.169 24.169 0 00-24.188 24.187V151.19"
                opacity={0.3}
              />
              <path data-name="Path 4394" d="M41.214 8v143.34" opacity={0.3} />
              <path
                data-name="Path 4395"
                d="M72.1 35.612H10.413"
                opacity={0.3}
              />
              <path
                data-name="Path 4396"
                d="M72.1 55.081H10.413"
                opacity={0.3}
              />
              <path
                data-name="Path 4397"
                d="M72.1 74.549H10.413"
                opacity={0.3}
              />
              <path
                data-name="Path 4398"
                d="M72.1 94.023H10.413"
                opacity={0.3}
              />
              <path
                data-name="Path 4399"
                d="M72.1 113.492H10.413"
                opacity={0.3}
              />
              <path
                data-name="Path 4400"
                d="M72.1 132.961H10.413"
                opacity={0.3}
              />
              <path
                data-name="Path 4401"
                d="M63.852 17.741l-5.595 5.1"
                opacity={0.3}
              />
              <path
                data-name="Path 4402"
                d="M18.815 17.741l5.59 5.1"
                opacity={0.3}
              />
            </g>
            <path
              data-name="Path 4552"
              d="M236.529 196.249h64.988"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 4553"
              d="M10 196.249h226.529"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <g data-name="Group 90691">
              <path
                data-name="Path 4344"
                d="M28.842 137.294a3.545 3.545 0 00-1.272-2.178c-1.272-1.272-2.087-2-2.087-2s-.637 2.089.543 3.359a22.342 22.342 0 002.811 2.453z"
                transform="translate(7.748 151.508) translate(-17.95 -133.118)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4345"
                d="M26.251 145.269a3.549 3.549 0 00-1.27-2.181c-1.27-1.272-2.09-2-2.09-2s-.635 2.089.546 3.361a22.37 22.37 0 002.813 2.446z"
                transform="translate(7.748 151.508) translate(-17.202 -135.419)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4346"
                d="M30.092 139.624a3.543 3.543 0 011.495-2.034c1.4-1.129 2.289-1.766 2.289-1.766s.412 2.143-.9 3.279a22.283 22.283 0 01-3.059 2.141z"
                transform="translate(7.748 151.508) translate(-19.28 -133.899)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4347"
                d="M26.882 149.2s.192-.888 1.7-1.874 2.462-1.516 2.462-1.516.183 2.176-1.237 3.172a22.437 22.437 0 01-3.28 1.808z"
                transform="translate(7.748 151.508) translate(-18.301 -136.78)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4348"
                d="M27.618 159.152a3.547 3.547 0 011.272-2.181c1.272-1.272 2.09-2 2.09-2s.635 2.09-.546 3.362a22.286 22.286 0 01-2.811 2.452z"
                transform="translate(7.748 151.508) translate(-18.616 -139.426)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4349"
                d="M26.323 161.48a3.576 3.576 0 00-.937-2.342c-1.066-1.443-1.783-2.275-1.783-2.275s-.937 1.978.061 3.4a22.375 22.375 0 002.439 2.828z"
                transform="translate(7.748 151.508) translate(-17.342 -139.972)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4350"
                d="M25.826 169.085a3.54 3.54 0 011.272-2.179c1.272-1.27 2.09-2 2.09-2s.635 2.087-.546 3.359a22.291 22.291 0 01-2.811 2.453z"
                transform="translate(7.748 151.508) translate(-18.099 -142.294)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4351"
                d="M27.013 175.528a3.52 3.52 0 01.677-2.431c.911-1.553 1.516-2.462 1.516-2.462s1.143 1.86.323 3.39a22.2 22.2 0 01-2.108 3.085z"
                transform="translate(7.748 151.508) translate(-18.433 -143.947)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4352"
                d="M11.007 3.944a26 26 0 01-.347 2.811c-.5 2.6-1.759 4.273-2.263 6.618s.937 5.366.555 8.379-1.56 4.685-1.225 6.7 2.094 7.454 2.094 7.454"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4353"
                d="M10.801 6.327l1.37-1.049"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4354"
                d="M10.861 5.12l-.574-1.019"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4355"
                d="M8.474 13.275s1.145-.86 2.326-1.722"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4356"
                d="M9.048 11.479A18.337 18.337 0 007.01 8.361"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4357"
                d="M9.049 21.016a14.163 14.163 0 012.453-3.279"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4358"
                d="M8.814 22.293a16.145 16.145 0 00-1.242-2.359c-.67-.989-.766-1.115-.766-1.115"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4359"
                d="M7.727 28.461a15.1 15.1 0 011.033-2.089 13.268 13.268 0 011.338-1.752"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4360"
                d="M8.996 33.163a3.9 3.9 0 01.344-2.008c.468-.923 1.019-2.134 1.242-2.611"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4361"
                d="M18.57 154.836a2.265 2.265 0 01.56-1.507c.658-.937 1.094-1.478 1.094-1.478a2.437 2.437 0 01.023 2.167 14.129 14.129 0 01-1.5 1.841z"
                transform="translate(7.748 151.508) translate(-16.002 -138.525)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4362"
                d="M21.063 159.564a2.26 2.26 0 01.56-1.506c.658-.935 1.1-1.487 1.1-1.487a2.428 2.428 0 01.021 2.165 14.192 14.192 0 01-1.5 1.843z"
                transform="translate(7.748 151.508) translate(-16.722 -139.888)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4363"
                d="M17.748 156.6s-.159-.556-1.157-1.113-1.628-.86-1.628-.86a2.434 2.434 0 00.921 1.963 14.277 14.277 0 002.15 1.009z"
                transform="translate(7.748 151.508) translate(-14.963 -139.326)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4364"
                d="M20.658 162.285s-.216-.536-1.267-.984-1.708-.684-1.708-.684a2.426 2.426 0 001.12 1.852 14.1 14.1 0 002.246.78z"
                transform="translate(7.748 151.508) translate(-15.748 -141.056)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4365"
                d="M21.566 168.549s-.1-.569-1.033-1.227-1.527-1.026-1.527-1.026a2.446 2.446 0 00.7 2.048 14.218 14.218 0 002.031 1.232z"
                transform="translate(7.748 151.508) translate(-16.126 -142.694)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4366"
                d="M22.89 169.738a2.246 2.246 0 01.34-1.569c.52-1.019.871-1.621.871-1.621a2.439 2.439 0 01.333 2.141 14.267 14.267 0 01-1.223 2.038z"
                transform="translate(7.748 151.508) translate(-17.242 -142.767)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4367"
                d="M25.1 176.518s.066-.574.963-1.286 1.464-1.113 1.464-1.113a2.434 2.434 0 01-.588 2.084 14.12 14.12 0 01-1.958 1.347z"
                transform="translate(7.748 151.508) translate(-17.853 -144.953)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4368"
                d="M23.767 174.584s-.1-.569-1.033-1.23-1.527-1.026-1.527-1.026a2.442 2.442 0 00.7 2.047 14.115 14.115 0 002.026 1.232z"
                transform="translate(7.748 151.508) translate(-16.761 -144.436)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4369"
                d="M23.948 178.7a2.251 2.251 0 00-.689-1.45c-.738-.874-1.218-1.38-1.218-1.38a2.438 2.438 0 00.164 2.16 14.221 14.221 0 001.654 1.708z"
                transform="translate(7.748 151.508) translate(-16.952 -145.458)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4370"
                d="M2.469 16.177a16.626 16.626 0 00.525 1.731c.6 1.572 1.567 2.488 2.136 3.9s0 3.469.562 5.315 1.488 2.771 1.494 4.069-.5 4.9-.5 4.9"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4371"
                d="M2.858 17.649l-.972-.511"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4372"
                d="M2.687 16.896l.248-.7"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4373"
                d="M5.067 21.753s-.813-.415-1.64-.827"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4374"
                d="M4.517 20.691a11.59 11.59 0 01.937-2.176"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4375"
                d="M5.551 26.67a9.094 9.094 0 00-1.89-1.793"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4376"
                d="M5.83 27.444a10.317 10.317 0 01.522-1.614c.314-.691.358-.782.358-.782"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4377"
                d="M7.145 32.179a8.44 8.44 0 011.045-1.087 5.726 5.726 0 00.682-.593"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4378"
                d="M7.187 31.196a9.714 9.714 0 00-.874-1.2 8.424 8.424 0 00-1.028-.949"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4379"
                d="M6.905 34.279a2.467 2.467 0 00-.433-1.225c-.4-.527-.871-1.228-1.063-1.5"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
              <path
                data-name="Path 4380"
                d="M10.647 44.742H5.339a.416.416 0 01-.417-.417l-1.317-8.789h8.775l-1.317 8.789a.416.416 0 01-.417.417z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(7.748 151.508)"
              />
            </g>
            <g data-name="Group 90696">
              <path
                data-name="Path 4344"
                d="M28.842 137.294a3.545 3.545 0 00-1.272-2.178c-1.272-1.272-2.087-2-2.087-2s-.637 2.089.543 3.359a22.342 22.342 0 002.811 2.453z"
                transform="translate(287.093 151.508) translate(-17.95 -133.118)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4345"
                d="M26.251 145.269a3.549 3.549 0 00-1.27-2.181c-1.27-1.272-2.09-2-2.09-2s-.635 2.089.546 3.361a22.37 22.37 0 002.813 2.446z"
                transform="translate(287.093 151.508) translate(-17.202 -135.419)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4346"
                d="M30.092 139.624a3.543 3.543 0 011.495-2.034c1.4-1.129 2.289-1.766 2.289-1.766s.412 2.143-.9 3.279a22.283 22.283 0 01-3.059 2.141z"
                transform="translate(287.093 151.508) translate(-19.28 -133.899)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4347"
                d="M26.882 149.2s.192-.888 1.7-1.874 2.462-1.516 2.462-1.516.183 2.176-1.237 3.172a22.437 22.437 0 01-3.28 1.808z"
                transform="translate(287.093 151.508) translate(-18.301 -136.78)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4348"
                d="M27.618 159.152a3.547 3.547 0 011.272-2.181c1.272-1.272 2.09-2 2.09-2s.635 2.09-.546 3.362a22.286 22.286 0 01-2.811 2.452z"
                transform="translate(287.093 151.508) translate(-18.616 -139.426)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4349"
                d="M26.323 161.48a3.576 3.576 0 00-.937-2.342c-1.066-1.443-1.783-2.275-1.783-2.275s-.937 1.978.061 3.4a22.375 22.375 0 002.439 2.828z"
                transform="translate(287.093 151.508) translate(-17.342 -139.972)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4350"
                d="M25.826 169.085a3.54 3.54 0 011.272-2.179c1.272-1.27 2.09-2 2.09-2s.635 2.087-.546 3.359a22.291 22.291 0 01-2.811 2.453z"
                transform="translate(287.093 151.508) translate(-18.099 -142.294)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4351"
                d="M27.013 175.528a3.52 3.52 0 01.677-2.431c.911-1.553 1.516-2.462 1.516-2.462s1.143 1.86.323 3.39a22.2 22.2 0 01-2.108 3.085z"
                transform="translate(287.093 151.508) translate(-18.433 -143.947)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4352"
                d="M11.007 3.944a26 26 0 01-.347 2.811c-.5 2.6-1.759 4.273-2.263 6.618s.937 5.366.555 8.379-1.56 4.685-1.225 6.7 2.094 7.454 2.094 7.454"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4353"
                d="M10.801 6.327l1.37-1.049"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4354"
                d="M10.861 5.12l-.574-1.019"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4355"
                d="M8.474 13.275s1.145-.86 2.326-1.722"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4356"
                d="M9.048 11.479A18.337 18.337 0 007.01 8.361"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4357"
                d="M9.049 21.016a14.163 14.163 0 012.453-3.279"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4358"
                d="M8.814 22.293a16.145 16.145 0 00-1.242-2.359c-.67-.989-.766-1.115-.766-1.115"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4359"
                d="M7.727 28.461a15.1 15.1 0 011.033-2.089 13.268 13.268 0 011.338-1.752"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4360"
                d="M8.996 33.163a3.9 3.9 0 01.344-2.008c.468-.923 1.019-2.134 1.242-2.611"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4361"
                d="M18.57 154.836a2.265 2.265 0 01.56-1.507c.658-.937 1.094-1.478 1.094-1.478a2.437 2.437 0 01.023 2.167 14.129 14.129 0 01-1.5 1.841z"
                transform="translate(287.093 151.508) translate(-16.002 -138.525)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4362"
                d="M21.063 159.564a2.26 2.26 0 01.56-1.506c.658-.935 1.1-1.487 1.1-1.487a2.428 2.428 0 01.021 2.165 14.192 14.192 0 01-1.5 1.843z"
                transform="translate(287.093 151.508) translate(-16.722 -139.888)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4363"
                d="M17.748 156.6s-.159-.556-1.157-1.113-1.628-.86-1.628-.86a2.434 2.434 0 00.921 1.963 14.277 14.277 0 002.15 1.009z"
                transform="translate(287.093 151.508) translate(-14.963 -139.326)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4364"
                d="M20.658 162.285s-.216-.536-1.267-.984-1.708-.684-1.708-.684a2.426 2.426 0 001.12 1.852 14.1 14.1 0 002.246.78z"
                transform="translate(287.093 151.508) translate(-15.748 -141.056)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4365"
                d="M21.566 168.549s-.1-.569-1.033-1.227-1.527-1.026-1.527-1.026a2.446 2.446 0 00.7 2.048 14.218 14.218 0 002.031 1.232z"
                transform="translate(287.093 151.508) translate(-16.126 -142.694)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4366"
                d="M22.89 169.738a2.246 2.246 0 01.34-1.569c.52-1.019.871-1.621.871-1.621a2.439 2.439 0 01.333 2.141 14.267 14.267 0 01-1.223 2.038z"
                transform="translate(287.093 151.508) translate(-17.242 -142.767)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4367"
                d="M25.1 176.518s.066-.574.963-1.286 1.464-1.113 1.464-1.113a2.434 2.434 0 01-.588 2.084 14.12 14.12 0 01-1.958 1.347z"
                transform="translate(287.093 151.508) translate(-17.853 -144.953)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4368"
                d="M23.767 174.584s-.1-.569-1.033-1.23-1.527-1.026-1.527-1.026a2.442 2.442 0 00.7 2.047 14.115 14.115 0 002.026 1.232z"
                transform="translate(287.093 151.508) translate(-16.761 -144.436)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4369"
                d="M23.948 178.7a2.251 2.251 0 00-.689-1.45c-.738-.874-1.218-1.38-1.218-1.38a2.438 2.438 0 00.164 2.16 14.221 14.221 0 001.654 1.708z"
                transform="translate(287.093 151.508) translate(-16.952 -145.458)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4370"
                d="M2.469 16.177a16.626 16.626 0 00.525 1.731c.6 1.572 1.567 2.488 2.136 3.9s0 3.469.562 5.315 1.488 2.771 1.494 4.069-.5 4.9-.5 4.9"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4371"
                d="M2.858 17.649l-.972-.511"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4372"
                d="M2.687 16.896l.248-.7"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4373"
                d="M5.067 21.753s-.813-.415-1.64-.827"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4374"
                d="M4.517 20.691a11.59 11.59 0 01.937-2.176"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4375"
                d="M5.551 26.67a9.094 9.094 0 00-1.89-1.793"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4376"
                d="M5.83 27.444a10.317 10.317 0 01.522-1.614c.314-.691.358-.782.358-.782"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4377"
                d="M7.145 32.179a8.44 8.44 0 011.045-1.087 5.726 5.726 0 00.682-.593"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4378"
                d="M7.187 31.196a9.714 9.714 0 00-.874-1.2 8.424 8.424 0 00-1.028-.949"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4379"
                d="M6.905 34.279a2.467 2.467 0 00-.433-1.225c-.4-.527-.871-1.228-1.063-1.5"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
              <path
                data-name="Path 4380"
                d="M10.647 44.742H5.339a.416.416 0 01-.417-.417l-1.317-8.789h8.775l-1.317 8.789a.416.416 0 01-.417.417z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(287.093 151.508)"
              />
            </g>
          </g>
        </g>
        <path
          data-name="Path 6522"
          d="M247.93 40.34s3.827 21.16 6.417 21.064c3.332-.125 14.7-17.745 14.7-17.745S249.8 40.7 247.93 40.34z"
          transform="translate(-39.17 59.34) translate(-70.278 -22.572)"
          fill="#4ac9b4"
        />
        <g data-name="Group 90693">
          <path
            data-name="Path 6523"
            d="M247.93 40.34s3.827 21.16 6.417 21.064c3.332-.125 14.7-17.745 14.7-17.745S249.8 40.7 247.93 40.34z"
            transform="translate(-39.17 59.34) translate(177.652 17.768) translate(-247.93 -40.34)"
            fill="#fff"
            opacity={0.3}
          />
        </g>
        <path
          data-name="Path 6524"
          d="M185.64 24.51l2.3.083a.345.345 0 01.133.025.262.262 0 01.187.279.234.234 0 01-.029.108.346.346 0 01-.3.179l-2.061-.062-.333 1.945 1.487.054a.383.383 0 01.158.037.275.275 0 01.167.275.246.246 0 01-.021.1.337.337 0 01-.3.183l-1.582-.058-.3 1.82 2.041.075a.483.483 0 01.154.029.279.279 0 01.175.279.25.25 0 010 .092.325.325 0 01-.3.192l-2.382-.087a.287.287 0 01-.162-.05.342.342 0 01-.129-.3q0-.054.833-4.914a.35.35 0 01.029-.1.271.271 0 01.242-.175z"
          fill="#263238"
          stroke="#263238"
          strokeWidth={0.4}
          transform="translate(-39.17 59.34)"
        />
        <path
          data-name="Path 6525"
          d="M303.66 49.1s5.7 20.735 8.271 20.406c3.332-.416 13.06-18.986 13.06-18.986s-19.436-1.228-21.331-1.42z"
          transform="translate(-39.17 59.34) translate(-102.799 -27.684)"
          fill="#38c5ae"
        />
        <path
          data-name="Path 6526"
          d="M211.502 32.897l-2.407.125a.258.258 0 01-.154-.037.446.446 0 01-.154-.292h0q0-.15.416-4.964a.871.871 0 010-.1.287.287 0 01.387-.162.266.266 0 01.162.246c0 .217-.042.67-.092 1.358q-.25 3.182-.254 3.352l2.045-.108a.475.475 0 01.154 0 .267.267 0 01.2.258.25.25 0 010 .1.333.333 0 01-.303.224z"
          fill="#263238"
          stroke="#263238"
          strokeWidth={0.4}
          transform="translate(-39.17 59.34)"
        />
        <path
          data-name="Path 6527"
          d="M359.89 51.838s7.542 20.139 10.07 19.573c3.265-.72 11.3-20.081 11.3-20.081s-19.467.529-21.37.508z"
          transform="translate(-39.17 59.34) translate(-135.612 -28.985)"
          fill="#4ac9b4"
        />
        <g data-name="Group 90694">
          <path
            data-name="Path 6528"
            d="M359.89 51.838s7.542 20.139 10.07 19.573c3.265-.72 11.3-20.081 11.3-20.081s-19.467.529-21.37.508z"
            transform="translate(-39.17 59.34) translate(224.278 22.345) translate(-359.89 -51.33)"
            fill="#fff"
            opacity={0.3}
          />
        </g>
        <path
          data-name="Path 6529"
          d="M235.471 29.041a1.744 1.744 0 00-.241-.321.8.8 0 00-.666-.279.758.758 0 00-.416.225 2.311 2.311 0 00-.57 1.137 3.985 3.985 0 00-.1 1.537 2.728 2.728 0 00.4 1.137.783.783 0 00.766.416.8.8 0 00.416-.25 2.382 2.382 0 00.55-.949.15.15 0 010-.046.254.254 0 01.217-.175.287.287 0 01.146 0 .271.271 0 01.179.229.364.364 0 010 .142 3.079 3.079 0 01-.416.9 1.578 1.578 0 01-1.062.725h-.158a1.283 1.283 0 01-1-.516 2.956 2.956 0 01-.629-1.533 4.263 4.263 0 010-1.174 3.8 3.8 0 01.566-1.632 1.6 1.6 0 011.091-.8 1.187 1.187 0 01.525.042 1.666 1.666 0 01.9.833.321.321 0 01.046.129.254.254 0 010 .146.283.283 0 01-.225.179.346.346 0 01-.319-.102z"
          fill="#263238"
          stroke="#263238"
          strokeWidth={0.4}
          transform="translate(-39.17 59.34)"
        />
        <path
          data-name="Path 6530"
          d="M413.55 49s8.708 19.665 11.2 18.977c3.215-.912 10.1-20.714 10.1-20.714S415.453 48.9 413.55 49z"
          transform="translate(-39.17 59.34) translate(-166.926 -26.61)"
          fill="#38c5ae"
        />
        <path
          data-name="Path 6531"
          d="M255.673 30.482a4.3 4.3 0 01-.071-1.187 3.719 3.719 0 01.483-1.666 1.591 1.591 0 011.029-.833 1.224 1.224 0 011.074.325 2.723 2.723 0 01.779 1.378c.071-.046.175-.121.308-.221a1.178 1.178 0 01.416-.233.242.242 0 01.133 0 .254.254 0 01.179.2.416.416 0 01-.071.279 1.828 1.828 0 01-.833.566 4.521 4.521 0 01.021.787 3.69 3.69 0 01-.475 1.691 1.633 1.633 0 01-1.054.833h-.158a1.287 1.287 0 01-1.045-.421 2.961 2.961 0 01-.715-1.498zm.575-.221a3.143 3.143 0 00.416 1.074c.25.391.537.554.854.487a.55.55 0 00.237-.108 1.766 1.766 0 00.562-.92 3.968 3.968 0 00.187-1.528 1.749 1.749 0 01-1.012-.1 2.115 2.115 0 01-1.045-.962 3.6 3.6 0 00-.2 2.057zm1.108-2.853a.349.349 0 00-.158.075.479.479 0 00-.1.479.788.788 0 00.037.121.97.97 0 00.616.554 1.249 1.249 0 00.658.079 3.339 3.339 0 00-.2-.554c-.246-.541-.529-.8-.85-.754z"
          fill="#263238"
          stroke="#263238"
          strokeWidth={0.4}
          transform="translate(-39.17 59.34)"
        />
        <path
          data-name="Path 6532"
          d="M467.86 40.32s10.694 18.657 13.1 17.695c3.107-1.249 7.912-21.655 7.912-21.655s-19.13 3.673-21.012 3.96z"
          transform="translate(-39.17 59.34) translate(-198.619 -20.249)"
          fill="#4ac9b4"
        />
        <g data-name="Group 90695">
          <path
            data-name="Path 6533"
            d="M467.86 40.32s10.694 18.657 13.1 17.695c3.107-1.249 7.912-21.655 7.912-21.655s-19.13 3.673-21.012 3.96z"
            transform="translate(-39.17 59.34) translate(269.241 16.111) translate(-467.86 -36.36)"
            fill="#fff"
            opacity={0.3}
          />
        </g>
        <path
          data-name="Path 6534"
          d="M283.459 27.862h0a.275.275 0 01-.187.354.292.292 0 01-.158 0 .345.345 0 01-.225-.25q0-.054-.558-2.915c-.183 1.312-.329 2.349-.416 3.107-.021.162-.033.25-.037.271a.329.329 0 01-.208.283h-.067a.329.329 0 01-.292-.167l-1.512-2.719q.3 1.628.491 3h0a.267.267 0 01-.187.35.246.246 0 01-.154 0 .329.329 0 01-.229-.246c0-.025-.233-1.3-.679-3.844-.112-.658-.175-1.012-.183-1.062a.444.444 0 010-.129.283.283 0 01.208-.212h.079a.221.221 0 01.217.1c.125.237.508.937 1.145 2.082l.887 1.62.621-4.448a.339.339 0 010-.083.329.329 0 01.208-.2.3.3 0 01.358.183 1.231 1.231 0 00.046.237c.515 2.782.795 4.339.832 4.688z"
          fill="#263238"
          stroke="#263238"
          strokeWidth={0.4}
          transform="translate(-39.17 59.34)"
        />
        <path
          data-name="Path 6535"
          d="M521.23 27.836s12.077 17.795 14.4 16.658c3-1.47 6.247-22.184 6.247-22.184s-18.79 5.097-20.647 5.526z"
          transform="translate(-39.17 59.34) translate(-229.763 -12.05)"
          fill="#38c5ae"
        />
        <path
          data-name="Path 6536"
          d="M301.536 18.743l2.136-.858a.519.519 0 01.129-.029.266.266 0 01.287.179.261.261 0 010 .112.35.35 0 01-.2.283l-1.92.766.487 1.911 1.4-.566a.445.445 0 01.162-.029.279.279 0 01.267.183.258.258 0 010 .1.341.341 0 01-.2.292l-1.478.6.479 1.774 1.895-.758a.391.391 0 01.15-.033.3.3 0 01.3.271.329.329 0 01-.2.3l-2.207.9a.3.3 0 01-.171 0 .341.341 0 01-.242-.225q0-.05-1.249-4.822a.3.3 0 010-.1.263.263 0 01.167-.242z"
          fill="#263238"
          stroke="#263238"
          strokeWidth={0.4}
          transform="translate(-39.17 59.34)"
        />
        <path
          data-name="Path 6537"
          d="M193.77 27.06s2.149 21.4 4.739 21.505c3.34.125 16.054-16.533 16.054-16.533s-18.956-4.468-20.793-4.972z"
          transform="translate(-39.17 59.34) translate(-38.672 -14.822)"
          fill="#38c5ae"
        />
        <path
          data-name="Path 6538"
          d="M161.582 19.742a.242.242 0 01.129.054.279.279 0 01.112.262c-.217.762-.383 1.362-.5 1.795-.3 1.054-.45 1.666-.475 1.8-.092.608 0 .933.321.983a1.762 1.762 0 00.775-.062 4.24 4.24 0 01.025-1.033 5.162 5.162 0 01.171-.775c.242-.766.629-1.108 1.158-1.029a.833.833 0 01.521.279.945.945 0 01.192.787 1.108 1.108 0 01-.05.25 3.153 3.153 0 01-.8 1.437 1.8 1.8 0 01-.479.4c0 .067.071.108.183.125a1.87 1.87 0 001.562-.633 6.026 6.026 0 001.183-1.712 1.762 1.762 0 01-.987-.491 1.249 1.249 0 01-.3-1.074 1 1 0 01.466-.7 1.062 1.062 0 01.725-.158 1.162 1.162 0 01.775.441 1.324 1.324 0 01.225 1.029 2.527 2.527 0 01-.092.446 1.1 1.1 0 00.162-.025 2.374 2.374 0 00.512-.167.683.683 0 01.354-.079.183.183 0 01.1.046.25.25 0 01.1.254c-.021.142-.162.262-.416.362a2.661 2.661 0 01-1.033.171 6.2 6.2 0 01-1.249 1.924 2.594 2.594 0 01-2.278.891h-.067a.833.833 0 01-.521-.362 2.4 2.4 0 01-1.129.1.8.8 0 01-.5-.271 1.72 1.72 0 01-.208-1.374 10.464 10.464 0 01.416-1.666c.212-.658.354-1.124.416-1.4-.258.117-.462.2-.612.267a1.441 1.441 0 01-.441.15.283.283 0 01-.246-.333.346.346 0 01.208-.242l.092-.042a6.138 6.138 0 011.512-.621zm.908 4.548a1.249 1.249 0 00.279-.225 2.207 2.207 0 00.625-1.249v-.067c0-.2-.058-.312-.229-.337s-.25.087-.371.3a3.144 3.144 0 00-.283.974 3.7 3.7 0 00-.024.604zm2.4-2.99a.591.591 0 00.033.321c.112.283.416.458.908.533a3.286 3.286 0 00.137-.525 1.062 1.062 0 000-.3.491.491 0 00-.416-.446.612.612 0 00-.337.033.479.479 0 00-.325.375z"
          fill="#263238"
          stroke="#263238"
          strokeWidth={0.4}
          transform="translate(-39.17 59.34)"
        />
        <path
          data-name="Path 6539"
          d="M332.216 3.467s-.171.075-.5.208l-1.478.587-2.407.954-1.537.6-1.766.641-4.168 1.516-5 1.666c-.9.312-1.828.591-2.794.887l-2.982.916c-.508.158-1.029.321-1.558.475l-1.607.454-3.332.937a274.535 274.535 0 01-32.678 6.742c-6.247.862-12.785 1.591-19.606 2.082s-13.9.712-21.151.683l-5.414-.067-5.33-.2-1.32-.05-1.316-.079-2.615-.162-2.594-.158-2.565-.217c-1.7-.158-3.394-.267-5.064-.458l-4.956-.546c-1.632-.187-3.244-.416-4.839-.637l-2.378-.325-2.34-.375c-6.218-.933-12.077-2.166-17.524-3.361-5.439-1.283-10.486-2.578-15.034-3.948l-3.332-1c-1.083-.316-2.12-.687-3.14-1.016-2.032-.67-3.96-1.278-5.726-1.941s-3.436-1.216-4.943-1.8L135.1 4.871c-.616-.246-1.2-.466-1.749-.7l-1.516-.645-2.386-1.02L128 1.881c-.329-.142-.5-.221-.5-.221s.171.062.5.2l1.47.608c.645.271 1.441.608 2.386 1l1.52.641c.546.225 1.133.441 1.753.683l4.119 1.591c1.512.575 3.173 1.141 4.947 1.782s3.7 1.249 5.73 1.924c1.02.325 2.057.691 3.144 1l3.332.991c4.552 1.378 9.616 2.649 15.029 3.927 5.46 1.187 11.3 2.411 17.516 3.332l2.34.375 2.378.321c1.595.208 3.2.45 4.835.637l4.952.541c1.666.187 3.361.3 5.06.454l2.565.217 2.59.158 2.615.158 1.312.079 1.32.05 5.33.2 5.414.067c7.246.029 14.322-.221 21.139-.679s13.368-1.224 19.573-2.082a276.37 276.37 0 0032.658-6.684l3.332-.933 1.666-.45 1.558-.466 2.982-.908c.966-.3 1.9-.575 2.794-.879l5-1.666 4.164-1.5 1.77-.633 1.541-.6 2.411-.929 1.487-.571z"
          fill="#455a64"
          transform="translate(-39.17 59.34)"
        />
        <g data-name="Yoga with face masks-bro">
          <g transform="translate(-9.405 -44.256) translate(230.821 177.005)">
            <path
              data-name="Path 6551"
              d="M11.815 71.035q2.971 7.172 5.926 14.373l74.074.025c-5.472-4.647-10.227-9.651-15.332-14.4z"
              fill="#0c8673"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6552"
              d="M40.091 28.525s-5.147.283-6.972 1.309-2.171 7.084-2.171 7.084L23.864 50.87S10.6 54.104 8.995 54.346s-2.7-.2-4.138.2-1.5.617-2.575 1.8-1.534 2.317-1.117 2.538 1.421-.675 1.725-1.013a10.519 10.519 0 011.167-.946s-.771 2.48-1.117 3.659c-.713 2.471-1.217-1.955-1.842-1.471-.813.625-.246 4.255 1.834 3.826s3.1-.379 3.938-1.471 2.638-3.771 2.638-3.771 7.422-.513 11.668-.971a17.97 17.97 0 009.418-3.788c1.25-1.213 5.488-10.218 5.488-10.218l3.88-10.264a4.9 4.9 0 00.129-3.931z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6553"
              d="M3.193 61.872a7.013 7.013 0 01-.721.542 3.852 3.852 0 01-1.209.333c-1.063.15-1.442.6-1.188.879s.721.229 1.7.229a3.726 3.726 0 002.038-.7 4.342 4.342 0 00.833-.746"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6554"
              d="M4.26 61.947a6.831 6.831 0 01-.646.629 2.525 2.525 0 01-1.154.488c-.538.071-1.354.775-1.063 1.021s.742.138 1.713 0a3.7 3.7 0 001.929-.954 4.258 4.258 0 00.721-.833"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6555"
              d="M468.781 319.14s-.892.2-1.509 1.6-.2 4.092-.6 4.267a1.767 1.767 0 01-1.25-.058c-.475-.133-1.25-.238-1.059.329.388 1.25 2.53.763 2.53.763s.325-.046 1.129-1.188 2.6-3.751 2.6-3.751"
              transform="translate(-461.367 -263.165)"
              fill="#fff"
            />
            <path
              data-name="Path 6556"
              d="M7.414 55.975s-.892.2-1.509 1.6-.2 4.092-.6 4.267a1.767 1.767 0 01-1.25-.058c-.475-.133-1.25-.238-1.059.329.388 1.25 2.53.763 2.53.763s.325-.046 1.129-1.188 2.6-3.751 2.6-3.751"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Line 358"
              transform="translate(34.144 37.33)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
              d="M1.5 4.851L0 0"
            />
            <path
              data-name="Path 6557"
              d="M53.827 28.525s5.147.283 6.972 1.309 2.171 7.084 2.171 7.084l7.084 13.952s13.265 3.234 14.869 3.476 2.7-.2 4.138.2 1.5.617 2.575 1.8 1.55 2.329 1.134 2.55-1.421-.675-1.725-1.013a10.5 10.5 0 00-1.167-.946s.771 2.48 1.113 3.659c.717 2.471 1.221-1.954 1.846-1.471.813.625.242 4.255-1.834 3.826s-3.1-.379-3.938-1.471-2.638-3.771-2.638-3.771-7.422-.513-11.668-.971-8.009-2.425-9.418-3.788c-1.25-1.213-5.488-10.218-5.488-10.218l-3.88-10.264a4.888 4.888 0 01-.146-3.943z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6558"
              d="M90.723 61.872a7 7 0 00.721.542 3.851 3.851 0 001.209.333c1.063.15 1.442.6 1.188.879s-.725.229-1.7.229a3.725 3.725 0 01-2.038-.7 4.2 4.2 0 01-.833-.746"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6559"
              d="M89.656 61.947a6.83 6.83 0 00.646.638 2.526 2.526 0 001.154.488c.538.071 1.354.775 1.063 1.021s-.742.138-1.713 0a3.7 3.7 0 01-1.93-.954 4.262 4.262 0 01-.721-.833"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6560"
              d="M662.206 319.14s.892.2 1.509 1.6.2 4.092.6 4.267a1.767 1.767 0 001.25-.058c.471-.133 1.25-.238 1.058.329-.388 1.25-2.53.763-2.53.763s-.325-.046-1.129-1.188-2.6-3.751-2.6-3.751"
              transform="translate(-575.7 -263.165)"
              fill="#fff"
            />
            <path
              data-name="Path 6561"
              d="M86.506 55.975s.892.2 1.509 1.6.2 4.092.6 4.267a1.767 1.767 0 001.25-.058c.471-.133 1.25-.238 1.058.329-.388 1.25-2.53.763-2.53.763s-.325-.046-1.129-1.188-2.6-3.751-2.6-3.751"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Line 359"
              transform="translate(58.273 37.33)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
              d="M0 4.851L1.496 0"
            />
            <path
              data-name="Path 6562"
              d="M44.77 21.582a12.1 12.1 0 01-1.325 4.447 6.721 6.721 0 01-3.355 2.5l-4.447 13.635 2.342 9.206a90.342 90.342 0 00-5.776 10.143c-1.638 3.821.329 8.151 2.046 9.943s4 4.238 9.831 4.013c8.1-.321 13.852.417 16.428-2.625s2.85-8.785-.229-13.119a66.44 66.44 0 01-4.417-8.335l2.534-9.493-3.9-13.394a5.77 5.77 0 01-3.751-1.85c-1.421-1.717-1.092-4.838-1.092-4.838z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6563"
              d="M566.432 240.231a6.357 6.357 0 002.5-.512 10 10 0 01-.195-2.876l-4.917-.233a14.333 14.333 0 01-.579 2.767 6.351 6.351 0 003.192.854z"
              transform="translate(-519.053 -215.028)"
              fill="#263238"
            />
            <path
              data-name="Path 6564"
              d="M58.385 41.893l-3.88-13.39a6.249 6.249 0 01-1.15-.192 10.878 10.878 0 01-.088 4.663 4.3 4.3 0 01-2.184 3.275 8.184 8.184 0 01-8.585-.546c-1.879-1.529-1.546-5.722-1.25-7.689a7.244 7.244 0 01-1.15.508l-4.454 13.644 2.342 9.206h17.865z"
              fill="#38c5ae"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6565"
              d="M41.22 14.219s-1.088-1.667-1.584-.2a4.049 4.049 0 001.188 3.859c.692.5.396-3.659.396-3.659z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6566"
              d="M53.288 14.219s1.092-1.667 1.584-.2a4.049 4.049 0 01-1.188 3.859c-.696.5-.396-3.659-.396-3.659z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6567"
              d="M47.379 23.445h0a6.276 6.276 0 01-6.276-6.284V7.53a2.338 2.338 0 012.338-2.338h7.872a2.338 2.338 0 012.338 2.338v9.631a6.272 6.272 0 01-6.272 6.284z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6568"
              d="M559.875 189.255s-4.872 5.447-8.164 7.276v2.013a10.656 10.656 0 01-2.63-5.63c-.367-3.3 7.134-9.331 10.977-7.868s-.183 4.209-.183 4.209z"
              transform="translate(-510.787 -184.821)"
              fill="#263238"
            />
            <path
              data-name="Path 6569"
              d="M571.333 191.736s2.475 4.947 5.442 7.422v1.879s3.067-4.651 3.167-6.43-6.734-4.767-8.61-5.163.001 2.292.001 2.292z"
              transform="translate(-523.288 -187.494)"
              fill="#263238"
            />
            <path
              data-name="Path 6570"
              d="M548.3 227.73s1.484 4.055-.4 5.538-3.263 1.188-4.355 5.342 3.959 4.947 3.959 7.618-2.967 3.267-2.967 3.267 0 2.475 3.859 2.275 6.726-3.563 6.134-7.918-3.563-5.247-3.363-6.926a41.94 41.94 0 01.888-4.355s-3.355-1.971-3.755-4.841z"
              transform="translate(-507.48 -209.848)"
              fill="#263238"
            />
            <path
              data-name="Path 6571"
              d="M53.572 14.44s-4.709-.754-5.938-.888-6.418 1.021-6.418 1.021l-.113.375v2.213a6.285 6.285 0 1012.569 0v-2.625z"
              fill="#38c5ae"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6572"
              d="M42.72 12.897a2.621 2.621 0 002.917 0"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6573"
              d="M49.213 12.897a2.63 2.63 0 002.917 0"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6574"
              d="M42.441 11.034s.763-1.313 3.109-1.109"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={2}
            />
            <path
              data-name="Path 6575"
              d="M48.729 9.926a2.917 2.917 0 013.592 1.108"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={2}
            />
            <path
              data-name="Path 6576"
              d="M32.21 61.53c-1.638 3.821.329 8.151 2.046 9.943s4 4.221 9.831 4c8.1-.321 13.852.417 16.428-2.625s2.85-8.785-.229-13.119a31.453 31.453 0 01-1.9-3.2H34.823a51.013 51.013 0 00-2.613 5.001z"
              fill="#263238"
              stroke="#202a30"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6577"
              d="M44.983 69.252c-4.109-4.259-11.56-6.388-15.211-7s-10.347-4.251-10.347-4.251-3.955-.133-3.651 4.584 11.714 10.193 16.128 12.627a14.248 14.248 0 0013.081.454"
              fill="#263238"
              stroke="#202a30"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6578"
              d="M47.55 69.423c4.109-4.259 11.56-6.388 15.215-7s9.331-3.721 9.331-3.721 4.967-.692 4.663 4.026-11.714 10.189-16.128 12.623a14.248 14.248 0 01-13.081.458"
              fill="#263238"
              stroke="#202a30"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6579"
              d="M64.507 73.265a1.126 1.126 0 00-.138-1.338c-.554-.8-1.754.371-2.738.692s-4.847 1.179-6.693 1.579c-1.575.342-4.021.358-4.747.479a5.871 5.871 0 01-.2 3.388c-.358.021.729-.029.363 0 3.209-.142 5.047-.175 6.038-.279 1.813-.2 4.167.625 6-.071s3.138-2.5 2.88-3.3a2.208 2.208 0 00-.767-1.146z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6580"
              d="M50.063 74.694h0z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6581"
              d="M49.975 74.711h0z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6582"
              d="M64.506 73.265a4.968 4.968 0 01-1.571.521"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6583"
              d="M65.253 74.398a14.17 14.17 0 01-2.084.688"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6584"
              d="M63.082 75.988a2.538 2.538 0 001.667-.258"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6585"
              d="M62.573 76.795a2.725 2.725 0 001.563-.25"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6586"
              d="M49.975 78.066a5.871 5.871 0 00.2-3.388l-.2.033a47.613 47.613 0 01-13.081-5.167c-6-3.663-13.619-9.3-17.469-11.543s-7.5 1.129-7.134 4.7 3.288 5.447 8.543 7.605 14.84 5.543 19.907 6.572c2.617.521 6.309 1.336 9.234 1.188z"
              fill="#263238"
              stroke="#202a30"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6587"
              d="M39.453 77.861a5.71 5.71 0 01-.254-3.392l.2.033a51.441 51.441 0 0013.535-5.192c6.234-3.659 16.127-9.168 20.124-11.431a4.884 4.884 0 017.405 4.7c-.392 3.571-3.413 5.447-8.868 7.605a180.548 180.548 0 01-22.658 6.455c-2.708.531-6.454 1.364-9.484 1.222z"
              fill="#263238"
              stroke="#202a30"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6588"
              d="M39.199 74.469s-7.005-.875-9.214-1.488-3.7-2.009-4.422-1.617-.125 1.375-.125 1.375a2.623 2.623 0 000 2.017c.492.8 1.2 1.567 3.68 2.859s5.384.8 6.922.729a24 24 0 003.413-.483 6.009 6.009 0 01-.254-3.392z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6589"
              d="M25.438 72.74a1.008 1.008 0 011.083.225 3.092 3.092 0 001.142.7"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6590"
              d="M25.23 74.203a1.055 1.055 0 01.971-.029 4.583 4.583 0 001.1.392"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6591"
              d="M26.168 75.632s.217-.35.471-.3 1.292.417 1.575.446"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6592"
              d="M27.514 76.678a1 1 0 01.583-.25 7.925 7.925 0 01.9.117"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
          </g>
          <g transform="translate(-9.405 -44.256) translate(69.074 171.42)">
            <path
              data-name="Path 6593"
              d="M16.567 76.62c-5.1 4.747-9.856 9.751-15.327 14.4l74.074-.025q2.955-7.214 5.922-14.373z"
              fill="#0c8673"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6594"
              d="M40.092 34.109s-5.151.283-6.976 1.309-2.167 7.084-2.167 7.084l-7.084 13.952S10.605 59.688 9 59.93s-2.7-.2-4.138.2-1.5.617-2.575 1.8-1.55 2.329-1.134 2.55 1.421-.675 1.725-1.013a10.584 10.584 0 011.163-.946s-.771 2.48-1.113 3.659c-.717 2.471-1.217-1.954-1.842-1.471-.833.625-.246 4.255 1.834 3.826s3.1-.379 3.938-1.471 2.634-3.771 2.634-3.771 7.426-.513 11.668-.971 8.01-2.425 9.422-3.788c1.25-1.213 5.488-10.218 5.488-10.218l3.9-10.277a4.924 4.924 0 00.122-3.93z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6595"
              d="M3.194 67.456a7.006 7.006 0 01-.721.542 3.889 3.889 0 01-1.209.333c-1.063.15-1.446.6-1.188.879s.721.229 1.7.229a3.726 3.726 0 002.038-.7 4.263 4.263 0 00.833-.746"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6596"
              d="M4.261 67.531a7.415 7.415 0 01-.646.638 2.525 2.525 0 01-1.146.479c-.533.071-1.354.775-1.063 1.021s.746.138 1.717 0a3.7 3.7 0 001.929-.954 4.258 4.258 0 00.721-.833"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6597"
              d="M80.641 319.14s-.9.2-1.509 1.6-.2 4.092-.6 4.267a1.767 1.767 0 01-1.25-.058c-.475-.133-1.25-.238-1.058.329.388 1.25 2.53.763 2.53.763s.325-.046 1.129-1.188 2.6-3.751 2.6-3.751"
              transform="translate(-73.229 -257.581)"
              fill="#fff"
            />
            <path
              data-name="Path 6598"
              d="M7.412 61.559s-.9.2-1.509 1.6-.2 4.092-.6 4.267a1.767 1.767 0 01-1.25-.058c-.475-.133-1.25-.238-1.058.329.388 1.25 2.53.763 2.53.763s.325-.046 1.129-1.188 2.6-3.751 2.6-3.751"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Line 360"
              transform="translate(34.145 42.915)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
              d="M1.5 4.851L0 0"
            />
            <path
              data-name="Path 6599"
              d="M53.828 34.109s5.147.283 6.972 1.309 2.167 7.084 2.167 7.084l7.084 13.952s13.265 3.234 14.869 3.476 2.7-.2 4.138.2 1.5.617 2.575 1.8 1.546 2.329 1.134 2.55-1.421-.675-1.729-1.013a10.193 10.193 0 00-1.163-.946s.771 2.48 1.113 3.659c.717 2.471 1.217-1.954 1.846-1.471.833.625.242 4.255-1.834 3.826s-3.1-.371-3.934-1.484-2.638-3.771-2.638-3.771-7.422-.513-11.668-.971-8.01-2.425-9.418-3.788c-1.25-1.213-5.492-10.218-5.492-10.218l-3.876-10.264a4.836 4.836 0 01-.146-3.93z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6600"
              d="M90.721 67.456a7.51 7.51 0 00.721.542 3.884 3.884 0 001.213.333c1.063.15 1.442.6 1.184.879s-.721.229-1.7.229a3.709 3.709 0 01-2.034-.7 4.2 4.2 0 01-.833-.746"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6601"
              d="M89.658 67.531a7.187 7.187 0 00.642.629 2.567 2.567 0 001.159.488c.538.071 1.354.775 1.063 1.021s-.746.138-1.717 0a3.663 3.663 0 01-1.925-.954 4.259 4.259 0 01-.721-.833"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6602"
              d="M274.076 319.14s.892.2 1.509 1.6.2 4.092.592 4.267a1.767 1.767 0 001.25-.058c.475-.133 1.25-.238 1.063.329-.388 1.25-2.534.763-2.534.763s-.321-.046-1.125-1.188-2.6-3.751-2.6-3.751"
              transform="translate(-187.568 -257.581)"
              fill="#fff"
            />
            <path
              data-name="Path 6603"
              d="M86.508 61.559s.892.2 1.509 1.6.2 4.092.592 4.267a1.767 1.767 0 001.25-.058c.475-.133 1.25-.238 1.063.329-.388 1.25-2.534.763-2.534.763s-.321-.046-1.125-1.188-2.6-3.751-2.6-3.751"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Line 361"
              transform="translate(58.274 42.915)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
              d="M0 4.851L1.496 0"
            />
            <path
              data-name="Path 6604"
              d="M44.772 27.167a12.1 12.1 0 01-1.325 4.447 6.722 6.722 0 01-3.355 2.5l-4.447 13.635 2.338 9.206a90.564 90.564 0 00-5.772 10.143c-1.638 3.821.329 8.151 2.046 9.943s3.992 4.221 9.814 4c8.1-.321 13.852.417 16.428-2.625s2.85-8.785-.229-13.119a66.439 66.439 0 01-4.417-8.335l2.534-9.493-3.871-13.39a5.769 5.769 0 01-3.751-1.85c-1.421-1.717-1.092-4.838-1.092-4.838z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6605"
              d="M178.3 240.231a6.358 6.358 0 002.5-.512 10 10 0 01-.2-2.876l-4.917-.233a14.167 14.167 0 01-.583 2.767 6.38 6.38 0 003.2.854z"
              transform="translate(-130.916 -209.443)"
              fill="#263238"
            />
            <ellipse
              data-name="Ellipse 129080"
              cx={4.188}
              cy={3.701}
              rx={4.188}
              ry={3.701}
              transform="translate(44.443)"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6606"
              d="M40.963 19.47s-1.429-1.171-1.429 1.038a3.592 3.592 0 001.688 3.117z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6607"
              d="M53.556 19.47s1.429-1.171 1.429 1.038a3.592 3.592 0 01-1.688 3.117z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6608"
              d="M48.252 6.422s-5.984-.438-7.943 1.85.8 12.26.8 12.26h12.8s1.525-6.28 1.525-9.322-.981-4.68-7.182-4.788z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6609"
              d="M47.381 29.029h0a6.276 6.276 0 01-6.276-6.284v-9.631c0-1.292 1.25-1.579 3.334-2.667l1.521-.871 5.351 1.2c1.613.417 2.338 1.046 2.338 2.338v9.631a6.272 6.272 0 01-6.268 6.284z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6610"
              d="M53.574 20.024s-4.709-.754-5.938-.888-6.418 1.021-6.418 1.021l-.113.375v2.213a6.276 6.276 0 1012.548 0V20.12z"
              fill="#38c5ae"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6611"
              d="M42.718 18.482a2.63 2.63 0 002.917 0"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6612"
              d="M49.214 18.482a2.621 2.621 0 002.917 0"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6613"
              d="M42.443 16.619s.758-1.313 3.109-1.109"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={2}
            />
            <path
              data-name="Path 6614"
              d="M48.727 15.511a2.917 2.917 0 013.592 1.108"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={2}
            />
            <path
              data-name="Path 6615"
              d="M32.212 67.115c-1.638 3.821.329 8.151 2.046 9.943s3.992 4.221 9.814 4c8.1-.321 13.852.417 16.428-2.625s2.85-8.785-.229-13.119a31.453 31.453 0 01-1.9-3.2H34.825a50.127 50.127 0 00-2.613 5z"
              fill="#263238"
              stroke="#20292d"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6616"
              d="M40.093 34.109s1.959 3.58 7.172 3.58c5.367 0 6.563-3.576 6.563-3.58.167-.5 3.871-.108 4.409-.025 1.279.2 3.23.471 4.013 1.667.521.779 2.6 5.209 2.6 5.209l-6.468 6.534s-1.742 7.8-1.613 8.972 4.038 9.368 4.038 9.368H32.671l4.167-9.385-.754-8.143-7.064-6.188s1.434-5.472 2.609-6.251 6.263-2.466 8.464-1.758z"
              fill="#38c5ae"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6617"
              d="M39.392 52.504c.521-1.284 1.142-2.98 1.829-5.159"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6618"
              d="M37.746 55.942a16.877 16.877 0 001.171-2.313"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6619"
              d="M51.836 47.891s2.013 5.488 3.476 7.5"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Line 362"
              transform="translate(34.45 39.656)"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
              d="M0.271 1.417L0 0"
            />
            <path
              data-name="Line 363"
              transform="translate(34.987 42.507)"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
              d="M1.096 5.801L0 0"
            />
            <path
              data-name="Line 364"
              transform="translate(58.387 39.656)"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
              d="M0 7.822L1.317 0"
            />
            <path
              data-name="Path 6620"
              d="M56.186 60.13c.246.388.5.763.771 1.117"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6621"
              d="M52.565 52.1a38.224 38.224 0 003.109 7.189"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6622"
              d="M42.139 47.161s-1.467 4.755-2.013 6.218"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6623"
              d="M44.976 74.836c-4.109-4.259-11.564-6.388-15.215-7s-10.335-4.251-10.335-4.251-3.955-.133-3.651 4.584 11.714 10.193 16.123 12.627a14.256 14.256 0 0013.085.454"
              fill="#263238"
              stroke="#20292d"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6624"
              d="M47.552 75.007c4.109-4.259 11.56-6.388 15.211-7s9.335-3.721 9.335-3.721 4.967-.7 4.663 4.026-11.714 10.189-16.127 12.623a14.248 14.248 0 01-13.081.458"
              fill="#263238"
              stroke="#20292d"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6625"
              d="M64.484 78.85a1.126 1.126 0 00-.138-1.338c-.554-.8-1.754.371-2.738.692s-4.847 1.179-6.693 1.579c-1.575.342-4.021.358-4.747.479a5.909 5.909 0 01-.2 3.388c-.354.021.733-.029.367 0 3.209-.142 5.047-.175 6.038-.279 1.813-.2 4.167.625 6-.071s3.138-2.5 2.875-3.3a2.192 2.192 0 00-.764-1.15z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6626"
              d="M50.065 80.279h0z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6627"
              d="M49.977 80.296h0z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6628"
              d="M64.488 78.85a4.968 4.968 0 01-1.571.521"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6629"
              d="M65.251 79.983a14.033 14.033 0 01-2.084.688"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6630"
              d="M63.083 81.572a2.538 2.538 0 001.688-.258"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6631"
              d="M62.575 82.379a2.713 2.713 0 001.559-.25"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6632"
              d="M49.977 83.65a5.909 5.909 0 00.2-3.388l-.2.033a47.665 47.665 0 01-13.085-5.167c-6-3.663-13.619-9.3-17.469-11.543s-7.5 1.129-7.134 4.7 3.284 5.447 8.543 7.605 14.84 5.543 19.907 6.572c2.619.521 6.319 1.336 9.238 1.188z"
              fill="#263238"
              stroke="#20292d"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6633"
              d="M39.455 83.446a5.709 5.709 0 01-.254-3.392l.2.033a51.5 51.5 0 0013.535-5.192c6.238-3.659 16.127-9.168 20.124-11.431a4.884 4.884 0 017.405 4.7c-.392 3.571-3.413 5.447-8.868 7.605a180.548 180.548 0 01-22.658 6.455c-2.712.531-6.463 1.364-9.484 1.222z"
              fill="#263238"
              stroke="#20292d"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6634"
              d="M39.2 80.054s-7.005-.875-9.226-1.467-3.692-2.009-4.417-1.617-.125 1.375-.125 1.375a2.623 2.623 0 000 2.017c.492.8 1.2 1.567 3.676 2.859s5.393.8 6.939.729a24.006 24.006 0 003.413-.483 6.085 6.085 0 01-.26-3.413z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6635"
              d="M25.44 78.324a1.008 1.008 0 011.084.225 3.092 3.092 0 001.142.7"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6636"
              d="M25.227 79.787a1.063 1.063 0 01.975-.029 4.584 4.584 0 001.1.392"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6637"
              d="M26.165 81.216s.217-.35.471-.3 1.292.417 1.575.446"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6638"
              d="M27.515 82.263a1 1 0 01.583-.25 8.015 8.015 0 01.9.117"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
          </g>
          <g transform="translate(-9.405 -44.256) translate(138.699 185.83)">
            <path
              data-name="Path 6639"
              d="M11.382 85.63c-2.338 6.73-4.742 13.485-7.418 20.291l107.6-.021q-3.638-10.152-7.293-20.27z"
              fill="#0c8673"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6640"
              d="M50.008 37.773s-6.422.35-8.7 1.629-2.7 8.822-2.7 8.822l-8.835 17.4s-16.544 4.034-18.544 4.338-3.371-.246-5.163.246-1.875.771-3.213 2.25-1.929 2.917-1.413 3.184 1.771-.833 2.155-1.25a12.772 12.772 0 011.45-1.184s-.958 3.092-1.388 4.584c-.892 3.084-1.517-2.434-2.3-1.834-1.017.783-.3 5.309 2.288 4.776s3.871-.475 4.913-1.838 3.288-4.722 3.288-4.722 9.26-.642 14.586-1.213 10-3.026 11.752-4.726c1.563-1.513 6.847-12.744 6.847-12.744l4.838-12.81s1.293-2.674.139-4.908z"
              fill="#787878"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6641"
              d="M3.985 79.366a8.787 8.787 0 01-.9.675 4.728 4.728 0 01-1.509.417c-1.325.188-1.8.742-1.479 1.1s.9.288 2.121.288a4.663 4.663 0 002.538-.867 5.417 5.417 0 001.029-.933"
              fill="#787878"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6642"
              d="M5.315 79.458a8.632 8.632 0 01-.8.788 3.167 3.167 0 01-1.446.6c-.667.087-1.688.963-1.325 1.275s.929.171 2.142 0a4.638 4.638 0 002.4-1.188 5.369 5.369 0 00.9-1.059"
              fill="#787878"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6643"
              d="M250.579 378.79s-1.117.254-1.884 2-.246 5.1-.742 5.326a2.21 2.21 0 01-1.559-.075c-.592-.163-1.542-.3-1.321.417.483 1.55 3.155.95 3.155.95s.417-.058 1.409-1.475 3.242-4.684 3.242-4.684"
              transform="translate(-241.335 -306.783)"
              fill="#787878"
            />
            <path
              data-name="Path 6644"
              d="M9.244 72.007s-1.117.254-1.884 2-.246 5.1-.742 5.326a2.21 2.21 0 01-1.559-.075c-.592-.163-1.542-.3-1.321.417.483 1.55 3.155.95 3.155.95s.417-.058 1.409-1.475 3.242-4.684 3.242-4.684"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Line 365"
              transform="translate(42.591 48.753)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
              d="M1.867 6.051L0 0"
            />
            <path
              data-name="Path 6645"
              d="M67.141 37.773s6.422.35 8.7 1.629 2.7 8.822 2.7 8.822l8.835 17.4s16.544 4.034 18.544 4.338 3.376-.246 5.163.246 1.879.771 3.213 2.25 1.934 2.917 1.413 3.184-1.771-.833-2.155-1.25a12.393 12.393 0 00-1.45-1.183s.963 3.092 1.388 4.584c.9 3.084 1.521-2.434 2.3-1.834 1.017.783.3 5.309-2.288 4.776s-3.871-.475-4.909-1.838-3.292-4.7-3.292-4.7-9.256-.642-14.586-1.213-10-3.025-11.752-4.726c-1.563-1.513-6.847-12.744-6.847-12.744L67.296 42.67s-1.314-2.663-.155-4.897z"
              fill="#787878"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6646"
              d="M113.164 79.366a8.592 8.592 0 00.9.675 4.788 4.788 0 001.513.417c1.325.188 1.8.742 1.479 1.1s-.9.288-2.121.288a4.68 4.68 0 01-2.542-.867 5.485 5.485 0 01-1.025-.934"
              fill="#787878"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6647"
              d="M111.83 79.458a8.836 8.836 0 00.808.788 3.146 3.146 0 001.442.6c.671.088 1.692.963 1.325 1.275s-.929.171-2.142 0a4.655 4.655 0 01-2.4-1.188 5.368 5.368 0 01-.9-1.059"
              fill="#787878"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6648"
              d="M491.85 378.79s1.117.254 1.884 2 .246 5.1.742 5.326a2.21 2.21 0 001.559-.075c.592-.163 1.542-.3 1.325.417-.483 1.55-3.159.95-3.159.95s-.417-.058-1.4-1.475l-3.246-4.684"
              transform="translate(-383.95 -306.783)"
              fill="#787878"
            />
            <path
              data-name="Path 6649"
              d="M107.9 72.007s1.117.254 1.884 2 .246 5.1.742 5.326a2.21 2.21 0 001.559-.075c.592-.163 1.542-.3 1.325.417-.483 1.55-3.159.95-3.159.95s-.417-.058-1.4-1.475l-3.246-4.684"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Line 366"
              transform="translate(72.687 48.753)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
              d="M0 6.051L1.867 0"
            />
            <path
              data-name="Path 6650"
              d="M367.889 229.113c.146.417-.663 1.134-.579 1.567s1.109.667 1.154 1.108-.921 1.071-.942 1.525.929.833.858 1.284-1.175.971-1.313 1.429.7.971.5 1.434-1.4.833-1.667 1.275.417 1.084.1 1.529-1.592.642-1.971 1.063.092 1.154-.342 1.563-1.725.417-2.217.788-.25 1.184-.8 1.529-1.788.163-2.375.463-.608 1.15-1.25 1.417-1.779-.108-2.442.1-.946 1.054-1.667 1.221-1.667-.379-2.4-.271-1.25.9-1.992.95-1.513-.629-2.242-.629-1.517.688-2.242.629-1.292-.833-1.992-.95-1.7.417-2.4.271-.988-1.008-1.667-1.221-1.809.163-2.442-.1-.654-1.117-1.25-1.417-1.834-.113-2.375-.463-.308-1.159-.8-1.529-1.775-.379-2.213-.788.037-1.142-.342-1.567-1.667-.608-1.971-1.059.358-1.075.1-1.529-1.467-.808-1.667-1.275.642-.963.5-1.434-1.25-.958-1.313-1.429.883-.833.858-1.284-.988-1.071-.942-1.525 1.067-.667 1.154-1.109-.725-1.138-.579-1.567 1.2-.513 1.379-.921-.467-1.179-.238-1.563 1.279-.354 1.538-.729-.217-1.184.083-1.529 1.309-.2 1.629-.529 0-1.167.367-1.471 1.3-.05 1.667-.342.208-1.133.6-1.392 1.25.083 1.667-.163.379-1.088.8-1.3 1.213.217 1.638 0 .525-1.033.954-1.2 1.142.338 1.584.188.642-.967 1.083-1.088 1.063.458 1.513.354.746-.888 1.188-.963.988.575 1.442.525.833-.8 1.279-.833.9.679 1.363.679.925-.7 1.363-.679.833.775 1.279.833 1-.6 1.442-.525.742.863 1.188.963 1.079-.479 1.513-.354.646.938 1.084 1.088 1.159-.358 1.584-.188.529 1.008.954 1.2 1.225-.229 1.638 0 .4 1.063.8 1.309 1.284-.1 1.667.158.233 1.1.6 1.392 1.321.042 1.667.342.046 1.142.367 1.471 1.334.188 1.629.529-.171 1.159.083 1.534 1.3.338 1.538.725-.417 1.15-.238 1.563 1.331.496 1.476.917z"
              transform="translate(-287.48 -211.919)"
              fill="#263238"
            />
            <path
              data-name="Path 6651"
              d="M55.846 29.113a14.976 14.976 0 01-1.667 5.547 8.379 8.379 0 01-4.167 3.113l-5.551 17.032 2.917 11.485s-5.159 7.889-7.2 12.648.417 10.168 2.555 12.406 4.98 5.267 12.239 5c10.1-.417 17.278.521 20.491-3.276s3.559-10.956-.283-16.365c-2.338-3.288-5.513-10.4-5.513-10.4l3.163-11.839L68 37.757a7.118 7.118 0 01-4.659-2.3c-1.742-2.138-1.363-6.034-1.363-6.034z"
              fill="#787878"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6652"
              d="M372.43 280.377a7.967 7.967 0 003.125-.642 12.477 12.477 0 01-.246-3.584l-6.13-.292a17.5 17.5 0 01-.729 3.446 7.959 7.959 0 003.98 1.071z"
              transform="translate(-313.316 -246.747)"
              fill="#263238"
            />
            <path
              data-name="Path 6653"
              d="M72.828 54.45l-4.83-16.707a7.529 7.529 0 01-1.434-.238 13.57 13.57 0 01-.113 5.813 5.355 5.355 0 01-2.725 4.088c-2.625 1.559-7.589 1.85-10.7-.679-2.35-1.909-1.934-7.139-1.584-9.585a8.67 8.67 0 01-1.434.638l-5.55 17.033 2.917 11.485h22.287z"
              fill="#38c5ae"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6654"
              d="M66.724 20.42h2.3a10.182 10.182 0 01-1.25 3.751c-.867 1.063-1.15 1.059-1.15 1.059z"
              fill="#787878"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6655"
              d="M51.467 20.42h-2.3a10.182 10.182 0 001.25 3.751c.867 1.063 1.15 1.059 1.15 1.059z"
              fill="#787878"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6656"
              d="M59.114 31.434h0a7.826 7.826 0 01-7.826-7.826V11.581a2.917 2.917 0 012.917-2.917h9.818a2.917 2.917 0 012.917 2.917v12.027a7.826 7.826 0 01-7.826 7.826z"
              fill="#787878"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6657"
              d="M66.823 20.2s-5.876-.938-7.409-1.108-8.005 1.279-8.005 1.279l-.138.467v2.771a7.826 7.826 0 1015.652 0V20.32z"
              fill="#38c5ae"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6658"
              d="M53.28 18.278a3.272 3.272 0 003.621 0"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6659"
              d="M61.385 18.278a3.276 3.276 0 003.621 0"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6660"
              d="M52.938 15.953s.95-1.638 3.88-1.379"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={2}
            />
            <path
              data-name="Path 6661"
              d="M60.781 14.584a3.663 3.663 0 014.484 1.379"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={2}
            />
            <path
              data-name="Path 6662"
              d="M40.177 78.938c-2.042 4.772.417 10.168 2.555 12.406s4.98 5.267 12.239 5c10.1-.417 17.278.521 20.491-3.276s3.559-10.956-.283-16.365a38.563 38.563 0 01-2.375-3.984H43.436a62.907 62.907 0 00-3.259 6.218z"
              fill="#263238"
              stroke="#1f2a2e"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6663"
              d="M56.109 88.589c-5.126-5.313-14.423-7.968-18.974-8.726s-12.919-5.338-12.919-5.338-4.93-.167-4.551 5.717 14.611 12.71 20.111 15.748a17.774 17.774 0 0016.319.567"
              fill="#263238"
              stroke="#1f2a2e"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6664"
              d="M59.314 88.785c5.122-5.313 14.419-7.972 18.974-8.73s11.639-4.626 11.639-4.626 6.2-.858 5.834 5.022S81.15 93.165 75.645 96.199a17.765 17.765 0 01-16.315.571"
              fill="#263238"
              stroke="#1f2a2e"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6665"
              d="M80.438 93.577a1.392 1.392 0 00-.171-1.667c-.7-1-2.188.467-3.417.863s-6.047 1.471-8.335 1.975c-1.967.417-5 .446-5.922.6a7.368 7.368 0 01-.246 4.23l.454-.021c4-.179 6.293-.217 7.53-.346 2.263-.242 5.18.779 7.5-.092s3.913-3.117 3.588-4.121a2.784 2.784 0 00-.983-1.417z"
              fill="#787878"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6666"
              d="M62.448 95.36l.125-.021z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6667"
              d="M62.335 95.381h0z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6668"
              d="M80.438 93.577a6.251 6.251 0 01-1.959.65"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6669"
              d="M81.393 94.99a17.562 17.562 0 01-2.588.858"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6670"
              d="M78.7 96.973a3.167 3.167 0 002.084-.325"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6671"
              d="M78.05 97.982a3.43 3.43 0 001.946-.313"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6672"
              d="M62.335 99.569a7.368 7.368 0 00.246-4.23l-.246.042a59.691 59.691 0 01-16.319-6.447c-7.5-4.567-16.982-11.6-21.787-14.406s-9.368 1.4-8.9 5.855 4.1 6.793 10.66 9.489 18.507 6.909 24.833 8.2c3.258.664 7.875 1.672 11.513 1.497z"
              fill="#263238"
              stroke="#1f2a2e"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6673"
              d="M49.212 99.311a7.159 7.159 0 01-.321-4.23l.258.038a64 64 0 0016.882-6.476c7.776-4.567 20.12-11.448 25.1-14.261a6.1 6.1 0 019.239 5.859c-.488 4.451-4.255 6.793-11.06 9.485s-21.7 6.764-28.263 8.051c-3.379.667-8.055 1.697-11.835 1.534z"
              fill="#263238"
              stroke="#1f2a2e"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6674"
              d="M48.891 95.081s-8.751-1.092-11.493-1.859-4.609-2.5-5.513-2.013-.154 1.713-.154 1.713a3.222 3.222 0 000 2.5c.617.983 1.5 1.959 4.584 3.567s6.714 1.025 8.631.921a29.367 29.367 0 004.255-.6 7.612 7.612 0 01-.31-4.229z"
              fill="#787878"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6675"
              d="M31.731 92.931a1.25 1.25 0 011.35.279 3.871 3.871 0 001.425.875"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6676"
              d="M31.468 94.748a1.325 1.325 0 011.213-.037 5.856 5.856 0 001.375.488"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6677"
              d="M32.635 96.527s.271-.417.588-.371 1.613.508 1.963.554"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6678"
              d="M34.323 97.836a1.25 1.25 0 01.725-.312 10.343 10.343 0 011.117.142"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 6679"
              d="M351.609 219.677c.479.1.338.658.95.55.275-.046.471-.808.833-.879.292-.054.754.583 1.1.508s.467-.833.8-.913.792.55 1.121.467.446-.833.767-.938.833.517 1.138.417.417-.871.729-.967.833.483 1.154.375.379-.883.692-1 .863.442 1.167.325.342-.9.642-1.033.888.417 1.188.263.288-.921.579-1.067.913.342 1.2.188.225-.938.5-1.1.938.275 1.213.1.146-.95.417-1.142 1.021.121 1.275-.083c.1-.138-.65-.3-.671-.525 0-.1.688-.292.671-.417s-.738-.125-.754-.25.675-.333.654-.45-.742-.1-.763-.221.658-.363.633-.479-.746-.071-.775-.187.642-.4.613-.508-.75-.033-.783-.15.617-.417.583-.542-.75 0-.792-.1.588-.471.546-.579-.746.063-.8-.042.546-.521.5-.625-.738.133-.8.033.488-.579.417-.675-.713.229-.783.138.4-.646.317-.729-.658.346-.746.271c-.192-.167-.112-.921-.467-1.054-.267-.1-.779.492-1.117.417s-.467-.833-.8-.875-.7.629-1.025.6-.571-.763-.9-.775-.642.692-.963.692-.638-.713-.958-.7-.592.742-.913.767-.692-.663-1.009-.629-.538.783-.833.833-.742-.608-1.054-.55-.475.833-.779.9-.8-.538-1.1-.45-.392.863-.688.967-.858-.446-1.146-.325-.279.9-.554 1.05-.917-.313-1.179-.146-.113.938-.354 1.134-.967-.108-1.179.121c-.142.15.271.763.154.921s-.833-.071-.929.1.438.679.363.863-.833.133-.879.321.6.546.571.742-.763.338-.767.533.713.388.729.588-.667.492-.633.688.779.238.833.417-.567.6-.5.788.808.117.888.3-.483.671-.417.833.833.025.917.2-.417.721-.3.883.833-.054.929.108-.338.754-.221.908.833-.113.934.029-.267.792-.154.921c.259.279.472-.217.768-.154z"
              transform="translate(-301.3 -206)"
              fill="#263238"
            />
          </g>
        </g>
        <circle
          data-name="Ellipse 129732"
          cx={18}
          cy={18}
          r={18}
          transform="translate(348 259)"
          fill="rgba(90,197,179,0.1)"
        />
      </g>
    </SvgIcon>
  );
}

export function PlanSummaryBackgroundImage(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 320,
    height: 241,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 347 241"
      {...rest}
      sx={rootSx}
    >
      <g
        id="Group_102586"
        data-name="Group 102586"
        transform="translate(-37 -54)"
      >
        <circle
          id="Ellipse_39441"
          data-name="Ellipse 39441"
          cx="18"
          cy="18"
          r="18"
          transform="translate(348 259)"
          fill="#e4e2f9"
        />
        <g
          id="Customized_plan_ready"
          data-name="Customized plan ready"
          transform="translate(37 51)"
        >
          <path
            id="Path_5251"
            data-name="Path 5251"
            d="M174.9,157.5a3,3,0,0,1,5.2,0l16.888,29.25a3,3,0,0,1-2.6,4.5H160.613a3,3,0,0,1-2.6-4.5Z"
            fill="rgba(94,90,197,0.1)"
          />
          <path
            id="Path_5252"
            data-name="Path 5252"
            d="M174.9,157.5a3,3,0,0,1,5.2,0l16.888,29.25a3,3,0,0,1-2.6,4.5H160.613a3,3,0,0,1-2.6-4.5Z"
            fill="rgba(94,90,197,0.1)"
          />
          <path
            id="Path_5253"
            data-name="Path 5253"
            d="M243.9,4.5a3,3,0,0,1,5.2,0l21.218,36.75a3,3,0,0,1-2.6,4.5H225.282a3,3,0,0,1-2.6-4.5Z"
            fill="rgba(94,90,197,0.1)"
          />
          <circle
            id="Ellipse_39458"
            data-name="Ellipse 39458"
            cx="30"
            cy="30"
            r="30"
            transform="translate(0 120)"
            fill="rgba(94,90,197,0.1)"
          />
          <circle
            id="Ellipse_39459"
            data-name="Ellipse 39459"
            cx="19"
            cy="19"
            r="19"
            transform="translate(43 14)"
            fill="rgba(94,90,197,0.1)"
          />
          <g id="Group_5481" data-name="Group 5481" opacity="0.3">
            <path
              id="Path_5254"
              data-name="Path 5254"
              d="M301,185.508H238.566V72.427A30.427,30.427,0,0,1,268.993,42a31.993,31.993,0,0,1,31.994,31.994V185.508Z"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5255"
              data-name="Path 5255"
              d="M293.94,185.172V74.244a24.169,24.169,0,0,0-24.169-24.169h0a24.169,24.169,0,0,0-24.156,24.169V185.19"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5256"
              data-name="Path 5256"
              d="M269.784,42V185.34"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5257"
              data-name="Path 5257"
              d="M300.665,69.612H238.983"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5258"
              data-name="Path 5258"
              d="M300.665,89.081H238.983"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5259"
              data-name="Path 5259"
              d="M300.665,108.549H238.983"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5260"
              data-name="Path 5260"
              d="M300.665,128.023H238.983"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5261"
              data-name="Path 5261"
              d="M300.665,147.493H238.983"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5262"
              data-name="Path 5262"
              d="M300.665,166.962H238.983"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5263"
              data-name="Path 5263"
              d="M292.418,51.741l-5.591,5.1"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5264"
              data-name="Path 5264"
              d="M247.381,51.741l5.6,5.1"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
          </g>
          <g id="Group_5482" data-name="Group 5482" opacity="0.3">
            <path
              id="Path_5265"
              data-name="Path 5265"
              d="M71.685,185.508H9.25V72.427A30.427,30.427,0,0,1,39.677,42,31.994,31.994,0,0,1,71.671,73.994V185.508Z"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5266"
              data-name="Path 5266"
              d="M64.633,185.172V74.244A24.17,24.17,0,0,0,40.464,50.057h0A24.169,24.169,0,0,0,16.276,74.244V185.19"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5267"
              data-name="Path 5267"
              d="M40.464,42V185.34"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5268"
              data-name="Path 5268"
              d="M71.349,69.612H9.663"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5269"
              data-name="Path 5269"
              d="M71.349,89.081H9.663"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5270"
              data-name="Path 5270"
              d="M71.349,108.549H9.663"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5271"
              data-name="Path 5271"
              d="M71.349,128.023H9.663"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5272"
              data-name="Path 5272"
              d="M71.349,147.493H9.663"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5273"
              data-name="Path 5273"
              d="M71.349,166.962H9.663"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5274"
              data-name="Path 5274"
              d="M63.1,51.741l-5.595,5.1"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_5275"
              data-name="Path 5275"
              d="M18.065,51.741l5.59,5.1"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
          </g>
          <path
            id="Path_5276"
            data-name="Path 5276"
            d="M147.417,100.257c.288-4.153,2.853-11.793,4.2-15.782A75.82,75.82,0,0,0,155.2,69.582c.67-5.39-.05-24.192.193-27.068,1.325-15.706,9.7-20.821,14.706-21.994,2.133-2.077,4.617-3.751,10.366-3.754,13.11.119,26.312,15.062,32.27,26.3,5.471,10.313,3.425,26.314,3.117,30.2-.284,3.568,1.744,11.593,2.959,14.576S165.14,116.839,147.417,100.257Z"
          />
          <path
            id="Path_5277"
            data-name="Path 5277"
            d="M164.9,36.239c-2.467,9.96-1.92,16.825,1.488,25.573-2.185.954-4.226,1.151-2.516,5.085,1,2.306,5.384,5.825,9.1,3.245,4.006,4.295,4.077,4.928,7.718,6.121a89.068,89.068,0,0,1,.268,10.8c-.122,1.193.1,4.471-6.459,6.141,1.093,4.414,3.764,17.059,7.648,21.233s5.22,3.936,9.954.477,13.475-14.792,17-20.995,2.549-7.515,2.549-7.515a23.31,23.31,0,0,1-5.706-.477c-1.82-.6-2.427-2.147-2.549-4.772s.438-11.834.438-11.834a29.885,29.885,0,0,0,1.457-5.081c.1-1.431-.086-3.339-.769-7.752,1.821-1.312,3.118-.987,3.794-5.759-4.431-2.344-7.094-4.413-9.215-7.219-3.079-.5-6.665-.3-10.8-3.38-4.977-3.706-7.622-8.962-13.985-10.155C166.546,28.516,164.9,36.239,164.9,36.239Z"
            fill="#fff"
          />
          <path
            id="Path_5278"
            data-name="Path 5278"
            d="M183.129,66.412a41.153,41.153,0,0,0,11.422-4.978c.656,3.183.735,6.715-2.61,8.416C188.218,71.743,185.216,69.264,183.129,66.412Z"
            fill="#fff"
          />
          <path
            id="Path_5279"
            data-name="Path 5279"
            d="M220.348,192.1s2.6-13.6,2.6-17.981c4.636-1.012,6.491-2.193,7.692-3.205s3.434-7.592,6.181-20.75,7.725-43.188,7.9-46.9-1.2-9.953-5.322-12.147-27.983-4.386-27.983-4.386a13.3,13.3,0,0,1-1.374,5.736c-1.373,2.362-8.755,14-13.562,18.557s-10.129,8.435-12.7,5.567-6.181-10.291-7.039-14.508-1.889-9.11-1.889-9.11a27.873,27.873,0,0,1-5.837,1.687c-3.6.675-14.42,2.362-17.339,3.205s-6.18,4.387-7.554,6.242-2.918,9.785-3.433,16.364-3.777,15.015-3.777,15.015a39.483,39.483,0,0,1-5.837-9.11c-2.232-5.061-8.069-19.4-8.241-21.425s1.066-5.744-2.2-3.045-7.074,10.3-7.933,11.817-.858,2.7,0,5.9,4.807,17.713,6.352,22.943,3.091,11.641,7.383,16.027,9.581,9.169,11.813,9.844,5.719-1.235,8.855-4.66c3.092-3.377,5.21-8.588,5.774-1.735.349,4.255,2.826,12.071,3,15.445s1.24,14.552,1.24,14.552,10.567,3.665,27.044,3.938C198.472,196.215,216.586,194.5,220.348,192.1Z"
            fill="#a191f7"
          />
          <path
            id="Path_5280"
            data-name="Path 5280"
            d="M147.1,166.176c-1.9.837-2.54,1.633-1.687,2.82s.94,2,.183,2.534a1.606,1.606,0,0,0-.354,2.59,1.9,1.9,0,0,1,.392,2.785,1.37,1.37,0,0,0,.163,2.224,1.84,1.84,0,0,1,.792,2.417c-.411,1.106,2.909,1.817,3.921,2.04.91.2,6.1-1.446,7.032-2.09s1.535-1.71.7-2.717c0,0,7.453-2.451,6.523-3.088-1.3-.891.014-13.8,1.46-13.64l-11.839,1.872S149,165.339,147.1,166.176Z"
            fill="#fff"
          />
          <path
            id="Path_5281"
            data-name="Path 5281"
            d="M113.816,116.25s2.232-.675,7.725-12.147c-1.373-3.12-3.691-10.206-5.236-12.652s-2.249-3.324-6.026-4.083-7.086-.394-8.851-.513-6.012-1.542-9.076-2.976c-3.655-1.711-4.374-3.225-4.374-3.225s-.172-1.856-1.2-2.362-2.146-.59-1.717,1.687c-.172.59-.858.169-1.545.843a2.268,2.268,0,0,0,.086,2.952,20.345,20.345,0,0,0,1.8,1.687l.429,3.964-1.888-.084a65.2,65.2,0,0,0-3.434-6.411c-1.459-2.193-2.575-4.555-3.691-4.892s-2.232-.169-2.232,1.012c-2.232-.843-4.292-1.35-4.378-.506s3.176,4.724,3.176,4.724a26.788,26.788,0,0,0-3.09-.422c-.858,0-1.03,1.434-1.03,1.434l9.7,6.664,1.545,3.627,11.245,1.434,3,2.109,14.85,2.362s.257-.338.772,1.181S112.1,111.273,113.816,116.25Z"
            fill="#fff"
          />
          <path
            id="Path_5282"
            data-name="Path 5282"
            d="M180.378,76.151a.583.583,0,0,0-.42.714,24.327,24.327,0,0,1,.349,4.309c.04,1.785.037,3.618.127,4.764a4.8,4.8,0,0,1-1.191,3.751c-1.2,1.394-3.6,2.869-8.3,3.889-6.63,1.438-13.557,1.719-19.171,3.921s-9.86,6.473-10.821,15.483a108.716,108.716,0,0,1-2.837,16.906c-.828,3.045-1.458,4.079-1.458,5.255a.589.589,0,0,0,.594.584h0a.589.589,0,0,0,.594-.584c0-.68.572-1.841,1.418-4.954a109.917,109.917,0,0,0,2.871-17.086c.928-8.7,4.749-12.429,10.078-14.519s12.222-2.4,18.987-3.865c4.855-1.053,7.519-2.608,8.953-4.275a6.081,6.081,0,0,0,1.468-4.595c-.082-1.047-.084-2.9-.124-4.7a22.571,22.571,0,0,0-.388-4.585.6.6,0,0,0-.728-.412h0Z"
          />
          <path
            id="Path_5283"
            data-name="Path 5283"
            d="M203.9,68.063a.59.59,0,0,0-.62.558c-.171,3.767-.65,7.951-.567,11.337a12.955,12.955,0,0,0,.69,4.371,3.433,3.433,0,0,0,2.588,2.3c2.123.348,7.5.892,13.106,1.461s11.4,1.162,14.2,1.578a13.2,13.2,0,0,1,7.574,3.828,12.4,12.4,0,0,1,3.253,9.406c-.332,8.312-8.819,55.137-10.792,61.6a15.875,15.875,0,0,1-1.742,4.253,8.734,8.734,0,0,1-3.936,3.1C223.618,173.7,216.05,175.1,201.4,176.4c-14.119,1.247-23.35.844-29.056.167a52.227,52.227,0,0,1-6.094-1.05c-.634-.153-1.091-.279-1.409-.363l-.061-.015a27.06,27.06,0,0,1-.057-4.445,35.282,35.282,0,0,1,.91-6.556,2.486,2.486,0,0,1,.412-.95.783.783,0,0,1,.513-.282,26.076,26.076,0,0,1,3.135-.017,96.864,96.864,0,0,0,21.806-3.737c3.966-1.193,8.694-3.1,12.8-4.741,2.052-.823,3.949-1.581,5.5-2.151a19.287,19.287,0,0,1,3.4-1.015,9.85,9.85,0,0,1,3.57.171c.91.248,1.375.654,1.454.927a.6.6,0,0,0,.735.4.582.582,0,0,0,.408-.721,2.92,2.92,0,0,0-2.28-1.731,10.924,10.924,0,0,0-4.026-.206,18.512,18.512,0,0,0-3.673,1.082c-1.581.579-3.483,1.34-5.536,2.163-4.105,1.645-8.818,3.538-12.7,4.706a97.932,97.932,0,0,1-21.457,3.685,18.966,18.966,0,0,0-3.389.045,2.106,2.106,0,0,0-1.173.674,3.491,3.491,0,0,0-.649,1.4,36.159,36.159,0,0,0-.946,6.785,26.065,26.065,0,0,0,.078,5.108.6.6,0,0,0,1.089.2.576.576,0,0,1-.322.241.428.428,0,0,1-.142.021c-.048,0-.04,0-.018,0,.045.008.158.036.31.077.305.081.783.212,1.437.37a53.411,53.411,0,0,0,6.233,1.075c5.8.688,15.117,1.09,29.305-.164,14.686-1.3,22.311-2.671,26.648-4.651a10.04,10.04,0,0,0,4.429-3.518,16.723,16.723,0,0,0,1.886-4.559c2.148-7.035,10.485-53,10.84-61.89A13.623,13.623,0,0,0,241.74,92.7a14.361,14.361,0,0,0-8.263-4.186c-2.87-.427-8.655-1.015-14.255-1.584s-11.036-1.124-13.033-1.451a2.132,2.132,0,0,1-1.677-1.574,12.208,12.208,0,0,1-.609-3.973c-.08-3.252.393-7.432.567-11.256a.589.589,0,0,0-.568-.609Z"
          />
          <path
            id="Path_5284"
            data-name="Path 5284"
            d="M219.188,110.438a.59.59,0,0,0-.642.532c-.428,4.966-1.286,13.271-2.272,21.043s-2.127,15.075-3.023,17.8a.582.582,0,0,0,.382.735.6.6,0,0,0,.749-.375h0c.992-3.014,2.083-10.221,3.071-18.011s1.847-16.1,2.277-21.09A.586.586,0,0,0,219.188,110.438Z"
          />
          <path
            id="Path_5285"
            data-name="Path 5285"
            d="M211.579,86.165a.6.6,0,0,0-.452.049.579.579,0,0,0-.234.793h0a2.451,2.451,0,0,1,0,1.482,14.407,14.407,0,0,1-1.031,2.81,57.381,57.381,0,0,1-4.566,7.69c-3.839,5.6-8.862,11.574-12.471,14.625s-5.829,3.562-7.275,3.161-2.4-1.822-3.324-3.172c-1.077-1.579-2.705-5.741-4.056-9.865a81.291,81.291,0,0,1-2.717-9.968.592.592,0,0,0-.672-.5h0a.586.586,0,0,0-.505.66h0a79.206,79.206,0,0,0,2.763,10.162c1.363,4.161,2.91,8.265,4.2,10.156.906,1.329,2,3.093,3.989,3.646s4.617-.223,8.374-3.4c3.774-3.191,8.794-9.192,12.681-14.857a58.3,58.3,0,0,0,4.66-7.857,15.327,15.327,0,0,0,1.113-3.048,3.208,3.208,0,0,0-.123-2.292A.594.594,0,0,0,211.579,86.165Z"
          />
          <path
            id="Path_5286"
            data-name="Path 5286"
            d="M152.753,112.912a.58.58,0,0,0-.335.756c1.23,3.076,2.092,6.042,1.351,8.85-1.64,6.22-4.382,12.1-5.653,17.487-1.234,5.229.163,10.629,3.064,15.686a34.471,34.471,0,0,1,1.88,7.6.592.592,0,0,0,.668.5h0a.586.586,0,0,0,.509-.657v0a35.07,35.07,0,0,0-1.957-7.878.637.637,0,0,0-.033-.07c-2.83-4.907-4.128-10.024-2.974-14.914,1.229-5.206,3.972-11.108,5.646-17.459.847-3.209-.142-6.432-1.4-9.569A.6.6,0,0,0,152.753,112.912Z"
          />
          <path
            id="Path_5287"
            data-name="Path 5287"
            d="M222.933,174.063a.591.591,0,0,0-.645.528h0c-.338,3.653-2.187,17.372-2.187,17.372a.585.585,0,0,0,.511.655.593.593,0,0,0,.667-.5s1.844-13.649,2.193-17.419a.588.588,0,0,0-.539-.634Z"
          />
          <path
            id="Path_5288"
            data-name="Path 5288"
            d="M156.121,181.643a.587.587,0,0,0-.513.654c.066.5.245,2.762.413,4.9.084,1.068.166,2.116.234,2.93.034.407.065.756.091,1.021a4.908,4.908,0,0,0,.069.564.593.593,0,0,0,.7.452h0a.584.584,0,0,0,.46-.692c.007.037-.025-.178-.049-.435s-.055-.6-.089-1.006c-.068-.809-.15-1.856-.234-2.923-.167-2.135-.334-4.3-.419-4.958A.594.594,0,0,0,156.121,181.643Z"
          />
          <path
            id="Path_5289"
            data-name="Path 5289"
            d="M86.531,77.456a1.55,1.55,0,0,0-1.022.017,1.791,1.791,0,0,0-1.044,1.746c0,1.395.431,5.371.774,9.328A6.212,6.212,0,0,0,86.8,92.675c.881.913,2.027,1.564,3.625,2.928A30.6,30.6,0,0,0,93.713,98.2a4.455,4.455,0,0,0,1.906.664c.516.073,2.8.522,5.288.966a67.509,67.509,0,0,0,6.867.978,4.752,4.752,0,0,1,1.528.27.712.712,0,0,1,.438.363,16.308,16.308,0,0,1,.228,1.754c.285,1.592,2.564,10.858,3.1,12.712a.6.6,0,0,0,.734.4.583.583,0,0,0,.409-.721h0c-.491-1.689-2.848-11.318-3.077-12.594a6.071,6.071,0,0,0-.33-2.063,2.018,2.018,0,0,0-1.033-.921,5.731,5.731,0,0,0-1.937-.365c-1.513-.08-4.246-.52-6.717-.962s-4.649-.877-5.334-.973a2.923,2.923,0,0,1-1.441-.5A30.9,30.9,0,0,1,91.2,94.722c-1.664-1.42-2.835-2.117-3.542-2.85s-1.068-1.506-1.234-3.422c-.344-3.972-.771-8.094-.771-9.229,0-.464.167-.611.287-.657s.342-.048.655.291A5.327,5.327,0,0,1,87.181,80c.235.591.481,1.332.708,2.1a34.943,34.943,0,0,1,.959,4.033,8.676,8.676,0,0,0,.393,2.248,4.823,4.823,0,0,0,2.2,2.133,19.782,19.782,0,0,1,2.863,1.817,1.727,1.727,0,0,0,.952.348,6.946,6.946,0,0,0,1.288-.138c1.144-.18,3.13-.512,7.019-.848s6.2-.42,7.512-.42a8.736,8.736,0,0,1,1.571.069.6.6,0,0,0,.714-.434.584.584,0,0,0-.443-.7,10.536,10.536,0,0,0-1.842-.1c-1.367,0-3.7.087-7.616.425s-5.971.681-7.1.859a7.438,7.438,0,0,1-1.057.124c-.156-.006-.128,0-.266-.1a21.549,21.549,0,0,0-2.975-1.894c-1.151-.687-1.538-1.135-1.723-1.579a10.17,10.17,0,0,1-.315-1.969,34.987,34.987,0,0,0-.995-4.192c-.234-.792-.487-1.559-.742-2.2a4.8,4.8,0,0,0-.815-1.509A2.181,2.181,0,0,0,86.531,77.456Z"
          />
          <path
            id="Path_5290"
            data-name="Path 5290"
            d="M75.712,77.393a1.828,1.828,0,0,0-1.1.5,1.714,1.714,0,0,0-.265,2.15c.636.982,1.235,1.578,1.614,2.248.047.082.31.681.609,1.447s.664,1.75,1.032,2.794a49.585,49.585,0,0,1,1.727,5.705c.265,1.389.535,2.155,1.163,2.593a4.378,4.378,0,0,0,2.08.491c.9.133,2.532.279,4.223.469a34.8,34.8,0,0,1,4.431.7.6.6,0,0,0,.733-.4h0a.583.583,0,0,0-.411-.72h0a34.213,34.213,0,0,0-4.616-.737c-1.707-.192-3.366-.344-4.182-.464a5.928,5.928,0,0,1-1.567-.289c-.188-.131-.434-.545-.684-1.856a48.721,48.721,0,0,0-1.771-5.873c-.372-1.055-.742-2.048-1.046-2.829a14.949,14.949,0,0,0-.681-1.6c-.48-.849-1.083-1.435-1.649-2.308a.554.554,0,0,1,.1-.7c.191-.188.484-.325,1.082,0a8.208,8.208,0,0,1,1.413,1.523c.629.824,1.346,1.876,2.032,2.948a53.969,53.969,0,0,1,2.9,5.025c.284.677.261,1.058.688,1.477a1.312,1.312,0,0,0,.8.33,7.173,7.173,0,0,0,.983-.011.588.588,0,0,0,.563-.613v0a.59.59,0,0,0-.624-.552,7.344,7.344,0,0,1-.814.015c-.137-.012-.085-.012-.065.008a7.473,7.473,0,0,0-.429-1.1,48.349,48.349,0,0,0-3-5.2c-.7-1.09-1.426-2.162-2.087-3.027A6.558,6.558,0,0,0,77.108,77.7,2.41,2.41,0,0,0,75.712,77.393Z"
          />
          <path
            id="Path_5291"
            data-name="Path 5291"
            d="M88.821,81.7a.6.6,0,0,0-.761.351h0a.581.581,0,0,0,.357.747h0a58.7,58.7,0,0,1,6.969,3.35,17.885,17.885,0,0,0,7.92,1.534c.8,0,2.8.034,4.794.172,1,.069,2,.163,2.836.291a7.721,7.721,0,0,1,1.843.455c1.624.8,2.572,1.707,3.483,4.149.971,2.6,3.445,7.736,4.273,11.071a.594.594,0,0,0,.717.43h0a.585.585,0,0,0,.436-.706c-.889-3.581-3.394-8.737-4.311-11.2a7.138,7.138,0,0,0-6.261-5.356c-.892-.135-1.915-.232-2.933-.3-2.037-.141-4.047-.174-4.879-.174-1.6,0-4.966-.142-7.36-1.4A58.63,58.63,0,0,0,88.821,81.7Z"
          />
          <path
            id="Path_5292"
            data-name="Path 5292"
            d="M71.626,77.663a2.137,2.137,0,0,0-1.423.353,1.346,1.346,0,0,0-.386,1.471A7.121,7.121,0,0,0,71.615,82c.779.8,1.65,1.594,2.347,2.4.712.823,1.846,2.252,2.834,3.609.494.678.953,1.34,1.3,1.895a6.981,6.981,0,0,1,.638,1.194.6.6,0,0,0,.734.4h0a.583.583,0,0,0,.408-.722h0a6.335,6.335,0,0,0-.77-1.488c-.372-.589-.842-1.267-1.346-1.959-1.008-1.385-2.148-2.823-2.9-3.687-.762-.881-1.651-1.689-2.4-2.451a6.531,6.531,0,0,1-1.529-2.078c-.077-.226-.062-.142-.015-.178a1.327,1.327,0,0,1,.655-.11,4.9,4.9,0,0,1,2.547.967.6.6,0,0,0,.835-.091h0a.577.577,0,0,0-.093-.82A5.815,5.815,0,0,0,71.626,77.663Z"
          />
          <path
            id="Path_5293"
            data-name="Path 5293"
            d="M71.421,82.453a3.957,3.957,0,0,0-1.536.126,1.875,1.875,0,0,0-1.158.947,1.244,1.244,0,0,0,.076,1.121,2.956,2.956,0,0,0,.771.812,27.614,27.614,0,0,0,2.645,1.681,31.251,31.251,0,0,1,6.853,4.818.6.6,0,0,0,.84-.024h0a.577.577,0,0,0-.024-.825h0a32.638,32.638,0,0,0-7.053-4.967,28.546,28.546,0,0,1-2.52-1.6,2.17,2.17,0,0,1-.482-.481c-.055-.093-.036-.029-.029-.045a.636.636,0,0,1,.445-.329,2.915,2.915,0,0,1,1.067-.074,7.054,7.054,0,0,1,2.63.83.6.6,0,0,0,.812-.213h0a.579.579,0,0,0-.216-.8h0A7.981,7.981,0,0,0,71.421,82.453Z"
          />
          <path
            id="Path_5294"
            data-name="Path 5294"
            d="M122.036,100.7a1.251,1.251,0,0,0-.856.361,6.807,6.807,0,0,0-.839.761.577.577,0,0,0,.038.825.6.6,0,0,0,.84-.036h0s.187-.164.288-.263c-.273,1.5-1.292,4.859-5.347,10.622a18.613,18.613,0,0,1-2.666,3.21,2.042,2.042,0,0,1-.582.38c-.01-.02-.006,0-.022-.087a2.594,2.594,0,0,1-.018-.636,7.391,7.391,0,0,1,.391-1.754.582.582,0,0,0-.368-.742.6.6,0,0,0-.756.361,8.4,8.4,0,0,0-.452,2.047,3.569,3.569,0,0,0,.034.941,1.338,1.338,0,0,0,.451.837,1.2,1.2,0,0,0,1.069.166,3,3,0,0,0,1.033-.632,19.1,19.1,0,0,0,2.864-3.427c4.849-6.893,5.587-10.694,5.684-11.927a1,1,0,0,0-.111-.62A.872.872,0,0,0,122.036,100.7Z"
          />
          <path
            id="Path_5295"
            data-name="Path 5295"
            d="M122.428,100.99a.587.587,0,0,0-.534.637v0a55.074,55.074,0,0,0,2.58,9.982c1.337,4.034,2.994,8.389,4.505,11.867a77.453,77.453,0,0,0,10.661,16.609c1.284,1.411,3.319,5.74,4.156,9.274a.6.6,0,0,0,.713.437.584.584,0,0,0,.444-.7c-.88-3.72-2.794-7.994-4.428-9.788-1.358-1.492-7.5-9.486-10.453-16.289-1.494-3.438-3.143-7.772-4.467-11.771a55.559,55.559,0,0,1-2.528-9.735A.59.59,0,0,0,122.428,100.99Z"
          />
          <path
            id="Path_5296"
            data-name="Path 5296"
            d="M112.341,116.676a.582.582,0,0,0-.394.729c.45,1.447,1.383,5.491,2.512,10.171s2.464,10.028,3.766,14.233c2.539,8.2,3.193,11.233,9.208,18.42a36,36,0,0,0,7.154,6.575c2.247,1.53,4.12,2.4,5.494,2.4a5.453,5.453,0,0,0,3.135-.988,20.976,20.976,0,0,0,2.944-2.627s1.35-1.287,2.836-2.844a24.77,24.77,0,0,0,3.724-4.556.579.579,0,0,0-.265-.783.6.6,0,0,0-.8.261,27.16,27.16,0,0,1-3.529,4.279c-1.464,1.534-2.8,2.806-2.8,2.806l-.009.009a20.659,20.659,0,0,1-2.777,2.491,4.1,4.1,0,0,1-2.465.784,11.575,11.575,0,0,1-4.817-2.194,34.911,34.911,0,0,1-6.913-6.356c-5.94-7.1-6.443-9.792-8.99-18.019-1.286-4.154-2.617-9.49-3.745-14.163s-2.038-8.652-2.533-10.242a.6.6,0,0,0-.741-.388Z"
          />
          <path
            id="Path_5297"
            data-name="Path 5297"
            d="M85.216,80.231a2.3,2.3,0,0,0-2.476.753,1.926,1.926,0,0,0,.011,2.008,6.64,6.64,0,0,0,2.223,2.563.6.6,0,0,0,.832-.113.578.578,0,0,0-.115-.818h0a5.535,5.535,0,0,1-1.848-2.089,1.977,1.977,0,0,1-.147-.854c.247-.327.5-.51,1.212-.32a.6.6,0,0,0,.728-.412h0a.583.583,0,0,0-.419-.715h0Z"
          />
          <path
            id="Path_5298"
            data-name="Path 5298"
            d="M164.428,175.553a46.418,46.418,0,0,1-13.578,4.129.584.584,0,1,0,.137,1.16,45.612,45.612,0,0,0,14.041-4.282.578.578,0,0,0,.213-.8.6.6,0,0,0-.813-.21Z"
          />
          <path
            id="Path_5299"
            data-name="Path 5299"
            d="M165.56,161.7a65.8,65.8,0,0,0-9.469.935,29.481,29.481,0,0,0-8.829,2.614,6.96,6.96,0,0,0-2.05,1.44,1.581,1.581,0,0,0-.365,1.031,2.159,2.159,0,0,0,.4,1.1,2.848,2.848,0,0,1,.534,1.244c.009.242-.027.322-.289.49a2.666,2.666,0,0,0-1.132,1.444,2.034,2.034,0,0,0,.57,2.031,1.752,1.752,0,0,1,.59,1.1,1.111,1.111,0,0,1-.337.887,2.324,2.324,0,0,0-.7,1.6,1.831,1.831,0,0,0,.875,1.518.911.911,0,0,1,.534.8,6.075,6.075,0,0,1-.118,1.086,2.137,2.137,0,0,0,.479,1.689,2.959,2.959,0,0,0,1.349.82,9.6,9.6,0,0,0,2.559.352,14.377,14.377,0,0,0,4.251-.646A13.829,13.829,0,0,0,157.632,182a3.161,3.161,0,0,0,1.3-1.458,2.126,2.126,0,0,0-.319-2.067.6.6,0,0,0-.831-.12.576.576,0,0,0-.122.816.85.85,0,0,1,.165.947,2.1,2.1,0,0,1-.833.9,15.094,15.094,0,0,1-2.9,1.09,13.836,13.836,0,0,1-3.868.6,9.232,9.232,0,0,1-2.244-.3,1.879,1.879,0,0,1-.822-.473.873.873,0,0,1-.2-.783,5.213,5.213,0,0,0,.122-1.33A2.239,2.239,0,0,0,146,178.145a.581.581,0,0,1-.329-.543,1.214,1.214,0,0,1,.378-.795,2.318,2.318,0,0,0,.655-1.771,2.92,2.92,0,0,0-.937-1.842.749.749,0,0,1-.268-.87,1.631,1.631,0,0,1,.643-.8,1.753,1.753,0,0,0,.825-1.508,3.68,3.68,0,0,0-.721-1.835,1.1,1.1,0,0,1-.214-.507c0-.088.008-.138.108-.262a7.586,7.586,0,0,1,1.714-1.155,29.223,29.223,0,0,1,8.438-2.475,65.044,65.044,0,0,1,9.283-.918.587.587,0,0,0,.585-.592h0a.589.589,0,0,0-.6-.576Z"
          />
          <path
            id="Path_5300"
            data-name="Path 5300"
            d="M167.847,31.152a.6.6,0,0,0-.83.128h0c-3.073,4.158-6.829,15.408-1.639,29.446a.6.6,0,0,0,.761.349h0a.581.581,0,0,0,.355-.748c-5.055-13.677-1.251-24.661,1.485-28.361a.577.577,0,0,0-.131-.815Z"
          />
          <path
            id="Path_5301"
            data-name="Path 5301"
            d="M175.71,29.488a.6.6,0,0,0-.711.44h0a.584.584,0,0,0,.448.7h0c1.425.316,3.244,1.84,5.154,3.691a48.23,48.23,0,0,0,6.1,5.441c4.2,2.823,8.541,4.784,12.712,4.215a.586.586,0,0,0,.507-.658.592.592,0,0,0-.67-.5h0c-3.684.5-7.784-1.271-11.877-4.022a48.484,48.484,0,0,1-5.932-5.308C179.5,31.612,177.667,29.922,175.71,29.488Z"
          />
          <path
            id="Path_5302"
            data-name="Path 5302"
            d="M196.894,38.911a.581.581,0,0,0-.359.745c1.085,2.988,3.894,6.12,6.311,8.053,1.771,1.417,3.767,2.3,5.319,3.434a6.413,6.413,0,0,1,2.934,4.92.594.594,0,0,0,1.182-.119h0a7.767,7.767,0,0,0-3.4-5.737c-1.7-1.246-3.666-2.113-5.28-3.4-2.271-1.816-4.992-4.923-5.942-7.539a.6.6,0,0,0-.759-.354Z"
          />
          <path
            id="Path_5303"
            data-name="Path 5303"
            d="M169.666,20.16c-4.062.887-9.644,3.622-12.219,11.323-2.535,7.582-3.3,15.3-2.537,29.8a59.214,59.214,0,0,1-2.6,19.5c-1.626,5.605-3.524,10.036-4.258,12.7a31.419,31.419,0,0,0-1.1,5.517,7.725,7.725,0,0,0-.007,1.706.593.593,0,0,0,.688.473.585.585,0,0,0,.482-.675,5.9,5.9,0,0,1,.021-1.4,30.467,30.467,0,0,1,1.059-5.312c.684-2.483,2.606-7,4.253-12.683a60.273,60.273,0,0,0,2.64-19.877c-.762-14.442,0-21.951,2.48-29.378,2.443-7.309,7.553-9.719,11.347-10.547a.584.584,0,0,0,.451-.7h0A.6.6,0,0,0,169.666,20.16Z"
          />
          <path
            id="Path_5304"
            data-name="Path 5304"
            d="M181.473,16.046a14.741,14.741,0,0,0-2.341.044,22.179,22.179,0,0,0-7.409,2.4.579.579,0,0,0-.283.777.6.6,0,0,0,.791.278h0a21.137,21.137,0,0,1,7.019-2.291c2.729-.269,6,.23,10.225,2.492,8.5,4.546,18.817,13.805,23.19,24.47a49.425,49.425,0,0,1,3.557,19.05c-.255,4.9-.885,9.05-.9,12.931a20.285,20.285,0,0,0,2.84,11.2.6.6,0,0,0,.815.2h0a.579.579,0,0,0,.205-.8A19.007,19.007,0,0,1,216.509,76.2c.017-3.759.643-7.916.9-12.878a50.1,50.1,0,0,0-3.642-19.546c-4.526-11.035-14.986-20.386-23.724-25.06A20.8,20.8,0,0,0,181.473,16.046Z"
          />
          <path
            id="Path_5305"
            data-name="Path 5305"
            d="M203.491,48.789a.584.584,0,0,0-.474.682h0s1.862,9.9.992,15.53c-.979,6.333-4.535,11.166-9.183,12.969-4.582,1.778-10.914-.236-15.035-2.674-4.213-2.494-6.714-6.074-10.959-11.518a.6.6,0,0,0-.833-.109.576.576,0,0,0-.111.819h0c4.228,5.423,6.825,9.167,11.29,11.809,4.325,2.56,10.891,4.776,16.085,2.76,5.128-1.989,8.89-7.219,9.92-13.88.938-6.065-1-15.922-1-15.922a.594.594,0,0,0-.694-.466Z"
          />
          <path
            id="Path_5306"
            data-name="Path 5306"
            d="M181.475,49.492a.6.6,0,0,0-.392.228.577.577,0,0,0,.119.818,8.044,8.044,0,0,1,2.034,1.978,4.341,4.341,0,0,1,.667,2.8,7.95,7.95,0,0,0-.013,3.014,2.15,2.15,0,0,0,.923,1.1,6.831,6.831,0,0,0,1.8.706.6.6,0,0,0,.733-.4h0a.582.582,0,0,0-.411-.72h0a5.961,5.961,0,0,1-1.481-.567.854.854,0,0,1-.437-.489,10.877,10.877,0,0,1,.076-2.566,5.612,5.612,0,0,0-.852-3.5,9.059,9.059,0,0,0-2.322-2.283A.6.6,0,0,0,181.475,49.492Z"
          />
          <path
            id="Path_5307"
            data-name="Path 5307"
            d="M194.759,60.886a.6.6,0,0,0-.572.088,30.249,30.249,0,0,1-4.474,2.434,38.022,38.022,0,0,1-6.721,2.435.583.583,0,0,0-.439.7.567.567,0,0,0,.1.205,11.752,11.752,0,0,0,4.005,3.677,5.975,5.975,0,0,0,5.562-.062,5.737,5.737,0,0,0,3.115-4.052,12.409,12.409,0,0,0-.2-5A.587.587,0,0,0,194.759,60.886Zm-.676,1.466a10.385,10.385,0,0,1,.084,3.727,4.434,4.434,0,0,1-2.5,3.253,4.621,4.621,0,0,1-4.477.058,9.894,9.894,0,0,1-3.031-2.685,41.225,41.225,0,0,0,6.056-2.24A28.9,28.9,0,0,0,194.083,62.352Z"
          />
          <path
            id="Path_5308"
            data-name="Path 5308"
            d="M208.285,50.321a.586.586,0,0,0-.538.634h0c.205,2.238-.445,3.278-1.08,3.837a2.5,2.5,0,0,1-1.269.623.584.584,0,1,0,.127,1.161,3.875,3.875,0,0,0,1.936-.914c.911-.8,1.7-2.308,1.47-4.812a.591.591,0,0,0-.645-.529Z"
          />
          <path
            id="Path_5309"
            data-name="Path 5309"
            d="M205.542,48.911a.593.593,0,0,0-.361.271,3.725,3.725,0,0,0-.472,1.782A.594.594,0,0,0,205.9,51h0a2.563,2.563,0,0,1,.312-1.232.578.578,0,0,0-.216-.8A.6.6,0,0,0,205.542,48.911Z"
          />
          <path
            id="Path_5310"
            data-name="Path 5310"
            d="M165.25,61.5a2.637,2.637,0,0,0-2.534,1.532,3.4,3.4,0,0,0,.087,2.655,11.122,11.122,0,0,0,2.587,3.592c2.2,2.205,3.96,2.78,5.231,2.692a3.131,3.131,0,0,0,1.99-.884.577.577,0,0,0-.069-.823h0a.6.6,0,0,0-.838.066h0a1.642,1.642,0,0,1-1.168.475c-.838.058-2.247-.286-4.3-2.344a10.116,10.116,0,0,1-2.327-3.2A2.219,2.219,0,0,1,163.8,63.5a1.565,1.565,0,0,1,1.886-.722.6.6,0,0,0,.793-.275.58.58,0,0,0-.28-.779A2.49,2.49,0,0,0,165.25,61.5Z"
          />
          <path
            id="Path_5311"
            data-name="Path 5311"
            d="M167.311,65.466a2.56,2.56,0,0,0-1.537.126.58.58,0,0,0-.309.767.6.6,0,0,0,.781.3,1.892,1.892,0,0,1,1.962.54.6.6,0,0,0,.837-.065h0a.577.577,0,0,0-.066-.823h0A3.86,3.86,0,0,0,167.311,65.466Z"
          />
          <path
            id="Path_5312"
            data-name="Path 5312"
            d="M186.524,38.891a5.114,5.114,0,0,0-3.09,2.817.581.581,0,0,0,.361.745.6.6,0,0,0,.758-.354,4.093,4.093,0,0,1,2.4-2.12.581.581,0,0,0,.337-.756A.6.6,0,0,0,186.524,38.891Z"
          />
          <path
            id="Path_5313"
            data-name="Path 5313"
            d="M173.67,46.01a6.757,6.757,0,0,0-3.41,1,6.273,6.273,0,0,0-3.084,3.355.583.583,0,0,0,.411.72h0a.6.6,0,0,0,.733-.4h0a5.533,5.533,0,0,1,2.535-2.66,4.839,4.839,0,0,1,3.5-.72.6.6,0,0,0,.761-.35.58.58,0,0,0-.357-.747h0A3.567,3.567,0,0,0,173.67,46.01Z"
          />
          <path
            id="Path_5314"
            data-name="Path 5314"
            d="M192.9,47.122a1.863,1.863,0,0,1-.457,2.581,1.928,1.928,0,0,1-2.431-1.076,1.862,1.862,0,0,1,.458-2.581A1.927,1.927,0,0,1,192.9,47.122Z"
          />
          <path
            id="Path_5315"
            data-name="Path 5315"
            d="M176.7,55.25a1.863,1.863,0,0,1-.457,2.581,1.928,1.928,0,0,1-2.431-1.076,1.863,1.863,0,0,1,.457-2.581A1.928,1.928,0,0,1,176.7,55.25Z"
          />
          <path
            id="Path_5316"
            data-name="Path 5316"
            d="M66.254,9.662A1.415,1.415,0,0,1,67.892,8.3c5.659.864,25.122,3.572,41.279,2.655a1.3,1.3,0,0,1,1.388,1.245l1.992,59.617a1.5,1.5,0,0,1-1.451,1.537c-6.793.268-34.766,1.272-44.711.058a1.182,1.182,0,0,1-1.047-1.186Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5317"
            data-name="Path 5317"
            d="M66.9,11.168a1.361,1.361,0,0,1,1.577-1.312c5.445.831,24.176,3.437,39.724,2.555a1.254,1.254,0,0,1,1.336,1.2l1.917,57.371a1.442,1.442,0,0,1-1.4,1.479c-6.537.258-33.457,1.224-43.028.055a1.138,1.138,0,0,1-1.007-1.141Z"
            fill="#fff"
            opacity="0.6"
          />
          <path
            id="Path_5318"
            data-name="Path 5318"
            d="M71.854,16.066l.327,12.3a.786.786,0,0,0,.755.759c2.31.108,9.509.415,13.58.283a.881.881,0,0,0,.857-.827c.125-2.3.432-9-.043-11.818a.993.993,0,0,0-.933-.819l-13.652-.726A.839.839,0,0,0,71.854,16.066Z"
            fill="#fff"
            opacity="0.78"
          />
          <path
            id="Path_5319"
            data-name="Path 5319"
            d="M79.636,22.846a2.642,2.642,0,1,0-2.7-2.624A2.666,2.666,0,0,0,79.636,22.846Z"
            fill="#506d7b"
            opacity="0.5"
          />
          <path
            id="Path_5320"
            data-name="Path 5320"
            d="M75.394,27.885l8.545.16a.652.652,0,0,0,.576-.993A5.519,5.519,0,0,0,79.7,24.277,5.989,5.989,0,0,0,74.85,26.8.679.679,0,0,0,75.394,27.885Z"
            fill="#506d7b"
            opacity="0.5"
          />
          <g id="Group_5483" data-name="Group 5483" opacity="0.6">
            <path
              id="Path_5321"
              data-name="Path 5321"
              d="M105.865,17.378c.339.006.614-.173.612-.4s-.281-.419-.619-.431l-14.711-.528a.388.388,0,0,0-.429.529.915.915,0,0,0,.8.563Z"
              fill="#fff"
              opacity="0.6"
            />
          </g>
          <g id="Group_5484" data-name="Group 5484" opacity="0.6">
            <path
              id="Path_5322"
              data-name="Path 5322"
              d="M91.1,18.313a.388.388,0,0,0-.429.53.915.915,0,0,0,.8.563l14.345.264c.339.006.614-.173.612-.4s-.281-.419-.619-.431Z"
              fill="#fff"
              opacity="0.6"
            />
          </g>
          <g id="Group_5485" data-name="Group 5485" opacity="0.6">
            <path
              id="Path_5323"
              data-name="Path 5323"
              d="M91.057,20.637c-.339-.012-.532.226-.429.529a.915.915,0,0,0,.8.563l14.345.264c.339.006.614-.173.612-.4s-.281-.419-.619-.431Z"
              fill="#fff"
              opacity="0.6"
            />
          </g>
          <g id="Group_5486" data-name="Group 5486" opacity="0.6">
            <path
              id="Path_5324"
              data-name="Path 5324"
              d="M107,33.222c.338.006.607-.172.6-.4s-.3-.415-.634-.424l-34.816-.907c-.339-.009-.447.2-.242.46l.122.156a1.462,1.462,0,0,0,.989.487Z"
              fill="#fff"
              opacity="0.6"
            />
          </g>
          <g id="Group_5487" data-name="Group 5487" opacity="0.6">
            <path
              id="Path_5325"
              data-name="Path 5325"
              d="M72.106,33.787c-.339-.009-.447.2-.242.46l.122.156a1.462,1.462,0,0,0,.99.487l33.984.624c.338.006.607-.172.6-.4s-.3-.415-.634-.424Z"
              fill="#fff"
              opacity="0.6"
            />
          </g>
          <path
            id="Path_5326"
            data-name="Path 5326"
            d="M76.381,42.7h-.007l-2.962-.083a.8.8,0,0,1-.806-.688l-.21-2.45a.534.534,0,0,1,.138-.4A.663.663,0,0,1,73,38.864h0c.25-.012.6-.035.975-.059.826-.054,1.762-.115,2.311-.111a.833.833,0,0,1,.825.592,12.029,12.029,0,0,1,.054,2.761A.738.738,0,0,1,76.381,42.7Zm-3.373-3.6a.418.418,0,0,0-.292.133.3.3,0,0,0-.078.225l.21,2.45a.558.558,0,0,0,.571.47l2.962.083h.005a.5.5,0,0,0,.533-.429,11.962,11.962,0,0,0-.048-2.692.6.6,0,0,0-.582-.411H76.28c-.54,0-1.512.06-2.293.111C73.613,39.068,73.26,39.091,73.008,39.1Z"
            fill="#fff"
          />
          <g id="Group_5488" data-name="Group 5488" opacity="0.6">
            <path
              id="Path_5327"
              data-name="Path 5327"
              d="M79.406,40.245a.442.442,0,0,0-.471.569l.07.282a.828.828,0,0,0,.761.586l26.6.212a.576.576,0,0,0,.615-.532.6.6,0,0,0-.616-.55Z"
              fill="#fff"
              opacity="0.6"
            />
          </g>
          <path
            id="Path_5328"
            data-name="Path 5328"
            d="M73.441,39.74a.458.458,0,0,1,.624.18l.563,1.042a.147.147,0,0,0,.261-.006L76.4,37.806a.162.162,0,0,1,.308.075,6.23,6.23,0,0,1-1.945,4.329,3.422,3.422,0,0,1-1.531-1.874A.466.466,0,0,1,73.441,39.74Z"
            fill="#7abc9f"
          />
          <path
            id="Path_5329"
            data-name="Path 5329"
            d="M76.259,48.957h-.007l-2.962-.083a.8.8,0,0,1-.806-.688l-.21-2.45a.534.534,0,0,1,.138-.4.663.663,0,0,1,.463-.214h0c.25-.012.6-.035.975-.059.826-.054,1.762-.115,2.311-.111a.835.835,0,0,1,.825.592A12.028,12.028,0,0,1,77.04,48.3.738.738,0,0,1,76.259,48.957Zm-3.373-3.6a.418.418,0,0,0-.292.133.3.3,0,0,0-.078.225l.21,2.45a.558.558,0,0,0,.571.47l2.962.083h.005a.5.5,0,0,0,.533-.429,11.961,11.961,0,0,0-.048-2.692.6.6,0,0,0-.582-.411h-.009c-.54,0-1.512.06-2.293.111C73.491,45.321,73.138,45.344,72.886,45.356Z"
            fill="#fff"
          />
          <path
            id="Path_5330"
            data-name="Path 5330"
            d="M73.2,45.606c.623-.03,1.979-.14,2.62-.136a.572.572,0,0,1,.566.4,9.745,9.745,0,0,1,.041,2.178.492.492,0,0,1-.53.434l-2.367-.066a.543.543,0,0,1-.551-.463L72.811,46A.382.382,0,0,1,73.2,45.606Z"
            fill="#fff"
            opacity="0.6"
          />
          <g id="Group_5489" data-name="Group 5489" opacity="0.6">
            <path
              id="Path_5331"
              data-name="Path 5331"
              d="M79.286,46.5a.442.442,0,0,0-.471.569l.07.282a.828.828,0,0,0,.761.586l26.6.212a.576.576,0,0,0,.615-.532.6.6,0,0,0-.617-.55Z"
              fill="#fff"
              opacity="0.6"
            />
          </g>
          <path
            id="Path_5332"
            data-name="Path 5332"
            d="M76.134,55.209h-.007l-2.962-.083a.8.8,0,0,1-.806-.689l-.21-2.45a.535.535,0,0,1,.138-.4.663.663,0,0,1,.463-.214c.25-.012.6-.035.973-.059.786-.051,1.763-.115,2.313-.111a.831.831,0,0,1,.825.592,12.038,12.038,0,0,1,.055,2.76A.738.738,0,0,1,76.134,55.209Zm-.091-3.771h-.009c-.541,0-1.513.06-2.3.111-.373.024-.726.047-.977.06h0a.418.418,0,0,0-.292.133.3.3,0,0,0-.078.225l.21,2.45a.558.558,0,0,0,.571.47l2.962.083h.005a.5.5,0,0,0,.533-.429,11.973,11.973,0,0,0-.048-2.692A.6.6,0,0,0,76.042,51.439Z"
            fill="#fff"
          />
          <path
            id="Path_5333"
            data-name="Path 5333"
            d="M73.074,51.86c.623-.03,1.979-.14,2.62-.136a.572.572,0,0,1,.566.4A9.745,9.745,0,0,1,76.3,54.3a.492.492,0,0,1-.53.434L73.4,54.67a.543.543,0,0,1-.55-.463l-.168-1.958A.382.382,0,0,1,73.074,51.86Z"
            fill="#fff"
            opacity="0.6"
          />
          <g id="Group_5490" data-name="Group 5490" opacity="0.6">
            <path
              id="Path_5334"
              data-name="Path 5334"
              d="M79.161,52.75a.442.442,0,0,0-.471.569l.07.282a.828.828,0,0,0,.761.586l26.6.212a.576.576,0,0,0,.615-.532.6.6,0,0,0-.617-.55Z"
              fill="#fff"
              opacity="0.6"
            />
          </g>
          <path
            id="Path_5335"
            data-name="Path 5335"
            d="M76.01,61.462H76l-2.962-.083a.8.8,0,0,1-.806-.688l-.21-2.451a.534.534,0,0,1,.138-.4.664.664,0,0,1,.463-.214c.249-.012.6-.035.973-.059.786-.051,1.763-.115,2.313-.112a.835.835,0,0,1,.825.592,12.034,12.034,0,0,1,.054,2.76A.738.738,0,0,1,76.01,61.462Zm-.091-3.771h-.009c-.541,0-1.514.06-2.3.111-.373.024-.726.047-.977.06h0a.417.417,0,0,0-.292.133.3.3,0,0,0-.078.225l.21,2.45a.558.558,0,0,0,.571.47l2.962.083h.005a.5.5,0,0,0,.533-.429A11.966,11.966,0,0,0,76.5,58.1.6.6,0,0,0,75.919,57.691Z"
            fill="#fff"
          />
          <path
            id="Path_5336"
            data-name="Path 5336"
            d="M72.951,58.113c.623-.03,1.979-.14,2.62-.136a.572.572,0,0,1,.566.4,9.747,9.747,0,0,1,.041,2.178.492.492,0,0,1-.53.434l-2.367-.066a.543.543,0,0,1-.551-.463L72.562,58.5A.382.382,0,0,1,72.951,58.113Z"
            fill="#fff"
            opacity="0.6"
          />
          <g id="Group_5491" data-name="Group 5491" opacity="0.6">
            <path
              id="Path_5337"
              data-name="Path 5337"
              d="M79.034,59a.442.442,0,0,0-.471.569l.07.282a.828.828,0,0,0,.761.586l26.6.212a.576.576,0,0,0,.615-.532.6.6,0,0,0-.616-.55Z"
              fill="#fff"
              opacity="0.6"
            />
          </g>
          <path
            id="Path_5338"
            data-name="Path 5338"
            d="M31.275,138.871s0-1.274-1.788-3.062S26.553,133,26.553,133s-.9,2.937.764,4.722a31.33,31.33,0,0,0,3.952,3.448Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5339"
            data-name="Path 5339"
            d="M28.684,146.847s0-1.278-1.785-3.066-2.937-2.809-2.937-2.809-.892,2.938.767,4.726a31.445,31.445,0,0,0,3.955,3.438Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5340"
            data-name="Path 5340"
            d="M31.163,141.048s.135-1.271,2.1-2.859,3.217-2.482,3.217-2.482.579,3.013-1.261,4.61a31.5,31.5,0,0,1-4.3,3.01Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5341"
            data-name="Path 5341"
            d="M28.026,150.453s.27-1.248,2.391-2.634,3.461-2.131,3.461-2.131.257,3.06-1.739,4.459a31.448,31.448,0,0,1-4.61,2.542Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5342"
            data-name="Path 5342"
            d="M28.618,160.73s0-1.277,1.788-3.066,2.937-2.809,2.937-2.809.892,2.938-.767,4.726a31.337,31.337,0,0,1-3.952,3.448Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5343"
            data-name="Path 5343"
            d="M28.588,163.236s.181-1.264-1.317-3.293-2.506-3.2-2.506-3.2-1.317,2.779.086,4.784a31.386,31.386,0,0,0,3.428,3.975Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5344"
            data-name="Path 5344"
            d="M26.826,170.662s0-1.278,1.788-3.063,2.937-2.808,2.937-2.808.892,2.934-.767,4.722a31.417,31.417,0,0,1-3.952,3.448Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5345"
            data-name="Path 5345"
            d="M28.024,177.4s-.329-1.235.952-3.418,2.131-3.461,2.131-3.461,1.607,2.614.454,4.765A31.266,31.266,0,0,1,28.6,179.62Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5346"
            data-name="Path 5346"
            d="M31.437,138.545a36.6,36.6,0,0,1-.487,3.952c-.708,3.648-2.473,6.006-3.181,9.3s1.317,7.545.781,11.78-2.193,6.586-1.722,9.418,2.944,10.478,2.944,10.478"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5347"
            data-name="Path 5347"
            d="M31.147,141.894l1.926-1.475"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5348"
            data-name="Path 5348"
            d="M31.236,140.192l-.807-1.432"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5349"
            data-name="Path 5349"
            d="M27.876,151.662s1.61-1.208,3.27-2.42"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5350"
            data-name="Path 5350"
            d="M28.683,149.136a25.818,25.818,0,0,0-2.865-4.383"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5351"
            data-name="Path 5351"
            d="M28.683,162.545a19.869,19.869,0,0,1,3.448-4.61"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5352"
            data-name="Path 5352"
            d="M28.353,164.339a22.8,22.8,0,0,0-1.745-3.316c-.942-1.39-1.077-1.567-1.077-1.567"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5353"
            data-name="Path 5353"
            d="M26.826,173.011a21.233,21.233,0,0,1,1.452-2.937,18.727,18.727,0,0,1,1.88-2.464"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5354"
            data-name="Path 5354"
            d="M28.6,179.619a5.481,5.481,0,0,1,.484-2.822c.659-1.3,1.432-3,1.745-3.672"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5355"
            data-name="Path 5355"
            d="M19.572,155.929a3.181,3.181,0,0,1,.787-2.117c.925-1.317,1.538-2.078,1.538-2.078a3.426,3.426,0,0,1,.033,3.046,19.865,19.865,0,0,1-2.108,2.588Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5356"
            data-name="Path 5356"
            d="M22.065,160.662a3.179,3.179,0,0,1,.787-2.118c.925-1.314,1.551-2.091,1.551-2.091a3.413,3.413,0,0,1,.03,3.043,19.95,19.95,0,0,1-2.108,2.591Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5357"
            data-name="Path 5357"
            d="M19.878,157.279s-.224-.78-1.627-1.564-2.289-1.209-2.289-1.209a3.422,3.422,0,0,0,1.294,2.76,20.068,20.068,0,0,0,3.023,1.419Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5358"
            data-name="Path 5358"
            d="M22.865,162.845s-.3-.754-1.782-1.383-2.4-.962-2.4-.962a3.414,3.414,0,0,0,1.574,2.6,19.916,19.916,0,0,0,3.158,1.1Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5359"
            data-name="Path 5359"
            d="M23.611,169.346s-.138-.8-1.452-1.726-2.147-1.442-2.147-1.442A3.436,3.436,0,0,0,21,169.056a19.894,19.894,0,0,0,2.855,1.732Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5360"
            data-name="Path 5360"
            d="M23.9,170.916a3.159,3.159,0,0,1,.478-2.207c.731-1.432,1.225-2.278,1.225-2.278a3.427,3.427,0,0,1,.468,3.009,20,20,0,0,1-1.719,2.865Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5361"
            data-name="Path 5361"
            d="M26.143,177.373s.092-.807,1.354-1.808S29.555,174,29.555,174a3.423,3.423,0,0,1-.826,2.931,19.931,19.931,0,0,1-2.753,1.893Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5362"
            data-name="Path 5362"
            d="M25.812,175.382s-.138-.8-1.452-1.729-2.147-1.443-2.147-1.443a3.436,3.436,0,0,0,.988,2.879,19.931,19.931,0,0,0,2.848,1.732Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5363"
            data-name="Path 5363"
            d="M25.8,179.731a3.165,3.165,0,0,0-.968-2.038c-1.037-1.228-1.712-1.94-1.712-1.94a3.429,3.429,0,0,0,.231,3.037,20.06,20.06,0,0,0,2.325,2.4Z"
            fill="#5d47cc"
          />
          <path
            id="Path_5364"
            data-name="Path 5364"
            d="M19.434,155.741a23.392,23.392,0,0,0,.738,2.434c.84,2.209,2.2,3.5,3,5.486s0,4.877.79,7.472,2.091,3.9,2.1,5.72-.708,6.889-.708,6.889"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5365"
            data-name="Path 5365"
            d="M19.981,157.81l-1.367-.718"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5366"
            data-name="Path 5366"
            d="M19.74,156.753l.349-.988"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5367"
            data-name="Path 5367"
            d="M23.086,163.579s-1.143-.582-2.305-1.162"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5368"
            data-name="Path 5368"
            d="M22.313,162.087a16.291,16.291,0,0,1,1.317-3.059"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5369"
            data-name="Path 5369"
            d="M23.768,170.491a12.752,12.752,0,0,0-2.657-2.519"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5370"
            data-name="Path 5370"
            d="M24.159,171.581a14.467,14.467,0,0,1,.734-2.269c.441-.972.5-1.1.5-1.1"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5371"
            data-name="Path 5371"
            d="M26.007,178.236a11.932,11.932,0,0,1,1.469-1.528,7.961,7.961,0,0,0,.958-.833"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5372"
            data-name="Path 5372"
            d="M26.066,176.853a13.733,13.733,0,0,0-1.228-1.686,11.848,11.848,0,0,0-1.446-1.334"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5373"
            data-name="Path 5373"
            d="M25.671,181.19a3.472,3.472,0,0,0-.609-1.722c-.563-.741-1.225-1.725-1.495-2.114"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5374"
            data-name="Path 5374"
            d="M30.93,195.9H23.468a.587.587,0,0,1-.586-.586l-1.851-12.356H33.367l-1.851,12.356a.587.587,0,0,1-.586.586Z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5375"
            data-name="Path 5375"
            d="M232.529,196.13h64.988"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_5376"
            data-name="Path 5376"
            d="M6,196.13H226.031"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
export function PlanDurationIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 140,
    height: 120,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64.999 73.799"
      {...rest}
      sx={rootSx}
    >
      <g
        id="Plan_duration"
        data-name="Plan duration"
        transform="translate(-0.001)"
      >
        <path
          id="Path_6704"
          data-name="Path 6704"
          d="M57.009,42.9a6.172,6.172,0,0,0-4.023,2.291l1.192,2.378a1.739,1.739,0,0,1-1.387-.533,7.84,7.84,0,0,1-1.237-2.173s-.218,2.593-.581,5.18c-.256,1.824-.454,3.529-.69,5.732-.116,1.088-.4,3.09-.457,4.336-.148,3.134.043,5.948.14,8.425.088,2.264.172,4.234.216,5.266H18.294c.272-2.334.783-7.061.913-10.641.094-2.6.115-5.058.048-6.583a15.45,15.45,0,0,0-.229-2.191L15.021,40.169a5.717,5.717,0,0,0-.769-1.5,3.094,3.094,0,0,0-1.023-.825l2.016-7.994a10.534,10.534,0,0,0,1.213-.718,27.457,27.457,0,0,1,4.016-2.315c1.953-.884,4.516-1.186,6.718-2.024a21.32,21.32,0,0,0,4.342-2.319l10.213.366a8.312,8.312,0,0,1,1.144.3c1.055.379,2.659.941,4.353,1.514a52.128,52.128,0,0,1,4.97,1.636A11.336,11.336,0,0,1,55.8,28.914a15.955,15.955,0,0,1,3.124,5.71c.539,1.469,1.106,3.026,1.5,4.261.64,2.02,1.8,4.194,2.1,5.013.1.268.209,1.254.085,1.192a6.275,6.275,0,0,1-.447-1.142S60.523,42.389,57.009,42.9Z"
          fill="#ada0ec"
          fillRule="evenodd"
        />
        <path
          id="Path_6705"
          data-name="Path 6705"
          d="M62.026,43.925a30.077,30.077,0,0,1,1.887,5.334c.291,1.02.425,1.414.643,2.452a11.554,11.554,0,0,1,.3,2.484c-.024,1.542-.35,2.762-2.039,3.315a9.339,9.339,0,0,1-2.9.323,31.288,31.288,0,0,1-8.5-1.753,62.355,62.355,0,0,0-6.361-1.972,25.691,25.691,0,0,1-4.2-1.09,14.362,14.362,0,0,1-1.614-1.1,4.727,4.727,0,0,0-.886-.451,1.465,1.465,0,0,1-.388.541,1.885,1.885,0,0,1-1.636.309,4.983,4.983,0,0,1-1.008-1.009,2.169,2.169,0,0,1-1.107-.264,2.083,2.083,0,0,1-.579-.954l-.239-.053s-.37.258-.5.334a.972.972,0,0,1-1.385-.323c-.132-.3.432-1.6.432-1.6a2.4,2.4,0,0,1-.119-.786,1.541,1.541,0,0,1,.278-1.026,5.112,5.112,0,0,1,1.424-.8c.1-.041.5-.23.5-.23a3.046,3.046,0,0,0-.479-.286,8.324,8.324,0,0,0-1.251-.287A11.559,11.559,0,0,1,29.016,44c-.451-.221-1.292-.623-1.351-1.221-.067-.674,1.219-.421,1.562-.379,1.581.19,3.112.428,4.705.55A12.47,12.47,0,0,1,39.25,45.1c.743.443,1.524.846,2.287,1.254.978.523,1.8,1.037,2.757,1.586a9.082,9.082,0,0,0,1.6.718,8.434,8.434,0,0,0,1.677.345,13.261,13.261,0,0,0,2.063.158c1.126-.027,2.307-.062,3.433-.051.3,0,1.517.034,1.517.034s-.261-1.084-.464-1.673a24.075,24.075,0,0,0-1.124-2.232,3.627,3.627,0,0,1,.617-.8A6.065,6.065,0,0,1,55.2,43.414a8.935,8.935,0,0,1,4.594-.524C60.488,42.989,61.688,43.256,62.026,43.925Z"
          fill="#ffd7b5"
          fillRule="evenodd"
        />
        <path
          id="Path_6706"
          data-name="Path 6706"
          d="M14.967,40.154a5.066,5.066,0,0,0-.66-1.39c-.177-.2-.869-.875-.869-.875s.362-.123.42-.172.415-.323.415-.323a4.994,4.994,0,0,0,1.266.258,1.247,1.247,0,0,0,.925-.417c.039-.052.213-.4.213-.4s.483-.151.515-.375a1.389,1.389,0,0,0-.268-.791,19.94,19.94,0,0,0-1.752-2.1c-.32-.439-1-1.26-.1-1.191a3.668,3.668,0,0,1,1.35.8,10.958,10.958,0,0,1,.83,2.345,1.149,1.149,0,0,0,.985.723c.446-.041.4-.542.4-.542s.085-1.352.062-1.74a9.958,9.958,0,0,0-.551-2.432c-.332-.907-1.292-1.107-2.119-1.5a6.883,6.883,0,0,0-2.366-.43,6.724,6.724,0,0,0-3.122.505,3.966,3.966,0,0,0-1.587,1.171c-.144.207-.358.374-.518.569a12.186,12.186,0,0,0-.9,1.865,16.806,16.806,0,0,1-1.694,1.442c-1.487,1.1-2.955,1.8-3.937,3.213a9.323,9.323,0,0,0-1.44,2.68A11.865,11.865,0,0,0,.136,42.58a10.691,10.691,0,0,0,.038,1.389,4.8,4.8,0,0,0,.958,2.875c.917.959,2.855.828,4.082.618A13.846,13.846,0,0,0,10.623,45a23.09,23.09,0,0,0,2.046-1.42A15.449,15.449,0,0,0,14.967,40.154Z"
          fill="#ffd7b5"
          fillRule="evenodd"
        />
        <path
          id="Path_6707"
          data-name="Path 6707"
          d="M41.407,24.384a5.148,5.148,0,0,0,.787-1.229,4.413,4.413,0,0,1-.891-.741,6.9,6.9,0,0,1-.548-1.471,11.425,11.425,0,0,1,.031-2.509,12.065,12.065,0,0,1,.244-1.5c.137-.406.334-.427.421-.44a2,2,0,0,0,.616-.2,2.23,2.23,0,0,0,1.2-2,1.494,1.494,0,0,0-.485-1.286,1.837,1.837,0,0,0-.6-.273c-.361-.127-.691-.637-.9-.933-.478-.676-.794-1.48-1.325-2.12a10,10,0,0,0-3.833-2.663A4.272,4.272,0,0,0,33.5,6.609C32.4,6.872,32.121,8.1,31.347,8.75c-.438.368-.929.672-1.372,1.044a4.694,4.694,0,0,1-.672.386s-.026.92.013,1.277c.022.2,0,.9,0,.9a2.017,2.017,0,0,0-.715.161,1.812,1.812,0,0,0-.277,1.681,3.831,3.831,0,0,0,.491,1.009,2.218,2.218,0,0,0,.662.508s.351,1.594.469,1.942a11.652,11.652,0,0,0,.721,1.464,8.739,8.739,0,0,0,.653.894L31.581,23a2.608,2.608,0,0,0-.782,1.609,2.474,2.474,0,0,0,1.133,2.142,3.048,3.048,0,0,0,1.842.6A10.58,10.58,0,0,0,39.438,25.9,12.9,12.9,0,0,0,41.407,24.384Z"
          fill="#ffd7b5"
          fillRule="evenodd"
        />
        <path
          id="Path_6708"
          data-name="Path 6708"
          d="M32.743,17.259s.473.038.652.069a10.626,10.626,0,0,0,1.908-.006c.462-.024,1.5-.185,1.5-.185a6.607,6.607,0,0,1-.4.928,7.552,7.552,0,0,1-.526.642,1.963,1.963,0,0,1-.58.34,1.919,1.919,0,0,1-1.588-.223A4.494,4.494,0,0,1,32.743,17.259Z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          id="Path_6709"
          data-name="Path 6709"
          d="M41.039,8a1.556,1.556,0,0,0,.741.354,11.807,11.807,0,0,1,.938,1.093A12.538,12.538,0,0,1,43.5,10.79a4.666,4.666,0,0,1-.461,1.77c-.069.095-.242.39-.242.39a2.469,2.469,0,0,0-.569-.107c-.7.045-.984.345-1.732-.636a4.908,4.908,0,0,1-.583-1.5,4.11,4.11,0,0,1-.74-.769A2.471,2.471,0,0,1,38.647,8.7c.015-.659,1.362-.884,1.847-.862C40.727,7.846,40.891,7.825,41.039,8Z"
          fillRule="evenodd"
        />
        <path
          id="Path_6710"
          data-name="Path 6710"
          d="M33.771,6.984a7.976,7.976,0,0,0-.914.743,16.9,16.9,0,0,1-2.288,2.26,3.6,3.6,0,0,1-1.2.383s-.022,1.316-.059,1.313a1.662,1.662,0,0,1-.556-.3,2.786,2.786,0,0,1-.89-1.486,4.374,4.374,0,0,1,.192-1.269,5.635,5.635,0,0,1,.624-1.259s.6-.174.883-.232a14.794,14.794,0,0,1,2.869-.392A10.126,10.126,0,0,1,33.771,6.984Z"
          fillRule="evenodd"
        />
        <path
          id="Path_6711"
          data-name="Path 6711"
          d="M42.72,3.616A11.585,11.585,0,0,0,38.735.67a6.872,6.872,0,0,0-4.8-.2,12.229,12.229,0,0,0-4.284,2.619,7.271,7.271,0,0,0-.819,1.189,3.874,3.874,0,0,0-.367,1.618c-.051.611-.09,1.159-.09,1.159s-2.307,1.264-2.426,2.074S28,10.241,28,10.241a3.476,3.476,0,0,1,.059-1.472,4.56,4.56,0,0,1,.692-1.325,14.513,14.513,0,0,1,3.06-.691c1.735-.169,3.665.8,5.184,1.555a9.448,9.448,0,0,0,2.2.888,2.73,2.73,0,0,0,1.689-.253,2.626,2.626,0,0,0,.836-.583,5.21,5.21,0,0,1,.87.854,12.179,12.179,0,0,1,.932,1.417A8.118,8.118,0,0,0,44.1,6.849,5.786,5.786,0,0,0,42.72,3.616Z"
          fill="#ada0ec"
          fillRule="evenodd"
        />
        <path
          id="Path_6712"
          data-name="Path 6712"
          d="M25.029,47.167a7.408,7.408,0,1,0-7.408,7.391A7.4,7.4,0,0,0,25.029,47.167Z"
          fill="#67a6f0"
          fillRule="evenodd"
        />
        <path
          id="Path_6713"
          data-name="Path 6713"
          d="M23.951,47.144a6.307,6.307,0,1,0-6.307,6.3A6.305,6.305,0,0,0,23.951,47.144Z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          id="Path_6714"
          data-name="Path 6714"
          d="M20.918,53.786l.44-.177s.483,1.013.595,1.239c.1.208.138.445.068.516-.1.1-.276-.05-.324-.137C21.443,54.769,20.918,53.786,20.918,53.786Z"
          fill="#b0b0b0"
          fillRule="evenodd"
        />
        <path
          id="Path_6715"
          data-name="Path 6715"
          d="M14.293,53.791l-.45-.278s-.193.353-.217.429a7.131,7.131,0,0,1-.467,1.026c-.036.072-.168.3-.074.371.156.118.249-.009.319-.118.18-.28.439-.708.6-1C14.093,54.076,14.293,53.791,14.293,53.791Z"
          fill="#b0b0b0"
          fillRule="evenodd"
        />
        <path
          id="Path_6716"
          data-name="Path 6716"
          d="M16.858,35.54s.324-.1.431-.112a1.64,1.64,0,0,1,1.05.159,1.761,1.761,0,0,1,.347,2.519,2.5,2.5,0,0,1-.781.469,1.636,1.636,0,0,1-.678.033,1.314,1.314,0,0,1-.965-.483,2.7,2.7,0,0,1-.3-.5L15.4,37.7a3.154,3.154,0,0,0,.711.976,2.316,2.316,0,0,0,2.576.056,1.68,1.68,0,0,0,.628-.576,2.309,2.309,0,0,0,.268-.878,2.008,2.008,0,0,0-1.256-2.25,2.383,2.383,0,0,0-1.367-.065c-.129.037-.425.172-.425.172Z"
          fill="#b0b0b0"
          fillRule="evenodd"
        />
        <path
          id="Path_6717"
          data-name="Path 6717"
          d="M18.081,38.406c.018-.116-.291-.259-.291-.259s-.011-.351-.023-.507.01-.405-.116-.511a.244.244,0,0,0-.392.091,3.3,3.3,0,0,0,0,.946s-.2.187-.175.334c.011.053.156.073.2.086C17.456,38.645,18.05,38.614,18.081,38.406Z"
          fill="#65a5ef"
          fillRule="evenodd"
        />
        <path
          id="Path_6718"
          data-name="Path 6718"
          d="M17.845,38.6c.084.035.009.427.05.538a.508.508,0,0,0,.09.187c.064.064.341.378.341.378l-1.521.062s.294-.344.316-.389c.012-.025.049-.123.055-.142a2.485,2.485,0,0,0,.028-.6A4.814,4.814,0,0,1,17.845,38.6Z"
          fill="#65a5ef"
          fillRule="evenodd"
        />
        <path
          id="Path_6719"
          data-name="Path 6719"
          d="M28.719,11.505a.136.136,0,0,0,.1-.044.139.139,0,0,0-.008-.195c-1-.93-.994-2.25.02-3.817a.138.138,0,0,0-.04-.191.136.136,0,0,0-.189.04c-1.386,2.14-.752,3.449.024,4.17A.135.135,0,0,0,28.719,11.505Z"
          fill="#384154"
        />
        <path
          id="Path_6720"
          data-name="Path 6720"
          d="M17.146,36.544a.137.137,0,0,0,.13-.1c.181-.571-.769-1.619-1.722-2.569-.083-.083-.147-.146-.182-.184a3.8,3.8,0,0,1-1.222-2.658.137.137,0,1,0-.274,0,4.055,4.055,0,0,0,1.3,2.846c.036.039.1.105.189.191,1.2,1.2,1.756,1.966,1.654,2.289a.138.138,0,0,0,.089.173A.135.135,0,0,0,17.146,36.544Z"
          fill="#384154"
        />
        <path
          id="Path_6721"
          data-name="Path 6721"
          d="M16.694,36.948a.634.634,0,0,0,.253-.048.592.592,0,0,0,.335-.468.137.137,0,1,0-.268-.054c-.042.213-.141.255-.174.269-.377.163-1.319-.445-2.076-.934l-.072-.046a4.6,4.6,0,0,1-1.229-1.129,7.361,7.361,0,0,0-.8-.861c-.132-.12-.258-.232-.378-.338a4.579,4.579,0,0,1-1.481-1.854.137.137,0,0,0-.178-.076.138.138,0,0,0-.076.179,4.855,4.855,0,0,0,1.554,1.957c.119.105.244.216.375.336a7.044,7.044,0,0,1,.769.832A4.881,4.881,0,0,0,14.544,35.9l.072.047A5.1,5.1,0,0,0,16.694,36.948Z"
          fill="#384154"
        />
        <path
          id="Path_6722"
          data-name="Path 6722"
          d="M15.519,37.773a1.6,1.6,0,0,0,.656-.124,1.057,1.057,0,0,0,.591-.7.138.138,0,0,0-.092-.171.136.136,0,0,0-.17.093.783.783,0,0,1-.441.527c-.534.24-1.528.041-2.8-.562-.258-.122-.6-.332-.936-.534-.3-.184-.59-.359-.822-.475-1.1-.553-2.292-1.559-2.316-2.46a.13.13,0,0,0-.141-.134.138.138,0,0,0-.133.142c.028,1.02,1.259,2.09,2.468,2.7.222.112.5.283.8.465.339.206.69.419.961.548A6.162,6.162,0,0,0,15.519,37.773Z"
          fill="#384154"
        />
        <path
          id="Path_6723"
          data-name="Path 6723"
          d="M12.238,38.065c.995,0,1.965-.151,2.093-.615a.138.138,0,0,0-.1-.17.136.136,0,0,0-.168.1c-.09.327-1.48.543-3.137.331a3.009,3.009,0,0,1-1.753-1.024,7.386,7.386,0,0,0-.848-.724.136.136,0,0,0-.19.035.138.138,0,0,0,.034.192,7.156,7.156,0,0,1,.817.7,3.265,3.265,0,0,0,1.906,1.1A10.894,10.894,0,0,0,12.238,38.065Z"
          fill="#384154"
        />
        <path
          id="Path_6724"
          data-name="Path 6724"
          d="M10.776,39.2a3.193,3.193,0,0,0,2.271-1.174.138.138,0,0,0-.022-.194.137.137,0,0,0-.192.022,2.9,2.9,0,0,1-2.2,1.065L10.3,38.9c-.93-.051-1.6-.088-2.015-1.033-.066-.15-.136-.3-.207-.454a5.663,5.663,0,0,1-.62-1.88A5.733,5.733,0,0,1,10.29,30.43a.138.138,0,0,0,.054-.187.136.136,0,0,0-.186-.054A6.024,6.024,0,0,0,7.19,35.556a5.856,5.856,0,0,0,.644,1.976c.07.151.139.3.2.449.481,1.1,1.3,1.145,2.251,1.2l.327.019C10.67,39.2,10.723,39.2,10.776,39.2Z"
          fill="#384154"
        />
        <path
          id="Path_6725"
          data-name="Path 6725"
          d="M18.643,35.257h.011a.138.138,0,0,0,.126-.148,2.368,2.368,0,0,1,.015-.367,4.182,4.182,0,0,0-.142-1.661c-.079-.284-.124-.529-.164-.746a2.227,2.227,0,0,0-.88-1.618,6.154,6.154,0,0,0-2.862-1.086l-.127-.019a6.544,6.544,0,0,0-4.879.832.138.138,0,0,0-.038.191.136.136,0,0,0,.19.038,6.3,6.3,0,0,1,4.686-.789l.128.02a5.89,5.89,0,0,1,2.73,1.027,1.96,1.96,0,0,1,.784,1.455c.041.222.088.474.17.769a3.938,3.938,0,0,1,.133,1.562,2.54,2.54,0,0,0-.015.412A.137.137,0,0,0,18.643,35.257Z"
          fill="#384154"
        />
        <path
          id="Path_6726"
          data-name="Path 6726"
          d="M18.172,36.4a.75.75,0,0,0,.408-.126.441.441,0,0,0,.211-.341.137.137,0,1,0-.272-.031.167.167,0,0,1-.085.139c-.362.232-.691-.07-.9-.364-.06-.083-.109-.156-.151-.225a.136.136,0,0,0-.188-.046.138.138,0,0,0-.045.189c.045.075.1.154.163.243A1.128,1.128,0,0,0,18.172,36.4Z"
          fill="#384154"
        />
        <path
          id="Path_6727"
          data-name="Path 6727"
          d="M17,34.958a.128.128,0,0,0,.027,0,.137.137,0,0,0,.108-.162l-.1-.522a2.4,2.4,0,0,0-1.915-2.013.138.138,0,0,0-.07.266,2.125,2.125,0,0,1,1.717,1.8l.1.522A.137.137,0,0,0,17,34.958Z"
          fill="#384154"
        />
        <path
          id="Path_6728"
          data-name="Path 6728"
          d="M62.646,45.481a.137.137,0,0,0,.131-.1c.26-.852-.488-2.475-1.211-4.045a23.929,23.929,0,0,1-.938-2.211c-2.083-6.208-2.922-8.475-5.247-10.824a11.534,11.534,0,0,0-5.878-3.07c-.472-.13-.96-.265-1.455-.421-1.133-.356-2.36-.8-3.442-1.2a15.694,15.694,0,0,0-2.871-.92.138.138,0,0,0,0,.276,18.168,18.168,0,0,1,2.778.9c1.085.4,2.315.845,3.454,1.2.5.157.99.292,1.464.423a11.311,11.311,0,0,1,5.756,3C57.47,30.8,58.3,33.054,60.369,39.216a24.131,24.131,0,0,0,.949,2.239c.7,1.523,1.427,3.1,1.2,3.847a.138.138,0,0,0,.091.172A.129.129,0,0,0,62.646,45.481Z"
          fill="#384154"
        />
        <path
          id="Path_6729"
          data-name="Path 6729"
          d="M60.361,57.983a6.093,6.093,0,0,0,3.319-.751,2.824,2.824,0,0,0,1.286-2.213c.271-2.851-1.149-6.742-2.522-10.5l-.255-.7a.137.137,0,1,0-.257.095l.255.7c1.363,3.734,2.772,7.595,2.507,10.383A2.56,2.56,0,0,1,63.532,57c-2.068,1.348-6.772.786-13.983-1.671a49.167,49.167,0,0,0-5.854-1.666c-.637-.145-1.3-.295-2.1-.5a5.164,5.164,0,0,1-1.682-.961c-.894-.668-1.819-1.358-3-.741a.138.138,0,0,0-.058.186.137.137,0,0,0,.184.059c1.026-.538,1.806.044,2.708.718a5.36,5.36,0,0,0,1.777,1.007c.806.21,1.467.36,2.106.505a48.926,48.926,0,0,1,5.827,1.658C54.138,57.184,57.783,57.983,60.361,57.983Z"
          fill="#384154"
        />
        <path
          id="Path_6730"
          data-name="Path 6730"
          d="M15.212,29.977a.135.135,0,0,0,.058-.013,18.409,18.409,0,0,0,2.238-1.347c.583-.389,1.187-.79,1.747-1.092a16.118,16.118,0,0,1,4.4-1.567,24.064,24.064,0,0,0,2.693-.76A18.093,18.093,0,0,0,31.621,22.5a.138.138,0,0,0,.03-.192.136.136,0,0,0-.191-.03,17.857,17.857,0,0,1-5.2,2.656,23.8,23.8,0,0,1-2.664.752,16.357,16.357,0,0,0-4.469,1.592c-.571.308-1.18.714-1.768,1.105a18.234,18.234,0,0,1-2.2,1.328.138.138,0,0,0-.066.183A.137.137,0,0,0,15.212,29.977Z"
          fill="#384154"
        />
        <path
          id="Path_6731"
          data-name="Path 6731"
          d="M3.713,47.742a11.313,11.313,0,0,0,5.169-1.455c.441-.24.923-.572,1.348-.865l.263-.181a.137.137,0,0,0-.153-.228l-.264.182c-.42.289-.895.617-1.323.849-2.485,1.35-5.235,1.793-6.844,1.1A2.043,2.043,0,0,1,.654,45.8a7.716,7.716,0,0,1,1.233-7.18A9.188,9.188,0,0,1,4.7,36.127a14.666,14.666,0,0,0,2.973-2.385.138.138,0,0,0,0-.195.136.136,0,0,0-.194,0A14.239,14.239,0,0,1,4.554,35.9a9.535,9.535,0,0,0-2.886,2.559A7.971,7.971,0,0,0,.391,45.87,2.333,2.333,0,0,0,1.8,47.4,4.89,4.89,0,0,0,3.713,47.742Z"
          fill="#384154"
        />
        <path
          id="Path_6732"
          data-name="Path 6732"
          d="M19.146,67.037c-.1,2.171-.347,4.072-.569,5.748-.046.347-.091.686-.132,1.014h-.276c.043-.34.089-.691.137-1.05.221-1.671.472-3.565.567-5.725.023-.522.049-1.064.075-1.618a69.949,69.949,0,0,0,0-10.905.137.137,0,0,1,.117-.155.139.139,0,0,1,.154.118,70.058,70.058,0,0,1,.006,10.956C19.195,65.973,19.17,66.515,19.146,67.037Z"
          fill="#384154"
        />
        <path
          id="Path_6733"
          data-name="Path 6733"
          d="M5.843,45.71A.134.134,0,0,0,5.9,45.7a4.334,4.334,0,0,0,2.421-2.428c.033-.072.065-.144.1-.214l.112-.238a12.837,12.837,0,0,1,2.255-3.6.138.138,0,0,0,0-.195.137.137,0,0,0-.194,0A13.258,13.258,0,0,0,8.287,42.7l-.111.237c-.034.071-.067.144-.1.218a4.1,4.1,0,0,1-2.293,2.295.138.138,0,0,0-.062.184A.137.137,0,0,0,5.843,45.71Z"
          fill="#384154"
        />
        <path
          id="Path_6734"
          data-name="Path 6734"
          d="M36.83,52.558a2.542,2.542,0,0,0,1.4-.6.541.541,0,0,0,.2-.4.133.133,0,0,0-.144-.131.137.137,0,0,0-.13.145c0,.022-.008.085-.117.191a2.191,2.191,0,0,1-1.248.523,2.02,2.02,0,0,1-1.219-.819.838.838,0,0,1-.208-.626c.069-.3.629-.718,1.079-1.057a3.263,3.263,0,0,0,.849-.773.138.138,0,0,0-.058-.186.136.136,0,0,0-.185.059,3.453,3.453,0,0,1-.771.68c-.536.4-1.089.82-1.181,1.215a1.08,1.08,0,0,0,.253.851,2.27,2.27,0,0,0,1.418.932Z"
          fill="#384154"
        />
        <path
          id="Path_6735"
          data-name="Path 6735"
          d="M35.123,51.421c.043,0,.086,0,.129-.005a.138.138,0,0,0-.022-.274,1.483,1.483,0,0,1-1.079-.357,1.04,1.04,0,0,1-.36-.743c-.015-.395.579-.989,1.155-1.564A5.655,5.655,0,0,0,36.13,47.04a.137.137,0,1,0-.252-.108,5.544,5.544,0,0,1-1.124,1.351c-.646.645-1.255,1.254-1.235,1.77a1.3,1.3,0,0,0,.451.938A1.774,1.774,0,0,0,35.123,51.421Z"
          fill="#384154"
        />
        <path
          id="Path_6736"
          data-name="Path 6736"
          d="M33.564,50.2h.016a.138.138,0,0,0,0-.276h-.014c-.656,0-1.14-.655-1.375-1.271a1.917,1.917,0,0,1,.136-1.986,4.119,4.119,0,0,1,1.164-.652,3.575,3.575,0,0,0,1.455-.932.139.139,0,0,0-.017-.194.136.136,0,0,0-.193.017,3.316,3.316,0,0,1-1.352.856,4.381,4.381,0,0,0-1.238.7,2.191,2.191,0,0,0-.211,2.292C32.2,49.456,32.77,50.2,33.564,50.2Z"
          fill="#384154"
        />
        <path
          id="Path_6737"
          data-name="Path 6737"
          d="M33.535,48.875a.134.134,0,0,0,.066-.017c.555-.306,1.665-.829,1.676-.834a.138.138,0,0,0,.066-.183.137.137,0,0,0-.182-.066c-.011.005-1.129.532-1.692.842a.138.138,0,0,0-.054.187A.136.136,0,0,0,33.535,48.875Z"
          fill="#384154"
        />
        <path
          id="Path_6738"
          data-name="Path 6738"
          d="M61.043,50.817a.138.138,0,0,0,.064-.259c-3.051-1.633-6.141-1.577-9.128-1.524a17.4,17.4,0,0,1-6.474-.668A15.412,15.412,0,0,1,43,47.034c-.4-.245-.818-.5-1.234-.73-.57-.317-1.017-.55-1.45-.775-.547-.285-1.064-.554-1.772-.963-.154-.089-.308-.182-.463-.275a12.55,12.55,0,0,0-1.323-.723,9.9,9.9,0,0,0-3.88-.75,27.19,27.19,0,0,1-3.524-.487l-.292-.054c-.718-.131-1.175-.083-1.395.149a.617.617,0,0,0-.117.595c.2.858,3.229,1.811,3.779,1.951.329.083.673.146,1.005.206a3.5,3.5,0,0,1,1.545.482.136.136,0,0,0,.194,0,.138.138,0,0,0,0-.195,3.479,3.479,0,0,0-1.691-.559c-.328-.06-.667-.121-.987-.2-1.159-.294-3.454-1.2-3.579-1.745-.054-.234.023-.316.049-.342.084-.089.345-.216,1.148-.068l.292.054a27.4,27.4,0,0,0,3.563.492,9.668,9.668,0,0,1,3.78.727,12.344,12.344,0,0,1,1.293.708c.156.094.312.187.467.277.714.413,1.233.683,1.783.969.431.224.877.456,1.443.771.411.229.825.481,1.224.725a15.866,15.866,0,0,0,2.548,1.354,17.6,17.6,0,0,0,6.575.685c2.953-.052,6.007-.108,8.995,1.492A.135.135,0,0,0,61.043,50.817Z"
          fill="#384154"
        />
        <path
          id="Path_6739"
          data-name="Path 6739"
          d="M32.372,50.624a1.69,1.69,0,0,0,1.046-.415.138.138,0,0,0,.024-.193.136.136,0,0,0-.192-.024,1.166,1.166,0,0,1-1.332.249c-.432-.195-.312-.582-.066-1.2a2.4,2.4,0,0,0,.213-.73.137.137,0,0,0-.132-.143.141.141,0,0,0-.142.133,2.252,2.252,0,0,1-.194.637c-.208.521-.494,1.235.188,1.543A1.348,1.348,0,0,0,32.372,50.624Z"
          fill="#384154"
        />
        <path
          id="Path_6740"
          data-name="Path 6740"
          d="M17.449,39.206l.09,0a2.245,2.245,0,0,0,1.052-4.215,2.518,2.518,0,0,0-2.011-.012.138.138,0,0,0-.069.182.136.136,0,0,0,.181.07,2.23,2.23,0,0,1,1.781.008,1.973,1.973,0,0,1,1.013,1.782,2.03,2.03,0,0,1-3.917.619.137.137,0,1,0-.259.09A2.254,2.254,0,0,0,17.449,39.206Z"
          fill="#384154"
        />
        <path
          id="Path_6741"
          data-name="Path 6741"
          d="M17.449,38.762h.071a1.837,1.837,0,0,0,1.3-.606,1.562,1.562,0,0,0,.4-1.158,2.348,2.348,0,0,0-.332-1.042,1.619,1.619,0,0,0-2.026-.581.138.138,0,0,0-.089.173.136.136,0,0,0,.172.09,1.355,1.355,0,0,1,1.715.47,2.057,2.057,0,0,1,.287.911,1.288,1.288,0,0,1-.333.954,1.561,1.561,0,0,1-1.107.514,1.5,1.5,0,0,1-1.34-.689,1.373,1.373,0,0,1-.1-.2.137.137,0,1,0-.252.107,1.657,1.657,0,0,0,.124.239A1.779,1.779,0,0,0,17.449,38.762Z"
          fill="#384154"
        />
        <path
          id="Path_6742"
          data-name="Path 6742"
          d="M17.625,54.663q-.149,0-.3-.006a7.555,7.555,0,0,1-5.271-2.411,7.471,7.471,0,0,1-2.017-5.411A7.562,7.562,0,0,1,17.6,39.589c.1,0,.2,0,.3.006a7.555,7.555,0,0,1,5.271,2.411,7.533,7.533,0,0,1-5.542,12.658Zm-.025-14.8a7.286,7.286,0,0,0-7.29,6.982,7.2,7.2,0,0,0,1.943,5.212,7.337,7.337,0,0,0,10.325.4,7.188,7.188,0,0,0,2.331-5.048h0a7.2,7.2,0,0,0-1.943-5.212,7.282,7.282,0,0,0-5.082-2.324Q17.742,39.864,17.6,39.864Z"
          fill="#384154"
        />
        <path
          id="Path_6743"
          data-name="Path 6743"
          d="M17.6,54.039q.137,0,.275-.005a6.944,6.944,0,0,0,6.685-7.174,6.846,6.846,0,0,0-2.22-4.807,6.979,6.979,0,0,0-9.822.377A6.909,6.909,0,0,0,17.6,54.039Zm.026-13.55a6.644,6.644,0,0,1,4.528,1.767,6.571,6.571,0,0,1,2.131,4.614A6.688,6.688,0,0,1,13.076,52a6.569,6.569,0,0,1-2.131-4.614h0a6.577,6.577,0,0,1,1.776-4.764,6.657,6.657,0,0,1,4.645-2.124Q17.5,40.489,17.63,40.489Z"
          fill="#384154"
        />
        <path
          id="Path_6744"
          data-name="Path 6744"
          d="M13.967,54.426c.073,0,.15-.054.392-.545A.139.139,0,0,0,14.3,53.7a.137.137,0,0,0-.184.062c-.051.1-.114.221-.163.306A.558.558,0,0,0,13.866,54a.475.475,0,0,0-.1-.043c.039-.078.1-.183.157-.279a.138.138,0,0,0-.043-.19.136.136,0,0,0-.189.043c-.313.5-.257.574-.212.634a.16.16,0,0,0,.177.053c.037-.014.137.053.154.093a.146.146,0,0,0,.126.108Zm-.246-.353h0Z"
          fill="#384154"
        />
        <path
          id="Path_6745"
          data-name="Path 6745"
          d="M13.252,55.52a.311.311,0,0,0,.269-.16c.111-.189.354-.643.445-.813l.014-.025a.235.235,0,0,0-.017-.24.544.544,0,0,0-.393-.225.183.183,0,0,0-.161.1c-.047.095-.362.712-.46.9a.311.311,0,0,0,.137.417A.337.337,0,0,0,13.252,55.52Zm.473-1.1c-.086.161-.33.617-.439.8-.007.013-.024.038-.066.015,0,0-.041-.024-.028-.049.085-.164.335-.651.431-.841A.335.335,0,0,1,13.725,54.418Z"
          fill="#384154"
        />
        <path
          id="Path_6746"
          data-name="Path 6746"
          d="M21.175,54.434h.017a.159.159,0,0,0,.145-.115c.012-.037.123-.08.163-.073a.144.144,0,0,0,.161-.042c.054-.063.1-.113-.2-.66a.137.137,0,1,0-.24.132c.055.1.114.22.155.31a.565.565,0,0,0-.1.036.5.5,0,0,0-.092.058c-.041-.077-.093-.185-.136-.29a.136.136,0,0,0-.179-.074.138.138,0,0,0-.073.18C21.008,54.4,21.1,54.434,21.175,54.434Z"
          fill="#384154"
        />
        <path
          id="Path_6747"
          data-name="Path 6747"
          d="M21.874,55.542a.347.347,0,0,0,.151-.036.317.317,0,0,0,.156-.425c-.092-.2-.332-.686-.411-.844a.239.239,0,0,0-.213-.14.527.527,0,0,0-.408.195.185.185,0,0,0-.01.19c.05.093.37.707.468.9A.3.3,0,0,0,21.874,55.542Zm-.343-1.169c.1.192.315.633.4.822.006.013.019.041-.026.063,0,0-.042.019-.055,0-.085-.165-.338-.65-.437-.839A.34.34,0,0,1,21.531,54.373Zm-.152-.022h0Z"
          fill="#384154"
        />
        <path
          id="Path_6748"
          data-name="Path 6748"
          d="M17.275,39.168h.018a.138.138,0,0,0,.118-.154c-.007-.058-.009-.166-.011-.251l0-.087a.14.14,0,0,0-.142-.133.138.138,0,0,0-.132.143l0,.083c0,.1,0,.216.013.281A.137.137,0,0,0,17.275,39.168Z"
          fill="#384154"
        />
        <path
          id="Path_6749"
          data-name="Path 6749"
          d="M17.871,39.112h.012a.137.137,0,0,0,.124-.149c-.016-.185-.021-.233-.023-.3a.142.142,0,0,0-.142-.133.138.138,0,0,0-.132.143c0,.074.007.125.024.318A.137.137,0,0,0,17.871,39.112Z"
          fill="#384154"
        />
        <path
          id="Path_6750"
          data-name="Path 6750"
          d="M17.506,39.5a1.136,1.136,0,0,0,.4-.064.243.243,0,0,0,.147-.192.354.354,0,0,0-.068-.273.136.136,0,0,0-.193.012.139.139,0,0,0-.016.16.132.132,0,0,1,.007.057,1.267,1.267,0,0,1-.4.017v-.013a.835.835,0,0,0,0-.1.132.132,0,0,0-.142-.132.137.137,0,0,0-.132.143.452.452,0,0,1,0,.061.246.246,0,0,0,.149.293A.921.921,0,0,0,17.506,39.5Z"
          fill="#384154"
        />
        <path
          id="Path_6751"
          data-name="Path 6751"
          d="M16.952,39.846h.006a.138.138,0,0,0,.131-.143.262.262,0,0,1,.14-.24.138.138,0,0,0-.121-.247.539.539,0,0,0-.292.5A.137.137,0,0,0,16.952,39.846Z"
          fill="#384154"
        />
        <path
          id="Path_6752"
          data-name="Path 6752"
          d="M17.051,38.645a.137.137,0,0,0,.134-.113c.043-.24.313-.271.466-.252s.287.1.281.181a.138.138,0,0,0,.127.147.136.136,0,0,0,.146-.128c.016-.238-.2-.433-.52-.474a.645.645,0,0,0-.77.476.138.138,0,0,0,.11.16Z"
          fill="#384154"
        />
        <path
          id="Path_6753"
          data-name="Path 6753"
          d="M17.265,38.272h.005a.138.138,0,0,0,.132-.143l0-.08c0-.025,0-.049,0-.077a.735.735,0,0,1,.253-.023c0,.023,0,.05,0,.067a.651.651,0,0,0,0,.075.137.137,0,1,0,.274-.01.4.4,0,0,1,0-.045.442.442,0,0,0-.034-.252c-.1-.183-.514-.091-.518-.09-.2.046-.241.146-.243.221a1.267,1.267,0,0,0,0,.152l0,.071A.138.138,0,0,0,17.265,38.272Z"
          fill="#384154"
        />
        <path
          id="Path_6754"
          data-name="Path 6754"
          d="M17.3,37.957a.136.136,0,0,0,.071-.02.138.138,0,0,0,.046-.188c-.01-.018-.024-.059-.013-.077a.252.252,0,0,1,.149-.011.555.555,0,0,1,0,.125.137.137,0,0,0,.113.158.136.136,0,0,0,.157-.114c.018-.113.03-.313-.1-.394a.493.493,0,0,0-.348-.043.31.31,0,0,0-.2.134.366.366,0,0,0,.012.364A.137.137,0,0,0,17.3,37.957Z"
          fill="#384154"
        />
        <path
          id="Path_6755"
          data-name="Path 6755"
          d="M17.382,37.671a.137.137,0,0,0,.132-.1.139.139,0,0,0,0-.063.136.136,0,0,0,.249.035.379.379,0,0,0,.034-.4.363.363,0,0,0-.344-.169.385.385,0,0,0-.339.2.365.365,0,0,0,0,.3.349.349,0,0,0,.227.2A.135.135,0,0,0,17.382,37.671Zm.089-.423a.113.113,0,0,1,.093.034c.009.015.006.056-.032.12a.138.138,0,0,0-.017.1.138.138,0,0,0-.094-.1.074.074,0,0,1-.05-.039.107.107,0,0,1-.009-.069.124.124,0,0,1,.1-.044Z"
          fill="#384154"
        />
        <path
          id="Path_6756"
          data-name="Path 6756"
          d="M17.6,53.557c.084,0,.168,0,.252,0a6.46,6.46,0,0,0,6.219-6.674,6.367,6.367,0,0,0-2.065-4.472,6.493,6.493,0,0,0-9.137.351,6.375,6.375,0,0,0-1.721,4.617A6.451,6.451,0,0,0,17.6,53.557Zm.022-12.586a6.161,6.161,0,0,1,4.2,1.639A6.091,6.091,0,0,1,23.8,46.888a6.193,6.193,0,0,1-12.376.475,6.1,6.1,0,0,1,1.647-4.418,6.174,6.174,0,0,1,4.308-1.97Q17.5,40.971,17.626,40.971Z"
          fill="#384154"
        />
        <path
          id="Path_6757"
          data-name="Path 6757"
          d="M17.735,47.195a.137.137,0,0,0,.136-.129l.355-5.4a.137.137,0,1,0-.273-.018l-.355,5.4a.138.138,0,0,0,.127.147Z"
          fill="#384154"
        />
        <path
          id="Path_6758"
          data-name="Path 6758"
          d="M17.709,47.2h.007a.137.137,0,0,0,.13-.144l-.18-3.659a.133.133,0,0,0-.143-.131.137.137,0,0,0-.13.144l.18,3.659A.137.137,0,0,0,17.709,47.2Z"
          fill="#384154"
        />
        <path
          id="Path_6759"
          data-name="Path 6759"
          d="M17.734,47.43h.01a.292.292,0,0,0-.011-.584h-.01a.292.292,0,0,0,.011.584Zm0-.308v.032l-.017-.015A.016.016,0,0,1,17.733,47.121Z"
          fill="#384154"
        />
        <path
          id="Path_6760"
          data-name="Path 6760"
          d="M15.33,43.789a.136.136,0,0,1-.117-.067s-.177-.295-.353-.6c-.042-.072-.085-.15-.125-.223a.137.137,0,0,1-.129.113.134.134,0,0,1-.142-.132c-.015-.37.06-.447.144-.475.045-.015.134-.023.215.1.03.045.086.145.15.26.04.072.083.15.125.222.175.3.35.6.35.6a.138.138,0,0,1-.047.189A.135.135,0,0,1,15.33,43.789Z"
          fill="#384154"
        />
        <path
          id="Path_6761"
          data-name="Path 6761"
          d="M15.857,43.431a.137.137,0,0,1-.117-.067s-.176-.295-.352-.6c-.042-.072-.085-.151-.125-.223a.137.137,0,0,1-.271-.019c-.015-.37.061-.447.144-.475a.182.182,0,0,1,.215.1c.03.044.084.142.146.254.041.074.085.154.128.228.175.3.35.6.35.6a.139.139,0,0,1-.047.189A.137.137,0,0,1,15.857,43.431Z"
          fill="#384154"
        />
        <path
          id="Path_6762"
          data-name="Path 6762"
          d="M17.2,43.071a.137.137,0,0,1-.137-.131s-.016-.344-.026-.7c0-.083,0-.173,0-.256a.137.137,0,0,1-.23-.147c.162-.333.264-.365.351-.349.047.009.129.044.143.188.005.054.007.167.009.3,0,.084,0,.174,0,.259.01.351.025.692.025.693a.137.137,0,0,1-.13.144Z"
          fill="#384154"
        />
        <path
          id="Path_6763"
          data-name="Path 6763"
          d="M19.9,43.707a.137.137,0,0,1-.117-.209s.176-.295.363-.595c.044-.071.093-.146.138-.216a.138.138,0,0,1-.11-.251c.318-.185.421-.155.484-.093a.184.184,0,0,1,.015.237c-.025.047-.085.141-.155.249-.046.071-.1.148-.141.221-.185.3-.36.59-.36.59A.136.136,0,0,1,19.9,43.707Z"
          fill="#384154"
        />
        <path
          id="Path_6764"
          data-name="Path 6764"
          d="M21.362,45.495c-.373-.545-.374-.641-.332-.727.019-.04.08-.162.52-.073a1.115,1.115,0,0,0,.723-.011.138.138,0,0,0,.039-.169c-.016-.043-.071-.138-.243-.1A.138.138,0,0,1,22,44.15a.456.456,0,0,1,.563.266.41.41,0,0,1-.164.51,1.323,1.323,0,0,1-.908.038c-.033-.007-.1-.015-.157-.02.04.074.113.194.243.384Z"
          fill="#384154"
        />
        <path
          id="Path_6765"
          data-name="Path 6765"
          d="M17.714,43.076c-.209,0-.277-.032-.318-.094-.079-.122.021-.25.254-.493a1.165,1.165,0,0,0,.376-.65c0-.061-.062-.109-.126-.12-.045-.008-.155-.007-.206.161a.136.136,0,0,1-.171.091.138.138,0,0,1-.091-.172.45.45,0,0,1,.513-.352.408.408,0,0,1,.354.4,1.346,1.346,0,0,1-.43.807l-.023.024c-.047.049-.083.088-.111.12.083,0,.207-.008.392-.023l.057,0a.141.141,0,0,1,.146.128.138.138,0,0,1-.128.147l-.052,0C17.96,43.068,17.82,43.076,17.714,43.076Z"
          fill="#384154"
        />
        <path
          id="Path_6766"
          data-name="Path 6766"
          d="M22.29,47.689a.455.455,0,0,1-.131-.02.562.562,0,0,1-.358-.488.475.475,0,0,1,.217-.482.138.138,0,0,1,.133.241c-.088.049-.081.174-.077.211a.292.292,0,0,0,.165.254.209.209,0,0,0,.232-.1.281.281,0,0,0,.037-.169.139.139,0,0,1,.087-.144.136.136,0,0,1,.16.048c.032.044.145.167.237.139a.107.107,0,0,0,.079-.089.161.161,0,0,0-.088-.161.138.138,0,0,1-.04-.19.137.137,0,0,1,.189-.04.44.44,0,0,1,.208.437.38.38,0,0,1-.281.312.425.425,0,0,1-.324-.057.429.429,0,0,1-.043.076A.5.5,0,0,1,22.29,47.689Z"
          fill="#384154"
        />
        <path
          id="Path_6767"
          data-name="Path 6767"
          d="M13.706,45.659a.135.135,0,0,1-.062-.015s-.306-.154-.617-.318c-.074-.039-.152-.081-.225-.121a.138.138,0,0,1-.049.165.136.136,0,0,1-.19-.035c-.209-.3-.186-.41-.131-.479a.18.18,0,0,1,.233-.034c.049.021.147.075.258.136.074.04.154.084.229.124.31.163.613.316.613.316a.139.139,0,0,1,.061.185A.137.137,0,0,1,13.706,45.659Z"
          fill="#384154"
        />
        <path
          id="Path_6768"
          data-name="Path 6768"
          d="M13.8,45.15a1.1,1.1,0,0,1-.55-.167c-.4-.237-.59-.628-.439-.891a.42.42,0,0,1,.267-.193.981.981,0,0,1,.716.147c.4.237.59.629.439.891a.419.419,0,0,1-.266.192A.658.658,0,0,1,13.8,45.15Zm-.752-.919c-.063.11.069.353.342.515a.735.735,0,0,0,.507.117.152.152,0,0,0,.1-.064c.063-.109-.07-.353-.342-.516a.733.733,0,0,0-.508-.117A.153.153,0,0,0,13.044,44.231Z"
          fill="#384154"
        />
        <path
          id="Path_6769"
          data-name="Path 6769"
          d="M12.526,47.733a.531.531,0,0,1-.065,0,.629.629,0,0,1-.418-.238.578.578,0,0,1-.107-.438c.047-.346.391-.38.6-.4a1.622,1.622,0,0,1,.825.131.453.453,0,0,1,.245.377.569.569,0,0,1-.192.5.136.136,0,0,1-.192-.027.138.138,0,0,1,.026-.193.306.306,0,0,0,.085-.251.184.184,0,0,0-.093-.156,1.052,1.052,0,0,0-.249-.082.7.7,0,0,1-.118.625A.455.455,0,0,1,12.526,47.733Zm.166-.812c-.045,0-.087,0-.125.006-.239.024-.345.053-.36.164a.3.3,0,0,0,.053.233.36.36,0,0,0,.236.131.186.186,0,0,0,.17-.062.522.522,0,0,0,.038-.462s0-.007,0-.01Z"
          fill="#384154"
        />
        <path
          id="Path_6770"
          data-name="Path 6770"
          d="M17.646,52.7a.55.55,0,0,1-.314-.1.634.634,0,0,1-.258-.406.464.464,0,0,1,.128-.422.7.7,0,0,1,.613-.154,1.063,1.063,0,0,0-.095-.245.181.181,0,0,0-.16-.084.3.3,0,0,0-.244.1.136.136,0,0,1-.19.037.138.138,0,0,1-.037-.191.556.556,0,0,1,.483-.221.449.449,0,0,1,.387.225,1.656,1.656,0,0,1,.177.815c-.008.2-.023.563-.364.63A.645.645,0,0,1,17.646,52.7Zm.017-.813a.376.376,0,0,0-.269.085.19.19,0,0,0-.052.175.361.361,0,0,0,.143.23.3.3,0,0,0,.235.04c.11-.022.132-.129.142-.363a1.4,1.4,0,0,0,0-.145l-.01,0A.935.935,0,0,0,17.663,51.89Z"
          fill="#384154"
        />
        <path
          id="Path_6771"
          data-name="Path 6771"
          d="M14.846,51.98a.136.136,0,0,1-.11-.056.138.138,0,0,1,.03-.192c.053-.039.2-.158.368-.292.29-.233.465-.372.568-.449a3.454,3.454,0,0,0-.468-.225.138.138,0,0,1,.1-.256c.7.278.7.417.705.484a.175.175,0,0,1-.1.165c-.054.031-.4.312-.635.5-.171.138-.323.259-.377.3A.135.135,0,0,1,14.846,51.98Zm.933-.932h0Zm.035-.137h0Z"
          fill="#384154"
        />
        <path
          id="Path_6772"
          data-name="Path 6772"
          d="M20.194,52.063a.138.138,0,0,1-.005-.276.531.531,0,0,0,.454-.293.166.166,0,0,0-.033-.2c-.122-.126-.306-.075-.6.162a.157.157,0,0,1-.179,0,1.511,1.511,0,0,1-.314-.705c.021-.058.044-.072.316-.245.092-.058.184-.117.227-.148a.137.137,0,0,1,.191.031.138.138,0,0,1-.031.192c-.045.033-.143.1-.241.158l-.172.11c.035.086.094.217.141.306.358-.254.645-.274.856-.056a.443.443,0,0,1,.091.49.8.8,0,0,1-.7.466Zm-.352-.817h0Z"
          fill="#384154"
        />
        <path
          id="Path_6773"
          data-name="Path 6773"
          d="M21.72,50.2a.238.238,0,0,1-.053-.009c-.184-.047-.478-1.141-.479-1.152a.161.161,0,0,1,.09-.177c.1-.045.455.162.771.374l.064-.105a.137.137,0,1,1,.233.145l-.07.116c.192.136.335.246.339.249a.138.138,0,0,1,.017.194.136.136,0,0,1-.193.017c-.062-.052-.174-.134-.3-.224C21.848,50.111,21.793,50.2,21.72,50.2Zm-.206-.974c.055.171.14.4.206.562.057-.094.127-.21.188-.312C21.767,49.379,21.625,49.289,21.514,49.222Z"
          fill="#384154"
        />
        <path
          id="Path_6774"
          data-name="Path 6774"
          d="M13.28,50.42a.527.527,0,0,1-.327-.126.6.6,0,0,1-.2-.758.639.639,0,0,1,.657-.18,1.336,1.336,0,0,1,.135.039.546.546,0,0,1,.327-.438.4.4,0,0,1,.549.175.444.444,0,0,1-.178.6.569.569,0,0,1-.453.047c0,.008,0,.016,0,.024a.848.848,0,0,1-.18.464A.438.438,0,0,1,13.28,50.42Zm-.06-.809a.3.3,0,0,0-.241.082c-.062.09.008.277.144.385.11.089.206.088.283,0a.583.583,0,0,0,.11-.3.389.389,0,0,0,0-.077l0-.026a1.285,1.285,0,0,0-.159-.051A.589.589,0,0,0,13.22,49.611Zm.584-.118a.343.343,0,0,0,.3,0,.169.169,0,0,0,.071-.229.129.129,0,0,0-.189-.053c-.137.065-.15.129-.181.269Zm.127-.41h0Z"
          fill="#384154"
        />
        <path
          id="Path_6775"
          data-name="Path 6775"
          d="M34.814,21.966h.014A6.385,6.385,0,0,0,39.949,18.7a.138.138,0,0,0-.052-.188.136.136,0,0,0-.186.052,6.188,6.188,0,0,1-4.884,3.125,5.237,5.237,0,0,1-3.637-2.052,8.54,8.54,0,0,1-1.59-4.445.137.137,0,1,0-.273.016,8.827,8.827,0,0,0,1.645,4.6A5.482,5.482,0,0,0,34.814,21.966Z"
          fill="#384154"
        />
        <path
          id="Path_6776"
          data-name="Path 6776"
          d="M41.376,16.6a2,2,0,0,0,1.219-.535,2.363,2.363,0,0,0,.828-1.764,1.5,1.5,0,0,0-.657-1.464,1.22,1.22,0,0,0-1.308.317.139.139,0,0,0-.015.194.136.136,0,0,0,.193.015.966.966,0,0,1,1.015-.277c.323.152.5.594.5,1.212a2.089,2.089,0,0,1-.734,1.558,1.606,1.606,0,0,1-1.129.462.138.138,0,0,0-.036.273A.923.923,0,0,0,41.376,16.6Z"
          fill="#384154"
        />
        <path
          id="Path_6777"
          data-name="Path 6777"
          d="M29.465,15.861a.138.138,0,0,0,.036-.271c-.012,0-.661-.207-1.014-1.408a1.658,1.658,0,0,1,.119-1.434.623.623,0,0,1,.554-.245.138.138,0,0,0,.014-.275.9.9,0,0,0-.783.35,1.9,1.9,0,0,0-.167,1.682c.4,1.367,1.172,1.588,1.205,1.6A.134.134,0,0,0,29.465,15.861Z"
          fill="#384154"
        />
        <path
          id="Path_6778"
          data-name="Path 6778"
          d="M34.507,15.682a.136.136,0,0,0,.107-.052.138.138,0,0,0-.022-.194c-.558-.446-.463-.643-.274-1.035a1.9,1.9,0,0,0,.1-1.7.137.137,0,1,0-.256.1,1.625,1.625,0,0,1-.092,1.485c-.2.405-.38.788.35,1.372A.136.136,0,0,0,34.507,15.682Z"
          fill="#384154"
        />
        <path
          id="Path_6779"
          data-name="Path 6779"
          d="M38.7,11.03a.136.136,0,0,0,.111-.057.138.138,0,0,0-.03-.192,2.842,2.842,0,0,0-2.559-.26.138.138,0,0,0-.052.188.137.137,0,0,0,.186.053A2.605,2.605,0,0,1,38.622,11,.136.136,0,0,0,38.7,11.03Z"
          fill="#384154"
        />
        <path
          id="Path_6780"
          data-name="Path 6780"
          d="M41.831,15.074a.137.137,0,0,0,.125-.081,1.884,1.884,0,0,1,.357-.5.138.138,0,0,0,0-.195.136.136,0,0,0-.193,0,2.142,2.142,0,0,0-.417.588.138.138,0,0,0,.069.182A.135.135,0,0,0,41.831,15.074Z"
          fill="#384154"
        />
        <path
          id="Path_6781"
          data-name="Path 6781"
          d="M29.375,13.682h.006a.137.137,0,0,0,.131-.143c0-.019-.082-1.965-.049-3.158a.137.137,0,1,0-.274-.008c-.034,1.2.048,3.158.049,3.178A.137.137,0,0,0,29.375,13.682Z"
          fill="#384154"
        />
        <path
          id="Path_6782"
          data-name="Path 6782"
          d="M38.074,13.024a.494.494,0,0,0-.5-.5.521.521,0,0,0-.4.6.494.494,0,0,0,.5.5A.521.521,0,0,0,38.074,13.024Z"
          fill="#384154"
          fillRule="evenodd"
        />
        <path
          id="Path_6783"
          data-name="Path 6783"
          d="M40.774,10.984l.1,0a.137.137,0,0,0,.131-.144.139.139,0,0,0-.143-.132c-.87.036-1.519-.476-2.042-1.618a.136.136,0,0,0-.182-.067.138.138,0,0,0-.067.183C39.12,10.4,39.841,10.984,40.774,10.984Z"
          fill="#384154"
        />
        <path
          id="Path_6784"
          data-name="Path 6784"
          d="M29.523,10.5c1.091,0,1.932-.987,2.69-1.877a4.16,4.16,0,0,1,1.7-1.461.138.138,0,0,0-.066-.268A4.3,4.3,0,0,0,32,8.441c-.913,1.073-1.858,2.182-3.166,1.635a.138.138,0,0,0-.1.254A2.033,2.033,0,0,0,29.523,10.5Z"
          fill="#384154"
        />
        <path
          id="Path_6785"
          data-name="Path 6785"
          d="M34.639,19.316h.043c1.742-.046,2.234-2.1,2.238-2.121a.139.139,0,0,0-.034-.126.137.137,0,0,0-.124-.041,14.883,14.883,0,0,1-2.193.216,9.808,9.808,0,0,1-1.812-.149.136.136,0,0,0-.127.041.138.138,0,0,0-.032.13C32.621,17.351,33.176,19.316,34.639,19.316Zm1.954-1.98a2.269,2.269,0,0,1-1.918,1.7c-1.013.037-1.56-1.145-1.742-1.635a11.139,11.139,0,0,0,1.638.115A14.66,14.66,0,0,0,36.592,17.335Z"
          fill="#384154"
        />
        <path
          id="Path_6786"
          data-name="Path 6786"
          d="M41.385,12.752a.138.138,0,0,0,0-.276c-.538-.017-.867-.356-1.066-1.1a.137.137,0,1,0-.264.072c.084.315.341,1.275,1.322,1.3Z"
          fill="#384154"
        />
        <path
          id="Path_6787"
          data-name="Path 6787"
          d="M32.478,12.974a.494.494,0,0,0-.5-.5.521.521,0,0,0-.4.6.494.494,0,0,0,.5.5A.521.521,0,0,0,32.478,12.974Z"
          fill="#384154"
          fillRule="evenodd"
        />
        <path
          id="Path_6788"
          data-name="Path 6788"
          d="M42.054,23.235a.136.136,0,0,0,.114-.062.138.138,0,0,0-.039-.191q-.117-.078-.229-.162c-1.361-1.02-1.164-3.309-.845-5.567a.137.137,0,1,0-.271-.039c-.331,2.34-.529,4.717.952,5.827.078.059.159.116.242.171A.137.137,0,0,0,42.054,23.235Z"
          fill="#384154"
        />
        <path
          id="Path_6789"
          data-name="Path 6789"
          d="M31.82,24.526l.021,0a.138.138,0,0,0,.114-.157c-.13-.852-.492-4.311-.5-4.346a.137.137,0,1,0-.272.029c0,.035.367,3.5.5,4.359A.137.137,0,0,0,31.82,24.526Z"
          fill="#384154"
        />
        <path
          id="Path_6790"
          data-name="Path 6790"
          d="M42.846,13.006a.136.136,0,0,0,.111-.056,3.929,3.929,0,0,0,.659-2.214,9.483,9.483,0,0,0,.594-3.984c-.566-3.664-3.9-5.57-5.844-6.38a6.83,6.83,0,0,0-4.953.2l-.421.2a8.6,8.6,0,0,0-3.984,2.938A5.164,5.164,0,0,0,28.286,6.3c-.022.226-.046.467-.078.727a.137.137,0,1,0,.272.033c.031-.262.056-.5.078-.733a4.952,4.952,0,0,1,.679-2.466,8.394,8.394,0,0,1,3.87-2.838l.422-.2A6.628,6.628,0,0,1,38.261.627c1.886.788,5.133,2.637,5.678,6.168a9.321,9.321,0,0,1-.591,3.882.133.133,0,0,0-.006.046,3.723,3.723,0,0,1-.605,2.064.138.138,0,0,0,.03.193A.136.136,0,0,0,42.846,13.006Z"
          fill="#384154"
        />
        <path
          id="Path_6791"
          data-name="Path 6791"
          d="M43.449,10.847a.137.137,0,0,0,.127-.189,7.2,7.2,0,0,0-3.063-3.382A11.516,11.516,0,0,0,30.8,5.895a13.176,13.176,0,0,0-4.165,2.224l-.094.079a2.374,2.374,0,0,0-.667.742.138.138,0,0,0,.066.183.136.136,0,0,0,.182-.066,2.181,2.181,0,0,1,.595-.648l.1-.081a12.907,12.907,0,0,1,4.078-2.173,11.245,11.245,0,0,1,9.478,1.355,6.934,6.934,0,0,1,2.954,3.251A.137.137,0,0,0,43.449,10.847Z"
          fill="#384154"
        />
        <path
          id="Path_6792"
          data-name="Path 6792"
          d="M41.68,8.333a.137.137,0,0,0,.123-.077,7.533,7.533,0,0,0,.113-5.63.137.137,0,0,0-.181-.068.138.138,0,0,0-.067.183,7.363,7.363,0,0,1-.11,5.392.138.138,0,0,0,.062.185A.137.137,0,0,0,41.68,8.333Z"
          fill="#384154"
        />
        <path
          id="Path_6793"
          data-name="Path 6793"
          d="M27.885,10.4a.138.138,0,0,0,.026-.273c-1.457-.286-1.762-.642-1.813-.829-.046-.165.055-.362.3-.585a7.566,7.566,0,0,1,3.431-1.456c.338-.045.643-.1.939-.159a6.292,6.292,0,0,1,4.646.636c.321.147.669.319,1.026.494a9.254,9.254,0,0,0,3.09,1.164,3.5,3.5,0,0,0,2.278-.909.138.138,0,0,0,0-.195.136.136,0,0,0-.193,0,3.282,3.282,0,0,1-2.089.83,9.665,9.665,0,0,1-2.968-1.136c-.359-.177-.709-.349-1.032-.5a6.584,6.584,0,0,0-4.81-.656c-.292.055-.594.113-.925.157a7.765,7.765,0,0,0-3.578,1.525c-.328.3-.455.59-.379.863.124.447.786.782,2.024,1.025Z"
          fill="#384154"
        />
        <path
          id="Path_6794"
          data-name="Path 6794"
          d="M30.469,10.779a.136.136,0,0,0,.074-.022A2.24,2.24,0,0,1,32.6,10.65a.136.136,0,0,0,.184-.06.138.138,0,0,0-.059-.185,2.5,2.5,0,0,0-2.325.12.139.139,0,0,0-.042.19A.137.137,0,0,0,30.469,10.779Z"
          fill="#384154"
        />
        <path
          id="Path_6795"
          data-name="Path 6795"
          d="M34.347,27.471a10.608,10.608,0,0,0,4.707-1.216,7.268,7.268,0,0,0,3.318-3.115.137.137,0,1,0-.252-.107,7,7,0,0,1-3.194,2.978c-2.141,1.14-5.308,1.683-6.9.617a2.526,2.526,0,0,1-1.007-2.519.138.138,0,0,0-.124-.15.136.136,0,0,0-.149.125,2.783,2.783,0,0,0,1.129,2.773A4.473,4.473,0,0,0,34.347,27.471Z"
          fill="#384154"
        />
        <path
          id="Path_6796"
          data-name="Path 6796"
          d="M14.976,40.289a.13.13,0,0,0,.035,0,.138.138,0,0,0,.1-.168,4.005,4.005,0,0,0-1.726-2.361.137.137,0,0,0-.184.062A.138.138,0,0,0,13.26,38a3.759,3.759,0,0,1,1.584,2.184A.137.137,0,0,0,14.976,40.289Z"
          fill="#384154"
        />
        <path
          id="Path_6797"
          data-name="Path 6797"
          d="M25.494,42.6a.136.136,0,0,0,.063-.015.138.138,0,0,0,.059-.186c-.349-.678.928-2.505,1.449-3.152a.139.139,0,0,0,0-.178.136.136,0,0,0-.175-.027c-.93.574-2.43,1.28-2.693.97-.355-.417.005-1.6.174-2.017a.138.138,0,0,0-.073-.178.136.136,0,0,0-.179.07c-.255.567-.759,1.371-1.079,1.38a.208.208,0,0,1-.182-.07.962.962,0,0,1-.1-.628.138.138,0,0,0-.09-.151.135.135,0,0,0-.164.062c-.076.134-.331.489-.6.517a.433.433,0,0,1-.366-.187.137.137,0,0,0-.193-.013.139.139,0,0,0-.013.195.7.7,0,0,0,.6.279.933.933,0,0,0,.547-.311.787.787,0,0,0,.166.42.514.514,0,0,0,.4.163c.268-.008.539-.27.765-.577a1.56,1.56,0,0,0,.175,1.226c.383.449,1.659-.138,2.454-.573-.562.789-1.433,2.2-1.068,2.906A.137.137,0,0,0,25.494,42.6Z"
          fill="#384154"
        />
        <path
          id="Path_6798"
          data-name="Path 6798"
          d="M18.241,39.867a.154.154,0,0,0,.133-.085.29.29,0,0,0-.013-.25.648.648,0,0,0-.4-.344.138.138,0,0,0-.068.267.354.354,0,0,1,.231.227.127.127,0,0,0,.064.174A.119.119,0,0,0,18.241,39.867Z"
          fill="#384154"
        />
      </g>
    </SvgIcon>
  );
}
export function PlanDurationRainbowIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 160,
    height: 140,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 140"
      {...rest}
      sx={rootSx}
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="1.015"
          y1="-0.014"
          x2="-0.317"
          y2="1.339"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#f1eeff" />
          <stop offset="1" stopColor="#9a85ff" />
        </linearGradient>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_46313"
            data-name="Rectangle 46313"
            width="160"
            height="140"
            rx="10"
            transform="translate(3966 6520)"
            fill="url(#linear-gradient)"
          />
        </clipPath>
      </defs>
      <g
        id="Mask_Group_10"
        data-name="Mask Group 10"
        transform="translate(-3966 -6520)"
        clipPath="url(#clip-path)"
      >
        <path
          id="duration_ellipse"
          data-name="duration ellipse"
          d="M72.954,100.757c-20.528,25.7-57.8,29.984-83.233,9.666S-39.77,52.81-19.243,27.111s57.8-29.984,83.234-9.666S93.482,75.058,72.954,100.757Z"
          transform="translate(3956.842 6612.874)"
          fill="none"
          stroke="rgba(196,187,246,0.88)"
          strokeWidth="8"
          opacity="0.4"
        />
      </g>
    </SvgIcon>
  );
}
export function EvaluationIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 55.998,
    height: 81.656,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 55.998 81.656"
      {...rest}
      sx={rootSx}
    >
      <path
        id="Path_6799"
        data-name="Path 6799"
        d="M21.246,17.309c0-6.64,4.836-10.2,8.732-10.2S40.032,10.556,40.032,17.2c0,2.455-1.747,5.749-2.954,9.81-2.058,6.921-4.349,14.733-6.8,14.733C26.378,41.738,21.246,23.949,21.246,17.309Z"
        fill="#ffd7b5"
        fillRule="evenodd"
      />
      <path
        id="Path_6800"
        data-name="Path 6800"
        d="M17.435,56.139a19.765,19.765,0,0,0,3.531-5.131C21.893,49.067,22.745,46,24.874,46s6.487-.143,5.184,1.894-5.184,8.823-6.186,9.567-2.806,3.021-4.058,3.812-2.354-.7-2.7-2.038S16.684,56.691,17.435,56.139Z"
        fill="#ffd7b5"
        fillRule="evenodd"
      />
      <path
        id="Path_6801"
        data-name="Path 6801"
        d="M50.8,56.859c.1,1.487-.05,3.812-2,4.483s-2,1.175-3.506.312-1.778-1.247-5.585-3.98-6.261-2.973-5.034-4.963S39.176,50,41.08,50.626s.4-.743,1.528-1.99,3.507-.575,4.308.384,1.2,1.007,2.354.168,1.754-1.343,1.653.671S50.7,55.373,50.8,56.859Z"
        fill="#ffd7b5"
        fillRule="evenodd"
      />
      <path
        id="Path_6802"
        data-name="Path 6802"
        d="M22.684,42.612c-.849-.949-.812-1.017-.458-1.706.8-1.552-1.93-1.8-1.611-3.7.167-.992.577-1.956.291-2.477-.161-.294-.805-.637-1.161-1.331-.276-.539-.049-1-.2-1.671-.125-.537-.42-.564-.56-1.2s.52-1.036.193-1.35a1.483,1.483,0,0,1-.37-1.876c.179-.306-1.07-1.244-1.321-2.1a4.476,4.476,0,0,1-.171-2.136c.075-.724.632-2.013,1.029-3.553.129-.5.228-1.321.406-2.36.227-1.321.168-3.063.373-4.523a24.04,24.04,0,0,1,1.229-4.093,13.054,13.054,0,0,1,1.521-3.357A11.088,11.088,0,0,1,25.993,1.08,8.969,8.969,0,0,1,30.247.229a7.091,7.091,0,0,1,2.514.539,24.451,24.451,0,0,1,2.356.778A10.885,10.885,0,0,1,38.4,4.564a25.3,25.3,0,0,1,1.878,3.349A25.573,25.573,0,0,1,42.1,16.729c.064.743.151,1.755.263,2.417a24.8,24.8,0,0,1,.575,3.611A3.642,3.642,0,0,1,41.792,25.6a1.591,1.591,0,0,1-1.5.341c-.181-.023-.015.415.026.839.078.788.2,1.911.21,2.642.035,2.745.567,4.728.85,7.982S40.638,40.24,39.5,40.85s-1.9.395-1.83-2.08.414-4.225.308-5.615a12.564,12.564,0,0,0-.612-1.706,18.082,18.082,0,0,1-.521-4.429c0-.76-1.564-.966-1-1.574a12.234,12.234,0,0,0,1.532-1.988,20.681,20.681,0,0,0,1.29-3.91,8.141,8.141,0,0,0-.576-4.618,13.23,13.23,0,0,0-.293-1.366c-.716-1.393-1-3-2.174-3.195-.6-.1-1.666-.933-2.682-.273a8.367,8.367,0,0,0-2.434,2.393c-1.005,1.545-3.4,3.749-5.106,4.093-2.691.542-3.553-.357-3.5.77a2.333,2.333,0,0,0,.579,1.7c.5.485,1.058.007,1.152,1.145.1,1.154.153,2.417.185,3.63A4.362,4.362,0,0,1,22.7,26.553c-1.487,1.356-.654.6-.583,3.688a21.073,21.073,0,0,0,1.8,8.023,2.738,2.738,0,0,1-.6,3.193C22.849,41.942,23.023,42.989,22.684,42.612Z"
        fillRule="evenodd"
      />
      <path
        id="Path_6803"
        data-name="Path 6803"
        d="M36.471,25.42a1.957,1.957,0,0,0-1.123.526,5.88,5.88,0,0,0-1.7,1.827,11.431,11.431,0,0,0-1.95,5.169c-.106,1.015-.261,2.826-.434,4.11a12.947,12.947,0,0,1-.548,2.11c-.188.713-.49,1.514-.713.816-.327-1.024-1.24-2.776-1.507-3.5a18.03,18.03,0,0,1-.378-3.106c-.153-1.155-1.669-3.017-2.4-3.921-.907-1.121-1.953-1.987-2.277-2.6-.491-.923-1.051-.06-1.778.612-.255.236.491,1.161.476,1.42-.021.358-.234.69-.066,1.074a1.43,1.43,0,0,1,.2.643c.069.761-.169.876-.065,1.3a9.054,9.054,0,0,1,.18,1,11.8,11.8,0,0,1-.311,2.117c-.034,1.06.775,1.479,1.458,2.478a3.5,3.5,0,0,1,.516,2.917c-.248.612-1,1.338-1.073,1.718-.154.8-1.306-.577-.9-.918a1.121,1.121,0,0,0,.213-1.223c-.142-.471-.591-.7-.975-1.059a2.777,2.777,0,0,1-.607-.894c-.354-.847.256-2.719.328-3.082s-.469-.722-.787-.957a1.952,1.952,0,0,1-.7-1.882c.055-.491.02-.5-.3-.917-.274-.366-.466-.793-.319-1.067.315-.588.375-.8.2-.918a1.172,1.172,0,0,1-.459-1.09c.069-.377.266-.684.262-.918,0-.2-.742.23-2.041.682-1.549.54-3.16.872-5.415,1.717-1.874.7-2.752.883-3.687,1.624a14.8,14.8,0,0,0-3.736,4.549c-1.732,3.631-1.269,7.856-1.991,10.894A39.912,39.912,0,0,0,.985,51.718c-.3,2.664-.3,6.255-.656,9.184-.613,5.075.139,5.467.68,8.471.192,1.067,1.806.922,3.056.839a16.554,16.554,0,0,0,6.154-2.063,36.443,36.443,0,0,0,5.333-3.412c.717-.592,1.1-1.422,1.467-1.145.722.543,1.138.553,1.213.282.184-.667,1.2-1.216,1.991-2.086a1.3,1.3,0,0,0,.139-1.8c-.2-.235-1.2,1.3-1.647,1.161-.411-.134-1.314-2.428-1.4-3.185-.177-1.539,0-1.673.59-1.984A5.108,5.108,0,0,0,19.19,54.7a33.235,33.235,0,0,0,2.589-5c.31-.653,1.381-1.219,1.688-1.749a4.965,4.965,0,0,1,1.106-1.388c.5-.343.5.456.516.518.109.34.61.48,1.049.369s.673.219,1.065-.142c.675-.619,2.294,1.245,2.868,1.365,1.154.242,11.516-4.068,14.076-3.584,1.817.343,6.273,2.37,5.81,5.043-.229,1.316.369,2.554.311,3.239-.148,1.736-.468,1.839-.27,2.839a6.914,6.914,0,0,1,.459,1.749c.065,3.191-4.592,3.957-5.17,3.977s.013.506.369,1.467a5.886,5.886,0,0,0,1.581,2.839,15.5,15.5,0,0,0,1.885,1.388c3.462,2.347,3.982.4,5.1-1.075a8.093,8.093,0,0,0,1.532-4.4c-.006-1.35-.227-2.9-.41-4.808-.188-1.98-.332-4.338-.434-6.212-.233-4.3-.184-7.762-.672-11.451-.214-1.621-.894-3.99-1.09-5.059a11.074,11.074,0,0,0-2.359-4.439c-1.389-1.4-3.038-1.7-5.3-2.07a34.594,34.594,0,0,1-3.565-.612c-1.545-.45-1.635-.327-1.679,0-.03.223-.2.558-.123.706a1.967,1.967,0,0,1,.394.926c-.015.8-.445,1.307-.352,1.576a2.562,2.562,0,0,1,.2.808,3.646,3.646,0,0,1-.3,1.38c-.34,1.009-.859,1.616.025,2.737a4.675,4.675,0,0,1,.9,2.236c.031,1.073-1.108,1.933-1.442,2.321-.5.578-.991,1.253-1.384.5a1.491,1.491,0,0,1-.139-1.2c.144-.675.839-.675.843-1.106.01-.78-.632-1.414-.811-1.914a2.748,2.748,0,0,1,.336-1.694c.344-.567.556-.739.319-1.287-.174-.4-.748-.872-1.04-1.5a2.258,2.258,0,0,1-.229-1.474c.122-.567.27-.831.074-.973a1.579,1.579,0,0,1-.582-1.271c.142-.72.52-.921.295-1.059a1.337,1.337,0,0,1-.344-1.161C36.924,25.628,36.755,25.43,36.471,25.42ZM11.645,52.349a31.823,31.823,0,0,1,1.42,3.553,5.876,5.876,0,0,1,.4,2.3,15.012,15.012,0,0,1-2.664.87,48.571,48.571,0,0,1,.609-6.475C11.466,52.54,11.529,52.34,11.645,52.349Z"
        fill="#ada0ec"
        fillRule="evenodd"
      />
      <path
        id="Path_6804"
        data-name="Path 6804"
        d="M12.91,81.656H49.464c-.353-1.479-1.986-8.455-2.395-10.445-.534-2.6-.332-3.457-.764-5.374-.5-2.227-.194-3.726-.7-4.34-.955-1.161-1.858-1.344-3.126-1.877-.5-.213-.93-.677-1.833-1.166-2.07-1.12-13.38-2.151-16.808-1.447-.369.076-1.263,1.048-1.416,1.17a86.146,86.146,0,0,0-7.589,6.93c-.559.629-.706,3.773-.654,5.423A86.05,86.05,0,0,1,12.91,81.656Z"
        fill="#ada0ec"
        fillRule="evenodd"
      />
      <path
        id="Path_6805"
        data-name="Path 6805"
        d="M28.46,49.834c-.124.126-.619-.636-.439-.807.112-.107.691.2.751.323C28.852,49.511,28.559,49.734,28.46,49.834Z"
        fill="#60b4ce"
        fillRule="evenodd"
      />
      <path
        id="Path_6806"
        data-name="Path 6806"
        d="M39.552,57.048a15.017,15.017,0,0,0-1.654-1,12.491,12.491,0,0,1-1.836-1.47c-.191-.2-.093-.316-.248-.5-.269-.32-.631-.527-.721-.758-.146-.374.591-.824,1.057-.77,1.456.168,1.964.305,1.611.174-.73-.271-1.464-.939-1.323-1.251.24-.532,1.626-.322,1.979-.306,2.292.107,5.463,1.6,5.965,1.731.893.237,1.225-.036,1.23-.566.006-.575-1.39-1.9-1.706-2.319-.357-.476-.68-1.2-.413-1.447.719-.679,1.829.2,2.118.374a5.109,5.109,0,0,1,1.927,2.214c.063.135.441-.032.441-.032,2.6-3.333,5.027-6.495,5.027-6.495a.731.731,0,0,0-.746-.715l-19.1-.751c-.412,0-9.889,14.515-9.889,14.515a.732.732,0,0,0,.747.714l16.056.335,1.163-.041A14.835,14.835,0,0,0,39.552,57.048Z"
        fill="#d8d6d7"
        fillRule="evenodd"
      />
      <path
        id="Path_6807"
        data-name="Path 6807"
        d="M30.6,28.1a3.679,3.679,0,0,1-.643-.052,8.294,8.294,0,0,1-3.77-1.992.219.219,0,0,1-.008-.319.243.243,0,0,1,.333-.007A7.96,7.96,0,0,0,30.045,27.6a6.575,6.575,0,0,0,4.5-1.346,9.978,9.978,0,0,0,3.985-7.34.234.234,0,0,1,.261-.2.228.228,0,0,1,.208.25,10.413,10.413,0,0,1-4.173,7.652A7.677,7.677,0,0,1,30.6,28.1Z"
      />
      <path
        id="Path_6808"
        data-name="Path 6808"
        d="M24.55,23.77a.238.238,0,0,1-.212-.126,10,10,0,0,1-1.031-5.032.236.236,0,0,1,.471.008v.009a9.576,9.576,0,0,0,.982,4.816.221.221,0,0,1-.107.3A.237.237,0,0,1,24.55,23.77Z"
      />
      <path
        id="Path_6809"
        data-name="Path 6809"
        d="M23.413,19.678a.238.238,0,0,1-.042,0c-.7-.12-1.562-.633-1.689-2.4a.229.229,0,0,1,.219-.241.233.233,0,0,1,.252.21c.085,1.185.523,1.854,1.3,1.986a.227.227,0,0,1,.191.262A.234.234,0,0,1,23.413,19.678Z"
      />
      <path
        id="Path_6810"
        data-name="Path 6810"
        d="M31.91,21.459a.244.244,0,0,1-.131-.038.22.22,0,0,1-.065-.313,1.528,1.528,0,0,1,.355-.323c.178-.133.362-.269.368-.408a.9.9,0,0,0-.116-.15,1.028,1.028,0,0,1-.21-.306,1.871,1.871,0,0,1,.287-1.673.242.242,0,0,1,.327-.062.22.22,0,0,1,.065.313,1.45,1.45,0,0,0-.235,1.272.786.786,0,0,0,.126.166.693.693,0,0,1,.227.435c0,.362-.305.589-.551.772a1.3,1.3,0,0,0-.251.216A.239.239,0,0,1,31.91,21.459Z"
      />
      <path
        id="Path_6811"
        data-name="Path 6811"
        d="M34.5,16.6a.237.237,0,0,1-.214-.129.222.222,0,0,1,.112-.3A3.293,3.293,0,0,1,36.941,16a.222.222,0,0,1,.1.3.241.241,0,0,1-.317.1,2.842,2.842,0,0,0-2.129.174A.243.243,0,0,1,34.5,16.6Z"
      />
      <path
        id="Path_6812"
        data-name="Path 6812"
        d="M34.267,6.363a.233.233,0,0,1-.234-.2c-.025-.2-.049-.411-.073-.617a8.613,8.613,0,0,0-1.085-3.917.221.221,0,0,1,.071-.312.244.244,0,0,1,.327.068A8.939,8.939,0,0,1,34.429,5.5c.024.205.047.41.072.613a.227.227,0,0,1-.206.251Z"
      />
      <path
        id="Path_6813"
        data-name="Path 6813"
        d="M30.657,16.251a.246.246,0,0,1-.094-.019,5.469,5.469,0,0,0-2.534-.282.233.233,0,0,1-.255-.206.229.229,0,0,1,.215-.245,5.941,5.941,0,0,1,2.763.318.223.223,0,0,1,.122.3A.237.237,0,0,1,30.657,16.251Z"
      />
      <path
        id="Path_6814"
        data-name="Path 6814"
        d="M28.637,18.388a1.9,1.9,0,0,1-1.362-.4.219.219,0,0,1,.019-.319.244.244,0,0,1,.333.019c.273.294,1.194.3,1.961.16a.235.235,0,0,1,.277.179.226.226,0,0,1-.187.265A6.017,6.017,0,0,1,28.637,18.388Z"
      />
      <path
        id="Path_6815"
        data-name="Path 6815"
        d="M35.683,18.576a4.687,4.687,0,0,1-.86-.088.227.227,0,0,1-.186-.266.235.235,0,0,1,.277-.178,2.439,2.439,0,0,0,1.567-.084.242.242,0,0,1,.322.085.221.221,0,0,1-.089.308A2.145,2.145,0,0,1,35.683,18.576Z"
      />
      <path
        id="Path_6816"
        data-name="Path 6816"
        d="M31.257,24.6a3.3,3.3,0,0,1-1.823-.438.22.22,0,0,1-.052-.316.243.243,0,0,1,.33-.05,4.38,4.38,0,0,0,3.243.079.239.239,0,0,1,.306.127.223.223,0,0,1-.133.293A5.674,5.674,0,0,1,31.257,24.6Z"
      />
      <path
        id="Path_6817"
        data-name="Path 6817"
        d="M28.088,33.824a.231.231,0,0,1-.236-.226,4.264,4.264,0,0,0-.983-2.249l-.143-.211a36.2,36.2,0,0,0-2.42-2.973c-.517-.6-1.006-1.157-1.37-1.613a.219.219,0,0,1,.044-.317.243.243,0,0,1,.331.042c.358.449.844,1.007,1.357,1.6a36.445,36.445,0,0,1,2.455,3.018l.142.209a4.654,4.654,0,0,1,1.059,2.5A.231.231,0,0,1,28.088,33.824Z"
      />
      <path
        id="Path_6818"
        data-name="Path 6818"
        d="M30.377,41.081c-.25,0-.351-.207-.669-1.387-.028-.1-.057-.209-.066-.236a12.277,12.277,0,0,0-.69-1.519,12.5,12.5,0,0,1-.7-1.553,8.077,8.077,0,0,1-.39-2.732.236.236,0,0,1,.472.016,7.6,7.6,0,0,0,.366,2.572,11.988,11.988,0,0,0,.681,1.5,12.571,12.571,0,0,1,.714,1.574c.013.04.035.118.075.266.02.075.053.2.092.335q.014-.069.029-.135c.091-.379.218-.752.34-1.113a11.356,11.356,0,0,0,.357-1.2,20.428,20.428,0,0,0,.35-2.917,18.2,18.2,0,0,1,.444-3.324,18.769,18.769,0,0,1,1.642-3.419c.2-.354.384-.688.52-.948a.24.24,0,0,1,.316-.1.221.221,0,0,1,.106.3c-.138.265-.326.6-.525.958a18.951,18.951,0,0,0-1.6,3.316,17.923,17.923,0,0,0-.43,3.245,20.607,20.607,0,0,1-.358,2.979,11.846,11.846,0,0,1-.37,1.244c-.119.351-.242.715-.328,1.075-.052.216-.091.478-.125.71l-.008.056c0,.011.006.023.009.035a.318.318,0,0,1-.034.3A.267.267,0,0,1,30.377,41.081Zm.146-.392h0Zm.088-.025h0Z"
      />
      <path
        id="Path_6819"
        data-name="Path 6819"
        d="M24.733,34.615a.241.241,0,0,1-.192-.093.22.22,0,0,1,.053-.316,3.869,3.869,0,0,0,1.031-1.461,3.462,3.462,0,0,1,.174-.333,1.024,1.024,0,0,1,.951-.476.869.869,0,0,1,.73.613.225.225,0,0,1-.149.286.24.24,0,0,1-.3-.143.415.415,0,0,0-.338-.308.544.544,0,0,0-.494.267c-.033.05-.085.158-.146.283a4.216,4.216,0,0,1-1.182,1.638A.242.242,0,0,1,24.733,34.615Z"
      />
      <path
        id="Path_6820"
        data-name="Path 6820"
        d="M36.419,33.59h-.01a4.041,4.041,0,0,1-1.512-.86,4.41,4.41,0,0,1-.4-.516c-.274-.392-.585-.836-.924-.891a.613.613,0,0,0-.457.144,2.306,2.306,0,0,0-.313.292c-.056.058-.113.118-.174.177a.243.243,0,0,1-.333,0,.219.219,0,0,1,0-.319c.054-.052.106-.107.158-.161a2.663,2.663,0,0,1,.379-.35,1.085,1.085,0,0,1,.819-.228c.539.088.91.618,1.237,1.085a4.216,4.216,0,0,0,.353.461,5.9,5.9,0,0,0,.912.617,4.452,4.452,0,0,1-.3-1.3,20.077,20.077,0,0,1,.154-3.2,24.727,24.727,0,0,0,.171-2.509.236.236,0,0,1,.472,0,24.983,24.983,0,0,1-.173,2.553,19.715,19.715,0,0,0-.153,3.132,4.066,4.066,0,0,0,.309,1.265c0,.008.02.032.03.046.047.072.192.29.011.464A.362.362,0,0,1,36.419,33.59Z"
      />
      <path
        id="Path_6821"
        data-name="Path 6821"
        d="M.235,64.322A.23.23,0,0,1,0,64.1c0-1.346.114-2.729.225-4.066q.028-.337.055-.671C.358,58.377.4,57.373.433,56.4a43.834,43.834,0,0,1,.36-4.8c.168-1.125.416-2.259.657-3.356a34.36,34.36,0,0,0,.83-4.907c.274-3.931.866-8.388,4.448-11.505C8.6,30.2,11.04,29.494,13.4,28.812a27.658,27.658,0,0,0,4.218-1.469c.138-.066.285-.134.435-.2s.323-.149.488-.228a.24.24,0,0,1,.316.1.221.221,0,0,1-.1.3c-.167.08-.332.156-.494.231s-.293.135-.43.2a27.95,27.95,0,0,1-4.292,1.5c-2.309.668-4.7,1.359-6.491,2.921-3.453,3-4.028,7.357-4.3,11.2a34.652,34.652,0,0,1-.838,4.97c-.239,1.09-.486,2.217-.652,3.327A43.325,43.325,0,0,0,.9,56.419C.868,57.394.83,58.4.75,59.4q-.027.334-.055.672C.585,61.4.472,62.769.472,64.1A.231.231,0,0,1,.235,64.322Z"
      />
      <path
        id="Path_6822"
        data-name="Path 6822"
        d="M10.79,58.978a.231.231,0,0,1-.236-.226,36.083,36.083,0,0,1,.352-4.341,27.637,27.637,0,0,0,.3-5.525,19.647,19.647,0,0,0-1.488-5.328c-.342-.893-.7-1.816-.969-2.731a.225.225,0,0,1,.162-.279A.238.238,0,0,1,9.2,40.7c.268.9.619,1.815.957,2.7a19.981,19.981,0,0,1,1.516,5.448,27.967,27.967,0,0,1-.3,5.613,35.662,35.662,0,0,0-.349,4.288A.231.231,0,0,1,10.79,58.978Z"
      />
      <path
        id="Path_6823"
        data-name="Path 6823"
        d="M51.883,68.874a.232.232,0,0,1-.235-.213.23.23,0,0,1,.222-.238c.739-.04,1.294-.839,1.739-1.48.127-.182.246-.354.358-.491,1.96-2.373,1.655-4.86,1.3-7.74l-.036-.3c-.2-1.644-.36-3.376-.487-5.295-.109-1.633-.165-3.3-.221-4.92q-.029-.853-.06-1.7l-.021-.549a44.305,44.305,0,0,0-.661-7.194c-.08-.389-.155-.789-.229-1.176-.448-2.36-.911-4.8-2.488-6.727-1.608-1.964-3.932-2.28-6.392-2.615a20.441,20.441,0,0,1-3.969-.812.223.223,0,0,1-.142-.289.24.24,0,0,1,.3-.136,20.051,20.051,0,0,0,3.875.79c2.556.348,4.972.676,6.7,2.783,1.65,2.015,2.123,4.511,2.582,6.925.073.386.149.784.227,1.17a44.648,44.648,0,0,1,.669,7.264l.02.549q.033.849.06,1.7c.055,1.612.111,3.28.22,4.906.127,1.911.286,3.635.486,5.271l.035.3c.351,2.856.682,5.554-1.4,8.074-.1.121-.215.286-.335.46-.477.687-1.132,1.628-2.106,1.681Z"
      />
      <path
        id="Path_6824"
        data-name="Path 6824"
        d="M51.577,68.916a3.581,3.581,0,0,1-1.6-.546c-.117-.062-.228-.121-.334-.173a7.812,7.812,0,0,1-3.185-2.6,9.176,9.176,0,0,1-.859-1.733,8.705,8.705,0,0,0-.816-1.654.22.22,0,0,1,.068-.313.243.243,0,0,1,.327.065,9.2,9.2,0,0,1,.861,1.737,8.686,8.686,0,0,0,.814,1.651,7.37,7.37,0,0,0,3.005,2.446c.113.055.227.116.348.18a2.867,2.867,0,0,0,1.495.483.234.234,0,0,1,.262.2.228.228,0,0,1-.207.251A1.618,1.618,0,0,1,51.577,68.916Z"
      />
      <path
        id="Path_6825"
        data-name="Path 6825"
        d="M47.524,65.95a.233.233,0,0,1-.235-.2A.229.229,0,0,1,47.5,65.5a5.89,5.89,0,0,0,5.139-3.636,3.8,3.8,0,0,0,.488-2.217,1.554,1.554,0,0,0-.366-.462,2.516,2.516,0,0,1-.353-.409c-.034-.054-.068-.11-.1-.168a3.693,3.693,0,0,0-1.109-1.319,3.969,3.969,0,0,0-.687-.313.529.529,0,0,1,.092.142,2.933,2.933,0,0,1,.028,1.592c-.435,1.684-2.227,2.79-3.811,3.14-.119.026-.245.058-.379.092a3.966,3.966,0,0,1-1.688.179.227.227,0,0,1-.183-.267.236.236,0,0,1,.279-.175,3.633,3.633,0,0,0,1.472-.174c.138-.035.267-.068.393-.1A4.483,4.483,0,0,0,50.169,58.6a2.563,2.563,0,0,0-.008-1.314c-.013-.019-.049-.061-.073-.089-.118-.138-.23-.267-.2-.42a.356.356,0,0,1,.214-.257c.244-.1.69.023,1.325.377a4.01,4.01,0,0,1,1.279,1.482q.052.086.1.165a2.253,2.253,0,0,0,.289.328,1.757,1.757,0,0,1,.478.648,3.95,3.95,0,0,1-.512,2.528,6.317,6.317,0,0,1-5.515,3.9Z"
      />
      <path
        id="Path_6826"
        data-name="Path 6826"
        d="M47.683,43.722a.249.249,0,0,1-.08-.013.224.224,0,0,1-.142-.29c.111-.294.223-.616.342-.958a12.116,12.116,0,0,1,1.7-3.6.244.244,0,0,1,.332-.037.219.219,0,0,1,.038.317A11.82,11.82,0,0,0,48.251,42.6c-.12.345-.233.67-.346.969A.236.236,0,0,1,47.683,43.722Z"
      />
      <path
        id="Path_6827"
        data-name="Path 6827"
        d="M1.576,63.14a.241.241,0,0,1-.105-.024.221.221,0,0,1-.106-.3,3.548,3.548,0,0,1,1.309-1.238c.1-.068.206-.137.307-.208a12.5,12.5,0,0,1,5.6-2.011,22.253,22.253,0,0,0,4.974-1.389.24.24,0,0,1,.31.119.222.222,0,0,1-.124.3A22.682,22.682,0,0,1,8.661,59.8a12.079,12.079,0,0,0-5.4,1.931c-.1.072-.211.143-.316.213a3.158,3.158,0,0,0-1.156,1.07A.237.237,0,0,1,1.576,63.14Z"
      />
      <path
        id="Path_6828"
        data-name="Path 6828"
        d="M17.295,56.586a.238.238,0,0,1-.2-.1.22.22,0,0,1,.062-.314c.05-.033.12-.074.2-.124a3.761,3.761,0,0,0,1.36-1.146.241.241,0,0,1,.318-.1.221.221,0,0,1,.1.3,4.108,4.108,0,0,1-1.532,1.325c-.076.045-.14.082-.186.112A.242.242,0,0,1,17.295,56.586Z"
      />
      <path
        id="Path_6829"
        data-name="Path 6829"
        d="M19,61.365a.245.245,0,0,1-.163-.061.22.22,0,0,1-.008-.32c.192-.194.371-.37.547-.54a11.338,11.338,0,0,1,.918-.762,10.389,10.389,0,0,0,.863-.716.245.245,0,0,1,.334,0,.219.219,0,0,1,0,.32,11.138,11.138,0,0,1-.9.748,10.816,10.816,0,0,0-.88.73c-.174.166-.35.34-.539.531A.239.239,0,0,1,19,61.365Z"
      />
      <path
        id="Path_6830"
        data-name="Path 6830"
        d="M2.631,70.461a2.155,2.155,0,0,1-1.461-.376,2.808,2.808,0,0,1-.547-1.37c-.012-.052-.022-.1-.031-.145A30.691,30.691,0,0,1,0,64.107a.23.23,0,0,1,.226-.234.233.233,0,0,1,.245.217,30.724,30.724,0,0,0,.58,4.387c.01.045.021.1.032.149a2.69,2.69,0,0,0,.419,1.14c.273.261.966.248,1.425.24l.229,0a11.677,11.677,0,0,0,4.655-.966,30.239,30.239,0,0,0,5.224-2.857c.254-.173.528-.345.792-.509A10.219,10.219,0,0,0,15.462,64.5c.339-.325.694-.684,1.12-1.132a.243.243,0,0,1,.333-.015.219.219,0,0,1,.016.319c-.431.453-.791.817-1.135,1.147a10.515,10.515,0,0,1-1.709,1.231c-.273.17-.53.331-.776.5A30.691,30.691,0,0,1,8,69.45a12.152,12.152,0,0,1-4.847,1l-.22,0C2.841,70.46,2.737,70.461,2.631,70.461Z"
      />
      <path
        id="Path_6831"
        data-name="Path 6831"
        d="M21.808,58.968a.24.24,0,0,1-.189-.09.219.219,0,0,1,.047-.316,4.048,4.048,0,0,0,1.532-4.1.227.227,0,0,1,.194-.26.235.235,0,0,1,.272.185,4.481,4.481,0,0,1-1.715,4.538A.242.242,0,0,1,21.808,58.968Z"
      />
      <path
        id="Path_6832"
        data-name="Path 6832"
        d="M18.955,55.179a.24.24,0,0,1-.154-.055.218.218,0,0,1-.025-.318,10.4,10.4,0,0,0,1.706-2.965,17.037,17.037,0,0,1,.96-1.965,7.813,7.813,0,0,1,1.449-1.665l.212-.2a3.857,3.857,0,0,0,.525-.685,4.174,4.174,0,0,1,.584-.754.78.78,0,0,1,.66-.237.491.491,0,0,1,.361.317c.446,1.137-.384,2.132-1.051,2.932-.146.176-.285.342-.4.5a3.881,3.881,0,0,0-.589,2.483.236.236,0,0,1-.472,0,4.294,4.294,0,0,1,.677-2.746c.126-.168.268-.339.419-.52.623-.747,1.329-1.594.977-2.491a.1.1,0,0,0-.02-.035.37.37,0,0,0-.226.116,3.793,3.793,0,0,0-.517.676,4.256,4.256,0,0,1-.592.765l-.213.2A7.32,7.32,0,0,0,21.852,50.1a16.9,16.9,0,0,0-.934,1.915A10.9,10.9,0,0,1,19.134,55.1.241.241,0,0,1,18.955,55.179Z"
      />
      <path
        id="Path_6833"
        data-name="Path 6833"
        d="M27.416,51.274a2.384,2.384,0,0,1-1.181-.59,2.715,2.715,0,0,1-.353-.417c-.045-.062-.091-.125-.141-.187-.071-.089-.151-.178-.234-.271a2.765,2.765,0,0,1-.639-.957.225.225,0,0,1,.157-.282.239.239,0,0,1,.295.15,2.424,2.424,0,0,0,.546.8c.083.094.17.191.249.289.056.069.106.138.154.2a2.3,2.3,0,0,0,.294.35c.218.2.741.511.874.463a.318.318,0,0,0,.017-.081,1.351,1.351,0,0,0-.271-.594,3.093,3.093,0,0,1-.168-.283c-.068-.139-.139-.32-.22-.529-.377-.973-.8-1.908-1.434-1.721a.239.239,0,0,1-.3-.15.225.225,0,0,1,.157-.282c1.116-.327,1.657,1.071,2.016,2,.077.2.144.373.2.494a2.659,2.659,0,0,0,.144.24,1.525,1.525,0,0,1,.338.867.5.5,0,0,1-.32.467A.548.548,0,0,1,27.416,51.274Z"
      />
      <path
        id="Path_6834"
        data-name="Path 6834"
        d="M28.295,49.956a.239.239,0,0,1-.17-.07,2.512,2.512,0,0,1-.558-1.191,2.438,2.438,0,0,0-.375-.914c-.093-.114-.436-.127-.664-.136a2.88,2.88,0,0,1-.339-.025.227.227,0,0,1-.193-.26.235.235,0,0,1,.272-.186c.069.011.171.015.279.019a1.352,1.352,0,0,1,1.016.308,2.779,2.779,0,0,1,.461,1.079,2.161,2.161,0,0,0,.442.992.219.219,0,0,1-.008.319A.242.242,0,0,1,28.295,49.956Z"
      />
      <path
        id="Path_6835"
        data-name="Path 6835"
        d="M29.245,48.464a.238.238,0,0,1-.106-.024,3.071,3.071,0,0,1-.688-.5c-.419-.369-.7-.588-1.2-.443a.237.237,0,0,1-.295-.15.224.224,0,0,1,.157-.282,1.615,1.615,0,0,1,1.653.543,2.658,2.658,0,0,0,.58.428.221.221,0,0,1,.1.3A.236.236,0,0,1,29.245,48.464Z"
      />
      <path
        id="Path_6836"
        data-name="Path 6836"
        d="M28.762,49.515a.238.238,0,0,1-.091-.017,2.948,2.948,0,0,1-.714-.393.22.22,0,0,1-.033-.318.243.243,0,0,1,.332-.032,2.471,2.471,0,0,0,.6.326.222.222,0,0,1,.126.3A.236.236,0,0,1,28.762,49.515Z"
      />
      <path
        id="Path_6837"
        data-name="Path 6837"
        d="M24.761,51.194a.264.264,0,0,1-.056-.007.226.226,0,0,1-.173-.274c.021-.08.041-.161.061-.242a3.423,3.423,0,0,1,.535-1.332.243.243,0,0,1,.33-.05.22.22,0,0,1,.051.316,3.044,3.044,0,0,0-.456,1.168c-.021.084-.041.166-.062.249A.235.235,0,0,1,24.761,51.194Z"
      />
      <path
        id="Path_6838"
        data-name="Path 6838"
        d="M25.765,51.208a.245.245,0,0,1-.068-.01.225.225,0,0,1-.158-.281c.015-.049.029-.1.043-.143a1.9,1.9,0,0,1,.265-.615.242.242,0,0,1,.328-.059.22.22,0,0,1,.062.314,1.507,1.507,0,0,0-.2.481l-.045.153A.236.236,0,0,1,25.765,51.208Z"
      />
      <path
        id="Path_6839"
        data-name="Path 6839"
        d="M19.289,61.6a1.16,1.16,0,0,1-.663-.211,2.31,2.31,0,0,1-.713-1c-.038-.081-.076-.162-.114-.238a6.746,6.746,0,0,1-.782-3.414c.03-.535.1-1.788,1.064-1.877a.233.233,0,0,1,.257.2.229.229,0,0,1-.212.246c-.494.046-.6.759-.638,1.451a6.3,6.3,0,0,0,.735,3.193c.041.08.081.165.121.251a1.948,1.948,0,0,0,.558.814.71.71,0,0,0,.77.02.991.991,0,0,0,.53-.9.229.229,0,0,1,.212-.246.234.234,0,0,1,.258.2,1.437,1.437,0,0,1-.764,1.339A1.278,1.278,0,0,1,19.289,61.6Z"
      />
      <path
        id="Path_6840"
        data-name="Path 6840"
        d="M17.927,64.2a.522.522,0,0,1-.055,0c-.674-.066-1.314-.775-1.781-1.293-.079-.088-.151-.167-.215-.234a7.978,7.978,0,0,1-2.07-3.651c-.013-.055-.029-.113-.046-.174a2.968,2.968,0,0,1-.12-1.692c.126-.311.564-.512.917-.673.087-.04.169-.077.224-.107.245-.133.513-.262.771-.386a8.522,8.522,0,0,0,1.53-.866.243.243,0,0,1,.332.032.219.219,0,0,1-.034.318,8.859,8.859,0,0,1-1.617.919c-.265.127-.515.247-.75.375-.07.038-.155.076-.253.122-.217.1-.622.285-.68.428a2.758,2.758,0,0,0,.137,1.419c.017.063.033.123.047.179a7.443,7.443,0,0,0,1.96,3.454c.066.069.142.152.224.243.392.435.984,1.092,1.471,1.139h0c.09,0,.235-.226.322-.363a1.688,1.688,0,0,1,.259-.339c.137-.125.3-.256.468-.394a3.984,3.984,0,0,0,1.346-1.506,2.047,2.047,0,0,0-.007-.8c-.011-.085-.023-.169-.031-.25a.228.228,0,0,1,.212-.246.234.234,0,0,1,.257.2c.008.076.018.155.029.236a2.389,2.389,0,0,1-.007.982,4.243,4.243,0,0,1-1.494,1.727c-.165.135-.32.262-.449.379a1.459,1.459,0,0,0-.182.248C18.491,63.866,18.278,64.2,17.927,64.2Z"
      />
      <path
        id="Path_6841"
        data-name="Path 6841"
        d="M45.127,53.15a.233.233,0,0,1-.232-.184.227.227,0,0,1,.189-.263c.235-.042.281-.144.3-.177a.971.971,0,0,0-.21-.8,5.305,5.305,0,0,0-.66-.7c-.757-.732-1.7-1.643-1.223-2.5a1.186,1.186,0,0,1,1.482-.268,6.787,6.787,0,0,1,2.344,1.795,9.3,9.3,0,0,1,.51.791A3.9,3.9,0,0,0,49.1,52.534a.222.222,0,0,1,.124.3.239.239,0,0,1-.31.119,4.2,4.2,0,0,1-1.706-1.877,8.787,8.787,0,0,0-.484-.751,6.351,6.351,0,0,0-2.183-1.661c-.233-.119-.728-.123-.843.083-.313.56.494,1.339,1.142,1.965a5.466,5.466,0,0,1,.723.781,1.413,1.413,0,0,1,.244,1.218.8.8,0,0,1-.643.44A.221.221,0,0,1,45.127,53.15Z"
      />
      <path
        id="Path_6842"
        data-name="Path 6842"
        d="M43.709,55.59a.238.238,0,0,1-.183-.083,11.961,11.961,0,0,0-1.845-.934c-.2-.089-.354-.158-.439-.2-.681-.334-1.393-.618-2.081-.893-.424-.169-.862-.344-1.295-.531l-.142-.061a3.223,3.223,0,0,1-1.373-.879.568.568,0,0,1-.081-.67c.37-.6,2-.476,2.014-.475a20.627,20.627,0,0,1,6.274,1.881.222.222,0,0,1,.118.3.24.24,0,0,1-.312.113,20.232,20.232,0,0,0-6.128-1.843c-.44-.044-1.423.036-1.559.256-.028.046.027.134.062.183a2.91,2.91,0,0,0,1.176.724l.144.062c.426.184.861.358,1.283.526.7.278,1.417.565,2.115.909.076.037.229.105.422.191a8.032,8.032,0,0,1,2.012,1.06.219.219,0,0,1-.034.318A.241.241,0,0,1,43.709,55.59Z"
      />
      <path
        id="Path_6843"
        data-name="Path 6843"
        d="M42.524,57.367a.239.239,0,0,1-.146-.049,5.833,5.833,0,0,0-1.008-.492c-.243-.1-.473-.2-.633-.285-.885-.472-1.821-.887-2.726-1.288-.749-.332-1.522-.675-2.273-1.052-.441-.222-.864-.675-.818-1.114.018-.172.129-.482.67-.634a3.139,3.139,0,0,1,1.528.138l.185.048c.474.117.98.256,1.594.438a.224.224,0,0,1,.156.282.238.238,0,0,1-.3.149c-.607-.18-1.106-.317-1.572-.432l-.191-.049a2.811,2.811,0,0,0-1.272-.14c-.145.04-.319.116-.333.245-.02.194.245.507.568.669.74.372,1.509.713,2.253,1.042.913.405,1.856.823,2.757,1.3.14.075.36.168.594.266a5.891,5.891,0,0,1,1.11.551.219.219,0,0,1,.038.318A.239.239,0,0,1,42.524,57.367Z"
      />
      <path
        id="Path_6844"
        data-name="Path 6844"
        d="M45.85,61.983a.238.238,0,0,1-.2-.106,4.206,4.206,0,0,0-2.148-1.54,10.961,10.961,0,0,1-1.239-.6,9.182,9.182,0,0,1-1.722-1.424A8.784,8.784,0,0,0,38.8,56.888a11.5,11.5,0,0,1-2.521-1.749l-.078-.076c-.3-.29-.57-.574-.582-.864a.236.236,0,0,1,.472-.018c.006.139.326.448.446.564.031.03.059.057.083.081A11.142,11.142,0,0,0,39.046,56.5,9.114,9.114,0,0,1,40.878,58a8.72,8.72,0,0,0,1.63,1.355,10.6,10.6,0,0,0,1.187.573,4.628,4.628,0,0,1,2.355,1.712.221.221,0,0,1-.075.311A.245.245,0,0,1,45.85,61.983Z"
      />
      <path
        id="Path_6845"
        data-name="Path 6845"
        d="M19.535,27.864a.247.247,0,0,1-.123-.033,5.035,5.035,0,0,1-1.221-1.064c-1.8-2-1.065-4.177-.352-6.286.09-.266.184-.541.27-.811a9.346,9.346,0,0,0,.315-1.7c.036-.289.072-.588.122-.879a21.837,21.837,0,0,0,.222-2.422,16.351,16.351,0,0,1,.4-3.3,23.623,23.623,0,0,1,2.9-6.856A9.022,9.022,0,0,1,28,.182a11.055,11.055,0,0,1,3.325-.1,3.729,3.729,0,0,1,.873.28,3.986,3.986,0,0,0,.67.233.226.226,0,0,1,.179.269.237.237,0,0,1-.282.172,4.374,4.374,0,0,1-.756-.259A3.311,3.311,0,0,0,31.258.53a10.552,10.552,0,0,0-3.17.1,8.575,8.575,0,0,0-5.615,4.13,23.187,23.187,0,0,0-2.844,6.727,16.032,16.032,0,0,0-.39,3.212,22.147,22.147,0,0,1-.228,2.471c-.048.281-.084.575-.119.859a9.641,9.641,0,0,1-.332,1.776c-.087.274-.181.55-.271.818-.7,2.081-1.37,4.047.26,5.851a4.634,4.634,0,0,0,1.11.974.22.22,0,0,1,.078.31A.238.238,0,0,1,19.535,27.864Z"
      />
      <path
        id="Path_6846"
        data-name="Path 6846"
        d="M31.06,61.585c-.013.365-.026.742-.017,1.106.038,1.512,1.047,12.284,1.543,15.376h.477c-.484-2.936-1.515-14.048-1.548-15.387-.008-.351,0-.7.017-1.08a9.409,9.409,0,0,0-.1-2.25.235.235,0,0,0-.277-.177.226.226,0,0,0-.185.265A9.145,9.145,0,0,1,31.06,61.585Z"
      />
      <path
        id="Path_6847"
        data-name="Path 6847"
        d="M40.956,58.97h-.006l-.886-.019-16.056-.335a.962.962,0,0,1-.977-.94.218.218,0,0,1,.036-.12c.023-.036,2.4-3.671,4.79-7.259,1.406-2.108,2.545-3.788,3.383-4.993,1.647-2.369,1.749-2.369,1.916-2.369h.009l19.1.752a.963.963,0,0,1,.977.941.217.217,0,0,1-.046.133c-.024.032-2.456,3.2-5.028,6.5a.242.242,0,0,1-.33.046.219.219,0,0,1-.048-.316c2.365-3.031,4.612-5.955,4.975-6.428a.5.5,0,0,0-.505-.421h-.01l-19.02-.748c-.713.7-6.146,8.87-9.72,14.345a.5.5,0,0,0,.506.429l16.948.354a.226.226,0,1,1-.005.452Z"
      />
      <path
        id="Path_6848"
        data-name="Path 6848"
        d="M23.43,17.03a7.326,7.326,0,0,1-1.706-.2.226.226,0,0,1-.172-.274.238.238,0,0,1,.287-.164,7.011,7.011,0,0,0,5.644-1.1,11.923,11.923,0,0,0,2-1.941l.135-.152c.212-.239.436-.522.672-.821.995-1.255,2.233-2.817,3.882-2.817a.226.226,0,1,1,0,.452c-1.414,0-2.574,1.463-3.505,2.638-.241.3-.469.59-.689.839l-.134.152a12.25,12.25,0,0,1-2.081,2.014A7.557,7.557,0,0,1,23.43,17.03Z"
      />
      <path
        id="Path_6849"
        data-name="Path 6849"
        d="M30.487,46.666a.231.231,0,0,1-.236-.226c0-.784-.037-1.8-.074-2.778s-.074-2.008-.074-2.8a.236.236,0,0,1,.472,0c0,.788.038,1.805.074,2.788s.074,2,.074,2.794A.231.231,0,0,1,30.487,46.666Z"
      />
      <path
        id="Path_6850"
        data-name="Path 6850"
        d="M35.775,18.909h-.031a.633.633,0,0,1-.441-.276.22.22,0,0,1,.047-.316.243.243,0,0,1,.33.045.355.355,0,0,0,.1.1.283.283,0,0,0,.085-.063.244.244,0,0,1,.334,0,.219.219,0,0,1,0,.319A.611.611,0,0,1,35.775,18.909Z"
      />
      <path
        id="Path_6851"
        data-name="Path 6851"
        d="M28.777,18.694a.687.687,0,0,1-.233-.039.5.5,0,0,1-.3-.282.223.223,0,0,1,.131-.294.24.24,0,0,1,.307.126.043.043,0,0,0,.03.027.362.362,0,0,0,.241-.031.242.242,0,0,1,.317.1.222.222,0,0,1-.106.3A.926.926,0,0,1,28.777,18.694Z"
      />
      <path
        id="Path_6852"
        data-name="Path 6852"
        d="M13.486,58.06a.23.23,0,0,1-.236-.226,8.854,8.854,0,0,0-1.043-3.511,12.785,12.785,0,0,1-.948-2.569.226.226,0,0,1,.186-.266.235.235,0,0,1,.277.177,12.279,12.279,0,0,0,.918,2.478,9.173,9.173,0,0,1,1.082,3.691A.231.231,0,0,1,13.486,58.06Z"
      />
      <path
        id="Path_6853"
        data-name="Path 6853"
        d="M13.467,78.066A34.317,34.317,0,0,0,14.178,73c.275-2.876.453-5.818.481-7.126a.23.23,0,0,0-.231-.23h0a.232.232,0,0,0-.236.221c-.028,1.289-.2,4.2-.476,7.055a31.134,31.134,0,0,1-.734,5.144Z"
      />
      <path
        id="Path_6854"
        data-name="Path 6854"
        d="M48.338,78.067h.5c-.649-1.653-2.1-10.795-2.306-12.391a.233.233,0,0,0-.263-.2.229.229,0,0,0-.205.252C46.151,66.437,47.556,75.758,48.338,78.067Z"
      />
      <path
        id="Path_6855"
        data-name="Path 6855"
        d="M40.6,26.2c-.13,0-.259-.007-.385-.014a4.058,4.058,0,0,0-.58,0,.234.234,0,0,1-.256-.2.228.228,0,0,1,.213-.246,4.524,4.524,0,0,1,.649,0,2.367,2.367,0,0,0,.975-.083,2.765,2.765,0,0,0,1.4-1.936,7.6,7.6,0,0,0-.286-3.343,14.965,14.965,0,0,1-.346-1.845q-.069-.716-.131-1.417c-.348-3.844-.677-7.474-2.751-11.05-1.118-1.927-2.629-4-5.361-4.777A.225.225,0,0,1,33.588,1a.239.239,0,0,1,.293-.152c2.894.821,4.475,2.984,5.639,4.991,2.124,3.66,2.457,7.337,2.809,11.23.042.467.085.938.131,1.415a14.565,14.565,0,0,0,.336,1.79,7.9,7.9,0,0,1,.285,3.543,3.2,3.2,0,0,1-1.7,2.256A2.23,2.23,0,0,1,40.6,26.2Z"
      />
      <path
        id="Path_6856"
        data-name="Path 6856"
        d="M24.617,34.795a.232.232,0,0,1-.234-.2,13.982,13.982,0,0,0-1.8-4.72c-.285-.539-.58-1.1-.854-1.676a.222.222,0,0,1,.117-.3.241.241,0,0,1,.313.112c.269.571.562,1.124.845,1.658a14.319,14.319,0,0,1,1.849,4.866.229.229,0,0,1-.2.253Z"
      />
      <path
        id="Path_6857"
        data-name="Path 6857"
        d="M23.23,25.834a.243.243,0,0,1-.167-.066.219.219,0,0,1,0-.32c.661-.633.555-1.914.47-2.944-.027-.329-.053-.64-.053-.909a.236.236,0,0,1,.472,0c0,.251.025.553.052.873.092,1.123.208,2.52-.606,3.3A.243.243,0,0,1,23.23,25.834Z"
      />
      <path
        id="Path_6858"
        data-name="Path 6858"
        d="M20.656,29.2l-.029,0a.228.228,0,0,1-.205-.252,3.622,3.622,0,0,1,1.624-2.142,9.37,9.37,0,0,0,.715-.613.244.244,0,0,1,.334-.006.219.219,0,0,1,.006.319,9.469,9.469,0,0,1-.752.646c-.669.536-1.36,1.091-1.458,1.851A.234.234,0,0,1,20.656,29.2Z"
      />
      <path
        id="Path_6859"
        data-name="Path 6859"
        d="M20.457,30.711a.238.238,0,0,1-.216-.135,2.583,2.583,0,0,0-.822-.873c-.51-.4-1.089-.856-.977-1.712a.232.232,0,0,1,.263-.2.228.228,0,0,1,.2.252c-.079.608.313.917.809,1.306a2.954,2.954,0,0,1,.954,1.04.222.222,0,0,1-.12.3A.246.246,0,0,1,20.457,30.711Z"
      />
      <path
        id="Path_6860"
        data-name="Path 6860"
        d="M20.74,32.076l-.03,0a.228.228,0,0,1-.2-.252,3.569,3.569,0,0,1,.742-1.52,4.264,4.264,0,0,0,.606-1.056,1,1,0,0,0-.149-.8,1.356,1.356,0,0,1-.2-.775.234.234,0,0,1,.263-.2.229.229,0,0,1,.206.252,1.006,1.006,0,0,0,.156.529,1.411,1.411,0,0,1,.171,1.12,4.644,4.644,0,0,1-.664,1.173,3.212,3.212,0,0,0-.666,1.324A.232.232,0,0,1,20.74,32.076Z"
      />
      <path
        id="Path_6861"
        data-name="Path 6861"
        d="M20.671,32.948a.238.238,0,0,1-.205-.113,3.745,3.745,0,0,0-.7-.769,2.648,2.648,0,0,1-1.02-1.527c-.04-.286-.112-.809.243-1.075a.243.243,0,0,1,.331.039.219.219,0,0,1-.042.317c-.142.106-.091.476-.066.654a2.287,2.287,0,0,0,.882,1.267,4.151,4.151,0,0,1,.777.869.22.22,0,0,1-.088.308A.24.24,0,0,1,20.671,32.948Z"
      />
      <path
        id="Path_6862"
        data-name="Path 6862"
        d="M21.312,33.831l-.03,0a.228.228,0,0,1-.2-.252,3.812,3.812,0,0,1,.535-1.358,4.451,4.451,0,0,0,.442-.97,1.789,1.789,0,0,0-.05-.847c-.029-.133-.058-.271-.076-.411a.227.227,0,0,1,.206-.251.233.233,0,0,1,.262.2c.016.122.043.245.071.375a2.142,2.142,0,0,1,.043,1.052,4.83,4.83,0,0,1-.482,1.066,3.419,3.419,0,0,0-.484,1.2A.232.232,0,0,1,21.312,33.831Z"
      />
      <path
        id="Path_6863"
        data-name="Path 6863"
        d="M20.909,34.669a.248.248,0,0,1-.1-.022,2.535,2.535,0,0,1-1.463-2.925.234.234,0,0,1,.264-.2.228.228,0,0,1,.2.252,2.08,2.08,0,0,0,1.2,2.462.222.222,0,0,1,.111.3A.238.238,0,0,1,20.909,34.669Z"
      />
      <path
        id="Path_6864"
        data-name="Path 6864"
        d="M21.92,34.949a.253.253,0,0,1-.085-.015.224.224,0,0,1-.135-.292c.046-.113.091-.221.134-.324A2.153,2.153,0,0,0,21.9,32.07a.222.222,0,0,1,.106-.3.241.241,0,0,1,.316.1,2.569,2.569,0,0,1-.049,2.617c-.042.1-.087.208-.131.319A.236.236,0,0,1,21.92,34.949Z"
      />
      <path
        id="Path_6865"
        data-name="Path 6865"
        d="M21.76,41.691a.239.239,0,0,1-.205-.114.221.221,0,0,1,.088-.308,1,1,0,0,0,.4-1.106A1.522,1.522,0,0,0,21.4,39.3a2.685,2.685,0,0,1-.673-.725,3.128,3.128,0,0,1-.121-2.542,7.806,7.806,0,0,0,.185-.883.234.234,0,0,1,.264-.2.228.228,0,0,1,.2.252,8.135,8.135,0,0,1-.195.933,2.712,2.712,0,0,0,.076,2.22,2.3,2.3,0,0,0,.569.6,1.946,1.946,0,0,1,.8,1.111,1.4,1.4,0,0,1-.626,1.588A.247.247,0,0,1,21.76,41.691Z"
      />
      <path
        id="Path_6866"
        data-name="Path 6866"
        d="M22.858,42.665h-.029a.228.228,0,0,1-.205-.252,2.618,2.618,0,0,1,.7-1.322,3.572,3.572,0,0,0,.505-.734,2.482,2.482,0,0,0-.01-1.506,4.693,4.693,0,0,0-1-1.928c-.066-.08-.145-.166-.228-.257a1.825,1.825,0,0,1-.679-1.38.233.233,0,0,1,.263-.2.227.227,0,0,1,.2.252c-.047.36.265.7.566,1.026.089.1.171.187.247.278a5.172,5.172,0,0,1,1.085,2.1,2.988,2.988,0,0,1-.019,1.793,3.946,3.946,0,0,1-.564.828,2.246,2.246,0,0,0-.6,1.1A.234.234,0,0,1,22.858,42.665Z"
      />
      <path
        id="Path_6867"
        data-name="Path 6867"
        d="M38.68,29.424a.232.232,0,0,1-.234-.2,1.716,1.716,0,0,0-.466-1.178,2.671,2.671,0,0,0-.452-.373,2.051,2.051,0,0,1-.739-.75,3.15,3.15,0,0,1,.147-2.169l0-.01a.238.238,0,0,1,.294-.151.224.224,0,0,1,.158.281l0,.01a2.805,2.805,0,0,0-.166,1.858,1.716,1.716,0,0,0,.59.57,3.033,3.033,0,0,1,.532.445,2.131,2.131,0,0,1,.571,1.417.229.229,0,0,1-.208.25Z"
      />
      <path
        id="Path_6868"
        data-name="Path 6868"
        d="M39.037,30.034a.242.242,0,0,1-.075-.012.225.225,0,0,1-.15-.286,5.647,5.647,0,0,1,.675-1.244c.468-.712.873-1.326.488-2.184a.222.222,0,0,1,.125-.3.239.239,0,0,1,.31.119,2.491,2.491,0,0,1-.523,2.6,5.343,5.343,0,0,0-.626,1.146A.235.235,0,0,1,39.037,30.034Z"
      />
      <path
        id="Path_6869"
        data-name="Path 6869"
        d="M38.756,31.484a.231.231,0,0,1-.236-.226c0-.521-.358-.836-.774-1.2a2.961,2.961,0,0,1-.843-1,1.682,1.682,0,0,1,.13-1.545.245.245,0,0,1,.334,0,.219.219,0,0,1,0,.32,1.386,1.386,0,0,0-.029,1.051,2.591,2.591,0,0,0,.727.843,2.062,2.062,0,0,1,.926,1.535A.231.231,0,0,1,38.756,31.484Z"
      />
      <path
        id="Path_6870"
        data-name="Path 6870"
        d="M39.162,32.288a.246.246,0,0,1-.121-.032.221.221,0,0,1-.081-.31c.1-.151.2-.3.306-.467.645-.965,1.375-2.059.7-3.033a.22.22,0,0,1,.066-.313.241.241,0,0,1,.326.063c.849,1.219-.005,2.5-.693,3.527-.106.16-.207.31-.3.456A.237.237,0,0,1,39.162,32.288Z"
      />
      <path
        id="Path_6871"
        data-name="Path 6871"
        d="M38.8,33.927a.236.236,0,0,1-.221-.147,4.351,4.351,0,0,0-.607-.993,6.246,6.246,0,0,1-.539-.817,3.062,3.062,0,0,1-.058-2.179.238.238,0,0,1,.286-.164.225.225,0,0,1,.171.274,2.705,2.705,0,0,0,.022,1.868,5.8,5.8,0,0,0,.5.758,4.776,4.776,0,0,1,.664,1.1.223.223,0,0,1-.138.291A.25.25,0,0,1,38.8,33.927Z"
      />
      <path
        id="Path_6872"
        data-name="Path 6872"
        d="M39.472,34.12a.243.243,0,0,1-.128-.036.22.22,0,0,1-.07-.312c.73-1.079,1.137-1.812.66-2.881a.222.222,0,0,1,.123-.3.24.24,0,0,1,.31.119c.613,1.368-.024,2.308-.7,3.3A.239.239,0,0,1,39.472,34.12Z"
      />
      <path
        id="Path_6873"
        data-name="Path 6873"
        d="M38.24,39.238a.236.236,0,0,1-.224-.154.224.224,0,0,1,.15-.286c.272-.087.438-.2.493-.338.107-.27-.162-.717-.4-1.113a2.252,2.252,0,0,1,.016-2.808c.05-.091.1-.185.154-.285a.241.241,0,0,1,.316-.1.221.221,0,0,1,.106.3c-.054.1-.107.2-.158.292a2.356,2.356,0,0,0-.417,1.533,2.567,2.567,0,0,0,.392.841c.3.506.618,1.029.432,1.5a1.13,1.13,0,0,1-.785.607A.244.244,0,0,1,38.24,39.238Z"
      />
      <path
        id="Path_6874"
        data-name="Path 6874"
        d="M39.281,41.3a.239.239,0,0,1-.2-.1c-.282-.4.032-.812.167-.985s.288-.339.463-.529a3.488,3.488,0,0,0,1.006-1.494,3.729,3.729,0,0,0-.688-2.276c-.052-.088-.12-.183-.192-.284-.267-.37-.6-.831-.332-1.34a.242.242,0,0,1,.317-.1.222.222,0,0,1,.1.3c-.132.252.033.512.3.881.075.1.153.213.215.32a4.153,4.153,0,0,1,.748,2.534,3.642,3.642,0,0,1-1.123,1.755c-.169.182-.328.355-.438.5-.186.24-.226.362-.154.466a.22.22,0,0,1-.065.313A.247.247,0,0,1,39.281,41.3Z"
      />
      <path
        id="Path_6875"
        data-name="Path 6875"
        d="M38.281,41.221a.231.231,0,0,1-.236-.226,1.7,1.7,0,0,1,.587-1.419.244.244,0,0,1,.334,0,.219.219,0,0,1,0,.319,1.271,1.271,0,0,0-.449,1.1A.231.231,0,0,1,38.281,41.221Z"
      />
      <path
        id="Path_6876"
        data-name="Path 6876"
        d="M38.9,12.8a.244.244,0,0,1-.105-.024,5.67,5.67,0,0,1-1.405-1.059A3.473,3.473,0,0,0,35.558,10.6a.228.228,0,0,1-.2-.257.235.235,0,0,1,.269-.189,3.883,3.883,0,0,1,2.09,1.239A5.322,5.322,0,0,0,39,12.373a.221.221,0,0,1,.106.3A.237.237,0,0,1,38.9,12.8Z"
      />
      <path
        id="Path_6877"
        data-name="Path 6877"
        d="M40.407,19.969a.24.24,0,0,1-.064-.009.225.225,0,0,1-.163-.279c.347-1.163-.39-2.053-1.17-3a8.278,8.278,0,0,1-.988-1.37,4.729,4.729,0,0,1-.4-1.434c-.023-.131-.044-.261-.07-.389a.228.228,0,0,1,.188-.264.235.235,0,0,1,.276.18c.026.132.049.266.072.4a4.41,4.41,0,0,0,.361,1.3,7.918,7.918,0,0,0,.935,1.291c.82.99,1.667,2.014,1.255,3.4A.235.235,0,0,1,40.407,19.969Z"
      />
      <path
        id="Path_6878"
        data-name="Path 6878"
        d="M23.371,18.069a.235.235,0,0,1-.224-.154c-.047-.136-.207-.224-.376-.317l-.1-.054a.221.221,0,0,1-.081-.31.242.242,0,0,1,.324-.078l.089.05a1.108,1.108,0,0,1,.589.566.224.224,0,0,1-.149.286A.249.249,0,0,1,23.371,18.069Z"
      />
    </SvgIcon>
  );
}
export function ActivityIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 117,
    height: 105,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 117 105"
      {...rest}
      sx={rootSx}
    >
      <defs>
        <linearGradient
          id="a"
          x1={1.015}
          y1={-0.014}
          x2={-0.317}
          y2={1.339}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fffffe" />
          <stop offset={1} stopColor="#ffb063" />
        </linearGradient>
        <clipPath id="b">
          <path
            data-name="Rectangle 44673"
            d="M0 0h107a10 10 0 0110 10v85a10 10 0 01-10 10H0V0z"
            transform="translate(5017 13268)"
            fill="url(#a)"
          />
        </clipPath>
      </defs>
      <g
        data-name="Total Activities Person"
        transform="translate(-5017 -13268)"
        clipPath="url(#b)"
      >
        <g data-name="Group 105960">
          <g data-name="Activities person">
            <path
              data-name="Path 5411"
              d="M11.158 47.606c.913-.481 1.209.632 3.674 1.633.939.382 2.132.879 3.416 1.307a16.6 16.6 0 014.052 1.676c1.174.764 2.477 1.884 3.834 2.642A85.4 85.4 0 0042.3 61.41s.76-3 1.833-7.656 2.035-10.938 2.035-10.938 7.384-.821 9.752 2.558-.079 10.958-.079 10.958-.6 2.368-1.954 6.475c-1.265 3.841-3.142 9.416-7.084 10.043-4.123.657-9.359-2.361-14.117-5.974a72.815 72.815 0 00-6.167-4.336 11.383 11.383 0 00-3.419-1.771c-1.491-.227-4.689 1.108-7.159 1.134a20.768 20.768 0 01-5.661-.67 4.85 4.85 0 01-1.229-.565s-3.082.066-4.693-.1-1.751-.547-1.751-.547-1.95.561-2.342-.356c-.2-.475 1.43-1.376 1.43-1.376S.39 57.24 3.264 56.2c2.263-.818 6.545-1.817 9.364-2.594a21.4 21.4 0 002.711-.951 2.553 2.553 0 00-.821-1.025 22.192 22.192 0 01-2.9-1.912c-.691-.693-1.125-1.762-.46-2.112z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(.097 16.869)"
              fill="#ffd7b5"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5412"
              d="M78.863 48.4c-.843-.545-.952.646-3.227 1.781-.867.432-1.968 1-3.153 1.48a13.891 13.891 0 00-3.739 1.9c-1.085.865-2.287 2.135-3.54 2.993a70.846 70.846 0 01-14.922 7.416s-.7-3.4-1.692-8.675-1.878-12.392-1.878-12.392-6.815-.93-9 2.9.073 12.416.073 12.416.577 3.116 1.825 7.769c1.168 4.352 2.758 10.5 6.4 11.214 3.805.744 8.758-2.943 13.149-7.035a68.97 68.97 0 015.692-4.913c1.022-.762 2.169-1.822 3.159-2.007 1.375-.257 4.327 1.255 6.607 1.284a15.813 15.813 0 005.225-.759 4.187 4.187 0 001.134-.641 40.334 40.334 0 004.331-.107c1.487-.182 1.617-.621 1.617-.621s1.56.731 1.922-.309c.188-.538-1.3-1.559-1.3-1.559s1.285-1.121-1.367-2.3c-2.089-.927-5.544-1.92-8.146-2.8-1.394-.471-3.03-1.08-3.03-1.08a4.539 4.539 0 01.923-1.464 17.708 17.708 0 002.444-2.03c.641-.783 1.107-2.061.493-2.461z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(57.649 13.316)"
              fill="#ffd7b5"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5413"
              d="M56.975.34a3.681 3.681 0 013.848.918 4.689 4.689 0 011.107 3 11.558 11.558 0 011.894 1.074c.983.688 1.27 1.142 2.037 1.679 1.075.754 2.783 1.772 3.411 2.79 2.225 3.6 1.557 8.871 1.557 8.871a17.58 17.58 0 01-1.6 3.906c-2.791 4.776-8.394 13.077-12.719 17.089-5.97 5.538-9.4 1.157-9.4 1.157a14.98 14.98 0 01-.755-3.526 14.4 14.4 0 01.27-3.552 4.917 4.917 0 00-1.386 1.854 10.268 10.268 0 00-.56 2.988s-1.9-3.607-.084-6.837a19.435 19.435 0 002.358-5.7l-.279-4.563S44.7 16.7 45.923 12.8s5.633-6.913 5.633-6.913S52.85 1.414 56.975.34z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(17.296 .066)"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5414"
              d="M47.153 30.111l30.955.077a23.96 23.96 0 014.052 1 11.31 11.31 0 015.64 3.641c1.643 2.178 2.211 5.615 2.644 8.252.427 2.6.729 4.422.729 4.422a12.721 12.721 0 01-4.024 2.3 19.355 19.355 0 01-5.218.753s.135 3.321.316 6.051a16.533 16.533 0 01-.825 4.882 26.437 26.437 0 00-1.357 6.46C80 75.162 81.12 90.334 81.12 90.334a116.909 116.909 0 01-18.754 1.71 132.269 132.269 0 01-19.474-1.71s.524-6.774.891-13.574c.26-4.811.667-8.623.052-11.625a50.74 50.74 0 00-1.345-5.018c-.612-1.72-.49-4.8-.332-7.128.082-1.209.175-2.66.175-2.66a17.625 17.625 0 01-4.854-.64 16.416 16.416 0 01-4.275-2.164s.252-2.16.886-5.077c.552-2.54 1.358-5.717 2.982-7.744a12.3 12.3 0 016.534-3.926 22.05 22.05 0 013.547-.667z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(13.109 11.888)"
              fill="#ada0ec"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5415"
              d="M57.544 8.087a5.8 5.8 0 015.765 1.774 18.559 18.559 0 012.847 3.474 12.283 12.283 0 011.461 5.325s2.525-.436 2.261 2.05a4.021 4.021 0 01-2.818 3.24l-.707 2.766-1.618 2.368s-.586 5.011 1.065 6.84c1.706 1.891 8.168 3.018 8.168 3.018a20.174 20.174 0 01-4.259 3.915A21.042 21.042 0 0158.437 46.4a21.814 21.814 0 01-11.805-3.994 12.979 12.979 0 01-3.362-3.494s5.973-1.216 7.392-2.779c1.647-1.814 1.126-6.65 1.126-6.65l-1.8-3.127-.847-2.536a3.823 3.823 0 01-3-3.943c-.086-2.028 2.381-.818 4.3-3.257a18.936 18.936 0 002.534-3.2c.4-.69.958-1.929 1.306-2.689a3.971 3.971 0 013.263-2.644z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(17.083 3.133)"
              fill="#ffddc0"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5416"
              d="M85.49 69.721a.343.343 0 01-.327-.23c-2.061-6.148-3.335-13.609-4.358-19.6-.761-4.458-1.418-8.307-2.137-9.912a10.507 10.507 0 00-7.7-5.981c-.97-.242-2-.458-2.992-.665-2.9-.608-5.9-1.236-7.926-2.641-1.66-1.152-1.765-4.556-1.671-7.394a.344.344 0 01.355-.321.337.337 0 01.333.342c-.082 2.465-.026 5.855 1.385 6.835 1.908 1.325 4.837 1.938 7.67 2.531 1 .209 2.034.426 3.018.672a11.131 11.131 0 018.16 6.36c.753 1.679 1.385 5.381 2.185 10.067 1.019 5.973 2.288 13.407 4.333 19.507a.329.329 0 01-.222.417.353.353 0 01-.106.013z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(23.038 9.07)"
            />
            <path
              data-name="Path 5417"
              d="M58.71 19.86a21.232 21.232 0 01-3.734.5 15.089 15.089 0 01-3.644-.285s.558 3.458 3.6 3.637c3.189.188 3.778-3.852 3.778-3.852z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(20.266 7.841)"
              fill="#fff"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5418"
              d="M55.239 24.143q-.114 0-.231-.006c-3.28-.193-3.912-3.88-3.918-3.917a.326.326 0 01.107-.295.353.353 0 01.314-.079 14.78 14.78 0 003.549.276 21.079 21.079 0 003.664-.49.355.355 0 01.314.074.324.324 0 01.111.293c-.213 1.461-1.303 4.144-3.91 4.144zm-3.355-3.551a3.651 3.651 0 003.166 2.882c2.21.133 3.047-2.081 3.311-3.084a22.058 22.058 0 01-3.272.394 15.949 15.949 0 01-3.205-.192z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(20.169 7.747)"
            />
            <path
              data-name="Path 5419"
              d="M56.785 29.3a5.463 5.463 0 01-2.646-.832 14.826 14.826 0 01-5.6-5.371 16.756 16.756 0 01-1.433-4.454.333.333 0 01.288-.377.342.342 0 01.392.277 16.164 16.164 0 001.359 4.241A14.114 14.114 0 0054.48 27.9a3.822 3.822 0 003.552.493 12.52 12.52 0 006.005-5.182 16.752 16.752 0 001.343-4.329.342.342 0 01.4-.269.332.332 0 01.279.383 17.141 17.141 0 01-1.418 4.534A13.222 13.222 0 0158.3 29a4.031 4.031 0 01-1.515.3z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(18.596 7.212)"
            />
            <path
              data-name="Path 5420"
              d="M54.211 20.315a.35.35 0 01-.2-.064c-.133-.094-1.3-.941-1.206-1.827a1.862 1.862 0 01.358-.773c.461-.712 1.091-1.688-.028-3.684a.325.325 0 01.14-.449.351.351 0 01.466.134c1.309 2.334.494 3.6.007 4.349a1.633 1.633 0 00-.257.487c-.041.406.607 1 .928 1.23a.323.323 0 01.074.463.349.349 0 01-.282.134z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(20.844 5.321)"
            />
            <path
              data-name="Path 5421"
              d="M52.3 12.831a.352.352 0 01-.164-.04 3.583 3.583 0 00-1.655-.429.331.331 0 110-.663 4.281 4.281 0 011.98.509.325.325 0 01.139.449.346.346 0 01-.3.174z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(19.796 4.619)"
            />
            <path
              data-name="Path 5422"
              d="M49.975 15.738c0-.806.494-1.456 1.1-1.454s1.086.658 1.082 1.463-.495 1.456-1.1 1.454-1.087-.658-1.082-1.463z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(19.73 5.639)"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5423"
              d="M62.605 23.1a30.044 30.044 0 01-3.069 2.458c-1.654 1.126-3.081 1.6-4.106 1.433s-6.085-3.809-6.085-3.809 3.587 5.858 7.4 6.139c2.924.215 5.657-2.509 5.657-2.509z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(19.482 9.119)"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5424"
              d="M47.561 18.515a.344.344 0 01-.318-.205.327.327 0 01.187-.432c2.7-1.07 4.03-4.127 5.2-6.826a19.862 19.862 0 011.549-3.1c.822-1.2 1.624-1.806 2.453-1.844 1.067-.051 1.936.82 2.652 1.676a.323.323 0 01-.052.466.354.354 0 01-.482-.05c-.85-1.016-1.487-1.455-2.083-1.43s-1.228.547-1.911 1.546a19.463 19.463 0 00-1.488 2.989c-1.165 2.677-2.614 6.008-5.577 7.182a.355.355 0 01-.13.028z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(18.641 2.412)"
            />
            <path
              data-name="Path 5425"
              d="M46.3 20.721a.345.345 0 01-.318-.2 15.393 15.393 0 01-1.182-6.564c.335-3.725 3.041-8.517 9.632-10.792 5.229-1.806 9.161.265 9.8 1.881a.327.327 0 01-.2.428.349.349 0 01-.444-.191c-.44-1.108-3.852-3.246-8.927-1.493-6.285 2.169-8.862 6.7-9.178 10.225a15.018 15.018 0 001.13 6.248.327.327 0 01-.185.433.357.357 0 01-.128.025z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(17.673 .973)"
            />
            <path
              data-name="Path 5426"
              d="M59.976 12.968a.353.353 0 01-.2-.063 3.484 3.484 0 00-3.789-.242.352.352 0 01-.468-.128.325.325 0 01.133-.451 4.232 4.232 0 014.529.285.323.323 0 01.076.463.348.348 0 01-.281.136z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(21.901 4.561)"
            />
            <path
              data-name="Path 5427"
              d="M62.082 17.661a.34.34 0 01-.343-.3 8.317 8.317 0 00-2.933-6.025 12.2 12.2 0 01-2.222-2.76.325.325 0 01.141-.448.352.352 0 01.466.136 11.654 11.654 0 002.109 2.609 8.966 8.966 0 013.122 6.43.336.336 0 01-.315.357z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(22.323 3.192)"
            />
            <path
              data-name="Path 5428"
              d="M63.311 20.48a.351.351 0 01-.165-.041.325.325 0 01-.136-.45 12.285 12.285 0 001.4-5.485c-.025-3.412-1.46-7.477-4.608-8.867a.326.326 0 01-.169-.439.352.352 0 01.456-.163c3.658 1.616 4.985 6.108 5.01 9.465a12.717 12.717 0 01-1.488 5.809.346.346 0 01-.3.171z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(23.531 1.976)"
            />
            <path
              data-name="Path 5429"
              d="M30.46 69.48a.371.371 0 01-.1-.014.33.33 0 01-.229-.414 146.927 146.927 0 003.843-17.929c.881-5.107 1.642-9.517 2.476-11.377a11.134 11.134 0 018.16-6.36c.983-.246 2.016-.462 3.015-.671 2.834-.593 5.764-1.207 7.672-2.532 1.413-.98 1.468-4.37 1.386-6.835a.337.337 0 01.333-.342.345.345 0 01.355.321c.094 2.837-.011 6.242-1.672 7.394-2.025 1.406-5.026 2.034-7.928 2.642a81.86 81.86 0 00-2.989.665 10.51 10.51 0 00-7.7 5.981c-.8 1.786-1.555 6.16-2.429 11.224a147.33 147.33 0 01-3.864 18.014.342.342 0 01-.329.233z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(11.89 9.083)"
            />
            <path
              data-name="Path 5430"
              d="M40.556 86.616h-.014a.337.337 0 01-.331-.344c.177-4.4.492-8.638.769-12.375.385-5.181.689-9.274.447-11.332a24.285 24.285 0 00-1.091-4.521 16.882 16.882 0 01-1.007-4.766 36.214 36.214 0 01.178-3.837 23.962 23.962 0 00.132-3.2c-.1-2.1-.521-5.6-.526-5.634a.335.335 0 01.3-.367.343.343 0 01.381.291c0 .035.424 3.557.529 5.678a24.409 24.409 0 01-.133 3.287 35.125 35.125 0 00-.176 3.771A16.4 16.4 0 0041 57.853a24.794 24.794 0 011.116 4.638c.249 2.118-.057 6.237-.444 11.453-.277 3.732-.591 7.963-.768 12.354a.339.339 0 01-.348.318z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(15.441 15.886)"
            />
            <path
              data-name="Path 5431"
              d="M67.9 86.6a.339.339 0 01-.343-.318c-.152-3.79-.372-7.469-.565-10.715-.349-5.86-.625-10.489-.351-12.811a24.742 24.742 0 011.116-4.639 16.4 16.4 0 00.977-4.586 35.129 35.129 0 00-.176-3.771 24.448 24.448 0 01-.133-3.287c.106-2.122.526-5.643.53-5.678a.34.34 0 01.381-.291.335.335 0 01.3.367c0 .035-.421 3.534-.526 5.634a23.988 23.988 0 00.132 3.2 36.281 36.281 0 01.178 3.836 16.878 16.878 0 01-1.006 4.766 24.232 24.232 0 00-1.091 4.522c-.267 2.266.008 6.87.355 12.7.194 3.249.413 6.931.565 10.727a.336.336 0 01-.33.344z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(26.266 15.989)"
            />
            <path
              data-name="Path 5432"
              d="M42.525 62.76a.349.349 0 01-.264-.118 8.569 8.569 0 00-2.822-2.111c-.49-.174-1.04-.35-1.69-.558-1.327-.425-3.145-1.006-5.717-1.988a57.594 57.594 0 01-9.589-4.459c-.975-.632-1.549-1.049-2.011-1.384a14.861 14.861 0 00-1.507-1 13.7 13.7 0 00-2.712-1.077 46.332 46.332 0 01-1.576-.527 24.49 24.49 0 01-2.558-1.138 36.095 36.095 0 00-1.406-.668 8.1 8.1 0 01-1.287-.747c-.527-.355-.773-.5-.919-.4a.346.346 0 00-.149.31 2.739 2.739 0 001.133 1.716 13.227 13.227 0 001.155.733 9.659 9.659 0 011.577 1.07 3.893 3.893 0 01.5.644 7.607 7.607 0 004.6 3.4.33.33 0 01.245.4.344.344 0 01-.421.235 8.226 8.226 0 01-5-3.671 3.97 3.97 0 00-.4-.529 9.055 9.055 0 00-1.466-.988 13.844 13.844 0 01-1.217-.774 3.331 3.331 0 01-1.4-2.247 1 1 0 01.428-.836c.56-.4 1.125-.016 1.723.387a7.44 7.44 0 001.178.687c.484.213.966.45 1.433.68a23.788 23.788 0 002.486 1.106c.559.2 1.073.365 1.553.519a14.206 14.206 0 012.847 1.137 15.617 15.617 0 011.568 1.038c.455.33 1.021.741 1.981 1.363a56.949 56.949 0 009.458 4.393c2.554.975 4.361 1.553 5.68 1.975.659.21 1.216.389 1.712.566a9.1 9.1 0 013.111 2.307.322.322 0 01-.043.466.35.35 0 01-.214.088z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(3.013 18.118)"
            />
            <path
              data-name="Path 5433"
              d="M43.929 69.562c-4.215 0-9.266-3.28-11.689-5.055-5.152-3.772-8.684-6.3-10.758-7.051a5.871 5.871 0 00-2.968.339c-.426.114-.867.232-1.285.317a16.551 16.551 0 01-3.9.367c-1.216-.042-3.369-.356-4.288-.491a19.224 19.224 0 01-3.13-1.059c-.673-.266-1.043-.69-.989-1.134.047-.386.4-.666.939-.748a9.026 9.026 0 012.285.271c.442.086.86.167 1.065.179a23.038 23.038 0 002.431-.052.341.341 0 01.372.3.335.335 0 01-.314.358 23.721 23.721 0 01-2.529.054 10.864 10.864 0 01-1.162-.191 9.242 9.242 0 00-2.044-.266c-.26.039-.357.134-.362.17-.008.066.124.269.567.444a19.584 19.584 0 002.972 1.017c.829.121 3.032.443 4.209.484a16.134 16.134 0 003.735-.353c.4-.081.827-.2 1.243-.308a6.219 6.219 0 013.395-.32c2.162.782 5.732 3.336 10.932 7.144 2.448 1.793 10.751 7.356 14.8 3.664 3.092-2.823 6.085-15.119 6.115-15.243a.343.343 0 01.413-.248.331.331 0 01.257.4c-.124.514-3.07 12.614-6.312 15.573a5.727 5.727 0 01-4 1.438z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(1.94 20.587)"
            />
            <path
              data-name="Path 5434"
              d="M12.979 54.768a.348.348 0 01-.291-.154.324.324 0 01.106-.457 8.484 8.484 0 014.528-1.51.327.327 0 01.358.318.336.336 0 01-.33.344 7.847 7.847 0 00-4.186 1.407.354.354 0 01-.185.052z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(4.988 20.785)"
            />
            <path
              data-name="Path 5435"
              d="M8.494 56.734h-.043a20.76 20.76 0 00-2.676-.184c-.3 0-.627-.007-1.055-.026-.064 0-.155 0-.265-.005-1.176-.019-2.355-.081-2.655-.678a.863.863 0 010-.841 2.263 2.263 0 011.782-.847 64.823 64.823 0 017.889-.25.332.332 0 11-.019.663 63.573 63.573 0 00-7.783.245c-.778.1-1.163.322-1.262.5a.221.221 0 00.01.23c.044.086.332.287 2.052.308.119 0 .218 0 .287.006.418.018.735.022 1.032.025a21.378 21.378 0 012.752.189.334.334 0 01.3.369.34.34 0 01-.346.296z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(.666 21.274)"
            />
            <path
              data-name="Path 5436"
              d="M1.151 56.733a1.124 1.124 0 01-.951-.377.9.9 0 01-.153-.856c.19-.568.92-1.052 2.171-1.437a40.844 40.844 0 019.4-1.688.332.332 0 11.017.663A40.046 40.046 0 002.428 54.7C.992 55.14.744 55.581.7 55.707a.252.252 0 00.054.255c.166.216.94.056 1.357-.029.189-.039.364-.074.505-.091a.344.344 0 01.384.286.334.334 0 01-.3.371c-.126.016-.281.048-.449.082a5.737 5.737 0 01-1.1.152z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(0 20.679)"
            />
            <path
              data-name="Path 5437"
              d="M1.58 55.885a.351.351 0 01-.247-.1 1.237 1.237 0 01-.449-1.029 1.6 1.6 0 01.9-1.083 12.65 12.65 0 012.59-1.033c1.547-.463 3.2-.865 4.955-1.29l.441-.107c.478-.116 1.421-.389 2.419-.679 1.114-.323 2.265-.657 2.989-.837a.348.348 0 01.419.238.331.331 0 01-.247.4c-.71.176-1.855.509-2.962.83-1.006.292-1.957.567-2.45.687l-.441.107c-1.744.423-3.39.823-4.919 1.28a12.363 12.363 0 00-2.43.964c-.361.216-.563.424-.585.6-.017.136.07.3.259.487a.323.323 0 01-.007.468.349.349 0 01-.235.097z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(.346 19.628)"
            />
            <path
              data-name="Path 5438"
              d="M9.306 56.392a.344.344 0 01-.318-.2 18.183 18.183 0 01-.979-4.375.335.335 0 01.314-.358.342.342 0 01.372.3 17.224 17.224 0 00.929 4.177.327.327 0 01-.186.433.357.357 0 01-.132.023z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(3.161 20.314)"
            />
            <path
              data-name="Path 5439"
              d="M41.44 45.861c-3.114 0-6.977-1.623-8.287-2.883a.322.322 0 010-.468.354.354 0 01.487 0 13.659 13.659 0 008.523 2.655.34.34 0 01.378.3.335.335 0 01-.307.364c-.257.02-.523.032-.794.032z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(13.049 16.744)"
            />
            <path
              data-name="Path 5440"
              d="M69.177 45.956a7.938 7.938 0 01-.795-.038.335.335 0 01-.307-.364.344.344 0 01.378-.3 13.658 13.658 0 008.524-2.654.354.354 0 01.487 0 .322.322 0 010 .468c-1.31 1.266-5.172 2.888-8.287 2.888z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(26.876 16.782)"
            />
            <path
              data-name="Path 5441"
              d="M58.831 38.018a19.168 19.168 0 01-2.648-.184c-7.047-.981-12.078-5.362-13.09-7.38a.326.326 0 01.16-.443.35.35 0 01.459.154c1.018 2.031 6.088 6.11 12.568 7.012 4.437.618 11.085-.088 17.559-6.958a.354.354 0 01.486-.023.323.323 0 01.024.468c-5.493 5.836-11.13 7.354-15.518 7.354z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(17 11.836)"
            />
            <path
              data-name="Path 5442"
              d="M48.3 21.168h-.02a3.862 3.862 0 01-3.064-3.085 2.44 2.44 0 01.427-2.289 2.232 2.232 0 011.991-.6.335.335 0 01.3.366.344.344 0 01-.38.293 1.6 1.6 0 00-1.4.387 1.853 1.853 0 00-.27 1.7 3.2 3.2 0 002.432 2.572.331.331 0 11-.019.662z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(17.811 5.988)"
            />
            <path
              data-name="Path 5443"
              d="M47.251 18.02a.349.349 0 01-.271-.127s-.334-.41-.58-.647a.322.322 0 010-.468.354.354 0 01.487 0c.275.265.62.689.635.706a.323.323 0 01-.059.465.352.352 0 01-.212.071z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(18.279 6.586)"
            />
            <path
              data-name="Path 5444"
              d="M60.41 21.344a.331.331 0 11-.019-.662 3.2 3.2 0 002.432-2.572 1.853 1.853 0 00-.269-1.7 1.606 1.606 0 00-1.4-.387.342.342 0 01-.38-.293.335.335 0 01.3-.366 2.236 2.236 0 011.991.6 2.439 2.439 0 01.427 2.289 3.865 3.865 0 01-3.064 3.086z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(23.714 6.058)"
            />
            <path
              data-name="Path 5445"
              d="M60.82 18.2a.35.35 0 01-.211-.07.323.323 0 01-.059-.465c.014-.018.36-.442.635-.707a.354.354 0 01.487 0 .323.323 0 010 .469c-.245.236-.576.642-.58.646a.349.349 0 01-.272.127z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(23.876 6.655)"
            />
            <path
              data-name="Path 5446"
              d="M56.162 15.653c0-.8.495-1.456 1.1-1.454s1.085.658 1.081 1.463-.495 1.456-1.1 1.454-1.085-.658-1.081-1.463z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(22.173 5.606)"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5447"
              d="M49.45 6.354a.359.359 0 01-.1-.013.33.33 0 01-.233-.411 8.713 8.713 0 015.4-5.668 4.33 4.33 0 013.693.312 4.546 4.546 0 011.875 3.564.344.344 0 01-.686.057 3.914 3.914 0 00-1.572-3.07 3.652 3.652 0 00-3.1-.231 8.014 8.014 0 00-4.947 5.222.343.343 0 01-.33.238z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(19.387)"
            />
            <path
              data-name="Path 5448"
              d="M45.149 32.3a.35.35 0 01-.275-.132 7.2 7.2 0 01-1.026-6.273 17.252 17.252 0 011.5-3.388 10.44 10.44 0 001.41-3.846.346.346 0 01.392-.279.334.334 0 01.289.377 11.112 11.112 0 01-1.481 4.055 16.487 16.487 0 00-1.446 3.271 6.42 6.42 0 00.156 4.231 6.148 6.148 0 012.026-4.446.354.354 0 01.487.015.323.323 0 01-.016.469 5.962 5.962 0 00-1.676 5.536.328.328 0 01-.187.378.356.356 0 01-.153.032z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(17.184 7.256)"
            />
            <path
              data-name="Path 5449"
              d="M46.513 32.435a.345.345 0 01-.32-.208 11 11 0 01.561-9.787.351.351 0 01.462-.148.326.326 0 01.154.444 10.262 10.262 0 00-.538 9.246.327.327 0 01-.192.43.361.361 0 01-.127.023z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(17.885 8.787)"
            />
            <path
              data-name="Path 5450"
              d="M10.347 18a5.722 5.722 0 01-4-1.437C3.107 13.6.133.942.008.4a.331.331 0 01.26-.4.343.343 0 01.412.259c.031.13 3.052 13 6.143 15.823 4.045 3.69 12.348-1.871 14.8-3.664 5.2-3.808 8.771-6.362 10.932-7.144a6.215 6.215 0 013.4.321c.416.111.846.226 1.243.307a16.141 16.141 0 003.735.354c1.178-.042 3.38-.363 4.209-.484a19.3 19.3 0 002.972-1.016c.444-.175.575-.379.566-.445 0-.037-.1-.131-.361-.17a9.248 9.248 0 00-2.042.266 10.9 10.9 0 01-1.162.191 23.71 23.71 0 01-2.528-.054.335.335 0 01-.314-.358.342.342 0 01.372-.3 23.231 23.231 0 002.431.052 10.791 10.791 0 001.064-.179 8.88 8.88 0 012.285-.271c.541.082.893.361.94.747.054.444-.315.868-.989 1.135a18.948 18.948 0 01-3.131 1.058c-.918.135-3.07.449-4.287.491a16.507 16.507 0 01-3.9-.368c-.417-.085-.858-.2-1.284-.316a5.866 5.866 0 00-2.969-.339c-2.073.75-5.605 3.279-10.758 7.051C19.613 14.719 14.562 18 10.347 18z"
              transform="translate(9.978 -200.418) translate(5020.553 13469.486) translate(94.569 70.793)"
            />
          </g>
          <g data-name="Activities clock">
            <path
              data-name="Path 5377"
              d="M7.142 4.968a9.618 9.618 0 011.38-2.8 4.981 4.981 0 012.889-1.95 5.193 5.193 0 013.645.723 11.276 11.276 0 012.39 2.09A10.694 10.694 0 0120.335.885 5.261 5.261 0 0123.65.474a5.469 5.469 0 013.115 2.236 6.159 6.159 0 01.84 2.762 8.833 8.833 0 012.6.17 5.1 5.1 0 013.222 1.985 5.538 5.538 0 01.6 3.7 8.005 8.005 0 01-1.242 2.808 7.317 7.317 0 011.115 2.65 4.658 4.658 0 01-.634 3.144 3.722 3.722 0 01-2.332 1.536 7.1 7.1 0 01-2.9-.221 8.944 8.944 0 01-1.119 2.505 5.07 5.07 0 01-3.03 2.2 6.692 6.692 0 01-4.08-.635 8.707 8.707 0 01-2.4-1.857A9.427 9.427 0 0114.73 25.6a6.238 6.238 0 01-3.8.572 5.628 5.628 0 01-3.4-2.1 7.86 7.86 0 01-1.186-2.774 9.334 9.334 0 01-3.242-.15 4.286 4.286 0 01-2.569-2.06 4.737 4.737 0 01-.191-3.324 8.415 8.415 0 011.428-2.721A8.464 8.464 0 01.78 9.9a5.258 5.258 0 01.868-3.119 4.707 4.707 0 012.735-1.9 6.352 6.352 0 012.759.087z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(.053 .054)"
              fill="#fff"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5378"
              d="M7.142 4.968a9.618 9.618 0 011.38-2.8 4.981 4.981 0 012.889-1.95 5.193 5.193 0 013.645.723 11.276 11.276 0 012.39 2.09A10.694 10.694 0 0120.335.885 5.261 5.261 0 0123.65.474a5.469 5.469 0 013.115 2.236 6.159 6.159 0 01.84 2.762 8.833 8.833 0 012.6.17 5.1 5.1 0 013.222 1.985 5.538 5.538 0 01.6 3.7 8.005 8.005 0 01-1.242 2.808 7.317 7.317 0 011.115 2.65 4.658 4.658 0 01-.634 3.144 3.722 3.722 0 01-2.332 1.536 7.1 7.1 0 01-2.9-.221 8.944 8.944 0 01-1.119 2.505 5.07 5.07 0 01-3.03 2.2 6.692 6.692 0 01-4.08-.635 8.707 8.707 0 01-2.4-1.857A9.427 9.427 0 0114.73 25.6a6.238 6.238 0 01-3.8.572 5.628 5.628 0 01-3.4-2.1 7.86 7.86 0 01-1.186-2.774 9.334 9.334 0 01-3.242-.15 4.286 4.286 0 01-2.569-2.06 4.737 4.737 0 01-.191-3.324 8.415 8.415 0 011.428-2.721A8.464 8.464 0 01.78 9.9a5.258 5.258 0 01.868-3.119 4.707 4.707 0 012.735-1.9 6.352 6.352 0 012.759.087z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(.053 .054)"
              fill="#f3f0ff"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5379"
              d="M5.537 10.527c.745-2.762 3.848-2.979 3.848-2.979a6.722 6.722 0 00.7 3.429 6.209 6.209 0 003.072 2.591 5.348 5.348 0 01-1.618 1.632 3.824 3.824 0 01-3.178.309 4.609 4.609 0 01-2.3-1.664 4.615 4.615 0 01-.524-3.318z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(2.142 2.98)"
              fill="#ffd83b"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5380"
              d="M12.1 26.5a6 6 0 01-1.255-.134A5.926 5.926 0 016.3 21.524c-.82.115-4.52.468-5.86-2.314-1.348-2.8.773-5.547 1.229-6.089-.383-.584-2.085-3.486-.191-6.306A5.033 5.033 0 017.119 4.9C7.313 4.1 8.3.8 11.379.108S16.941 2.224 17.5 2.92c.609-.649 3.222-3.207 6.022-2.556A5.528 5.528 0 0127.8 5.4c.889-.08 5.027-.265 6.215 3.016a6.413 6.413 0 01-1.007 5.831c.395.552 2.152 3.27.5 5.772-1.608 2.444-4.567 1.72-5.308 1.491-.192.77-1.105 3.8-3.735 4.5a6.982 6.982 0 01-6.968-2.275A7.443 7.443 0 0112.1 26.5zm-5.666-5.315a.159.159 0 01.157.141 5.664 5.664 0 004.32 4.732c3.861.823 6.427-2.634 6.452-2.669a.158.158 0 01.254 0 6.737 6.737 0 006.765 2.311c2.764-.735 3.539-4.392 3.547-4.429a.159.159 0 01.212-.116c.138.053 3.4 1.269 5.106-1.315s-.539-5.473-.562-5.5a.158.158 0 010-.2 6.139 6.139 0 001.029-5.62c-1.241-3.427-5.995-2.8-6.043-2.793a.158.158 0 01-.18-.154 5.18 5.18 0 00-4.041-4.9c-2.944-.684-5.812 2.564-5.84 2.6a.151.151 0 01-.127.054.158.158 0 01-.121-.065c-.026-.036-2.63-3.575-5.916-2.841S7.4 5.087 7.391 5.126a.158.158 0 01-.209.12 4.712 4.712 0 00-5.44 1.745c-1.982 2.95.233 6.017.255 6.047a.158.158 0 01-.011.2c-.027.029-2.662 2.92-1.26 5.833S6.361 21.2 6.4 21.188z"
              transform="translate(9.978 -200.418) translate(5008 13500.191)"
            />
            <path
              data-name="Path 5381"
              d="M8.24 9.581a5.671 5.671 0 115.671 5.594A5.633 5.633 0 018.24 9.581z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(3.253 1.574)"
              fill="#586580"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5382"
              d="M13.956 15.378a5.752 5.752 0 115.829-5.752 5.8 5.8 0 01-5.829 5.752zm0-11.188a5.436 5.436 0 105.513 5.436 5.481 5.481 0 00-5.513-5.436z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(3.209 1.529)"
            />
            <path
              data-name="Path 5383"
              d="M8.678 9.41a5.063 5.063 0 115.062 4.99 5.029 5.029 0 01-5.062-4.99z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(3.426 1.743)"
              fill="#fff"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5384"
              d="M13.785 14.607a5.153 5.153 0 115.221-5.152 5.193 5.193 0 01-5.221 5.152zm0-9.988a4.837 4.837 0 104.9 4.836 4.876 4.876 0 00-4.9-4.836z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(3.381 1.699)"
            />
            <path
              data-name="Path 5385"
              d="M11.982 8.124a.47.47 0 11.469.43.45.45 0 01-.469-.43z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(4.731 3.038)"
              fill="#505a6f"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5386"
              d="M12.5 8.757a.589.589 0 11.626-.588.609.609 0 01-.626.588zm0-.86a.274.274 0 10.31.272.293.293 0 00-.31-.269z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(4.686 2.993)"
            />
            <path
              data-name="Path 5387"
              d="M12.366 8.639a.158.158 0 01-.158-.157l-.015-2.754a.158.158 0 01.157-.159.158.158 0 01.158.157l.015 2.754a.158.158 0 01-.157.159z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(4.814 2.198)"
            />
            <path
              data-name="Path 5388"
              d="M12.436 8.319a.158.158 0 01-.122-.058l-1.163-1.416a.158.158 0 01.245-.2l1.162 1.416a.158.158 0 01-.122.258z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(4.388 2.601)"
            />
            <path
              data-name="Path 5389"
              d="M12.353 5.573a.158.158 0 01-.157-.159v-.573a.158.158 0 01.158-.157.158.158 0 01.157.159v.573a.158.158 0 01-.158.157z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(4.815 1.849)"
            />
            <path
              data-name="Path 5390"
              d="M12.351 11.546a.158.158 0 01-.157-.159v-.573a.158.158 0 01.158-.157.158.158 0 01.157.159v.573a.158.158 0 01-.158.157z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(4.814 4.207)"
            />
            <path
              data-name="Path 5391"
              d="M9.679 8.17H9.11a.158.158 0 010-.316h.569a.158.158 0 010 .316z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(3.534 3.1)"
            />
            <path
              data-name="Path 5392"
              d="M15.7 8.09l-.577-.005a.158.158 0 010-.316l.577.005a.158.158 0 010 .316z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(5.908 3.067)"
            />
            <path
              data-name="Path 5393"
              d="M9.58 15.918a4.253 4.253 0 01-.225-8.5.16.16 0 01.166.15.158.158 0 01-.15.166 3.94 3.94 0 103.744 5.766.158.158 0 01.279.149 4.311 4.311 0 01-3.814 2.269z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(2.08 2.927)"
            />
            <path
              data-name="Path 5394"
              d="M18.876 12.976a3.791 3.791 0 00-.142-4.529c-.38-.567-.712-.772-.606-.749a4.091 4.091 0 01-.9 8.1 4.165 4.165 0 01-3.373-1.706c-.2-.27.2.018.935.188a3.669 3.669 0 004.086-1.304z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(5.452 3.038)"
              fill="#ffd83b"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5395"
              d="M17.277 16a4.344 4.344 0 01-3.5-1.771c-.043-.059-.131-.18-.046-.292s.21-.071.434.012a5.661 5.661 0 00.71.22 3.491 3.491 0 003.917-1.234 3.577 3.577 0 00-.142-4.353 3.9 3.9 0 00-.529-.636c-.085-.084-.165-.163-.1-.276a.187.187 0 01.192-.08 4.249 4.249 0 01-.936 8.41zm-3.026-1.684a4.033 4.033 0 003.026 1.367 3.931 3.931 0 001.362-7.641 4.245 4.245 0 01.272.364 3.91 3.91 0 01.141 4.706 3.852 3.852 0 01-4.252 1.361 5.151 5.151 0 01-.549-.16zm4.67-1.292z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(5.407 2.994)"
            />
            <path
              data-name="Path 5396"
              d="M3.719 10.664a.158.158 0 010-.316h1.017a.158.158 0 010 .316H3.719z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(1.406 4.085)"
            />
            <path
              data-name="Path 5397"
              d="M4.887 9.533a.159.159 0 01-.05-.008L3.872 9.2a.158.158 0 11.1-.3l.965.324a.158.158 0 01-.05.308z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(1.486 3.511)"
            />
            <path
              data-name="Path 5398"
              d="M5.473 8.449a.157.157 0 01-.092-.03l-.827-.593a.158.158 0 11.184-.257l.827.593a.158.158 0 01-.092.286z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(1.772 2.977)"
            />
            <path
              data-name="Path 5399"
              d="M6.39 7.614a.158.158 0 01-.133-.072L5.7 6.69a.158.158 0 11.265-.173l.556.853a.158.158 0 01-.132.244z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(2.241 2.545)"
            />
            <path
              data-name="Path 5400"
              d="M7.561 7.091a.158.158 0 01-.151-.112L7.114 6a.158.158 0 11.3-.092l.3.974a.158.158 0 01-.151.2z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(2.806 2.29)"
            />
            <path
              data-name="Path 5401"
              d="M3.9 12.166a.158.158 0 01-.05-.308l.965-.324a.158.158 0 11.1.3l-.965.324a.157.157 0 01-.05.008z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(1.477 4.551)"
            />
            <path
              data-name="Path 5402"
              d="M4.623 13.6a.158.158 0 01-.092-.286l.828-.593a.158.158 0 11.184.257l-.828.593a.156.156 0 01-.092.029z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(1.763 5.009)"
            />
            <path
              data-name="Path 5403"
              d="M5.812 14.767a.158.158 0 01-.132-.244l.556-.853a.158.158 0 11.265.173l-.556.853a.158.158 0 01-.133.071z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(2.232 5.369)"
            />
            <path
              data-name="Path 5404"
              d="M7.289 15.444a.163.163 0 01-.046-.007.158.158 0 01-.105-.2l.3-.974a.158.158 0 01.3.092l-.3.974a.158.158 0 01-.149.115z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(2.815 5.588)"
            />
            <path
              data-name="Path 5405"
              d="M9.046 15.53a.158.158 0 01-.157-.145l-.084-1.015a.158.158 0 01.315-.026l.08 1.015a.158.158 0 01-.144.17z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(3.476 5.606)"
            />
            <path
              data-name="Path 5406"
              d="M10.87 14.968a.158.158 0 01-.141-.087l-.458-.909a.158.158 0 11.282-.142l.458.909a.158.158 0 01-.141.229z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(4.048 5.426)"
            />
            <path
              data-name="Path 5407"
              d="M12.195 13.932a.157.157 0 01-.112-.046l-.718-.722a.158.158 0 11.224-.223l.718.722a.158.158 0 01-.112.27z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(4.468 5.091)"
            />
            <path
              data-name="Path 5408"
              d="M17.156 15.721c-.1-.271-.247-1.039-.247-1.039s-.182.844-.239 1.061c-.052.2-.774.307-.774.307s.7.107.777.311.261 1.095.261 1.095l.238-1.091c.048-.222.764-.327.764-.327s-.703-.105-.78-.317z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(6.276 5.797)"
              fill="#ffd83b"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5409"
              d="M21.918 10.1c-.1-.271-.247-1.039-.247-1.039s-.181.844-.239 1.061c-.052.2-.774.307-.774.307s.7.107.777.312.261 1.095.261 1.095l.239-1.091c.048-.222.764-.327.764-.327s-.704-.102-.781-.318z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(8.156 3.579)"
              fill="#ffd83b"
              fillRule="evenodd"
            />
            <path
              data-name="Path 5410"
              d="M20.914 7.37c-.1-.271-.247-1.039-.247-1.039s-.181.844-.239 1.061c-.052.2-.774.307-.774.307s.7.107.777.311.261 1.1.261 1.1l.238-1.091c.049-.222.764-.327.764-.327s-.703-.111-.78-.322z"
              transform="translate(9.978 -200.418) translate(5008 13500.191) translate(7.76 2.5)"
              fill="#ffd83b"
              fillRule="evenodd"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function DoctorWelcome(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 421.584,
    height: 323.582,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 421.584 323.582"
      sx={rootSx}
      {...rest}
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 55678"
            fill="none"
            d="M0 0H29.218V36.824H0z"
          />
        </clipPath>
      </defs>
      <g data-name="background check">
        <g data-name="Group 105528" opacity={0.2}>
          <g
            data-name="Group 105527"
            fill="none"
            stroke="#58aa9d"
            strokeLinecap="round"
            strokeWidth={2}
            strokeDasharray="15 20 15 20 15 20 15 20 15 20 15 20"
          >
            <path
              data-name="Path 100985"
              d="M93.348 49.428c-5.291-2.489-14.042 1.558-16.833 7.478-5.326 11.3 11.9 27.669 18.164 25.912 7-1.963 8.382-28.822-1.333-33.391z"
              transform="translate(-307.519 -295.001) translate(308.529 295.001) translate(0 31.605)"
            />
            <path
              data-name="Path 100986"
              d="M66.882 75.025c-1.889-1.093-21.891-12.663-33.212-3.506-7.949 6.429-8.024 20.175-2.051 27.9 11.831 15.3 48.515 8.44 52.321-2.508 2.564-7.372-9.471-17.497-17.058-21.886z"
              transform="translate(-307.519 -295.001) translate(308.529 295.001) translate(0 31.605)"
            />
            <path
              data-name="Path 100987"
              d="M92.621 263.943c48.69-12.085 104.013-24.388 189.921-22.293 48.045 1.172 58.932-13.737 95.344-32.275 32.455-16.522 48.395-49.376 38.605-68-9.884-18.8-39.988-11.314-64.642-39.3-11.228-12.744-9.252-21.677-15.734-35.809-20.528-44.75-97.465-79.727-135.4-61.216-50.123 24.454-7.272 130.118-63.3 158.982-35.44 18.259-62.227-16.792-97.22 9.965C22.856 187.255 1.65 205.853.01 226.046c-.005.009-2.301 49.378 92.611 37.897z"
              transform="translate(-307.519 -295.001) translate(308.529 295.001) translate(0 31.605)"
            />
          </g>
          <path
            data-name="Path 100988"
            d="M931.559 535.564a255.427 255.427 0 00-17.642 27.736c-7.953 14.468-14 33.964-15.336 50.24-3.746-.177-7.86-.344-12.308-.5-26.344-.935-64.376-1.52-106.664-1.52-48.076 0-90.65.758-116.8 1.923q-1.351.06-2.643.121c-32.652-40.471-98.4-110.979-37.894-139.984a113.442 113.442 0 0011.079-4.25c21.034-9.18 64.257-33.883 59.449-80.46a124.084 124.084 0 01-1.638-20.785c0-28.279 8.953-75.153 68.721-73.014a113.638 113.638 0 0189.68 49.2c19.767 28.915 51.373 64.491 77.113 44.18a23.806 23.806 0 0121.132-4.366c18.523 5.201 39.57 32.141-16.249 151.479z"
            transform="translate(-307.519 -295.001) translate(308.529 295.001) translate(-569.933 -295.001)"
            fill="#dbeae8"
          />
        </g>
        <path
          data-name="Path 100989"
          d="M809.545 3608.025c0 1.914-89.549 3.465-200.013 3.465-62.327 0-118-.494-154.679-1.269-8.449-.179-15.889-.371-22.172-.577a759.376 759.376 0 01-10.865-.422c-7.953-.372-12.3-.776-12.3-1.2 0-.537 7.05-1.046 19.632-1.5 5.153-.187 11.233-.363 18.137-.527 36.328-.871 95.464-1.439 162.243-1.439 58.74 0 111.567.438 148.159 1.138 32.219.615 51.854 1.432 51.854 2.328z"
          transform="translate(-307.519 -295.001) translate(-91.328 -2992.907)"
          fill="#040c2b"
          opacity={0.05}
        />
        <g data-name="Group 105538">
          <g data-name="Group 105526">
            <g data-name="Group 105524">
              <path
                data-name="Path 99827"
                d="M225.71 157.075c2.274-3.644 7.769-7.415 12.631-10.385.771 1.775-4.555 6.04-12.631 10.385z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(2.847 34.137) translate(-136.217 -107.945)"
                fill="#ffc2b1"
              />
              <path
                data-name="Path 99828"
                d="M238.918 173.763a14.917 14.917 0 01-1.59.36c0 .035-.035.029-.081.023a13.16 13.16 0 01-2.506.261 14.07 14.07 0 01-4.38-.337 9.488 9.488 0 01-2.785-1.172 4 4 0 01-.9-.708h-.035a1.855 1.855 0 01.255-.464c-.4.012-.824-.273-1.358-1.184a1.736 1.736 0 01-.424-.487.175.175 0 01-.052-.116 2.771 2.771 0 01-.313-.76 18.061 18.061 0 003.382 1.236c.238.1.482.139.69.209a14.443 14.443 0 005.848.313c.1.058.2.1.261.145a2.069 2.069 0 00.267.151 23.84 23.84 0 013.533 2.356 1.021 1.021 0 00.188.174z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(2.847 34.137) translate(-135.814 -117.387)"
                opacity={0.1}
              />
              <path
                data-name="Path 99829"
                d="M223.91 159.871a5.382 5.382 0 01.58-.853 8.031 8.031 0 01.888-1.178c.215-.249.429-.511.673-.772.5-.528 1.044-1.039 1.613-1.555a10.932 10.932 0 011.039-.934c.023-.046.058-.052.11-.11.209-.174.424-.325.627-.5.528-.429 1.1-.87 1.659-1.305a156.17 156.17 0 012.715-1.955s.012.041.023.07c.58 1.334-3.075 4.74-8.819 8.372-.186.133-.4.267-.609.412-.157.087-.342.215-.493.3z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(2.847 34.137) translate(-135.461 -109.633)"
                fill="#ffc2b1"
              />
              <g data-name="Group 105523">
                <g
                  data-name="Group 105510"
                  transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(2.847 34.137) translate(0 .017)"
                >
                  <path
                    data-name="Path 99830"
                    d="M179.143 84.373V143.9c0 .075 0 .151-.006.226a4.379 4.379 0 01-.186 1.073.058.058 0 00-.006.017 1.593 1.593 0 01-.046.157 4.5 4.5 0 01-.174.418 5.127 5.127 0 01-.377.65 5.3 5.3 0 01-.348.441c-.006.017-.023.029-.035.046a.987.987 0 01-.11.11 1.853 1.853 0 01-.157.145l-.157.139-.168.133-.174.122c-.058.041-.116.075-.18.116a4.032 4.032 0 01-.371.2l-.2.087a.02.02 0 01-.012.006 3.218 3.218 0 01-.395.145c-.075.023-.145.046-.22.064a4.283 4.283 0 01-1.1.139h-98.8a4.283 4.283 0 01-1.1-.139c-.075-.017-.145-.041-.22-.064a3.217 3.217 0 01-.395-.145.018.018 0 01-.012-.006l-.2-.087a3.734 3.734 0 01-.36-.2 5.283 5.283 0 01-.551-.395c-.046-.041-.093-.081-.145-.122s-.1-.093-.157-.145c-.035-.035-.075-.07-.11-.11-.012-.017-.029-.029-.035-.046a2.84 2.84 0 01-.348-.441l-.023-.041c-.046-.07-.087-.133-.133-.2s-.081-.145-.122-.22a.693.693 0 01-.046-.093 1.335 1.335 0 01-.075-.157.643.643 0 01-.041-.093.029.029 0 00-.006-.017c-.023-.058-.046-.122-.07-.18a.006.006 0 01-.006-.006c-.006-.017-.012-.029-.017-.046l-.017-.058a.684.684 0 01-.041-.116.288.288 0 01-.017-.075 1.1 1.1 0 00-.035-.1.221.221 0 00-.017-.058l-.035-.168c-.012-.058-.029-.145-.041-.22s-.017-.145-.029-.22a.283.283 0 00-.006-.07v-.081c-.006-.1-.012-.2-.012-.307V84.146a4.038 4.038 0 01.191-1.068 4.741 4.741 0 01.186-.5 4.511 4.511 0 01.545-.911 4.291 4.291 0 01.435-.482 4.034 4.034 0 01.835-.627 4.225 4.225 0 01.673-.325.029.029 0 00.017-.006c.11-.041.215-.075.331-.11a4.49 4.49 0 011.224-.174h98.788a4.276 4.276 0 011.224.174 4.145 4.145 0 01.783.307 3.821 3.821 0 01.516.313 3.75 3.75 0 01.551.453 2.721 2.721 0 01.22.226.026.026 0 01.017.017.375.375 0 01.046.052.018.018 0 01.012.006c.052.058.1.116.145.174a4.128 4.128 0 01.569.963 3.277 3.277 0 01.168.453 4.038 4.038 0 01.191 1.068v.232z"
                    transform="translate(-71.473 -79.94)"
                    fill="#addcd4"
                  />
                  <g data-name="Group 105509" opacity={0.3} fill="#007965">
                    <path
                      data-name="Path 99831"
                      d="M74.651 81.083a.531.531 0 01-.528.534h-.313a4.033 4.033 0 01.835-.627.507.507 0 01.012.093z"
                      transform="translate(0 .168) translate(-72.447 -80.549)"
                    />
                    <path
                      data-name="Path 99832"
                      d="M80.28 80.768a.526.526 0 01-.528.528h-3.174a.519.519 0 01-.441-.238.5.5 0 01-.087-.29.522.522 0 01.2-.418.314.314 0 01.157-.081.035.035 0 00.023-.006.312.312 0 00.058-.017c.029 0 .058-.006.093-.006h3.168a.52.52 0 01.458.273.488.488 0 01.07.261z"
                      transform="translate(0 .168) translate(-73.387 -80.234)"
                    />
                    <path
                      data-name="Path 99833"
                      d="M88.354 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -80.23)"
                    />
                    <path
                      data-name="Path 99834"
                      d="M96.434 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -80.23)"
                    />
                    <path
                      data-name="Path 99835"
                      d="M104.5 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -80.23)"
                    />
                    <path
                      data-name="Path 99836"
                      d="M112.584 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -80.23)"
                    />
                    <path
                      data-name="Path 99837"
                      d="M120.654 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -80.23)"
                    />
                    <path
                      data-name="Path 99838"
                      d="M128.734 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -80.23)"
                    />
                    <path
                      data-name="Path 99839"
                      d="M136.814 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -80.23)"
                    />
                    <path
                      data-name="Path 99840"
                      d="M144.884 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -80.23)"
                    />
                    <path
                      data-name="Path 99841"
                      d="M152.964 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -80.23)"
                    />
                    <path
                      data-name="Path 99842"
                      d="M161.034 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -80.23)"
                    />
                    <path
                      data-name="Path 99843"
                      d="M169.114 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -80.23)"
                    />
                    <path
                      data-name="Path 99844"
                      d="M177.184 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -80.23)"
                    />
                    <path
                      data-name="Path 99845"
                      d="M185.264 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -80.23)"
                    />
                    <path
                      data-name="Path 99846"
                      d="M193.344 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -80.23)"
                    />
                    <path
                      data-name="Path 99847"
                      d="M201.414 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -80.23)"
                    />
                    <path
                      data-name="Path 99848"
                      d="M209.494 80.764a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -80.23)"
                    />
                    <path
                      data-name="Path 99849"
                      d="M217.564 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -80.23)"
                    />
                    <path
                      data-name="Path 99850"
                      d="M225.644 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -80.23)"
                    />
                    <path
                      data-name="Path 99851"
                      d="M233.714 80.764a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -80.23)"
                    />
                    <path
                      data-name="Path 99852"
                      d="M241.794 80.764a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -80.23)"
                    />
                    <path
                      data-name="Path 99853"
                      d="M249.874 80.764v.046a.527.527 0 01-.528.487h-3.168a.527.527 0 01-.528-.534.5.5 0 01.07-.261.523.523 0 01.464-.273h2.86a4.145 4.145 0 01.783.308.588.588 0 01.052.226z"
                      transform="translate(0 .168) translate(-144.588 -80.23)"
                    />
                    <path
                      data-name="Path 99854"
                      d="M254.281 81.747h-.029a.51.51 0 01-.081-.006.485.485 0 01-.348-.215.551.551 0 01-.093-.226 3.749 3.749 0 01.551.453z"
                      transform="translate(0 .168) translate(-147.98 -80.679)"
                    />
                    <path
                      data-name="Path 99855"
                      d="M76.187 83.434a.53.53 0 01-.528.528h-3.168a.537.537 0 01-.371-.151 4.511 4.511 0 01.545-.911h2.994a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.737 -81.351)"
                    />
                    <path
                      data-name="Path 99856"
                      d="M84.144 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -81.351)"
                    />
                    <path
                      data-name="Path 99857"
                      d="M92.224 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -81.351)"
                    />
                    <path
                      data-name="Path 99858"
                      d="M100.294 83.434a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -81.351)"
                    />
                    <path
                      data-name="Path 99859"
                      d="M108.374 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -81.351)"
                    />
                    <path
                      data-name="Path 99860"
                      d="M116.444 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -81.351)"
                    />
                    <path
                      data-name="Path 99861"
                      d="M124.524 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -81.351)"
                    />
                    <path
                      data-name="Path 99862"
                      d="M132.6 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -81.351)"
                    />
                    <path
                      data-name="Path 99863"
                      d="M140.674 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -81.351)"
                    />
                    <path
                      data-name="Path 99864"
                      d="M148.754 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -81.351)"
                    />
                    <path
                      data-name="Path 99865"
                      d="M156.824 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -81.351)"
                    />
                    <path
                      data-name="Path 99866"
                      d="M164.9 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -81.351)"
                    />
                    <path
                      data-name="Path 99867"
                      d="M172.974 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -81.351)"
                    />
                    <path
                      data-name="Path 99868"
                      d="M181.054 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -81.351)"
                    />
                    <path
                      data-name="Path 99869"
                      d="M189.134 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -81.351)"
                    />
                    <path
                      data-name="Path 99870"
                      d="M197.2 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -81.351)"
                    />
                    <path
                      data-name="Path 99871"
                      d="M205.284 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -81.351)"
                    />
                    <path
                      data-name="Path 99872"
                      d="M213.354 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -81.351)"
                    />
                    <path
                      data-name="Path 99873"
                      d="M221.434 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -81.351)"
                    />
                    <path
                      data-name="Path 99874"
                      d="M229.514 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -81.351)"
                    />
                    <path
                      data-name="Path 99875"
                      d="M237.584 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -81.351)"
                    />
                    <path
                      data-name="Path 99876"
                      d="M245.664 83.434a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -81.351)"
                    />
                    <path
                      data-name="Path 99877"
                      d="M253.513 83.863a.512.512 0 01-.308.1h-3.168a.526.526 0 01-.528-.528.535.535 0 01.528-.534h2.907a4.128 4.128 0 01.569.962z"
                      transform="translate(0 .168) translate(-146.208 -81.351)"
                    />
                    <path
                      data-name="Path 99878"
                      d="M73.669 85.874a.531.531 0 01-.528.534H71.47a4.038 4.038 0 01.191-1.068h1.479a.531.531 0 01.529.534z"
                      transform="translate(0 .168) translate(-71.464 -82.375)"
                    />
                    <path
                      data-name="Path 99879"
                      d="M80.274 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -82.375)"
                    />
                    <path
                      data-name="Path 99880"
                      d="M88.354 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -82.375)"
                    />
                    <path
                      data-name="Path 99881"
                      d="M96.434 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -82.375)"
                    />
                    <path
                      data-name="Path 99882"
                      d="M104.5 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -82.375)"
                    />
                    <path
                      data-name="Path 99883"
                      d="M112.584 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -82.375)"
                    />
                    <path
                      data-name="Path 99884"
                      d="M120.654 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -82.375)"
                    />
                    <path
                      data-name="Path 99885"
                      d="M128.734 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -82.375)"
                    />
                    <path
                      data-name="Path 99886"
                      d="M136.814 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -82.375)"
                    />
                    <path
                      data-name="Path 99887"
                      d="M144.884 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -82.375)"
                    />
                    <path
                      data-name="Path 99888"
                      d="M152.964 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -82.375)"
                    />
                    <path
                      data-name="Path 99889"
                      d="M161.034 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -82.375)"
                    />
                    <path
                      data-name="Path 99890"
                      d="M169.114 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -82.375)"
                    />
                    <path
                      data-name="Path 99891"
                      d="M177.184 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -82.375)"
                    />
                    <path
                      data-name="Path 99892"
                      d="M185.264 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -82.375)"
                    />
                    <path
                      data-name="Path 99893"
                      d="M193.344 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -82.375)"
                    />
                    <path
                      data-name="Path 99894"
                      d="M201.414 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -82.375)"
                    />
                    <path
                      data-name="Path 99895"
                      d="M209.494 85.874a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -82.375)"
                    />
                    <path
                      data-name="Path 99896"
                      d="M217.564 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -82.375)"
                    />
                    <path
                      data-name="Path 99897"
                      d="M225.644 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -82.375)"
                    />
                    <path
                      data-name="Path 99898"
                      d="M233.714 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -82.375)"
                    />
                    <path
                      data-name="Path 99899"
                      d="M241.794 85.874a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -82.375)"
                    />
                    <path
                      data-name="Path 99900"
                      d="M249.874 85.874a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -82.375)"
                    />
                    <path
                      data-name="Path 99901"
                      d="M255.64 86.408h-1.392a.534.534 0 010-1.068h1.2a4.04 4.04 0 01.192 1.068z"
                      transform="translate(0 .168) translate(-147.976 -82.375)"
                    />
                    <path
                      data-name="Path 99902"
                      d="M76.064 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -83.496)"
                    />
                    <path
                      data-name="Path 99903"
                      d="M84.144 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -83.496)"
                    />
                    <path
                      data-name="Path 99904"
                      d="M92.224 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -83.496)"
                    />
                    <path
                      data-name="Path 99905"
                      d="M100.294 88.544a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -83.496)"
                    />
                    <path
                      data-name="Path 99906"
                      d="M108.374 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -83.496)"
                    />
                    <path
                      data-name="Path 99907"
                      d="M116.444 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -83.496)"
                    />
                    <path
                      data-name="Path 99908"
                      d="M124.524 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -83.496)"
                    />
                    <path
                      data-name="Path 99909"
                      d="M132.6 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -83.496)"
                    />
                    <path
                      data-name="Path 99910"
                      d="M140.674 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -83.496)"
                    />
                    <path
                      data-name="Path 99911"
                      d="M148.754 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -83.496)"
                    />
                    <path
                      data-name="Path 99912"
                      d="M156.824 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -83.496)"
                    />
                    <path
                      data-name="Path 99913"
                      d="M164.9 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -83.496)"
                    />
                    <path
                      data-name="Path 99914"
                      d="M172.974 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -83.496)"
                    />
                    <path
                      data-name="Path 99915"
                      d="M181.054 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -83.496)"
                    />
                    <path
                      data-name="Path 99916"
                      d="M189.134 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -83.496)"
                    />
                    <path
                      data-name="Path 99917"
                      d="M197.2 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -83.496)"
                    />
                    <path
                      data-name="Path 99918"
                      d="M205.284 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -83.496)"
                    />
                    <path
                      data-name="Path 99919"
                      d="M213.354 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -83.496)"
                    />
                    <path
                      data-name="Path 99920"
                      d="M221.434 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -83.496)"
                    />
                    <path
                      data-name="Path 99921"
                      d="M229.514 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -83.496)"
                    />
                    <path
                      data-name="Path 99922"
                      d="M237.584 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -83.496)"
                    />
                    <path
                      data-name="Path 99923"
                      d="M245.664 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -83.496)"
                    />
                    <path
                      data-name="Path 99924"
                      d="M253.734 88.544a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -83.496)"
                    />
                    <path
                      data-name="Path 99925"
                      d="M73.665 90.994a.53.53 0 01-.528.528H71.46V90.46h1.677a.527.527 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -84.525)"
                    />
                    <path
                      data-name="Path 99926"
                      d="M80.274 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -84.521)"
                    />
                    <path
                      data-name="Path 99927"
                      d="M88.354 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -84.521)"
                    />
                    <path
                      data-name="Path 99928"
                      d="M96.434 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -84.521)"
                    />
                    <path
                      data-name="Path 99929"
                      d="M104.5 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -84.521)"
                    />
                    <path
                      data-name="Path 99930"
                      d="M112.584 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -84.521)"
                    />
                    <path
                      data-name="Path 99931"
                      d="M120.654 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -84.521)"
                    />
                    <path
                      data-name="Path 99932"
                      d="M128.734 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -84.521)"
                    />
                    <path
                      data-name="Path 99933"
                      d="M136.814 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -84.521)"
                    />
                    <path
                      data-name="Path 99934"
                      d="M144.884 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -84.521)"
                    />
                    <path
                      data-name="Path 99935"
                      d="M152.964 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -84.521)"
                    />
                    <path
                      data-name="Path 99936"
                      d="M161.034 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -84.521)"
                    />
                    <path
                      data-name="Path 99937"
                      d="M169.114 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -84.521)"
                    />
                    <path
                      data-name="Path 99938"
                      d="M177.184 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -84.521)"
                    />
                    <path
                      data-name="Path 99939"
                      d="M185.264 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -84.521)"
                    />
                    <path
                      data-name="Path 99940"
                      d="M193.344 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -84.521)"
                    />
                    <path
                      data-name="Path 99941"
                      d="M201.414 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -84.521)"
                    />
                    <path
                      data-name="Path 99942"
                      d="M209.494 90.984a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -84.521)"
                    />
                    <path
                      data-name="Path 99943"
                      d="M217.564 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -84.521)"
                    />
                    <path
                      data-name="Path 99944"
                      d="M225.644 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -84.521)"
                    />
                    <path
                      data-name="Path 99945"
                      d="M233.714 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -84.521)"
                    />
                    <path
                      data-name="Path 99946"
                      d="M241.794 90.984a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -84.521)"
                    />
                    <path
                      data-name="Path 99947"
                      d="M249.874 90.984a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -84.521)"
                    />
                    <path
                      data-name="Path 99948"
                      d="M255.65 90.46v1.062h-1.392a.526.526 0 01-.528-.528.535.535 0 01.528-.534z"
                      transform="translate(0 .168) translate(-147.98 -84.525)"
                    />
                    <path
                      data-name="Path 99949"
                      d="M76.064 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -85.641)"
                    />
                    <path
                      data-name="Path 99950"
                      d="M84.144 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -85.641)"
                    />
                    <path
                      data-name="Path 99951"
                      d="M92.224 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -85.641)"
                    />
                    <path
                      data-name="Path 99952"
                      d="M100.294 93.654a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -85.641)"
                    />
                    <path
                      data-name="Path 99953"
                      d="M108.374 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -85.641)"
                    />
                    <path
                      data-name="Path 99954"
                      d="M116.444 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -85.641)"
                    />
                    <path
                      data-name="Path 99955"
                      d="M124.524 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -85.641)"
                    />
                    <path
                      data-name="Path 99956"
                      d="M132.6 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -85.641)"
                    />
                    <path
                      data-name="Path 99957"
                      d="M140.674 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -85.641)"
                    />
                    <path
                      data-name="Path 99958"
                      d="M148.754 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -85.641)"
                    />
                    <path
                      data-name="Path 99959"
                      d="M156.824 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -85.641)"
                    />
                    <path
                      data-name="Path 99960"
                      d="M164.9 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -85.641)"
                    />
                    <path
                      data-name="Path 99961"
                      d="M172.974 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -85.641)"
                    />
                    <path
                      data-name="Path 99962"
                      d="M181.054 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -85.641)"
                    />
                    <path
                      data-name="Path 99963"
                      d="M189.134 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -85.641)"
                    />
                    <path
                      data-name="Path 99964"
                      d="M197.2 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -85.641)"
                    />
                    <path
                      data-name="Path 99965"
                      d="M205.284 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -85.641)"
                    />
                    <path
                      data-name="Path 99966"
                      d="M213.354 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -85.641)"
                    />
                    <path
                      data-name="Path 99967"
                      d="M221.434 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -85.641)"
                    />
                    <path
                      data-name="Path 99968"
                      d="M229.514 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -85.641)"
                    />
                    <path
                      data-name="Path 99969"
                      d="M237.584 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -85.641)"
                    />
                    <path
                      data-name="Path 99970"
                      d="M245.664 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -85.641)"
                    />
                    <path
                      data-name="Path 99971"
                      d="M253.734 93.654a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -85.641)"
                    />
                    <path
                      data-name="Path 99972"
                      d="M73.665 96.1a.531.531 0 01-.528.534H71.46V95.57h1.677a.531.531 0 01.528.53z"
                      transform="translate(0 .168) translate(-71.46 -86.67)"
                    />
                    <path
                      data-name="Path 99973"
                      d="M80.274 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -86.67)"
                    />
                    <path
                      data-name="Path 99974"
                      d="M88.354 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -86.67)"
                    />
                    <path
                      data-name="Path 99975"
                      d="M96.434 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -86.67)"
                    />
                    <path
                      data-name="Path 99976"
                      d="M104.5 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -86.67)"
                    />
                    <path
                      data-name="Path 99977"
                      d="M112.584 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -86.67)"
                    />
                    <path
                      data-name="Path 99978"
                      d="M120.654 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -86.67)"
                    />
                    <path
                      data-name="Path 99979"
                      d="M128.734 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -86.67)"
                    />
                    <path
                      data-name="Path 99980"
                      d="M136.814 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -86.67)"
                    />
                    <path
                      data-name="Path 99981"
                      d="M144.884 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -86.67)"
                    />
                    <path
                      data-name="Path 99982"
                      d="M152.964 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -86.67)"
                    />
                    <path
                      data-name="Path 99983"
                      d="M161.034 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -86.67)"
                    />
                    <path
                      data-name="Path 99984"
                      d="M169.114 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -86.67)"
                    />
                    <path
                      data-name="Path 99985"
                      d="M177.184 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -86.67)"
                    />
                    <path
                      data-name="Path 99986"
                      d="M185.264 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -86.67)"
                    />
                    <path
                      data-name="Path 99987"
                      d="M193.344 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -86.67)"
                    />
                    <path
                      data-name="Path 99988"
                      d="M201.414 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -86.67)"
                    />
                    <path
                      data-name="Path 99989"
                      d="M209.494 96.1a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -86.67)"
                    />
                    <path
                      data-name="Path 99990"
                      d="M217.564 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -86.67)"
                    />
                    <path
                      data-name="Path 99991"
                      d="M225.644 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -86.67)"
                    />
                    <path
                      data-name="Path 99992"
                      d="M233.714 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -86.67)"
                    />
                    <path
                      data-name="Path 99993"
                      d="M241.794 96.1a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -86.67)"
                    />
                    <path
                      data-name="Path 99994"
                      d="M249.874 96.1a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -86.67)"
                    />
                    <path
                      data-name="Path 99995"
                      d="M255.65 95.57v1.068h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -86.67)"
                    />
                    <path
                      data-name="Path 99996"
                      d="M76.064 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -87.791)"
                    />
                    <path
                      data-name="Path 99997"
                      d="M84.144 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -87.791)"
                    />
                    <path
                      data-name="Path 99998"
                      d="M92.224 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -87.791)"
                    />
                    <path
                      data-name="Path 99999"
                      d="M100.294 98.774a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -87.791)"
                    />
                    <path
                      data-name="Path 100000"
                      d="M108.374 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -87.791)"
                    />
                    <path
                      data-name="Path 100001"
                      d="M116.444 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -87.791)"
                    />
                    <path
                      data-name="Path 100002"
                      d="M124.524 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -87.791)"
                    />
                    <path
                      data-name="Path 100003"
                      d="M132.6 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -87.791)"
                    />
                    <path
                      data-name="Path 100004"
                      d="M140.674 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -87.791)"
                    />
                    <path
                      data-name="Path 100005"
                      d="M148.754 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -87.791)"
                    />
                    <path
                      data-name="Path 100006"
                      d="M156.824 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -87.791)"
                    />
                    <path
                      data-name="Path 100007"
                      d="M164.9 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -87.791)"
                    />
                    <path
                      data-name="Path 100008"
                      d="M172.974 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -87.791)"
                    />
                    <path
                      data-name="Path 100009"
                      d="M181.054 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -87.791)"
                    />
                    <path
                      data-name="Path 100010"
                      d="M189.134 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -87.791)"
                    />
                    <path
                      data-name="Path 100011"
                      d="M197.2 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -87.791)"
                    />
                    <path
                      data-name="Path 100012"
                      d="M205.284 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -87.791)"
                    />
                    <path
                      data-name="Path 100013"
                      d="M213.354 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -87.791)"
                    />
                    <path
                      data-name="Path 100014"
                      d="M221.434 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -87.791)"
                    />
                    <path
                      data-name="Path 100015"
                      d="M229.514 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -87.791)"
                    />
                    <path
                      data-name="Path 100016"
                      d="M237.584 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -87.791)"
                    />
                    <path
                      data-name="Path 100017"
                      d="M245.664 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -87.791)"
                    />
                    <path
                      data-name="Path 100018"
                      d="M253.734 98.774a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -87.791)"
                    />
                    <path
                      data-name="Path 100019"
                      d="M73.665 101.214a.531.531 0 01-.528.534H71.46v-1.068h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -88.815)"
                    />
                    <path
                      data-name="Path 100020"
                      d="M80.274 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -88.815)"
                    />
                    <path
                      data-name="Path 100021"
                      d="M88.354 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -88.815)"
                    />
                    <path
                      data-name="Path 100022"
                      d="M96.434 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -88.815)"
                    />
                    <path
                      data-name="Path 100023"
                      d="M104.5 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -88.815)"
                    />
                    <path
                      data-name="Path 100024"
                      d="M112.584 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -88.815)"
                    />
                    <path
                      data-name="Path 100025"
                      d="M120.654 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -88.815)"
                    />
                    <path
                      data-name="Path 100026"
                      d="M128.734 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -88.815)"
                    />
                    <path
                      data-name="Path 100027"
                      d="M136.814 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -88.815)"
                    />
                    <path
                      data-name="Path 100028"
                      d="M144.884 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -88.815)"
                    />
                    <path
                      data-name="Path 100029"
                      d="M152.964 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -88.815)"
                    />
                    <path
                      data-name="Path 100030"
                      d="M161.034 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -88.815)"
                    />
                    <path
                      data-name="Path 100031"
                      d="M169.114 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -88.815)"
                    />
                    <path
                      data-name="Path 100032"
                      d="M177.184 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -88.815)"
                    />
                    <path
                      data-name="Path 100033"
                      d="M185.264 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -88.815)"
                    />
                    <path
                      data-name="Path 100034"
                      d="M193.344 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -88.815)"
                    />
                    <path
                      data-name="Path 100035"
                      d="M201.414 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -88.815)"
                    />
                    <path
                      data-name="Path 100036"
                      d="M209.494 101.214a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -88.815)"
                    />
                    <path
                      data-name="Path 100037"
                      d="M217.564 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -88.815)"
                    />
                    <path
                      data-name="Path 100038"
                      d="M225.644 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -88.815)"
                    />
                    <path
                      data-name="Path 100039"
                      d="M233.714 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -88.815)"
                    />
                    <path
                      data-name="Path 100040"
                      d="M241.794 101.214a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -88.815)"
                    />
                    <path
                      data-name="Path 100041"
                      d="M249.874 101.214a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -88.815)"
                    />
                    <path
                      data-name="Path 100042"
                      d="M255.65 100.68v1.068h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -88.815)"
                    />
                    <path
                      data-name="Path 100043"
                      d="M76.064 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -89.936)"
                    />
                    <path
                      data-name="Path 100044"
                      d="M84.144 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -89.936)"
                    />
                    <path
                      data-name="Path 100045"
                      d="M92.224 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -89.936)"
                    />
                    <path
                      data-name="Path 100046"
                      d="M100.294 103.884a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -89.936)"
                    />
                    <path
                      data-name="Path 100047"
                      d="M108.374 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -89.936)"
                    />
                    <path
                      data-name="Path 100048"
                      d="M116.444 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -89.936)"
                    />
                    <path
                      data-name="Path 100049"
                      d="M124.524 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -89.936)"
                    />
                    <path
                      data-name="Path 100050"
                      d="M132.6 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -89.936)"
                    />
                    <path
                      data-name="Path 100051"
                      d="M140.674 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -89.936)"
                    />
                    <path
                      data-name="Path 100052"
                      d="M148.754 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -89.936)"
                    />
                    <path
                      data-name="Path 100053"
                      d="M156.824 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -89.936)"
                    />
                    <path
                      data-name="Path 100054"
                      d="M164.9 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -89.936)"
                    />
                    <path
                      data-name="Path 100055"
                      d="M172.974 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -89.936)"
                    />
                    <path
                      data-name="Path 100056"
                      d="M181.054 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -89.936)"
                    />
                    <path
                      data-name="Path 100057"
                      d="M189.134 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -89.936)"
                    />
                    <path
                      data-name="Path 100058"
                      d="M197.2 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -89.936)"
                    />
                    <path
                      data-name="Path 100059"
                      d="M205.284 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -89.936)"
                    />
                    <path
                      data-name="Path 100060"
                      d="M213.354 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -89.936)"
                    />
                    <path
                      data-name="Path 100061"
                      d="M221.434 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -89.936)"
                    />
                    <path
                      data-name="Path 100062"
                      d="M229.514 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -89.936)"
                    />
                    <path
                      data-name="Path 100063"
                      d="M237.584 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -89.936)"
                    />
                    <path
                      data-name="Path 100064"
                      d="M245.664 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -89.936)"
                    />
                    <path
                      data-name="Path 100065"
                      d="M253.734 103.884a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -89.936)"
                    />
                    <path
                      data-name="Path 100066"
                      d="M73.665 106.334a.531.531 0 01-.528.534H71.46V105.8h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -90.965)"
                    />
                    <path
                      data-name="Path 100067"
                      d="M80.274 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -90.965)"
                    />
                    <path
                      data-name="Path 100068"
                      d="M88.354 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -90.965)"
                    />
                    <path
                      data-name="Path 100069"
                      d="M96.434 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -90.965)"
                    />
                    <path
                      data-name="Path 100070"
                      d="M104.5 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -90.965)"
                    />
                    <path
                      data-name="Path 100071"
                      d="M112.584 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -90.965)"
                    />
                    <path
                      data-name="Path 100072"
                      d="M120.654 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -90.965)"
                    />
                    <path
                      data-name="Path 100073"
                      d="M128.734 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -90.965)"
                    />
                    <path
                      data-name="Path 100074"
                      d="M136.814 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -90.965)"
                    />
                    <path
                      data-name="Path 100075"
                      d="M144.884 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -90.965)"
                    />
                    <path
                      data-name="Path 100076"
                      d="M152.964 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -90.965)"
                    />
                    <path
                      data-name="Path 100077"
                      d="M161.034 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -90.965)"
                    />
                    <path
                      data-name="Path 100078"
                      d="M169.114 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -90.965)"
                    />
                    <path
                      data-name="Path 100079"
                      d="M177.184 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -90.965)"
                    />
                    <path
                      data-name="Path 100080"
                      d="M185.264 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -90.965)"
                    />
                    <path
                      data-name="Path 100081"
                      d="M193.344 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -90.965)"
                    />
                    <path
                      data-name="Path 100082"
                      d="M201.414 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -90.965)"
                    />
                    <path
                      data-name="Path 100083"
                      d="M209.494 106.334a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -90.965)"
                    />
                    <path
                      data-name="Path 100084"
                      d="M217.564 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -90.965)"
                    />
                    <path
                      data-name="Path 100085"
                      d="M225.644 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -90.965)"
                    />
                    <path
                      data-name="Path 100086"
                      d="M233.714 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -90.965)"
                    />
                    <path
                      data-name="Path 100087"
                      d="M241.794 106.334a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -90.965)"
                    />
                    <path
                      data-name="Path 100088"
                      d="M249.874 106.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -90.965)"
                    />
                    <path
                      data-name="Path 100089"
                      d="M255.65 105.8v1.068h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -90.965)"
                    />
                    <path
                      data-name="Path 100090"
                      d="M76.064 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -92.081)"
                    />
                    <path
                      data-name="Path 100091"
                      d="M84.144 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -92.081)"
                    />
                    <path
                      data-name="Path 100092"
                      d="M92.224 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -92.081)"
                    />
                    <path
                      data-name="Path 100093"
                      d="M100.294 108.994a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -92.081)"
                    />
                    <path
                      data-name="Path 100094"
                      d="M108.374 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -92.081)"
                    />
                    <path
                      data-name="Path 100095"
                      d="M116.444 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -92.081)"
                    />
                    <path
                      data-name="Path 100096"
                      d="M124.524 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -92.081)"
                    />
                    <path
                      data-name="Path 100097"
                      d="M132.6 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -92.081)"
                    />
                    <path
                      data-name="Path 100098"
                      d="M140.674 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -92.081)"
                    />
                    <path
                      data-name="Path 100099"
                      d="M148.754 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -92.081)"
                    />
                    <path
                      data-name="Path 100100"
                      d="M156.824 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -92.081)"
                    />
                    <path
                      data-name="Path 100101"
                      d="M164.9 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -92.081)"
                    />
                    <path
                      data-name="Path 100102"
                      d="M172.974 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -92.081)"
                    />
                    <path
                      data-name="Path 100103"
                      d="M181.054 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -92.081)"
                    />
                    <path
                      data-name="Path 100104"
                      d="M189.134 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -92.081)"
                    />
                    <path
                      data-name="Path 100105"
                      d="M197.2 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -92.081)"
                    />
                    <path
                      data-name="Path 100106"
                      d="M205.284 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -92.081)"
                    />
                    <path
                      data-name="Path 100107"
                      d="M213.354 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -92.081)"
                    />
                    <path
                      data-name="Path 100108"
                      d="M221.434 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -92.081)"
                    />
                    <path
                      data-name="Path 100109"
                      d="M229.514 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -92.081)"
                    />
                    <path
                      data-name="Path 100110"
                      d="M237.584 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -92.081)"
                    />
                    <path
                      data-name="Path 100111"
                      d="M245.664 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -92.081)"
                    />
                    <path
                      data-name="Path 100112"
                      d="M253.734 108.994a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -92.081)"
                    />
                    <path
                      data-name="Path 100113"
                      d="M73.665 111.444a.53.53 0 01-.528.528H71.46v-1.062h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -93.11)"
                    />
                    <path
                      data-name="Path 100114"
                      d="M80.274 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -93.11)"
                    />
                    <path
                      data-name="Path 100115"
                      d="M88.354 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -93.11)"
                    />
                    <path
                      data-name="Path 100116"
                      d="M96.434 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -93.11)"
                    />
                    <path
                      data-name="Path 100117"
                      d="M104.5 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -93.11)"
                    />
                    <path
                      data-name="Path 100118"
                      d="M112.584 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -93.11)"
                    />
                    <path
                      data-name="Path 100119"
                      d="M120.654 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -93.11)"
                    />
                    <path
                      data-name="Path 100120"
                      d="M128.734 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -93.11)"
                    />
                    <path
                      data-name="Path 100121"
                      d="M136.814 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -93.11)"
                    />
                    <path
                      data-name="Path 100122"
                      d="M144.884 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -93.11)"
                    />
                    <path
                      data-name="Path 100123"
                      d="M152.964 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -93.11)"
                    />
                    <path
                      data-name="Path 100124"
                      d="M161.034 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -93.11)"
                    />
                    <path
                      data-name="Path 100125"
                      d="M169.114 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -93.11)"
                    />
                    <path
                      data-name="Path 100126"
                      d="M177.184 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -93.11)"
                    />
                    <path
                      data-name="Path 100127"
                      d="M185.264 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -93.11)"
                    />
                    <path
                      data-name="Path 100128"
                      d="M193.344 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -93.11)"
                    />
                    <path
                      data-name="Path 100129"
                      d="M201.414 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -93.11)"
                    />
                    <path
                      data-name="Path 100130"
                      d="M209.494 111.444a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -93.11)"
                    />
                    <path
                      data-name="Path 100131"
                      d="M217.564 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -93.11)"
                    />
                    <path
                      data-name="Path 100132"
                      d="M225.644 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -93.11)"
                    />
                    <path
                      data-name="Path 100133"
                      d="M233.714 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -93.11)"
                    />
                    <path
                      data-name="Path 100134"
                      d="M241.794 111.444a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -93.11)"
                    />
                    <path
                      data-name="Path 100135"
                      d="M249.874 111.444a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -93.11)"
                    />
                    <path
                      data-name="Path 100136"
                      d="M255.65 110.91v1.062h-1.392a.526.526 0 01-.528-.528.535.535 0 01.528-.534z"
                      transform="translate(0 .168) translate(-147.98 -93.11)"
                    />
                    <path
                      data-name="Path 100137"
                      d="M76.064 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -94.231)"
                    />
                    <path
                      data-name="Path 100138"
                      d="M84.144 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -94.231)"
                    />
                    <path
                      data-name="Path 100139"
                      d="M92.224 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -94.231)"
                    />
                    <path
                      data-name="Path 100140"
                      d="M100.294 114.114a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -94.231)"
                    />
                    <path
                      data-name="Path 100141"
                      d="M108.374 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -94.231)"
                    />
                    <path
                      data-name="Path 100142"
                      d="M116.444 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -94.231)"
                    />
                    <path
                      data-name="Path 100143"
                      d="M124.524 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -94.231)"
                    />
                    <path
                      data-name="Path 100144"
                      d="M132.6 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -94.231)"
                    />
                    <path
                      data-name="Path 100145"
                      d="M140.674 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -94.231)"
                    />
                    <path
                      data-name="Path 100146"
                      d="M148.754 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -94.231)"
                    />
                    <path
                      data-name="Path 100147"
                      d="M156.824 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -94.231)"
                    />
                    <path
                      data-name="Path 100148"
                      d="M164.9 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -94.231)"
                    />
                    <path
                      data-name="Path 100149"
                      d="M172.974 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -94.231)"
                    />
                    <path
                      data-name="Path 100150"
                      d="M181.054 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -94.231)"
                    />
                    <path
                      data-name="Path 100151"
                      d="M189.134 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -94.231)"
                    />
                    <path
                      data-name="Path 100152"
                      d="M197.2 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -94.231)"
                    />
                    <path
                      data-name="Path 100153"
                      d="M205.284 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -94.231)"
                    />
                    <path
                      data-name="Path 100154"
                      d="M213.354 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -94.231)"
                    />
                    <path
                      data-name="Path 100155"
                      d="M221.434 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -94.231)"
                    />
                    <path
                      data-name="Path 100156"
                      d="M229.514 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -94.231)"
                    />
                    <path
                      data-name="Path 100157"
                      d="M237.584 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -94.231)"
                    />
                    <path
                      data-name="Path 100158"
                      d="M245.664 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -94.231)"
                    />
                    <path
                      data-name="Path 100159"
                      d="M253.734 114.114a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -94.231)"
                    />
                    <path
                      data-name="Path 100160"
                      d="M73.665 116.558a.531.531 0 01-.528.534H71.46v-1.062h1.677a.53.53 0 01.528.528z"
                      transform="translate(0 .168) translate(-71.46 -95.259)"
                    />
                    <path
                      data-name="Path 100161"
                      d="M80.274 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -95.255)"
                    />
                    <path
                      data-name="Path 100162"
                      d="M88.354 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -95.255)"
                    />
                    <path
                      data-name="Path 100163"
                      d="M96.434 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -95.255)"
                    />
                    <path
                      data-name="Path 100164"
                      d="M104.5 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -95.255)"
                    />
                    <path
                      data-name="Path 100165"
                      d="M112.584 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -95.255)"
                    />
                    <path
                      data-name="Path 100166"
                      d="M120.654 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -95.255)"
                    />
                    <path
                      data-name="Path 100167"
                      d="M128.734 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -95.255)"
                    />
                    <path
                      data-name="Path 100168"
                      d="M136.814 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -95.255)"
                    />
                    <path
                      data-name="Path 100169"
                      d="M144.884 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -95.255)"
                    />
                    <path
                      data-name="Path 100170"
                      d="M152.964 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -95.255)"
                    />
                    <path
                      data-name="Path 100171"
                      d="M161.034 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -95.255)"
                    />
                    <path
                      data-name="Path 100172"
                      d="M169.114 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -95.255)"
                    />
                    <path
                      data-name="Path 100173"
                      d="M177.184 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -95.255)"
                    />
                    <path
                      data-name="Path 100174"
                      d="M185.264 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -95.255)"
                    />
                    <path
                      data-name="Path 100175"
                      d="M193.344 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -95.255)"
                    />
                    <path
                      data-name="Path 100176"
                      d="M201.414 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -95.255)"
                    />
                    <path
                      data-name="Path 100177"
                      d="M209.494 116.554a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -95.255)"
                    />
                    <path
                      data-name="Path 100178"
                      d="M217.564 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -95.255)"
                    />
                    <path
                      data-name="Path 100179"
                      d="M225.644 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -95.255)"
                    />
                    <path
                      data-name="Path 100180"
                      d="M233.714 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -95.255)"
                    />
                    <path
                      data-name="Path 100181"
                      d="M241.794 116.554a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -95.255)"
                    />
                    <path
                      data-name="Path 100182"
                      d="M249.874 116.554a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -95.255)"
                    />
                    <path
                      data-name="Path 100183"
                      d="M255.65 116.03v1.062h-1.392a.531.531 0 010-1.062z"
                      transform="translate(0 .168) translate(-147.98 -95.259)"
                    />
                    <path
                      data-name="Path 100184"
                      d="M76.064 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -96.376)"
                    />
                    <path
                      data-name="Path 100185"
                      d="M84.144 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -96.376)"
                    />
                    <path
                      data-name="Path 100186"
                      d="M92.224 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -96.376)"
                    />
                    <path
                      data-name="Path 100187"
                      d="M100.294 119.224a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -96.376)"
                    />
                    <path
                      data-name="Path 100188"
                      d="M108.374 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -96.376)"
                    />
                    <path
                      data-name="Path 100189"
                      d="M116.444 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -96.376)"
                    />
                    <path
                      data-name="Path 100190"
                      d="M124.524 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -96.376)"
                    />
                    <path
                      data-name="Path 100191"
                      d="M132.6 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -96.376)"
                    />
                    <path
                      data-name="Path 100192"
                      d="M140.674 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -96.376)"
                    />
                    <path
                      data-name="Path 100193"
                      d="M148.754 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -96.376)"
                    />
                    <path
                      data-name="Path 100194"
                      d="M156.824 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -96.376)"
                    />
                    <path
                      data-name="Path 100195"
                      d="M164.9 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -96.376)"
                    />
                    <path
                      data-name="Path 100196"
                      d="M172.974 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -96.376)"
                    />
                    <path
                      data-name="Path 100197"
                      d="M181.054 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -96.376)"
                    />
                    <path
                      data-name="Path 100198"
                      d="M189.134 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -96.376)"
                    />
                    <path
                      data-name="Path 100199"
                      d="M197.2 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -96.376)"
                    />
                    <path
                      data-name="Path 100200"
                      d="M205.284 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -96.376)"
                    />
                    <path
                      data-name="Path 100201"
                      d="M213.354 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -96.376)"
                    />
                    <path
                      data-name="Path 100202"
                      d="M221.434 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -96.376)"
                    />
                    <path
                      data-name="Path 100203"
                      d="M229.514 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -96.376)"
                    />
                    <path
                      data-name="Path 100204"
                      d="M237.584 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -96.376)"
                    />
                    <path
                      data-name="Path 100205"
                      d="M245.664 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -96.376)"
                    />
                    <path
                      data-name="Path 100206"
                      d="M253.734 119.224a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -96.376)"
                    />
                    <path
                      data-name="Path 100207"
                      d="M73.665 121.664a.531.531 0 01-.528.534H71.46v-1.068h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -97.401)"
                    />
                    <path
                      data-name="Path 100208"
                      d="M80.274 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -97.405)"
                    />
                    <path
                      data-name="Path 100209"
                      d="M88.354 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -97.405)"
                    />
                    <path
                      data-name="Path 100210"
                      d="M96.434 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -97.405)"
                    />
                    <path
                      data-name="Path 100211"
                      d="M104.5 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -97.405)"
                    />
                    <path
                      data-name="Path 100212"
                      d="M112.584 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -97.405)"
                    />
                    <path
                      data-name="Path 100213"
                      d="M120.654 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -97.405)"
                    />
                    <path
                      data-name="Path 100214"
                      d="M128.734 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -97.405)"
                    />
                    <path
                      data-name="Path 100215"
                      d="M136.814 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -97.405)"
                    />
                    <path
                      data-name="Path 100216"
                      d="M144.884 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -97.405)"
                    />
                    <path
                      data-name="Path 100217"
                      d="M152.964 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -97.405)"
                    />
                    <path
                      data-name="Path 100218"
                      d="M161.034 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -97.405)"
                    />
                    <path
                      data-name="Path 100219"
                      d="M169.114 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -97.405)"
                    />
                    <path
                      data-name="Path 100220"
                      d="M177.184 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -97.405)"
                    />
                    <path
                      data-name="Path 100221"
                      d="M185.264 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -97.405)"
                    />
                    <path
                      data-name="Path 100222"
                      d="M193.344 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -97.405)"
                    />
                    <path
                      data-name="Path 100223"
                      d="M201.414 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -97.405)"
                    />
                    <path
                      data-name="Path 100224"
                      d="M209.494 121.674a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -97.405)"
                    />
                    <path
                      data-name="Path 100225"
                      d="M217.564 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -97.405)"
                    />
                    <path
                      data-name="Path 100226"
                      d="M225.644 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -97.405)"
                    />
                    <path
                      data-name="Path 100227"
                      d="M233.714 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -97.405)"
                    />
                    <path
                      data-name="Path 100228"
                      d="M241.794 121.674a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -97.405)"
                    />
                    <path
                      data-name="Path 100229"
                      d="M249.874 121.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -97.405)"
                    />
                    <path
                      data-name="Path 100230"
                      d="M255.65 121.13v1.07h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -97.4)"
                    />
                    <path
                      data-name="Path 100231"
                      d="M76.064 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -98.521)"
                    />
                    <path
                      data-name="Path 100232"
                      d="M84.144 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -98.521)"
                    />
                    <path
                      data-name="Path 100233"
                      d="M92.224 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -98.521)"
                    />
                    <path
                      data-name="Path 100234"
                      d="M100.294 124.334a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -98.521)"
                    />
                    <path
                      data-name="Path 100235"
                      d="M108.374 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -98.521)"
                    />
                    <path
                      data-name="Path 100236"
                      d="M116.444 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -98.521)"
                    />
                    <path
                      data-name="Path 100237"
                      d="M124.524 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -98.521)"
                    />
                    <path
                      data-name="Path 100238"
                      d="M132.6 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -98.521)"
                    />
                    <path
                      data-name="Path 100239"
                      d="M140.674 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -98.521)"
                    />
                    <path
                      data-name="Path 100240"
                      d="M148.754 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -98.521)"
                    />
                    <path
                      data-name="Path 100241"
                      d="M156.824 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -98.521)"
                    />
                    <path
                      data-name="Path 100242"
                      d="M164.9 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -98.521)"
                    />
                    <path
                      data-name="Path 100243"
                      d="M172.974 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -98.521)"
                    />
                    <path
                      data-name="Path 100244"
                      d="M181.054 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -98.521)"
                    />
                    <path
                      data-name="Path 100245"
                      d="M189.134 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -98.521)"
                    />
                    <path
                      data-name="Path 100246"
                      d="M197.2 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -98.521)"
                    />
                    <path
                      data-name="Path 100247"
                      d="M205.284 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -98.521)"
                    />
                    <path
                      data-name="Path 100248"
                      d="M213.354 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -98.521)"
                    />
                    <path
                      data-name="Path 100249"
                      d="M221.434 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -98.521)"
                    />
                    <path
                      data-name="Path 100250"
                      d="M229.514 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -98.521)"
                    />
                    <path
                      data-name="Path 100251"
                      d="M237.584 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -98.521)"
                    />
                    <path
                      data-name="Path 100252"
                      d="M245.664 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -98.521)"
                    />
                    <path
                      data-name="Path 100253"
                      d="M253.734 124.334a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -98.521)"
                    />
                    <path
                      data-name="Path 100254"
                      d="M73.665 126.784a.531.531 0 01-.528.534H71.46v-1.068h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -99.55)"
                    />
                    <path
                      data-name="Path 100255"
                      d="M80.274 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -99.55)"
                    />
                    <path
                      data-name="Path 100256"
                      d="M88.354 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -99.55)"
                    />
                    <path
                      data-name="Path 100257"
                      d="M96.434 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -99.55)"
                    />
                    <path
                      data-name="Path 100258"
                      d="M104.5 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -99.55)"
                    />
                    <path
                      data-name="Path 100259"
                      d="M112.584 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -99.55)"
                    />
                    <path
                      data-name="Path 100260"
                      d="M120.654 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -99.55)"
                    />
                    <path
                      data-name="Path 100261"
                      d="M128.734 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -99.55)"
                    />
                    <path
                      data-name="Path 100262"
                      d="M136.814 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -99.55)"
                    />
                    <path
                      data-name="Path 100263"
                      d="M144.884 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -99.55)"
                    />
                    <path
                      data-name="Path 100264"
                      d="M152.964 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -99.55)"
                    />
                    <path
                      data-name="Path 100265"
                      d="M161.034 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -99.55)"
                    />
                    <path
                      data-name="Path 100266"
                      d="M169.114 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -99.55)"
                    />
                    <path
                      data-name="Path 100267"
                      d="M177.184 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -99.55)"
                    />
                    <path
                      data-name="Path 100268"
                      d="M185.264 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -99.55)"
                    />
                    <path
                      data-name="Path 100269"
                      d="M193.344 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -99.55)"
                    />
                    <path
                      data-name="Path 100270"
                      d="M201.414 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -99.55)"
                    />
                    <path
                      data-name="Path 100271"
                      d="M209.494 126.784a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -99.55)"
                    />
                    <path
                      data-name="Path 100272"
                      d="M217.564 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -99.55)"
                    />
                    <path
                      data-name="Path 100273"
                      d="M225.644 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -99.55)"
                    />
                    <path
                      data-name="Path 100274"
                      d="M233.714 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -99.55)"
                    />
                    <path
                      data-name="Path 100275"
                      d="M241.794 126.784a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -99.55)"
                    />
                    <path
                      data-name="Path 100276"
                      d="M249.874 126.784a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -99.55)"
                    />
                    <path
                      data-name="Path 100277"
                      d="M255.65 126.25v1.068h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -99.55)"
                    />
                    <path
                      data-name="Path 100278"
                      d="M76.064 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -100.671)"
                    />
                    <path
                      data-name="Path 100279"
                      d="M84.144 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -100.671)"
                    />
                    <path
                      data-name="Path 100280"
                      d="M92.224 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -100.671)"
                    />
                    <path
                      data-name="Path 100281"
                      d="M100.294 129.454a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -100.671)"
                    />
                    <path
                      data-name="Path 100282"
                      d="M108.374 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -100.671)"
                    />
                    <path
                      data-name="Path 100283"
                      d="M116.444 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -100.671)"
                    />
                    <path
                      data-name="Path 100284"
                      d="M124.524 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -100.671)"
                    />
                    <path
                      data-name="Path 100285"
                      d="M132.6 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -100.671)"
                    />
                    <path
                      data-name="Path 100286"
                      d="M140.674 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -100.671)"
                    />
                    <path
                      data-name="Path 100287"
                      d="M148.754 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -100.671)"
                    />
                    <path
                      data-name="Path 100288"
                      d="M156.824 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -100.671)"
                    />
                    <path
                      data-name="Path 100289"
                      d="M164.9 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -100.671)"
                    />
                    <path
                      data-name="Path 100290"
                      d="M172.974 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -100.671)"
                    />
                    <path
                      data-name="Path 100291"
                      d="M181.054 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -100.671)"
                    />
                    <path
                      data-name="Path 100292"
                      d="M189.134 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -100.671)"
                    />
                    <path
                      data-name="Path 100293"
                      d="M197.2 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -100.671)"
                    />
                    <path
                      data-name="Path 100294"
                      d="M205.284 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -100.671)"
                    />
                    <path
                      data-name="Path 100295"
                      d="M213.354 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -100.671)"
                    />
                    <path
                      data-name="Path 100296"
                      d="M221.434 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -100.671)"
                    />
                    <path
                      data-name="Path 100297"
                      d="M229.514 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -100.671)"
                    />
                    <path
                      data-name="Path 100298"
                      d="M237.584 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -100.671)"
                    />
                    <path
                      data-name="Path 100299"
                      d="M245.664 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -100.671)"
                    />
                    <path
                      data-name="Path 100300"
                      d="M253.734 129.454a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -100.671)"
                    />
                    <path
                      data-name="Path 100301"
                      d="M73.665 131.894a.526.526 0 01-.528.528H71.46v-1.062h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -101.695)"
                    />
                    <path
                      data-name="Path 100302"
                      d="M80.274 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -101.695)"
                    />
                    <path
                      data-name="Path 100303"
                      d="M88.354 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -101.695)"
                    />
                    <path
                      data-name="Path 100304"
                      d="M96.434 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -101.695)"
                    />
                    <path
                      data-name="Path 100305"
                      d="M104.5 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -101.695)"
                    />
                    <path
                      data-name="Path 100306"
                      d="M112.584 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -101.695)"
                    />
                    <path
                      data-name="Path 100307"
                      d="M120.654 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -101.695)"
                    />
                    <path
                      data-name="Path 100308"
                      d="M128.734 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -101.695)"
                    />
                    <path
                      data-name="Path 100309"
                      d="M136.814 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -101.695)"
                    />
                    <path
                      data-name="Path 100310"
                      d="M144.884 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -101.695)"
                    />
                    <path
                      data-name="Path 100311"
                      d="M152.964 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -101.695)"
                    />
                    <path
                      data-name="Path 100312"
                      d="M161.034 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -101.695)"
                    />
                    <path
                      data-name="Path 100313"
                      d="M169.114 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -101.695)"
                    />
                    <path
                      data-name="Path 100314"
                      d="M177.184 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -101.695)"
                    />
                    <path
                      data-name="Path 100315"
                      d="M185.264 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -101.695)"
                    />
                    <path
                      data-name="Path 100316"
                      d="M193.344 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -101.695)"
                    />
                    <path
                      data-name="Path 100317"
                      d="M201.414 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -101.695)"
                    />
                    <path
                      data-name="Path 100318"
                      d="M209.494 131.894a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -101.695)"
                    />
                    <path
                      data-name="Path 100319"
                      d="M217.564 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -101.695)"
                    />
                    <path
                      data-name="Path 100320"
                      d="M225.644 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -101.695)"
                    />
                    <path
                      data-name="Path 100321"
                      d="M233.714 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -101.695)"
                    />
                    <path
                      data-name="Path 100322"
                      d="M241.794 131.894a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -101.695)"
                    />
                    <path
                      data-name="Path 100323"
                      d="M249.874 131.894a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -101.695)"
                    />
                    <path
                      data-name="Path 100324"
                      d="M255.65 131.36v1.062h-1.392a.526.526 0 01-.528-.528.535.535 0 01.528-.534z"
                      transform="translate(0 .168) translate(-147.98 -101.695)"
                    />
                    <path
                      data-name="Path 100325"
                      d="M76.064 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -102.816)"
                    />
                    <path
                      data-name="Path 100326"
                      d="M84.144 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -102.816)"
                    />
                    <path
                      data-name="Path 100327"
                      d="M92.224 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -102.816)"
                    />
                    <path
                      data-name="Path 100328"
                      d="M100.294 134.564a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -102.816)"
                    />
                    <path
                      data-name="Path 100329"
                      d="M108.374 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -102.816)"
                    />
                    <path
                      data-name="Path 100330"
                      d="M116.444 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -102.816)"
                    />
                    <path
                      data-name="Path 100331"
                      d="M124.524 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -102.816)"
                    />
                    <path
                      data-name="Path 100332"
                      d="M132.6 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -102.816)"
                    />
                    <path
                      data-name="Path 100333"
                      d="M140.674 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -102.816)"
                    />
                    <path
                      data-name="Path 100334"
                      d="M148.754 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -102.816)"
                    />
                    <path
                      data-name="Path 100335"
                      d="M156.824 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -102.816)"
                    />
                    <path
                      data-name="Path 100336"
                      d="M164.9 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -102.816)"
                    />
                    <path
                      data-name="Path 100337"
                      d="M172.974 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -102.816)"
                    />
                    <path
                      data-name="Path 100338"
                      d="M181.054 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -102.816)"
                    />
                    <path
                      data-name="Path 100339"
                      d="M189.134 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -102.816)"
                    />
                    <path
                      data-name="Path 100340"
                      d="M197.2 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -102.816)"
                    />
                    <path
                      data-name="Path 100341"
                      d="M205.284 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -102.816)"
                    />
                    <path
                      data-name="Path 100342"
                      d="M213.354 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -102.816)"
                    />
                    <path
                      data-name="Path 100343"
                      d="M221.434 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -102.816)"
                    />
                    <path
                      data-name="Path 100344"
                      d="M229.514 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -102.816)"
                    />
                    <path
                      data-name="Path 100345"
                      d="M237.584 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -102.816)"
                    />
                    <path
                      data-name="Path 100346"
                      d="M245.664 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -102.816)"
                    />
                    <path
                      data-name="Path 100347"
                      d="M253.734 134.564a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -102.816)"
                    />
                    <path
                      data-name="Path 100348"
                      d="M73.665 137.014a.53.53 0 01-.528.528H71.46v-1.062h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -103.845)"
                    />
                    <path
                      data-name="Path 100349"
                      d="M80.274 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -103.845)"
                    />
                    <path
                      data-name="Path 100350"
                      d="M88.354 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -103.845)"
                    />
                    <path
                      data-name="Path 100351"
                      d="M96.434 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -103.845)"
                    />
                    <path
                      data-name="Path 100352"
                      d="M104.5 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -103.845)"
                    />
                    <path
                      data-name="Path 100353"
                      d="M112.584 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -103.845)"
                    />
                    <path
                      data-name="Path 100354"
                      d="M120.654 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -103.845)"
                    />
                    <path
                      data-name="Path 100355"
                      d="M128.734 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -103.845)"
                    />
                    <path
                      data-name="Path 100356"
                      d="M136.814 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -103.845)"
                    />
                    <path
                      data-name="Path 100357"
                      d="M144.884 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -103.845)"
                    />
                    <path
                      data-name="Path 100358"
                      d="M152.964 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -103.845)"
                    />
                    <path
                      data-name="Path 100359"
                      d="M161.034 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -103.845)"
                    />
                    <path
                      data-name="Path 100360"
                      d="M169.114 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -103.845)"
                    />
                    <path
                      data-name="Path 100361"
                      d="M177.184 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -103.845)"
                    />
                    <path
                      data-name="Path 100362"
                      d="M185.264 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -103.845)"
                    />
                    <path
                      data-name="Path 100363"
                      d="M193.344 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -103.845)"
                    />
                    <path
                      data-name="Path 100364"
                      d="M201.414 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -103.845)"
                    />
                    <path
                      data-name="Path 100365"
                      d="M209.494 137.014a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -103.845)"
                    />
                    <path
                      data-name="Path 100366"
                      d="M217.564 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -103.845)"
                    />
                    <path
                      data-name="Path 100367"
                      d="M225.644 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -103.845)"
                    />
                    <path
                      data-name="Path 100368"
                      d="M233.714 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -103.845)"
                    />
                    <path
                      data-name="Path 100369"
                      d="M241.794 137.014a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -103.845)"
                    />
                    <path
                      data-name="Path 100370"
                      d="M249.874 137.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -103.845)"
                    />
                    <path
                      data-name="Path 100371"
                      d="M255.65 136.48v1.062h-1.392a.526.526 0 01-.528-.528.535.535 0 01.528-.534z"
                      transform="translate(0 .168) translate(-147.98 -103.845)"
                    />
                    <path
                      data-name="Path 100372"
                      d="M76.064 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -104.961)"
                    />
                    <path
                      data-name="Path 100373"
                      d="M84.144 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -104.961)"
                    />
                    <path
                      data-name="Path 100374"
                      d="M92.224 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -104.961)"
                    />
                    <path
                      data-name="Path 100375"
                      d="M100.294 139.674a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -104.961)"
                    />
                    <path
                      data-name="Path 100376"
                      d="M108.374 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -104.961)"
                    />
                    <path
                      data-name="Path 100377"
                      d="M116.444 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -104.961)"
                    />
                    <path
                      data-name="Path 100378"
                      d="M124.524 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -104.961)"
                    />
                    <path
                      data-name="Path 100379"
                      d="M132.6 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -104.961)"
                    />
                    <path
                      data-name="Path 100380"
                      d="M140.674 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -104.961)"
                    />
                    <path
                      data-name="Path 100381"
                      d="M148.754 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -104.961)"
                    />
                    <path
                      data-name="Path 100382"
                      d="M156.824 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -104.961)"
                    />
                    <path
                      data-name="Path 100383"
                      d="M164.9 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -104.961)"
                    />
                    <path
                      data-name="Path 100384"
                      d="M172.974 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -104.961)"
                    />
                    <path
                      data-name="Path 100385"
                      d="M181.054 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -104.961)"
                    />
                    <path
                      data-name="Path 100386"
                      d="M189.134 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -104.961)"
                    />
                    <path
                      data-name="Path 100387"
                      d="M197.2 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -104.961)"
                    />
                    <path
                      data-name="Path 100388"
                      d="M205.284 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -104.961)"
                    />
                    <path
                      data-name="Path 100389"
                      d="M213.354 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -104.961)"
                    />
                    <path
                      data-name="Path 100390"
                      d="M221.434 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -104.961)"
                    />
                    <path
                      data-name="Path 100391"
                      d="M229.514 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -104.961)"
                    />
                    <path
                      data-name="Path 100392"
                      d="M237.584 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -104.961)"
                    />
                    <path
                      data-name="Path 100393"
                      d="M245.664 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -104.961)"
                    />
                    <path
                      data-name="Path 100394"
                      d="M253.734 139.674a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -104.961)"
                    />
                    <path
                      data-name="Path 100395"
                      d="M73.665 142.124a.531.531 0 01-.528.534H71.46v-1.068h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -105.99)"
                    />
                    <path
                      data-name="Path 100396"
                      d="M80.274 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -105.99)"
                    />
                    <path
                      data-name="Path 100397"
                      d="M88.354 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -105.99)"
                    />
                    <path
                      data-name="Path 100398"
                      d="M96.434 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -105.99)"
                    />
                    <path
                      data-name="Path 100399"
                      d="M104.5 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -105.99)"
                    />
                    <path
                      data-name="Path 100400"
                      d="M112.584 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -105.99)"
                    />
                    <path
                      data-name="Path 100401"
                      d="M120.654 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -105.99)"
                    />
                    <path
                      data-name="Path 100402"
                      d="M128.734 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -105.99)"
                    />
                    <path
                      data-name="Path 100403"
                      d="M136.814 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -105.99)"
                    />
                    <path
                      data-name="Path 100404"
                      d="M144.884 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -105.99)"
                    />
                    <path
                      data-name="Path 100405"
                      d="M152.964 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -105.99)"
                    />
                    <path
                      data-name="Path 100406"
                      d="M161.034 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -105.99)"
                    />
                    <path
                      data-name="Path 100407"
                      d="M169.114 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -105.99)"
                    />
                    <path
                      data-name="Path 100408"
                      d="M177.184 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -105.99)"
                    />
                    <path
                      data-name="Path 100409"
                      d="M185.264 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -105.99)"
                    />
                    <path
                      data-name="Path 100410"
                      d="M193.344 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -105.99)"
                    />
                    <path
                      data-name="Path 100411"
                      d="M201.414 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -105.99)"
                    />
                    <path
                      data-name="Path 100412"
                      d="M209.494 142.124a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -105.99)"
                    />
                    <path
                      data-name="Path 100413"
                      d="M217.564 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -105.99)"
                    />
                    <path
                      data-name="Path 100414"
                      d="M225.644 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -105.99)"
                    />
                    <path
                      data-name="Path 100415"
                      d="M233.714 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -105.99)"
                    />
                    <path
                      data-name="Path 100416"
                      d="M241.794 142.124a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -105.99)"
                    />
                    <path
                      data-name="Path 100417"
                      d="M249.874 142.124a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -105.99)"
                    />
                    <path
                      data-name="Path 100418"
                      d="M255.65 141.59v1.068h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -105.99)"
                    />
                    <path
                      data-name="Path 100419"
                      d="M76.064 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -107.111)"
                    />
                    <path
                      data-name="Path 100420"
                      d="M84.144 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -107.111)"
                    />
                    <path
                      data-name="Path 100421"
                      d="M92.224 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -107.111)"
                    />
                    <path
                      data-name="Path 100422"
                      d="M100.294 144.794a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -107.111)"
                    />
                    <path
                      data-name="Path 100423"
                      d="M108.374 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -107.111)"
                    />
                    <path
                      data-name="Path 100424"
                      d="M116.444 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -107.111)"
                    />
                    <path
                      data-name="Path 100425"
                      d="M124.524 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -107.111)"
                    />
                    <path
                      data-name="Path 100426"
                      d="M132.6 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -107.111)"
                    />
                    <path
                      data-name="Path 100427"
                      d="M140.674 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -107.111)"
                    />
                    <path
                      data-name="Path 100428"
                      d="M148.754 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -107.111)"
                    />
                    <path
                      data-name="Path 100429"
                      d="M156.824 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -107.111)"
                    />
                    <path
                      data-name="Path 100430"
                      d="M164.9 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -107.111)"
                    />
                    <path
                      data-name="Path 100431"
                      d="M172.974 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -107.111)"
                    />
                    <path
                      data-name="Path 100432"
                      d="M181.054 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -107.111)"
                    />
                    <path
                      data-name="Path 100433"
                      d="M189.134 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -107.111)"
                    />
                    <path
                      data-name="Path 100434"
                      d="M197.2 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -107.111)"
                    />
                    <path
                      data-name="Path 100435"
                      d="M205.284 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -107.111)"
                    />
                    <path
                      data-name="Path 100436"
                      d="M213.354 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -107.111)"
                    />
                    <path
                      data-name="Path 100437"
                      d="M221.434 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -107.111)"
                    />
                    <path
                      data-name="Path 100438"
                      d="M229.514 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -107.111)"
                    />
                    <path
                      data-name="Path 100439"
                      d="M237.584 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -107.111)"
                    />
                    <path
                      data-name="Path 100440"
                      d="M245.664 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -107.111)"
                    />
                    <path
                      data-name="Path 100441"
                      d="M253.734 144.794a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -107.111)"
                    />
                    <path
                      data-name="Path 100442"
                      d="M73.665 147.234a.531.531 0 01-.528.534H71.46V146.7h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -108.135)"
                    />
                    <path
                      data-name="Path 100443"
                      d="M80.274 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -108.135)"
                    />
                    <path
                      data-name="Path 100444"
                      d="M88.354 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -108.135)"
                    />
                    <path
                      data-name="Path 100445"
                      d="M96.434 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -108.135)"
                    />
                    <path
                      data-name="Path 100446"
                      d="M104.5 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -108.135)"
                    />
                    <path
                      data-name="Path 100447"
                      d="M112.584 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -108.135)"
                    />
                    <path
                      data-name="Path 100448"
                      d="M120.654 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -108.135)"
                    />
                    <path
                      data-name="Path 100449"
                      d="M128.734 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -108.135)"
                    />
                    <path
                      data-name="Path 100450"
                      d="M136.814 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -108.135)"
                    />
                    <path
                      data-name="Path 100451"
                      d="M144.884 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -108.135)"
                    />
                    <path
                      data-name="Path 100452"
                      d="M152.964 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -108.135)"
                    />
                    <path
                      data-name="Path 100453"
                      d="M161.034 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -108.135)"
                    />
                    <path
                      data-name="Path 100454"
                      d="M169.114 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -108.135)"
                    />
                    <path
                      data-name="Path 100455"
                      d="M177.184 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -108.135)"
                    />
                    <path
                      data-name="Path 100456"
                      d="M185.264 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -108.135)"
                    />
                    <path
                      data-name="Path 100457"
                      d="M193.344 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -108.135)"
                    />
                    <path
                      data-name="Path 100458"
                      d="M201.414 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -108.135)"
                    />
                    <path
                      data-name="Path 100459"
                      d="M209.494 147.234a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -108.135)"
                    />
                    <path
                      data-name="Path 100460"
                      d="M217.564 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -108.135)"
                    />
                    <path
                      data-name="Path 100461"
                      d="M225.644 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -108.135)"
                    />
                    <path
                      data-name="Path 100462"
                      d="M233.714 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -108.135)"
                    />
                    <path
                      data-name="Path 100463"
                      d="M241.794 147.234a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -108.135)"
                    />
                    <path
                      data-name="Path 100464"
                      d="M249.874 147.234a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -108.135)"
                    />
                    <path
                      data-name="Path 100465"
                      d="M255.65 146.7v1.068h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -108.135)"
                    />
                    <path
                      data-name="Path 100466"
                      d="M76.064 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -109.256)"
                    />
                    <path
                      data-name="Path 100467"
                      d="M84.144 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -109.256)"
                    />
                    <path
                      data-name="Path 100468"
                      d="M92.224 149.9a.531.531 0 01-.528.534h-3.168A.531.531 0 0188 149.9a.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -109.256)"
                    />
                    <path
                      data-name="Path 100469"
                      d="M100.294 149.9a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -109.256)"
                    />
                    <path
                      data-name="Path 100470"
                      d="M108.374 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -109.256)"
                    />
                    <path
                      data-name="Path 100471"
                      d="M116.444 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -109.256)"
                    />
                    <path
                      data-name="Path 100472"
                      d="M124.524 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -109.256)"
                    />
                    <path
                      data-name="Path 100473"
                      d="M132.6 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -109.256)"
                    />
                    <path
                      data-name="Path 100474"
                      d="M140.674 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -109.256)"
                    />
                    <path
                      data-name="Path 100475"
                      d="M148.754 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -109.256)"
                    />
                    <path
                      data-name="Path 100476"
                      d="M156.824 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -109.256)"
                    />
                    <path
                      data-name="Path 100477"
                      d="M164.9 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -109.256)"
                    />
                    <path
                      data-name="Path 100478"
                      d="M172.974 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -109.256)"
                    />
                    <path
                      data-name="Path 100479"
                      d="M181.054 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -109.256)"
                    />
                    <path
                      data-name="Path 100480"
                      d="M189.134 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -109.256)"
                    />
                    <path
                      data-name="Path 100481"
                      d="M197.2 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -109.256)"
                    />
                    <path
                      data-name="Path 100482"
                      d="M205.284 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -109.256)"
                    />
                    <path
                      data-name="Path 100483"
                      d="M213.354 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -109.256)"
                    />
                    <path
                      data-name="Path 100484"
                      d="M221.434 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -109.256)"
                    />
                    <path
                      data-name="Path 100485"
                      d="M229.514 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -109.256)"
                    />
                    <path
                      data-name="Path 100486"
                      d="M237.584 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -109.256)"
                    />
                    <path
                      data-name="Path 100487"
                      d="M245.664 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -109.256)"
                    />
                    <path
                      data-name="Path 100488"
                      d="M253.734 149.9a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -109.256)"
                    />
                    <path
                      data-name="Path 100489"
                      d="M73.665 152.354a.531.531 0 01-.528.534H71.46v-1.068h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -110.285)"
                    />
                    <path
                      data-name="Path 100490"
                      d="M80.274 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -110.285)"
                    />
                    <path
                      data-name="Path 100491"
                      d="M88.354 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -110.285)"
                    />
                    <path
                      data-name="Path 100492"
                      d="M96.434 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -110.285)"
                    />
                    <path
                      data-name="Path 100493"
                      d="M104.5 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -110.285)"
                    />
                    <path
                      data-name="Path 100494"
                      d="M112.584 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -110.285)"
                    />
                    <path
                      data-name="Path 100495"
                      d="M120.654 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -110.285)"
                    />
                    <path
                      data-name="Path 100496"
                      d="M128.734 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -110.285)"
                    />
                    <path
                      data-name="Path 100497"
                      d="M136.814 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -110.285)"
                    />
                    <path
                      data-name="Path 100498"
                      d="M144.884 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -110.285)"
                    />
                    <path
                      data-name="Path 100499"
                      d="M152.964 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -110.285)"
                    />
                    <path
                      data-name="Path 100500"
                      d="M161.034 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -110.285)"
                    />
                    <path
                      data-name="Path 100501"
                      d="M169.114 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -110.285)"
                    />
                    <path
                      data-name="Path 100502"
                      d="M177.184 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -110.285)"
                    />
                    <path
                      data-name="Path 100503"
                      d="M185.264 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -110.285)"
                    />
                    <path
                      data-name="Path 100504"
                      d="M193.344 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -110.285)"
                    />
                    <path
                      data-name="Path 100505"
                      d="M201.414 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -110.285)"
                    />
                    <path
                      data-name="Path 100506"
                      d="M209.494 152.354a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -110.285)"
                    />
                    <path
                      data-name="Path 100507"
                      d="M217.564 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -110.285)"
                    />
                    <path
                      data-name="Path 100508"
                      d="M225.644 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -110.285)"
                    />
                    <path
                      data-name="Path 100509"
                      d="M233.714 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -110.285)"
                    />
                    <path
                      data-name="Path 100510"
                      d="M241.794 152.354a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -110.285)"
                    />
                    <path
                      data-name="Path 100511"
                      d="M249.874 152.354a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -110.285)"
                    />
                    <path
                      data-name="Path 100512"
                      d="M255.65 151.82v1.068h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -110.285)"
                    />
                    <path
                      data-name="Path 100513"
                      d="M76.064 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -111.401)"
                    />
                    <path
                      data-name="Path 100514"
                      d="M84.144 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -111.401)"
                    />
                    <path
                      data-name="Path 100515"
                      d="M92.224 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -111.401)"
                    />
                    <path
                      data-name="Path 100516"
                      d="M100.294 155.014a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -111.401)"
                    />
                    <path
                      data-name="Path 100517"
                      d="M108.374 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -111.401)"
                    />
                    <path
                      data-name="Path 100518"
                      d="M116.444 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -111.401)"
                    />
                    <path
                      data-name="Path 100519"
                      d="M124.524 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -111.401)"
                    />
                    <path
                      data-name="Path 100520"
                      d="M132.6 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -111.401)"
                    />
                    <path
                      data-name="Path 100521"
                      d="M140.674 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -111.401)"
                    />
                    <path
                      data-name="Path 100522"
                      d="M148.754 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -111.401)"
                    />
                    <path
                      data-name="Path 100523"
                      d="M156.824 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -111.401)"
                    />
                    <path
                      data-name="Path 100524"
                      d="M164.9 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -111.401)"
                    />
                    <path
                      data-name="Path 100525"
                      d="M172.974 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -111.401)"
                    />
                    <path
                      data-name="Path 100526"
                      d="M181.054 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -111.401)"
                    />
                    <path
                      data-name="Path 100527"
                      d="M189.134 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -111.401)"
                    />
                    <path
                      data-name="Path 100528"
                      d="M197.2 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -111.401)"
                    />
                    <path
                      data-name="Path 100529"
                      d="M205.284 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -111.401)"
                    />
                    <path
                      data-name="Path 100530"
                      d="M213.354 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -111.401)"
                    />
                    <path
                      data-name="Path 100531"
                      d="M221.434 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -111.401)"
                    />
                    <path
                      data-name="Path 100532"
                      d="M229.514 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -111.401)"
                    />
                    <path
                      data-name="Path 100533"
                      d="M237.584 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -111.401)"
                    />
                    <path
                      data-name="Path 100534"
                      d="M245.664 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -111.401)"
                    />
                    <path
                      data-name="Path 100535"
                      d="M253.734 155.014a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -111.401)"
                    />
                    <path
                      data-name="Path 100536"
                      d="M73.665 157.464a.531.531 0 01-.528.534H71.46v-1.068h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -112.43)"
                    />
                    <path
                      data-name="Path 100537"
                      d="M80.274 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -112.43)"
                    />
                    <path
                      data-name="Path 100538"
                      d="M88.354 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -112.43)"
                    />
                    <path
                      data-name="Path 100539"
                      d="M96.434 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -112.43)"
                    />
                    <path
                      data-name="Path 100540"
                      d="M104.5 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -112.43)"
                    />
                    <path
                      data-name="Path 100541"
                      d="M112.584 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -112.43)"
                    />
                    <path
                      data-name="Path 100542"
                      d="M120.654 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -112.43)"
                    />
                    <path
                      data-name="Path 100543"
                      d="M128.734 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -112.43)"
                    />
                    <path
                      data-name="Path 100544"
                      d="M136.814 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -112.43)"
                    />
                    <path
                      data-name="Path 100545"
                      d="M144.884 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -112.43)"
                    />
                    <path
                      data-name="Path 100546"
                      d="M152.964 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -112.43)"
                    />
                    <path
                      data-name="Path 100547"
                      d="M161.034 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -112.43)"
                    />
                    <path
                      data-name="Path 100548"
                      d="M169.114 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -112.43)"
                    />
                    <path
                      data-name="Path 100549"
                      d="M177.184 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -112.43)"
                    />
                    <path
                      data-name="Path 100550"
                      d="M185.264 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -112.43)"
                    />
                    <path
                      data-name="Path 100551"
                      d="M193.344 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -112.43)"
                    />
                    <path
                      data-name="Path 100552"
                      d="M201.414 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -112.43)"
                    />
                    <path
                      data-name="Path 100553"
                      d="M209.494 157.464a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -112.43)"
                    />
                    <path
                      data-name="Path 100554"
                      d="M217.564 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -112.43)"
                    />
                    <path
                      data-name="Path 100555"
                      d="M225.644 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -112.43)"
                    />
                    <path
                      data-name="Path 100556"
                      d="M233.714 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -112.43)"
                    />
                    <path
                      data-name="Path 100557"
                      d="M241.794 157.464a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -112.43)"
                    />
                    <path
                      data-name="Path 100558"
                      d="M249.874 157.464a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -112.43)"
                    />
                    <path
                      data-name="Path 100559"
                      d="M255.65 156.93V158h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -112.43)"
                    />
                    <path
                      data-name="Path 100560"
                      d="M76.064 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -113.551)"
                    />
                    <path
                      data-name="Path 100561"
                      d="M84.144 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -113.551)"
                    />
                    <path
                      data-name="Path 100562"
                      d="M92.224 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -113.551)"
                    />
                    <path
                      data-name="Path 100563"
                      d="M100.294 160.134a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -113.551)"
                    />
                    <path
                      data-name="Path 100564"
                      d="M108.374 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -113.551)"
                    />
                    <path
                      data-name="Path 100565"
                      d="M116.444 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -113.551)"
                    />
                    <path
                      data-name="Path 100566"
                      d="M124.524 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -113.551)"
                    />
                    <path
                      data-name="Path 100567"
                      d="M132.6 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -113.551)"
                    />
                    <path
                      data-name="Path 100568"
                      d="M140.674 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -113.551)"
                    />
                    <path
                      data-name="Path 100569"
                      d="M148.754 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -113.551)"
                    />
                    <path
                      data-name="Path 100570"
                      d="M156.824 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -113.551)"
                    />
                    <path
                      data-name="Path 100571"
                      d="M164.9 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -113.551)"
                    />
                    <path
                      data-name="Path 100572"
                      d="M172.974 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -113.551)"
                    />
                    <path
                      data-name="Path 100573"
                      d="M181.054 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -113.551)"
                    />
                    <path
                      data-name="Path 100574"
                      d="M189.134 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -113.551)"
                    />
                    <path
                      data-name="Path 100575"
                      d="M197.2 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -113.551)"
                    />
                    <path
                      data-name="Path 100576"
                      d="M205.284 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -113.551)"
                    />
                    <path
                      data-name="Path 100577"
                      d="M213.354 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -113.551)"
                    />
                    <path
                      data-name="Path 100578"
                      d="M221.434 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -113.551)"
                    />
                    <path
                      data-name="Path 100579"
                      d="M229.514 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -113.551)"
                    />
                    <path
                      data-name="Path 100580"
                      d="M237.584 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -113.551)"
                    />
                    <path
                      data-name="Path 100581"
                      d="M245.664 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -113.551)"
                    />
                    <path
                      data-name="Path 100582"
                      d="M253.734 160.134a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -113.551)"
                    />
                    <path
                      data-name="Path 100583"
                      d="M73.665 162.578a.531.531 0 01-.528.534H71.46v-1.062h1.677a.53.53 0 01.528.528z"
                      transform="translate(0 .168) translate(-71.46 -114.579)"
                    />
                    <path
                      data-name="Path 100584"
                      d="M80.274 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -114.575)"
                    />
                    <path
                      data-name="Path 100585"
                      d="M88.354 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -114.575)"
                    />
                    <path
                      data-name="Path 100586"
                      d="M96.434 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -114.575)"
                    />
                    <path
                      data-name="Path 100587"
                      d="M104.5 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -114.575)"
                    />
                    <path
                      data-name="Path 100588"
                      d="M112.584 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -114.575)"
                    />
                    <path
                      data-name="Path 100589"
                      d="M120.654 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -114.575)"
                    />
                    <path
                      data-name="Path 100590"
                      d="M128.734 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -114.575)"
                    />
                    <path
                      data-name="Path 100591"
                      d="M136.814 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -114.575)"
                    />
                    <path
                      data-name="Path 100592"
                      d="M144.884 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -114.575)"
                    />
                    <path
                      data-name="Path 100593"
                      d="M152.964 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -114.575)"
                    />
                    <path
                      data-name="Path 100594"
                      d="M161.034 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -114.575)"
                    />
                    <path
                      data-name="Path 100595"
                      d="M169.114 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -114.575)"
                    />
                    <path
                      data-name="Path 100596"
                      d="M177.184 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -114.575)"
                    />
                    <path
                      data-name="Path 100597"
                      d="M185.264 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -114.575)"
                    />
                    <path
                      data-name="Path 100598"
                      d="M193.344 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -114.575)"
                    />
                    <path
                      data-name="Path 100599"
                      d="M201.414 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -114.575)"
                    />
                    <path
                      data-name="Path 100600"
                      d="M209.494 162.574a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -114.575)"
                    />
                    <path
                      data-name="Path 100601"
                      d="M217.564 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -114.575)"
                    />
                    <path
                      data-name="Path 100602"
                      d="M225.644 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -114.575)"
                    />
                    <path
                      data-name="Path 100603"
                      d="M233.714 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -114.575)"
                    />
                    <path
                      data-name="Path 100604"
                      d="M241.794 162.574a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -114.575)"
                    />
                    <path
                      data-name="Path 100605"
                      d="M249.874 162.574a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -114.575)"
                    />
                    <path
                      data-name="Path 100606"
                      d="M255.65 162.05v1.062h-1.392a.531.531 0 010-1.062z"
                      transform="translate(0 .168) translate(-147.98 -114.579)"
                    />
                    <path
                      data-name="Path 100607"
                      d="M76.064 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -115.696)"
                    />
                    <path
                      data-name="Path 100608"
                      d="M84.144 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -115.696)"
                    />
                    <path
                      data-name="Path 100609"
                      d="M92.224 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -115.696)"
                    />
                    <path
                      data-name="Path 100610"
                      d="M100.294 165.244a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -115.696)"
                    />
                    <path
                      data-name="Path 100611"
                      d="M108.374 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -115.696)"
                    />
                    <path
                      data-name="Path 100612"
                      d="M116.444 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -115.696)"
                    />
                    <path
                      data-name="Path 100613"
                      d="M124.524 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -115.696)"
                    />
                    <path
                      data-name="Path 100614"
                      d="M132.6 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -115.696)"
                    />
                    <path
                      data-name="Path 100615"
                      d="M140.674 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -115.696)"
                    />
                    <path
                      data-name="Path 100616"
                      d="M148.754 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -115.696)"
                    />
                    <path
                      data-name="Path 100617"
                      d="M156.824 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -115.696)"
                    />
                    <path
                      data-name="Path 100618"
                      d="M164.9 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -115.696)"
                    />
                    <path
                      data-name="Path 100619"
                      d="M172.974 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -115.696)"
                    />
                    <path
                      data-name="Path 100620"
                      d="M181.054 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -115.696)"
                    />
                    <path
                      data-name="Path 100621"
                      d="M189.134 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -115.696)"
                    />
                    <path
                      data-name="Path 100622"
                      d="M197.2 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -115.696)"
                    />
                    <path
                      data-name="Path 100623"
                      d="M205.284 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -115.696)"
                    />
                    <path
                      data-name="Path 100624"
                      d="M213.354 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -115.696)"
                    />
                    <path
                      data-name="Path 100625"
                      d="M221.434 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -115.696)"
                    />
                    <path
                      data-name="Path 100626"
                      d="M229.514 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -115.696)"
                    />
                    <path
                      data-name="Path 100627"
                      d="M237.584 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -115.696)"
                    />
                    <path
                      data-name="Path 100628"
                      d="M245.664 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -115.696)"
                    />
                    <path
                      data-name="Path 100629"
                      d="M253.734 165.244a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -115.696)"
                    />
                    <path
                      data-name="Path 100630"
                      d="M73.665 167.694a.531.531 0 01-.528.534H71.46v-1.068h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -116.725)"
                    />
                    <path
                      data-name="Path 100631"
                      d="M80.274 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -116.725)"
                    />
                    <path
                      data-name="Path 100632"
                      d="M88.354 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -116.725)"
                    />
                    <path
                      data-name="Path 100633"
                      d="M96.434 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -116.725)"
                    />
                    <path
                      data-name="Path 100634"
                      d="M104.5 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -116.725)"
                    />
                    <path
                      data-name="Path 100635"
                      d="M112.584 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -116.725)"
                    />
                    <path
                      data-name="Path 100636"
                      d="M120.654 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -116.725)"
                    />
                    <path
                      data-name="Path 100637"
                      d="M128.734 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -116.725)"
                    />
                    <path
                      data-name="Path 100638"
                      d="M136.814 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -116.725)"
                    />
                    <path
                      data-name="Path 100639"
                      d="M144.884 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -116.725)"
                    />
                    <path
                      data-name="Path 100640"
                      d="M152.964 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -116.725)"
                    />
                    <path
                      data-name="Path 100641"
                      d="M161.034 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -116.725)"
                    />
                    <path
                      data-name="Path 100642"
                      d="M169.114 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -116.725)"
                    />
                    <path
                      data-name="Path 100643"
                      d="M177.184 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -116.725)"
                    />
                    <path
                      data-name="Path 100644"
                      d="M185.264 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -116.725)"
                    />
                    <path
                      data-name="Path 100645"
                      d="M193.344 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -116.725)"
                    />
                    <path
                      data-name="Path 100646"
                      d="M201.414 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -116.725)"
                    />
                    <path
                      data-name="Path 100647"
                      d="M209.494 167.694a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -116.725)"
                    />
                    <path
                      data-name="Path 100648"
                      d="M217.564 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -116.725)"
                    />
                    <path
                      data-name="Path 100649"
                      d="M225.644 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -116.725)"
                    />
                    <path
                      data-name="Path 100650"
                      d="M233.714 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -116.725)"
                    />
                    <path
                      data-name="Path 100651"
                      d="M241.794 167.694a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -116.725)"
                    />
                    <path
                      data-name="Path 100652"
                      d="M249.874 167.694a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -116.725)"
                    />
                    <path
                      data-name="Path 100653"
                      d="M255.65 167.16v1.068h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -116.725)"
                    />
                    <path
                      data-name="Path 100654"
                      d="M76.064 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -117.846)"
                    />
                    <path
                      data-name="Path 100655"
                      d="M84.144 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -117.846)"
                    />
                    <path
                      data-name="Path 100656"
                      d="M92.224 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -117.846)"
                    />
                    <path
                      data-name="Path 100657"
                      d="M100.294 170.364a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -117.846)"
                    />
                    <path
                      data-name="Path 100658"
                      d="M108.374 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -117.846)"
                    />
                    <path
                      data-name="Path 100659"
                      d="M116.444 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -117.846)"
                    />
                    <path
                      data-name="Path 100660"
                      d="M124.524 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -117.846)"
                    />
                    <path
                      data-name="Path 100661"
                      d="M132.6 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -117.846)"
                    />
                    <path
                      data-name="Path 100662"
                      d="M140.674 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -117.846)"
                    />
                    <path
                      data-name="Path 100663"
                      d="M148.754 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -117.846)"
                    />
                    <path
                      data-name="Path 100664"
                      d="M156.824 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -117.846)"
                    />
                    <path
                      data-name="Path 100665"
                      d="M164.9 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -117.846)"
                    />
                    <path
                      data-name="Path 100666"
                      d="M172.974 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -117.846)"
                    />
                    <path
                      data-name="Path 100667"
                      d="M181.054 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -117.846)"
                    />
                    <path
                      data-name="Path 100668"
                      d="M189.134 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -117.846)"
                    />
                    <path
                      data-name="Path 100669"
                      d="M197.2 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -117.846)"
                    />
                    <path
                      data-name="Path 100670"
                      d="M205.284 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -117.846)"
                    />
                    <path
                      data-name="Path 100671"
                      d="M213.354 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -117.846)"
                    />
                    <path
                      data-name="Path 100672"
                      d="M221.434 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -117.846)"
                    />
                    <path
                      data-name="Path 100673"
                      d="M229.514 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -117.846)"
                    />
                    <path
                      data-name="Path 100674"
                      d="M237.584 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -117.846)"
                    />
                    <path
                      data-name="Path 100675"
                      d="M245.664 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -117.846)"
                    />
                    <path
                      data-name="Path 100676"
                      d="M253.734 170.364a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -117.846)"
                    />
                    <path
                      data-name="Path 100677"
                      d="M73.665 172.8a.531.531 0 01-.528.534H71.46v-1.064h1.677a.531.531 0 01.528.53z"
                      transform="translate(0 .168) translate(-71.46 -118.87)"
                    />
                    <path
                      data-name="Path 100678"
                      d="M80.274 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -118.87)"
                    />
                    <path
                      data-name="Path 100679"
                      d="M88.354 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -118.87)"
                    />
                    <path
                      data-name="Path 100680"
                      d="M96.434 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -118.87)"
                    />
                    <path
                      data-name="Path 100681"
                      d="M104.5 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -118.87)"
                    />
                    <path
                      data-name="Path 100682"
                      d="M112.584 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -118.87)"
                    />
                    <path
                      data-name="Path 100683"
                      d="M120.654 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -118.87)"
                    />
                    <path
                      data-name="Path 100684"
                      d="M128.734 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -118.87)"
                    />
                    <path
                      data-name="Path 100685"
                      d="M136.814 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -118.87)"
                    />
                    <path
                      data-name="Path 100686"
                      d="M144.884 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -118.87)"
                    />
                    <path
                      data-name="Path 100687"
                      d="M152.964 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -118.87)"
                    />
                    <path
                      data-name="Path 100688"
                      d="M161.034 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -118.87)"
                    />
                    <path
                      data-name="Path 100689"
                      d="M169.114 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -118.87)"
                    />
                    <path
                      data-name="Path 100690"
                      d="M177.184 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -118.87)"
                    />
                    <path
                      data-name="Path 100691"
                      d="M185.264 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -118.87)"
                    />
                    <path
                      data-name="Path 100692"
                      d="M193.344 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -118.87)"
                    />
                    <path
                      data-name="Path 100693"
                      d="M201.414 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -118.87)"
                    />
                    <path
                      data-name="Path 100694"
                      d="M209.494 172.8a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -118.87)"
                    />
                    <path
                      data-name="Path 100695"
                      d="M217.564 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -118.87)"
                    />
                    <path
                      data-name="Path 100696"
                      d="M225.644 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -118.87)"
                    />
                    <path
                      data-name="Path 100697"
                      d="M233.714 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -118.87)"
                    />
                    <path
                      data-name="Path 100698"
                      d="M241.794 172.8a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -118.87)"
                    />
                    <path
                      data-name="Path 100699"
                      d="M249.874 172.8a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -118.87)"
                    />
                    <path
                      data-name="Path 100700"
                      d="M255.65 172.27v1.068h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -118.87)"
                    />
                    <path
                      data-name="Path 100701"
                      d="M76.064 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -119.991)"
                    />
                    <path
                      data-name="Path 100702"
                      d="M84.144 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -119.991)"
                    />
                    <path
                      data-name="Path 100703"
                      d="M92.224 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -119.991)"
                    />
                    <path
                      data-name="Path 100704"
                      d="M100.294 175.474a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -119.991)"
                    />
                    <path
                      data-name="Path 100705"
                      d="M108.374 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -119.991)"
                    />
                    <path
                      data-name="Path 100706"
                      d="M116.444 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -119.991)"
                    />
                    <path
                      data-name="Path 100707"
                      d="M124.524 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -119.991)"
                    />
                    <path
                      data-name="Path 100708"
                      d="M132.6 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -119.991)"
                    />
                    <path
                      data-name="Path 100709"
                      d="M140.674 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -119.991)"
                    />
                    <path
                      data-name="Path 100710"
                      d="M148.754 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -119.991)"
                    />
                    <path
                      data-name="Path 100711"
                      d="M156.824 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -119.991)"
                    />
                    <path
                      data-name="Path 100712"
                      d="M164.9 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -119.991)"
                    />
                    <path
                      data-name="Path 100713"
                      d="M172.974 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -119.991)"
                    />
                    <path
                      data-name="Path 100714"
                      d="M181.054 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -119.991)"
                    />
                    <path
                      data-name="Path 100715"
                      d="M189.134 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -119.991)"
                    />
                    <path
                      data-name="Path 100716"
                      d="M197.2 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -119.991)"
                    />
                    <path
                      data-name="Path 100717"
                      d="M205.284 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -119.991)"
                    />
                    <path
                      data-name="Path 100718"
                      d="M213.354 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -119.991)"
                    />
                    <path
                      data-name="Path 100719"
                      d="M221.434 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -119.991)"
                    />
                    <path
                      data-name="Path 100720"
                      d="M229.514 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -119.991)"
                    />
                    <path
                      data-name="Path 100721"
                      d="M237.584 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -119.991)"
                    />
                    <path
                      data-name="Path 100722"
                      d="M245.664 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -119.991)"
                    />
                    <path
                      data-name="Path 100723"
                      d="M253.734 175.474a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -119.991)"
                    />
                    <path
                      data-name="Path 100724"
                      d="M73.665 177.924a.535.535 0 01-.528.534H71.46v-1.068h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -121.019)"
                    />
                    <path
                      data-name="Path 100725"
                      d="M80.274 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -121.015)"
                    />
                    <path
                      data-name="Path 100726"
                      d="M88.354 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -121.015)"
                    />
                    <path
                      data-name="Path 100727"
                      d="M96.434 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -121.015)"
                    />
                    <path
                      data-name="Path 100728"
                      d="M104.5 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -121.015)"
                    />
                    <path
                      data-name="Path 100729"
                      d="M112.584 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -121.015)"
                    />
                    <path
                      data-name="Path 100730"
                      d="M120.654 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -121.015)"
                    />
                    <path
                      data-name="Path 100731"
                      d="M128.734 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -121.015)"
                    />
                    <path
                      data-name="Path 100732"
                      d="M136.814 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -121.015)"
                    />
                    <path
                      data-name="Path 100733"
                      d="M144.884 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -121.015)"
                    />
                    <path
                      data-name="Path 100734"
                      d="M152.964 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -121.015)"
                    />
                    <path
                      data-name="Path 100735"
                      d="M161.034 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -121.015)"
                    />
                    <path
                      data-name="Path 100736"
                      d="M169.114 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -121.015)"
                    />
                    <path
                      data-name="Path 100737"
                      d="M177.184 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -121.015)"
                    />
                    <path
                      data-name="Path 100738"
                      d="M185.264 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -121.015)"
                    />
                    <path
                      data-name="Path 100739"
                      d="M193.344 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -121.015)"
                    />
                    <path
                      data-name="Path 100740"
                      d="M201.414 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -121.015)"
                    />
                    <path
                      data-name="Path 100741"
                      d="M209.494 177.914a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -121.015)"
                    />
                    <path
                      data-name="Path 100742"
                      d="M217.564 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -121.015)"
                    />
                    <path
                      data-name="Path 100743"
                      d="M225.644 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -121.015)"
                    />
                    <path
                      data-name="Path 100744"
                      d="M233.714 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -121.015)"
                    />
                    <path
                      data-name="Path 100745"
                      d="M241.794 177.914a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -121.015)"
                    />
                    <path
                      data-name="Path 100746"
                      d="M249.874 177.914a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -121.015)"
                    />
                    <path
                      data-name="Path 100747"
                      d="M255.65 177.39v1.068h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -121.019)"
                    />
                    <path
                      data-name="Path 100748"
                      d="M76.064 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -122.136)"
                    />
                    <path
                      data-name="Path 100749"
                      d="M84.144 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -122.136)"
                    />
                    <path
                      data-name="Path 100750"
                      d="M92.224 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -122.136)"
                    />
                    <path
                      data-name="Path 100751"
                      d="M100.294 180.584a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -122.136)"
                    />
                    <path
                      data-name="Path 100752"
                      d="M108.374 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -122.136)"
                    />
                    <path
                      data-name="Path 100753"
                      d="M116.444 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -122.136)"
                    />
                    <path
                      data-name="Path 100754"
                      d="M124.524 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -122.136)"
                    />
                    <path
                      data-name="Path 100755"
                      d="M132.6 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -122.136)"
                    />
                    <path
                      data-name="Path 100756"
                      d="M140.674 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -122.136)"
                    />
                    <path
                      data-name="Path 100757"
                      d="M148.754 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -122.136)"
                    />
                    <path
                      data-name="Path 100758"
                      d="M156.824 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -122.136)"
                    />
                    <path
                      data-name="Path 100759"
                      d="M164.9 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -122.136)"
                    />
                    <path
                      data-name="Path 100760"
                      d="M172.974 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -122.136)"
                    />
                    <path
                      data-name="Path 100761"
                      d="M181.054 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -122.136)"
                    />
                    <path
                      data-name="Path 100762"
                      d="M189.134 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -122.136)"
                    />
                    <path
                      data-name="Path 100763"
                      d="M197.2 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -122.136)"
                    />
                    <path
                      data-name="Path 100764"
                      d="M205.284 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -122.136)"
                    />
                    <path
                      data-name="Path 100765"
                      d="M213.354 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -122.136)"
                    />
                    <path
                      data-name="Path 100766"
                      d="M221.434 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -122.136)"
                    />
                    <path
                      data-name="Path 100767"
                      d="M229.514 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -122.136)"
                    />
                    <path
                      data-name="Path 100768"
                      d="M237.584 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -122.136)"
                    />
                    <path
                      data-name="Path 100769"
                      d="M245.664 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -122.136)"
                    />
                    <path
                      data-name="Path 100770"
                      d="M253.734 180.584a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -122.136)"
                    />
                    <path
                      data-name="Path 100771"
                      d="M73.665 183.028a.531.531 0 01-.528.534H71.46V182.5h1.677a.53.53 0 01.528.528z"
                      transform="translate(0 .168) translate(-71.46 -123.165)"
                    />
                    <path
                      data-name="Path 100772"
                      d="M80.274 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -123.165)"
                    />
                    <path
                      data-name="Path 100773"
                      d="M88.354 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -123.165)"
                    />
                    <path
                      data-name="Path 100774"
                      d="M96.434 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -123.165)"
                    />
                    <path
                      data-name="Path 100775"
                      d="M104.5 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -123.165)"
                    />
                    <path
                      data-name="Path 100776"
                      d="M112.584 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -123.165)"
                    />
                    <path
                      data-name="Path 100777"
                      d="M120.654 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -123.165)"
                    />
                    <path
                      data-name="Path 100778"
                      d="M128.734 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -123.165)"
                    />
                    <path
                      data-name="Path 100779"
                      d="M136.814 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -123.165)"
                    />
                    <path
                      data-name="Path 100780"
                      d="M144.884 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -123.165)"
                    />
                    <path
                      data-name="Path 100781"
                      d="M152.964 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -123.165)"
                    />
                    <path
                      data-name="Path 100782"
                      d="M161.034 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -123.165)"
                    />
                    <path
                      data-name="Path 100783"
                      d="M169.114 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -123.165)"
                    />
                    <path
                      data-name="Path 100784"
                      d="M177.184 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -123.165)"
                    />
                    <path
                      data-name="Path 100785"
                      d="M185.264 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -123.165)"
                    />
                    <path
                      data-name="Path 100786"
                      d="M193.344 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -123.165)"
                    />
                    <path
                      data-name="Path 100787"
                      d="M201.414 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -123.165)"
                    />
                    <path
                      data-name="Path 100788"
                      d="M209.494 183.034a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -123.165)"
                    />
                    <path
                      data-name="Path 100789"
                      d="M217.564 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -123.165)"
                    />
                    <path
                      data-name="Path 100790"
                      d="M225.644 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -123.165)"
                    />
                    <path
                      data-name="Path 100791"
                      d="M233.714 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -123.165)"
                    />
                    <path
                      data-name="Path 100792"
                      d="M241.794 183.034a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -123.165)"
                    />
                    <path
                      data-name="Path 100793"
                      d="M249.874 183.034a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -123.165)"
                    />
                    <path
                      data-name="Path 100794"
                      d="M255.65 182.5v1.062h-1.392a.531.531 0 010-1.062z"
                      transform="translate(0 .168) translate(-147.98 -123.165)"
                    />
                    <path
                      data-name="Path 100795"
                      d="M76.064 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -124.286)"
                    />
                    <path
                      data-name="Path 100796"
                      d="M84.144 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -124.286)"
                    />
                    <path
                      data-name="Path 100797"
                      d="M92.224 185.7a.531.531 0 01-.528.534h-3.168A.531.531 0 0188 185.7a.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -124.286)"
                    />
                    <path
                      data-name="Path 100798"
                      d="M100.294 185.7a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -124.286)"
                    />
                    <path
                      data-name="Path 100799"
                      d="M108.374 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -124.286)"
                    />
                    <path
                      data-name="Path 100800"
                      d="M116.444 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -124.286)"
                    />
                    <path
                      data-name="Path 100801"
                      d="M124.524 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -124.286)"
                    />
                    <path
                      data-name="Path 100802"
                      d="M132.6 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -124.286)"
                    />
                    <path
                      data-name="Path 100803"
                      d="M140.674 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -124.286)"
                    />
                    <path
                      data-name="Path 100804"
                      d="M148.754 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -124.286)"
                    />
                    <path
                      data-name="Path 100805"
                      d="M156.824 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -124.286)"
                    />
                    <path
                      data-name="Path 100806"
                      d="M164.9 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -124.286)"
                    />
                    <path
                      data-name="Path 100807"
                      d="M172.974 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -124.286)"
                    />
                    <path
                      data-name="Path 100808"
                      d="M181.054 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -124.286)"
                    />
                    <path
                      data-name="Path 100809"
                      d="M189.134 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -124.286)"
                    />
                    <path
                      data-name="Path 100810"
                      d="M197.2 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -124.286)"
                    />
                    <path
                      data-name="Path 100811"
                      d="M205.284 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -124.286)"
                    />
                    <path
                      data-name="Path 100812"
                      d="M213.354 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -124.286)"
                    />
                    <path
                      data-name="Path 100813"
                      d="M221.434 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -124.286)"
                    />
                    <path
                      data-name="Path 100814"
                      d="M229.514 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -124.286)"
                    />
                    <path
                      data-name="Path 100815"
                      d="M237.584 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -124.286)"
                    />
                    <path
                      data-name="Path 100816"
                      d="M245.664 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -124.286)"
                    />
                    <path
                      data-name="Path 100817"
                      d="M253.734 185.7a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -124.286)"
                    />
                    <path
                      data-name="Path 100818"
                      d="M73.665 188.144a.531.531 0 01-.528.534H71.46v-1.068h1.677a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.46 -125.31)"
                    />
                    <path
                      data-name="Path 100819"
                      d="M80.274 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -125.31)"
                    />
                    <path
                      data-name="Path 100820"
                      d="M88.354 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -125.31)"
                    />
                    <path
                      data-name="Path 100821"
                      d="M96.434 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -125.31)"
                    />
                    <path
                      data-name="Path 100822"
                      d="M104.5 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -125.31)"
                    />
                    <path
                      data-name="Path 100823"
                      d="M112.584 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -125.31)"
                    />
                    <path
                      data-name="Path 100824"
                      d="M120.654 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -125.31)"
                    />
                    <path
                      data-name="Path 100825"
                      d="M128.734 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -125.31)"
                    />
                    <path
                      data-name="Path 100826"
                      d="M136.814 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -125.31)"
                    />
                    <path
                      data-name="Path 100827"
                      d="M144.884 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -125.31)"
                    />
                    <path
                      data-name="Path 100828"
                      d="M152.964 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -125.31)"
                    />
                    <path
                      data-name="Path 100829"
                      d="M161.034 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -125.31)"
                    />
                    <path
                      data-name="Path 100830"
                      d="M169.114 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -125.31)"
                    />
                    <path
                      data-name="Path 100831"
                      d="M177.184 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -125.31)"
                    />
                    <path
                      data-name="Path 100832"
                      d="M185.264 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -125.31)"
                    />
                    <path
                      data-name="Path 100833"
                      d="M193.344 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -125.31)"
                    />
                    <path
                      data-name="Path 100834"
                      d="M201.414 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -125.31)"
                    />
                    <path
                      data-name="Path 100835"
                      d="M209.494 188.144a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -125.31)"
                    />
                    <path
                      data-name="Path 100836"
                      d="M217.564 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -125.31)"
                    />
                    <path
                      data-name="Path 100837"
                      d="M225.644 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -125.31)"
                    />
                    <path
                      data-name="Path 100838"
                      d="M233.714 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -125.31)"
                    />
                    <path
                      data-name="Path 100839"
                      d="M241.794 188.144a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -125.31)"
                    />
                    <path
                      data-name="Path 100840"
                      d="M249.874 188.144a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -125.31)"
                    />
                    <path
                      data-name="Path 100841"
                      d="M255.65 187.61v1.068h-1.392a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.98 -125.31)"
                    />
                    <path
                      data-name="Path 100842"
                      d="M76.064 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.62 -126.431)"
                    />
                    <path
                      data-name="Path 100843"
                      d="M84.144 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -126.431)"
                    />
                    <path
                      data-name="Path 100844"
                      d="M92.224 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -126.431)"
                    />
                    <path
                      data-name="Path 100845"
                      d="M100.294 190.814a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -126.431)"
                    />
                    <path
                      data-name="Path 100846"
                      d="M108.374 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -126.431)"
                    />
                    <path
                      data-name="Path 100847"
                      d="M116.444 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -126.431)"
                    />
                    <path
                      data-name="Path 100848"
                      d="M124.524 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -126.431)"
                    />
                    <path
                      data-name="Path 100849"
                      d="M132.6 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -126.431)"
                    />
                    <path
                      data-name="Path 100850"
                      d="M140.674 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -126.431)"
                    />
                    <path
                      data-name="Path 100851"
                      d="M148.754 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -126.431)"
                    />
                    <path
                      data-name="Path 100852"
                      d="M156.824 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -126.431)"
                    />
                    <path
                      data-name="Path 100853"
                      d="M164.9 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -126.431)"
                    />
                    <path
                      data-name="Path 100854"
                      d="M172.974 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -126.431)"
                    />
                    <path
                      data-name="Path 100855"
                      d="M181.054 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -126.431)"
                    />
                    <path
                      data-name="Path 100856"
                      d="M189.134 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -126.431)"
                    />
                    <path
                      data-name="Path 100857"
                      d="M197.2 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -126.431)"
                    />
                    <path
                      data-name="Path 100858"
                      d="M205.284 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -126.431)"
                    />
                    <path
                      data-name="Path 100859"
                      d="M213.354 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -126.431)"
                    />
                    <path
                      data-name="Path 100860"
                      d="M221.434 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -126.431)"
                    />
                    <path
                      data-name="Path 100861"
                      d="M229.514 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -126.431)"
                    />
                    <path
                      data-name="Path 100862"
                      d="M237.584 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -126.431)"
                    />
                    <path
                      data-name="Path 100863"
                      d="M245.664 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -126.431)"
                    />
                    <path
                      data-name="Path 100864"
                      d="M253.734 190.814a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-146.208 -126.431)"
                    />
                    <path
                      data-name="Path 100865"
                      d="M73.849 193.264a.531.531 0 01-.528.534h-.876a4.215 4.215 0 01-.545-1.068h1.421a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-71.645 -127.459)"
                    />
                    <path
                      data-name="Path 100866"
                      d="M80.274 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-73.387 -127.459)"
                    />
                    <path
                      data-name="Path 100867"
                      d="M88.354 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-76.779 -127.459)"
                    />
                    <path
                      data-name="Path 100868"
                      d="M96.434 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-80.171 -127.459)"
                    />
                    <path
                      data-name="Path 100869"
                      d="M104.5 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-83.559 -127.459)"
                    />
                    <path
                      data-name="Path 100870"
                      d="M112.584 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-86.951 -127.459)"
                    />
                    <path
                      data-name="Path 100871"
                      d="M120.654 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-90.339 -127.459)"
                    />
                    <path
                      data-name="Path 100872"
                      d="M128.734 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-93.731 -127.459)"
                    />
                    <path
                      data-name="Path 100873"
                      d="M136.814 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-97.123 -127.459)"
                    />
                    <path
                      data-name="Path 100874"
                      d="M144.884 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-100.511 -127.459)"
                    />
                    <path
                      data-name="Path 100875"
                      d="M152.964 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-103.903 -127.459)"
                    />
                    <path
                      data-name="Path 100876"
                      d="M161.034 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-107.291 -127.459)"
                    />
                    <path
                      data-name="Path 100877"
                      d="M169.114 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-110.684 -127.459)"
                    />
                    <path
                      data-name="Path 100878"
                      d="M177.184 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-114.071 -127.459)"
                    />
                    <path
                      data-name="Path 100879"
                      d="M185.264 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-117.464 -127.459)"
                    />
                    <path
                      data-name="Path 100880"
                      d="M193.344 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-120.856 -127.459)"
                    />
                    <path
                      data-name="Path 100881"
                      d="M201.414 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-124.244 -127.459)"
                    />
                    <path
                      data-name="Path 100882"
                      d="M209.494 193.264a.531.531 0 01-.528.534H205.8a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-127.636 -127.459)"
                    />
                    <path
                      data-name="Path 100883"
                      d="M217.564 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-131.024 -127.459)"
                    />
                    <path
                      data-name="Path 100884"
                      d="M225.644 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-134.416 -127.459)"
                    />
                    <path
                      data-name="Path 100885"
                      d="M233.714 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-137.804 -127.459)"
                    />
                    <path
                      data-name="Path 100886"
                      d="M241.794 193.264a.531.531 0 01-.528.534H238.1a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-141.196 -127.459)"
                    />
                    <path
                      data-name="Path 100887"
                      d="M249.874 193.264a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-144.588 -127.459)"
                    />
                    <path
                      data-name="Path 100888"
                      d="M255.391 192.73a4.431 4.431 0 01-.551 1.068h-.592a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-147.976 -127.459)"
                    />
                    <path
                      data-name="Path 100889"
                      d="M76.771 195.934a.531.531 0 01-.528.534h-1.2a4.445 4.445 0 01-1.533-1.068h2.733a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-72.321 -128.58)"
                    />
                    <path
                      data-name="Path 100890"
                      d="M84.144 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-75.012 -128.576)"
                    />
                    <path
                      data-name="Path 100891"
                      d="M92.224 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H91.7a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-78.404 -128.576)"
                    />
                    <path
                      data-name="Path 100892"
                      d="M100.294 195.924a.531.531 0 01-.528.534H96.6a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-81.792 -128.576)"
                    />
                    <path
                      data-name="Path 100893"
                      d="M108.374 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-85.184 -128.576)"
                    />
                    <path
                      data-name="Path 100894"
                      d="M116.444 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-88.572 -128.576)"
                    />
                    <path
                      data-name="Path 100895"
                      d="M124.524 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534H124a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-91.964 -128.576)"
                    />
                    <path
                      data-name="Path 100896"
                      d="M132.6 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-95.356 -128.576)"
                    />
                    <path
                      data-name="Path 100897"
                      d="M140.674 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-98.744 -128.576)"
                    />
                    <path
                      data-name="Path 100898"
                      d="M148.754 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-102.136 -128.576)"
                    />
                    <path
                      data-name="Path 100899"
                      d="M156.824 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.172a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-105.524 -128.576)"
                    />
                    <path
                      data-name="Path 100900"
                      d="M164.9 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-108.916 -128.576)"
                    />
                    <path
                      data-name="Path 100901"
                      d="M172.974 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-112.304 -128.576)"
                    />
                    <path
                      data-name="Path 100902"
                      d="M181.054 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-115.696 -128.576)"
                    />
                    <path
                      data-name="Path 100903"
                      d="M189.134 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-119.088 -128.576)"
                    />
                    <path
                      data-name="Path 100904"
                      d="M197.2 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-122.476 -128.576)"
                    />
                    <path
                      data-name="Path 100905"
                      d="M205.284 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-125.868 -128.576)"
                    />
                    <path
                      data-name="Path 100906"
                      d="M213.354 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-129.256 -128.576)"
                    />
                    <path
                      data-name="Path 100907"
                      d="M221.434 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-132.648 -128.576)"
                    />
                    <path
                      data-name="Path 100908"
                      d="M229.514 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-136.04 -128.576)"
                    />
                    <path
                      data-name="Path 100909"
                      d="M237.584 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-139.428 -128.576)"
                    />
                    <path
                      data-name="Path 100910"
                      d="M245.664 195.924a.531.531 0 01-.528.534h-3.168a.531.531 0 01-.528-.534.531.531 0 01.528-.534h3.168a.531.531 0 01.528.534z"
                      transform="translate(0 .168) translate(-142.821 -128.576)"
                    />
                    <path
                      data-name="Path 100911"
                      d="M252.684 195.4a4.37 4.37 0 01-1.532 1.068h-1.114a.534.534 0 010-1.068z"
                      transform="translate(0 .168) translate(-146.208 -128.58)"
                    />
                  </g>
                  <path
                    data-name="Path 100912"
                    d="M179.125 190.08v.058a4.435 4.435 0 01-4.438 4.438H75.9a4.438 4.438 0 01-4.438-4.438v-.058z"
                    transform="translate(-71.46 -126.179)"
                    fill="#e6eff8"
                  />
                  <path
                    data-name="Path 100913"
                    d="M79.109 192.009l-.969.406-.87.36v.406l.714.3 1.207.5v-.528L78 192.984l1.189-.476v-.528l-.087.035z"
                    transform="translate(-73.899 -126.976)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100914"
                    d="M87.264 192.016l-.934.389-.87.36v.406l.714.3 1.178.493.029.012v-.528l-1.189-.476 1.189-.476v-.528l-.122.052z"
                    transform="translate(-77.337 -126.972)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100915"
                    d="M90.846 192.053l-.859.36-.847.354v.406l.714.3 1.155.482.058.023v-.528l-.667-.273-.522-.209.545-.22.644-.261v-.528l-.22.093z"
                    transform="translate(-78.882 -126.968)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100916"
                    d="M93.69 192.415l-.87.36v.406l.719.3 1.213.5v-.528l-1.189-.476 1.189-.476v-.528l-1.062.441z"
                    transform="translate(-80.427 -126.976)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100917"
                    d="M98.206 192.057l-.835.348-.87.36v.406l.714.3 1.155.482.058.023v-.528l-.342-.139-.847-.336.882-.354.3-.122v-.528l-.22.093z"
                    transform="translate(-81.972 -126.972)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100918"
                    d="M101.05 192.415l-.766.319-.1.046v.406l.145.058.563.238 1.213.5v-.528l-1.189-.476 1.189-.476v-.528l-1.056.441z"
                    transform="translate(-83.517 -126.976)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100919"
                    d="M105.562 192.053l-.841.348-.87.36v.406l.719.3 1.155.482.058.023v-.528l-.081-.029-1.114-.447 1.184-.476h.006v-.534l-.22.093z"
                    transform="translate(-85.058 -126.968)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100920"
                    d="M122.086 192.057l-.835.348-.87.36v.406l.714.3 1.155.482.058.023v-.528l-.209-.081-.986-.395 1.039-.412.157-.064v-.528l-.22.093z"
                    transform="translate(-91.997 -126.972)"
                    fill="#565655"
                  />
                  <path
                    data-name="Rectangle 55656"
                    transform="translate(5.796 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55657"
                    transform="translate(21.043 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Path 100921"
                    d="M125.034 192.419l-.58.244-.284.122v.406l.366.157.342.139 1.213.511v-.528l-1.189-.476 1.189-.476v-.528l-1.056.441z"
                    transform="translate(-93.589 -126.98)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100922"
                    d="M129.536 192.057l-.835.348-.87.36v.406l.714.3 1.155.482.058.023v-.528h-.006l-1.178-.476 1.189-.476v-.528l-.22.093z"
                    transform="translate(-95.125 -126.972)"
                    fill="#565655"
                  />
                  <path
                    data-name="Rectangle 55658"
                    transform="translate(34.962 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55659"
                    transform="translate(23.55 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Path 100923"
                    d="M157.54 192.415l-.737.307-.133.058v.406l.18.075.534.22 1.213.5v-.528l-1.189-.476 1.189-.476v-.528l-1.056.441z"
                    transform="translate(-107.233 -126.976)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100924"
                    d="M162.056 192.053l-.835.348-.87.36v.406l.714.3 1.155.482.058.023v-.528l-.064-.029-1.126-.453 1.189-.476v-.528l-.22.093z"
                    transform="translate(-108.778 -126.968)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100925"
                    d="M165.74 192.061l-1.7.714v.406l1.926.806v-.528l-1.189-.476 1.189-.476v-.528l-.22.093z"
                    transform="translate(-110.327 -126.976)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100926"
                    d="M169.406 192.057l-.835.348-.87.36v.406l.714.3 1.155.482.058.023v-.528l-1.189-.476 1.189-.476v-.528l-.22.093z"
                    transform="translate(-111.863 -126.972)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100927"
                    d="M173.086 192.061l-1.358.569-.348.145v.406l.313.133 1.555.65.058.023v-.528l-1-.4-.191-.075.186-.075 1-.4v-.528l-.22.093z"
                    transform="translate(-113.408 -126.976)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100928"
                    d="M176.766 192.057l-.835.348-.87.36v.406l.714.3 1.155.482.058.023v-.528l-1.189-.476 1.189-.476v-.528l-.22.093z"
                    transform="translate(-114.953 -126.972)"
                    fill="#565655"
                  />
                  <path
                    data-name="Rectangle 55660"
                    transform="translate(62.358 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55661"
                    transform="translate(64.864 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55662"
                    transform="translate(67.51 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55663"
                    transform="translate(70.156 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55664"
                    transform="translate(72.801 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55665"
                    transform="translate(75.447 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55666"
                    transform="translate(78.093 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55667"
                    transform="translate(80.738 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55668"
                    transform="translate(83.384 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55669"
                    transform="translate(26.056 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Path 100929"
                    d="M137.572 192.057l-.841.348-.87.36v.406l.719.3 1.155.482.058.023v-.528l-1.189-.476 1.189-.476v-.528l-.22.093z"
                    transform="translate(-98.496 -126.972)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100930"
                    d="M154.1 192.049l-.835.348-.87.36v.406l.714.3 1.155.482.058.023v-.528l-.1-.041-1.085-.441 1.149-.464.041-.017v-.528l-.22.093z"
                    transform="translate(-105.436 -126.964)"
                    fill="#565655"
                  />
                  <path
                    data-name="Rectangle 55670"
                    transform="translate(39.615 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55671"
                    transform="translate(42.121 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Rectangle 55672"
                    transform="translate(44.622 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Path 100931"
                    d="M229.656 192.053l-1.369.574-.337.139v.406l.3.122 1.572.656.058.023v-.528l-1.015-.412-.174-.07.162-.064 1.021-.412v-.528l-.22.093z"
                    transform="translate(-137.157 -126.968)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100932"
                    d="M233.336 192.057l-.835.348-.87.36v.406l.714.3 1.155.482.058.023v-.528l-1.189-.476 1.189-.476v-.528l-.22.093z"
                    transform="translate(-138.702 -126.972)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100933"
                    d="M225.366 192.057l-.835.348-.87.36v.406l.714.3 1.155.482.058.023v-.528l-1.189-.476 1.189-.476v-.528l-.22.093z"
                    transform="translate(-135.356 -126.972)"
                    fill="#565655"
                  />
                  <path
                    data-name="Rectangle 55673"
                    transform="translate(85.977 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                  <path
                    data-name="Path 100934"
                    d="M245.956 192.049l-1.445.6-.261.11v.406l.232.093 1.636.685.058.023v-.528l-1.114-.447-.075-.035.07-.029 1.12-.453v-.528l-.22.093z"
                    transform="translate(-144 -126.964)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100935"
                    d="M249.636 192.057l-.835.348-.87.36v.406l.714.3 1.155.482.058.023v-.528l-1.189-.476 1.189-.476v-.528l-.22.093z"
                    transform="translate(-145.545 -126.972)"
                    fill="#565655"
                  />
                  <path
                    data-name="Path 100936"
                    d="M241.676 192.057l-.835.348-.87.36v.406l.714.3 1.155.482.058.023v-.528l-1.189-.476 1.189-.476v-.528l-.22.093z"
                    transform="translate(-142.203 -126.972)"
                    fill="#565655"
                  />
                  <path
                    data-name="Rectangle 55674"
                    transform="translate(95.44 64.992)"
                    fill="#565655"
                    d="M0 0H2.036V2.123H0z"
                  />
                </g>
                <path
                  data-name="Path 100937"
                  d="M179.13 84.373v7.4H71.46v-7.632a4.038 4.038 0 01.191-1.068 4.743 4.743 0 01.186-.5 4.511 4.511 0 01.545-.911 4.29 4.29 0 01.435-.482 4.033 4.033 0 01.835-.627 4.225 4.225 0 01.673-.325.314.314 0 01.157-.081.035.035 0 00.023-.006.313.313 0 00.058-.017c.029 0 .058-.006.093-.006h.023a4.49 4.49 0 011.221-.178h98.788a4.277 4.277 0 011.224.174 4.144 4.144 0 01.783.307 3.82 3.82 0 01.516.313 3.751 3.751 0 01.551.453 2.721 2.721 0 01.22.226.026.026 0 01.017.017l.058.058c.052.058.1.116.145.174a4.127 4.127 0 01.569.963 3.273 3.273 0 01.168.453 4.038 4.038 0 01.191 1.068v.232z"
                  transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(2.847 34.137) translate(-71.46 -79.923)"
                  fill="#58aa9d"
                />
                <path
                  data-name="Path 100938"
                  d="M178.072 81.471a.02.02 0 00-.012-.006 3.8 3.8 0 00-.383-.3 2.672 2.672 0 00-.348-.215c-.052-.035-.11-.064-.162-.093a4.637 4.637 0 00-.784-.307 4.49 4.49 0 00-1.224-.174H76.366a4.306 4.306 0 00-1.224.174h-.023a.5.5 0 00-.3.11H74.8a3.3 3.3 0 00-.563.261c-.041.017-.075.041-.11.058a4.622 4.622 0 00-.835.627l-.035.035a3.664 3.664 0 00-.4.447 5.315 5.315 0 00-.4.615c-.052.093-.1.2-.145.3l-.023.058a2.928 2.928 0 00-.162.447 4.212 4.212 0 00-.145.621 3.759 3.759 0 00-.046.447v59.759c0 .151.012.3.023.441a.347.347 0 00.012.07.572.572 0 00.012.1 1.94 1.94 0 00.041.244c.006.041.017.081.023.122a.13.13 0 00.017.058 1.958 1.958 0 00.052.2c.017.064.035.122.058.186a.221.221 0 00.017.058.6.6 0 01.023.058q.078.2.174.4c.023.046.046.1.07.145 0 .006.006.012.012.017a3 3 0 00.249.412l.017.035a.153.153 0 00.029.035 3.633 3.633 0 00.226.3c-.052-.046-.1-.087-.145-.133l-.07-.07c-.029-.029-.064-.058-.093-.093a.184.184 0 01-.035-.046 2.838 2.838 0 01-.348-.441l-.023-.041c-.046-.07-.087-.133-.133-.2s-.081-.145-.122-.22c-.023-.046-.046-.1-.07-.151s-.058-.128-.093-.2a.029.029 0 00-.006-.017c-.023-.058-.046-.122-.07-.18a.6.6 0 01-.023-.058l-.017-.058c-.017-.064-.041-.128-.058-.191a3.652 3.652 0 01-.064-.255.927.927 0 00-.029-.122c-.017-.11-.041-.226-.052-.342 0-.017-.006-.035-.006-.052v-.017l-.012-.133c-.006-.1-.012-.2-.012-.307V84.111a4.038 4.038 0 01.191-1.068 4.743 4.743 0 01.186-.5 4.511 4.511 0 01.545-.911 4.29 4.29 0 01.435-.482 4.034 4.034 0 01.835-.627 4.226 4.226 0 01.673-.325.029.029 0 00.017-.006.607.607 0 01.133-.075.035.035 0 00.023-.006.312.312 0 00.058-.017c.029 0 .058-.006.093-.006h.023a4.49 4.49 0 011.224-.174h98.788a4.277 4.277 0 011.224.174 4.146 4.146 0 01.783.308 3.818 3.818 0 01.516.313 3.75 3.75 0 01.551.453 2.719 2.719 0 01.22.226.026.026 0 01.017.017l.058.058z"
                  transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(2.847 34.137) translate(-71.481 -79.91)"
                  fill="#fff"
                  opacity={0.3}
                />
                <g
                  data-name="Group 105517"
                  transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(2.847 34.137) translate(4.45 16.088)"
                  clipPath="url(#a)"
                >
                  <path
                    data-name="Rectangle 55675"
                    fill="#fff"
                    d="M0 0H29.218V36.824H0z"
                  />
                  <g
                    data-name="Group 105516"
                    transform="translate(-2.599 5.796)"
                  >
                    <path
                      data-name="Rectangle 55676"
                      transform="translate(12.532 22.169)"
                      fill="#f7c8a8"
                      d="M0 0H9.173V5.396H0z"
                    />
                    <path
                      data-name="Path 100939"
                      d="M93.7 134.442c.249 1.108-.012 2.077-.592 2.176s-1.247-.725-1.5-1.828.012-2.077.592-2.176 1.251.726 1.5 1.828z"
                      transform="translate(-81.731 -123.918)"
                      fill="#f7c8a8"
                    />
                    <path
                      data-name="Path 100940"
                      d="M93.638 134.907c.18.795-.012 1.491-.424 1.561s-.893-.516-1.073-1.311.012-1.491.424-1.561.893.516 1.073 1.311z"
                      transform="translate(-81.965 -124.33)"
                      opacity={0.3}
                    />
                    <path
                      data-name="Path 100941"
                      d="M113.272 134.442c-.249 1.108.012 2.077.592 2.176s1.247-.725 1.5-1.828-.012-2.077-.592-2.176-1.251.726-1.5 1.828z"
                      transform="translate(-90.824 -123.918)"
                      fill="#f7c8a8"
                    />
                    <path
                      data-name="Path 100942"
                      d="M113.8 134.907c-.18.795.012 1.491.424 1.561s.893-.516 1.073-1.311-.012-1.491-.424-1.561-.892.516-1.073 1.311z"
                      transform="translate(-91.058 -124.33)"
                      opacity={0.3}
                    />
                    <g data-name="Group 105511" fill="#f7c8a8">
                      <path
                        data-name="Path 100943"
                        d="M91.7 146.6v6.62h-8.21v-.7a7.116 7.116 0 00.795-.279c.145-.058.3-.116.453-.18.458-.186.975-.406 1.52-.615a17.413 17.413 0 002.669-1.265c.168-.1.331-.2.493-.308 1.299-.873 2.28-1.962 2.28-3.273z"
                        transform="translate(5.129 16.808) translate(-83.49 -146.6)"
                      />
                      <path
                        data-name="Path 100944"
                        d="M119.19 152.518v.7h-8.21V146.6c0 1.311.981 2.4 2.28 3.272.157.1.325.209.493.307a17.123 17.123 0 002.669 1.259 49.17 49.17 0 011.52.615c.157.064.307.128.453.18a7.081 7.081 0 00.789.278z"
                        transform="translate(5.129 16.808) translate(-95.031 -146.6)"
                      />
                    </g>
                    <path
                      data-name="Rectangle 55677"
                      transform="translate(13.338 13.449)"
                      fill="#f7c8a8"
                      d="M0 0H7.734V9.12H0z"
                    />
                    <g data-name="Group 105512">
                      <path
                        data-name="Path 100945"
                        d="M105.39 144.264a5.127 5.127 0 01-7.74 0V140.8h7.734v3.464z"
                        transform="translate(13.344 13.443) translate(-97.65 -140.8)"
                        opacity={0.15}
                      />
                    </g>
                    <path
                      data-name="Path 100946"
                      d="M106.128 126.562a11.372 11.372 0 01-.882 4.34c-1.137 2.727-3.255 4.8-5.68 4.8s-4.543-2.077-5.68-4.8a11.47 11.47 0 01-.876-4.334c0-4.514 2.936-7.212 6.556-7.212s6.562 2.692 6.562 7.206z"
                      transform="translate(-82.358 -118.352)"
                      fill="#f7c8a8"
                    />
                    <g data-name="Group 105515">
                      <g data-name="Group 105513">
                        <path
                          data-name="Path 100947"
                          d="M86.66 154.69l-.064.754-.267 1.178H83.51v-.7a7.112 7.112 0 00.795-.278c.145-.058.3-.116.453-.18.458-.186.975-.406 1.52-.615.128-.046.255-.1.389-.151z"
                          transform="translate(5.14 16.808) translate(-83.51 -149.996)"
                          fill="#c4c4c4"
                        />
                        <path
                          data-name="Path 100948"
                          d="M97.237 146.6v5.216l-.487-3.052-.07-.482a4.066 4.066 0 00.255-.435c.029-.052.052-.11.075-.162a.023.023 0 01.012-.023c.023-.058.046-.122.07-.18s.046-.139.064-.215.035-.139.046-.215.023-.145.029-.22a.855.855 0 000-.122v-.1z"
                          transform="translate(5.14 16.808) translate(-89.039 -146.6)"
                          fill="#f7c8a8"
                        />
                      </g>
                      <g data-name="Group 105514">
                        <path
                          data-name="Path 100949"
                          d="M111.579 148.341l-.609 1.746v-3.249a2.174 2.174 0 00.029.226v.017c.012.07.029.139.046.209s.035.122.052.18a.651.651 0 00.029.075c.029.075.058.151.093.226.029.058.052.11.087.168a1.447 1.447 0 00.122.2c.035.052.07.11.1.162a.176.176 0 00.029.041z"
                          transform="translate(5.14 16.808) translate(15.932) translate(-110.97 -146.6)"
                          fill="#f7c8a8"
                        />
                        <path
                          data-name="Path 100950"
                          d="M123.833 156.3v.7h-1.561l-.232-1.387c.191.075.377.157.551.226.157.064.308.128.453.18a7.085 7.085 0 00.789.278z"
                          transform="translate(5.14 16.808) translate(15.932) translate(-115.617 -150.387)"
                          fill="#c4c4c4"
                        />
                      </g>
                    </g>
                    <path
                      data-name="Path 100951"
                      d="M103.062 154.677c-.122-.035-.249-.07-.371-.1a31.71 31.71 0 01-.551-.226 47.258 47.258 0 00-.975-.389A17.414 17.414 0 0198.5 152.7c-.058-.035-.11-.064-.162-.1a12.846 12.846 0 01-.841 1.259 9.387 9.387 0 01-2.686 2.454 1.546 1.546 0 00-.116.07l-.07.035c-.035.017-.07.035-.1.052a.583.583 0 01-.087.041c-.029.017-.058.029-.087.046s-.064.029-.1.046l-.081.035c-.035.017-.07.029-.1.046l-.075.035c-.035.017-.075.029-.11.046s-.052.017-.075.029-.075.029-.11.041-.052.017-.075.023l-.116.035c-.023.006-.052.017-.075.023l-.116.035c-.023.006-.052.017-.075.023s-.075.017-.116.029l-.081.017c-.035.006-.075.017-.116.023a.407.407 0 00-.081.017l-.11.017c-.029 0-.052.012-.081.012a.8.8 0 00-.116.017.392.392 0 00-.081.012.864.864 0 00-.122.012.332.332 0 00-.075.006 1.028 1.028 0 00-.133.006h-.551a.662.662 0 01-.151-.012.383.383 0 01-.081-.006 1.142 1.142 0 01-.139-.017.392.392 0 01-.081-.012 1.166 1.166 0 01-.139-.023.339.339 0 01-.075-.012c-.052-.012-.1-.017-.151-.029a.206.206 0 01-.058-.012c-.145-.035-.29-.07-.429-.116a.082.082 0 01-.035-.012c-.058-.017-.116-.041-.18-.058l-.061-.015c-.052-.017-.1-.041-.157-.058a.606.606 0 00-.058-.023c-.052-.023-.1-.041-.157-.064-.017-.006-.035-.017-.052-.023-.058-.023-.11-.052-.168-.075-.012 0-.023-.012-.035-.017a6.229 6.229 0 01-.609-.337c-.012-.006-.023-.017-.035-.023-.052-.035-.1-.064-.157-.1l-.052-.035a1.72 1.72 0 01-.139-.1 9.823 9.823 0 01-2.147-2.106 12.847 12.847 0 01-.841-1.259 2.84 2.84 0 01-.162.1 16.674 16.674 0 01-2.292 1.114c-.128.052-.255.1-.377.151a49.17 49.17 0 00-1.52.615 5.916 5.916 0 00-.371.1c-3.684 1.044-6.017 3.243-6.017 7.838 0 8.36 7.711 21.484 17.22 21.484s17.22-13.13 17.22-21.484c0-4.6-2.332-6.794-6.016-7.838z"
                      transform="translate(-74.65 -132.311)"
                      fill="#577981"
                    />
                    <path
                      data-name="Path 100952"
                      d="M95.031 118.309c-2.158.145-3.493 1.862-3.423 5.692s1.166 4.288 1.166 4.288a9.271 9.271 0 011.949-6.887c.075.075.928.957 5.268 1.155s5.146 5.987 5.146 5.987c3.469-14.853-10.1-10.234-10.1-10.234z"
                      transform="translate(-81.768 -117.63)"
                      fill="#b58f6c"
                    />
                  </g>
                </g>
                <g
                  data-name="Group 105520"
                  transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(2.847 34.137) translate(94.523 13.106)"
                >
                  <path
                    data-name="Rectangle 55679"
                    fill="#fff"
                    d="M0 0H8.651V48.016H0z"
                  />
                  <g
                    data-name="Group 105519"
                    transform="translate(.65 .586)"
                    fill="#171714"
                  >
                    <path
                      data-name="Rectangle 55680"
                      transform="translate(0 46.67)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55681"
                      transform="translate(0 45.782)"
                      d="M0 0H7.345V0.354H0z"
                    />
                    <path
                      data-name="Rectangle 55682"
                      transform="translate(0 45.248)"
                      d="M0 0H7.345V0.354H0z"
                    />
                    <path
                      data-name="Rectangle 55683"
                      transform="translate(0 44.535)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55684"
                      transform="translate(0 44.181)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55685"
                      transform="translate(0 43.293)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55686"
                      transform="translate(0 42.406)"
                      d="M0 0H7.345V0.534H0z"
                    />
                    <path
                      data-name="Rectangle 55687"
                      transform="translate(0 42.046)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55688"
                      transform="translate(0 41.158)"
                      d="M0 0H7.345V0.174H0z"
                    />
                    <path
                      data-name="Rectangle 55689"
                      transform="translate(0 40.804)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55690"
                      transform="translate(0 39.917)"
                      d="M0 0H7.345V0.708H0z"
                    />
                    <path
                      data-name="Rectangle 55691"
                      transform="translate(0 39.557)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55692"
                      transform="translate(0 38.495)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55693"
                      transform="translate(0 37.602)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55694"
                      transform="translate(0 37.248)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55695"
                      transform="translate(0 36.534)"
                      d="M0 0H7.345V0.534H0z"
                    />
                    <path
                      data-name="Rectangle 55696"
                      transform="translate(0 36)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55697"
                      transform="translate(0 35.293)"
                      d="M0 0H7.345V0.534H0z"
                    />
                    <path
                      data-name="Rectangle 55698"
                      transform="translate(0 34.759)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55699"
                      transform="translate(0 33.871)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55700"
                      transform="translate(0 33.517)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55701"
                      transform="translate(0 32.624)"
                      d="M0 0H7.345V0.534H0z"
                    />
                    <path
                      data-name="Rectangle 55702"
                      transform="translate(0 32.27)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55703"
                      transform="translate(0 31.382)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55704"
                      transform="translate(0 30.982)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55705"
                      transform="translate(0 30.088)"
                      d="M0 0H7.345V0.354H0z"
                    />
                    <path
                      data-name="Rectangle 55706"
                      transform="translate(0 29.555)"
                      d="M0 0H7.345V0.354H0z"
                    />
                    <path
                      data-name="Rectangle 55707"
                      transform="translate(0 28.847)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55708"
                      transform="translate(0 28.493)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55709"
                      transform="translate(0 27.599)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55710"
                      transform="translate(0 26.712)"
                      d="M0 0H7.345V0.534H0z"
                    />
                    <path
                      data-name="Rectangle 55711"
                      transform="translate(0 26.358)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55712"
                      transform="translate(0 25.47)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55713"
                      transform="translate(0 25.11)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55714"
                      transform="translate(0 24.223)"
                      d="M0 0H7.345V0.708H0z"
                    />
                    <path
                      data-name="Rectangle 55715"
                      transform="translate(0 23.869)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55716"
                      transform="translate(0 22.801)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55717"
                      transform="translate(0 21.914)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55718"
                      transform="translate(0 21.554)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55719"
                      transform="translate(0 20.846)"
                      d="M0 0H7.345V0.534H0z"
                    />
                    <path
                      data-name="Rectangle 55720"
                      transform="translate(0 20.312)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55721"
                      transform="translate(0 19.599)"
                      d="M0 0H7.345V0.534H0z"
                    />
                    <path
                      data-name="Rectangle 55722"
                      transform="translate(0 19.071)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55723"
                      transform="translate(0 18.177)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55724"
                      transform="translate(0 17.823)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55725"
                      transform="translate(0 16.936)"
                      d="M0 0H7.345V0.534H0z"
                    />
                    <path
                      data-name="Rectangle 55726"
                      transform="translate(0 16.582)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55727"
                      transform="translate(0 15.688)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55728"
                      transform="translate(0 15.288)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55729"
                      transform="translate(0 14.4)"
                      d="M0 0H7.345V0.354H0z"
                    />
                    <path
                      data-name="Rectangle 55730"
                      transform="translate(0 13.866)"
                      d="M0 0H7.345V0.354H0z"
                    />
                    <path
                      data-name="Rectangle 55731"
                      transform="translate(0 13.153)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55732"
                      transform="translate(0 12.799)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55733"
                      transform="translate(0 11.911)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55734"
                      transform="translate(0 11.023)"
                      d="M0 0H7.345V0.534H0z"
                    />
                    <path
                      data-name="Rectangle 55735"
                      transform="translate(0 10.664)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55736"
                      transform="translate(0 9.776)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55737"
                      transform="translate(0 9.422)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55738"
                      transform="translate(0 8.534)"
                      d="M0 0H7.345V0.714H0z"
                    />
                    <path
                      data-name="Rectangle 55739"
                      transform="translate(0 8.175)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55740"
                      transform="translate(0 7.107)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55741"
                      transform="translate(0 6.22)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55742"
                      transform="translate(0 5.866)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55743"
                      transform="translate(0 5.152)"
                      d="M0 0H7.345V0.534H0z"
                    />
                    <path
                      data-name="Rectangle 55744"
                      transform="translate(0 4.624)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55745"
                      transform="translate(0 3.91)"
                      d="M0 0H7.345V0.534H0z"
                    />
                    <path
                      data-name="Rectangle 55746"
                      transform="translate(0 3.377)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55747"
                      transform="translate(0 2.489)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55748"
                      transform="translate(0 2.135)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path
                      data-name="Rectangle 55749"
                      transform="translate(0 1.242)"
                      d="M0 0H7.345V0.534H0z"
                    />
                    <path
                      data-name="Rectangle 55750"
                      transform="translate(0 .888)"
                      d="M0 0H7.345V0.18H0z"
                    />
                    <path data-name="Rectangle 55751" d="M0 0H7.345V0.18H0z" />
                  </g>
                </g>
                <g
                  data-name="Group 105521"
                  transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(2.847 34.137) translate(37.758 16.181)"
                >
                  <path
                    data-name="Rectangle 55752"
                    transform="translate(.139)"
                    fill="#fff"
                    d="M0 0H43.525V3.725H0z"
                  />
                  <path
                    data-name="Rectangle 55753"
                    transform="translate(.139 6.44)"
                    fill="#565655"
                    d="M0 0H9.956V1.642H0z"
                  />
                  <path
                    data-name="Rectangle 55754"
                    transform="translate(11.749 6.44)"
                    fill="#797979"
                    d="M0 0H23.642V1.642H0z"
                  />
                  <path
                    data-name="Rectangle 55755"
                    transform="translate(.139 23.027)"
                    fill="#565655"
                    d="M0 0H12.544V1.642H0z"
                  />
                  <path
                    data-name="Rectangle 55756"
                    transform="translate(16.512 23.027)"
                    fill="#797979"
                    d="M0 0H23.642V1.642H0z"
                  />
                  <path
                    data-name="Rectangle 55757"
                    transform="translate(0 10.751)"
                    fill="#797979"
                    d="M0 0H44.477V1.642H0z"
                  />
                  <path
                    data-name="Rectangle 55758"
                    transform="translate(0 13.843)"
                    fill="#797979"
                    d="M0 0H46.275V1.642H0z"
                  />
                  <path
                    data-name="Rectangle 55759"
                    transform="translate(0 16.936)"
                    fill="#797979"
                    d="M0 0H40.729V1.642H0z"
                  />
                  <path
                    data-name="Rectangle 55760"
                    transform="translate(0 27.338)"
                    fill="#797979"
                    d="M0 0H38.588V1.642H0z"
                  />
                  <path
                    data-name="Rectangle 55761"
                    transform="translate(0 30.431)"
                    fill="#797979"
                    d="M0 0H33.424V1.642H0z"
                  />
                  <path
                    data-name="Rectangle 55762"
                    transform="translate(0 33.523)"
                    fill="#797979"
                    d="M0 0H42.295V1.642H0z"
                  />
                </g>
                <g
                  data-name="Group 105522"
                  transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(2.847 34.137) translate(67.058 38.89)"
                  opacity={0.5}
                  fill="#ff010b"
                >
                  <circle
                    data-name="Ellipse 129795"
                    cx={6.399}
                    cy={6.399}
                    r={6.399}
                    transform="rotate(-76.65 11.656 5.78)"
                  />
                  <path
                    data-name="Path 100966"
                    d="M200.023 151.57a8.34 8.34 0 108.343 8.337 8.339 8.339 0 00-8.343-8.337zm0 16.17a7.83 7.83 0 117.832-7.832 7.829 7.829 0 01-7.832 7.832z"
                    transform="translate(-188.988 -148.884)"
                  />
                  <path
                    data-name="Path 100967"
                    d="M198.075 146.94a11.029 11.029 0 1011.035 11.023 11.028 11.028 0 00-11.035-11.023zm0 21.38a10.35 10.35 0 1110.356-10.356 10.355 10.355 0 01-10.356 10.356z"
                    transform="translate(-187.04 -146.94)"
                  />
                  <path
                    data-name="Path 100968"
                    d="M190.264 165.222a8.253 8.253 0 00.064 1h-1.021a9.607 9.607 0 01-.046-1 9.243 9.243 0 01.046-.992h1.021a7.991 7.991 0 00-.064.992z"
                    transform="translate(-187.972 -154.199)"
                  />
                  <path
                    data-name="Path 100969"
                    d="M191.634 158.393a8.623 8.623 0 00-.76 1.851l-.934-.383a9.581 9.581 0 01.748-1.851z"
                    transform="translate(-188.257 -151.587)"
                  />
                  <path
                    data-name="Path 100970"
                    d="M191.686 171.989l-.94.4a9.633 9.633 0 01-.766-1.851l.934-.389a8.8 8.8 0 00.777 1.845z"
                    transform="translate(-188.274 -156.684)"
                  />
                  <path
                    data-name="Path 100971"
                    d="M195.151 153.629a8.831 8.831 0 00-1.421 1.41l-.719-.719a9.33 9.33 0 011.421-1.41z"
                    transform="translate(-189.546 -149.446)"
                  />
                  <path
                    data-name="Path 100972"
                    d="M195.155 176.724l-.725.725a10.443 10.443 0 01-1.41-1.41l.719-.719a8.794 8.794 0 001.421 1.4z"
                    transform="translate(-189.551 -158.854)"
                  />
                  <path
                    data-name="Path 100973"
                    d="M200.254 150.808a8.8 8.8 0 00-1.845.777l-.389-.94a9.735 9.735 0 011.845-.766l.389.934z"
                    transform="translate(-191.65 -148.174)"
                  />
                  <path
                    data-name="Path 100974"
                    d="M200.364 179.91l-.383.934a9.733 9.733 0 01-1.851-.748l.383-.946a8.625 8.625 0 001.851.76z"
                    transform="translate(-191.696 -160.462)"
                  />
                  <path
                    data-name="Path 100975"
                    d="M206.337 149.2v1.021a7.926 7.926 0 00-2.007 0V149.2c.331-.029.667-.046 1-.046s.677.019 1.007.046z"
                    transform="translate(-194.299 -147.868)"
                  />
                  <path
                    data-name="Path 100976"
                    d="M206.337 180.91v1.021c-.331.029-.667.046-1 .046s-.673-.023-1-.046v-1.021a7.926 7.926 0 002.007 0z"
                    transform="translate(-194.299 -161.201)"
                  />
                  <path
                    data-name="Path 100977"
                    d="M212.374 150.578l-.389.946a8.457 8.457 0 00-1.845-.76l.383-.934a9.732 9.732 0 011.851.748z"
                    transform="translate(-196.738 -148.153)"
                  />
                  <path
                    data-name="Path 100978"
                    d="M212.5 180.026a9.632 9.632 0 01-1.851.766l-.389-.934a8.8 8.8 0 001.845-.777l.4.94z"
                    transform="translate(-196.788 -160.433)"
                  />
                  <path
                    data-name="Path 100979"
                    d="M217.561 154.32l-.719.719a8.38 8.38 0 00-1.421-1.41l.719-.719a9.892 9.892 0 011.421 1.41z"
                    transform="translate(-198.954 -149.446)"
                  />
                  <path
                    data-name="Path 100980"
                    d="M217.565 176.039a10.443 10.443 0 01-1.41 1.41l-.725-.725a8.794 8.794 0 001.421-1.4l.719.719z"
                    transform="translate(-198.959 -158.854)"
                  />
                  <path
                    data-name="Path 100981"
                    d="M220.912 159.741l-.934.389a8.275 8.275 0 00-.777-1.851l.94-.389a9.634 9.634 0 01.766 1.851z"
                    transform="translate(-200.541 -151.537)"
                  />
                  <path
                    data-name="Path 100982"
                    d="M220.954 170.409a9.594 9.594 0 01-.754 1.851l-.94-.389a8.322 8.322 0 00.754-1.851z"
                    transform="translate(-200.567 -156.629)"
                  />
                  <path
                    data-name="Path 100983"
                    d="M222.1 165.222a9.611 9.611 0 01-.046 1h-1.024a8.25 8.25 0 00.064-1 7.916 7.916 0 00-.064-.992h1.021a9.318 9.318 0 01.049.992z"
                    transform="translate(-201.31 -154.199)"
                  />
                </g>
              </g>
              <path
                data-name="Path 100984"
                d="M229.686 178.06c.052 1.108-1.723 1.358-2.646 1.851a7.19 7.19 0 012.646-1.851c.005.174-.592.279 0 0z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(2.847 34.137) translate(-136.775 -121.115)"
                opacity={0.1}
              />
            </g>
          </g>
          <g data-name="Group 105530">
            <path
              data-name="Path 100990"
              d="M1903.437 1489.381v3.434h9.326v9.326h3.434v-12.761h-12.761zm-100.516 12.761h3.434v-9.326h9.326v-3.434h-12.76v12.76zm109.842 111.166v9.326h-9.326v3.434h12.763v-12.76h-3.434zm-106.408 0h-3.434v12.76h12.76v-3.434h-9.326v-9.326z"
              transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(-1802.869 -1489.38)"
              fill="#f58634"
            />
            <g
              data-name="Group 105529"
              transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(0 44.57)"
              fill="#e7975c"
            >
              <path
                data-name="Rectangle 55764"
                opacity={0.3}
                d="M0 0H113.381V47.549H0z"
              />
              <path
                data-name="Rectangle 55765"
                transform="translate(0 42.205)"
                d="M0 0H113.381V5.344H0z"
              />
            </g>
          </g>
          <g data-name="Group 105537">
            <g
              data-name="Group 105535"
              transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(0 16.36)"
              opacity={0.5}
            >
              <path
                data-name="Path 100991"
                d="M3090.813 2664h30.98a3.465 3.465 0 013.463 3.464v18.375a3.465 3.465 0 01-3.463 3.464h-30.98a1.914 1.914 0 01-1.914-1.914v-21.475a1.914 1.914 0 011.914-1.914z"
                transform="translate(-3088.9 -2664)"
                fill="#c9c9c9"
              />
              <path
                data-name="Rectangle 55766"
                transform="translate(22.5)"
                opacity={0.2}
                d="M0 0H2.025V25.302H0z"
              />
              <path
                data-name="Path 100992"
                d="M3326.51 2664h11.71a1.914 1.914 0 011.914 1.914v21.475a1.915 1.915 0 01-1.914 1.914h-11.71V2664z"
                transform="translate(-3303.776 -2664)"
                fill="#969696"
              />
              <g data-name="Group 105532" transform="translate(5.333 2.452)">
                <path
                  data-name="Rectangle 55767"
                  fill="#bdbdbd"
                  d="M0 0H11.833V8.564H0z"
                />
                <path
                  data-name="Rectangle 55768"
                  transform="translate(.195 .141)"
                  fill="#eee"
                  d="M0 0H11.444V8.282H0z"
                />
                <g
                  data-name="Group 105531"
                  transform="translate(0 11.756)"
                  fill="#ebebeb"
                >
                  <rect
                    data-name="Rectangle 55769"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                  />
                  <rect
                    data-name="Rectangle 55770"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(3.348)"
                  />
                  <rect
                    data-name="Rectangle 55771"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(3.348)"
                  />
                  <rect
                    data-name="Rectangle 55772"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(6.696)"
                  />
                  <rect
                    data-name="Rectangle 55773"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(10.043)"
                  />
                  <rect
                    data-name="Rectangle 55774"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(3.348 2.386)"
                  />
                  <rect
                    data-name="Rectangle 55775"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(6.696 2.386)"
                  />
                  <rect
                    data-name="Rectangle 55776"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(10.043 2.386)"
                  />
                  <rect
                    data-name="Rectangle 55777"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(3.348 4.772)"
                  />
                  <rect
                    data-name="Rectangle 55778"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(6.696 4.772)"
                  />
                  <rect
                    data-name="Rectangle 55779"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(10.043 4.772)"
                  />
                  <rect
                    data-name="Rectangle 55780"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(3.348 7.159)"
                  />
                  <rect
                    data-name="Rectangle 55781"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(6.696 7.159)"
                  />
                  <rect
                    data-name="Rectangle 55782"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(10.043 7.159)"
                  />
                  <rect
                    data-name="Rectangle 55783"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(0 7.159)"
                  />
                  <rect
                    data-name="Rectangle 55784"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(0 4.772)"
                  />
                  <rect
                    data-name="Rectangle 55785"
                    width={1.791}
                    height={1.483}
                    rx={0.742}
                    transform="translate(0 2.386)"
                  />
                </g>
              </g>
              <rect
                data-name="Rectangle 55786"
                width={7.629}
                height={13.702}
                rx={3.815}
                transform="translate(25.731 5.8)"
                fill="#656668"
              />
              <rect
                data-name="Rectangle 55787"
                width={7.318}
                height={13.391}
                rx={2.75}
                transform="translate(25.887 5.956)"
                fill="#a9a9a9"
              />
              <g data-name="Group 105533" opacity={0.2}>
                <path
                  data-name="Path 100993"
                  d="M3366.778 2726.513v4.019h-7.318v-4.019a.264.264 0 01.263-.263h6.792a.264.264 0 01.263.263z"
                  transform="translate(25.887 5.956) translate(-3359.46 -2726.25)"
                />
                <path
                  data-name="Path 100994"
                  d="M3363.937 2821.45v4.281h-4.214a.264.264 0 01-.263-.263v-4.019z"
                  transform="translate(25.887 5.956) translate(-3359.46 -2812.341)"
                  fill="#fff"
                />
                <path
                  data-name="Path 100995"
                  d="M3409.091 2821.45v4.019a.264.264 0 01-.263.263h-2.579v-4.281z"
                  transform="translate(25.887 5.956) translate(-3401.773 -2812.341)"
                />
              </g>
              <g data-name="Group 105534" fill="#8f8f8f">
                <path
                  data-name="Path 100996"
                  d="M3361.09 2731.967v-3.976a.109.109 0 01.107-.111h6.792a.109.109 0 01.107.111v3.976z"
                  transform="translate(26.043 6.112) translate(-3361.09 -2727.88)"
                />
                <path
                  data-name="Path 100997"
                  d="M3361.2 2825.206a.11.11 0 01-.107-.113v-4.053h7.006v4.053a.11.11 0 01-.107.113z"
                  transform="translate(26.043 6.112) translate(-3361.09 -2812.127)"
                />
              </g>
              <path
                data-name="Path 100998"
                d="M3384.479 2779.118h-2.846a.126.126 0 01-.126-.134l.241-3.8a.127.127 0 01.126-.119h2.363a.127.127 0 01.126.119l.241 3.8a.126.126 0 01-.125.134z"
                transform="translate(-3353.511 -2764.443)"
                opacity={0.1}
              />
              <path
                data-name="Path 100999"
                d="M3382.378 2779.639l.23-3.64a.126.126 0 01.126-.119h2.217a.126.126 0 01.126.119l.23 3.64a.126.126 0 01-.126.134h-2.681a.126.126 0 01-.126-.134z"
                transform="translate(-3354.298 -2765.175)"
                fill="#007965"
              />
            </g>
            <g data-name="Group 105536">
              <path
                data-name="Path 101000"
                d="M3618.478 3554.854l.5 5.9-3.009 1.108-2.26-2.315.948-4.949z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3590.821 -3453.029)"
                fill="#db965f"
              />
              <path
                data-name="Path 101001"
                d="M3532.872 3582.251s-.255-1.532-.781-1.782c0 0-6.947 2.019-7.949 2.713 0 0-2.647 1.217-.02 2.872a6.2 6.2 0 002.694.91l5.138.509s6.563.568 5.39-3.074l-.617-2.408s-2.196 2.999-3.855.26z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3508.754 -3476.423)"
                fill="#040c2b"
              />
              <path
                data-name="Path 101002"
                d="M3744.819 3470.04l2.654 4.264-4.461 3.308-.841-1.119-.781-6.022z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3706.285 -3376.559)"
                fill="#db965f"
              />
              <path
                data-name="Path 101003"
                d="M3741.409 3498.813s.531 1.15-.69 4.063a4.789 4.789 0 00-.715 2.365 7.884 7.884 0 01-4.882 5.028 1.6 1.6 0 01-1.906-.7 4.389 4.389 0 01-.178-3.114 70.971 70.971 0 001.171-7.453s2.352 1.589 4.651-1.779c0 0 1.116-.767 2.549 1.59z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3698.57 -3401.033)"
                fill="#040c2b"
              />
              <path
                data-name="Path 101004"
                d="M3605.649 2990.876l6.749 7.428 4.295 4.727 3.939-2.917-8.655-13.31a3.575 3.575 0 01-.269-3.4l6.918-15.535a21.284 21.284 0 000-17.636l-13.746 1.068.445 2.59 1.965 11.432-3.923 16.747a9.785 9.785 0 002.285 8.811z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3581.231 -2906.483)"
                fill="#040c2b"
              />
              <path
                data-name="Path 101005"
                d="M3605.649 3025.458l6.749 7.428-3.009-12.865 4.384-31.057-8.452-.494 1.965 11.432-3.923 16.747a9.785 9.785 0 002.285 8.811z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3581.231 -2941.065)"
                opacity={0.15}
              />
              <path
                data-name="Path 101006"
                d="M3553.319 2987.476l2.6 15.767 3.172 22.116 4-.31 1.167-.09-.918-22.524 4.035-34.347-12.341-.857a63.728 63.728 0 00-1.715 20.245z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3536.006 -2921.857)"
                fill="#040c2b"
              />
              <path
                data-name="Path 101007"
                d="M3638.78 2614l.989 4.754 2.9.065 5.376.121 2.161-2.531a4.368 4.368 0 01-.747-1.97 22.892 22.892 0 01-.328-2.691c-.2-2.807-.1-5.773-.1-5.773l-7.533 2.408a8.5 8.5 0 01-2.716 5.619z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3613.492 -2595.162)"
                fill="#c9885b"
              />
              <path
                data-name="Path 101008"
                d="M3644.041 2502.99s-.7 10.177-8.439 9.548a1.577 1.577 0 01-.9-.38c-1.087-.941-3.592-3.992-.646-10.525 0 0 7.129-9.089 9.987 1.358z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3607.967 -2497.493)"
                fill="#db965f"
              />
              <path
                data-name="Path 101009"
                d="M3588.44 2691.035v10.476h.371l.394-10.73z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3567.969 -2671.857)"
                fill="#262c84"
              />
              <path
                data-name="Path 101010"
                d="M3538.75 2795.763l2.7 1.386 1.378.71.248.127-.034-.68-.052-1.037-.122-2.494-.383-7.737-.12-2.407-2.439-.711-.894 9.791-.178 1.942z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3523.033 -2755.181)"
                fill="#db965f"
              />
              <path
                data-name="Path 101011"
                d="M3374.715 2810.016a2.615 2.615 0 003.034 1.223l11.89 7.832a2.84 2.84 0 004.208-1.345l.428-1.1.214-.553.342-.883-.394-.154-1.294-.506-2.842-1.11-6.554-2.562a13.98 13.98 0 01-3-2.332 6.087 6.087 0 01-.976-1.251 14.431 14.431 0 00-1.95-2.5 18.027 18.027 0 00-1.134-1.1.887.887 0 00-.064 1.2l1.212 1.479-.477-.076a2.454 2.454 0 00-2.791 1.852 3.017 3.017 0 00.145 1.894z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3374.483 -2773.946)"
                fill="#db965f"
              />
              <path
                data-name="Path 101012"
                d="M3507.761 2713.108l3.243.9 2.97.824.865.24.27.074.345.036-.3-8.349-.4-10.943a6.272 6.272 0 00-3.784 4.808l-3.211 12.41z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3495.009 -2676.479)"
                fill="#fff"
              />
              <path
                data-name="Path 101013"
                d="M3559.27 2802.692q.14-.713.248-1.386c.128-.787.229-1.53.306-2.229a41.322 41.322 0 00.425-5.52l.247-1.42.433-3.087c-.018 1.62-.283 6.493-.233 10.269h-.006l.008.156.116 2.339.394.154-.343.883.033.68-.248-.127-.428 1.1a2.82 2.82 0 01-1.761 1.671c.332-1.226.6-2.389.81-3.483z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3540.858 -2760.725)"
                opacity={0.15}
              />
              <path
                data-name="Path 101014"
                d="M3577.814 2897.883c1.578 1.285 5.8 1.218 5.8 1.218l10.42 1.538 3.3.488.36.053a2.84 2.84 0 003.246-3l-.078-1.181-.039-.591-.063-.944-.422.027-1.387.088-1.924.123-1.12.072-2.256.144-4.767.3a14.016 14.016 0 01-3.7-.849 6.147 6.147 0 01-1.413-.722 14.407 14.407 0 00-2.823-1.442c-.857-.337-1.495-.521-1.495-.521a.888.888 0 00.448 1.112l1.724.829-1.839-.179a3.161 3.161 0 00-1.8.351c-2.06 1.113-.169 3.083-.169 3.083z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3557.642 -2854.449)"
                fill="#db965f"
              />
              <path
                data-name="Path 101015"
                d="M3783.62 2766.79l.8 14.942-4.137.926-.186-9.879z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3741.292 -2740.595)"
                fill="#db965f"
              />
              <path
                data-name="Path 101016"
                d="M3776.622 2724.694l.165 4.672.206.021 8.953-3.025-3.767-10.374c-1.366-4.73-2.823-6.15-3.225-6.468a30.683 30.683 0 00-2.332 15.174z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3737.998 -2688.804)"
                fill="#fff"
              />
              <path
                data-name="Path 101017"
                d="M3742.03 2798.54l.847 10.582.377 4.721 3.306.487-.307-5.423-.692-12.2z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3706.864 -2767.652)"
                opacity={0.15}
              />
              <path
                data-name="Path 101018"
                d="M3582.026 2703.512l.043 1.22-.047-.005c0 1.977.058 3.8.137 5.406.12 2.445.7 4.654.579 5.827l-21.6-.449c.213-2.245.6-4.661.983-6.7.482-2.594.946-4.579 1.005-4.833a.216.216 0 00.006-.056l-.015-1-.015-3.323c-.037-2.831-.03-3.223-.019-3.925a17.5 17.5 0 01.13-1.878l.143-1.146-.311-8.6-.017-.47a6.302 6.302 0 01.6-.194l.124-.041.764-.254 4.649-.813a27.978 27.978 0 013.709.474c1.691.288 2.357 2.23 4.949-.1l.005-.006 4.389 1.506.834.286 1.075.368a1.069 1.069 0 01.109.077 30.048 30.048 0 00-1.909 6.175 30.378 30.378 0 00-.554 7.282l.253 5.168z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3543.281 -2664.171)"
                fill="#fff"
              />
              <path
                data-name="Path 101019"
                d="M3653.3 2493.041s3.153-.15 5.265 5a15.683 15.683 0 011.137 5.289c.208 4.955-.421 16.181-11.373 9.047 0 0 3.9-2.885 2.762-9.708 0 0-3.5-2.238-2.6-4.183 0 0 .316-6 4.814-5.446z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3622.128 -2493.005)"
              />
              <path
                data-name="Path 101020"
                d="M3667.182 2585.043c-.166.705.072 1.364.529 1.471s.962-.378 1.128-1.083-.072-1.365-.529-1.471-.963.378-1.128 1.083z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3639.129 -2575.244)"
                fill="#db965f"
              />
              <path
                data-name="Path 101021"
                d="M3639.761 2500.5s-.236-.394-1.341-2.762c0 0 1.973-4.815 5.682-4.5 3.149.269-4.341 7.262-4.341 7.262z"
                transform="translate(-307.519 -295.001) translate(451.458 409.277) translate(123.091 96.025) translate(27.324) translate(-3613.167 -2493.203)"
              />
            </g>
          </g>
        </g>
        <g data-name="Group 105556">
          <g
            data-name="Group 105540"
            transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(41.346 242.57)"
          >
            <rect
              data-name="Rectangle 55788"
              width={26.801}
              height={24.368}
              rx={12.184}
              transform="translate(0 .547)"
              fill="#addcd4"
            />
            <g data-name="Group 105539" fill="#fff">
              <path
                data-name="Path 101022"
                d="M1177.07 3363.19l-.068 1.247v.025l.572.2a3.856 3.856 0 01-.458 1.041l-.01.017-.22-.108-.363-.178-.749 1 .266.377a3.445 3.445 0 01-1.023.463l-.12-.587-1.2-.024-.182.665a3.384 3.384 0 01-1.125-.434l.349-.588-.82-.928-.669.4h-.006a2.989 2.989 0 01-.047-.073 3.86 3.86 0 01-.53-1.39l.589-.131.067-1.272-.608-.189a3.872 3.872 0 01.54-1.252l.624.373.842-.914-.334-.562a3.419 3.419 0 011.434-.493l.133.756 1.2.06.189-.627a3.023 3.023 0 011.083.646l-.386.566.8.979.518-.286a3.893 3.893 0 01.317 1.1l-.615.119zm-2.85-1.954a2.156 2.156 0 00-1.25.368 2.291 2.291 0 00-.358.3 2.488 2.488 0 00-.075 3.374 2.164 2.164 0 003.185.064 2.488 2.488 0 00.075-3.374 2.076 2.076 0 00-.131-.134 2.162 2.162 0 00-1.446-.6z"
                transform="translate(4.776 4.367) translate(-1159.987 -3351.134)"
              />
              <path
                data-name="Path 101023"
                d="M1160.578 3272.353l-.075 1.463v.029h.007l.625.229a4.75 4.75 0 01-.5 1.222l-.011.02-.241-.126-.4-.208-.821 1.175.29.441a3.673 3.673 0 01-1.118.544l-.129-.688-1.315-.027-.2.78a3.564 3.564 0 01-1.229-.507l.383-.691-.895-1.088-.732.475h-.007c-.017-.029-.035-.057-.051-.086a4.721 4.721 0 01-.577-1.63l.644-.155.076-1.493-.664-.222a4.732 4.732 0 01.592-1.471l.681.437.922-1.072-.364-.659a3.564 3.564 0 011.57-.58l.144.887 1.314.068.208-.736c.119-.053.835.429 1.183.756l-.424.665.878 1.147.567-.336a4.781 4.781 0 01.344 1.288l-.673.142zm-3.112-2.287a2.243 2.243 0 00-1.367.434 2.661 2.661 0 00-.392.349 3.075 3.075 0 00-.088 3.958 2.26 2.26 0 003.483.071 3.075 3.075 0 00.088-3.958 2.678 2.678 0 00-.144-.157 2.274 2.274 0 00-1.58-.697z"
                transform="translate(4.776 4.367) translate(-1144.532 -3268.47)"
              />
              <path
                data-name="Path 101024"
                d="M1068.632 3314.414l-.1 2.015v.04h.01l.859.315a6.511 6.511 0 01-.691 1.682l-.016.028-.331-.174-.545-.286-1.128 1.618.4.607a5.045 5.045 0 01-1.538.75l-.178-.948-1.808-.036-.275 1.074a4.887 4.887 0 01-1.691-.7l.526-.951-1.23-1.5-1.007.654-.009.006a4.58 4.58 0 01-.07-.118 6.5 6.5 0 01-.793-2.245l.885-.212.1-2.055-.913-.305a6.518 6.518 0 01.815-2.025l.938.6 1.269-1.477-.5-.907a4.9 4.9 0 012.158-.8l.2 1.221 1.806.094.286-1.013c.164-.073 1.148.592 1.626 1.04l-.583.916 1.207 1.58.779-.463a6.609 6.609 0 01.474 1.774l-.925.2zm-4.28-3.15a3.079 3.079 0 00-1.88.6 3.538 3.538 0 00-.54.481 4.24 4.24 0 00-.12 5.45 3.1 3.1 0 004.789.1 4.241 4.241 0 00.12-5.45 2.72 2.72 0 00-.2-.216 3.122 3.122 0 00-2.168-.964z"
                transform="translate(4.776 4.367) translate(-1059.01 -3305.186)"
              />
            </g>
          </g>
          <g data-name="Group 105542">
            <path
              data-name="Path 101025"
              d="M980.407 1948.917h-19.114a3.843 3.843 0 01-3.843-3.843v-16.681a3.843 3.843 0 013.843-3.843h19.114a3.843 3.843 0 013.843 3.843v16.681a3.843 3.843 0 01-3.843 3.843z"
              transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(36.405 118.354) translate(-957.45 -1924.55)"
              fill="#addcd4"
            />
            <g data-name="Group 105541">
              <path
                data-name="Path 101026"
                d="M1034.846 2030.792v8.3a1.583 1.583 0 01-1.622 1.541h-11.583a1.583 1.583 0 01-1.622-1.541v-8.3a1.583 1.583 0 011.622-1.541h11.583a1.583 1.583 0 011.622 1.541z"
                transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(36.405 118.354) translate(5.987 2.968) translate(-1020.02 -2022.201)"
                fill="#fff"
              />
              <path
                data-name="Path 101027"
                d="M1056.227 1957.065a4.533 4.533 0 00-3.337-1.5 4.925 4.925 0 00-4.72 5.106v1.943h1.036v-1.943a3.7 3.7 0 117.367 0v1.943h1.036v-1.943a5.307 5.307 0 00-1.382-3.606z"
                transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(36.405 118.354) translate(5.987 2.968) translate(-1045.477 -1955.57)"
                fill="#fff"
              />
              <path
                data-name="Path 101028"
                d="M1088.257 2056.063a1.1 1.1 0 10-2.187 0 1.207 1.207 0 00.529 1.014v1.965a.094.094 0 00.09.1h.107a.082.082 0 01.078.085v.228a.082.082 0 01-.078.085h-.158a.042.042 0 00-.04.043v.088a.042.042 0 00.04.043h.066a.083.083 0 01.078.085v.228a.082.082 0 01-.078.085h-.067a.04.04 0 00-.038.042v.092a.039.039 0 00.038.041h.16a.082.082 0 01.078.085v.228a.082.082 0 01-.078.085h-.107a.094.094 0 00-.09.1.554.554 0 00.5.575.539.539 0 00.536-.56v-3.666a1.2 1.2 0 00.622-1.068z"
                transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(36.405 118.354) translate(5.987 2.968) translate(-1079.75 -2045.378)"
                fill="#dee4fc"
              />
            </g>
          </g>
          <g data-name="Group 105544">
            <path
              data-name="Path 101029"
              d="M3711.407 1270.917h-19.114a3.843 3.843 0 01-3.844-3.843v-16.68a3.843 3.843 0 013.844-3.843h19.114a3.843 3.843 0 013.843 3.843v16.68a3.843 3.843 0 01-3.843 3.843z"
              transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(297.702 53.484) translate(-3688.45 -1246.55)"
              fill="#addcd4"
            />
            <g
              data-name="Group 105543"
              transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(297.702 53.484) translate(6.033 3.369)"
              fill="#fff"
            >
              <path
                data-name="Path 101030"
                d="M3751.674 1333.381c-1.023-3.719 2.722-9.41 7.2-9.411s8.22 5.705 7.2 9.411c-.835 3.024-4.678 4.118-6.969 4.177-2.574.067-6.578-1.076-7.431-4.177z"
                transform="translate(-3751.504 -1319.931)"
              />
              <ellipse
                data-name="Ellipse 129796"
                cx={3.485}
                cy={3.978}
                rx={3.485}
                ry={3.978}
                transform="translate(3.896)"
                stroke="#e3e9f7"
                strokeWidth={1}
              />
            </g>
          </g>
          <g data-name="Group 105546">
            <path
              data-name="Path 101031"
              d="M3035.907 711.917h-19.113a3.844 3.844 0 01-3.844-3.843v-16.681a3.844 3.844 0 013.844-3.843h19.113a3.844 3.844 0 013.844 3.843v16.681a3.843 3.843 0 01-3.844 3.843z"
              transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(233.071) translate(-3012.95 -687.55)"
              fill="#addcd4"
            />
            <g
              data-name="Group 105545"
              transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(233.071) translate(6.135 2.67)"
              fill="#fff"
            >
              <path
                data-name="Path 101032"
                d="M3106.018 752.646a.373.373 0 01-.216-.07l-10.122-7.237 10.119-7.351a.372.372 0 11.437.6l-9.285 6.744 9.282 6.636a.372.372 0 01-.217.674z"
                transform="translate(-3093.9 -735.768)"
              />
              <circle
                data-name="Ellipse 129797"
                cx={2.083}
                cy={2.083}
                r={2.083}
                transform="rotate(-14 8.902 -38.569)"
              />
              <circle
                data-name="Ellipse 129798"
                cx={2.083}
                cy={2.083}
                r={2.083}
                transform="rotate(-22.19 43.852 -16.297)"
              />
              <circle
                data-name="Ellipse 129799"
                cx={2.083}
                cy={2.083}
                r={2.083}
                transform="rotate(-80.85 6.635 5.652)"
              />
            </g>
          </g>
          <g data-name="Group 105547">
            <path
              data-name="Path 101033"
              d="M599.907 2405.917h-19.114a3.843 3.843 0 01-3.843-3.843v-16.681a3.843 3.843 0 013.843-3.843h19.114a3.843 3.843 0 013.843 3.843v16.681a3.843 3.843 0 01-3.843 3.843z"
              transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(0 162.078) translate(-576.95 -2381.55)"
              fill="#addcd4"
            />
            <path
              data-name="Path 101034"
              d="M643.41 2429.538l-7.011-7.177a6.729 6.729 0 00.609-2.821c0-3.341-2.363-6.05-5.279-6.05s-5.279 2.709-5.279 6.05 2.363 6.05 5.279 6.05a4.845 4.845 0 003.254-1.287l6.957 7.122a1.009 1.009 0 001.559-.1 1.4 1.4 0 00-.089-1.787zm-11.682-5.049c-2.381 0-4.319-2.221-4.319-4.95s1.937-4.95 4.319-4.95 4.319 2.221 4.319 4.95-1.938 4.95-4.319 4.95z"
              transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(0 162.078) translate(-621.714 -2410.434)"
              fill="#fff"
            />
            <path
              data-name="Path 101035"
              d="M642.886 2454.129a.226.226 0 01-.2-.112 5.263 5.263 0 010-4.842.226.226 0 01.4.214 4.892 4.892 0 000 4.4.226.226 0 01-.2.34z"
              transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(0 162.078) translate(-635.848 -2442.597)"
              fill="#fff"
            />
          </g>
          <g data-name="Group 105552">
            <path
              data-name="Path 101036"
              d="M4257.907 1858.917h-19.114a3.843 3.843 0 01-3.843-3.843v-16.681a3.843 3.843 0 013.843-3.843h19.114a3.843 3.843 0 013.843 3.843v16.681a3.843 3.843 0 01-3.843 3.843z"
              transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(349.99 109.743) translate(-4234.95 -1834.55)"
              fill="#addcd4"
            />
            <g
              data-name="Group 105551"
              transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(349.99 109.743) translate(6.917 3.053)"
            >
              <path
                data-name="Rectangle 55789"
                fill="#fff"
                d="M0 0H12.964V18.261H0z"
              />
              <g data-name="Group 105550" fill="#dee4fc">
                <g data-name="Group 105548">
                  <path
                    data-name="Path 101037"
                    d="M4328.79 1978.765h-9.968a.392.392 0 01-.392-.392.392.392 0 01.392-.392h9.968a.392.392 0 01.392.392.392.392 0 01-.392.392z"
                    transform="translate(1.07 2.864) translate(0 7.806) translate(-4318.43 -1977.98)"
                  />
                  <path
                    data-name="Path 101038"
                    d="M4328.95 1999.375h-9.968a.392.392 0 01-.393-.392.392.392 0 01.393-.392h9.968a.392.392 0 01.392.392.392.392 0 01-.392.392z"
                    transform="translate(1.07 2.864) translate(0 7.806) translate(-4318.574 -1996.618)"
                  />
                  <path
                    data-name="Path 101039"
                    d="M4329.109 2019.975h-9.968a.392.392 0 01-.392-.392.392.392 0 01.392-.392h9.968a.393.393 0 01.393.392.392.392 0 01-.393.392z"
                    transform="translate(1.07 2.864) translate(0 7.806) translate(-4318.719 -2015.247)"
                  />
                </g>
                <g data-name="Group 105549">
                  <path
                    data-name="Path 101040"
                    d="M4325.682 1897.175h-6.58a.392.392 0 01-.392-.392.392.392 0 01.392-.392h6.58a.392.392 0 01.392.392.392.392 0 01-.392.392z"
                    transform="translate(1.07 2.864) translate(.027) translate(-4318.71 -1896.39)"
                  />
                  <path
                    data-name="Path 101041"
                    d="M4329.229 1917.785h-9.968a.392.392 0 01-.392-.392.392.392 0 01.392-.392h9.968a.392.392 0 01.393.392.392.392 0 01-.393.392z"
                    transform="translate(1.07 2.864) translate(.027) translate(-4318.854 -1915.028)"
                  />
                  <path
                    data-name="Path 101042"
                    d="M4329.39 1938.395h-9.968a.392.392 0 01-.392-.392.392.392 0 01.392-.392h9.968a.392.392 0 01.393.392.392.392 0 01-.393.392z"
                    transform="translate(1.07 2.864) translate(.027) translate(-4319 -1933.666)"
                  />
                  <path
                    data-name="Path 101043"
                    d="M4329.55 1959h-9.968a.392.392 0 01-.392-.392.392.392 0 01.392-.392h9.968a.392.392 0 01.393.392.392.392 0 01-.393.392z"
                    transform="translate(1.07 2.864) translate(.027) translate(-4319.144 -1952.304)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g data-name="Group 105555">
            <path
              data-name="Path 101044"
              d="M724.907 2836.917h-19.114a3.843 3.843 0 01-3.843-3.843v-16.68a3.844 3.844 0 013.843-3.844h19.114a3.844 3.844 0 013.843 3.844v16.68a3.843 3.843 0 01-3.843 3.843z"
              transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(11.96 203.315) translate(-701.95 -2812.55)"
              fill="#addcd4"
            />
            <g
              data-name="Group 105554"
              transform="translate(-307.519 -295.001) translate(334.211 332.559) translate(11.96 203.315) translate(3.684 2.857)"
              fill="#fff"
            >
              <g data-name="Group 105553">
                <path
                  data-name="Path 101045"
                  d="M758.778 2849.764a1.11 1.11 0 01-.926-.495c-1.968-2.944-4.768-4.633-7.682-4.633s-5.706 1.684-7.673 4.619a1.113 1.113 0 01-1.849-1.239c2.387-3.563 5.858-5.607 9.523-5.607s7.145 2.049 9.533 5.622a1.114 1.114 0 01-.925 1.732z"
                  transform="translate(-740.458 -2842.41)"
                />
                <path
                  data-name="Path 101046"
                  d="M779.038 2892.3a1.109 1.109 0 01-.926-.495 5.954 5.954 0 00-10.556-.009 1.113 1.113 0 01-1.849-1.239 8.161 8.161 0 0114.257.011 1.113 1.113 0 01-.924 1.732z"
                  transform="translate(-763.12 -2882.173)"
                />
                <path
                  data-name="Path 101047"
                  d="M799.3 2934.845a1.115 1.115 0 01-.927-.495 3.224 3.224 0 00-5.757 0 1.113 1.113 0 11-1.849-1.239 5.431 5.431 0 019.458.008 1.113 1.113 0 01-.924 1.732z"
                  transform="translate(-785.783 -2921.936)"
                />
              </g>
              <ellipse
                data-name="Ellipse 129800"
                cx={1.871}
                cy={2.461}
                rx={1.871}
                ry={2.461}
                transform="translate(7.84 13.732)"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
export function NoAppointments(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 150.711,
    height: 128.435,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150.711 128.435"
      sx={rootSx}
      {...rest}
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Path 97951"
            d="M51.79 331.494a353.039 353.039 0 0012.388-53.963l86.734-.382s-7.677 37.949-16.926 56.164c0 0-10.082-.65-23.036-.8-21.95-.253-51.418-.56-59.16-1.027z"
            transform="translate(-51.79 -277.15)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g data-name="no appointments">
        <path
          data-name="Path 20625"
          d="M209.837 156.559c.355-2.034.924-4.045 1.332-6.116a36.154 36.154 0 00.17-12.112 47.577 47.577 0 00-8.928-21.259c-4.973-6.672-12.451-12.072-20.488-10.034-8.362 2.113-15.44 8.562-23.571 11.5-13.772 4.981-27.715-4.1-41.593-3.773-11.984.26-24.556 4.562-32.45 15.2-3.222 4.343-5.467 10.188-4.705 15.938.932 7.007 6.075 12.339 9.909 17.523 5.879 7.946 8.1 16.6 3.158 25.877-3.343 6.286-7.841 11.84-7.452 19.647.623 12.489 12.154 20.032 21.662 23.394 9.66 3.419 20.628 3.773 30.231-.075 8.531-3.434 14.486-10.942 22.262-15.734a35.19 35.19 0 0122.832-5.011c8.218.981 16.878 2.709 24.82-.834 7.6-3.4 11.2-12.471 11.482-21.168a34.77 34.77 0 00-1.928-12.769c-1.762-4.928-5.66-8.773-6.758-14a16.225 16.225 0 01.015-6.2z"
          transform="translate(-59.069 -186.779) translate(59.069 186.779) translate(-79.454 -106.601)"
          fill="#c5e8e2"
        />
        <path
          data-name="Path 20626"
          d="M209.837 156.559c.355-2.034.924-4.045 1.332-6.116a36.154 36.154 0 00.17-12.112 47.577 47.577 0 00-8.928-21.259c-4.973-6.672-12.451-12.072-20.488-10.034-8.362 2.113-15.44 8.562-23.571 11.5-13.772 4.981-27.715-4.1-41.593-3.773-11.984.26-24.556 4.562-32.45 15.2-3.222 4.343-5.467 10.188-4.705 15.938.932 7.007 6.075 12.339 9.909 17.523 5.879 7.946 8.1 16.6 3.158 25.877-3.343 6.286-7.841 11.84-7.452 19.647.623 12.489 12.154 20.032 21.662 23.394 9.66 3.419 20.628 3.773 30.231-.075 8.531-3.434 14.486-10.942 22.262-15.734a35.19 35.19 0 0122.832-5.011c8.218.981 16.878 2.709 24.82-.834 7.6-3.4 11.2-12.471 11.482-21.168a34.77 34.77 0 00-1.928-12.769c-1.762-4.928-5.66-8.773-6.758-14a16.225 16.225 0 01.015-6.2z"
          transform="translate(-59.069 -186.779) translate(59.069 186.779) translate(-79.454 -106.601)"
          fill="#fff"
          opacity={0.7}
        />
        <g>
          <g
            data-name="Group 105498"
            transform="translate(-59.069 -186.779) translate(33.49 202.815)"
          >
            <g data-name="Group 105495" transform="translate(35.707 10.908)">
              <path
                data-name="Path 97936"
                d="M259.92 327.63H266a2.268 2.268 0 001.914-2.5v-94.5h-3.764z"
                transform="translate(-147.626 -227.744)"
                fill="#d1e3f2"
              />
              <path
                data-name="Path 97937"
                d="M259.92 327.63H266a2.268 2.268 0 001.914-2.5v-94.5h-3.764z"
                transform="translate(-147.626 -227.744)"
                fill="#b7cbcb"
              />
              <path
                data-name="Path 97938"
                d="M72.185 336.162l-1.165 6.983h93.68s.962-12.294 2.966-33.813 3.491-47.922 3.491-47.922L72.18 336.162z"
                transform="translate(-52.408 -243.259)"
                fill="#d1e3f2"
              />
              <path
                data-name="Path 97939"
                d="M72.185 336.162l-1.165 6.983h93.68s.962-12.294 2.966-33.813 3.491-47.922 3.491-47.922L72.18 336.162z"
                transform="translate(-52.408 -243.259)"
                fill="#b3d5ce"
              />
              <path
                data-name="Path 97940"
                d="M39.955 314.765s-3.839 9-4.885 10.132c0 0 23.413.114 26.785 0s27.574.8 29.667.8 35.018 1.215 42.695-.759c0 0 18.836-47 20.348-90.007H58.89z"
                transform="translate(-34.286 -229.911)"
                fill="#d1e3f2"
              />
              <path
                data-name="Path 97941"
                d="M39.955 314.765s-3.839 9-4.885 10.132c0 0 23.413.114 26.785 0s27.574.8 29.667.8 35.018 1.215 42.695-.759c0 0 18.836-47 20.348-90.007H58.89z"
                transform="translate(-34.286 -229.911)"
                fill="#c3e4de"
              />
              <path
                data-name="Path 97942"
                d="M66.8 242.421l3.025-17.611h100.739l-3.189 17.611z"
                transform="translate(-50.28 -224.81)"
                fill="#c0dcd7"
              />
              <path
                data-name="Path 97958"
                d="M78.878 96.157s18.032.164 21.057-1.131c0 0 9.824-27.39 12.954-41.44"
                fill="#c3e4de"
                stroke="#a7ccc5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.12}
              />
              <path
                data-name="Path 97943"
                d="M50.01 260.32s-12.681 60.643-16.52 69.3c0 0 74.693 3.873 97.029 2.276 0 0 15.691-36.595 20.07-71.573H50.01z"
                transform="translate(-33.49 -242.709)"
                fill="#c9e7e1"
              />
              <path
                data-name="Path 97944"
                d="M51.79 331.494a353.039 353.039 0 0012.388-53.963l86.734-.382s-7.677 37.949-16.926 56.164c0 0-10.082-.65-23.036-.8-21.95-.253-51.418-.56-59.16-1.027z"
                transform="translate(-42.714 -251.193)"
                fill="#fff"
              />
              <g
                data-name="Group 105494"
                transform="translate(9.076 25.957)"
                clipPath="url(#a)"
              >
                <g
                  data-name="Group 105493"
                  fill="none"
                  stroke="#ccd4db"
                  strokeWidth={1.79}
                >
                  <path
                    data-name="Path 97945"
                    d="M4.711 16.514s69.336-1.989 91.678 1.4"
                    transform="translate(2.733 -1.562)"
                  />
                  <path
                    data-name="Path 97946"
                    d="M0 38.494s69.336-1.989 91.678 1.4"
                    transform="translate(2.733 -1.562)"
                  />
                  <path
                    data-name="Path 97947"
                    d="M26.845.005s-2.881 22.654-13.7 59.314"
                    transform="translate(2.733 -1.562)"
                  />
                  <path
                    data-name="Path 97948"
                    d="M42.854.005s-2.881 22.654-13.7 59.314"
                    transform="translate(2.733 -1.562)"
                  />
                  <path
                    data-name="Path 97949"
                    d="M61.359.005s-2.881 22.654-13.7 59.314"
                    transform="translate(2.733 -1.562)"
                  />
                  <path
                    data-name="Path 97950"
                    d="M78.616 0s-2.549 22.724-12.84 59.641"
                    transform="translate(2.733 -1.562)"
                  />
                </g>
              </g>
              <path
                data-name="Path 97955"
                d="M40.716 30.816l2.852 4.171 8.958-11.991"
                fill="none"
                stroke="#91bac6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.23}
              />
              <path
                data-name="Path 97956"
                d="M57.93 31.134l2.981 4.017 8.57-12.468"
                fill="none"
                stroke="#91bac6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.23}
              />
              <path
                data-name="Path 97957"
                d="M76.785 31.348l3.5 3.64 9.239-10.811"
                fill="none"
                stroke="#91bac6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.23}
              />
              <path
                data-name="Line 1564"
                transform="translate(89.521 47.208)"
                fill="none"
                stroke="#91bac6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.23}
                d="M0 0L6.69 10.325"
              />
              <path
                data-name="Line 1565"
                transform="translate(87.488 47.664)"
                fill="none"
                stroke="#91bac6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.23}
                d="M9.363 0L0 9.259"
              />
              <path
                data-name="Line 1566"
                transform="translate(49.911 67.705)"
                fill="none"
                stroke="#91bac6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.23}
                d="M0 0L5.059 8.5"
              />
              <path
                data-name="Line 1567"
                transform="translate(46.623 66.301)"
                fill="none"
                stroke="#91bac6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.23}
                d="M12.795 0L0 11.382"
              />
              <path
                data-name="Path 97959"
                d="M99.851 82.125s11.089-29.771 14.035-46.147"
                fill="#c9e7e1"
                stroke="#a7ccc5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.12}
              />
              <path
                data-name="Path 97960"
                d="M112.597 96.166s3.67-38.871 4.5-50.585"
                fill="#c9e7e1"
                stroke="#a7ccc5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.12}
              />
              <path
                data-name="Path 97961"
                d="M116.872 98.746s2.053-68.88 2.1-72.352"
                fill="#c9e7e1"
                stroke="#a7ccc5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.12}
              />
              <path
                data-name="Line 1568"
                transform="translate(82.598 99.886)"
                fill="none"
                stroke="#91bac6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.12}
                d="M0 0L32.251 0"
              />
              <path
                data-name="Line 1569"
                transform="translate(69.689 99.886)"
                fill="none"
                stroke="#91bac6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.12}
                d="M0 0L6.978 0"
              />
            </g>
            <path
              data-name="Line 1570"
              transform="translate(33.705 111.208)"
              fill="none"
              stroke="#adc0c9"
              strokeWidth={1.73}
              d="M0 0L139 0"
            />
            <g data-name="Group 105497" transform="translate(124.814 -6.039)">
              <circle
                data-name="Ellipse 129733"
                cx={18.675}
                cy={18.675}
                r={18.675}
                transform="rotate(-57.95 28.585 15.829)"
                fill="#8fb7b0"
              />
              <g data-name="Group 105496">
                <path
                  data-name="Path 97962"
                  d="M268.375 228.27H253.42v1.613h1.2s-.667 4.231 2.339 5.974a6.972 6.972 0 012.456 2.1 1.061 1.061 0 01-.356 1.477c-1.367.855-4.231 2.851-4.231 4.549v2.858h-1.153v1.225h14.443v-1.225h-1.153v-2.858c0-1.691-2.864-3.687-4.231-4.549a1.066 1.066 0 01-.356-1.477 6.906 6.906 0 012.456-2.1c3.007-1.743 2.339-5.974 2.339-5.974h1.2v-1.613z"
                  transform="translate(18.194 16.494) translate(-253.42 -228.27)"
                  fill="#fff"
                />
                <path
                  data-name="Path 97963"
                  d="M257.477 234.761s1.892-1.186 4.84.337a3.991 3.991 0 004.84-.557 4.623 4.623 0 01-2.6 3.454c-2.3 1-2.248 4.905-2.248 4.905h-.279s.4-3.123-1.413-4.29-1.918-1.555-2.2-2.449a3.066 3.066 0 00-.953-1.4z"
                  transform="translate(18.194 16.494) translate(-254.846 -230.4)"
                  fill="#e05353"
                  opacity={0.13}
                />
                <path
                  data-name="Path 97964"
                  d="M262.048 249.573a.377.377 0 00-.492.052 2.1 2.1 0 01-1.626.564c-1.477-.026-2.618.22-2.9 1.445a6.086 6.086 0 000 2.423 8.581 8.581 0 004.73.473 35.162 35.162 0 015.65-.058s.279-2.7-.836-3.454c-1.335-.9-3.357-.59-4.536-1.451z"
                  transform="translate(18.194 16.494) translate(-254.648 -235.745)"
                  fill="#e05353"
                  opacity={0.13}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
export function NoRefferals(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 128.252,
    height: 118.438,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128.252 118.438"
      sx={rootSx}
      {...rest}
    >
      <path
        data-name="Path 20625"
        d="M199.688 152.67c.327-1.875.852-3.73 1.228-5.64a33.34 33.34 0 00.157-11.169 43.873 43.873 0 00-8.233-19.6c-4.586-6.152-11.482-11.134-18.894-9.252-7.711 1.949-14.238 7.9-21.737 10.609-12.7 4.593-25.557-3.779-38.355-3.48-11.051.24-22.645 4.207-29.924 14.016-2.972 4-5.042 9.395-4.339 14.7.859 6.462 5.6 11.378 9.137 16.159 5.421 7.328 7.474 15.31 2.912 23.863-3.083 5.8-7.23 10.919-6.872 18.118.574 11.517 11.208 18.473 19.976 21.573 8.908 3.152 19.023 3.48 27.878-.07 7.867-3.166 13.358-10.091 20.529-14.51a32.45 32.45 0 0121.055-4.621c7.578.9 15.564 2.5 22.888-.769 7.008-3.132 10.327-11.5 10.588-19.52a32.063 32.063 0 00-1.778-11.775c-1.625-4.544-5.219-8.09-6.232-12.909a14.962 14.962 0 01.014-5.717z"
        transform="translate(-77.798 -112.187) translate(77.798 112.187) translate(-79.454 -106.601)"
        fill="#c5e8e2"
      />
      <path
        data-name="Path 20626"
        d="M199.688 152.67c.327-1.875.852-3.73 1.228-5.64a33.34 33.34 0 00.157-11.169 43.873 43.873 0 00-8.233-19.6c-4.586-6.152-11.482-11.134-18.894-9.252-7.711 1.949-14.238 7.9-21.737 10.609-12.7 4.593-25.557-3.779-38.355-3.48-11.051.24-22.645 4.207-29.924 14.016-2.972 4-5.042 9.395-4.339 14.7.859 6.462 5.6 11.378 9.137 16.159 5.421 7.328 7.474 15.31 2.912 23.863-3.083 5.8-7.23 10.919-6.872 18.118.574 11.517 11.208 18.473 19.976 21.573 8.908 3.152 19.023 3.48 27.878-.07 7.867-3.166 13.358-10.091 20.529-14.51a32.45 32.45 0 0121.055-4.621c7.578.9 15.564 2.5 22.888-.769 7.008-3.132 10.327-11.5 10.588-19.52a32.063 32.063 0 00-1.778-11.775c-1.625-4.544-5.219-8.09-6.232-12.909a14.962 14.962 0 01.014-5.717z"
        transform="translate(-77.798 -112.187) translate(77.798 112.187) translate(-79.454 -106.601)"
        fill="#fff"
        opacity={0.7}
      />
      <path
        d="M16.558 4A8.569 8.569 0 008 12.558v58.957a8.569 8.569 0 008.558 8.558h24.991a25.556 25.556 0 01-3.615-4.8c-.07-.113-.289-.505-.5-.9H16.558a2.856 2.856 0 01-2.853-2.853V12.558a2.856 2.856 0 012.853-2.853h21.871v16.166a8.569 8.569 0 008.558 8.558h16.166v4.127a24.415 24.415 0 015.705 1.586v-8.565a2.842 2.842 0 00-.836-2.017L43.3 4.836A2.842 2.842 0 0041.282 4zm27.577 9.739l14.984 14.985H46.988a2.856 2.856 0 01-2.853-2.853zm15.215 28.3a20.92 20.92 0 1020.92 20.92 20.92 20.92 0 00-20.921-20.922zm-9.51 9.507a1.9 1.9 0 011.345.557l8.165 8.164 8.164-8.167a1.9 1.9 0 112.686 2.692l-8.164 8.165 8.164 8.164a1.9 1.9 0 11-2.689 2.689l-8.165-8.164-8.165 8.164a1.9 1.9 0 01-2.681-2.689l8.164-8.165-8.164-8.164a1.9 1.9 0 011.345-3.246z"
        transform="translate(-77.798 -112.187) translate(97.905 127.252)"
        fill="#8fb7b0"
      />
    </SvgIcon>
  );
}
export function EmptyPatients(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 214,
    height: 99.749,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 214 99.749"
      sx={rootSx}
      {...rest}
    >
      <g data-name="Group 105500" transform="translate(-450.5 -435.925)">
        <path
          data-name="Path 99763"
          d="M371.545 397.25c.077.048-3.518 6.4-8.029 14.183s-8.22 14.076-8.3 14.029 3.523-6.392 8.029-14.183 8.229-14.071 8.3-14.029z"
          transform="translate(458.189 435.925) translate(-314.327 -340.142)"
          fill="#87a59f"
        />
        <path
          data-name="Path 99764"
          d="M379.823 423.694a2.2 2.2 0 01-.226-.244l-.6-.744-2.208-2.744c-1.869-2.309-4.5-5.464-7.517-8.85s-5.851-6.35-7.934-8.475l-2.476-2.506-.667-.684a1.785 1.785 0 01-.22-.256 1.435 1.435 0 01.262.208l.708.649c.6.559 1.482 1.393 2.547 2.434 2.125 2.083 4.988 5.035 8.011 8.428s5.63 6.547 7.458 8.928c.911 1.19 1.643 2.131 2.131 2.8l.56.78a1.6 1.6 0 01.171.276z"
          transform="translate(458.189 435.925) translate(-315.445 -340.927)"
          fill="#87a59f"
        />
        <path
          data-name="Path 99765"
          d="M342.4 427.268a38.547 38.547 0 01-2.506-4.7c-1.47-2.946-3.452-7.047-5.619-11.582s-4.1-8.66-5.494-11.648l-1.625-3.571-.428-.97a1.887 1.887 0 01-.131-.345 1.419 1.419 0 01.191.321l.476.946 1.72 3.5 5.589 11.63 5.535 11.624c.7 1.458 1.268 2.655 1.684 3.518.185.393.339.708.458.958q.066.164.149.322z"
          transform="translate(458.189 435.925) translate(-302.742 -339.009)"
          fill="#87a59f"
        />
        <path
          data-name="Path 99766"
          d="M337.812 399.45a1.842 1.842 0 01-.2.3c-.161.214-.363.488-.6.827-.536.708-1.327 1.726-2.327 2.976-1.994 2.476-4.851 5.821-8.041 9.475s-6.077 6.987-8.112 9.4l-2.381 2.9-.655.786a1.916 1.916 0 01-.244.262 1.431 1.431 0 01.2-.3l.6-.827c.536-.708 1.327-1.726 2.327-2.976 1.994-2.482 4.851-5.827 8.041-9.481s6.065-6.976 8.1-9.416l2.381-2.9.655-.786a1.912 1.912 0 01.256-.24z"
          transform="translate(458.189 435.925) translate(-298.151 -341.033)"
          fill="#87a59f"
        />
        <path
          data-name="Path 99767"
          d="M317.192 388.16c-.1 1.1-13.832 47.02-13.832 47.02h3.274l14.576-45.924z"
          transform="translate(458.189 435.925) translate(-293.334 -336.462)"
          fill="#87a59f"
        />
        <path
          data-name="Path 99768"
          d="M317.087 388.152a2.313 2.313 0 01.256.06l.774.19 3.006.762h.06v.059c-2.351 7.606-7.934 25.319-14.475 45.948v.042l-.036.107H303.1l.06-.2 9.951-33.33c1.256-4.22 2.268-7.63 2.976-10l1.059-3.654a1.046 1.046 0 01-.048.256c-.048.167-.077.393-.161.7-.167.625-.411 1.548-.738 2.732a855.607 855.607 0 01-2.881 10.023c-2.464 8.481-5.952 20.236-9.856 33.366l-.149-.2h3.274l-.149.107v-.042c6.547-20.623 12.2-38.318 14.659-45.889l.042.077-2.976-.827-.78-.22a1.863 1.863 0 01-.296-.067z"
          transform="translate(458.189 435.925) translate(-293.228 -336.454)"
          fill="#263238"
        />
        <path
          data-name="Path 99769"
          d="M351.934 386.059c.2 1.083-.744 48.258-.744 48.258h3.4L356.047 386z"
          transform="translate(458.189 435.925) translate(-312.696 -335.588)"
          fill="#87a59f"
        />
        <path
          data-name="Path 99770"
          d="M351.841 386.051a1.322 1.322 0 01.262 0h.786l3.065-.071h.065v.012c-.178 7.91-.7 26.39-1.351 47.918v.542h-3.708v-.152c.262-13.5.5-25.563.672-34.259.077-4.333.137-7.833.185-10.261 0-2.274.036-3.357.042-3.738v3.738c0 2.416-.03 5.916-.089 10.261-.107 8.69-.309 20.754-.6 34.265l-.155-.161h3.4l-.155.149v-.394c.649-21.534 1.25-40.014 1.542-47.912l.06.06h-4.023z"
          transform="translate(458.189 435.925) translate(-312.603 -335.58)"
          fill="#263238"
        />
        <path
          data-name="Path 99771"
          d="M379.6 389.07c.107 1.1 13.5 46.49 13.5 46.49h-3.256l-14.724-45.936z"
          transform="translate(458.189 435.925) translate(-322.383 -336.831)"
          fill="#87a59f"
        />
        <path
          data-name="Path 99772"
          d="M379.553 389.07l-.3.048-.869.119-3.3.429.048-.083c2.512 7.642 8.142 25.1 14.647 45.407.059.179.113.357.167.524l-.143-.107h3.256l-.149.2c-3.827-13-7.22-24.623-9.624-33-1.19-4.166-2.161-7.571-2.8-9.9a148.37 148.37 0 01-.72-2.69c-.083-.31-.125-.536-.161-.7l-.048-.25c.107.363.411 1.411 1.036 3.607.69 2.339 1.672 5.7 2.9 9.874 2.47 8.368 5.892 19.974 9.719 32.967l.059.2H389.7l-.036-.107-.173-.524c-6.511-20.308-12.07-37.788-14.487-45.46v-.071h.077l3.351-.363.857-.089z"
          transform="translate(458.189 435.925) translate(-322.335 -336.831)"
          fill="#263238"
        />
        <path
          data-name="Path 99773"
          d="M287.028 317.153c.208.542 9.523 27.319 14.85 34.1s12.647 9.747 21.422 10.08c8.208.315 33.973-4.946 33.973-4.946s5.809-9.35 6.172-10.267-4.945-25.12-7.328-28.235-20.349-1.19-25.117-4.535-12.808-10.862-17.4-11.779-30.876 4.38-26.572 15.582z"
          transform="translate(458.189 435.925) translate(-286.53 -301.368)"
          fill="#c9e7e1"
        />
        <path
          data-name="Path 99774"
          d="M287.012 317.084s-.065-.178-.185-.536a6.691 6.691 0 01-.309-1.631 6.547 6.547 0 01.47-2.654 9.44 9.44 0 012.161-2.976 26.271 26.271 0 018.749-4.976 52.713 52.713 0 016.047-1.815 45.657 45.657 0 016.987-1.149 16.757 16.757 0 011.9-.036 6.214 6.214 0 011.9.417 18.754 18.754 0 013.571 1.833 81.537 81.537 0 016.815 4.988l3.494 2.75q.893.7 1.786 1.375a7.692 7.692 0 001.952 1.149 13.936 13.936 0 002.232.643c.762.167 1.542.292 2.333.4 1.577.208 3.19.345 4.821.458 3.268.238 6.63.321 10.047.786a17.318 17.318 0 012.547.536 5.992 5.992 0 011.232.512 2.571 2.571 0 01.952.988 30.626 30.626 0 011.887 4.982c1.042 3.416 1.934 6.934 2.791 10.523s1.672 7.232 2.3 10.969c.042.292.089.6.119.863a3.7 3.7 0 010 .452 1.243 1.243 0 01-.161.464c-.28.506-.565 1-.857 1.488l-1.744 2.9-3.452 5.619-.036.054h-.065c-6.654 1.333-13.142 2.512-19.415 3.488-3.131.47-6.214.9-9.243 1.19-.756.065-1.512.155-2.262.185s-1.5.089-2.244.077a35.609 35.609 0 01-8.612-1.119 28.4 28.4 0 01-3.934-1.369 24.892 24.892 0 01-6.684-4.279 24.024 24.024 0 01-4.678-5.7c-1.19-2.036-2.178-4.089-3.107-6.041-1.786-3.922-3.285-7.523-4.541-10.713s-2.28-5.91-3.107-8.148-1.452-3.982-1.863-5.166l-.464-1.345c-.1-.3-.149-.458-.149-.458s.065.149.178.452l.488 1.333c.44 1.19 1.083 2.91 1.911 5.142s1.893 4.97 3.16 8.13 2.756 6.761 4.571 10.672c.934 1.94 1.9 3.988 3.119 6.005a23.737 23.737 0 004.648 5.642 24.6 24.6 0 006.619 4.22 28.743 28.743 0 003.928 1.387 35.247 35.247 0 004.166.8 34.067 34.067 0 004.363.292c.738 0 1.482-.036 2.226-.083s1.5-.113 2.256-.179c3.018-.3 6.095-.726 9.225-1.19 6.261-.976 12.749-2.155 19.4-3.488l-.1.065c1.125-1.821 2.274-3.7 3.452-5.613.6-.958 1.155-1.928 1.744-2.9.286-.488.6-.982.839-1.482.054-.113.149-.256.131-.333a3.021 3.021 0 010-.4 6 6 0 00-.113-.845c-.6-3.714-1.452-7.368-2.292-10.945s-1.75-7.1-2.785-10.5a29.868 29.868 0 00-1.857-4.922 2.279 2.279 0 00-.839-.875 5.8 5.8 0 00-1.19-.488 17.137 17.137 0 00-2.5-.53c-3.393-.458-6.755-.548-10.023-.792a79.006 79.006 0 01-4.839-.464c-.8-.107-1.583-.238-2.381-.4a13.637 13.637 0 01-2.274-.667 8.1 8.1 0 01-2.012-1.19c-.6-.452-1.22-.917-1.815-1.381a441.345 441.345 0 01-3.482-2.762c-2.291-1.786-4.506-3.535-6.785-4.982a18.5 18.5 0 00-3.5-1.821 8.1 8.1 0 00-3.7-.375 46.18 46.18 0 00-6.958 1.119 52.234 52.234 0 00-6.035 1.785 25.4 25.4 0 00-8.725 4.9 9.155 9.155 0 00-2.155 2.928 6.442 6.442 0 00-.494 2.613 6.084 6.084 0 00.28 1.625c.121.335.169.519.169.519z"
          transform="translate(458.189 435.925) translate(-286.514 -301.3)"
          fill="#87a59f"
        />
        <path
          data-name="Path 99785"
          d="M417.231 453.769a.94.94 0 00-.661 1.065.9.9 0 001.048.667.988.988 0 00.7-1.131.928.928 0 00-1.19-.6"
          transform="translate(458.189 435.925) translate(-339.157 -363.003)"
          fill="#e0e0e0"
        />
        <path
          data-name="Path 99825"
          d="M300 341.81a115.6 115.6 0 0025.807 6.785c14.552 2.047 21.933.4 23.48 4.761 1.161 3.268 2.488 20.236 2.488 20.236s-23.843 4.869-32.14-.268-12.183-12.725-15.076-20.093C301.19 344.75 300 341.81 300 341.81"
          transform="translate(458.189 435.925) translate(-291.974 -317.699)"
          fill="#c9e7e1"
        />
        <path
          data-name="Path 99826"
          d="M351.433 373.025a2.21 2.21 0 01-.065-.327l-.149-.952c-.125-.863-.3-2.077-.518-3.619-.435-3.131-1.048-7.565-1.786-12.844v.03a4.625 4.625 0 00-2.333-2.47 9.523 9.523 0 00-3.637-.881l-4.012-.226a127.7 127.7 0 01-4.166-.327 137.018 137.018 0 01-23.331-4.244c-2.928-.8-5.267-1.565-6.88-2.1l-1.839-.649-.476-.179-.161-.071.167.042.488.149 1.863.6c1.619.5 3.964 1.226 6.9 2a143.92 143.92 0 0023.3 4.166c1.411.137 2.8.238 4.166.333s2.7.137 4.017.226a9.666 9.666 0 013.744.929 4.887 4.887 0 012.458 2.631c.684 5.285 1.256 9.719 1.666 12.862.185 1.542.339 2.762.446 3.625.042.4.077.72.107.958a2.288 2.288 0 01.031.338z"
          transform="translate(458.189 435.925) translate(-292.816 -318.654)"
          fill="#87a59f"
        />
        <g data-name="freepik--character-2--inject-34">
          <path
            data-name="Path 99763"
            d="M355.219 397.25c-.077.048 3.518 6.4 8.029 14.183s8.22 14.076 8.3 14.029-3.523-6.392-8.029-14.183-8.228-14.071-8.3-14.029z"
            transform="translate(575.189 435.925) translate(-333.264 -340.142)"
            fill="#87a59f"
          />
          <path
            data-name="Path 99764"
            d="M357.98 423.694a2.2 2.2 0 00.226-.244l.6-.744 2.208-2.744c1.869-2.309 4.5-5.464 7.517-8.85s5.851-6.35 7.934-8.475l2.476-2.506.667-.684a1.785 1.785 0 00.22-.256 1.435 1.435 0 00-.262.208l-.708.649c-.6.559-1.482 1.393-2.547 2.434-2.125 2.083-4.988 5.035-8.011 8.428s-5.63 6.547-7.458 8.928c-.911 1.19-1.643 2.131-2.131 2.8l-.56.78a1.6 1.6 0 00-.171.276z"
            transform="translate(575.189 435.925) translate(-343.184 -340.927)"
            fill="#87a59f"
          />
          <path
            data-name="Path 99765"
            d="M326.6 427.268a38.544 38.544 0 002.506-4.7c1.47-2.946 3.452-7.047 5.619-11.582s4.1-8.66 5.494-11.648l1.625-3.571.428-.97a1.887 1.887 0 00.131-.345 1.419 1.419 0 00-.191.321l-.476.946-1.72 3.5-5.589 11.63-5.535 11.624c-.7 1.458-1.268 2.655-1.684 3.518-.185.393-.339.708-.458.958q-.066.164-.149.322z"
            transform="translate(575.189 435.925) translate(-287.086 -339.009)"
            fill="#87a59f"
          />
          <path
            data-name="Path 99766"
            d="M315.26 399.45a1.842 1.842 0 00.2.3c.161.214.363.488.6.827.536.708 1.327 1.726 2.327 2.976 1.994 2.476 4.851 5.821 8.041 9.475s6.077 6.987 8.112 9.4l2.381 2.9.655.786a1.916 1.916 0 00.244.262 1.431 1.431 0 00-.2-.3l-.6-.827a147.223 147.223 0 00-2.327-2.976c-1.994-2.482-4.851-5.827-8.041-9.481s-6.065-6.976-8.1-9.416l-2.381-2.9-.655-.786a1.912 1.912 0 00-.256-.24z"
            transform="translate(575.189 435.925) translate(-275.746 -341.033)"
            fill="#87a59f"
          />
          <path
            data-name="Path 99767"
            d="M307.378 388.16c.1 1.1 13.832 47.019 13.832 47.019h-3.273l-14.577-45.924z"
            transform="translate(575.189 435.925) translate(-252.062 -336.462)"
            fill="#87a59f"
          />
          <path
            data-name="Path 99768"
            d="M307.195 388.152a2.313 2.313 0 00-.256.06l-.774.19-3.006.762h-.06v.059c2.351 7.606 7.934 25.319 14.475 45.948v.042l.036.107h3.571l-.06-.2-9.951-33.33c-1.256-4.22-2.268-7.63-2.976-10l-1.059-3.654a1.046 1.046 0 00.048.256c.048.167.077.393.161.7.167.625.411 1.548.738 2.732a855.607 855.607 0 002.881 10.023c2.464 8.481 5.952 20.236 9.856 33.366l.149-.2h-3.274l.149.107v-.042c-6.547-20.623-12.2-38.318-14.659-45.889l-.042.077 2.976-.827.78-.22a1.863 1.863 0 00.297-.067z"
            transform="translate(575.189 435.925) translate(-251.879 -336.454)"
            fill="#263238"
          />
          <path
            data-name="Path 99769"
            d="M355.3 386.059c-.2 1.083.744 48.258.744 48.258h-3.4L351.19 386z"
            transform="translate(575.189 435.925) translate(-315.367 -335.588)"
            fill="#87a59f"
          />
          <path
            data-name="Path 99770"
            d="M355.138 386.051a1.322 1.322 0 00-.262 0h-.786l-3.065-.071h-.065v.012c.178 7.91.7 26.39 1.351 47.918v.542h3.708v-.152c-.262-13.5-.5-25.563-.672-34.259-.077-4.333-.137-7.833-.185-10.261 0-2.274-.036-3.357-.042-3.738v3.738c0 2.416.03 5.916.089 10.261.107 8.69.309 20.754.6 34.265l.155-.161h-3.4l.155.149v-.394c-.649-21.534-1.25-40.014-1.542-47.912l-.06.06h4.023z"
            transform="translate(575.189 435.925) translate(-315.202 -335.58)"
            fill="#263238"
          />
          <path
            data-name="Path 99771"
            d="M388.625 389.07c-.107 1.1-13.5 46.49-13.5 46.49h3.256l14.731-45.936z"
            transform="translate(575.189 435.925) translate(-366.669 -336.831)"
            fill="#87a59f"
          />
          <path
            data-name="Path 99772"
            d="M388.713 389.07l.3.048.869.119 3.3.429-.048-.083c-2.512 7.642-8.142 25.1-14.647 45.407-.059.179-.113.357-.167.524l.143-.107h-3.256l.149.2c3.827-13 7.22-24.623 9.624-33 1.19-4.166 2.161-7.571 2.8-9.9.327-1.19.565-2.077.72-2.69.083-.31.125-.536.161-.7l.048-.25c-.107.363-.411 1.411-1.036 3.607-.69 2.339-1.672 5.7-2.9 9.874-2.47 8.368-5.892 19.974-9.719 32.967l-.059.2h3.571l.036-.107.173-.524c6.511-20.308 12.07-37.788 14.487-45.46v-.071h-.077l-3.351-.363-.857-.089z"
            transform="translate(575.189 435.925) translate(-366.757 -336.831)"
            fill="#263238"
          />
          <path
            data-name="Path 99773"
            d="M362.993 317.153c-.208.542-9.523 27.319-14.85 34.1S335.5 361 326.716 361.333c-8.208.315-33.973-4.946-33.973-4.946s-5.809-9.35-6.172-10.267 4.946-25.12 7.329-28.235 20.349-1.19 25.117-4.535 12.808-10.862 17.4-11.779 30.883 4.38 26.576 15.582z"
            transform="translate(575.189 435.925) translate(-284.316 -301.368)"
            fill="#c9e7e1"
          />
          <path
            data-name="Path 99774"
            d="M363.116 317.084s.065-.178.185-.536a6.691 6.691 0 00.309-1.631 6.547 6.547 0 00-.47-2.654 9.44 9.44 0 00-2.161-2.976 26.271 26.271 0 00-8.749-4.976 52.713 52.713 0 00-6.047-1.815 45.656 45.656 0 00-6.987-1.149 16.757 16.757 0 00-1.9-.036 6.214 6.214 0 00-1.9.417 18.754 18.754 0 00-3.571 1.833 81.524 81.524 0 00-6.815 4.988l-3.494 2.75q-.893.7-1.786 1.375a7.692 7.692 0 01-1.952 1.149 13.936 13.936 0 01-2.232.643c-.762.167-1.542.292-2.333.4-1.577.208-3.19.345-4.821.458-3.267.238-6.63.321-10.047.786a17.318 17.318 0 00-2.547.536 5.992 5.992 0 00-1.232.512 2.571 2.571 0 00-.952.988 30.626 30.626 0 00-1.887 4.982c-1.042 3.416-1.934 6.934-2.791 10.523s-1.672 7.232-2.3 10.969c-.042.292-.089.6-.119.863a3.7 3.7 0 000 .452 1.243 1.243 0 00.161.464c.28.506.565 1 .857 1.488l1.744 2.9 3.452 5.618.036.054h.065c6.654 1.333 13.142 2.512 19.415 3.488 3.131.47 6.214.9 9.243 1.19.756.065 1.512.155 2.262.185s1.5.089 2.244.077a35.609 35.609 0 008.612-1.119 28.4 28.4 0 003.934-1.369 24.891 24.891 0 006.684-4.279 24.023 24.023 0 004.678-5.7c1.19-2.036 2.178-4.089 3.107-6.041 1.786-3.922 3.285-7.523 4.541-10.713s2.28-5.91 3.107-8.148 1.452-3.982 1.863-5.166l.464-1.345c.1-.3.149-.458.149-.458s-.065.149-.178.452l-.488 1.333c-.44 1.19-1.083 2.91-1.911 5.142s-1.893 4.97-3.16 8.13-2.756 6.761-4.571 10.672c-.934 1.94-1.9 3.988-3.119 6.005a23.736 23.736 0 01-4.648 5.642 24.6 24.6 0 01-6.618 4.22 28.743 28.743 0 01-3.928 1.387 35.247 35.247 0 01-4.166.8 34.067 34.067 0 01-4.363.292c-.738 0-1.482-.036-2.226-.083s-1.5-.113-2.256-.179c-3.018-.3-6.095-.726-9.225-1.19-6.261-.976-12.749-2.155-19.4-3.488l.1.065c-1.125-1.821-2.274-3.7-3.452-5.613-.6-.958-1.155-1.928-1.744-2.9-.286-.488-.6-.982-.839-1.482-.054-.113-.149-.256-.131-.333a3.021 3.021 0 000-.4 6 6 0 01.113-.845c.6-3.714 1.452-7.368 2.292-10.945s1.75-7.1 2.785-10.5a29.868 29.868 0 011.857-4.922 2.279 2.279 0 01.839-.875 5.8 5.8 0 011.19-.488 17.137 17.137 0 012.5-.53c3.393-.458 6.755-.548 10.023-.792a79.006 79.006 0 004.839-.464c.8-.107 1.583-.238 2.381-.4a13.637 13.637 0 002.274-.667 8.1 8.1 0 002.012-1.19c.6-.452 1.22-.917 1.815-1.381 1.19-.934 2.345-1.851 3.482-2.762 2.291-1.786 4.506-3.535 6.785-4.982a18.5 18.5 0 013.5-1.821 8.1 8.1 0 013.7-.375 46.179 46.179 0 016.958 1.119 52.234 52.234 0 016.035 1.785 25.4 25.4 0 018.725 4.9 9.155 9.155 0 012.155 2.928 6.442 6.442 0 01.494 2.613 6.084 6.084 0 01-.28 1.625c-.123.336-.17.52-.17.52z"
            transform="translate(575.189 435.925) translate(-284.439 -301.3)"
            fill="#87a59f"
          />
          <path
            data-name="Path 99785"
            d="M417.656 453.769a.94.94 0 01.661 1.065.9.9 0 01-1.048.667.988.988 0 01-.7-1.131.928.928 0 011.19-.6"
            transform="translate(575.189 435.925) translate(-416.556 -363.003)"
            fill="#e0e0e0"
          />
          <path
            data-name="Path 99825"
            d="M351.775 341.81a115.6 115.6 0 01-25.807 6.785c-14.552 2.047-21.933.4-23.48 4.761-1.161 3.268-2.488 20.236-2.488 20.236s23.843 4.869 32.14-.268 12.183-12.725 15.076-20.093a2324.01 2324.01 0 014.559-11.422"
            transform="translate(575.189 435.925) translate(-280.627 -317.699)"
            fill="#c9e7e1"
          />
          <path
            data-name="Path 99826"
            d="M302.08 373.025a2.21 2.21 0 00.065-.327l.149-.952c.125-.863.3-2.077.518-3.619.435-3.131 1.048-7.565 1.786-12.844v.03a4.625 4.625 0 012.333-2.47 9.522 9.522 0 013.637-.881l4.012-.226a127.7 127.7 0 004.166-.327 137.017 137.017 0 0023.331-4.244c2.928-.8 5.267-1.565 6.88-2.1l1.839-.649.476-.179.161-.071-.167.042-.488.149-1.863.6c-1.619.5-3.964 1.226-6.9 2a143.92 143.92 0 01-23.3 4.166c-1.411.137-2.8.238-4.166.333s-2.7.137-4.017.226a9.666 9.666 0 00-3.744.929 4.887 4.887 0 00-2.458 2.631c-.684 5.285-1.256 9.719-1.666 12.862-.185 1.542-.339 2.762-.446 3.625-.042.4-.077.72-.107.958a2.288 2.288 0 00-.031.338z"
            transform="translate(575.189 435.925) translate(-281.523 -318.654)"
            fill="#87a59f"
          />
        </g>
        <path
          data-name="Line 1570"
          transform="translate(450.5 534.809)"
          fill="none"
          stroke="#adc0c9"
          strokeWidth={1.73}
          d="M0 0L214 0"
        />
      </g>
    </SvgIcon>
  );
}

export function ExpertWelcome(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 264.178,
    height: 202.576,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 264.178 202.576"
      {...rest}
      sx={rootSx}
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_55678"
            data-name="Rectangle 55678"
            width="18.292"
            height="23.054"
            fill="none"
          />
        </clipPath>
      </defs>
      <g
        id="background_check"
        data-name="background check"
        transform="translate(-307.773 -295.001)"
      >
        <g
          id="Group_105528"
          data-name="Group 105528"
          transform="translate(308.529 295.001)"
          opacity="0.2"
        >
          <g
            id="Group_105527"
            data-name="Group 105527"
            transform="translate(0 19.786)"
          >
            <path
              id="Path_100985"
              data-name="Path 100985"
              d="M1108.888,1134.6c-3.312-1.558-8.791.975-10.538,4.682-3.335,7.075,7.45,17.322,11.372,16.222,4.383-1.229,5.248-18.044-.834-20.9Z"
              transform="translate(-1050.448 -1103.659)"
              fill="none"
              stroke="#b6aaf3"
              strokeLinecap="round"
              strokeWidth="1.5"
              strokeDasharray="10 10 10 10 10 10 10 10 10 10 10 10"
            />
            <path
              id="Path_100986"
              data-name="Path 100986"
              d="M619.556,1340.625c-1.182-.684-13.7-7.927-20.792-2.195-4.976,4.025-5.024,12.63-1.284,17.466,7.406,9.578,30.373,5.284,32.755-1.57C631.84,1349.711,624.306,1343.372,619.556,1340.625Z"
              transform="translate(-577.685 -1293.656)"
              fill="none"
              stroke="#b6aaf3"
              strokeLinecap="round"
              strokeWidth="1.5"
              strokeDasharray="10 10 10 10 10 10 10 10 10 10 10 10"
            />
            <path
              id="Path_100987"
              data-name="Path 100987"
              d="M366.514,790.572c30.482-7.566,65.117-15.268,118.9-13.956,30.078.734,36.894-8.6,59.689-20.206,20.318-10.343,30.3-30.911,24.168-42.568-6.188-11.768-25.034-7.083-40.469-24.6-7.029-7.978-5.792-13.571-9.85-22.418-12.851-28.015-61.017-49.912-84.769-38.324-31.379,15.309-4.553,81.459-39.629,99.53-22.187,11.431-38.957-10.513-60.864,6.238-10.855,8.3-24.131,19.943-25.157,32.585C308.532,766.853,307.094,797.76,366.514,790.572Z"
              transform="translate(-308.529 -625.333)"
              fill="none"
              stroke="#b6aaf3"
              strokeLinecap="round"
              strokeWidth="1.5"
              strokeDasharray="10 10 10 10 10 10 10 10 10 10 10 10"
            />
          </g>
          <path
            id="Path_100988"
            data-name="Path 100988"
            d="M806.669,445.6a159.9,159.9,0,0,0-11.044,17.365,84.784,84.784,0,0,0-9.6,31.453c-2.345-.111-4.921-.215-7.705-.314-16.492-.585-40.3-.952-66.776-.952-30.1,0-56.751.474-73.124,1.2l-1.654.076c-20.442-25.336-61.6-69.477-23.723-87.636a71.014,71.014,0,0,0,6.936-2.661c13.168-5.747,40.228-21.212,37.218-50.372a77.682,77.682,0,0,1-1.025-13.012c0-17.7,5.6-47.049,43.022-45.71a71.142,71.142,0,0,1,56.143,30.8c12.375,18.1,32.162,40.374,48.276,27.659a14.9,14.9,0,0,1,13.23-2.733C828.437,354.027,841.614,370.893,806.669,445.6Z"
            transform="translate(-580.276 -295.001)"
            fill="#eae6ff"
          />
        </g>
        <path
          id="Path_100989"
          data-name="Path 100989"
          d="M659.953,3606.729c0,1.2-56.061,2.169-125.216,2.169-39.02,0-73.871-.309-96.835-.794-5.29-.112-9.947-.232-13.881-.361-2.591-.084-4.867-.173-6.8-.264-4.979-.233-7.7-.486-7.7-.75,0-.336,4.413-.655,12.291-.938,3.226-.117,7.032-.227,11.354-.33,22.743-.545,59.764-.9,101.571-.9,36.774,0,69.846.274,92.754.712,20.171.385,32.463.9,32.463,1.457Z"
          transform="translate(-94.942 -3111.322)"
          fill="#040c2b"
          opacity="0.05"
        />
        <g
          id="Group_105538"
          data-name="Group 105538"
          transform="translate(398.009 366.542)"
        >
          <g
            id="Group_105526"
            data-name="Group 105526"
            transform="translate(1.782 21.371)"
          >
            <g
              id="Group_105524"
              data-name="Group 105524"
              transform="translate(0 0)"
            >
              <path
                id="Path_99827"
                data-name="Path 99827"
                d="M225.71,153.192c1.424-2.281,4.863-4.642,7.907-6.5C234.1,147.8,230.766,150.471,225.71,153.192Z"
                transform="translate(-169.683 -122.434)"
                fill="#ffc2b1"
              />
              <path
                id="Path_99828"
                data-name="Path 99828"
                d="M233.62,172.049a9.34,9.34,0,0,1-1,.225c0,.022-.022.018-.051.015a8.239,8.239,0,0,1-1.569.163,8.808,8.808,0,0,1-2.742-.211,5.94,5.94,0,0,1-1.743-.734,2.5,2.5,0,0,1-.563-.443h-.022a1.162,1.162,0,0,1,.16-.291c-.251.007-.516-.171-.85-.741a1.087,1.087,0,0,1-.265-.305.11.11,0,0,1-.033-.073,1.734,1.734,0,0,1-.2-.476,11.307,11.307,0,0,0,2.118.774c.149.062.3.087.432.131a9.042,9.042,0,0,0,3.661.2c.062.036.127.065.163.091a1.3,1.3,0,0,0,.167.094,14.924,14.924,0,0,1,2.212,1.475A.64.64,0,0,0,233.62,172.049Z"
                transform="translate(-169.072 -136.755)"
                opacity="0.1"
              />
              <path
                id="Path_99829"
                data-name="Path 99829"
                d="M223.91,156.445a3.369,3.369,0,0,1,.363-.534,5.028,5.028,0,0,1,.556-.737c.134-.156.269-.32.421-.483.312-.331.654-.65,1.01-.973a6.846,6.846,0,0,1,.65-.585c.015-.029.036-.033.069-.069.131-.109.265-.2.392-.312.331-.269.686-.545,1.039-.817.567-.418,1.148-.835,1.7-1.224,0,0,.007.025.015.044.363.835-1.925,2.967-5.521,5.241-.116.084-.251.167-.381.258-.1.054-.214.134-.309.189Z"
                transform="translate(-168.537 -124.994)"
                fill="#ffc2b1"
              />
              <g id="Group_105523" data-name="Group 105523">
                <g
                  id="Group_105510"
                  data-name="Group 105510"
                  transform="translate(0 0.011)"
                >
                  <path
                    id="Path_99830"
                    data-name="Path 99830"
                    d="M138.885,82.715v37.266c0,.047,0,.094,0,.142a2.742,2.742,0,0,1-.116.672.037.037,0,0,0,0,.011,1,1,0,0,1-.029.1,2.819,2.819,0,0,1-.109.262,3.208,3.208,0,0,1-.236.407,3.318,3.318,0,0,1-.218.276c0,.011-.015.018-.022.029a.618.618,0,0,1-.069.069,1.161,1.161,0,0,1-.1.091l-.1.087-.105.084-.109.076c-.036.025-.073.047-.113.073-.076.047-.153.087-.232.127l-.127.054a.013.013,0,0,1-.007,0,2.015,2.015,0,0,1-.247.091c-.047.015-.091.029-.138.04a2.681,2.681,0,0,1-.69.087H74.261a2.681,2.681,0,0,1-.69-.087c-.047-.011-.091-.025-.138-.04a2.015,2.015,0,0,1-.247-.091.011.011,0,0,1-.007,0l-.127-.054c-.076-.036-.153-.08-.225-.123a3.307,3.307,0,0,1-.345-.247c-.029-.025-.058-.051-.091-.076s-.065-.058-.1-.091-.047-.044-.069-.069-.018-.018-.022-.029a1.779,1.779,0,0,1-.218-.276l-.015-.025-.084-.127c-.025-.047-.051-.091-.076-.138a.434.434,0,0,1-.029-.058c-.018-.033-.033-.065-.047-.1a.4.4,0,0,1-.025-.058.018.018,0,0,0,0-.011c-.015-.036-.029-.076-.044-.113a0,0,0,0,1,0,0c0-.011-.007-.018-.011-.029s-.007-.025-.011-.036a.428.428,0,0,1-.025-.073.18.18,0,0,1-.011-.047.688.688,0,0,0-.022-.065.138.138,0,0,0-.011-.036c-.007-.036-.015-.069-.022-.105s-.018-.091-.025-.138-.011-.091-.018-.138a.177.177,0,0,0,0-.044v-.051c0-.062-.007-.127-.007-.193V82.573a2.528,2.528,0,0,1,.12-.668,2.969,2.969,0,0,1,.116-.316,2.824,2.824,0,0,1,.341-.57,2.685,2.685,0,0,1,.272-.3,2.525,2.525,0,0,1,.523-.392,2.645,2.645,0,0,1,.421-.2h0a.018.018,0,0,0,.011,0c.069-.025.134-.047.207-.069a2.811,2.811,0,0,1,.766-.109h61.845a2.677,2.677,0,0,1,.766.109,2.6,2.6,0,0,1,.49.193h0a2.392,2.392,0,0,1,.323.2,2.348,2.348,0,0,1,.345.283,1.705,1.705,0,0,1,.138.142.016.016,0,0,1,.011.011.235.235,0,0,1,.029.033.011.011,0,0,1,.007,0c.033.036.062.073.091.109a2.584,2.584,0,0,1,.356.6,2.051,2.051,0,0,1,.105.283,2.528,2.528,0,0,1,.12.668v.145Z"
                    transform="translate(-71.479 -79.94)"
                    fill="#dfd8ff"
                  />
                  <g
                    id="Group_105509"
                    data-name="Group 105509"
                    transform="translate(0 0.105)"
                    opacity="0.3"
                  >
                    <path
                      id="Path_99831"
                      data-name="Path 99831"
                      d="M74.337,81.048a.333.333,0,0,1-.331.334h-.2a2.525,2.525,0,0,1,.523-.392.317.317,0,0,1,.007.058Z"
                      transform="translate(-72.956 -80.714)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99832"
                      data-name="Path 99832"
                      d="M78.7,80.571a.329.329,0,0,1-.331.331H76.381a.325.325,0,0,1-.276-.149.315.315,0,0,1-.054-.182.327.327,0,0,1,.127-.262.2.2,0,0,1,.1-.051.022.022,0,0,0,.015,0,.2.2,0,0,0,.036-.011c.018,0,.036,0,.058,0h1.983a.326.326,0,0,1,.287.171.305.305,0,0,1,.044.163Z"
                      transform="translate(-74.383 -80.236)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99833"
                      data-name="Path 99833"
                      d="M86.774,80.564a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99834"
                      data-name="Path 99834"
                      d="M94.854,80.564a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99835"
                      data-name="Path 99835"
                      d="M102.924,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99836"
                      data-name="Path 99836"
                      d="M111,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99837"
                      data-name="Path 99837"
                      d="M119.074,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99838"
                      data-name="Path 99838"
                      d="M127.154,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99839"
                      data-name="Path 99839"
                      d="M135.234,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99840"
                      data-name="Path 99840"
                      d="M143.3,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99841"
                      data-name="Path 99841"
                      d="M151.384,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99842"
                      data-name="Path 99842"
                      d="M159.454,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99843"
                      data-name="Path 99843"
                      d="M167.534,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99844"
                      data-name="Path 99844"
                      d="M175.6,80.564a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99845"
                      data-name="Path 99845"
                      d="M183.684,80.564a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99846"
                      data-name="Path 99846"
                      d="M191.764,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99847"
                      data-name="Path 99847"
                      d="M199.834,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99848"
                      data-name="Path 99848"
                      d="M207.914,80.564a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99849"
                      data-name="Path 99849"
                      d="M215.984,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99850"
                      data-name="Path 99850"
                      d="M224.064,80.564a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99851"
                      data-name="Path 99851"
                      d="M232.134,80.564a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99852"
                      data-name="Path 99852"
                      d="M240.214,80.564a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99853"
                      data-name="Path 99853"
                      d="M248.294,80.564v.029a.33.33,0,0,1-.331.305h-1.983a.33.33,0,0,1-.331-.334.315.315,0,0,1,.044-.163.327.327,0,0,1,.291-.171h1.791a2.6,2.6,0,0,1,.49.193h0a.368.368,0,0,1,.033.142Z"
                      transform="translate(-182.381 -80.23)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99854"
                      data-name="Path 99854"
                      d="M254.075,81.58h-.018a.319.319,0,0,1-.051,0,.3.3,0,0,1-.218-.134.345.345,0,0,1-.058-.142,2.348,2.348,0,0,1,.345.283Z"
                      transform="translate(-187.526 -80.911)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99855"
                      data-name="Path 99855"
                      d="M74.666,83.234a.332.332,0,0,1-.331.331H72.352a.336.336,0,0,1-.232-.094,2.823,2.823,0,0,1,.341-.57h1.874a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.88 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99856"
                      data-name="Path 99856"
                      d="M82.564,83.234a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99857"
                      data-name="Path 99857"
                      d="M90.644,83.234a.333.333,0,0,1-.331.334H88.331A.333.333,0,0,1,88,83.234h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99858"
                      data-name="Path 99858"
                      d="M98.714,83.234a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0A.333.333,0,0,1,96.4,82.9h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99859"
                      data-name="Path 99859"
                      d="M106.794,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99860"
                      data-name="Path 99860"
                      d="M114.864,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99861"
                      data-name="Path 99861"
                      d="M122.944,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99862"
                      data-name="Path 99862"
                      d="M131.024,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99863"
                      data-name="Path 99863"
                      d="M139.094,83.234a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99864"
                      data-name="Path 99864"
                      d="M147.174,83.234a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99865"
                      data-name="Path 99865"
                      d="M155.244,83.234a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99866"
                      data-name="Path 99866"
                      d="M163.324,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99867"
                      data-name="Path 99867"
                      d="M171.394,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99868"
                      data-name="Path 99868"
                      d="M179.474,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99869"
                      data-name="Path 99869"
                      d="M187.554,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-143.703 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99870"
                      data-name="Path 99870"
                      d="M195.624,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99871"
                      data-name="Path 99871"
                      d="M203.7,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99872"
                      data-name="Path 99872"
                      d="M211.774,83.234a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99873"
                      data-name="Path 99873"
                      d="M219.854,83.234a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99874"
                      data-name="Path 99874"
                      d="M227.934,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99875"
                      data-name="Path 99875"
                      d="M236,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99876"
                      data-name="Path 99876"
                      d="M244.084,83.234a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99877"
                      data-name="Path 99877"
                      d="M252.016,83.5a.321.321,0,0,1-.193.062h-1.983a.329.329,0,0,1-.331-.331.335.335,0,0,1,.331-.334h1.82A2.584,2.584,0,0,1,252.016,83.5Z"
                      transform="translate(-184.839 -81.93)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99878"
                      data-name="Path 99878"
                      d="M72.847,85.674a.333.333,0,0,1-.331.334H71.47a2.528,2.528,0,0,1,.12-.668h.926A.333.333,0,0,1,72.847,85.674Z"
                      transform="translate(-71.466 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99879"
                      data-name="Path 99879"
                      d="M78.694,85.674a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99880"
                      data-name="Path 99880"
                      d="M86.774,85.674a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99881"
                      data-name="Path 99881"
                      d="M94.854,85.674a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99882"
                      data-name="Path 99882"
                      d="M102.924,85.674a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99883"
                      data-name="Path 99883"
                      d="M111,85.674a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99884"
                      data-name="Path 99884"
                      d="M119.074,85.674a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99885"
                      data-name="Path 99885"
                      d="M127.154,85.674a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99886"
                      data-name="Path 99886"
                      d="M135.234,85.674a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99887"
                      data-name="Path 99887"
                      d="M143.3,85.674a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99888"
                      data-name="Path 99888"
                      d="M151.384,85.674a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99889"
                      data-name="Path 99889"
                      d="M159.454,85.674a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99890"
                      data-name="Path 99890"
                      d="M167.534,85.674a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99891"
                      data-name="Path 99891"
                      d="M175.6,85.674a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99892"
                      data-name="Path 99892"
                      d="M183.684,85.674a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99893"
                      data-name="Path 99893"
                      d="M191.764,85.674a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99894"
                      data-name="Path 99894"
                      d="M199.834,85.674a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99895"
                      data-name="Path 99895"
                      d="M207.914,85.674a.332.332,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99896"
                      data-name="Path 99896"
                      d="M215.984,85.674a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99897"
                      data-name="Path 99897"
                      d="M224.064,85.674a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99898"
                      data-name="Path 99898"
                      d="M232.134,85.674a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99899"
                      data-name="Path 99899"
                      d="M240.214,85.674a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99900"
                      data-name="Path 99900"
                      d="M248.294,85.674a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99901"
                      data-name="Path 99901"
                      d="M254.922,86.008h-.872a.334.334,0,0,1,0-.668h.752A2.529,2.529,0,0,1,254.922,86.008Z"
                      transform="translate(-187.52 -83.484)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99902"
                      data-name="Path 99902"
                      d="M74.484,88.344a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99903"
                      data-name="Path 99903"
                      d="M82.564,88.344a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99904"
                      data-name="Path 99904"
                      d="M90.644,88.344a.333.333,0,0,1-.331.334H88.331A.333.333,0,0,1,88,88.344h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99905"
                      data-name="Path 99905"
                      d="M98.714,88.344a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99906"
                      data-name="Path 99906"
                      d="M106.794,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99907"
                      data-name="Path 99907"
                      d="M114.864,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99908"
                      data-name="Path 99908"
                      d="M122.944,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99909"
                      data-name="Path 99909"
                      d="M131.024,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99910"
                      data-name="Path 99910"
                      d="M139.094,88.344a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99911"
                      data-name="Path 99911"
                      d="M147.174,88.344a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99912"
                      data-name="Path 99912"
                      d="M155.244,88.344a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99913"
                      data-name="Path 99913"
                      d="M163.324,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99914"
                      data-name="Path 99914"
                      d="M171.394,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99915"
                      data-name="Path 99915"
                      d="M179.474,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99916"
                      data-name="Path 99916"
                      d="M187.554,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-143.703 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99917"
                      data-name="Path 99917"
                      d="M195.624,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99918"
                      data-name="Path 99918"
                      d="M203.7,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99919"
                      data-name="Path 99919"
                      d="M211.774,88.344a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99920"
                      data-name="Path 99920"
                      d="M219.854,88.344a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99921"
                      data-name="Path 99921"
                      d="M227.934,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99922"
                      data-name="Path 99922"
                      d="M236,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99923"
                      data-name="Path 99923"
                      d="M244.084,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99924"
                      data-name="Path 99924"
                      d="M252.154,88.344a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -85.184)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99925"
                      data-name="Path 99925"
                      d="M72.84,90.794a.332.332,0,0,1-.331.331H71.46V90.46h1.05A.33.33,0,0,1,72.84,90.794Z"
                      transform="translate(-71.46 -86.744)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99926"
                      data-name="Path 99926"
                      d="M78.694,90.784a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99927"
                      data-name="Path 99927"
                      d="M86.774,90.784a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99928"
                      data-name="Path 99928"
                      d="M94.854,90.784a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99929"
                      data-name="Path 99929"
                      d="M102.924,90.784a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99930"
                      data-name="Path 99930"
                      d="M111,90.784a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99931"
                      data-name="Path 99931"
                      d="M119.074,90.784a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99932"
                      data-name="Path 99932"
                      d="M127.154,90.784a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99933"
                      data-name="Path 99933"
                      d="M135.234,90.784a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99934"
                      data-name="Path 99934"
                      d="M143.3,90.784a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99935"
                      data-name="Path 99935"
                      d="M151.384,90.784a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99936"
                      data-name="Path 99936"
                      d="M159.454,90.784a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99937"
                      data-name="Path 99937"
                      d="M167.534,90.784a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99938"
                      data-name="Path 99938"
                      d="M175.6,90.784a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99939"
                      data-name="Path 99939"
                      d="M183.684,90.784a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99940"
                      data-name="Path 99940"
                      d="M191.764,90.784a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99941"
                      data-name="Path 99941"
                      d="M199.834,90.784a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99942"
                      data-name="Path 99942"
                      d="M207.914,90.784a.332.332,0,0,1-.331.334H205.6a.332.332,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99943"
                      data-name="Path 99943"
                      d="M215.984,90.784a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99944"
                      data-name="Path 99944"
                      d="M224.064,90.784a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99945"
                      data-name="Path 99945"
                      d="M232.134,90.784a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99946"
                      data-name="Path 99946"
                      d="M240.214,90.784a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99947"
                      data-name="Path 99947"
                      d="M248.294,90.784a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -86.738)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99948"
                      data-name="Path 99948"
                      d="M254.932,90.46v.665h-.872a.329.329,0,0,1-.331-.331.335.335,0,0,1,.331-.334Z"
                      transform="translate(-187.526 -86.744)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99949"
                      data-name="Path 99949"
                      d="M74.484,93.454a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99950"
                      data-name="Path 99950"
                      d="M82.564,93.454a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99951"
                      data-name="Path 99951"
                      d="M90.644,93.454a.333.333,0,0,1-.331.334H88.331A.333.333,0,0,1,88,93.454h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99952"
                      data-name="Path 99952"
                      d="M98.714,93.454a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99953"
                      data-name="Path 99953"
                      d="M106.794,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99954"
                      data-name="Path 99954"
                      d="M114.864,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99955"
                      data-name="Path 99955"
                      d="M122.944,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99956"
                      data-name="Path 99956"
                      d="M131.024,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99957"
                      data-name="Path 99957"
                      d="M139.094,93.454a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99958"
                      data-name="Path 99958"
                      d="M147.174,93.454a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99959"
                      data-name="Path 99959"
                      d="M155.244,93.454a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99960"
                      data-name="Path 99960"
                      d="M163.324,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99961"
                      data-name="Path 99961"
                      d="M171.394,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99962"
                      data-name="Path 99962"
                      d="M179.474,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99963"
                      data-name="Path 99963"
                      d="M187.554,93.454a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-143.703 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99964"
                      data-name="Path 99964"
                      d="M195.624,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99965"
                      data-name="Path 99965"
                      d="M203.7,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99966"
                      data-name="Path 99966"
                      d="M211.774,93.454a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99967"
                      data-name="Path 99967"
                      d="M219.854,93.454a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99968"
                      data-name="Path 99968"
                      d="M227.934,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99969"
                      data-name="Path 99969"
                      d="M236,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99970"
                      data-name="Path 99970"
                      d="M244.084,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99971"
                      data-name="Path 99971"
                      d="M252.154,93.454a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -88.438)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99972"
                      data-name="Path 99972"
                      d="M72.84,95.9a.333.333,0,0,1-.331.334H71.46V95.57h1.05A.333.333,0,0,1,72.84,95.9Z"
                      transform="translate(-71.46 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99973"
                      data-name="Path 99973"
                      d="M78.694,95.9a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99974"
                      data-name="Path 99974"
                      d="M86.774,95.9a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99975"
                      data-name="Path 99975"
                      d="M94.854,95.9a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99976"
                      data-name="Path 99976"
                      d="M102.924,95.9a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99977"
                      data-name="Path 99977"
                      d="M111,95.9a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983A.333.333,0,0,1,111,95.9Z"
                      transform="translate(-94.957 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99978"
                      data-name="Path 99978"
                      d="M119.074,95.9a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99979"
                      data-name="Path 99979"
                      d="M127.154,95.9a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99980"
                      data-name="Path 99980"
                      d="M135.234,95.9a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99981"
                      data-name="Path 99981"
                      d="M143.3,95.9a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99982"
                      data-name="Path 99982"
                      d="M151.384,95.9a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99983"
                      data-name="Path 99983"
                      d="M159.454,95.9a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99984"
                      data-name="Path 99984"
                      d="M167.534,95.9a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99985"
                      data-name="Path 99985"
                      d="M175.6,95.9a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99986"
                      data-name="Path 99986"
                      d="M183.684,95.9a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99987"
                      data-name="Path 99987"
                      d="M191.764,95.9a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99988"
                      data-name="Path 99988"
                      d="M199.834,95.9a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99989"
                      data-name="Path 99989"
                      d="M207.914,95.9a.332.332,0,0,1-.331.334H205.6a.332.332,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99990"
                      data-name="Path 99990"
                      d="M215.984,95.9a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99991"
                      data-name="Path 99991"
                      d="M224.064,95.9a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99992"
                      data-name="Path 99992"
                      d="M232.134,95.9a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99993"
                      data-name="Path 99993"
                      d="M240.214,95.9a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99994"
                      data-name="Path 99994"
                      d="M248.294,95.9a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99995"
                      data-name="Path 99995"
                      d="M254.932,95.57v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -89.998)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99996"
                      data-name="Path 99996"
                      d="M74.484,98.574a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99997"
                      data-name="Path 99997"
                      d="M82.564,98.574a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99998"
                      data-name="Path 99998"
                      d="M90.644,98.574a.333.333,0,0,1-.331.334H88.331A.333.333,0,0,1,88,98.574h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_99999"
                      data-name="Path 99999"
                      d="M98.714,98.574a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100000"
                      data-name="Path 100000"
                      d="M106.794,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100001"
                      data-name="Path 100001"
                      d="M114.864,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100002"
                      data-name="Path 100002"
                      d="M122.944,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100003"
                      data-name="Path 100003"
                      d="M131.024,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100004"
                      data-name="Path 100004"
                      d="M139.094,98.574a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100005"
                      data-name="Path 100005"
                      d="M147.174,98.574a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100006"
                      data-name="Path 100006"
                      d="M155.244,98.574a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100007"
                      data-name="Path 100007"
                      d="M163.324,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100008"
                      data-name="Path 100008"
                      d="M171.394,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100009"
                      data-name="Path 100009"
                      d="M179.474,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100010"
                      data-name="Path 100010"
                      d="M187.554,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-143.703 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100011"
                      data-name="Path 100011"
                      d="M195.624,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100012"
                      data-name="Path 100012"
                      d="M203.7,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100013"
                      data-name="Path 100013"
                      d="M211.774,98.574a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100014"
                      data-name="Path 100014"
                      d="M219.854,98.574a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100015"
                      data-name="Path 100015"
                      d="M227.934,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100016"
                      data-name="Path 100016"
                      d="M236,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100017"
                      data-name="Path 100017"
                      d="M244.084,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100018"
                      data-name="Path 100018"
                      d="M252.154,98.574a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -91.698)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100019"
                      data-name="Path 100019"
                      d="M72.84,101.014a.333.333,0,0,1-.331.334H71.46v-.668h1.05A.333.333,0,0,1,72.84,101.014Z"
                      transform="translate(-71.46 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100020"
                      data-name="Path 100020"
                      d="M78.694,101.014a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100021"
                      data-name="Path 100021"
                      d="M86.774,101.014a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100022"
                      data-name="Path 100022"
                      d="M94.854,101.014a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100023"
                      data-name="Path 100023"
                      d="M102.924,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100024"
                      data-name="Path 100024"
                      d="M111,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100025"
                      data-name="Path 100025"
                      d="M119.074,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100026"
                      data-name="Path 100026"
                      d="M127.154,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100027"
                      data-name="Path 100027"
                      d="M135.234,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.332.332,0,0,1,.331.334Z"
                      transform="translate(-110.386 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100028"
                      data-name="Path 100028"
                      d="M143.3,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100029"
                      data-name="Path 100029"
                      d="M151.384,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100030"
                      data-name="Path 100030"
                      d="M159.454,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100031"
                      data-name="Path 100031"
                      d="M167.534,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100032"
                      data-name="Path 100032"
                      d="M175.6,101.014a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100033"
                      data-name="Path 100033"
                      d="M183.684,101.014a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100034"
                      data-name="Path 100034"
                      d="M191.764,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100035"
                      data-name="Path 100035"
                      d="M199.834,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100036"
                      data-name="Path 100036"
                      d="M207.914,101.014a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100037"
                      data-name="Path 100037"
                      d="M215.984,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100038"
                      data-name="Path 100038"
                      d="M224.064,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100039"
                      data-name="Path 100039"
                      d="M232.134,101.014a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100040"
                      data-name="Path 100040"
                      d="M240.214,101.014a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100041"
                      data-name="Path 100041"
                      d="M248.294,101.014a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100042"
                      data-name="Path 100042"
                      d="M254.932,100.68v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -93.252)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100043"
                      data-name="Path 100043"
                      d="M74.484,103.684a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100044"
                      data-name="Path 100044"
                      d="M82.564,103.684a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100045"
                      data-name="Path 100045"
                      d="M90.644,103.684a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100046"
                      data-name="Path 100046"
                      d="M98.714,103.684a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100047"
                      data-name="Path 100047"
                      d="M106.794,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100048"
                      data-name="Path 100048"
                      d="M114.864,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100049"
                      data-name="Path 100049"
                      d="M122.944,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100050"
                      data-name="Path 100050"
                      d="M131.024,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100051"
                      data-name="Path 100051"
                      d="M139.094,103.684a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100052"
                      data-name="Path 100052"
                      d="M147.174,103.684a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100053"
                      data-name="Path 100053"
                      d="M155.244,103.684a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100054"
                      data-name="Path 100054"
                      d="M163.324,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100055"
                      data-name="Path 100055"
                      d="M171.394,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100056"
                      data-name="Path 100056"
                      d="M179.474,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100057"
                      data-name="Path 100057"
                      d="M187.554,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-143.703 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100058"
                      data-name="Path 100058"
                      d="M195.624,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100059"
                      data-name="Path 100059"
                      d="M203.7,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100060"
                      data-name="Path 100060"
                      d="M211.774,103.684a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100061"
                      data-name="Path 100061"
                      d="M219.854,103.684a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100062"
                      data-name="Path 100062"
                      d="M227.934,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100063"
                      data-name="Path 100063"
                      d="M236,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100064"
                      data-name="Path 100064"
                      d="M244.084,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100065"
                      data-name="Path 100065"
                      d="M252.154,103.684a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -94.952)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100066"
                      data-name="Path 100066"
                      d="M72.84,106.134a.333.333,0,0,1-.331.334H71.46V105.8h1.05A.333.333,0,0,1,72.84,106.134Z"
                      transform="translate(-71.46 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100067"
                      data-name="Path 100067"
                      d="M78.694,106.134a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100068"
                      data-name="Path 100068"
                      d="M86.774,106.134a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100069"
                      data-name="Path 100069"
                      d="M94.854,106.134a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100070"
                      data-name="Path 100070"
                      d="M102.924,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100071"
                      data-name="Path 100071"
                      d="M111,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100072"
                      data-name="Path 100072"
                      d="M119.074,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100073"
                      data-name="Path 100073"
                      d="M127.154,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100074"
                      data-name="Path 100074"
                      d="M135.234,106.134a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100075"
                      data-name="Path 100075"
                      d="M143.3,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100076"
                      data-name="Path 100076"
                      d="M151.384,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100077"
                      data-name="Path 100077"
                      d="M159.454,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100078"
                      data-name="Path 100078"
                      d="M167.534,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100079"
                      data-name="Path 100079"
                      d="M175.6,106.134a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100080"
                      data-name="Path 100080"
                      d="M183.684,106.134a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100081"
                      data-name="Path 100081"
                      d="M191.764,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100082"
                      data-name="Path 100082"
                      d="M199.834,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100083"
                      data-name="Path 100083"
                      d="M207.914,106.134a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100084"
                      data-name="Path 100084"
                      d="M215.984,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100085"
                      data-name="Path 100085"
                      d="M224.064,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100086"
                      data-name="Path 100086"
                      d="M232.134,106.134a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100087"
                      data-name="Path 100087"
                      d="M240.214,106.134a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100088"
                      data-name="Path 100088"
                      d="M248.294,106.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100089"
                      data-name="Path 100089"
                      d="M254.932,105.8v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -96.513)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100090"
                      data-name="Path 100090"
                      d="M74.484,108.794a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100091"
                      data-name="Path 100091"
                      d="M82.564,108.794a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100092"
                      data-name="Path 100092"
                      d="M90.644,108.794a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100093"
                      data-name="Path 100093"
                      d="M98.714,108.794a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100094"
                      data-name="Path 100094"
                      d="M106.794,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100095"
                      data-name="Path 100095"
                      d="M114.864,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100096"
                      data-name="Path 100096"
                      d="M122.944,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100097"
                      data-name="Path 100097"
                      d="M131.024,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100098"
                      data-name="Path 100098"
                      d="M139.094,108.794a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100099"
                      data-name="Path 100099"
                      d="M147.174,108.794a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100100"
                      data-name="Path 100100"
                      d="M155.244,108.794a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100101"
                      data-name="Path 100101"
                      d="M163.324,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100102"
                      data-name="Path 100102"
                      d="M171.394,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100103"
                      data-name="Path 100103"
                      d="M179.474,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100104"
                      data-name="Path 100104"
                      d="M187.554,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-143.703 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100105"
                      data-name="Path 100105"
                      d="M195.624,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100106"
                      data-name="Path 100106"
                      d="M203.7,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100107"
                      data-name="Path 100107"
                      d="M211.774,108.794a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100108"
                      data-name="Path 100108"
                      d="M219.854,108.794a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100109"
                      data-name="Path 100109"
                      d="M227.934,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100110"
                      data-name="Path 100110"
                      d="M236,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100111"
                      data-name="Path 100111"
                      d="M244.084,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100112"
                      data-name="Path 100112"
                      d="M252.154,108.794a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -98.206)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100113"
                      data-name="Path 100113"
                      d="M72.84,111.244a.332.332,0,0,1-.331.331H71.46v-.665h1.05A.333.333,0,0,1,72.84,111.244Z"
                      transform="translate(-71.46 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100114"
                      data-name="Path 100114"
                      d="M78.694,111.244a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100115"
                      data-name="Path 100115"
                      d="M86.774,111.244a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100116"
                      data-name="Path 100116"
                      d="M94.854,111.244a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100117"
                      data-name="Path 100117"
                      d="M102.924,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100118"
                      data-name="Path 100118"
                      d="M111,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100119"
                      data-name="Path 100119"
                      d="M119.074,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100120"
                      data-name="Path 100120"
                      d="M127.154,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100121"
                      data-name="Path 100121"
                      d="M135.234,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.332.332,0,0,1,.331.334Z"
                      transform="translate(-110.386 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100122"
                      data-name="Path 100122"
                      d="M143.3,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100123"
                      data-name="Path 100123"
                      d="M151.384,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100124"
                      data-name="Path 100124"
                      d="M159.454,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100125"
                      data-name="Path 100125"
                      d="M167.534,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100126"
                      data-name="Path 100126"
                      d="M175.6,111.244a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100127"
                      data-name="Path 100127"
                      d="M183.684,111.244a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100128"
                      data-name="Path 100128"
                      d="M191.764,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100129"
                      data-name="Path 100129"
                      d="M199.834,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100130"
                      data-name="Path 100130"
                      d="M207.914,111.244a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-156.668 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100131"
                      data-name="Path 100131"
                      d="M215.984,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-161.806 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100132"
                      data-name="Path 100132"
                      d="M224.064,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100133"
                      data-name="Path 100133"
                      d="M232.134,111.244a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100134"
                      data-name="Path 100134"
                      d="M240.214,111.244a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100135"
                      data-name="Path 100135"
                      d="M248.294,111.244a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100136"
                      data-name="Path 100136"
                      d="M254.932,110.91v.665h-.872a.329.329,0,0,1-.331-.331.335.335,0,0,1,.331-.334Z"
                      transform="translate(-187.526 -99.766)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100137"
                      data-name="Path 100137"
                      d="M74.484,113.914a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100138"
                      data-name="Path 100138"
                      d="M82.564,113.914a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100139"
                      data-name="Path 100139"
                      d="M90.644,113.914a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100140"
                      data-name="Path 100140"
                      d="M98.714,113.914a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100141"
                      data-name="Path 100141"
                      d="M106.794,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100142"
                      data-name="Path 100142"
                      d="M114.864,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100143"
                      data-name="Path 100143"
                      d="M122.944,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100144"
                      data-name="Path 100144"
                      d="M131.024,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100145"
                      data-name="Path 100145"
                      d="M139.094,113.914a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100146"
                      data-name="Path 100146"
                      d="M147.174,113.914a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100147"
                      data-name="Path 100147"
                      d="M155.244,113.914a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100148"
                      data-name="Path 100148"
                      d="M163.324,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100149"
                      data-name="Path 100149"
                      d="M171.394,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100150"
                      data-name="Path 100150"
                      d="M179.474,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100151"
                      data-name="Path 100151"
                      d="M187.554,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-143.703 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100152"
                      data-name="Path 100152"
                      d="M195.624,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100153"
                      data-name="Path 100153"
                      d="M203.7,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100154"
                      data-name="Path 100154"
                      d="M211.774,113.914a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100155"
                      data-name="Path 100155"
                      d="M219.854,113.914a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100156"
                      data-name="Path 100156"
                      d="M227.934,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100157"
                      data-name="Path 100157"
                      d="M236,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100158"
                      data-name="Path 100158"
                      d="M244.084,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100159"
                      data-name="Path 100159"
                      d="M252.154,113.914a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -101.467)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100160"
                      data-name="Path 100160"
                      d="M72.84,116.361a.333.333,0,0,1-.331.334H71.46v-.665h1.05A.332.332,0,0,1,72.84,116.361Z"
                      transform="translate(-71.46 -103.027)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100161"
                      data-name="Path 100161"
                      d="M78.694,116.354a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100162"
                      data-name="Path 100162"
                      d="M86.774,116.354a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100163"
                      data-name="Path 100163"
                      d="M94.854,116.354a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100164"
                      data-name="Path 100164"
                      d="M102.924,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100165"
                      data-name="Path 100165"
                      d="M111,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100166"
                      data-name="Path 100166"
                      d="M119.074,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100167"
                      data-name="Path 100167"
                      d="M127.154,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100168"
                      data-name="Path 100168"
                      d="M135.234,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.332.332,0,0,1,.331.334Z"
                      transform="translate(-110.386 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100169"
                      data-name="Path 100169"
                      d="M143.3,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100170"
                      data-name="Path 100170"
                      d="M151.384,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100171"
                      data-name="Path 100171"
                      d="M159.454,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100172"
                      data-name="Path 100172"
                      d="M167.534,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100173"
                      data-name="Path 100173"
                      d="M175.6,116.354a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100174"
                      data-name="Path 100174"
                      d="M183.684,116.354a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100175"
                      data-name="Path 100175"
                      d="M191.764,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100176"
                      data-name="Path 100176"
                      d="M199.834,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100177"
                      data-name="Path 100177"
                      d="M207.914,116.354a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-156.668 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100178"
                      data-name="Path 100178"
                      d="M215.984,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-161.806 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100179"
                      data-name="Path 100179"
                      d="M224.064,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100180"
                      data-name="Path 100180"
                      d="M232.134,116.354a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100181"
                      data-name="Path 100181"
                      d="M240.214,116.354a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100182"
                      data-name="Path 100182"
                      d="M248.294,116.354a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -103.02)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100183"
                      data-name="Path 100183"
                      d="M254.932,116.03v.665h-.872a.332.332,0,0,1,0-.665Z"
                      transform="translate(-187.526 -103.027)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100184"
                      data-name="Path 100184"
                      d="M74.484,119.024a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100185"
                      data-name="Path 100185"
                      d="M82.564,119.024a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100186"
                      data-name="Path 100186"
                      d="M90.644,119.024a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100187"
                      data-name="Path 100187"
                      d="M98.714,119.024a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100188"
                      data-name="Path 100188"
                      d="M106.794,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100189"
                      data-name="Path 100189"
                      d="M114.864,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100190"
                      data-name="Path 100190"
                      d="M122.944,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100191"
                      data-name="Path 100191"
                      d="M131.024,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100192"
                      data-name="Path 100192"
                      d="M139.094,119.024a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100193"
                      data-name="Path 100193"
                      d="M147.174,119.024a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100194"
                      data-name="Path 100194"
                      d="M155.244,119.024a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100195"
                      data-name="Path 100195"
                      d="M163.324,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100196"
                      data-name="Path 100196"
                      d="M171.394,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100197"
                      data-name="Path 100197"
                      d="M179.474,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100198"
                      data-name="Path 100198"
                      d="M187.554,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-143.703 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100199"
                      data-name="Path 100199"
                      d="M195.624,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100200"
                      data-name="Path 100200"
                      d="M203.7,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100201"
                      data-name="Path 100201"
                      d="M211.774,119.024a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100202"
                      data-name="Path 100202"
                      d="M219.854,119.024a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100203"
                      data-name="Path 100203"
                      d="M227.934,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100204"
                      data-name="Path 100204"
                      d="M236,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100205"
                      data-name="Path 100205"
                      d="M244.084,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100206"
                      data-name="Path 100206"
                      d="M252.154,119.024a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -104.721)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100207"
                      data-name="Path 100207"
                      d="M72.84,121.464a.333.333,0,0,1-.331.334H71.46v-.668h1.05A.333.333,0,0,1,72.84,121.464Z"
                      transform="translate(-71.46 -106.274)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100208"
                      data-name="Path 100208"
                      d="M78.694,121.474a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100209"
                      data-name="Path 100209"
                      d="M86.774,121.474a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100210"
                      data-name="Path 100210"
                      d="M94.854,121.474a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100211"
                      data-name="Path 100211"
                      d="M102.924,121.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100212"
                      data-name="Path 100212"
                      d="M111,121.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100213"
                      data-name="Path 100213"
                      d="M119.074,121.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100214"
                      data-name="Path 100214"
                      d="M127.154,121.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100215"
                      data-name="Path 100215"
                      d="M135.234,121.474a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100216"
                      data-name="Path 100216"
                      d="M143.3,121.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100217"
                      data-name="Path 100217"
                      d="M151.384,121.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100218"
                      data-name="Path 100218"
                      d="M159.454,121.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100219"
                      data-name="Path 100219"
                      d="M167.534,121.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100220"
                      data-name="Path 100220"
                      d="M175.6,121.474a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100221"
                      data-name="Path 100221"
                      d="M183.684,121.474a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100222"
                      data-name="Path 100222"
                      d="M191.764,121.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100223"
                      data-name="Path 100223"
                      d="M199.834,121.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100224"
                      data-name="Path 100224"
                      d="M207.914,121.474a.332.332,0,0,1-.331.334H205.6a.332.332,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100225"
                      data-name="Path 100225"
                      d="M215.984,121.474a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100226"
                      data-name="Path 100226"
                      d="M224.064,121.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100227"
                      data-name="Path 100227"
                      d="M232.134,121.474a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100228"
                      data-name="Path 100228"
                      d="M240.214,121.474a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100229"
                      data-name="Path 100229"
                      d="M248.294,121.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -106.281)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100230"
                      data-name="Path 100230"
                      d="M254.932,121.13v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -106.274)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100231"
                      data-name="Path 100231"
                      d="M74.484,124.134a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100232"
                      data-name="Path 100232"
                      d="M82.564,124.134a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100233"
                      data-name="Path 100233"
                      d="M90.644,124.134a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100234"
                      data-name="Path 100234"
                      d="M98.714,124.134a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100235"
                      data-name="Path 100235"
                      d="M106.794,124.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100236"
                      data-name="Path 100236"
                      d="M114.864,124.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100237"
                      data-name="Path 100237"
                      d="M122.944,124.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100238"
                      data-name="Path 100238"
                      d="M131.024,124.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100239"
                      data-name="Path 100239"
                      d="M139.094,124.134a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100240"
                      data-name="Path 100240"
                      d="M147.174,124.134a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100241"
                      data-name="Path 100241"
                      d="M155.244,124.134a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100242"
                      data-name="Path 100242"
                      d="M163.324,124.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100243"
                      data-name="Path 100243"
                      d="M171.394,124.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100244"
                      data-name="Path 100244"
                      d="M179.474,124.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100245"
                      data-name="Path 100245"
                      d="M187.554,124.134a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-143.703 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100246"
                      data-name="Path 100246"
                      d="M195.624,124.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100247"
                      data-name="Path 100247"
                      d="M203.7,124.134a.333.333,0,0,1-.331.334h-1.983a.332.332,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100248"
                      data-name="Path 100248"
                      d="M211.774,124.134a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100249"
                      data-name="Path 100249"
                      d="M219.854,124.134a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100250"
                      data-name="Path 100250"
                      d="M227.934,124.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100251"
                      data-name="Path 100251"
                      d="M236,124.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100252"
                      data-name="Path 100252"
                      d="M244.084,124.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100253"
                      data-name="Path 100253"
                      d="M252.154,124.134a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -107.975)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100254"
                      data-name="Path 100254"
                      d="M72.84,126.584a.333.333,0,0,1-.331.334H71.46v-.668h1.05A.333.333,0,0,1,72.84,126.584Z"
                      transform="translate(-71.46 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100255"
                      data-name="Path 100255"
                      d="M78.694,126.584a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100256"
                      data-name="Path 100256"
                      d="M86.774,126.584a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100257"
                      data-name="Path 100257"
                      d="M94.854,126.584a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100258"
                      data-name="Path 100258"
                      d="M102.924,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100259"
                      data-name="Path 100259"
                      d="M111,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100260"
                      data-name="Path 100260"
                      d="M119.074,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100261"
                      data-name="Path 100261"
                      d="M127.154,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100262"
                      data-name="Path 100262"
                      d="M135.234,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100263"
                      data-name="Path 100263"
                      d="M143.3,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100264"
                      data-name="Path 100264"
                      d="M151.384,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100265"
                      data-name="Path 100265"
                      d="M159.454,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100266"
                      data-name="Path 100266"
                      d="M167.534,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100267"
                      data-name="Path 100267"
                      d="M175.6,126.584a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100268"
                      data-name="Path 100268"
                      d="M183.684,126.584a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100269"
                      data-name="Path 100269"
                      d="M191.764,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100270"
                      data-name="Path 100270"
                      d="M199.834,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100271"
                      data-name="Path 100271"
                      d="M207.914,126.584a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100272"
                      data-name="Path 100272"
                      d="M215.984,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100273"
                      data-name="Path 100273"
                      d="M224.064,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100274"
                      data-name="Path 100274"
                      d="M232.134,126.584a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100275"
                      data-name="Path 100275"
                      d="M240.214,126.584a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100276"
                      data-name="Path 100276"
                      d="M248.294,126.584a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100277"
                      data-name="Path 100277"
                      d="M254.932,126.25v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -109.535)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100278"
                      data-name="Path 100278"
                      d="M74.484,129.254a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100279"
                      data-name="Path 100279"
                      d="M82.564,129.254a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100280"
                      data-name="Path 100280"
                      d="M90.644,129.254a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100281"
                      data-name="Path 100281"
                      d="M98.714,129.254a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100282"
                      data-name="Path 100282"
                      d="M106.794,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100283"
                      data-name="Path 100283"
                      d="M114.864,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100284"
                      data-name="Path 100284"
                      d="M122.944,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100285"
                      data-name="Path 100285"
                      d="M131.024,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100286"
                      data-name="Path 100286"
                      d="M139.094,129.254a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100287"
                      data-name="Path 100287"
                      d="M147.174,129.254a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100288"
                      data-name="Path 100288"
                      d="M155.244,129.254a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100289"
                      data-name="Path 100289"
                      d="M163.324,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100290"
                      data-name="Path 100290"
                      d="M171.394,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100291"
                      data-name="Path 100291"
                      d="M179.474,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100292"
                      data-name="Path 100292"
                      d="M187.554,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-143.703 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100293"
                      data-name="Path 100293"
                      d="M195.624,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100294"
                      data-name="Path 100294"
                      d="M203.7,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100295"
                      data-name="Path 100295"
                      d="M211.774,129.254a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100296"
                      data-name="Path 100296"
                      d="M219.854,129.254a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100297"
                      data-name="Path 100297"
                      d="M227.934,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100298"
                      data-name="Path 100298"
                      d="M236,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100299"
                      data-name="Path 100299"
                      d="M244.084,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100300"
                      data-name="Path 100300"
                      d="M252.154,129.254a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -111.235)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100301"
                      data-name="Path 100301"
                      d="M72.84,131.694a.329.329,0,0,1-.331.331H71.46v-.665h1.05A.333.333,0,0,1,72.84,131.694Z"
                      transform="translate(-71.46 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100302"
                      data-name="Path 100302"
                      d="M78.694,131.694a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100303"
                      data-name="Path 100303"
                      d="M86.774,131.694a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100304"
                      data-name="Path 100304"
                      d="M94.854,131.694a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100305"
                      data-name="Path 100305"
                      d="M102.924,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100306"
                      data-name="Path 100306"
                      d="M111,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100307"
                      data-name="Path 100307"
                      d="M119.074,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100308"
                      data-name="Path 100308"
                      d="M127.154,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100309"
                      data-name="Path 100309"
                      d="M135.234,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100310"
                      data-name="Path 100310"
                      d="M143.3,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100311"
                      data-name="Path 100311"
                      d="M151.384,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100312"
                      data-name="Path 100312"
                      d="M159.454,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100313"
                      data-name="Path 100313"
                      d="M167.534,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100314"
                      data-name="Path 100314"
                      d="M175.6,131.694a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100315"
                      data-name="Path 100315"
                      d="M183.684,131.694a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100316"
                      data-name="Path 100316"
                      d="M191.764,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100317"
                      data-name="Path 100317"
                      d="M199.834,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100318"
                      data-name="Path 100318"
                      d="M207.914,131.694a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100319"
                      data-name="Path 100319"
                      d="M215.984,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100320"
                      data-name="Path 100320"
                      d="M224.064,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100321"
                      data-name="Path 100321"
                      d="M232.134,131.694a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100322"
                      data-name="Path 100322"
                      d="M240.214,131.694a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100323"
                      data-name="Path 100323"
                      d="M248.294,131.694a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100324"
                      data-name="Path 100324"
                      d="M254.932,131.36v.665h-.872a.329.329,0,0,1-.331-.331.335.335,0,0,1,.331-.334Z"
                      transform="translate(-187.526 -112.789)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100325"
                      data-name="Path 100325"
                      d="M74.484,134.364a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100326"
                      data-name="Path 100326"
                      d="M82.564,134.364a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100327"
                      data-name="Path 100327"
                      d="M90.644,134.364a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100328"
                      data-name="Path 100328"
                      d="M98.714,134.364a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100329"
                      data-name="Path 100329"
                      d="M106.794,134.364a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100330"
                      data-name="Path 100330"
                      d="M114.864,134.364a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100331"
                      data-name="Path 100331"
                      d="M122.944,134.364a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100332"
                      data-name="Path 100332"
                      d="M131.024,134.364a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100333"
                      data-name="Path 100333"
                      d="M139.094,134.364a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100334"
                      data-name="Path 100334"
                      d="M147.174,134.364a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100335"
                      data-name="Path 100335"
                      d="M155.244,134.364a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100336"
                      data-name="Path 100336"
                      d="M163.324,134.364a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100337"
                      data-name="Path 100337"
                      d="M171.394,134.364a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100338"
                      data-name="Path 100338"
                      d="M179.474,134.364a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100339"
                      data-name="Path 100339"
                      d="M187.554,134.364a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-143.703 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100340"
                      data-name="Path 100340"
                      d="M195.624,134.364a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100341"
                      data-name="Path 100341"
                      d="M203.7,134.364a.333.333,0,0,1-.331.334h-1.983a.332.332,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100342"
                      data-name="Path 100342"
                      d="M211.774,134.364a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100343"
                      data-name="Path 100343"
                      d="M219.854,134.364a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100344"
                      data-name="Path 100344"
                      d="M227.934,134.364a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100345"
                      data-name="Path 100345"
                      d="M236,134.364a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100346"
                      data-name="Path 100346"
                      d="M244.084,134.364a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100347"
                      data-name="Path 100347"
                      d="M252.154,134.364a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -114.489)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100348"
                      data-name="Path 100348"
                      d="M72.84,136.814a.332.332,0,0,1-.331.331H71.46v-.665h1.05A.333.333,0,0,1,72.84,136.814Z"
                      transform="translate(-71.46 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100349"
                      data-name="Path 100349"
                      d="M78.694,136.814a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100350"
                      data-name="Path 100350"
                      d="M86.774,136.814a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100351"
                      data-name="Path 100351"
                      d="M94.854,136.814a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100352"
                      data-name="Path 100352"
                      d="M102.924,136.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100353"
                      data-name="Path 100353"
                      d="M111,136.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100354"
                      data-name="Path 100354"
                      d="M119.074,136.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100355"
                      data-name="Path 100355"
                      d="M127.154,136.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100356"
                      data-name="Path 100356"
                      d="M135.234,136.814a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.332.332,0,0,1,.331.334Z"
                      transform="translate(-110.386 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100357"
                      data-name="Path 100357"
                      d="M143.3,136.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100358"
                      data-name="Path 100358"
                      d="M151.384,136.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100359"
                      data-name="Path 100359"
                      d="M159.454,136.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100360"
                      data-name="Path 100360"
                      d="M167.534,136.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100361"
                      data-name="Path 100361"
                      d="M175.6,136.814a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100362"
                      data-name="Path 100362"
                      d="M183.684,136.814a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100363"
                      data-name="Path 100363"
                      d="M191.764,136.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100364"
                      data-name="Path 100364"
                      d="M199.834,136.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100365"
                      data-name="Path 100365"
                      d="M207.914,136.814a.332.332,0,0,1-.331.334H205.6a.332.332,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-156.668 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100366"
                      data-name="Path 100366"
                      d="M215.984,136.814a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-161.806 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100367"
                      data-name="Path 100367"
                      d="M224.064,136.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100368"
                      data-name="Path 100368"
                      d="M232.134,136.814a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100369"
                      data-name="Path 100369"
                      d="M240.214,136.814a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100370"
                      data-name="Path 100370"
                      d="M248.294,136.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100371"
                      data-name="Path 100371"
                      d="M254.932,136.48v.665h-.872a.329.329,0,0,1-.331-.331.335.335,0,0,1,.331-.334Z"
                      transform="translate(-187.526 -116.049)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100372"
                      data-name="Path 100372"
                      d="M74.484,139.474a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100373"
                      data-name="Path 100373"
                      d="M82.564,139.474a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100374"
                      data-name="Path 100374"
                      d="M90.644,139.474a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100375"
                      data-name="Path 100375"
                      d="M98.714,139.474a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100376"
                      data-name="Path 100376"
                      d="M106.794,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100377"
                      data-name="Path 100377"
                      d="M114.864,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100378"
                      data-name="Path 100378"
                      d="M122.944,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100379"
                      data-name="Path 100379"
                      d="M131.024,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100380"
                      data-name="Path 100380"
                      d="M139.094,139.474a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100381"
                      data-name="Path 100381"
                      d="M147.174,139.474a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100382"
                      data-name="Path 100382"
                      d="M155.244,139.474a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100383"
                      data-name="Path 100383"
                      d="M163.324,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100384"
                      data-name="Path 100384"
                      d="M171.394,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100385"
                      data-name="Path 100385"
                      d="M179.474,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100386"
                      data-name="Path 100386"
                      d="M187.554,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-143.703 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100387"
                      data-name="Path 100387"
                      d="M195.624,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100388"
                      data-name="Path 100388"
                      d="M203.7,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100389"
                      data-name="Path 100389"
                      d="M211.774,139.474a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100390"
                      data-name="Path 100390"
                      d="M219.854,139.474a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100391"
                      data-name="Path 100391"
                      d="M227.934,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100392"
                      data-name="Path 100392"
                      d="M236,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100393"
                      data-name="Path 100393"
                      d="M244.084,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100394"
                      data-name="Path 100394"
                      d="M252.154,139.474a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -117.743)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100395"
                      data-name="Path 100395"
                      d="M72.84,141.924a.333.333,0,0,1-.331.334H71.46v-.668h1.05A.333.333,0,0,1,72.84,141.924Z"
                      transform="translate(-71.46 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100396"
                      data-name="Path 100396"
                      d="M78.694,141.924a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100397"
                      data-name="Path 100397"
                      d="M86.774,141.924a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100398"
                      data-name="Path 100398"
                      d="M94.854,141.924a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100399"
                      data-name="Path 100399"
                      d="M102.924,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100400"
                      data-name="Path 100400"
                      d="M111,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100401"
                      data-name="Path 100401"
                      d="M119.074,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100402"
                      data-name="Path 100402"
                      d="M127.154,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100403"
                      data-name="Path 100403"
                      d="M135.234,141.924a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100404"
                      data-name="Path 100404"
                      d="M143.3,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100405"
                      data-name="Path 100405"
                      d="M151.384,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100406"
                      data-name="Path 100406"
                      d="M159.454,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100407"
                      data-name="Path 100407"
                      d="M167.534,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100408"
                      data-name="Path 100408"
                      d="M175.6,141.924a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100409"
                      data-name="Path 100409"
                      d="M183.684,141.924a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100410"
                      data-name="Path 100410"
                      d="M191.764,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100411"
                      data-name="Path 100411"
                      d="M199.834,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100412"
                      data-name="Path 100412"
                      d="M207.914,141.924a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100413"
                      data-name="Path 100413"
                      d="M215.984,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100414"
                      data-name="Path 100414"
                      d="M224.064,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100415"
                      data-name="Path 100415"
                      d="M232.134,141.924a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100416"
                      data-name="Path 100416"
                      d="M240.214,141.924a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100417"
                      data-name="Path 100417"
                      d="M248.294,141.924a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100418"
                      data-name="Path 100418"
                      d="M254.932,141.59v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -119.303)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100419"
                      data-name="Path 100419"
                      d="M74.484,144.594a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100420"
                      data-name="Path 100420"
                      d="M82.564,144.594a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100421"
                      data-name="Path 100421"
                      d="M90.644,144.594a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100422"
                      data-name="Path 100422"
                      d="M98.714,144.594a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100423"
                      data-name="Path 100423"
                      d="M106.794,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100424"
                      data-name="Path 100424"
                      d="M114.864,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100425"
                      data-name="Path 100425"
                      d="M122.944,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100426"
                      data-name="Path 100426"
                      d="M131.024,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100427"
                      data-name="Path 100427"
                      d="M139.094,144.594a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100428"
                      data-name="Path 100428"
                      d="M147.174,144.594a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100429"
                      data-name="Path 100429"
                      d="M155.244,144.594a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100430"
                      data-name="Path 100430"
                      d="M163.324,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100431"
                      data-name="Path 100431"
                      d="M171.394,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100432"
                      data-name="Path 100432"
                      d="M179.474,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100433"
                      data-name="Path 100433"
                      d="M187.554,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-143.703 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100434"
                      data-name="Path 100434"
                      d="M195.624,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100435"
                      data-name="Path 100435"
                      d="M203.7,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100436"
                      data-name="Path 100436"
                      d="M211.774,144.594a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100437"
                      data-name="Path 100437"
                      d="M219.854,144.594a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100438"
                      data-name="Path 100438"
                      d="M227.934,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100439"
                      data-name="Path 100439"
                      d="M236,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100440"
                      data-name="Path 100440"
                      d="M244.084,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100441"
                      data-name="Path 100441"
                      d="M252.154,144.594a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -121.003)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100442"
                      data-name="Path 100442"
                      d="M72.84,147.034a.333.333,0,0,1-.331.334H71.46V146.7h1.05A.333.333,0,0,1,72.84,147.034Z"
                      transform="translate(-71.46 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100443"
                      data-name="Path 100443"
                      d="M78.694,147.034a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100444"
                      data-name="Path 100444"
                      d="M86.774,147.034a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100445"
                      data-name="Path 100445"
                      d="M94.854,147.034a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100446"
                      data-name="Path 100446"
                      d="M102.924,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100447"
                      data-name="Path 100447"
                      d="M111,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100448"
                      data-name="Path 100448"
                      d="M119.074,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100449"
                      data-name="Path 100449"
                      d="M127.154,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100450"
                      data-name="Path 100450"
                      d="M135.234,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100451"
                      data-name="Path 100451"
                      d="M143.3,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100452"
                      data-name="Path 100452"
                      d="M151.384,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100453"
                      data-name="Path 100453"
                      d="M159.454,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100454"
                      data-name="Path 100454"
                      d="M167.534,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100455"
                      data-name="Path 100455"
                      d="M175.6,147.034a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100456"
                      data-name="Path 100456"
                      d="M183.684,147.034a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100457"
                      data-name="Path 100457"
                      d="M191.764,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100458"
                      data-name="Path 100458"
                      d="M199.834,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100459"
                      data-name="Path 100459"
                      d="M207.914,147.034a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100460"
                      data-name="Path 100460"
                      d="M215.984,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100461"
                      data-name="Path 100461"
                      d="M224.064,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100462"
                      data-name="Path 100462"
                      d="M232.134,147.034a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100463"
                      data-name="Path 100463"
                      d="M240.214,147.034a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100464"
                      data-name="Path 100464"
                      d="M248.294,147.034a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100465"
                      data-name="Path 100465"
                      d="M254.932,146.7v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -122.557)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100466"
                      data-name="Path 100466"
                      d="M74.484,149.7a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100467"
                      data-name="Path 100467"
                      d="M82.564,149.7a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100468"
                      data-name="Path 100468"
                      d="M90.644,149.7a.333.333,0,0,1-.331.334H88.331A.333.333,0,0,1,88,149.7h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100469"
                      data-name="Path 100469"
                      d="M98.714,149.7a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100470"
                      data-name="Path 100470"
                      d="M106.794,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100471"
                      data-name="Path 100471"
                      d="M114.864,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100472"
                      data-name="Path 100472"
                      d="M122.944,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100473"
                      data-name="Path 100473"
                      d="M131.024,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100474"
                      data-name="Path 100474"
                      d="M139.094,149.7a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100475"
                      data-name="Path 100475"
                      d="M147.174,149.7a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100476"
                      data-name="Path 100476"
                      d="M155.244,149.7a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100477"
                      data-name="Path 100477"
                      d="M163.324,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100478"
                      data-name="Path 100478"
                      d="M171.394,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100479"
                      data-name="Path 100479"
                      d="M179.474,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100480"
                      data-name="Path 100480"
                      d="M187.554,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-143.703 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100481"
                      data-name="Path 100481"
                      d="M195.624,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100482"
                      data-name="Path 100482"
                      d="M203.7,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100483"
                      data-name="Path 100483"
                      d="M211.774,149.7a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100484"
                      data-name="Path 100484"
                      d="M219.854,149.7a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100485"
                      data-name="Path 100485"
                      d="M227.934,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100486"
                      data-name="Path 100486"
                      d="M236,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100487"
                      data-name="Path 100487"
                      d="M244.084,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100488"
                      data-name="Path 100488"
                      d="M252.154,149.7a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -124.257)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100489"
                      data-name="Path 100489"
                      d="M72.84,152.154a.333.333,0,0,1-.331.334H71.46v-.668h1.05A.333.333,0,0,1,72.84,152.154Z"
                      transform="translate(-71.46 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100490"
                      data-name="Path 100490"
                      d="M78.694,152.154a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100491"
                      data-name="Path 100491"
                      d="M86.774,152.154a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100492"
                      data-name="Path 100492"
                      d="M94.854,152.154a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100493"
                      data-name="Path 100493"
                      d="M102.924,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100494"
                      data-name="Path 100494"
                      d="M111,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100495"
                      data-name="Path 100495"
                      d="M119.074,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100496"
                      data-name="Path 100496"
                      d="M127.154,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100497"
                      data-name="Path 100497"
                      d="M135.234,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.332.332,0,0,1,.331.334Z"
                      transform="translate(-110.386 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100498"
                      data-name="Path 100498"
                      d="M143.3,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100499"
                      data-name="Path 100499"
                      d="M151.384,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100500"
                      data-name="Path 100500"
                      d="M159.454,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100501"
                      data-name="Path 100501"
                      d="M167.534,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100502"
                      data-name="Path 100502"
                      d="M175.6,152.154a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100503"
                      data-name="Path 100503"
                      d="M183.684,152.154a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100504"
                      data-name="Path 100504"
                      d="M191.764,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100505"
                      data-name="Path 100505"
                      d="M199.834,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100506"
                      data-name="Path 100506"
                      d="M207.914,152.154a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-156.668 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100507"
                      data-name="Path 100507"
                      d="M215.984,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-161.806 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100508"
                      data-name="Path 100508"
                      d="M224.064,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100509"
                      data-name="Path 100509"
                      d="M232.134,152.154a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100510"
                      data-name="Path 100510"
                      d="M240.214,152.154a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100511"
                      data-name="Path 100511"
                      d="M248.294,152.154a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100512"
                      data-name="Path 100512"
                      d="M254.932,151.82v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -125.817)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100513"
                      data-name="Path 100513"
                      d="M74.484,154.814a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100514"
                      data-name="Path 100514"
                      d="M82.564,154.814a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100515"
                      data-name="Path 100515"
                      d="M90.644,154.814a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100516"
                      data-name="Path 100516"
                      d="M98.714,154.814a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100517"
                      data-name="Path 100517"
                      d="M106.794,154.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100518"
                      data-name="Path 100518"
                      d="M114.864,154.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100519"
                      data-name="Path 100519"
                      d="M122.944,154.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100520"
                      data-name="Path 100520"
                      d="M131.024,154.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100521"
                      data-name="Path 100521"
                      d="M139.094,154.814a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100522"
                      data-name="Path 100522"
                      d="M147.174,154.814a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100523"
                      data-name="Path 100523"
                      d="M155.244,154.814a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100524"
                      data-name="Path 100524"
                      d="M163.324,154.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100525"
                      data-name="Path 100525"
                      d="M171.394,154.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100526"
                      data-name="Path 100526"
                      d="M179.474,154.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100527"
                      data-name="Path 100527"
                      d="M187.554,154.814a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-143.703 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100528"
                      data-name="Path 100528"
                      d="M195.624,154.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100529"
                      data-name="Path 100529"
                      d="M203.7,154.814a.333.333,0,0,1-.331.334h-1.983a.332.332,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100530"
                      data-name="Path 100530"
                      d="M211.774,154.814a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100531"
                      data-name="Path 100531"
                      d="M219.854,154.814a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100532"
                      data-name="Path 100532"
                      d="M227.934,154.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100533"
                      data-name="Path 100533"
                      d="M236,154.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100534"
                      data-name="Path 100534"
                      d="M244.084,154.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100535"
                      data-name="Path 100535"
                      d="M252.154,154.814a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -127.511)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100536"
                      data-name="Path 100536"
                      d="M72.84,157.264a.333.333,0,0,1-.331.334H71.46v-.668h1.05A.333.333,0,0,1,72.84,157.264Z"
                      transform="translate(-71.46 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100537"
                      data-name="Path 100537"
                      d="M78.694,157.264a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100538"
                      data-name="Path 100538"
                      d="M86.774,157.264a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100539"
                      data-name="Path 100539"
                      d="M94.854,157.264a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100540"
                      data-name="Path 100540"
                      d="M102.924,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100541"
                      data-name="Path 100541"
                      d="M111,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100542"
                      data-name="Path 100542"
                      d="M119.074,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100543"
                      data-name="Path 100543"
                      d="M127.154,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100544"
                      data-name="Path 100544"
                      d="M135.234,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100545"
                      data-name="Path 100545"
                      d="M143.3,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100546"
                      data-name="Path 100546"
                      d="M151.384,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100547"
                      data-name="Path 100547"
                      d="M159.454,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100548"
                      data-name="Path 100548"
                      d="M167.534,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100549"
                      data-name="Path 100549"
                      d="M175.6,157.264a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100550"
                      data-name="Path 100550"
                      d="M183.684,157.264a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100551"
                      data-name="Path 100551"
                      d="M191.764,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100552"
                      data-name="Path 100552"
                      d="M199.834,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100553"
                      data-name="Path 100553"
                      d="M207.914,157.264a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100554"
                      data-name="Path 100554"
                      d="M215.984,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100555"
                      data-name="Path 100555"
                      d="M224.064,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100556"
                      data-name="Path 100556"
                      d="M232.134,157.264a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100557"
                      data-name="Path 100557"
                      d="M240.214,157.264a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100558"
                      data-name="Path 100558"
                      d="M248.294,157.264a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100559"
                      data-name="Path 100559"
                      d="M254.932,156.93v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -129.071)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100560"
                      data-name="Path 100560"
                      d="M74.484,159.934a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100561"
                      data-name="Path 100561"
                      d="M82.564,159.934a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100562"
                      data-name="Path 100562"
                      d="M90.644,159.934a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100563"
                      data-name="Path 100563"
                      d="M98.714,159.934a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100564"
                      data-name="Path 100564"
                      d="M106.794,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100565"
                      data-name="Path 100565"
                      d="M114.864,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100566"
                      data-name="Path 100566"
                      d="M122.944,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100567"
                      data-name="Path 100567"
                      d="M131.024,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100568"
                      data-name="Path 100568"
                      d="M139.094,159.934a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100569"
                      data-name="Path 100569"
                      d="M147.174,159.934a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100570"
                      data-name="Path 100570"
                      d="M155.244,159.934a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100571"
                      data-name="Path 100571"
                      d="M163.324,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100572"
                      data-name="Path 100572"
                      d="M171.394,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100573"
                      data-name="Path 100573"
                      d="M179.474,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100574"
                      data-name="Path 100574"
                      d="M187.554,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-143.703 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100575"
                      data-name="Path 100575"
                      d="M195.624,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100576"
                      data-name="Path 100576"
                      d="M203.7,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100577"
                      data-name="Path 100577"
                      d="M211.774,159.934a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100578"
                      data-name="Path 100578"
                      d="M219.854,159.934a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100579"
                      data-name="Path 100579"
                      d="M227.934,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100580"
                      data-name="Path 100580"
                      d="M236,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100581"
                      data-name="Path 100581"
                      d="M244.084,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100582"
                      data-name="Path 100582"
                      d="M252.154,159.934a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -130.771)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100583"
                      data-name="Path 100583"
                      d="M72.84,162.381a.333.333,0,0,1-.331.334H71.46v-.665h1.05A.332.332,0,0,1,72.84,162.381Z"
                      transform="translate(-71.46 -132.331)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100584"
                      data-name="Path 100584"
                      d="M78.694,162.374a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100585"
                      data-name="Path 100585"
                      d="M86.774,162.374a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100586"
                      data-name="Path 100586"
                      d="M94.854,162.374a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100587"
                      data-name="Path 100587"
                      d="M102.924,162.374a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100588"
                      data-name="Path 100588"
                      d="M111,162.374a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100589"
                      data-name="Path 100589"
                      d="M119.074,162.374a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100590"
                      data-name="Path 100590"
                      d="M127.154,162.374a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100591"
                      data-name="Path 100591"
                      d="M135.234,162.374a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100592"
                      data-name="Path 100592"
                      d="M143.3,162.374a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100593"
                      data-name="Path 100593"
                      d="M151.384,162.374a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100594"
                      data-name="Path 100594"
                      d="M159.454,162.374a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100595"
                      data-name="Path 100595"
                      d="M167.534,162.374a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100596"
                      data-name="Path 100596"
                      d="M175.6,162.374a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100597"
                      data-name="Path 100597"
                      d="M183.684,162.374a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100598"
                      data-name="Path 100598"
                      d="M191.764,162.374a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100599"
                      data-name="Path 100599"
                      d="M199.834,162.374a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100600"
                      data-name="Path 100600"
                      d="M207.914,162.374a.332.332,0,0,1-.331.334H205.6a.332.332,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100601"
                      data-name="Path 100601"
                      d="M215.984,162.374a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100602"
                      data-name="Path 100602"
                      d="M224.064,162.374a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100603"
                      data-name="Path 100603"
                      d="M232.134,162.374a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100604"
                      data-name="Path 100604"
                      d="M240.214,162.374a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100605"
                      data-name="Path 100605"
                      d="M248.294,162.374a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -132.325)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100606"
                      data-name="Path 100606"
                      d="M254.932,162.05v.665h-.872a.332.332,0,0,1,0-.665Z"
                      transform="translate(-187.526 -132.331)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100607"
                      data-name="Path 100607"
                      d="M74.484,165.044a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100608"
                      data-name="Path 100608"
                      d="M82.564,165.044a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100609"
                      data-name="Path 100609"
                      d="M90.644,165.044a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100610"
                      data-name="Path 100610"
                      d="M98.714,165.044a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100611"
                      data-name="Path 100611"
                      d="M106.794,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100612"
                      data-name="Path 100612"
                      d="M114.864,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100613"
                      data-name="Path 100613"
                      d="M122.944,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100614"
                      data-name="Path 100614"
                      d="M131.024,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100615"
                      data-name="Path 100615"
                      d="M139.094,165.044a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100616"
                      data-name="Path 100616"
                      d="M147.174,165.044a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100617"
                      data-name="Path 100617"
                      d="M155.244,165.044a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100618"
                      data-name="Path 100618"
                      d="M163.324,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100619"
                      data-name="Path 100619"
                      d="M171.394,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100620"
                      data-name="Path 100620"
                      d="M179.474,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100621"
                      data-name="Path 100621"
                      d="M187.554,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-143.703 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100622"
                      data-name="Path 100622"
                      d="M195.624,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100623"
                      data-name="Path 100623"
                      d="M203.7,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100624"
                      data-name="Path 100624"
                      d="M211.774,165.044a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100625"
                      data-name="Path 100625"
                      d="M219.854,165.044a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100626"
                      data-name="Path 100626"
                      d="M227.934,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100627"
                      data-name="Path 100627"
                      d="M236,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100628"
                      data-name="Path 100628"
                      d="M244.084,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100629"
                      data-name="Path 100629"
                      d="M252.154,165.044a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -134.025)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100630"
                      data-name="Path 100630"
                      d="M72.84,167.494a.333.333,0,0,1-.331.334H71.46v-.668h1.05A.333.333,0,0,1,72.84,167.494Z"
                      transform="translate(-71.46 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100631"
                      data-name="Path 100631"
                      d="M78.694,167.494a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100632"
                      data-name="Path 100632"
                      d="M86.774,167.494a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100633"
                      data-name="Path 100633"
                      d="M94.854,167.494a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100634"
                      data-name="Path 100634"
                      d="M102.924,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100635"
                      data-name="Path 100635"
                      d="M111,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100636"
                      data-name="Path 100636"
                      d="M119.074,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100637"
                      data-name="Path 100637"
                      d="M127.154,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100638"
                      data-name="Path 100638"
                      d="M135.234,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.332.332,0,0,1,.331.334Z"
                      transform="translate(-110.386 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100639"
                      data-name="Path 100639"
                      d="M143.3,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100640"
                      data-name="Path 100640"
                      d="M151.384,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100641"
                      data-name="Path 100641"
                      d="M159.454,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100642"
                      data-name="Path 100642"
                      d="M167.534,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100643"
                      data-name="Path 100643"
                      d="M175.6,167.494a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100644"
                      data-name="Path 100644"
                      d="M183.684,167.494a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100645"
                      data-name="Path 100645"
                      d="M191.764,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100646"
                      data-name="Path 100646"
                      d="M199.834,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100647"
                      data-name="Path 100647"
                      d="M207.914,167.494a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-156.668 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100648"
                      data-name="Path 100648"
                      d="M215.984,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-161.806 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100649"
                      data-name="Path 100649"
                      d="M224.064,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100650"
                      data-name="Path 100650"
                      d="M232.134,167.494a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100651"
                      data-name="Path 100651"
                      d="M240.214,167.494a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100652"
                      data-name="Path 100652"
                      d="M248.294,167.494a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100653"
                      data-name="Path 100653"
                      d="M254.932,167.16v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -135.585)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100654"
                      data-name="Path 100654"
                      d="M74.484,170.164a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100655"
                      data-name="Path 100655"
                      d="M82.564,170.164a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100656"
                      data-name="Path 100656"
                      d="M90.644,170.164a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100657"
                      data-name="Path 100657"
                      d="M98.714,170.164a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100658"
                      data-name="Path 100658"
                      d="M106.794,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100659"
                      data-name="Path 100659"
                      d="M114.864,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100660"
                      data-name="Path 100660"
                      d="M122.944,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100661"
                      data-name="Path 100661"
                      d="M131.024,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100662"
                      data-name="Path 100662"
                      d="M139.094,170.164a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100663"
                      data-name="Path 100663"
                      d="M147.174,170.164a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100664"
                      data-name="Path 100664"
                      d="M155.244,170.164a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100665"
                      data-name="Path 100665"
                      d="M163.324,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100666"
                      data-name="Path 100666"
                      d="M171.394,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100667"
                      data-name="Path 100667"
                      d="M179.474,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100668"
                      data-name="Path 100668"
                      d="M187.554,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-143.703 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100669"
                      data-name="Path 100669"
                      d="M195.624,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100670"
                      data-name="Path 100670"
                      d="M203.7,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100671"
                      data-name="Path 100671"
                      d="M211.774,170.164a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100672"
                      data-name="Path 100672"
                      d="M219.854,170.164a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100673"
                      data-name="Path 100673"
                      d="M227.934,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100674"
                      data-name="Path 100674"
                      d="M236,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100675"
                      data-name="Path 100675"
                      d="M244.084,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100676"
                      data-name="Path 100676"
                      d="M252.154,170.164a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -137.286)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100677"
                      data-name="Path 100677"
                      d="M72.84,172.6a.333.333,0,0,1-.331.334H71.46v-.668h1.05A.333.333,0,0,1,72.84,172.6Z"
                      transform="translate(-71.46 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100678"
                      data-name="Path 100678"
                      d="M78.694,172.6a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100679"
                      data-name="Path 100679"
                      d="M86.774,172.6a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100680"
                      data-name="Path 100680"
                      d="M94.854,172.6a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100681"
                      data-name="Path 100681"
                      d="M102.924,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100682"
                      data-name="Path 100682"
                      d="M111,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100683"
                      data-name="Path 100683"
                      d="M119.074,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100684"
                      data-name="Path 100684"
                      d="M127.154,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100685"
                      data-name="Path 100685"
                      d="M135.234,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.332.332,0,0,1,.331.334Z"
                      transform="translate(-110.386 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100686"
                      data-name="Path 100686"
                      d="M143.3,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100687"
                      data-name="Path 100687"
                      d="M151.384,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100688"
                      data-name="Path 100688"
                      d="M159.454,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100689"
                      data-name="Path 100689"
                      d="M167.534,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100690"
                      data-name="Path 100690"
                      d="M175.6,172.6a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100691"
                      data-name="Path 100691"
                      d="M183.684,172.6a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100692"
                      data-name="Path 100692"
                      d="M191.764,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100693"
                      data-name="Path 100693"
                      d="M199.834,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100694"
                      data-name="Path 100694"
                      d="M207.914,172.6a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-156.668 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100695"
                      data-name="Path 100695"
                      d="M215.984,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-161.806 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100696"
                      data-name="Path 100696"
                      d="M224.064,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100697"
                      data-name="Path 100697"
                      d="M232.134,172.6a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100698"
                      data-name="Path 100698"
                      d="M240.214,172.6a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100699"
                      data-name="Path 100699"
                      d="M248.294,172.6a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100700"
                      data-name="Path 100700"
                      d="M254.932,172.27v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -138.839)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100701"
                      data-name="Path 100701"
                      d="M74.484,175.274a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100702"
                      data-name="Path 100702"
                      d="M82.564,175.274a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100703"
                      data-name="Path 100703"
                      d="M90.644,175.274a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100704"
                      data-name="Path 100704"
                      d="M98.714,175.274a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100705"
                      data-name="Path 100705"
                      d="M106.794,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100706"
                      data-name="Path 100706"
                      d="M114.864,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100707"
                      data-name="Path 100707"
                      d="M122.944,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100708"
                      data-name="Path 100708"
                      d="M131.024,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100709"
                      data-name="Path 100709"
                      d="M139.094,175.274a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100710"
                      data-name="Path 100710"
                      d="M147.174,175.274a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100711"
                      data-name="Path 100711"
                      d="M155.244,175.274a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100712"
                      data-name="Path 100712"
                      d="M163.324,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100713"
                      data-name="Path 100713"
                      d="M171.394,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100714"
                      data-name="Path 100714"
                      d="M179.474,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100715"
                      data-name="Path 100715"
                      d="M187.554,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-143.703 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100716"
                      data-name="Path 100716"
                      d="M195.624,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100717"
                      data-name="Path 100717"
                      d="M203.7,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100718"
                      data-name="Path 100718"
                      d="M211.774,175.274a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100719"
                      data-name="Path 100719"
                      d="M219.854,175.274a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100720"
                      data-name="Path 100720"
                      d="M227.934,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100721"
                      data-name="Path 100721"
                      d="M236,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100722"
                      data-name="Path 100722"
                      d="M244.084,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100723"
                      data-name="Path 100723"
                      d="M252.154,175.274a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -140.539)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100724"
                      data-name="Path 100724"
                      d="M72.84,177.724a.335.335,0,0,1-.331.334H71.46v-.668h1.05A.333.333,0,0,1,72.84,177.724Z"
                      transform="translate(-71.46 -142.1)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100725"
                      data-name="Path 100725"
                      d="M78.694,177.714a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100726"
                      data-name="Path 100726"
                      d="M86.774,177.714a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100727"
                      data-name="Path 100727"
                      d="M94.854,177.714a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100728"
                      data-name="Path 100728"
                      d="M102.924,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100729"
                      data-name="Path 100729"
                      d="M111,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100730"
                      data-name="Path 100730"
                      d="M119.074,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100731"
                      data-name="Path 100731"
                      d="M127.154,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100732"
                      data-name="Path 100732"
                      d="M135.234,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100733"
                      data-name="Path 100733"
                      d="M143.3,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100734"
                      data-name="Path 100734"
                      d="M151.384,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100735"
                      data-name="Path 100735"
                      d="M159.454,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100736"
                      data-name="Path 100736"
                      d="M167.534,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100737"
                      data-name="Path 100737"
                      d="M175.6,177.714a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100738"
                      data-name="Path 100738"
                      d="M183.684,177.714a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100739"
                      data-name="Path 100739"
                      d="M191.764,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100740"
                      data-name="Path 100740"
                      d="M199.834,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100741"
                      data-name="Path 100741"
                      d="M207.914,177.714a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100742"
                      data-name="Path 100742"
                      d="M215.984,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100743"
                      data-name="Path 100743"
                      d="M224.064,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100744"
                      data-name="Path 100744"
                      d="M232.134,177.714a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100745"
                      data-name="Path 100745"
                      d="M240.214,177.714a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100746"
                      data-name="Path 100746"
                      d="M248.294,177.714a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -142.093)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100747"
                      data-name="Path 100747"
                      d="M254.932,177.39v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -142.1)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100748"
                      data-name="Path 100748"
                      d="M74.484,180.384a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100749"
                      data-name="Path 100749"
                      d="M82.564,180.384a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100750"
                      data-name="Path 100750"
                      d="M90.644,180.384a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100751"
                      data-name="Path 100751"
                      d="M98.714,180.384a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100752"
                      data-name="Path 100752"
                      d="M106.794,180.384a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100753"
                      data-name="Path 100753"
                      d="M114.864,180.384a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100754"
                      data-name="Path 100754"
                      d="M122.944,180.384a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100755"
                      data-name="Path 100755"
                      d="M131.024,180.384a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100756"
                      data-name="Path 100756"
                      d="M139.094,180.384a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100757"
                      data-name="Path 100757"
                      d="M147.174,180.384a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100758"
                      data-name="Path 100758"
                      d="M155.244,180.384a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100759"
                      data-name="Path 100759"
                      d="M163.324,180.384a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100760"
                      data-name="Path 100760"
                      d="M171.394,180.384a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100761"
                      data-name="Path 100761"
                      d="M179.474,180.384a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100762"
                      data-name="Path 100762"
                      d="M187.554,180.384a.332.332,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-143.703 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100763"
                      data-name="Path 100763"
                      d="M195.624,180.384a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100764"
                      data-name="Path 100764"
                      d="M203.7,180.384a.333.333,0,0,1-.331.334h-1.983a.332.332,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100765"
                      data-name="Path 100765"
                      d="M211.774,180.384a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100766"
                      data-name="Path 100766"
                      d="M219.854,180.384a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100767"
                      data-name="Path 100767"
                      d="M227.934,180.384a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100768"
                      data-name="Path 100768"
                      d="M236,180.384a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100769"
                      data-name="Path 100769"
                      d="M244.084,180.384a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100770"
                      data-name="Path 100770"
                      d="M252.154,180.384a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -143.793)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100771"
                      data-name="Path 100771"
                      d="M72.84,182.831a.333.333,0,0,1-.331.334H71.46V182.5h1.05A.332.332,0,0,1,72.84,182.831Z"
                      transform="translate(-71.46 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100772"
                      data-name="Path 100772"
                      d="M78.694,182.834a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100773"
                      data-name="Path 100773"
                      d="M86.774,182.834a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100774"
                      data-name="Path 100774"
                      d="M94.854,182.834a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100775"
                      data-name="Path 100775"
                      d="M102.924,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100776"
                      data-name="Path 100776"
                      d="M111,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100777"
                      data-name="Path 100777"
                      d="M119.074,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100778"
                      data-name="Path 100778"
                      d="M127.154,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100779"
                      data-name="Path 100779"
                      d="M135.234,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.332.332,0,0,1,.331.334Z"
                      transform="translate(-110.386 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100780"
                      data-name="Path 100780"
                      d="M143.3,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100781"
                      data-name="Path 100781"
                      d="M151.384,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100782"
                      data-name="Path 100782"
                      d="M159.454,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100783"
                      data-name="Path 100783"
                      d="M167.534,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100784"
                      data-name="Path 100784"
                      d="M175.6,182.834a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100785"
                      data-name="Path 100785"
                      d="M183.684,182.834a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100786"
                      data-name="Path 100786"
                      d="M191.764,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100787"
                      data-name="Path 100787"
                      d="M199.834,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100788"
                      data-name="Path 100788"
                      d="M207.914,182.834a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-156.668 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100789"
                      data-name="Path 100789"
                      d="M215.984,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-161.806 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100790"
                      data-name="Path 100790"
                      d="M224.064,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100791"
                      data-name="Path 100791"
                      d="M232.134,182.834a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100792"
                      data-name="Path 100792"
                      d="M240.214,182.834a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100793"
                      data-name="Path 100793"
                      d="M248.294,182.834a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100794"
                      data-name="Path 100794"
                      d="M254.932,182.5v.665h-.872a.332.332,0,0,1,0-.665Z"
                      transform="translate(-187.526 -145.354)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100795"
                      data-name="Path 100795"
                      d="M74.484,185.5a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100796"
                      data-name="Path 100796"
                      d="M82.564,185.5a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100797"
                      data-name="Path 100797"
                      d="M90.644,185.5a.333.333,0,0,1-.331.334H88.331A.333.333,0,0,1,88,185.5h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100798"
                      data-name="Path 100798"
                      d="M98.714,185.5a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100799"
                      data-name="Path 100799"
                      d="M106.794,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100800"
                      data-name="Path 100800"
                      d="M114.864,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100801"
                      data-name="Path 100801"
                      d="M122.944,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100802"
                      data-name="Path 100802"
                      d="M131.024,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100803"
                      data-name="Path 100803"
                      d="M139.094,185.5a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100804"
                      data-name="Path 100804"
                      d="M147.174,185.5a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100805"
                      data-name="Path 100805"
                      d="M155.244,185.5a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100806"
                      data-name="Path 100806"
                      d="M163.324,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100807"
                      data-name="Path 100807"
                      d="M171.394,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100808"
                      data-name="Path 100808"
                      d="M179.474,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100809"
                      data-name="Path 100809"
                      d="M187.554,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-143.703 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100810"
                      data-name="Path 100810"
                      d="M195.624,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100811"
                      data-name="Path 100811"
                      d="M203.7,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100812"
                      data-name="Path 100812"
                      d="M211.774,185.5a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100813"
                      data-name="Path 100813"
                      d="M219.854,185.5a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100814"
                      data-name="Path 100814"
                      d="M227.934,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100815"
                      data-name="Path 100815"
                      d="M236,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100816"
                      data-name="Path 100816"
                      d="M244.084,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100817"
                      data-name="Path 100817"
                      d="M252.154,185.5a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -147.054)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100818"
                      data-name="Path 100818"
                      d="M72.84,187.944a.333.333,0,0,1-.331.334H71.46v-.668h1.05A.333.333,0,0,1,72.84,187.944Z"
                      transform="translate(-71.46 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100819"
                      data-name="Path 100819"
                      d="M78.694,187.944a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100820"
                      data-name="Path 100820"
                      d="M86.774,187.944a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100821"
                      data-name="Path 100821"
                      d="M94.854,187.944a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100822"
                      data-name="Path 100822"
                      d="M102.924,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100823"
                      data-name="Path 100823"
                      d="M111,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100824"
                      data-name="Path 100824"
                      d="M119.074,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100825"
                      data-name="Path 100825"
                      d="M127.154,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100826"
                      data-name="Path 100826"
                      d="M135.234,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100827"
                      data-name="Path 100827"
                      d="M143.3,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100828"
                      data-name="Path 100828"
                      d="M151.384,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100829"
                      data-name="Path 100829"
                      d="M159.454,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100830"
                      data-name="Path 100830"
                      d="M167.534,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100831"
                      data-name="Path 100831"
                      d="M175.6,187.944a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100832"
                      data-name="Path 100832"
                      d="M183.684,187.944a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100833"
                      data-name="Path 100833"
                      d="M191.764,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100834"
                      data-name="Path 100834"
                      d="M199.834,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100835"
                      data-name="Path 100835"
                      d="M207.914,187.944a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100836"
                      data-name="Path 100836"
                      d="M215.984,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100837"
                      data-name="Path 100837"
                      d="M224.064,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100838"
                      data-name="Path 100838"
                      d="M232.134,187.944a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100839"
                      data-name="Path 100839"
                      d="M240.214,187.944a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100840"
                      data-name="Path 100840"
                      d="M248.294,187.944a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100841"
                      data-name="Path 100841"
                      d="M254.932,187.61v.668h-.872a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.526 -148.607)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100842"
                      data-name="Path 100842"
                      d="M74.484,190.614a.333.333,0,0,1-.331.334H72.171a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.702 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100843"
                      data-name="Path 100843"
                      d="M82.564,190.614a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100844"
                      data-name="Path 100844"
                      d="M90.644,190.614a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100845"
                      data-name="Path 100845"
                      d="M98.714,190.614a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100846"
                      data-name="Path 100846"
                      d="M106.794,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100847"
                      data-name="Path 100847"
                      d="M114.864,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100848"
                      data-name="Path 100848"
                      d="M122.944,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100849"
                      data-name="Path 100849"
                      d="M131.024,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100850"
                      data-name="Path 100850"
                      d="M139.094,190.614a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100851"
                      data-name="Path 100851"
                      d="M147.174,190.614a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100852"
                      data-name="Path 100852"
                      d="M155.244,190.614a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100853"
                      data-name="Path 100853"
                      d="M163.324,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100854"
                      data-name="Path 100854"
                      d="M171.394,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100855"
                      data-name="Path 100855"
                      d="M179.474,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100856"
                      data-name="Path 100856"
                      d="M187.554,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-143.703 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100857"
                      data-name="Path 100857"
                      d="M195.624,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100858"
                      data-name="Path 100858"
                      d="M203.7,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100859"
                      data-name="Path 100859"
                      d="M211.774,190.614a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100860"
                      data-name="Path 100860"
                      d="M219.854,190.614a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100861"
                      data-name="Path 100861"
                      d="M227.934,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100862"
                      data-name="Path 100862"
                      d="M236,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100863"
                      data-name="Path 100863"
                      d="M244.084,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100864"
                      data-name="Path 100864"
                      d="M252.154,190.614a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-184.839 -150.308)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100865"
                      data-name="Path 100865"
                      d="M73.12,193.064a.333.333,0,0,1-.331.334h-.548a2.639,2.639,0,0,1-.341-.668h.89a.333.333,0,0,1,.331.334Z"
                      transform="translate(-71.74 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100866"
                      data-name="Path 100866"
                      d="M78.694,193.064a.333.333,0,0,1-.331.334H76.381a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-74.383 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100867"
                      data-name="Path 100867"
                      d="M86.774,193.064a.333.333,0,0,1-.331.334H84.461a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-79.528 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100868"
                      data-name="Path 100868"
                      d="M94.854,193.064a.333.333,0,0,1-.331.334H92.541a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-84.673 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100869"
                      data-name="Path 100869"
                      d="M102.924,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-89.812 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100870"
                      data-name="Path 100870"
                      d="M111,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-94.957 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100871"
                      data-name="Path 100871"
                      d="M119.074,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-100.096 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100872"
                      data-name="Path 100872"
                      d="M127.154,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-105.241 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100873"
                      data-name="Path 100873"
                      d="M135.234,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H134.9a.333.333,0,0,1,.331.334Z"
                      transform="translate(-110.386 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100874"
                      data-name="Path 100874"
                      d="M143.3,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-115.525 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100875"
                      data-name="Path 100875"
                      d="M151.384,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-120.67 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100876"
                      data-name="Path 100876"
                      d="M159.454,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-125.809 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100877"
                      data-name="Path 100877"
                      d="M167.534,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H167.2a.333.333,0,0,1,.331.334Z"
                      transform="translate(-130.954 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100878"
                      data-name="Path 100878"
                      d="M175.6,193.064a.333.333,0,0,1-.331.334H173.29a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-136.093 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100879"
                      data-name="Path 100879"
                      d="M183.684,193.064a.333.333,0,0,1-.331.334H181.37a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-141.238 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100880"
                      data-name="Path 100880"
                      d="M191.764,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-146.384 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100881"
                      data-name="Path 100881"
                      d="M199.834,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H199.5a.333.333,0,0,1,.331.334Z"
                      transform="translate(-151.522 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100882"
                      data-name="Path 100882"
                      d="M207.914,193.064a.333.333,0,0,1-.331.334H205.6a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-156.668 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100883"
                      data-name="Path 100883"
                      d="M215.984,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-161.806 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100884"
                      data-name="Path 100884"
                      d="M224.064,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-166.952 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100885"
                      data-name="Path 100885"
                      d="M232.134,193.064a.333.333,0,0,1-.331.334H229.82a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H231.8a.333.333,0,0,1,.331.334Z"
                      transform="translate(-172.09 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100886"
                      data-name="Path 100886"
                      d="M240.214,193.064a.333.333,0,0,1-.331.334H237.9a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-177.236 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100887"
                      data-name="Path 100887"
                      d="M248.294,193.064a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-182.381 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100888"
                      data-name="Path 100888"
                      d="M254.766,192.73a2.774,2.774,0,0,1-.345.668h-.37a.334.334,0,0,1,0-.668Z"
                      transform="translate(-187.52 -151.868)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100889"
                      data-name="Path 100889"
                      d="M75.551,195.734a.333.333,0,0,1-.331.334h-.748a2.783,2.783,0,0,1-.963-.668h1.711A.333.333,0,0,1,75.551,195.734Z"
                      transform="translate(-72.765 -153.568)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100890"
                      data-name="Path 100890"
                      d="M82.564,195.724a.333.333,0,0,1-.331.334H80.251a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-76.847 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100891"
                      data-name="Path 100891"
                      d="M90.644,195.724a.333.333,0,0,1-.331.334H88.331a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-81.992 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100892"
                      data-name="Path 100892"
                      d="M98.714,195.724a.333.333,0,0,1-.331.334H96.4a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-87.131 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100893"
                      data-name="Path 100893"
                      d="M106.794,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-92.276 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100894"
                      data-name="Path 100894"
                      d="M114.864,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-97.415 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100895"
                      data-name="Path 100895"
                      d="M122.944,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-102.56 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100896"
                      data-name="Path 100896"
                      d="M131.024,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-107.706 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100897"
                      data-name="Path 100897"
                      d="M139.094,195.724a.333.333,0,0,1-.331.334H136.78a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-112.844 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100898"
                      data-name="Path 100898"
                      d="M147.174,195.724a.333.333,0,0,1-.331.334H144.86a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-117.99 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100899"
                      data-name="Path 100899"
                      d="M155.244,195.724a.333.333,0,0,1-.331.334H152.93a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-123.128 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100900"
                      data-name="Path 100900"
                      d="M163.324,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-128.274 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100901"
                      data-name="Path 100901"
                      d="M171.394,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-133.412 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100902"
                      data-name="Path 100902"
                      d="M179.474,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-138.558 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100903"
                      data-name="Path 100903"
                      d="M187.554,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.332.332,0,0,1,.331.334Z"
                      transform="translate(-143.703 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100904"
                      data-name="Path 100904"
                      d="M195.624,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-148.842 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100905"
                      data-name="Path 100905"
                      d="M203.7,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.332.332,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-153.987 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100906"
                      data-name="Path 100906"
                      d="M211.774,195.724a.333.333,0,0,1-.331.334H209.46a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-159.126 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100907"
                      data-name="Path 100907"
                      d="M219.854,195.724a.333.333,0,0,1-.331.334H217.54a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-164.271 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100908"
                      data-name="Path 100908"
                      d="M227.934,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334H227.6a.333.333,0,0,1,.331.334Z"
                      transform="translate(-169.416 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100909"
                      data-name="Path 100909"
                      d="M236,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-174.555 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100910"
                      data-name="Path 100910"
                      d="M244.084,195.724a.333.333,0,0,1-.331.334h-1.983a.333.333,0,0,1-.331-.334h0a.333.333,0,0,1,.331-.334h1.983a.333.333,0,0,1,.331.334Z"
                      transform="translate(-179.7 -153.562)"
                      fill="#6552cc"
                    />
                    <path
                      id="Path_100911"
                      data-name="Path 100911"
                      d="M251.5,195.4a2.736,2.736,0,0,1-.959.668h-.7a.334.334,0,0,1,0-.668Z"
                      transform="translate(-184.839 -153.568)"
                      fill="#6552cc"
                    />
                  </g>
                  <path
                    id="Path_100912"
                    data-name="Path 100912"
                    d="M138.863,190.08v.036a2.776,2.776,0,0,1-2.779,2.779H74.239a2.779,2.779,0,0,1-2.779-2.779v-.036Z"
                    transform="translate(-71.46 -150.075)"
                    fill="#eeebff"
                  />
                  <path
                    id="Path_100913"
                    data-name="Path 100913"
                    d="M78.421,192l-.607.254-.545.225v.254l.447.189.755.316h0v-.331l-.745-.3.745-.3v-.331l-.054.022Z"
                    transform="translate(-75.16 -151.285)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100914"
                    data-name="Path 100914"
                    d="M86.59,192l-.585.243-.545.225v.254l.447.189.737.309.018.007V192.9l-.745-.3.745-.3v-.331l-.076.033Z"
                    transform="translate(-80.375 -151.279)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100915"
                    data-name="Path 100915"
                    d="M90.208,192.018l-.538.225-.53.222v.254l.447.189.723.3.036.015v-.331l-.418-.171-.327-.131.341-.138.4-.163v-.331l-.138.058Z"
                    transform="translate(-82.718 -151.272)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100916"
                    data-name="Path 100916"
                    d="M93.365,192.252l-.545.225v.254l.45.189.759.316v-.331l-.745-.3.745-.3v-.331l-.665.276Z"
                    transform="translate(-85.062 -151.285)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100917"
                    data-name="Path 100917"
                    d="M97.568,192.024l-.523.218-.545.225v.254l.447.189.723.3.036.015V192.9l-.214-.087-.53-.211.552-.222.189-.076v-.331l-.138.058Z"
                    transform="translate(-87.405 -151.279)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100918"
                    data-name="Path 100918"
                    d="M100.725,192.252l-.479.2-.065.029v.254l.091.036h0l.352.149.759.316v-.331l-.745-.3.745-.3v-.331l-.661.276Z"
                    transform="translate(-89.748 -151.285)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100919"
                    data-name="Path 100919"
                    d="M104.922,192.018l-.527.218-.545.225v.254l.45.189.723.3.036.015v-.331l-.051-.018-.7-.28.741-.3h0v-.334l-.138.058Z"
                    transform="translate(-92.085 -151.272)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100920"
                    data-name="Path 100920"
                    d="M121.448,192.024l-.523.218-.545.225v.254l.447.189.723.3.036.015V192.9l-.131-.051-.617-.247.65-.258.1-.04v-.331l-.138.058Z"
                    transform="translate(-102.611 -151.279)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55656"
                    data-name="Rectangle 55656"
                    width="1.275"
                    height="1.329"
                    transform="translate(3.629 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55657"
                    data-name="Rectangle 55657"
                    width="1.275"
                    height="1.329"
                    transform="translate(13.174 40.688)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100921"
                    data-name="Path 100921"
                    d="M124.711,192.259l-.363.153-.178.076v.254l.229.1.214.087.759.32v-.331l-.745-.3.745-.3v-.331l-.661.276Z"
                    transform="translate(-105.025 -151.291)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100922"
                    data-name="Path 100922"
                    d="M128.9,192.024l-.523.218-.545.225v.254l.447.189.723.3.036.015V192.9h0l-.737-.3.745-.3v-.331l-.138.058Z"
                    transform="translate(-107.355 -151.279)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55658"
                    data-name="Rectangle 55658"
                    width="1.275"
                    height="1.329"
                    transform="translate(21.888 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55659"
                    data-name="Rectangle 55659"
                    width="1.275"
                    height="1.329"
                    transform="translate(14.743 40.688)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100923"
                    data-name="Path 100923"
                    d="M157.215,192.252l-.461.193-.084.036v.254l.113.047.334.138.759.316v-.331l-.745-.3.745-.3v-.331l-.661.276Z"
                    transform="translate(-125.72 -151.285)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100924"
                    data-name="Path 100924"
                    d="M161.418,192.018l-.523.218-.545.225v.254l.447.189.723.3.036.015v-.331l-.04-.018-.7-.283.745-.3v-.331l-.138.058Z"
                    transform="translate(-128.063 -151.272)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100925"
                    data-name="Path 100925"
                    d="M165.1,192.031l-1.064.447h0v.254l1.206.5v-.331l-.745-.3.745-.3v-.331l-.138.058Z"
                    transform="translate(-130.413 -151.285)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100926"
                    data-name="Path 100926"
                    d="M168.768,192.024l-.523.218-.545.225v.254l.447.189.723.3.036.015V192.9l-.745-.3.745-.3v-.331l-.138.058Z"
                    transform="translate(-132.744 -151.279)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100927"
                    data-name="Path 100927"
                    d="M172.448,192.031l-.85.356-.218.091v.254l.2.084.973.407.036.015v-.331l-.625-.251-.12-.047.116-.047.628-.251v-.331l-.138.058Z"
                    transform="translate(-135.087 -151.285)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100928"
                    data-name="Path 100928"
                    d="M176.128,192.024l-.523.218-.545.225v.254l.447.189.723.3.036.015V192.9l-.745-.3.745-.3v-.331l-.138.058Z"
                    transform="translate(-137.43 -151.279)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55660"
                    data-name="Rectangle 55660"
                    width="1.275"
                    height="1.329"
                    transform="translate(39.039 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55661"
                    data-name="Rectangle 55661"
                    width="1.275"
                    height="1.329"
                    transform="translate(40.608 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55662"
                    data-name="Rectangle 55662"
                    width="1.275"
                    height="1.329"
                    transform="translate(42.264 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55663"
                    data-name="Rectangle 55663"
                    width="1.275"
                    height="1.329"
                    transform="translate(43.92 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55664"
                    data-name="Rectangle 55664"
                    width="1.275"
                    height="1.329"
                    transform="translate(45.577 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55665"
                    data-name="Rectangle 55665"
                    width="1.275"
                    height="1.329"
                    transform="translate(47.233 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55666"
                    data-name="Rectangle 55666"
                    width="1.275"
                    height="1.329"
                    transform="translate(48.889 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55667"
                    data-name="Rectangle 55667"
                    width="1.275"
                    height="1.329"
                    transform="translate(50.546 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55668"
                    data-name="Rectangle 55668"
                    width="1.275"
                    height="1.329"
                    transform="translate(52.202 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55669"
                    data-name="Rectangle 55669"
                    width="1.275"
                    height="1.329"
                    transform="translate(16.312 40.688)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100929"
                    data-name="Path 100929"
                    d="M136.932,192.024l-.527.218-.545.225v.254l.45.189.723.3.036.015V192.9l-.745-.3.745-.3v-.331l-.138.058Z"
                    transform="translate(-112.469 -151.279)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100930"
                    data-name="Path 100930"
                    d="M153.458,192.012l-.523.218-.545.225v.254l.447.189.723.3.036.015v-.331l-.065-.025-.679-.276.719-.291.025-.011v-.331l-.138.058Z"
                    transform="translate(-122.995 -151.266)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55670"
                    data-name="Rectangle 55670"
                    width="1.275"
                    height="1.329"
                    transform="translate(24.801 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55671"
                    data-name="Rectangle 55671"
                    width="1.275"
                    height="1.329"
                    transform="translate(26.37 40.688)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55672"
                    data-name="Rectangle 55672"
                    width="1.275"
                    height="1.329"
                    transform="translate(27.935 40.688)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100931"
                    data-name="Path 100931"
                    d="M229.018,192.018l-.857.36-.211.087v.254l.185.076.984.41.036.015v-.331l-.636-.258-.109-.044.1-.04.639-.258v-.331l-.138.058Z"
                    transform="translate(-171.11 -151.272)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100932"
                    data-name="Path 100932"
                    d="M232.7,192.024l-.523.218-.545.225v.254l.447.189.723.3.036.015V192.9l-.745-.3.745-.3v-.331l-.138.058Z"
                    transform="translate(-173.453 -151.279)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100933"
                    data-name="Path 100933"
                    d="M224.728,192.024l-.523.218-.545.225v.254l.447.189.723.3.036.015V192.9l-.745-.3.745-.3v-.331l-.138.058Z"
                    transform="translate(-168.378 -151.279)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55673"
                    data-name="Rectangle 55673"
                    width="1.275"
                    height="1.329"
                    transform="translate(53.825 40.688)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100934"
                    data-name="Path 100934"
                    d="M245.318,192.012l-.9.378-.163.069v.254l.145.058,1.024.429.036.015v-.331l-.7-.28-.047-.022.044-.018.7-.283v-.331l-.138.058Z"
                    transform="translate(-181.489 -151.266)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100935"
                    data-name="Path 100935"
                    d="M249,192.024l-.523.218-.545.225v.254l.447.189.723.3.036.015V192.9l-.745-.3.745-.3v-.331l-.138.058Z"
                    transform="translate(-183.833 -151.279)"
                    fill="#565655"
                  />
                  <path
                    id="Path_100936"
                    data-name="Path 100936"
                    d="M241.038,192.024l-.523.218-.545.225v.254l.447.189.723.3.036.015V192.9l-.745-.3.745-.3v-.331l-.138.058Z"
                    transform="translate(-178.764 -151.279)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55674"
                    data-name="Rectangle 55674"
                    width="1.275"
                    height="1.329"
                    transform="translate(59.75 40.688)"
                    fill="#565655"
                  />
                </g>
                <path
                  id="Path_100937"
                  data-name="Path 100937"
                  d="M138.866,82.715V87.35H71.46V82.57a2.528,2.528,0,0,1,.12-.668,2.97,2.97,0,0,1,.116-.316,2.824,2.824,0,0,1,.341-.57,2.687,2.687,0,0,1,.272-.3,2.525,2.525,0,0,1,.523-.392,2.645,2.645,0,0,1,.421-.2.2.2,0,0,1,.1-.051.022.022,0,0,0,.015,0,.2.2,0,0,0,.036-.011c.018,0,.036,0,.058,0h.015a2.811,2.811,0,0,1,.766-.109h61.845a2.677,2.677,0,0,1,.766.109,2.6,2.6,0,0,1,.49.193h0a2.392,2.392,0,0,1,.323.2,2.348,2.348,0,0,1,.345.283,1.7,1.7,0,0,1,.138.142.016.016,0,0,1,.011.011l.036.036c.033.036.062.073.091.109a2.584,2.584,0,0,1,.356.6,2.047,2.047,0,0,1,.105.283,2.527,2.527,0,0,1,.12.668v.145Z"
                  transform="translate(-71.46 -79.929)"
                  fill="#9a8bef"
                />
                <path
                  id="Path_100938"
                  data-name="Path 100938"
                  d="M138.222,80.887a.013.013,0,0,0-.007,0,2.382,2.382,0,0,0-.24-.189h0a1.674,1.674,0,0,0-.218-.134c-.033-.022-.069-.04-.1-.058h0c-.08-.04-.163-.076-.247-.109s-.16-.058-.243-.084a2.811,2.811,0,0,0-.766-.109H74.55a2.7,2.7,0,0,0-.766.109h-.015a.316.316,0,0,0-.189.069h-.011a2.069,2.069,0,0,0-.352.163c-.025.011-.047.025-.069.036a2.894,2.894,0,0,0-.523.392l-.022.022a2.3,2.3,0,0,0-.251.28,3.328,3.328,0,0,0-.251.385c-.033.058-.062.123-.091.185,0,.011-.011.025-.015.036a1.833,1.833,0,0,0-.1.28,2.636,2.636,0,0,0-.091.389,2.353,2.353,0,0,0-.029.28v37.412c0,.094.007.185.015.276a.217.217,0,0,0,.007.044.358.358,0,0,0,.007.062,1.214,1.214,0,0,0,.025.153c0,.025.011.051.015.076a.081.081,0,0,0,.011.036,1.225,1.225,0,0,0,.033.124c.011.04.022.076.036.116a.138.138,0,0,0,.011.036.375.375,0,0,1,.015.036q.049.125.109.251c.015.029.029.062.044.091,0,0,0,.007.007.011a1.874,1.874,0,0,0,.156.258l.011.022a.1.1,0,0,0,.018.022,2.273,2.273,0,0,0,.142.185c-.033-.029-.062-.054-.091-.084l-.044-.044c-.018-.018-.04-.036-.058-.058h0a.115.115,0,0,1-.022-.029,1.777,1.777,0,0,1-.218-.276l-.015-.025-.084-.127c-.025-.047-.051-.091-.076-.138-.015-.029-.029-.062-.044-.094s-.036-.08-.058-.123a.018.018,0,0,0,0-.011c-.015-.036-.029-.076-.044-.113a.376.376,0,0,1-.015-.036c0-.011-.007-.025-.011-.036-.011-.04-.025-.08-.036-.12s-.029-.105-.04-.16a.581.581,0,0,0-.018-.076c-.011-.069-.025-.142-.033-.214,0-.011,0-.022,0-.033v-.011l-.007-.084c0-.062-.007-.127-.007-.193V82.54a2.528,2.528,0,0,1,.12-.668,2.97,2.97,0,0,1,.116-.316,2.824,2.824,0,0,1,.341-.57,2.685,2.685,0,0,1,.272-.3,2.526,2.526,0,0,1,.523-.392,2.647,2.647,0,0,1,.421-.2h0a.018.018,0,0,0,.011,0,.38.38,0,0,1,.084-.047.022.022,0,0,0,.015,0,.2.2,0,0,0,.036-.011c.018,0,.036,0,.058,0h.015a2.811,2.811,0,0,1,.766-.109h61.845a2.678,2.678,0,0,1,.766.109,2.6,2.6,0,0,1,.49.193h0a2.39,2.39,0,0,1,.323.2,2.348,2.348,0,0,1,.345.283,1.7,1.7,0,0,1,.138.142.016.016,0,0,1,.011.011l.036.036Z"
                  transform="translate(-71.492 -79.91)"
                  fill="#fff"
                  opacity="0.3"
                />
                <g
                  id="Group_105517"
                  data-name="Group 105517"
                  transform="translate(2.786 10.072)"
                  clipPath="url(#clip-path)"
                >
                  <rect
                    id="Rectangle_55675"
                    data-name="Rectangle 55675"
                    width="18.292"
                    height="23.054"
                    fill="#fff"
                  />
                  <g
                    id="Group_105516"
                    data-name="Group 105516"
                    transform="translate(-1.627 3.628)"
                  >
                    <rect
                      id="Rectangle_55676"
                      data-name="Rectangle 55676"
                      width="5.742"
                      height="3.378"
                      transform="translate(7.846 13.879)"
                      fill="#f7c8a8"
                    />
                    <path
                      id="Path_100939"
                      data-name="Path 100939"
                      d="M92.884,133.756c.156.694-.007,1.3-.37,1.362s-.781-.454-.937-1.144.007-1.3.37-1.362S92.728,133.066,92.884,133.756Z"
                      transform="translate(-85.391 -127.167)"
                      fill="#f7c8a8"
                    />
                    <path
                      id="Path_100940"
                      data-name="Path 100940"
                      d="M93.053,134.415c.113.5-.007.933-.265.977s-.559-.323-.672-.821.007-.933.265-.977S92.94,133.917,93.053,134.415Z"
                      transform="translate(-85.745 -127.793)"
                      opacity="0.3"
                    />
                    <path
                      id="Path_100941"
                      data-name="Path 100941"
                      d="M113.236,133.756c-.156.694.007,1.3.37,1.362s.781-.454.937-1.144-.007-1.3-.37-1.362S113.393,133.066,113.236,133.756Z"
                      transform="translate(-99.183 -127.167)"
                      fill="#f7c8a8"
                    />
                    <path
                      id="Path_100942"
                      data-name="Path 100942"
                      d="M113.776,134.415c-.113.5.007.933.265.977s.559-.323.672-.821-.007-.933-.265-.977S113.888,133.917,113.776,134.415Z"
                      transform="translate(-99.538 -127.793)"
                      opacity="0.3"
                    />
                    <g
                      id="Group_105511"
                      data-name="Group 105511"
                      transform="translate(3.211 10.523)"
                    >
                      <path
                        id="Path_100943"
                        data-name="Path 100943"
                        d="M88.63,146.6v4.144H83.49V150.3a4.459,4.459,0,0,0,.5-.174l.283-.113c.287-.116.61-.254.952-.385a10.9,10.9,0,0,0,1.671-.792c.105-.062.207-.127.309-.193A2.661,2.661,0,0,0,88.63,146.6Z"
                        transform="translate(-83.49 -146.6)"
                        fill="#f7c8a8"
                      />
                      <path
                        id="Path_100944"
                        data-name="Path 100944"
                        d="M116.12,150.3v.439h-5.14V146.6a2.661,2.661,0,0,0,1.427,2.049h0c.1.065.2.131.309.193a10.721,10.721,0,0,0,1.671.788h0c.341.131.668.265.952.385.1.04.193.08.283.113h0a4.431,4.431,0,0,0,.494.174Z"
                        transform="translate(-100.995 -146.6)"
                        fill="#f7c8a8"
                      />
                    </g>
                    <rect
                      id="Rectangle_55677"
                      data-name="Rectangle 55677"
                      width="4.842"
                      height="5.71"
                      transform="translate(8.35 8.42)"
                      fill="#f7c8a8"
                    />
                    <g
                      id="Group_105512"
                      data-name="Group 105512"
                      transform="translate(8.354 8.416)"
                      opacity="0.15"
                    >
                      <path
                        id="Path_100945"
                        data-name="Path 100945"
                        d="M102.5,142.968h0a3.21,3.21,0,0,1-4.845,0h0V140.8h4.842v2.168Z"
                        transform="translate(-97.65 -140.8)"
                      />
                    </g>
                    <path
                      id="Path_100946"
                      data-name="Path 100946"
                      d="M101.222,123.865a7.119,7.119,0,0,1-.552,2.717c-.712,1.707-2.038,3-3.556,3s-2.844-1.3-3.556-3.007a7.181,7.181,0,0,1-.548-2.713c0-2.826,1.838-4.515,4.1-4.515S101.222,121.039,101.222,123.865Z"
                      transform="translate(-86.341 -118.725)"
                      fill="#f7c8a8"
                    />
                    <g
                      id="Group_105515"
                      data-name="Group 105515"
                      transform="translate(3.218 10.523)"
                    >
                      <g id="Group_105513" data-name="Group 105513">
                        <path
                          id="Path_100947"
                          data-name="Path 100947"
                          d="M85.482,154.69l-.04.472-.167.737H83.51v-.439a4.449,4.449,0,0,0,.5-.174l.283-.113c.287-.116.61-.254.952-.385.08-.029.16-.062.243-.094Z"
                          transform="translate(-83.51 -151.752)"
                          fill="#c4c4c4"
                        />
                        <path
                          id="Path_100948"
                          data-name="Path 100948"
                          d="M97.029,146.6v3.265l-.305-1.911-.044-.3a2.546,2.546,0,0,0,.16-.272c.018-.033.033-.069.047-.1a.014.014,0,0,1,.007-.015c.015-.036.029-.076.044-.113s.029-.087.04-.134.022-.087.029-.134.015-.091.018-.138a.535.535,0,0,0,0-.076V146.6Z"
                          transform="translate(-91.896 -146.6)"
                          fill="#f7c8a8"
                        />
                      </g>
                      <g
                        id="Group_105514"
                        data-name="Group 105514"
                        transform="translate(9.974)"
                      >
                        <path
                          id="Path_100949"
                          data-name="Path 100949"
                          d="M111.351,147.69l-.381,1.093v-2.034h0a1.359,1.359,0,0,0,.018.142v.011c.007.044.018.087.029.131s.022.076.033.113a.408.408,0,0,0,.018.047c.018.047.036.094.058.142s.033.069.054.105a.9.9,0,0,0,.076.127c.022.033.044.069.065.1a.11.11,0,0,0,.018.025Z"
                          transform="translate(-110.97 -146.6)"
                          fill="#f7c8a8"
                        />
                        <path
                          id="Path_100950"
                          data-name="Path 100950"
                          d="M123.162,156.049v.439h-.977l-.145-.868c.12.047.236.1.345.142s.193.08.283.113h0A4.434,4.434,0,0,0,123.162,156.049Z"
                          transform="translate(-118.019 -152.344)"
                          fill="#c4c4c4"
                        />
                      </g>
                    </g>
                    <path
                      id="Path_100951"
                      data-name="Path 100951"
                      d="M92.437,153.9c-.076-.022-.156-.044-.232-.062-.109-.044-.225-.091-.345-.142h0c-.193-.08-.4-.16-.61-.243h0a10.9,10.9,0,0,1-1.671-.792c-.036-.022-.069-.04-.1-.062a8.044,8.044,0,0,1-.527.788,5.877,5.877,0,0,1-1.682,1.536c-.025.015-.051.029-.073.044l-.044.022c-.022.011-.044.022-.062.033a.365.365,0,0,1-.054.025c-.018.011-.036.018-.054.029l-.062.029-.051.022c-.022.011-.044.018-.065.029l-.047.022c-.022.011-.047.018-.069.029s-.033.011-.047.018l-.069.025-.047.015-.073.022-.047.015-.073.022-.047.015c-.022.007-.047.011-.073.018l-.051.011c-.022,0-.047.011-.073.015a.254.254,0,0,0-.051.011l-.069.011c-.018,0-.033.007-.051.007a.5.5,0,0,0-.073.011.245.245,0,0,0-.051.007.54.54,0,0,0-.076.007.208.208,0,0,0-.047,0,.643.643,0,0,0-.084,0h-.345a.414.414,0,0,1-.094-.007.24.24,0,0,1-.051,0,.717.717,0,0,1-.087-.011.245.245,0,0,1-.051-.007.73.73,0,0,1-.087-.015.212.212,0,0,1-.047-.007c-.033-.007-.065-.011-.094-.018a.129.129,0,0,1-.036-.007c-.091-.022-.182-.044-.269-.073a.052.052,0,0,1-.022-.007c-.036-.011-.073-.025-.113-.036l-.033-.011c-.033-.011-.065-.025-.1-.036a.381.381,0,0,0-.036-.015c-.033-.015-.065-.025-.1-.04-.011,0-.022-.011-.033-.015-.036-.015-.069-.033-.105-.047-.007,0-.015-.007-.022-.011a3.9,3.9,0,0,1-.381-.211c-.007,0-.015-.011-.022-.015-.033-.022-.065-.04-.1-.062l-.033-.022c-.029-.018-.058-.04-.087-.062a6.15,6.15,0,0,1-1.344-1.318,8.045,8.045,0,0,1-.527-.788c-.033.022-.069.044-.1.062a10.438,10.438,0,0,1-1.435.7c-.08.033-.16.062-.236.094-.341.131-.668.265-.952.385-.08.018-.156.04-.232.062a4.6,4.6,0,0,0-3.767,4.907c0,5.234,4.827,13.45,10.78,13.45s10.78-8.22,10.78-13.45a4.6,4.6,0,0,0-3.767-4.907Z"
                      transform="translate(-74.65 -139.898)"
                      fill="#577981"
                    />
                    <path
                      id="Path_100952"
                      data-name="Path 100952"
                      d="M93.75,118.055c-1.351.091-2.187,1.166-2.143,3.563s.73,2.684.73,2.684a5.8,5.8,0,0,1,1.22-4.311c.047.047.581.6,3.3.723s3.222,3.748,3.222,3.748c2.172-9.3-6.324-6.407-6.324-6.407h0Z"
                      transform="translate(-85.447 -117.63)"
                      fill="#b58f6c"
                    />
                  </g>
                </g>
                <g
                  id="Group_105520"
                  data-name="Group 105520"
                  transform="translate(59.176 8.205)"
                >
                  <rect
                    id="Rectangle_55679"
                    data-name="Rectangle 55679"
                    width="5.416"
                    height="30.06"
                    fill="#fff"
                  />
                  <g
                    id="Group_105519"
                    data-name="Group 105519"
                    transform="translate(0.407 0.367)"
                  >
                    <rect
                      id="Rectangle_55680"
                      data-name="Rectangle 55680"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 29.217)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55681"
                      data-name="Rectangle 55681"
                      width="4.598"
                      height="0.222"
                      transform="translate(0 28.662)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55682"
                      data-name="Rectangle 55682"
                      width="4.598"
                      height="0.222"
                      transform="translate(0 28.327)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55683"
                      data-name="Rectangle 55683"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 27.881)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55684"
                      data-name="Rectangle 55684"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 27.659)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55685"
                      data-name="Rectangle 55685"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 27.103)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55686"
                      data-name="Rectangle 55686"
                      width="4.598"
                      height="0.334"
                      transform="translate(0 26.548)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55687"
                      data-name="Rectangle 55687"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 26.322)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55688"
                      data-name="Rectangle 55688"
                      width="4.598"
                      height="0.109"
                      transform="translate(0 25.767)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55689"
                      data-name="Rectangle 55689"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 25.545)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55690"
                      data-name="Rectangle 55690"
                      width="4.598"
                      height="0.443"
                      transform="translate(0 24.989)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55691"
                      data-name="Rectangle 55691"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 24.764)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55692"
                      data-name="Rectangle 55692"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 24.1)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55693"
                      data-name="Rectangle 55693"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 23.54)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55694"
                      data-name="Rectangle 55694"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 23.319)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55695"
                      data-name="Rectangle 55695"
                      width="4.598"
                      height="0.334"
                      transform="translate(0 22.872)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55696"
                      data-name="Rectangle 55696"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 22.538)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55697"
                      data-name="Rectangle 55697"
                      width="4.598"
                      height="0.334"
                      transform="translate(0 22.095)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55698"
                      data-name="Rectangle 55698"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 21.76)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55699"
                      data-name="Rectangle 55699"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 21.205)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55700"
                      data-name="Rectangle 55700"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 20.983)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55701"
                      data-name="Rectangle 55701"
                      width="4.598"
                      height="0.334"
                      transform="translate(0 20.424)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55702"
                      data-name="Rectangle 55702"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 20.202)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55703"
                      data-name="Rectangle 55703"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 19.647)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55704"
                      data-name="Rectangle 55704"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 19.396)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55705"
                      data-name="Rectangle 55705"
                      width="4.598"
                      height="0.222"
                      transform="translate(0 18.837)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55706"
                      data-name="Rectangle 55706"
                      width="4.598"
                      height="0.222"
                      transform="translate(0 18.502)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55707"
                      data-name="Rectangle 55707"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 18.059)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55708"
                      data-name="Rectangle 55708"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 17.838)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55709"
                      data-name="Rectangle 55709"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 17.278)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55710"
                      data-name="Rectangle 55710"
                      width="4.598"
                      height="0.334"
                      transform="translate(0 16.723)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55711"
                      data-name="Rectangle 55711"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 16.501)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55712"
                      data-name="Rectangle 55712"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 15.945)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55713"
                      data-name="Rectangle 55713"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 15.72)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55714"
                      data-name="Rectangle 55714"
                      width="4.598"
                      height="0.443"
                      transform="translate(0 15.164)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55715"
                      data-name="Rectangle 55715"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 14.943)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55716"
                      data-name="Rectangle 55716"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 14.275)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55717"
                      data-name="Rectangle 55717"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 13.719)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55718"
                      data-name="Rectangle 55718"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 13.494)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55719"
                      data-name="Rectangle 55719"
                      width="4.598"
                      height="0.334"
                      transform="translate(0 13.05)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55720"
                      data-name="Rectangle 55720"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 12.716)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55721"
                      data-name="Rectangle 55721"
                      width="4.598"
                      height="0.334"
                      transform="translate(0 12.27)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55722"
                      data-name="Rectangle 55722"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 11.939)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55723"
                      data-name="Rectangle 55723"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 11.38)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55724"
                      data-name="Rectangle 55724"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 11.158)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55725"
                      data-name="Rectangle 55725"
                      width="4.598"
                      height="0.334"
                      transform="translate(0 10.602)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55726"
                      data-name="Rectangle 55726"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 10.381)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55727"
                      data-name="Rectangle 55727"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 9.821)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55728"
                      data-name="Rectangle 55728"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 9.571)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55729"
                      data-name="Rectangle 55729"
                      width="4.598"
                      height="0.222"
                      transform="translate(0 9.015)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55730"
                      data-name="Rectangle 55730"
                      width="4.598"
                      height="0.222"
                      transform="translate(0 8.681)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55731"
                      data-name="Rectangle 55731"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 8.234)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55732"
                      data-name="Rectangle 55732"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 8.013)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55733"
                      data-name="Rectangle 55733"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 7.457)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55734"
                      data-name="Rectangle 55734"
                      width="4.598"
                      height="0.334"
                      transform="translate(0 6.901)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55735"
                      data-name="Rectangle 55735"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 6.676)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55736"
                      data-name="Rectangle 55736"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 6.12)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55737"
                      data-name="Rectangle 55737"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 5.899)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55738"
                      data-name="Rectangle 55738"
                      width="4.598"
                      height="0.447"
                      transform="translate(0 5.343)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55739"
                      data-name="Rectangle 55739"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 5.118)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55740"
                      data-name="Rectangle 55740"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 4.449)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55741"
                      data-name="Rectangle 55741"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 3.894)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55742"
                      data-name="Rectangle 55742"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 3.672)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55743"
                      data-name="Rectangle 55743"
                      width="4.598"
                      height="0.334"
                      transform="translate(0 3.225)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55744"
                      data-name="Rectangle 55744"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 2.895)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55745"
                      data-name="Rectangle 55745"
                      width="4.598"
                      height="0.334"
                      transform="translate(0 2.448)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55746"
                      data-name="Rectangle 55746"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 2.114)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55747"
                      data-name="Rectangle 55747"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 1.558)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55748"
                      data-name="Rectangle 55748"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 1.337)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55749"
                      data-name="Rectangle 55749"
                      width="4.598"
                      height="0.334"
                      transform="translate(0 0.777)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55750"
                      data-name="Rectangle 55750"
                      width="4.598"
                      height="0.113"
                      transform="translate(0 0.556)"
                      fill="#171714"
                    />
                    <rect
                      id="Rectangle_55751"
                      data-name="Rectangle 55751"
                      width="4.598"
                      height="0.113"
                      fill="#171714"
                    />
                  </g>
                </g>
                <g
                  id="Group_105521"
                  data-name="Group 105521"
                  transform="translate(23.638 10.13)"
                >
                  <rect
                    id="Rectangle_55752"
                    data-name="Rectangle 55752"
                    width="27.249"
                    height="2.332"
                    transform="translate(0.087)"
                    fill="#fff"
                  />
                  <rect
                    id="Rectangle_55753"
                    data-name="Rectangle 55753"
                    width="6.233"
                    height="1.028"
                    transform="translate(0.087 4.032)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55754"
                    data-name="Rectangle 55754"
                    width="14.801"
                    height="1.028"
                    transform="translate(7.355 4.032)"
                    fill="#797979"
                  />
                  <rect
                    id="Rectangle_55755"
                    data-name="Rectangle 55755"
                    width="7.853"
                    height="1.028"
                    transform="translate(0.087 14.416)"
                    fill="#565655"
                  />
                  <rect
                    id="Rectangle_55756"
                    data-name="Rectangle 55756"
                    width="14.801"
                    height="1.028"
                    transform="translate(10.337 14.416)"
                    fill="#797979"
                  />
                  <rect
                    id="Rectangle_55757"
                    data-name="Rectangle 55757"
                    width="27.844"
                    height="1.028"
                    transform="translate(0 6.73)"
                    fill="#797979"
                  />
                  <rect
                    id="Rectangle_55758"
                    data-name="Rectangle 55758"
                    width="28.97"
                    height="1.028"
                    transform="translate(0 8.666)"
                    fill="#797979"
                  />
                  <rect
                    id="Rectangle_55759"
                    data-name="Rectangle 55759"
                    width="25.498"
                    height="1.028"
                    transform="translate(0 10.602)"
                    fill="#797979"
                  />
                  <rect
                    id="Rectangle_55760"
                    data-name="Rectangle 55760"
                    width="24.158"
                    height="1.028"
                    transform="translate(0 17.115)"
                    fill="#797979"
                  />
                  <rect
                    id="Rectangle_55761"
                    data-name="Rectangle 55761"
                    width="20.925"
                    height="1.028"
                    transform="translate(0 19.051)"
                    fill="#797979"
                  />
                  <rect
                    id="Rectangle_55762"
                    data-name="Rectangle 55762"
                    width="26.479"
                    height="1.028"
                    transform="translate(0 20.987)"
                    fill="#797979"
                  />
                </g>
                <g
                  id="Group_105522"
                  data-name="Group 105522"
                  transform="translate(41.981 24.347)"
                  opacity="0.5"
                >
                  <circle
                    id="Ellipse_129795"
                    data-name="Ellipse 129795"
                    cx="4.006"
                    cy="4.006"
                    r="4.006"
                    transform="translate(2.091 9.883) rotate(-76.65)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100966"
                    data-name="Path 100966"
                    d="M196.9,151.57a5.221,5.221,0,1,0,5.223,5.219A5.221,5.221,0,0,0,196.9,151.57Zm0,10.123a4.9,4.9,0,1,1,4.9-4.9A4.9,4.9,0,0,1,196.9,161.693Z"
                    transform="translate(-189.995 -149.888)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100967"
                    data-name="Path 100967"
                    d="M193.948,146.94a6.9,6.9,0,1,0,6.908,6.9A6.9,6.9,0,0,0,193.948,146.94Zm0,13.385a6.48,6.48,0,1,1,6.483-6.483A6.483,6.483,0,0,1,193.948,160.325Z"
                    transform="translate(-187.04 -146.94)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100968"
                    data-name="Path 100968"
                    d="M189.888,164.851a5.167,5.167,0,0,0,.04.628h-.639a6.017,6.017,0,0,1-.029-.628,5.789,5.789,0,0,1,.029-.621h.639A5,5,0,0,0,189.888,164.851Z"
                    transform="translate(-188.454 -157.95)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100969"
                    data-name="Path 100969"
                    d="M191,158.25a5.4,5.4,0,0,0-.476,1.159l-.585-.24a6,6,0,0,1,.469-1.159Z"
                    transform="translate(-188.887 -153.989)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100970"
                    data-name="Path 100970"
                    d="M191.048,171.3l-.588.251a6.031,6.031,0,0,1-.479-1.159l.585-.243a5.511,5.511,0,0,0,.487,1.155Z"
                    transform="translate(-188.912 -161.72)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100971"
                    data-name="Path 100971"
                    d="M194.35,153.36a5.528,5.528,0,0,0-.89.883l-.45-.45a5.84,5.84,0,0,1,.89-.883Z"
                    transform="translate(-190.842 -150.742)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100972"
                    data-name="Path 100972"
                    d="M194.357,176.2l-.454.454a6.538,6.538,0,0,1-.883-.883l.45-.45a5.505,5.505,0,0,0,.89.879Z"
                    transform="translate(-190.848 -165.012)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100973"
                    data-name="Path 100973"
                    d="M199.418,150.461a5.513,5.513,0,0,0-1.155.487l-.243-.588a6.093,6.093,0,0,1,1.155-.479l.243.585Z"
                    transform="translate(-194.032 -148.812)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100974"
                    data-name="Path 100974"
                    d="M199.528,179.626l-.24.585a6.092,6.092,0,0,1-1.159-.469l.24-.592A5.4,5.4,0,0,0,199.528,179.626Z"
                    transform="translate(-194.102 -167.451)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100975"
                    data-name="Path 100975"
                    d="M205.587,149.179v.639a4.962,4.962,0,0,0-1.257,0v-.639c.207-.018.418-.029.628-.029S205.38,149.165,205.587,149.179Z"
                    transform="translate(-198.05 -148.347)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100976"
                    data-name="Path 100976"
                    d="M205.587,180.91v.639c-.207.018-.418.029-.628.029s-.421-.015-.628-.029v-.639a4.962,4.962,0,0,0,1.257,0Z"
                    transform="translate(-198.05 -168.571)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100977"
                    data-name="Path 100977"
                    d="M211.538,150.3l-.243.592a5.3,5.3,0,0,0-1.155-.476l.24-.585A6.092,6.092,0,0,1,211.538,150.3Z"
                    transform="translate(-201.75 -148.78)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100978"
                    data-name="Path 100978"
                    d="M211.662,179.672a6.031,6.031,0,0,1-1.159.479l-.243-.585a5.511,5.511,0,0,0,1.155-.487l.251.588Z"
                    transform="translate(-201.826 -167.406)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100979"
                    data-name="Path 100979"
                    d="M216.76,153.793l-.45.45a5.247,5.247,0,0,0-.89-.883l.45-.45A6.193,6.193,0,0,1,216.76,153.793Z"
                    transform="translate(-205.112 -150.742)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100980"
                    data-name="Path 100980"
                    d="M216.767,175.77a6.537,6.537,0,0,1-.883.883l-.454-.454a5.506,5.506,0,0,0,.89-.879l.45.45Z"
                    transform="translate(-205.118 -165.012)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100981"
                    data-name="Path 100981"
                    d="M220.271,159.049l-.585.243a5.18,5.18,0,0,0-.487-1.159l.588-.243a6.031,6.031,0,0,1,.479,1.159Z"
                    transform="translate(-207.519 -153.913)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100982"
                    data-name="Path 100982"
                    d="M220.321,170.263a6.006,6.006,0,0,1-.472,1.159l-.588-.243a5.209,5.209,0,0,0,.472-1.159Z"
                    transform="translate(-207.557 -161.637)"
                    fill="#ff010b"
                  />
                  <path
                    id="Path_100983"
                    data-name="Path 100983"
                    d="M221.7,164.851a6.017,6.017,0,0,1-.029.628h-.639a5.164,5.164,0,0,0,.04-.628,4.954,4.954,0,0,0-.04-.621h.639A5.833,5.833,0,0,1,221.7,164.851Z"
                    transform="translate(-208.684 -157.95)"
                    fill="#ff010b"
                  />
                </g>
              </g>
              <path
                id="Path_100984"
                data-name="Path 100984"
                d="M228.7,178.06c.033.694-1.079.85-1.656,1.159a4.5,4.5,0,0,1,1.656-1.159C228.7,178.169,228.326,178.234,228.7,178.06Z"
                transform="translate(-170.53 -142.41)"
                opacity="0.1"
              />
            </g>
          </g>
          <g
            id="Group_105530"
            data-name="Group 105530"
            transform="translate(0)"
          >
            <path
              id="Path_100990"
              data-name="Path 100990"
              d="M1865.848,1489.38v2.15h5.838v5.838h2.15v-7.989h-7.989Zm-62.927,7.989h2.15v-5.838h5.838v-2.15h-7.989v7.989Zm68.766,69.595v5.838h-5.838v2.15h7.989v-7.989h-2.15Zm-66.616,0h-2.15v7.989h7.989V1572.8h-5.838v-5.839Z"
              transform="translate(-1802.888 -1489.38)"
              fill="#f58634"
            />
            <g
              id="Group_105529"
              data-name="Group 105529"
              transform="translate(0 27.902)"
            >
              <rect
                id="Rectangle_55764"
                data-name="Rectangle 55764"
                width="70.981"
                height="29.768"
                fill="#e7975c"
                opacity="0.3"
              />
              <rect
                id="Rectangle_55765"
                data-name="Rectangle 55765"
                width="70.981"
                height="3.345"
                transform="translate(0 26.422)"
                fill="#e7975c"
              />
            </g>
          </g>
          <g
            id="Group_105537"
            data-name="Group 105537"
            transform="translate(77.06 60.116)"
          >
            <g
              id="Group_105535"
              data-name="Group 105535"
              transform="translate(0 10.242)"
              opacity="0.5"
            >
              <path
                id="Path_100991"
                data-name="Path 100991"
                d="M3090.1,2664h19.4a2.169,2.169,0,0,1,2.168,2.168v11.5a2.169,2.169,0,0,1-2.168,2.168h-19.4a1.2,1.2,0,0,1-1.2-1.2V2665.2A1.2,1.2,0,0,1,3090.1,2664Z"
                transform="translate(-3088.9 -2664)"
                fill="#c9c9c9"
              />
              <rect
                id="Rectangle_55766"
                data-name="Rectangle 55766"
                width="1.267"
                height="15.84"
                transform="translate(14.086)"
                opacity="0.2"
              />
              <path
                id="Path_100992"
                data-name="Path 100992"
                d="M3326.51,2664h7.331a1.2,1.2,0,0,1,1.2,1.2v13.444a1.2,1.2,0,0,1-1.2,1.2h-7.331V2664Z"
                transform="translate(-3312.278 -2664)"
                fill="#969696"
              />
              <g
                id="Group_105532"
                data-name="Group 105532"
                transform="translate(3.339 1.535)"
              >
                <rect
                  id="Rectangle_55767"
                  data-name="Rectangle 55767"
                  width="7.408"
                  height="5.362"
                  fill="#bdbdbd"
                />
                <rect
                  id="Rectangle_55768"
                  data-name="Rectangle 55768"
                  width="7.164"
                  height="5.185"
                  transform="translate(0.122 0.088)"
                  fill="#eee"
                />
                <g
                  id="Group_105531"
                  data-name="Group 105531"
                  transform="translate(0 7.36)"
                >
                  <rect
                    id="Rectangle_55769"
                    data-name="Rectangle 55769"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55770"
                    data-name="Rectangle 55770"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(2.096)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55771"
                    data-name="Rectangle 55771"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(2.096)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55772"
                    data-name="Rectangle 55772"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(4.192)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55773"
                    data-name="Rectangle 55773"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(6.288)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55774"
                    data-name="Rectangle 55774"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(2.096 1.494)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55775"
                    data-name="Rectangle 55775"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(4.192 1.494)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55776"
                    data-name="Rectangle 55776"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(6.288 1.494)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55777"
                    data-name="Rectangle 55777"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(2.096 2.988)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55778"
                    data-name="Rectangle 55778"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(4.192 2.988)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55779"
                    data-name="Rectangle 55779"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(6.288 2.988)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55780"
                    data-name="Rectangle 55780"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(2.096 4.482)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55781"
                    data-name="Rectangle 55781"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(4.192 4.482)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55782"
                    data-name="Rectangle 55782"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(6.288 4.482)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55783"
                    data-name="Rectangle 55783"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(0 4.482)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55784"
                    data-name="Rectangle 55784"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(0 2.988)"
                    fill="#ebebeb"
                  />
                  <rect
                    id="Rectangle_55785"
                    data-name="Rectangle 55785"
                    width="1.121"
                    height="0.928"
                    rx="0.464"
                    transform="translate(0 1.494)"
                    fill="#ebebeb"
                  />
                </g>
              </g>
              <rect
                id="Rectangle_55786"
                data-name="Rectangle 55786"
                width="4.776"
                height="8.578"
                rx="2.388"
                transform="translate(16.108 3.631)"
                fill="#656668"
              />
              <rect
                id="Rectangle_55787"
                data-name="Rectangle 55787"
                width="4.582"
                height="8.383"
                rx="2.291"
                transform="translate(16.206 3.729)"
                fill="#a9a9a9"
              />
              <g
                id="Group_105533"
                data-name="Group 105533"
                transform="translate(16.206 3.729)"
                opacity="0.2"
              >
                <path
                  id="Path_100993"
                  data-name="Path 100993"
                  d="M3364.042,2726.415v2.516h-4.582v-2.516a.165.165,0,0,1,.165-.165h4.252A.165.165,0,0,1,3364.042,2726.415Z"
                  transform="translate(-3359.46 -2726.25)"
                />
                <path
                  id="Path_100994"
                  data-name="Path 100994"
                  d="M3362.262,2821.45v2.68h-2.638a.165.165,0,0,1-.165-.165v-2.516Z"
                  transform="translate(-3359.46 -2815.748)"
                  fill="#fff"
                />
                <path
                  id="Path_100995"
                  data-name="Path 100995"
                  d="M3408.029,2821.45v2.516a.165.165,0,0,1-.165.165h-1.614v-2.68Z"
                  transform="translate(-3403.447 -2815.748)"
                />
              </g>
              <g
                id="Group_105534"
                data-name="Group 105534"
                transform="translate(16.304 3.826)"
              >
                <path
                  id="Path_100996"
                  data-name="Path 100996"
                  d="M3361.09,2730.439v-2.489a.068.068,0,0,1,.067-.07h4.252a.068.068,0,0,1,.067.07v2.489Z"
                  transform="translate(-3361.09 -2727.88)"
                  fill="#8f8f8f"
                />
                <path
                  id="Path_100997"
                  data-name="Path 100997"
                  d="M3361.157,2823.648a.069.069,0,0,1-.067-.071v-2.537h4.386v2.537a.069.069,0,0,1-.067.071Z"
                  transform="translate(-3361.09 -2815.46)"
                  fill="#8f8f8f"
                />
              </g>
              <path
                id="Path_100998"
                data-name="Path 100998"
                d="M3383.368,2777.6h-1.781a.079.079,0,0,1-.079-.084l.151-2.376a.079.079,0,0,1,.079-.074h1.479a.079.079,0,0,1,.079.074l.151,2.376A.079.079,0,0,1,3383.368,2777.6Z"
                transform="translate(-3363.98 -2768.417)"
                opacity="0.1"
              />
              <path
                id="Path_100999"
                data-name="Path 100999"
                d="M3382.377,2778.233l.145-2.279a.079.079,0,0,1,.079-.074h1.388a.079.079,0,0,1,.079.074l.145,2.279a.079.079,0,0,1-.079.084h-1.677a.079.079,0,0,1-.079-.084Z"
                transform="translate(-3364.798 -2769.178)"
                fill="#6e4fff"
              />
            </g>
            <g
              id="Group_105536"
              data-name="Group 105536"
              transform="translate(17.106)"
            >
              <path
                id="Path_101000"
                data-name="Path 101000"
                d="M3616.695,3554.759l.313,3.7-1.883.694-1.415-1.449.594-3.1Z"
                transform="translate(-3599.381 -3491.012)"
                fill="#db965f"
              />
              <path
                id="Path_101001"
                data-name="Path 101001"
                d="M3529.165,3581.585s-.16-.959-.489-1.115a43.7,43.7,0,0,0-4.976,1.7s-1.658.762-.013,1.8a3.888,3.888,0,0,0,1.687.569l3.217.319s4.108.355,3.374-1.925l-.386-1.508S3530.2,3583.3,3529.165,3581.585Z"
                transform="translate(-3514.066 -3515.332)"
                fill="#040c2b"
              />
              <path
                id="Path_101002"
                data-name="Path 101002"
                d="M3743.537,3470.04l1.662,2.669-2.793,2.071-.527-.7-.489-3.77Z"
                transform="translate(-3719.413 -3411.517)"
                fill="#db965f"
              />
              <path
                id="Path_101003"
                data-name="Path 101003"
                d="M3738.211,3498.174s.332.72-.432,2.544a3,3,0,0,0-.448,1.481,4.936,4.936,0,0,1-3.057,3.147,1,1,0,0,1-1.193-.439,2.749,2.749,0,0,1-.111-1.95,44.434,44.434,0,0,0,.733-4.666s1.472.995,2.912-1.114c0,0,.7-.48,1.6,1Z"
                transform="translate(-3711.392 -3436.959)"
                fill="#040c2b"
              />
              <path
                id="Path_101004"
                data-name="Path 101004"
                d="M3604.7,2975.676l4.225,4.65,2.689,2.959,2.466-1.826-5.418-8.333a2.238,2.238,0,0,1-.168-2.13l4.331-9.726a13.324,13.324,0,0,0,0-11.041l-8.606.668.279,1.621,1.23,7.157-2.456,10.484a6.126,6.126,0,0,0,1.43,5.516Z"
                transform="translate(-3589.411 -2922.843)"
                fill="#040c2b"
              />
              <path
                id="Path_101005"
                data-name="Path 101005"
                d="M3604.7,3011.626l4.225,4.65-1.884-8.054,2.745-19.443-5.291-.309,1.23,7.157-2.456,10.484a6.126,6.126,0,0,0,1.43,5.516Z"
                transform="translate(-3589.411 -2958.792)"
                opacity="0.15"
              />
              <path
                id="Path_101006"
                data-name="Path 101006"
                d="M3553.235,2979.9l1.63,9.87,1.986,13.846,2.5-.194.731-.056-.575-14.1,2.526-21.5-7.726-.537a39.9,39.9,0,0,0-1.074,12.674Z"
                transform="translate(-3542.397 -2938.825)"
                fill="#040c2b"
              />
              <path
                id="Path_101007"
                data-name="Path 101007"
                d="M3638.78,2610.995l.619,2.976,1.814.041,3.366.075,1.353-1.585a2.727,2.727,0,0,1-.468-1.233,14.331,14.331,0,0,1-.206-1.685c-.126-1.757-.061-3.614-.061-3.614l-4.716,1.508a5.324,5.324,0,0,1-1.7,3.518Z"
                transform="translate(-3622.949 -2599.204)"
                fill="#c9885b"
              />
              <path
                id="Path_101008"
                data-name="Path 101008"
                d="M3639.789,2501.112s-.441,6.372-5.283,5.977a.987.987,0,0,1-.564-.238c-.68-.589-2.249-2.5-.4-6.589,0,0,4.463-5.69,6.252.85Z"
                transform="translate(-3617.205 -2497.67)"
                fill="#db965f"
              />
              <path
                id="Path_101009"
                data-name="Path 101009"
                d="M3588.44,2690.939v6.558h.232l.247-6.718Z"
                transform="translate(-3575.624 -2678.934)"
                fill="#262c84"
              />
              <path
                id="Path_101010"
                data-name="Path 101010"
                d="M3538.75,2790.96l1.687.868.863.445.155.08-.021-.426-.032-.649-.076-1.562-.24-4.843-.075-1.507-1.527-.445-.559,6.129-.111,1.216Z"
                transform="translate(-3528.911 -2765.554)"
                fill="#db965f"
              />
              <path
                id="Path_101011"
                data-name="Path 101011"
                d="M3374.628,2807.643a1.637,1.637,0,0,0,1.9.766l7.444,4.9a1.778,1.778,0,0,0,2.634-.842l.268-.69.134-.346.214-.553-.247-.1-.81-.317-1.779-.695-4.1-1.6a8.765,8.765,0,0,1-1.876-1.459,3.809,3.809,0,0,1-.611-.783,9.04,9.04,0,0,0-1.22-1.565c-.4-.418-.71-.691-.71-.691a.555.555,0,0,0-.04.749l.759.926-.3-.048a1.536,1.536,0,0,0-1.747,1.16,1.887,1.887,0,0,0,.091,1.186Z"
                transform="translate(-3374.483 -2785.062)"
                fill="#db965f"
              />
              <path
                id="Path_101012"
                data-name="Path 101012"
                d="M3507.761,2706.669l2.03.563,1.859.516.542.15.169.046.216.022-.189-5.227-.248-6.851a3.926,3.926,0,0,0-2.369,3.01l-2.01,7.769Z"
                transform="translate(-3499.777 -2683.738)"
                fill="#fff"
              />
              <path
                id="Path_101013"
                data-name="Path 101013"
                d="M3558.967,2797.591q.087-.446.155-.868.12-.739.191-1.4a25.888,25.888,0,0,0,.266-3.455l.154-.889.271-1.933c-.011,1.014-.177,4.064-.146,6.429h0l0,.1.073,1.464.247.1-.214.553.021.426-.155-.08-.268.69a1.767,1.767,0,0,1-1.1,1.046c.208-.767.375-1.5.507-2.18Z"
                transform="translate(-3547.44 -2771.317)"
                opacity="0.15"
              />
              <path
                id="Path_101014"
                data-name="Path 101014"
                d="M3577.517,2895.941c.988.8,3.63.763,3.63.763l6.523.962,2.069.306.225.033a1.778,1.778,0,0,0,2.032-1.875l-.049-.739-.025-.37-.04-.591-.264.017-.868.055-1.2.077-.7.045-1.412.09-2.984.189a8.788,8.788,0,0,1-2.317-.531,3.855,3.855,0,0,1-.885-.452,9.019,9.019,0,0,0-1.768-.9c-.537-.211-.936-.326-.936-.326a.556.556,0,0,0,.281.7l1.079.519-1.151-.112a1.981,1.981,0,0,0-1.13.22c-1.29.7-.106,1.93-.106,1.93Z"
                transform="translate(-3564.888 -2868.749)"
                fill="#db965f"
              />
              <path
                id="Path_101015"
                data-name="Path 101015"
                d="M3782.3,2766.79l.5,9.354-2.59.58-.116-6.185Z"
                transform="translate(-3755.804 -2750.391)"
                fill="#db965f"
              />
              <path
                id="Path_101016"
                data-name="Path 101016"
                d="M3776.561,2719.019l.1,2.925.128.013,5.6-1.894-2.358-6.494c-.855-2.961-1.767-3.85-2.019-4.049a19.213,19.213,0,0,0-1.459,9.5Z"
                transform="translate(-3752.38 -2696.551)"
                fill="#fff"
              />
              <path
                id="Path_101017"
                data-name="Path 101017"
                d="M3742.03,2797.856l.53,6.625.236,2.955,2.069.3-.192-3.4-.433-7.636Z"
                transform="translate(-3720.014 -2778.519)"
                opacity="0.15"
              />
              <path
                id="Path_101018"
                data-name="Path 101018"
                d="M3574.216,2695.572l.027.764-.029,0c0,1.238.036,2.377.086,3.384.075,1.531.439,2.914.362,3.648l-13.521-.281c.134-1.405.378-2.918.615-4.195.3-1.624.592-2.867.629-3.025a.132.132,0,0,0,0-.035q0-.322-.009-.627c0-.032-.009-2.048-.01-2.08-.023-1.772-.019-2.018-.012-2.457a10.936,10.936,0,0,1,.081-1.176l.089-.718-.195-5.381-.011-.294c.069-.026.139-.05.21-.073.054-.017.109-.033.165-.049l.077-.026.478-.159,2.911-.509a17.51,17.51,0,0,1,2.322.3c1.059.18,1.476,1.4,3.1-.062l0,0,2.748.943.522.179.673.231a.719.719,0,0,1,.068.049,18.815,18.815,0,0,0-1.2,3.866,19.016,19.016,0,0,0-.346,4.559l.158,3.236Z"
                transform="translate(-3549.959 -2670.943)"
                fill="#fff"
              />
              <path
                id="Path_101019"
                data-name="Path 101019"
                d="M3651.442,2493.027s1.974-.094,3.3,3.13a9.818,9.818,0,0,1,.711,3.311c.13,3.1-.264,10.13-7.12,5.664,0,0,2.444-1.806,1.729-6.077,0,0-2.191-1.4-1.63-2.619,0,0,.2-3.755,3.014-3.41Z"
                transform="translate(-3631.927 -2493.005)"
              />
              <path
                id="Path_101020"
                data-name="Path 101020"
                d="M3667.162,2584.632c-.1.441.045.854.331.921s.6-.236.706-.678-.045-.854-.331-.921S3667.265,2584.191,3667.162,2584.632Z"
                transform="translate(-3649.6 -2578.498)"
                fill="#db965f"
              />
              <path
                id="Path_101021"
                data-name="Path 101021"
                d="M3639.26,2497.779s-.148-.247-.84-1.729c0,0,1.235-3.014,3.557-2.816C3643.949,2493.4,3639.26,2497.779,3639.26,2497.779Z"
                transform="translate(-3622.611 -2493.211)"
              />
            </g>
          </g>
        </g>
        <g
          id="Group_105556"
          data-name="Group 105556"
          transform="translate(324.607 318.514)"
        >
          <g
            id="Group_105540"
            data-name="Group 105540"
            transform="translate(25.884 151.859)"
          >
            <rect
              id="Rectangle_55788"
              data-name="Rectangle 55788"
              width="16.779"
              height="15.256"
              rx="7.628"
              transform="matrix(1, -0.02, 0.02, 1, 0, 0.343)"
              fill="#c9bfff"
            />
            <g
              id="Group_105539"
              data-name="Group 105539"
              transform="translate(2.99 2.734)"
            >
              <path
                id="Path_101022"
                data-name="Path 101022"
                d="M1174.677,3361.952l-.043.781v.016h0l.358.122a2.41,2.41,0,0,1-.287.652l-.007.011-.138-.067-.227-.112-.469.626.167.236a2.16,2.16,0,0,1-.64.291l-.075-.368-.753-.015-.114.416a2.109,2.109,0,0,1-.7-.271l.219-.368-.513-.581-.419.253,0,0-.029-.046a2.412,2.412,0,0,1-.332-.87l.368-.082.042-.8-.38-.119a2.426,2.426,0,0,1,.338-.784l.391.233.527-.572-.209-.352a2.137,2.137,0,0,1,.9-.309l.083.473.752.038.119-.392a1.889,1.889,0,0,1,.678.4l-.242.354.5.613.324-.179a2.44,2.44,0,0,1,.2.688l-.385.075Zm-1.784-1.223a1.349,1.349,0,0,0-.782.231,1.451,1.451,0,0,0-.224.186,1.558,1.558,0,0,0-.047,2.112,1.355,1.355,0,0,0,1.994.04,1.558,1.558,0,0,0,.047-2.112c-.026-.03-.054-.058-.082-.084a1.355,1.355,0,0,0-.9-.374Z"
                transform="translate(-1163.982 -3354.404)"
                fill="#fff"
              />
              <path
                id="Path_101023"
                data-name="Path 101023"
                d="M1157.961,3270.9l-.047.916v.018h0l.391.143a2.976,2.976,0,0,1-.314.765l-.007.012-.151-.079-.248-.13-.514.736.182.276a2.292,2.292,0,0,1-.7.341l-.081-.431-.823-.017-.125.488a2.229,2.229,0,0,1-.77-.317l.24-.433-.56-.681-.458.3,0,0c-.011-.018-.022-.035-.032-.054a2.959,2.959,0,0,1-.361-1.021l.4-.1.047-.935-.416-.139a2.965,2.965,0,0,1,.371-.921l.427.273.577-.671-.228-.412a2.231,2.231,0,0,1,.983-.363l.09.555.823.042.13-.46c.074-.033.523.269.74.473l-.265.417.55.718.355-.21a2.991,2.991,0,0,1,.216.806l-.421.089Zm-1.948-1.432a1.405,1.405,0,0,0-.856.272,1.667,1.667,0,0,0-.245.219,1.925,1.925,0,0,0-.055,2.478,1.415,1.415,0,0,0,2.18.044,1.925,1.925,0,0,0,.055-2.478c-.029-.034-.059-.067-.09-.1A1.426,1.426,0,0,0,1156.013,3269.469Z"
                transform="translate(-1147.915 -3268.47)"
                fill="#fff"
              />
              <path
                id="Path_101024"
                data-name="Path 101024"
                d="M1065.034,3312.416l-.065,1.262v.025l.006,0,.538.2a4.07,4.07,0,0,1-.432,1.053l-.01.017-.207-.109-.341-.179-.706,1.013.25.38a3.149,3.149,0,0,1-.963.47l-.112-.593-1.132-.023-.172.673a3.067,3.067,0,0,1-1.058-.437l.329-.6-.77-.938-.63.409-.005,0-.044-.074a4.063,4.063,0,0,1-.5-1.406l.554-.133.065-1.287-.571-.191a4.081,4.081,0,0,1,.51-1.268l.587.376.794-.925-.313-.568a3.069,3.069,0,0,1,1.351-.5l.124.764,1.131.059.179-.634c.1-.045.719.371,1.018.651l-.365.573.756.989.488-.29a4.135,4.135,0,0,1,.3,1.111l-.579.122Zm-2.679-1.972a1.925,1.925,0,0,0-1.177.375,2.191,2.191,0,0,0-.338.3,2.655,2.655,0,0,0-.075,3.412,1.944,1.944,0,0,0,3,.061,2.656,2.656,0,0,0,.075-3.412c-.04-.047-.081-.092-.124-.135A1.955,1.955,0,0,0,1062.355,3310.444Z"
                transform="translate(-1059.01 -3306.639)"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Group_105542"
            data-name="Group 105542"
            transform="translate(22.791 74.094)"
          >
            <path
              id="Path_101025"
              data-name="Path 101025"
              d="M971.822,1939.8H959.856a2.406,2.406,0,0,1-2.406-2.406v-10.443a2.406,2.406,0,0,1,2.406-2.406h11.966a2.406,2.406,0,0,1,2.406,2.406V1937.4A2.406,2.406,0,0,1,971.822,1939.8Z"
              transform="translate(-957.45 -1924.55)"
              fill="#c9bfff"
            />
            <g
              id="Group_105541"
              data-name="Group 105541"
              transform="translate(3.748 1.858)"
            >
              <path
                id="Path_101026"
                data-name="Path 101026"
                d="M1029.3,2030.215v5.2a.991.991,0,0,1-1.015.965h-7.251a.991.991,0,0,1-1.015-.965v-5.2a.991.991,0,0,1,1.015-.965h7.251A.991.991,0,0,1,1029.3,2030.215Z"
                transform="translate(-1020.02 -2024.837)"
                fill="#fff"
              />
              <path
                id="Path_101027"
                data-name="Path 101027"
                d="M1053.214,1956.506a2.838,2.838,0,0,0-2.089-.936,3.083,3.083,0,0,0-2.955,3.2v1.216h.649v-1.216a2.313,2.313,0,1,1,4.612,0v1.216h.649v-1.216A3.322,3.322,0,0,0,1053.214,1956.506Z"
                transform="translate(-1046.484 -1955.57)"
                fill="#fff"
              />
              <path
                id="Path_101028"
                data-name="Path 101028"
                d="M1087.439,2055.621a.687.687,0,1,0-1.369,0,.756.756,0,0,0,.331.635v1.23a.059.059,0,0,0,.056.061h.067a.051.051,0,0,1,.049.053v.142a.051.051,0,0,1-.049.053h-.1a.026.026,0,0,0-.025.027v.055a.026.026,0,0,0,.025.027h.041a.052.052,0,0,1,.049.053v.142a.051.051,0,0,1-.049.053h-.042a.025.025,0,0,0-.024.026v.058a.025.025,0,0,0,.024.026h.1a.052.052,0,0,1,.049.053v.143a.052.052,0,0,1-.049.053h-.067a.059.059,0,0,0-.056.061.346.346,0,0,0,.313.36.337.337,0,0,0,.336-.35v-2.295a.748.748,0,0,0,.389-.668Z"
                transform="translate(-1082.114 -2048.931)"
                fill="#dee4fc"
              />
            </g>
          </g>
          <g
            id="Group_105544"
            data-name="Group 105544"
            transform="translate(186.374 33.483)"
          >
            <path
              id="Path_101029"
              data-name="Path 101029"
              d="M3702.822,1261.8h-11.966a2.406,2.406,0,0,1-2.406-2.406v-10.443a2.406,2.406,0,0,1,2.406-2.406h11.966a2.406,2.406,0,0,1,2.406,2.406V1259.4A2.406,2.406,0,0,1,3702.822,1261.8Z"
              transform="translate(-3688.45 -1246.55)"
              fill="#c9bfff"
            />
            <g
              id="Group_105543"
              data-name="Group 105543"
              transform="translate(3.777 2.109)"
            >
              <path
                id="Path_101030"
                data-name="Path 101030"
                d="M3751.61,1329.862c-.64-2.328,1.7-5.891,4.506-5.892s5.146,3.572,4.505,5.892c-.523,1.893-2.928,2.578-4.363,2.615C3754.651,1332.519,3752.144,1331.8,3751.61,1329.862Z"
                transform="translate(-3751.504 -1321.442)"
                fill="#fff"
              />
              <ellipse
                id="Ellipse_129796"
                data-name="Ellipse 129796"
                cx="2.182"
                cy="2.491"
                rx="2.182"
                ry="2.491"
                transform="translate(2.439)"
                fill="#fff"
                stroke="#e3e9f7"
                strokeWidth="1"
              />
            </g>
          </g>
          <g
            id="Group_105546"
            data-name="Group 105546"
            transform="translate(145.913 0)"
          >
            <path
              id="Path_101031"
              data-name="Path 101031"
              d="M3027.322,702.8h-11.966a2.406,2.406,0,0,1-2.406-2.406V689.956a2.406,2.406,0,0,1,2.406-2.406h11.966a2.406,2.406,0,0,1,2.406,2.406V700.4A2.406,2.406,0,0,1,3027.322,702.8Z"
              transform="translate(-3012.95 -687.55)"
              fill="#c9bfff"
            />
            <g
              id="Group_105545"
              data-name="Group 105545"
              transform="translate(3.841 1.671)"
            >
              <path
                id="Path_101032"
                data-name="Path 101032"
                d="M3102.152,747.138a.232.232,0,0,1-.135-.044l-6.337-4.531,6.335-4.6a.233.233,0,1,1,.273.377l-5.812,4.222,5.811,4.155a.233.233,0,0,1-.136.422Z"
                transform="translate(-3094.565 -736.572)"
                fill="#fff"
              />
              <circle
                id="Ellipse_129797"
                data-name="Ellipse 129797"
                cx="1.304"
                cy="1.304"
                r="1.304"
                transform="translate(6.007 0.631) rotate(-14)"
                fill="#fff"
              />
              <circle
                id="Ellipse_129798"
                data-name="Ellipse 129798"
                cx="1.304"
                cy="1.304"
                r="1.304"
                transform="translate(5.887 9.613) rotate(-22.19)"
                fill="#fff"
              />
              <circle
                id="Ellipse_129799"
                data-name="Ellipse 129799"
                cx="1.304"
                cy="1.304"
                r="1.304"
                transform="matrix(0.159, -0.987, 0.987, 0.159, 0, 7.075)"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Group_105547"
            data-name="Group 105547"
            transform="translate(0 101.468)"
          >
            <path
              id="Path_101033"
              data-name="Path 101033"
              d="M591.322,2396.8H579.356a2.406,2.406,0,0,1-2.406-2.406v-10.443a2.406,2.406,0,0,1,2.406-2.406h11.966a2.406,2.406,0,0,1,2.406,2.406V2394.4A2.406,2.406,0,0,1,591.322,2396.8Z"
              transform="translate(-576.95 -2381.55)"
              fill="#c9bfff"
            />
            <path
              id="Path_101034"
              data-name="Path 101034"
              d="M637.068,2423.537l-4.389-4.493a4.213,4.213,0,0,0,.381-1.766,3.335,3.335,0,1,0-3.3,3.787,3.034,3.034,0,0,0,2.037-.806l4.355,4.459a.631.631,0,0,0,.976-.063h0A.875.875,0,0,0,637.068,2423.537Zm-7.314-3.161a3.128,3.128,0,1,1,2.7-3.1A2.925,2.925,0,0,1,629.754,2420.376Z"
              transform="translate(-623.485 -2411.577)"
              fill="#fff"
            />
            <path
              id="Path_101035"
              data-name="Path 101035"
              d="M642.584,2452.232a.142.142,0,0,1-.122-.07,3.294,3.294,0,0,1,0-3.031.142.142,0,1,1,.249.134,3.062,3.062,0,0,0,0,2.753.141.141,0,0,1-.122.213Z"
              transform="translate(-638.178 -2445.013)"
              fill="#fff"
            />
          </g>
          <g
            id="Group_105552"
            data-name="Group 105552"
            transform="translate(219.108 68.703)"
          >
            <path
              id="Path_101036"
              data-name="Path 101036"
              d="M4249.322,1849.8h-11.966a2.406,2.406,0,0,1-2.406-2.406v-10.443a2.406,2.406,0,0,1,2.406-2.406h11.966a2.406,2.406,0,0,1,2.406,2.406V1847.4A2.407,2.407,0,0,1,4249.322,1849.8Z"
              transform="translate(-4234.95 -1834.55)"
              fill="#c9bfff"
            />
            <g
              id="Group_105551"
              data-name="Group 105551"
              transform="translate(4.331 1.911)"
            >
              <rect
                id="Rectangle_55789"
                data-name="Rectangle 55789"
                width="8.116"
                height="11.432"
                fill="#fff"
              />
              <g
                id="Group_105550"
                data-name="Group 105550"
                transform="translate(0.67 1.793)"
              >
                <g
                  id="Group_105548"
                  data-name="Group 105548"
                  transform="translate(0 4.887)"
                >
                  <path
                    id="Path_101037"
                    data-name="Path 101037"
                    d="M4324.916,1978.471h-6.241a.245.245,0,0,1-.245-.246h0a.245.245,0,0,1,.245-.245h6.241a.246.246,0,0,1,.246.245h0A.246.246,0,0,1,4324.916,1978.471Z"
                    transform="translate(-4318.43 -1977.98)"
                    fill="#dee4fc"
                  />
                  <path
                    id="Path_101038"
                    data-name="Path 101038"
                    d="M4325.076,1999.081h-6.24a.245.245,0,0,1-.246-.246h0a.245.245,0,0,1,.246-.245h6.24a.245.245,0,0,1,.245.245h0A.245.245,0,0,1,4325.076,1999.081Z"
                    transform="translate(-4318.58 -1997.356)"
                    fill="#dee4fc"
                  />
                  <path
                    id="Path_101039"
                    data-name="Path 101039"
                    d="M4325.235,2019.681h-6.24a.245.245,0,0,1-.245-.246h0a.246.246,0,0,1,.245-.246h6.24a.246.246,0,0,1,.246.246h0A.246.246,0,0,1,4325.235,2019.681Z"
                    transform="translate(-4318.73 -2016.721)"
                    fill="#dee4fc"
                  />
                </g>
                <g
                  id="Group_105549"
                  data-name="Group 105549"
                  transform="translate(0.017)"
                >
                  <path
                    id="Path_101040"
                    data-name="Path 101040"
                    d="M4323.075,1896.881h-4.12a.245.245,0,0,1-.245-.246h0a.245.245,0,0,1,.245-.246h4.12a.245.245,0,0,1,.246.246h0A.246.246,0,0,1,4323.075,1896.881Z"
                    transform="translate(-4318.71 -1896.39)"
                    fill="#dee4fc"
                  />
                  <path
                    id="Path_101041"
                    data-name="Path 101041"
                    d="M4325.355,1917.491h-6.24a.245.245,0,0,1-.245-.246h0a.245.245,0,0,1,.245-.246h6.24a.246.246,0,0,1,.246.246h0A.246.246,0,0,1,4325.355,1917.491Z"
                    transform="translate(-4318.86 -1915.766)"
                    fill="#dee4fc"
                  />
                  <path
                    id="Path_101042"
                    data-name="Path 101042"
                    d="M4325.516,1938.1h-6.24a.246.246,0,0,1-.246-.245h0a.246.246,0,0,1,.246-.246h6.24a.246.246,0,0,1,.246.246h0A.245.245,0,0,1,4325.516,1938.1Z"
                    transform="translate(-4319.011 -1935.141)"
                    fill="#dee4fc"
                  />
                  <path
                    id="Path_101043"
                    data-name="Path 101043"
                    d="M4325.676,1958.711h-6.24a.246.246,0,0,1-.246-.246h0a.246.246,0,0,1,.246-.246h6.24a.246.246,0,0,1,.246.246h0A.246.246,0,0,1,4325.676,1958.711Z"
                    transform="translate(-4319.161 -1954.516)"
                    fill="#dee4fc"
                  />
                </g>
              </g>
            </g>
          </g>
          <g
            id="Group_105555"
            data-name="Group 105555"
            transform="translate(7.487 127.284)"
          >
            <path
              id="Path_101044"
              data-name="Path 101044"
              d="M716.322,2827.8H704.356a2.406,2.406,0,0,1-2.406-2.406v-10.443a2.406,2.406,0,0,1,2.406-2.406h11.966a2.406,2.406,0,0,1,2.406,2.406V2825.4A2.406,2.406,0,0,1,716.322,2827.8Z"
              transform="translate(-701.95 -2812.55)"
              fill="#c9bfff"
            />
            <g
              id="Group_105554"
              data-name="Group 105554"
              transform="translate(2.307 1.789)"
            >
              <g id="Group_105553" data-name="Group 105553">
                <path
                  id="Path_101045"
                  data-name="Path 101045"
                  d="M751.927,2847.014a.7.7,0,0,1-.58-.31,5.437,5.437,0,0,0-9.613-.008.7.7,0,0,1-1.158-.776,6.819,6.819,0,0,1,11.93.01.7.7,0,0,1-.579,1.084Z"
                  transform="translate(-740.458 -2842.41)"
                  fill="#fff"
                />
                <path
                  id="Path_101046"
                  data-name="Path 101046"
                  d="M773.982,2890.089a.7.7,0,0,1-.58-.31,3.727,3.727,0,0,0-6.609-.005.7.7,0,0,1-1.158-.776,5.109,5.109,0,0,1,8.925.007.7.7,0,0,1-.579,1.084Z"
                  transform="translate(-764.017 -2883.746)"
                  fill="#fff"
                />
                <path
                  id="Path_101047"
                  data-name="Path 101047"
                  d="M796.038,2933.164a.7.7,0,0,1-.58-.31,2.018,2.018,0,0,0-3.6,0,.7.7,0,0,1-1.158-.776,3.4,3.4,0,0,1,5.921,0,.7.7,0,0,1-.579,1.084Z"
                  transform="translate(-787.576 -2925.083)"
                  fill="#fff"
                />
              </g>
              <ellipse
                id="Ellipse_129800"
                data-name="Ellipse 129800"
                cx="1.171"
                cy="1.541"
                rx="1.171"
                ry="1.541"
                transform="translate(4.908 8.597)"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
